import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export enum Acl {
  Public = 'PUBLIC',
  Secure = 'SECURE'
}

export enum ActorRole {
  AssessorOrInterviewer = 'ASSESSOR_OR_INTERVIEWER',
  EarlyCareerTeamMember = 'EARLY_CAREER_TEAM_MEMBER',
  HeadOfPeopleOrTalent = 'HEAD_OF_PEOPLE_OR_TALENT',
  HiringManager = 'HIRING_MANAGER',
  Interviewer = 'INTERVIEWER',
  LineManager = 'LINE_MANAGER',
  RecruiterOrTalentAcquisitionPartner = 'RECRUITER_OR_TALENT_ACQUISITION_PARTNER',
  ReskillingTeamMember = 'RESKILLING_TEAM_MEMBER'
}

export enum AdditionalAssessmentType {
  Coding = 'CODING',
  English = 'ENGLISH'
}

export enum AdjustmentQuestionnaireResponse {
  AssistiveTechnology = 'ASSISTIVE_TECHNOLOGY',
  AuditoryProcessing = 'AUDITORY_PROCESSING',
  DifficultyMaintainingFocus = 'DIFFICULTY_MAINTAINING_FOCUS',
  DifficultyManagingAnxiety = 'DIFFICULTY_MANAGING_ANXIETY',
  DifficultyManagingFatigue = 'DIFFICULTY_MANAGING_FATIGUE',
  DifficultyProcessingInformation = 'DIFFICULTY_PROCESSING_INFORMATION',
  DifficultySpokenCommunication = 'DIFFICULTY_SPOKEN_COMMUNICATION',
  PhysicalChallenges = 'PHYSICAL_CHALLENGES'
}

export enum AdminResultsExportLevel {
  AllData = 'ALL_DATA',
  SummaryAndScoreDetails = 'SUMMARY_AND_SCORE_DETAILS',
  SummaryOfScores = 'SUMMARY_OF_SCORES'
}

export type AdminResultsExportRunnerArgs = {
  __typename?: 'AdminResultsExportRunnerArgs';
  exportLevel?: Maybe<AdminResultsExportLevel>;
  includeDeiData?: Maybe<Scalars['Boolean']>;
  includeFormsData?: Maybe<Scalars['Boolean']>;
  lastDateOfCandidateActionFrom?: Maybe<Scalars['Date']>;
  lastDateOfCandidateActionTo?: Maybe<Scalars['Date']>;
  scoreType?: Maybe<AdminResultsExportScoreType>;
  stageIds: Array<Scalars['Int']>;
};

export enum AdminResultsExportScoreType {
  Grade = 'GRADE',
  Percentile = 'PERCENTILE',
  StenScore = 'STEN_SCORE',
  ZScore = 'Z_SCORE'
}

export type AiInterviewAssessmentStageAction = {
  __typename?: 'AiInterviewAssessmentStageAction';
  createdAt: Scalars['Date'];
  duration: Scalars['Int'];
  id: Scalars['ID'];
  isAvatarEnabled: Scalars['Boolean'];
  isTimingAgentEnabled: Scalars['Boolean'];
  knowledgeBase?: Maybe<Scalars['String']>;
  livekitAgentName: LivekitAgentName;
  name: Scalars['String'];
  selectedLocales: Array<SupportedLocale>;
  stageId: Scalars['Int'];
  supportedLocales: Array<SupportedLocale>;
  updatedAt: Scalars['Date'];
};

export type AiInterviewAssessmentStageActionCandidate = {
  __typename?: 'AiInterviewAssessmentStageActionCandidate';
  /** The hiring team's note on the interview. Null for candidates. */
  candidateNote?: Maybe<Scalars['String']>;
  /** Every saved version of the hiring team's note, newest first. The first one is the current note. Empty for candidates. */
  candidateNoteHistory: Array<AiInterviewCandidateNoteVersion>;
  conference?: Maybe<Conference>;
  /** The consent gate for this interview: whether it applies, the candidate's standing, and the text to show. */
  consent: AiInterviewConsent;
  createdAt: Scalars['Date'];
  estimatedDurationMinutes: Scalars['Int'];
  /** Whether the hiring team wrote a note on the interview. False for candidates. */
  hasCandidateNote: Scalars['Boolean'];
  /** Whether a reviewer annotated at least one score of the interview. False for candidates. */
  hasScoreAnnotations: Scalars['Boolean'];
  id: Scalars['ID'];
  integrityMonitoringSession?: Maybe<IntegrityMonitoringSession>;
  /** Whether consent is required and the candidate has declined it. Shown as "Consent declined" to recruiters. */
  isConsentDeclined: Scalars['Boolean'];
  /** @deprecated This information is encompassed in the result property. */
  resultStatus: AiInterviewAssessmentStageActionCandidateResultStatus;
  results: AiInterviewAssessmentStageActionCandidateResult;
  stageAction: AiInterviewAssessmentStageActionNested;
  stageCandidate: SmStageCandidateModel;
  status: AiInterviewAssessmentStageActionCandidateStatus;
  timeModifierPercentage: Scalars['Float'];
  updatedAt: Scalars['Date'];
};

export type AiInterviewAssessmentStageActionCandidateResult = AiInterviewAssessmentStageActionCandidateResultNotReady | AiInterviewAssessmentStageActionCandidateResultReady;

export type AiInterviewAssessmentStageActionCandidateResultNotReady = {
  __typename?: 'AiInterviewAssessmentStageActionCandidateResultNotReady';
  status: AiInterviewAssessmentStageActionCandidateResultStatusNotReady;
};

export type AiInterviewAssessmentStageActionCandidateResultReady = {
  __typename?: 'AiInterviewAssessmentStageActionCandidateResultReady';
  evidence: Array<AiInterviewSkillEvidence>;
  resultSummary?: Maybe<Scalars['String']>;
  scores: Array<AiInterviewScore>;
  summaryScore?: Maybe<Scalars['Float']>;
};

export enum AiInterviewAssessmentStageActionCandidateResultStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export enum AiInterviewAssessmentStageActionCandidateResultStatusNotReady {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export type AiInterviewAssessmentStageActionCandidateRoleStage = {
  __typename?: 'AiInterviewAssessmentStageActionCandidateRoleStage';
  roleId: Scalars['ID'];
  stageId: Scalars['ID'];
};

export enum AiInterviewAssessmentStageActionCandidateStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Initiated = 'INITIATED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Ready = 'READY'
}

export type AiInterviewAssessmentStageActionNested = {
  __typename?: 'AiInterviewAssessmentStageActionNested';
  createdAt: Scalars['Date'];
  duration: Scalars['Int'];
  id: Scalars['ID'];
  isAvatarEnabled: Scalars['Boolean'];
  isTimingAgentEnabled: Scalars['Boolean'];
  knowledgeBase?: Maybe<Scalars['String']>;
  livekitAgentName: LivekitAgentName;
  name: Scalars['String'];
  selectedLocales: Array<SupportedLocale>;
  stageId: Scalars['Int'];
  updatedAt: Scalars['Date'];
};

export type AiInterviewAssessmentStageActionUpdateInput = {
  duration?: InputMaybe<Scalars['Int']>;
  knowledgeBase?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  selectedLocales?: InputMaybe<Array<SupportedLocale>>;
};

/** One saved version of the hiring team's note on an AI interview. */
export type AiInterviewCandidateNoteVersion = {
  __typename?: 'AiInterviewCandidateNoteVersion';
  /** Who saved it. Null when that user no longer exists. */
  authorName?: Maybe<Scalars['String']>;
  /** The note as saved. Null when the save cleared it. */
  content?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
};

export type AiInterviewConsent = {
  __typename?: 'AiInterviewConsent';
  consentText: Scalars['String'];
  isRequired: Scalars['Boolean'];
  status: AiInterviewConsentStatus;
};

export enum AiInterviewConsentStatus {
  Declined = 'DECLINED',
  Given = 'GIVEN',
  NotDecided = 'NOT_DECIDED'
}

export type AiInterviewScore = {
  __typename?: 'AiInterviewScore';
  /** The reviewer's current annotation on this score. Null when there is none, and for candidates. */
  annotation?: Maybe<AiInterviewScoreAnnotationVersion>;
  /** Every saved version of the annotation, newest first. The first one is the current annotation. Empty for candidates. */
  annotationHistory: Array<AiInterviewScoreAnnotationVersion>;
  createdAt: Scalars['Date'];
  evidence: Array<AiInterviewScoreEvidence>;
  flags: Array<Scalars['String']>;
  id: Scalars['Int'];
  indicator: Scalars['String'];
  justification?: Maybe<Scalars['JSONObject']>;
  score: Scalars['Int'];
  softSkill: SoftSkill;
  softSkillId: Scalars['Int'];
};

/** A reviewer's annotation on one AI interview score (skill–indicator line). */
export type AiInterviewScoreAnnotationInput = {
  /** Optional when the score matches the AI score, required when it differs. */
  comment?: InputMaybe<Scalars['String']>;
  /** The reviewer's own score, 1 to 5. */
  score: Scalars['Int'];
};

/** One saved version of a reviewer's annotation on an AI interview score. Newest first in a history; the first one is the current annotation. */
export type AiInterviewScoreAnnotationVersion = {
  __typename?: 'AiInterviewScoreAnnotationVersion';
  /** Who saved it. Null when that user no longer exists. */
  authorName?: Maybe<Scalars['String']>;
  /** Timestamps in it ("1:12") are the transcript moments the reviewer linked. */
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  /** The reviewer's own score, 1 to 5. */
  score: Scalars['Int'];
};

export type AiInterviewScoreEvidence = {
  __typename?: 'AiInterviewScoreEvidence';
  from: Scalars['Int'];
  sentiment: Scalars['String'];
  text: Scalars['String'];
  to: Scalars['Int'];
};

export type AiInterviewSkillEvidence = {
  __typename?: 'AiInterviewSkillEvidence';
  evidence: Array<AiInterviewScoreEvidence>;
  softSkill: SoftSkill;
  summaryScore?: Maybe<Scalars['Float']>;
};

export type AmApiKeyModel = {
  __typename?: 'AmApiKeyModel';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  hasClientSecret: Scalars['Boolean'];
  id: Scalars['Int'];
  key: Scalars['String'];
  ownerId: Scalars['Int'];
  ownerType: ApiKeyOwnerType;
  puppetUserId: Scalars['Int'];
  role?: Maybe<IdentityPermissionRole>;
  updatedAt: Scalars['Date'];
  usageRecord: Array<ApiKeyUsageRecordModel>;
};

export type Answer = {
  __typename?: 'Answer';
  field?: Maybe<Field>;
  fieldId?: Maybe<Scalars['Int']>;
  form?: Maybe<Form>;
  formId: Scalars['Int'];
  id: Scalars['Int'];
  respondantId: Scalars['Int'];
  response?: Maybe<Scalars['String']>;
  responseType: ResponseType;
};

export enum ApiKeyOwnerType {
  Company = 'COMPANY',
  User = 'USER'
}

export type ApiKeyUsageRecordModel = {
  __typename?: 'ApiKeyUsageRecordModel';
  count: Scalars['Int'];
  route: Scalars['String'];
};

export type ApiUserModel = {
  __typename?: 'ApiUserModel';
  clientId: Scalars['String'];
  clientSecret?: Maybe<Scalars['String']>;
  companyId: Scalars['Int'];
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  hasClientSecret: Scalars['Boolean'];
  id: Scalars['Int'];
  ownerId: Scalars['Int'];
  ownerType: ApiUserOwnerType;
  puppetUserId: Scalars['Int'];
  role?: Maybe<IdentityPermissionRole>;
  updatedAt: Scalars['Date'];
};

export enum ApiUserOwnerType {
  Company = 'COMPANY',
  User = 'USER'
}

export enum ApplicationQuestionAnswerPreference {
  NotPreferred = 'NOT_PREFERRED',
  Preferred = 'PREFERRED'
}

/** The answer's shape follows the question's type, which GraphQL cannot express as a union of scalars. Each shape gets its own field instead, and `type` names the one that is set. */
export type ApplicationQuestionAnswerValue = {
  __typename?: 'ApplicationQuestionAnswerValue';
  /** BOOLEAN questions. */
  boolean?: Maybe<Scalars['Boolean']>;
  /** DATE questions, as an ISO-8601 string. */
  date?: Maybe<Scalars['String']>;
  /** NUMBER questions. */
  number?: Maybe<Scalars['Float']>;
  /** SINGLE_SELECT (exactly one) and MULTI_SELECT questions, as the option names the candidate saw. Names rather than ids: the ATS identifies an option by its display text in answers, and only by id on the question. */
  optionNames?: Maybe<Array<Scalars['String']>>;
  /** TEXT questions. */
  text?: Maybe<Scalars['String']>;
  type: RoleApplicationQuestionType;
};

export type ApplicationQuestionDateRange = {
  __typename?: 'ApplicationQuestionDateRange';
  from?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
};

export type ApplicationQuestionNumberRange = {
  __typename?: 'ApplicationQuestionNumberRange';
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
};

export enum ApplicationQuestionOptionMatch {
  All = 'ALL',
  Any = 'ANY'
}

export type ApplicationQuestionPreferredAnswer = {
  __typename?: 'ApplicationQuestionPreferredAnswer';
  /** BOOLEAN questions. */
  boolean?: Maybe<Scalars['Boolean']>;
  /** DATE questions, as an ISO-8601 string. */
  date?: Maybe<Scalars['String']>;
  /** DATE questions, as a range. */
  dateRange?: Maybe<ApplicationQuestionDateRange>;
  /** NUMBER questions. */
  number?: Maybe<Scalars['Float']>;
  /** NUMBER questions, as a range. */
  numberRange?: Maybe<ApplicationQuestionNumberRange>;
  /** SINGLE_SELECT / MULTI_SELECT questions, as question option ids. */
  optionIds?: Maybe<Array<Scalars['ID']>>;
  /** MULTI_SELECT questions: ANY prefers a candidate who picked at least one of optionIds, ALL one who picked every one of them. Null when no strategy was chosen, which is judged as ANY; always null for other question types. */
  optionMatch?: Maybe<ApplicationQuestionOptionMatch>;
  /** TEXT questions. */
  text?: Maybe<Scalars['String']>;
};

export type ApplicationQuestionPreferredAnswerInput = {
  /** BOOLEAN questions. */
  boolean?: InputMaybe<Scalars['Boolean']>;
  /** DATE questions, as an ISO-8601 string. */
  date?: InputMaybe<Scalars['String']>;
  /** DATE questions, as a range. */
  dateRange?: InputMaybe<DateRangeInput>;
  /** NUMBER questions. */
  number?: InputMaybe<Scalars['Float']>;
  /** NUMBER questions, as a range. */
  numberRange?: InputMaybe<NumericRangeInput>;
  /** SINGLE_SELECT (exactly one) and MULTI_SELECT questions, as ids of the question options. */
  optionIds?: InputMaybe<Array<Scalars['ID']>>;
  /** MULTI_SELECT questions: whether the candidate must pick any or all of optionIds. */
  optionMatch?: InputMaybe<ApplicationQuestionOptionMatch>;
  /** TEXT questions. */
  text?: InputMaybe<Scalars['String']>;
};

export enum AssessmentBrowserSwitchCandidateTrackingEvent {
  AssessmentTabSwitchEndCandidateTrackingEvent = 'AssessmentTabSwitchEndCandidateTrackingEvent',
  AssessmentTabSwitchStartCandidateTrackingEvent = 'AssessmentTabSwitchStartCandidateTrackingEvent',
  AssessmentWindowOutOfFocusEndCandidateTrackingEvent = 'AssessmentWindowOutOfFocusEndCandidateTrackingEvent',
  AssessmentWindowOutOfFocusStartCandidateTrackingEvent = 'AssessmentWindowOutOfFocusStartCandidateTrackingEvent'
}

export type AssessmentCandidateBrowserSwitchTrackingEventModel = {
  __typename?: 'AssessmentCandidateBrowserSwitchTrackingEventModel';
  assessment: AssessmentDataModel;
  assessmentId: Scalars['Int'];
  assessmentTimeSeconds?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['Int'];
  invokedAt: Scalars['Date'];
  subId: Scalars['String'];
  type: AssessmentBrowserSwitchCandidateTrackingEvent;
  updatedAt: Scalars['Date'];
};

export type AssessmentDataAnswerGqlModel = {
  optionSubId?: InputMaybe<Scalars['String']>;
  questionSubId: Scalars['String'];
};

export type AssessmentDataAnswerModel = {
  __typename?: 'AssessmentDataAnswerModel';
  inTime?: Maybe<Scalars['Boolean']>;
  isCorrect: Scalars['Boolean'];
  timestamp: Scalars['Date'];
};

export type AssessmentDataModel = {
  __typename?: 'AssessmentDataModel';
  allowedTimePerSection?: Maybe<Scalars['Int']>;
  answers: Array<Maybe<AssessmentDataAnswerModel>>;
  completedAt?: Maybe<Scalars['Date']>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['Int'];
  locale: Scalars['String'];
  manuallyCreated: Scalars['Boolean'];
  nQuestionsPerTrait?: Maybe<Scalars['Int']>;
  normGroupType: NormGroupType;
  questions: Array<Maybe<AssessmentDataQuestionModel>>;
  roleLevel?: Maybe<ContentRoleLevel>;
  startingAbilityLowerBound: Scalars['Float'];
  startingAbilityUpperBound: Scalars['Float'];
  startingQuestions?: Maybe<Array<Maybe<AssessmentDataQuestionModel>>>;
  subId: Scalars['String'];
  testCandidateDoneBy?: Maybe<Scalars['Int']>;
  testCandidateId?: Maybe<Scalars['Int']>;
  testType?: Maybe<TestFullType>;
  traitIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  updatedAt: Scalars['Date'];
};

export type AssessmentDataQuestionModel = {
  __typename?: 'AssessmentDataQuestionModel';
  questionSubId: Scalars['String'];
  timestamp: Scalars['Date'];
  traitId?: Maybe<Scalars['Int']>;
};

export type AssessmentExpiryOption = {
  __typename?: 'AssessmentExpiryOption';
  duration: Scalars['Int'];
  unit: AssessmentExpiryOptionUnit;
};

export type AssessmentExpiryOptionArgs = {
  duration: Scalars['Int'];
  unit: AssessmentExpiryOptionUnit;
};

export enum AssessmentExpiryOptionUnit {
  Day = 'DAY'
}

export type AssessmentStage = {
  __typename?: 'AssessmentStage';
  actions: AssessmentStageActions;
  additionalAssessmentTypes: Array<AdditionalAssessmentType>;
  assessmentExpiryOption?: Maybe<AssessmentExpiryOption>;
  autoProgressionThreshold?: Maybe<Scalars['Int']>;
  availableActions: Array<StageAvailableActionModel>;
  branding?: Maybe<StageBranding>;
  cognitiveMode: CognitiveMode;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  emailSettings: AssessmentStageEmailSettings;
  endTime?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  interviewGuideBlueprints: Array<InterviewGuideBlueprintModel>;
  inviteUrl: Scalars['String'];
  isAutoProgressionEnabled: Scalars['Boolean'];
  isIntegrityMonitoringEnabled: Scalars['Boolean'];
  kind: AssessmentStageKind;
  name: Scalars['String'];
  order: Scalars['Int'];
  project: ProjectNested;
  softSkills: Array<SoftSkill>;
  stageId: Scalars['Int'];
  startTime?: Maybe<Scalars['Date']>;
  technicalSkills: Array<TechnicalSkill>;
  updatedAt: Scalars['Date'];
};


export type AssessmentStageInviteUrlArgs = {
  locale: SupportedLocale;
};

export enum AssessmentStageActionKind {
  AiInterview = 'AI_INTERVIEW',
  Calibration = 'CALIBRATION',
  Coderbyte = 'CODERBYTE',
  CognitiveTestInductive = 'COGNITIVE_TEST_INDUCTIVE',
  CognitiveTestNumerical = 'COGNITIVE_TEST_NUMERICAL',
  CognitiveTestVerbal = 'COGNITIVE_TEST_VERBAL',
  DeiForm = 'DEI_FORM',
  EnglishProficiency = 'ENGLISH_PROFICIENCY',
  Form = 'FORM',
  ManagerReview = 'MANAGER_REVIEW',
  PersonalityTest = 'PERSONALITY_TEST',
  RssAssessmentSoft = 'RSS_ASSESSMENT_SOFT',
  RssAssessmentTechnical = 'RSS_ASSESSMENT_TECHNICAL'
}

export type AssessmentStageActionLocales = {
  kind: AssessmentStageActionKind;
  locales: Array<SupportedLocale>;
};

export type AssessmentStageActions = {
  __typename?: 'AssessmentStageActions';
  aiInterview?: Maybe<AiInterviewAssessmentStageAction>;
  coderbyte?: Maybe<CoderbyteAssessmentStageActionNested>;
  cognitiveTests: Array<CognitiveTestAssessmentStageActionNested>;
  dei?: Maybe<DeiStageActionModel>;
  englishProficiency?: Maybe<EnglishProficiencyAssessmentStageActionNested>;
  personalityTest?: Maybe<PersonalityTestAssessmentStageActionNested>;
  roleSkillSelfAssessments: Array<RssAssessmentModel>;
};

export type AssessmentStageEmailSettings = {
  __typename?: 'AssessmentStageEmailSettings';
  candidateReport?: Maybe<Report>;
  emailCandidateReport: Scalars['Boolean'];
  managerReport?: Maybe<Report>;
  projectTeamEmailSettings: ProjectTeamEmailSettings;
};

export enum AssessmentStageKind {
  AiInterview = 'AI_INTERVIEW',
  Assessment = 'ASSESSMENT'
}

export type AssessmentStageResultsFilterArgs = {
  createdAtGte?: InputMaybe<Scalars['Date']>;
  createdAtLte?: InputMaybe<Scalars['Date']>;
  lastDateOfCandidateActionGte?: InputMaybe<Scalars['Date']>;
  lastDateOfCandidateActionLte?: InputMaybe<Scalars['Date']>;
  nameOrEmailContains?: InputMaybe<Scalars['String']>;
  overallScorePercentileGte?: InputMaybe<Scalars['Float']>;
  overallScorePercentileLte?: InputMaybe<Scalars['Float']>;
  progressionStatusIn?: InputMaybe<Array<ProgressionStatus>>;
  spottedZebraScoreGte?: InputMaybe<Scalars['Int']>;
  spottedZebraScoreLte?: InputMaybe<Scalars['Int']>;
  stageProgressionStatusIn?: InputMaybe<Array<StageProgressionStatus>>;
  statusIn?: InputMaybe<Array<StageCandidateStatus>>;
};

export type AssessmentStageResultsOrderArgs = {
  direction?: InputMaybe<SortOption>;
  field?: InputMaybe<AssessmentStageResultsOrderField>;
};

export enum AssessmentStageResultsOrderField {
  CognitiveCombinedScore = 'CognitiveCombinedScore',
  CognitiveSummaryScore = 'CognitiveSummaryScore',
  CreatedAt = 'CreatedAt',
  EnglishProficiencyLevel = 'EnglishProficiencyLevel',
  IntegrityFlags = 'IntegrityFlags',
  LastDateOfCandidateAction = 'LastDateOfCandidateAction',
  Name = 'Name',
  OverallScore = 'OverallScore',
  RightForTheFutureScore = 'RightForTheFutureScore',
  RightForTheRoleScore = 'RightForTheRoleScore',
  RightForUsScore = 'RightForUsScore',
  SpottedZebraScore = 'SpottedZebraScore',
  Status = 'Status',
  TechnicalChallengesScore = 'TechnicalChallengesScore',
  TechnicalOverallScore = 'TechnicalOverallScore',
  TechnicalQuestionsScore = 'TechnicalQuestionsScore'
}

export type AssessmentStageResultsOutput = {
  __typename?: 'AssessmentStageResultsOutput';
  page: Pageinfo;
  stage: SmStageModel;
  stageCandidatesStatistics: Array<StageCandidateStatisticsModel>;
};

export type AssignmentStatus = {
  __typename?: 'AssignmentStatus';
  asGroupMember?: Maybe<Scalars['Boolean']>;
  asIndividual?: Maybe<Scalars['Boolean']>;
};

export enum AtsCandidatePullMode {
  All = 'ALL',
  MappedStages = 'MAPPED_STAGES'
}

export enum AtsCandidatePullState {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS'
}

/** Why mirroring a stage move to the ATS failed. TRANSIENT means the push never reached the ATS and moving the candidate again later retries it. PERMANENT means the ATS refused the stage change, or the target ATS stage could not be resolved on the linked job, so the stages stay out of sync until an admin fixes the integration mapping. The Spotted Zebra move stands in both cases. */
export enum AtsProgressionFailureType {
  Permanent = 'PERMANENT',
  Transient = 'TRANSIENT'
}

export type AtsProgressionWritebackFailure = {
  __typename?: 'AtsProgressionWritebackFailure';
  message?: Maybe<Scalars['String']>;
  status: AtsProgressionFailureType;
  subId: Scalars['ID'];
};

export type AtsProgressionWritebackSuccess = {
  __typename?: 'AtsProgressionWritebackSuccess';
  atsStageName: Scalars['String'];
  count: Scalars['Int'];
};

export type AtsResultPushConfigGqlModel = {
  __typename?: 'AtsResultPushConfigGQLModel';
  /** ATS stage this result type moves a completed application to. Null when unconfigured, and always null for AI Shortlist and interview evaluations. */
  completionStageRef?: Maybe<Scalars['String']>;
  fieldAliases: AtsWorkdayFieldAliasesGqlModel;
  fieldIds: AtsResultPushFieldIdsGqlModel;
  /** Workday custom object alias the result is written to. Empty when unconfigured. */
  objectAlias: Scalars['String'];
  resultType: AtsResultType;
  sendAssessmentOrder: Scalars['Boolean'];
  sendResultLink: Scalars['Boolean'];
  sendToAtsFields: Scalars['Boolean'];
  sendToWorkdayObjects: Scalars['Boolean'];
};

export type AtsResultPushConfigInput = {
  /** Send null or blank to clear the completion stage. Rejected for AI Shortlist and interview evaluations, and rejected when it names a stage already in the stage map. */
  completionStageRef?: InputMaybe<Scalars['String']>;
  fieldAliases?: InputMaybe<AtsWorkdayFieldAliasesInput>;
  fieldIds?: InputMaybe<AtsResultPushFieldIdsInput>;
  objectAlias?: InputMaybe<Scalars['String']>;
  resultType: AtsResultType;
  sendAssessmentOrder?: InputMaybe<Scalars['Boolean']>;
  sendResultLink?: InputMaybe<Scalars['Boolean']>;
  sendToAtsFields?: InputMaybe<Scalars['Boolean']>;
  sendToWorkdayObjects?: InputMaybe<Scalars['Boolean']>;
};

export type AtsResultPushFieldIdsGqlModel = {
  __typename?: 'AtsResultPushFieldIdsGQLModel';
  completionDate?: Maybe<Scalars['String']>;
  integrityRisk?: Maybe<Scalars['String']>;
  orderStatus?: Maybe<Scalars['String']>;
  resultUrl?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['String']>;
};

export type AtsResultPushFieldIdsInput = {
  completionDate?: InputMaybe<Scalars['String']>;
  integrityRisk?: InputMaybe<Scalars['String']>;
  orderStatus?: InputMaybe<Scalars['String']>;
  resultUrl?: InputMaybe<Scalars['String']>;
  score?: InputMaybe<Scalars['String']>;
};

export enum AtsResultType {
  AiInterview = 'AI_INTERVIEW',
  AiShortlist = 'AI_SHORTLIST',
  Assessment = 'ASSESSMENT',
  InterviewEvaluation = 'INTERVIEW_EVALUATION'
}

export type AtsSettingsGqlModel = {
  __typename?: 'AtsSettingsGQLModel';
  aiInterviewResultsEnabled: Scalars['Boolean'];
  aiShortlistResultsEnabled: Scalars['Boolean'];
  /** Allowlist of rejection-reason ids recruiters may pick in the reject modal. Null = no filtering (every reason allowed). */
  allowedRejectionReasonIds?: Maybe<Array<Scalars['String']>>;
  applicationTrackingEnabled: Scalars['Boolean'];
  assessmentResultsEnabled: Scalars['Boolean'];
  candidatePullMode: AtsCandidatePullMode;
  companyId: Scalars['Int'];
  /** Whether the ATS hiring-team sync may grant SZ access: create accounts for unmatched members and add users of other companies to this one. When disabled, only members who are already users of this company are added to the role team; everyone else is skipped and logged, and gets added by a later sync once an admin makes them a company user. Defaults to enabled. */
  hiringTeamUserProvisioningEnabled: Scalars['Boolean'];
  interviewEvaluationResultsEnabled: Scalars['Boolean'];
  /** Rejection write-back: SZ rejections are mirrored to the ATS. */
  progressionEnabled: Scalars['Boolean'];
  /** Remote ID of the ATS user outbound rejections are performed on behalf of. Workable-only at send time (sent as remote_fields.workable.on_behalf_of_user_remote_id on Kombo reject calls). Null = not configured, field omitted. */
  rejectOnBehalfOfUserRemoteId?: Maybe<Scalars['String']>;
  resultPush: Array<AtsResultPushConfigGqlModel>;
  /** Per-tenant map from SZ stage types to provider-native ATS stage refs. Empty when unconfigured. */
  stageMap: Array<AtsStageMapEntryGqlModel>;
  /** Progression write-back: SZ stage moves into mapped stage types are mirrored to the ATS. */
  stagePushEnabled: Scalars['Boolean'];
  /** Workday only: the rejection reasons valid at each Workday stage, used to narrow the reasons offered when rejecting. Empty when unconfigured and for non-Workday integrations. */
  stageRejectionReasons: Array<AtsStageRejectionReasonsEntryGqlModel>;
};

export type AtsStageCatalogueEntryGqlModel = {
  __typename?: 'AtsStageCatalogueEntryGQLModel';
  atsStageRef: Scalars['String'];
  name: Scalars['String'];
};

export type AtsStageCatalogueGqlModel = {
  __typename?: 'AtsStageCatalogueGQLModel';
  companyId: Scalars['Int'];
  missingRefCount: Scalars['Int'];
  stages: Array<AtsStageCatalogueEntryGqlModel>;
};

export type AtsStageMapEntryGqlModel = {
  __typename?: 'AtsStageMapEntryGQLModel';
  atsStageRef: Scalars['String'];
  szStageType: SzMappedStageType;
  /** @deprecated Use workdayStepIds; holds only its first entry. */
  workdayStepId?: Maybe<Scalars['String']>;
  workdayStepIds: Array<Scalars['String']>;
};

export type AtsStageMapEntryInput = {
  atsStageRef: Scalars['String'];
  szStageType: SzMappedStageType;
  /** @deprecated Use workdayStepIds; ignored when that is provided. */
  workdayStepId?: InputMaybe<Scalars['String']>;
  workdayStepIds?: InputMaybe<Array<Scalars['String']>>;
};

export type AtsStageRejectionReasonsEntryGqlModel = {
  __typename?: 'AtsStageRejectionReasonsEntryGQLModel';
  atsStageRef: Scalars['String'];
  /** Reserved for automated rejection; not used yet. */
  defaultAutoRejectReasonId?: Maybe<Scalars['String']>;
  rejectionReasonIds: Array<Scalars['String']>;
};

export type AtsStageRejectionReasonsEntryInput = {
  atsStageRef: Scalars['String'];
  defaultAutoRejectReasonId?: InputMaybe<Scalars['String']>;
  rejectionReasonIds: Array<Scalars['String']>;
};

export type AtsWorkdayFieldAliasesGqlModel = {
  __typename?: 'AtsWorkdayFieldAliasesGQLModel';
  completionDate?: Maybe<Scalars['String']>;
  evaluationId?: Maybe<Scalars['String']>;
  evaluatorName?: Maybe<Scalars['String']>;
  interviewName?: Maybe<Scalars['String']>;
  orderStatus?: Maybe<Scalars['String']>;
  recommendedDecision?: Maybe<Scalars['String']>;
  resultUrl?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['String']>;
};

export type AtsWorkdayFieldAliasesInput = {
  completionDate?: InputMaybe<Scalars['String']>;
  evaluationId?: InputMaybe<Scalars['String']>;
  evaluatorName?: InputMaybe<Scalars['String']>;
  interviewName?: InputMaybe<Scalars['String']>;
  orderStatus?: InputMaybe<Scalars['String']>;
  recommendedDecision?: InputMaybe<Scalars['String']>;
  resultUrl?: InputMaybe<Scalars['String']>;
  score?: InputMaybe<Scalars['String']>;
};

export type AtsWritebackFailure = {
  __typename?: 'AtsWritebackFailure';
  message?: Maybe<Scalars['String']>;
  status: AtsWritebackFailureType;
  subId: Scalars['ID'];
};

/** Why mirroring a rejection to the ATS failed. VALIDATION_REFUSED means the ATS rejected the input (e.g. the reason is not reachable from the candidate’s current stage) and the SZ-side rejection was NOT applied. SYNC_FAILED means the rejection stands in SZ but did not reach the ATS. */
export enum AtsWritebackFailureType {
  SyncFailed = 'SYNC_FAILED',
  ValidationRefused = 'VALIDATION_REFUSED'
}

export type Attendee = {
  email: Scalars['String'];
  isOrganiser?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type AttendeeModel = {
  __typename?: 'AttendeeModel';
  email: Scalars['String'];
  isOrganiser: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
};

export type AuthCodeResult = {
  __typename?: 'AuthCodeResult';
  authCode: Scalars['String'];
};

export type AuthCodeResultCookie = {
  __typename?: 'AuthCodeResultCookie';
  authCode: Scalars['String'];
  mfaCookie: Scalars['String'];
};

export type AuthenticationMethodModel = {
  __typename?: 'AuthenticationMethodModel';
  authInfoSubId?: Maybe<Scalars['String']>;
  identityProvider?: Maybe<IdentityProviderModel>;
  type: AuthenticationMethodType;
};

export enum AuthenticationMethodType {
  EmailPassword = 'EMAIL_PASSWORD',
  Saml = 'SAML'
}

export type AuthenticationResult = {
  __typename?: 'AuthenticationResult';
  accessToken: Scalars['String'];
  refreshToken: Scalars['String'];
};

export type AuthenticationResultCookie = {
  __typename?: 'AuthenticationResultCookie';
  accessToken: Scalars['String'];
  mfaCookie: Scalars['String'];
  refreshToken: Scalars['String'];
};

export type AuthenticationResultE2eCookie = {
  __typename?: 'AuthenticationResultE2eCookie';
  mfaCookie: Scalars['String'];
};

/** How far one interviewer's availability can be trusted */
export enum AvailabilityConfidence {
  High = 'high',
  Low = 'low'
}

/** Why one interviewer's availability cannot be trusted */
export enum AvailabilityLowConfidenceReason {
  CompanyDefaultTimezone = 'companyDefaultTimezone',
  NoCalendarAccess = 'noCalendarAccess',
  StaleSync = 'staleSync',
  UnsyncedWindow = 'unsyncedWindow'
}

/** Interviewer availability over a requested window */
export type AvailabilityPreviewModel = {
  __typename?: 'AvailabilityPreviewModel';
  /** The company's working hours, in the company's zone */
  companyWorkingWindow: FallbackWorkingWindowModel;
  /** Start of the window answered for */
  from: Scalars['DateTime'];
  /** One entry per requested interviewer, in request order */
  interviewers: Array<InterviewerAvailabilityModel>;
  /** End of the window answered for */
  to: Scalars['DateTime'];
};

export enum Avatar {
  Avatar_1 = 'AVATAR_1',
  Avatar_2 = 'AVATAR_2',
  Avatar_3 = 'AVATAR_3',
  Avatar_4 = 'AVATAR_4',
  Avatar_5 = 'AVATAR_5',
  Spot = 'SPOT'
}

export type BackfillAtsApplicationIdsForAllIntegratedCompaniesResultModel = {
  __typename?: 'BackfillAtsApplicationIdsForAllIntegratedCompaniesResultModel';
  /** PCs that would have been persisted (dry-run) or were persisted (execution). */
  backfilled: Scalars['Int'];
  /** Number of Kombo-integrated companies enumerated via sdk.integrations.list(). */
  companiesConsidered: Scalars['Int'];
  /** True when the call ran in dry-run mode (no rows written). */
  dryRun: Scalars['Boolean'];
  /** Per-PC DB write failures during execution; always 0 on dry-run. See logs for context. */
  failed: Scalars['Int'];
  /** PCs with no matching ATS application — e.g., upstream application was deleted, or email differs between ATS and SZ. */
  noAtsMatch: Scalars['Int'];
  /** Per-company breakdown for ops debugging — one entry per integrated company in the order returned by sdk.integrations.list(). */
  perCompany: Array<BackfillAtsApplicationIdsPerCompanyEntryModel>;
  /** Total project candidates examined across all considered projects. */
  projectCandidatesConsidered: Scalars['Int'];
  /** Projects on this company that had at least one PC missing ats_application_id (and so were walked). */
  projectsConsidered: Scalars['Int'];
};

export type BackfillAtsApplicationIdsForCompanyResultModel = {
  __typename?: 'BackfillAtsApplicationIdsForCompanyResultModel';
  /** PCs that would have been persisted (dry-run) or were persisted (execution). */
  backfilled: Scalars['Int'];
  /** True when the call ran in dry-run mode (no rows written). */
  dryRun: Scalars['Boolean'];
  /** Per-PC DB write failures during execution; always 0 on dry-run. See logs for context. */
  failed: Scalars['Int'];
  /** PCs with no matching ATS application — e.g., upstream application was deleted, or email differs between ATS and SZ. */
  noAtsMatch: Scalars['Int'];
  /** Total project candidates examined across all considered projects. */
  projectCandidatesConsidered: Scalars['Int'];
  /** Projects on this company that had at least one PC missing ats_application_id (and so were walked). */
  projectsConsidered: Scalars['Int'];
};

export type BackfillAtsApplicationIdsPerCompanyEntryModel = {
  __typename?: 'BackfillAtsApplicationIdsPerCompanyEntryModel';
  /** PCs that would have been persisted (dry-run) or were persisted (execution). */
  backfilled: Scalars['Int'];
  /** Owning company id for this breakdown row. */
  companyId: Scalars['Int'];
  /** True when the call ran in dry-run mode (no rows written). */
  dryRun: Scalars['Boolean'];
  /** Per-PC DB write failures during execution; always 0 on dry-run. See logs for context. */
  failed: Scalars['Int'];
  /** PCs with no matching ATS application — e.g., upstream application was deleted, or email differs between ATS and SZ. */
  noAtsMatch: Scalars['Int'];
  /** Total project candidates examined across all considered projects. */
  projectCandidatesConsidered: Scalars['Int'];
  /** Projects on this company that had at least one PC missing ats_application_id (and so were walked). */
  projectsConsidered: Scalars['Int'];
};

export type BackfillAtsAssessmentStageCandidatesResultModel = {
  __typename?: 'BackfillAtsAssessmentStageCandidatesResultModel';
  /** Project candidates that already had a `sm_stage_candidate` row; the call was a no-op for these. */
  alreadyExisted: Scalars['Int'];
  /** New `sm_stage_candidate` rows persisted by this call. */
  created: Scalars['Int'];
  /** True when the call ran in dry-run mode (no rows were written). */
  dryRun: Scalars['Boolean'];
  /** Project candidates for which the upsert threw an unexpected error; see the gateway logs. */
  failed: Scalars['Int'];
  /** Number of project candidates whose current stage is an assessment stage and were considered for the backfill. */
  projectCandidatesConsidered: Scalars['Int'];
  /** Project candidates whose stage could not be resolved (e.g., missing current stage id, or the stage no longer exists). */
  skipped: Scalars['Int'];
};

export type BackfillAtsRejectionReasonsForAllIntegratedCompaniesResultModel = {
  __typename?: 'BackfillAtsRejectionReasonsForAllIntegratedCompaniesResultModel';
  /** PCs already carrying the reason the ATS holds — no write needed. High on a re-run, which is expected: the backfill is idempotent. */
  alreadyMirrored: Scalars['Int'];
  /** PCs that would have been stamped (dry-run) or were stamped (execution). */
  backfilled: Scalars['Int'];
  /** Number of Kombo-integrated companies enumerated via sdk.integrations.list(). */
  companiesConsidered: Scalars['Int'];
  /** True when the call ran in dry-run mode (no rows written). */
  dryRun: Scalars['Boolean'];
  /** Per-PC RPC or DB failures; the run continues past them. See logs for context. */
  failed: Scalars['Int'];
  /** Upper bound on rejected rows this backfill cannot see: every rejected PC with no ats_application_id, so it was not walked at all. Mostly manually-invited candidates that never had an ATS application, which nothing can repair — it will not reach zero, so do not treat it as a precondition. If the walked count looks low, run backfillAtsApplicationIdsForCompany once and compare this number before and after. */
  noApplicationId: Scalars['Int'];
  /** PCs whose ATS application is declined but carries no rejection reason. */
  noReason: Scalars['Int'];
  /** PCs rejected in SZ whose ATS application is not declined — typically a failed rejection write-back. Skipped deliberately: the gateway never clears a reason once set, so mirroring one here would attribute a stale reason to the wrong rejection. */
  notDeclinedInAts: Scalars['Int'];
  /** Per-company breakdown for ops debugging — one entry per integrated company in the order returned by sdk.integrations.list(). */
  perCompany: Array<BackfillAtsRejectionReasonsPerCompanyEntryModel>;
  /** Rejected project candidates on this company carrying an ats_application_id — the rows the backfill walked. */
  projectCandidatesConsidered: Scalars['Int'];
  /** PCs whose ats_application_id the ATS could not resolve at all — usually a stale or wrong id. */
  unresolvedApplication: Scalars['Int'];
};

export type BackfillAtsRejectionReasonsForCompanyResultModel = {
  __typename?: 'BackfillAtsRejectionReasonsForCompanyResultModel';
  /** PCs already carrying the reason the ATS holds — no write needed. High on a re-run, which is expected: the backfill is idempotent. */
  alreadyMirrored: Scalars['Int'];
  /** PCs that would have been stamped (dry-run) or were stamped (execution). */
  backfilled: Scalars['Int'];
  /** True when the call ran in dry-run mode (no rows written). */
  dryRun: Scalars['Boolean'];
  /** Per-PC RPC or DB failures; the run continues past them. See logs for context. */
  failed: Scalars['Int'];
  /** Upper bound on rejected rows this backfill cannot see: every rejected PC with no ats_application_id, so it was not walked at all. Mostly manually-invited candidates that never had an ATS application, which nothing can repair — it will not reach zero, so do not treat it as a precondition. If the walked count looks low, run backfillAtsApplicationIdsForCompany once and compare this number before and after. */
  noApplicationId: Scalars['Int'];
  /** PCs whose ATS application is declined but carries no rejection reason. */
  noReason: Scalars['Int'];
  /** PCs rejected in SZ whose ATS application is not declined — typically a failed rejection write-back. Skipped deliberately: the gateway never clears a reason once set, so mirroring one here would attribute a stale reason to the wrong rejection. */
  notDeclinedInAts: Scalars['Int'];
  /** Rejected project candidates on this company carrying an ats_application_id — the rows the backfill walked. */
  projectCandidatesConsidered: Scalars['Int'];
  /** PCs whose ats_application_id the ATS could not resolve at all — usually a stale or wrong id. */
  unresolvedApplication: Scalars['Int'];
};

export type BackfillAtsRejectionReasonsPerCompanyEntryModel = {
  __typename?: 'BackfillAtsRejectionReasonsPerCompanyEntryModel';
  /** PCs already carrying the reason the ATS holds — no write needed. High on a re-run, which is expected: the backfill is idempotent. */
  alreadyMirrored: Scalars['Int'];
  /** PCs that would have been stamped (dry-run) or were stamped (execution). */
  backfilled: Scalars['Int'];
  /** Owning company id for this breakdown row. */
  companyId: Scalars['Int'];
  /** True when the call ran in dry-run mode (no rows written). */
  dryRun: Scalars['Boolean'];
  /** Per-PC RPC or DB failures; the run continues past them. See logs for context. */
  failed: Scalars['Int'];
  /** Upper bound on rejected rows this backfill cannot see: every rejected PC with no ats_application_id, so it was not walked at all. Mostly manually-invited candidates that never had an ATS application, which nothing can repair — it will not reach zero, so do not treat it as a precondition. If the walked count looks low, run backfillAtsApplicationIdsForCompany once and compare this number before and after. */
  noApplicationId: Scalars['Int'];
  /** PCs whose ATS application is declined but carries no rejection reason. */
  noReason: Scalars['Int'];
  /** PCs rejected in SZ whose ATS application is not declined — typically a failed rejection write-back. Skipped deliberately: the gateway never clears a reason once set, so mirroring one here would attribute a stale reason to the wrong rejection. */
  notDeclinedInAts: Scalars['Int'];
  /** Rejected project candidates on this company carrying an ats_application_id — the rows the backfill walked. */
  projectCandidatesConsidered: Scalars['Int'];
  /** PCs whose ats_application_id the ATS could not resolve at all — usually a stale or wrong id. */
  unresolvedApplication: Scalars['Int'];
};

export type BackfillCandidateInterviewGuideModel = {
  __typename?: 'BackfillCandidateInterviewGuideModel';
  /** Number of CIGs within the scope identified as potentially orphaned (lacking both interview and stage candidates). */
  cigsCheckedForOrphanDelete: Scalars['Int'];
  /** Number of orphaned CIGs actually deleted (0 in dry-run). */
  cigsDeleted: Scalars['Int'];
  /** Number of CIGs within the scope identified as needing their interview_stage_candidate_id backfilled. */
  cigsNeedUpdateCount: Scalars['Int'];
  /** Number of CIGs that were actually updated with the correct interview_stage_candidate_id (0 in dry-run). */
  cigsUpdatedCount: Scalars['Int'];
  /** Total duration of the operation execution in milliseconds. */
  durationMs: Scalars['Int'];
  /** Indicates if the operation was executed in dry-run mode (no changes persisted). */
  isDryRun: Scalars['Boolean'];
  /** Total number of CIGs considered within the specified scope (all relevant or filtered by ID). */
  processedCigCount: Scalars['Int'];
  /** Array of specific CIG IDs processed (empty if filtered IDs were not found or if scope was all relevant CIGs without matches). */
  processedCigIds: Array<Scalars['Int']>;
  /** Number of unique Interview Stage Candidate (ISC) records involved in linking CIGs. */
  relevantIscCount: Scalars['Int'];
};

export type BackfillKomboApplicationsForProjectResultModel = {
  __typename?: 'BackfillKomboApplicationsForProjectResultModel';
  /** Gateway-side `kombo_sync_run` id when the gateway accepted the trigger and a sync run was created. Caller can correlate downstream gateway logs by this id. `null` when `triggered` is false. */
  runId?: Maybe<Scalars['String']>;
  /** One of: `project-not-found`, `project-not-published`, `no-kombo-link`, `integration-disabled`. Present only when `triggered` is false. */
  skippedReason?: Maybe<Scalars['String']>;
  /** True when the gateway accepted the trigger and a sync run was created. False means the gateway declined for one of the structured reasons in `skippedReason`. */
  triggered: Scalars['Boolean'];
};

/** Result of admin backfill participant user IDs operation */
export type BackfillUserIdsResult = {
  __typename?: 'BackfillUserIdsResult';
  /** Total distinct emails with null userId found */
  totalProcessed: Scalars['Int'];
  /** Total participant rows updated with resolved userId */
  totalUpdated: Scalars['Int'];
};

export type BasicBroadSoftSkill = SoftSkill & {
  __typename?: 'BasicBroadSoftSkill';
  category: SoftSkillCategory;
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  examples: Array<Scalars['String']>;
  granularity: SoftSkillGranularity;
  /** @deprecated Please use subId instead */
  id: Scalars['Int'];
  measurementConstructType?: Maybe<MeasurementConstructType>;
  name: Scalars['String'];
  softSkillTraits?: Maybe<Array<SoftSkillTrait>>;
  subId: Scalars['ID'];
  taxonomyVersion: Scalars['Int'];
  updatedAt: Scalars['Date'];
};

export type BasicFocusedSoftSkill = SoftSkill & {
  __typename?: 'BasicFocusedSoftSkill';
  category: SoftSkillCategory;
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  examples: Array<Scalars['String']>;
  granularity: SoftSkillGranularity;
  /** @deprecated Please use subId instead */
  id: Scalars['Int'];
  measurementConstructType?: Maybe<MeasurementConstructType>;
  name: Scalars['String'];
  softSkillTraits?: Maybe<Array<SoftSkillTrait>>;
  subId: Scalars['ID'];
  taxonomyVersion: Scalars['Int'];
  updatedAt: Scalars['Date'];
};

export type BasicProjectCandidate = {
  __typename?: 'BasicProjectCandidate';
  assessmentStageCandidates: Array<SmStageCandidateModel>;
  atsStage?: Maybe<Scalars['String']>;
  contentStageCandidates: Array<ContentStageCandidateModel>;
  createdAt: Scalars['Date'];
  currentStageId?: Maybe<Scalars['Int']>;
  currentStageType?: Maybe<StageType>;
  deadlineAt?: Maybe<Scalars['Date']>;
  expiresAt?: Maybe<Scalars['Date']>;
  interviewStageCandidates: Array<InterviewStageCandidate>;
  isExpired: Scalars['Boolean'];
  offerStageCandidate?: Maybe<OfferStageCandidateModel>;
  progressionStatus: ProgressionStatus;
  shortlistStageCandidates: Array<ShortlistStageCandidate>;
  subId: Scalars['ID'];
  updatedAt: Scalars['Date'];
};

export type BehaviourContentModel = {
  __typename?: 'BehaviourContentModel';
  behaviourId: Scalars['Int'];
  id: Scalars['Int'];
  negativeSummary: Scalars['String'];
  positiveSummary: Scalars['String'];
  roleLevel?: Maybe<ContentRoleLevel>;
};

export type BehaviourFromCsvRowsCreateManyArgs = {
  internalName: Scalars['String'];
  level: Scalars['String'];
  negativeSummary: Scalars['String'];
  positiveSummary: Scalars['String'];
  softSkillId: Scalars['String'];
  traitId: Scalars['String'];
};

export type BehaviourModel = {
  __typename?: 'BehaviourModel';
  content?: Maybe<BehaviourContentModel>;
  contents: Array<BehaviourContentModel>;
  contexts: Array<TraitSoftSkillContextModel>;
  id: Scalars['Int'];
  internalName: Scalars['String'];
};

/** Bot session metadata including platform details, meeting URL, recording location, and logs */
export type BotSessionMetadataModel = {
  __typename?: 'BotSessionMetadataModel';
  /** Additional logs and diagnostic information from the bot provider */
  logs?: Maybe<Scalars['JSON']>;
  /** Meeting URL where the bot attempted to join */
  meetingUrl?: Maybe<Scalars['String']>;
  /** Meeting platform where the bot joined (e.g., zoom, google_meet, microsoft_teams) */
  platform?: Maybe<Scalars['String']>;
  /** URL to the recording file if available from the provider */
  recordingUrl?: Maybe<Scalars['String']>;
  /** The date when bot is scheduled to join */
  scheduledAt?: Maybe<Scalars['DateTime']>;
};

export type BroadSoftSkill = SoftSkill & {
  __typename?: 'BroadSoftSkill';
  category: SoftSkillCategory;
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  examples: Array<Scalars['String']>;
  focusedSoftSkills: Array<BasicFocusedSoftSkill>;
  granularity: SoftSkillGranularity;
  /** @deprecated Please use subId instead */
  id: Scalars['Int'];
  measurementConstructType?: Maybe<MeasurementConstructType>;
  name: Scalars['String'];
  similarSoftSkills: Array<BasicBroadSoftSkill>;
  softSkillTraits?: Maybe<Array<SoftSkillTrait>>;
  subId: Scalars['ID'];
  taxonomyVersion: Scalars['Int'];
  updatedAt: Scalars['Date'];
};

export type BulkUpdateSoftSkillTraitArgsSingle = {
  addEmptyContent?: InputMaybe<Scalars['Boolean']>;
  isAdded?: InputMaybe<Scalars['Boolean']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isUpdated?: InputMaybe<Scalars['Boolean']>;
  orientation: Orientation;
  softSkillId: Scalars['Int'];
  traitId: Scalars['Int'];
  weight: Scalars['Float'];
};

/** One masked interval of an interviewer's busy time */
export type BusyBlockModel = {
  __typename?: 'BusyBlockModel';
  /** How the provider classified the interval */
  busyType: SchedulingBusyType;
  endsAt: Scalars['DateTime'];
  startsAt: Scalars['DateTime'];
};

export enum CalculationMethod {
  PercentileWeightedAverage = 'PERCENTILE_WEIGHTED_AVERAGE',
  RoleSkillsProfile = 'ROLE_SKILLS_PROFILE',
  StenWeightedAverage = 'STEN_WEIGHTED_AVERAGE',
  StenWeightedAverageWithAdjustemt = 'STEN_WEIGHTED_AVERAGE_WITH_ADJUSTEMT',
  TrCustomCalculator = 'TR_CUSTOM_CALCULATOR',
  ZWeightedAverageWithAdjustment = 'Z_WEIGHTED_AVERAGE_WITH_ADJUSTMENT',
  ZWeightedAverageWithSmarterAdjustment = 'Z_WEIGHTED_AVERAGE_WITH_SMARTER_ADJUSTMENT',
  ZWeightedAverageWithSmarterAdjustmentAndLimit = 'Z_WEIGHTED_AVERAGE_WITH_SMARTER_ADJUSTMENT_AND_LIMIT'
}

/** What calendar access resolved for one interviewer */
export enum CalendarAccessState {
  Accessible = 'accessible',
  Frozen = 'frozen',
  OptedOut = 'optedOut',
  Unavailable = 'unavailable',
  Unresolved = 'unresolved'
}

/** An attendee/participant in a calendar event */
export type CalendarAttendeeModel = {
  __typename?: 'CalendarAttendeeModel';
  /** Email address of the attendee */
  email: Scalars['String'];
  /** Whether this attendee is the organizer of the event */
  isOrganizer?: Maybe<Scalars['Boolean']>;
  /** Display name of the attendee */
  name?: Maybe<Scalars['String']>;
  /** RSVP status (provider-native: needsAction, accepted, declined, tentative) */
  rsvp?: Maybe<Scalars['String']>;
  /** Internal user ID if the attendee is a registered user */
  userId?: Maybe<Scalars['Int']>;
};

export enum CalendarProviderV2 {
  Google = 'google',
  Microsoft = 'microsoft'
}

export type CalibrationAnswersInput = {
  adjacentDomain?: InputMaybe<ShortlistCalibrationAnswer>;
  adjacentExperience?: InputMaybe<ShortlistCalibrationAnswer>;
  nearMatch?: InputMaybe<ShortlistCalibrationAnswer>;
  secondaryCapacity?: InputMaybe<ShortlistCalibrationAnswer>;
  stronglyImpliedExperience?: InputMaybe<ShortlistCalibrationAnswer>;
};

export type CalibrationConfigExtendedModel = {
  __typename?: 'CalibrationConfigExtendedModel';
  gradeBands: Array<GradeBandUnion>;
  softSkillEntries: Array<CalibrationConfigSoftSkillEntryModel>;
  technicalSkillEntries: Array<CalibrationConfigTechnicalSkillEntryModel>;
  totalEntry: CalibrationConfigTotalEntryModel;
};

export type CalibrationConfigModel = {
  __typename?: 'CalibrationConfigModel';
  gradeBands: Array<GradeBandUnion>;
  softSkillIds: Array<Scalars['Int']>;
  successProfileId: Scalars['Int'];
};

export type CalibrationConfigSoftSkillEntryModel = {
  __typename?: 'CalibrationConfigSoftSkillEntryModel';
  latestResult?: Maybe<ResultModel>;
  originalResult?: Maybe<ResultModel>;
  softSkill: SoftSkill;
  softSkillId: Scalars['Int'];
};

export type CalibrationConfigTechnicalSkillEntryModel = {
  __typename?: 'CalibrationConfigTechnicalSkillEntryModel';
  latestResult?: Maybe<ResultModel>;
  originalResult?: Maybe<ResultModel>;
  technicalSkill: TechnicalSkill;
  technicalSkillId: Scalars['Int'];
};

export type CalibrationConfigTotalEntryModel = {
  __typename?: 'CalibrationConfigTotalEntryModel';
  latestResult?: Maybe<ResultModel>;
  originalResult?: Maybe<ResultModel>;
  successProfileId: Scalars['Int'];
};

export type CalibrationFileUploadArgs = {
  projectId: Scalars['Int'];
  signOff: Scalars['Boolean'];
};

export type CalibrationFileUploadLineModel = {
  __typename?: 'CalibrationFileUploadLineModel';
  directReportEmployeeId: Scalars['String'];
  directReportName: Scalars['String'];
  managerEmployeeId: Scalars['String'];
  managerName: Scalars['String'];
  overallResult: TrCustomEvaluation;
  overallResultAdjustment: TrCustomEvaluation;
  overallResultId: Scalars['Int'];
  softSkillResult1: TrCustomEvaluation;
  softSkillResult1Adjustment: TrCustomEvaluation;
  softSkillResult1PreviousId: Scalars['Int'];
  softSkillResult2: TrCustomEvaluation;
  softSkillResult2Adjustment: TrCustomEvaluation;
  softSkillResult2PreviousId: Scalars['Int'];
  softSkillResult3: TrCustomEvaluation;
  softSkillResult3Adjustment: TrCustomEvaluation;
  softSkillResult3PreviousId: Scalars['Int'];
  stageCandidateId: Scalars['Int'];
};

export type CalibrationFileUploadModel = {
  __typename?: 'CalibrationFileUploadModel';
  apply: Scalars['Boolean'];
  creates?: Maybe<Array<CalibrationFileUploadLineModel>>;
  deletes?: Maybe<Array<CalibrationFileUploadLineModel>>;
  errorMessage?: Maybe<Scalars['String']>;
  errorMessages?: Maybe<Array<Scalars['String']>>;
  errors?: Maybe<Array<CalibrationFileUploadLineModel>>;
  noChanges?: Maybe<Array<CalibrationFileUploadLineModel>>;
  projectId: Scalars['Int'];
  signOff: Scalars['Boolean'];
  updates?: Maybe<Array<CalibrationFileUploadLineModel>>;
};

export type CandidateAcceptIndirectInvitationResult = {
  __typename?: 'CandidateAcceptIndirectInvitationResult';
  role: MyRole;
  stageId: Scalars['ID'];
};

export type CandidateApplication = {
  __typename?: 'CandidateApplication';
  isMine: Scalars['Boolean'];
  projectCandidateSubId: Scalars['ID'];
  projectId: Scalars['Int'];
  projectSubId: Scalars['ID'];
  requisitionCode?: Maybe<Scalars['String']>;
  requisitionLocation?: Maybe<RequisitionLocationModel>;
  roleCreatedAt: Scalars['DateTime'];
  roleName: Scalars['String'];
  roleStatus: ProjectStatus;
};

export type CandidateFeedbackEventPayload = {
  __typename?: 'CandidateFeedbackEventPayload';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  generatedAt?: Maybe<Scalars['Date']>;
  id: Scalars['String'];
  interviewEvaluationId: Scalars['String'];
  isRegenerationAllowed: Scalars['Boolean'];
  needsRegeneration: Scalars['Boolean'];
  requestId?: Maybe<Scalars['String']>;
  src?: Maybe<Scalars['String']>;
  status: InterviewCandidateFeedbackStatus;
  updatedAt: Scalars['Date'];
};

export type CandidateFeedbackModelV2 = {
  __typename?: 'CandidateFeedbackModelV2';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  generatedAt?: Maybe<Scalars['Date']>;
  id: Scalars['String'];
  interviewEvaluation?: Maybe<InterviewEvaluationModel>;
  interviewEvaluationId: Scalars['String'];
  isRegenerationAllowed: Scalars['Boolean'];
  needsRegeneration: Scalars['Boolean'];
  src?: Maybe<Scalars['String']>;
  status: InterviewCandidateFeedbackStatus;
  updatedAt: Scalars['Date'];
};

export type CandidateHit = {
  __typename?: 'CandidateHit';
  applications: Array<CandidateApplication>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  match: SearchMatch;
  primaryApplication: CandidateApplication;
  userSubId: Scalars['ID'];
};

export type CandidateInterviewGuideEventPayload = {
  __typename?: 'CandidateInterviewGuideEventPayload';
  companyId: Scalars['Int'];
  confirmedAt?: Maybe<Scalars['Date']>;
  confirmedBy?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Date'];
  createdBy: Scalars['Int'];
  deletedAt?: Maybe<Scalars['Date']>;
  duration: Scalars['Int'];
  estimatedDuration: Scalars['Int'];
  id: Scalars['ID'];
  interviewGuideBlueprintId: Scalars['Int'];
  interviewStageCandidateId?: Maybe<Scalars['Int']>;
  isQuestionListModified?: Maybe<Scalars['Boolean']>;
  isQuestionsEdited: Scalars['Boolean'];
  lastUpdatedAt: Scalars['Date'];
  lastUpdatedById?: Maybe<Scalars['Int']>;
  questions: Array<CandidateInterviewGuideQuestionEventPayload>;
  stageCandidateId?: Maybe<Scalars['Int']>;
  subId: Scalars['String'];
  updatedAt: Scalars['Date'];
};

export type CandidateInterviewGuideModel = {
  __typename?: 'CandidateInterviewGuideModel';
  assessmentStageCandidate?: Maybe<SmStageCandidateModel>;
  assessmentStageCandidateId?: Maybe<Scalars['Int']>;
  cachedLocales: Array<SupportedLocale>;
  candidateUser?: Maybe<User>;
  companyId: Scalars['Int'];
  confirmedAt?: Maybe<Scalars['Date']>;
  confirmedBy?: Maybe<Scalars['Int']>;
  confirmedByUser?: Maybe<User>;
  createdAt: Scalars['Date'];
  createdBy: Scalars['Int'];
  deletedAt?: Maybe<Scalars['Date']>;
  duration: Scalars['Int'];
  estimatedDuration: Scalars['Int'];
  /** True while candidates have not yet finished this guide's AI interview stage. The guide cannot be edited then, except by SZ admins. Always false for human interview stages. */
  hasPendingAiInterviewCandidates: Scalars['Boolean'];
  id: Scalars['ID'];
  interviewGuideBlueprint: InterviewGuideBlueprintModel;
  interviewGuideBlueprintId: Scalars['Int'];
  interviewStageCandidate?: Maybe<InterviewStageCandidate>;
  interviewStageCandidateId?: Maybe<Scalars['Int']>;
  /** True when the company has AI interviews switched off, so only Spotted Zebra users may change this guide. Always false for human interview stages. */
  isAiInterviewSelfServeDisabled: Scalars['Boolean'];
  isQuestionListModified: Scalars['Boolean'];
  isQuestionsEdited: Scalars['Boolean'];
  lastUpdatedAt: Scalars['Date'];
  lastUpdatedById?: Maybe<Scalars['Int']>;
  questions: Array<CandidateInterviewGuideQuestionModel>;
  stageCandidate?: Maybe<SmStageCandidateModel>;
  stageCandidateId?: Maybe<Scalars['Int']>;
  subId: Scalars['String'];
  updatedAt: Scalars['Date'];
};

export type CandidateInterviewGuidePdfEventPayload = {
  __typename?: 'CandidateInterviewGuidePdfEventPayload';
  candidateInterviewGuideId: Scalars['ID'];
  companyId: Scalars['Int'];
  downloadRequestId: Scalars['ID'];
  error?: Maybe<Scalars['String']>;
  signedUrl?: Maybe<Scalars['String']>;
  status: PdfGenerationStatus;
  url?: Maybe<Scalars['String']>;
};

/** Types of questions in the CandidateInterviewGuideQuestionCreate mutation */
export enum CandidateInterviewGuideQuestionCreateQuestionType {
  AssessmentQuestion = 'ASSESSMENT_QUESTION',
  NonQuestion = 'NON_QUESTION',
  UserQuestion = 'USER_QUESTION'
}

export type CandidateInterviewGuideQuestionEventPayload = {
  __typename?: 'CandidateInterviewGuideQuestionEventPayload';
  candidateInterviewGuideId: Scalars['Float'];
  content?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  duration: Scalars['Float'];
  editingStartedAt?: Maybe<Scalars['Date']>;
  editingUserId?: Maybe<Scalars['Float']>;
  estimatedDuration: Scalars['Int'];
  extraContent?: Maybe<Scalars['String']>;
  generationStatus: InterviewGuideBlueprintQuestionGenerationStatus;
  id: Scalars['ID'];
  interviewGuideBlueprintQuestionId?: Maybe<Scalars['Float']>;
  isEditable: Scalars['Boolean'];
  isEdited: Scalars['Boolean'];
  isMandatory: Scalars['Boolean'];
  lastUpdatedById?: Maybe<Scalars['Float']>;
  position: Scalars['Float'];
  softSkills?: Maybe<Array<SoftSkill>>;
  subId: Scalars['String'];
  subtype?: Maybe<InterviewGuideBlueprintQuestionSubtype>;
  technicalSkills?: Maybe<Array<TechnicalSkill>>;
  type: CandidateInterviewGuideQuestionType;
  updatedAt: Scalars['Date'];
};

export type CandidateInterviewGuideQuestionModel = {
  __typename?: 'CandidateInterviewGuideQuestionModel';
  candidateInterviewGuide: CandidateInterviewGuideModel;
  candidateInterviewGuideId: Scalars['Float'];
  content?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  duration: Scalars['Float'];
  editingStartedAt?: Maybe<Scalars['Date']>;
  editingUserId?: Maybe<Scalars['Float']>;
  extraContent?: Maybe<Scalars['String']>;
  generationStatus: InterviewGuideBlueprintQuestionGenerationStatus;
  id: Scalars['ID'];
  interviewGuideBlueprintQuestionId?: Maybe<Scalars['Float']>;
  isEditable: Scalars['Boolean'];
  isEdited: Scalars['Boolean'];
  isMandatory: Scalars['Boolean'];
  lastUpdatedById?: Maybe<Scalars['Float']>;
  position: Scalars['Float'];
  softSkillJunctions: Array<CandidateInterviewGuideQuestionSoftSkill>;
  softSkills?: Maybe<Array<SoftSkill>>;
  subId: Scalars['String'];
  subtype?: Maybe<InterviewGuideBlueprintQuestionSubtype>;
  technicalSkills?: Maybe<Array<TechnicalSkill>>;
  type: CandidateInterviewGuideQuestionType;
  updatedAt: Scalars['Date'];
};

export type CandidateInterviewGuideQuestionSoftSkill = {
  __typename?: 'CandidateInterviewGuideQuestionSoftSkill';
  indicators: Array<SoftSkillIndicator>;
  softSkill: SoftSkill;
};

/** Types of questions in the interview guide */
export enum CandidateInterviewGuideQuestionType {
  AiQuestion = 'AI_QUESTION',
  AssessmentQuestion = 'ASSESSMENT_QUESTION',
  CustomizedAiQuestion = 'CUSTOMIZED_AI_QUESTION',
  NonQuestion = 'NON_QUESTION',
  UserQuestion = 'USER_QUESTION'
}

export type CandidateInterviewGuideQuestionUpdateData = {
  content?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Int']>;
  extraContent?: InputMaybe<Scalars['String']>;
};

export enum CandidateJourneyStageStatus {
  Completed = 'COMPLETED',
  Locked = 'LOCKED',
  Unlocked = 'UNLOCKED',
  Unsuccessful = 'UNSUCCESSFUL'
}

/** Whether a candidate has a report and a guide to link */
export type CandidateMaterialsAvailabilityModel = {
  __typename?: 'CandidateMaterialsAvailabilityModel';
  hasAssessmentReport: Scalars['Boolean'];
  hasInterviewGuide: Scalars['Boolean'];
  stageCandidateId: Scalars['Int'];
};

export type CandidateOverviewStageResult = {
  __typename?: 'CandidateOverviewStageResult';
  aiInterviewSummaryScore?: Maybe<Scalars['Int']>;
  assessmentStageKind?: Maybe<AssessmentStageKind>;
  codingFinalScore?: Maybe<Scalars['Int']>;
  codingQualifyingScore?: Maybe<Scalars['Int']>;
  cognitiveSummaryPercentile?: Maybe<Scalars['Int']>;
  displayName: Scalars['String'];
  englishCefrLevel?: Maybe<CefrLevel>;
  englishHasPassed?: Maybe<Scalars['Boolean']>;
  hasEntered: Scalars['Boolean'];
  hasScoringConfig?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isCurrentStage: Scalars['Boolean'];
  order: Scalars['Int'];
  psychometricOverallPercentile?: Maybe<Scalars['Int']>;
  shortlistCriteriaScore?: Maybe<Scalars['Int']>;
  shortlistIsKnockedOut?: Maybe<Scalars['Boolean']>;
  spottedZebraScore?: Maybe<SpottedZebraScore>;
  stageId: Scalars['Int'];
  stageType: StageType;
};

export type CandidateProgressionData = {
  __typename?: 'CandidateProgressionData';
  latestHire?: Maybe<CandidateProgressionEntry>;
  latestHireCleared?: Maybe<CandidateProgressionEntry>;
  latestProgression?: Maybe<CandidateProgressionEntry>;
  latestRejection?: Maybe<CandidateProgressionEntry>;
  latestUnrejection?: Maybe<CandidateProgressionEntry>;
};

export type CandidateProgressionEntry = {
  __typename?: 'CandidateProgressionEntry';
  fromStageId?: Maybe<Scalars['Int']>;
  fromStageName?: Maybe<Scalars['String']>;
  fromStageType?: Maybe<StageType>;
  occurredAt?: Maybe<Scalars['Date']>;
  performedBy?: Maybe<User>;
  performedByType?: Maybe<ProgressionEventPerformedByType>;
  toStageId?: Maybe<Scalars['Int']>;
  toStageName?: Maybe<Scalars['String']>;
  toStageType?: Maybe<StageType>;
};

export enum CandidateResultsExportLevel {
  AllData = 'ALL_DATA',
  SummaryAndScoreDetails = 'SUMMARY_AND_SCORE_DETAILS',
  SummaryOfScores = 'SUMMARY_OF_SCORES'
}

export type CandidateSearchPage = {
  __typename?: 'CandidateSearchPage';
  hasMore: Scalars['Boolean'];
  hits: Array<CandidateHit>;
};

export enum CandidateSearchSort {
  LatestStageActivity = 'LATEST_STAGE_ACTIVITY',
  Name = 'NAME',
  Relevance = 'RELEVANCE'
}

export type CandidateStageInviteSettings = {
  deadlineInEmail?: InputMaybe<Scalars['Date']>;
  stageSubId: Scalars['ID'];
  stageType: StageType;
};

/** Score for a single skill category (e.g. Right for the Role) */
export type CategoryScoreModel = {
  __typename?: 'CategoryScoreModel';
  /** Average score across all skills in this category (0-100) */
  averageScore: Scalars['Float'];
  /** Skill category */
  group: SkillsEvaluationSkillGroup;
  /** Number of skills in this category */
  skillCount: Scalars['Int'];
};

/** A Common European Framework of Reference level. Ordinal: each is stronger than the one before. BELOW_A1 is a result a candidate can be given, but not a level a stage can require. */
export enum CefrLevel {
  A1 = 'A1',
  A2 = 'A2',
  B1 = 'B1',
  B2 = 'B2',
  BelowA1 = 'BELOW_A1',
  C1 = 'C1',
  C2 = 'C2'
}

export type Citation = {
  __typename?: 'Citation';
  sourceField: Scalars['String'];
  text: Scalars['String'];
};

export type CleanupDuplicateBlueprintsResult = {
  __typename?: 'CleanupDuplicateBlueprintsResult';
  /** Total number of DRAFT blueprints checked */
  blueprintsChecked: Scalars['Int'];
  /** Number of blueprints actually deleted (0 in dry-run mode) */
  blueprintsDeleted: Scalars['Int'];
  /** Number of blueprints that will be/were soft-deleted */
  blueprintsToDelete: Scalars['Int'];
  /** Detailed information about each duplicate group */
  duplicateGroups: Array<DuplicateBlueprintGroup>;
  /** Number of duplicate groups found (same stage/job role with multiple DRAFTs) */
  duplicateGroupsFound: Scalars['Int'];
  /** Total duration of the operation execution in milliseconds. */
  durationMs: Scalars['Int'];
  /** Indicates if the operation was executed in dry-run mode (no changes persisted). */
  isDryRun: Scalars['Boolean'];
};

export type CleanupForbiddenSkillRelationsResult = {
  __typename?: 'CleanupForbiddenSkillRelationsResult';
  /** Number of blueprint soft skill relationships removed. */
  blueprintSoftSkillRelationsRemoved: Scalars['Int'];
  /** Number of blueprint technical skill relationships removed. */
  blueprintTechnicalSkillRelationsRemoved: Scalars['Int'];
  /** Number of candidate soft skill relationships removed. */
  candidateSoftSkillRelationsRemoved: Scalars['Int'];
  /** Number of candidate technical skill relationships removed. */
  candidateTechnicalSkillRelationsRemoved: Scalars['Int'];
  /** Total duration of the operation execution in milliseconds. */
  durationMs: Scalars['Int'];
  /** Indicates if the operation was executed in dry-run mode (no changes persisted). */
  isDryRun: Scalars['Boolean'];
  /** Total number of skill relationships removed across all tables. */
  totalRelationsRemoved: Scalars['Int'];
};

export type CleanupResultModel = {
  __typename?: 'CleanupResultModel';
  blueprintQuestionsCleaned: Scalars['Float'];
  candidateQuestionsCleaned: Scalars['Float'];
  totalCleaned: Scalars['Float'];
};

export enum ClientDomainType {
  AdminAppDomain = 'ADMIN_APP_DOMAIN',
  CandidateAppDomain = 'CANDIDATE_APP_DOMAIN',
  CompanyAppDomain = 'COMPANY_APP_DOMAIN',
  PdfAppDomain = 'PDF_APP_DOMAIN'
}

export enum ClientType {
  Admin = 'ADMIN',
  Candidate = 'CANDIDATE',
  Company = 'COMPANY',
  Pdf = 'PDF'
}

export type CoderbyteAssessmentResultChallenge = {
  __typename?: 'CoderbyteAssessmentResultChallenge';
  date?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Float']>;
  timeTakenMinutes?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type CoderbyteAssessmentResultCheatingDetails = {
  __typename?: 'CoderbyteAssessmentResultCheatingDetails';
  aiUsage?: Maybe<Scalars['Boolean']>;
  pastedCode?: Maybe<Scalars['String']>;
  plagiarism?: Maybe<Scalars['String']>;
  suspiciousActivity?: Maybe<Scalars['Boolean']>;
  tabLeavingCount?: Maybe<Scalars['Int']>;
};

export type CoderbyteAssessmentResultMultipleChoiceQuestion = {
  __typename?: 'CoderbyteAssessmentResultMultipleChoiceQuestion';
  /** @deprecated Null on questions that take several picks. Use `answers`. */
  answer?: Maybe<Scalars['String']>;
  answers: Array<Scalars['String']>;
  correct: Scalars['Boolean'];
  id: Scalars['ID'];
  question: Scalars['String'];
};

export type CoderbyteAssessmentResultOpenEndedQuestion = {
  __typename?: 'CoderbyteAssessmentResultOpenEndedQuestion';
  answer: Scalars['String'];
  id: Scalars['ID'];
  question: Scalars['String'];
};

export type CoderbyteAssessmentStageAction = {
  __typename?: 'CoderbyteAssessmentStageAction';
  coderbyteTestId: Scalars['String'];
  createdAt: Scalars['Date'];
  details: CoderbyteAssessmentStageActionDetails;
  id: Scalars['ID'];
  name: Scalars['String'];
  stageId: Scalars['Int'];
  technicalSkills: Array<TechnicalSkill>;
  updatedAt: Scalars['Date'];
};

export type CoderbyteAssessmentStageActionCandidate = {
  __typename?: 'CoderbyteAssessmentStageActionCandidate';
  action?: Maybe<CoderbyteAssessmentStageActionNested>;
  completedAt?: Maybe<Scalars['Date']>;
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  result: CoderbyteAssessmentStageActionCandidateResult;
  /** @deprecated This information is encompassed in the result property. */
  resultStatus: CoderbyteAssessmentStageActionCandidateResultStatus;
  stageCandidateId: Scalars['Int'];
  startedAt?: Maybe<Scalars['Date']>;
  status: CoderbyteAssessmentStageActionCandidateStatus;
  timeModifierPercentage: Scalars['Float'];
  updatedAt: Scalars['Date'];
};

export type CoderbyteAssessmentStageActionCandidateResult = CoderbyteAssessmentStageActionCandidateResultNotReady | CoderbyteAssessmentStageActionCandidateResultReady;

export type CoderbyteAssessmentStageActionCandidateResultNotReady = {
  __typename?: 'CoderbyteAssessmentStageActionCandidateResultNotReady';
  status: CoderbyteAssessmentStageActionCandidateResultStatusNotReady;
};

export type CoderbyteAssessmentStageActionCandidateResultReady = {
  __typename?: 'CoderbyteAssessmentStageActionCandidateResultReady';
  challenges: Array<CoderbyteAssessmentResultChallenge>;
  cheatingDetails?: Maybe<CoderbyteAssessmentResultCheatingDetails>;
  cheatingFlag?: Maybe<Scalars['String']>;
  codeScore?: Maybe<Scalars['Float']>;
  finalScore?: Maybe<Scalars['Float']>;
  integrityFlagsCount?: Maybe<Scalars['Int']>;
  mcqScore?: Maybe<Scalars['Float']>;
  multipleChoiceQuestions: Array<CoderbyteAssessmentResultMultipleChoiceQuestion>;
  openEndedQuestions: Array<CoderbyteAssessmentResultOpenEndedQuestion>;
  receivedAt?: Maybe<Scalars['Date']>;
  reportLink?: Maybe<Scalars['String']>;
  timeTakenMinutes?: Maybe<Scalars['Int']>;
};

export enum CoderbyteAssessmentStageActionCandidateResultStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export enum CoderbyteAssessmentStageActionCandidateResultStatusNotReady {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export type CoderbyteAssessmentStageActionCandidateStart = {
  __typename?: 'CoderbyteAssessmentStageActionCandidateStart';
  inviteUrl: Scalars['String'];
};

export enum CoderbyteAssessmentStageActionCandidateStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export type CoderbyteAssessmentStageActionDetails = {
  __typename?: 'CoderbyteAssessmentStageActionDetails';
  challengeCount?: Maybe<Scalars['Int']>;
  isFrozen: Scalars['Boolean'];
  multipleChoiceCount?: Maybe<Scalars['Int']>;
  qualifyingScore?: Maybe<Scalars['Int']>;
  timeLimitInMinutes?: Maybe<Scalars['Int']>;
};

export type CoderbyteAssessmentStageActionNested = {
  __typename?: 'CoderbyteAssessmentStageActionNested';
  coderbyteTestId: Scalars['String'];
  createdAt: Scalars['Date'];
  details: CoderbyteAssessmentStageActionDetails;
  id: Scalars['ID'];
  name: Scalars['String'];
  stageId: Scalars['Int'];
  technicalSkills: Array<TechnicalSkill>;
  updatedAt: Scalars['Date'];
};

export type CoderbyteAvailableAssessment = {
  __typename?: 'CoderbyteAvailableAssessment';
  closed: Scalars['Boolean'];
  coderbyteTestId: Scalars['String'];
  createdAt?: Maybe<Scalars['Date']>;
  createdByEmail?: Maybe<Scalars['String']>;
  createdByName?: Maybe<Scalars['String']>;
  isFrozen: Scalars['Boolean'];
  name: Scalars['String'];
};

export type CoderbyteResultRetry = {
  __typename?: 'CoderbyteResultRetry';
  message?: Maybe<Scalars['String']>;
  outcome: CoderbyteResultRetryOutcome;
  stageCandidateId?: Maybe<Scalars['Int']>;
  subId: Scalars['ID'];
};

export enum CoderbyteResultRetryOutcome {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  NotFound = 'NOT_FOUND',
  NotReady = 'NOT_READY',
  Skipped = 'SKIPPED'
}

/** A single-use hand-off into a company Coderbyte workspace. Minted on demand and never stored server-side. */
export type CoderbyteSsoLink = {
  __typename?: 'CoderbyteSsoLink';
  /** Coderbyte SSO URL. Expires within seconds of being issued — navigate to it immediately. It must not be cached, retried, or rendered into a link's href, since it will be dead by the time anyone clicks it. */
  url: Scalars['String'];
};

/** A company's Coderbyte organization. Coderbyte's API calls this an *organization*; `externalId` is their `organizationId`. */
export type CoderbyteWorkspace = {
  __typename?: 'CoderbyteWorkspace';
  /** Address the workspace's Coderbyte admin account is registered under. Sign in to Coderbyte with this plus the stored admin password — admin accounts cannot use SSO. */
  adminEmail: Scalars['String'];
  /** When the Coderbyte admin password was last stored. Null means none has been recorded yet, which also keeps the workspace out of service. */
  adminPasswordSetAt?: Maybe<Scalars['Date']>;
  companyId: Scalars['Int'];
  companyName: Scalars['String'];
  createdAt: Scalars['Date'];
  /** Deep link into the workspace's Coderbyte dashboard. */
  dashboardUrl: Scalars['String'];
  /** Coderbyte's organization id, e.g. `szfniq-a5rq8`. */
  externalId: Scalars['String'];
  id: Scalars['Int'];
  /** When the workspace API key was last entered. */
  keySetAt?: Maybe<Scalars['Date']>;
  /** When that key was last confirmed to work against Coderbyte. */
  keyVerifiedAt?: Maybe<Scalars['Date']>;
  status: CoderbyteWorkspaceStatus;
  updatedAt: Scalars['Date'];
  /** Users with an account in this workspace, showing the mapping from their real address to the synthetic one Coderbyte knows them by. */
  users: Array<CoderbyteWorkspaceUser>;
  /** URL to register under "Edit webhooks" in this workspace's Coderbyte API settings. Coderbyte offers no API for this, so it has to be pasted in by hand; until it is, results are never delivered and nothing reports an error. */
  webhookUrl: Scalars['String'];
};

/** Lifecycle of a company's Coderbyte workspace. */
export enum CoderbyteWorkspaceStatus {
  Active = 'ACTIVE',
  PendingSetup = 'PENDING_SETUP',
  Suspended = 'SUSPENDED'
}

/** A Spotted Zebra user's account inside a company's Coderbyte workspace. */
export type CoderbyteWorkspaceUser = {
  __typename?: 'CoderbyteWorkspaceUser';
  /** When we detected the account had materialised on Coderbyte. An upper bound on when the user actually followed their invitation — Coderbyte never tells us the moment itself. */
  activatedAt?: Maybe<Scalars['Date']>;
  /** The synthetic address this user is registered under on Coderbyte. Coderbyte allows one account per organization, so a person working across several client companies gets a distinct address in each. */
  coderbyteEmail: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  invitedAt?: Maybe<Scalars['Date']>;
  lastLoginAt?: Maybe<Scalars['Date']>;
  lastName?: Maybe<Scalars['String']>;
  status: CoderbyteWorkspaceUserStatus;
  /** The user's real Spotted Zebra email address. */
  userEmail: Scalars['String'];
  userId: Scalars['Int'];
};

/** Lifecycle of a user's account inside their company's Coderbyte workspace. */
export enum CoderbyteWorkspaceUserStatus {
  Active = 'ACTIVE',
  Invited = 'INVITED',
  Revoked = 'REVOKED'
}

export enum CognitiveKind {
  Inductive = 'INDUCTIVE',
  Numerical = 'NUMERICAL',
  Verbal = 'VERBAL'
}

export enum CognitiveMode {
  InDepth = 'IN_DEPTH',
  Streamlined = 'STREAMLINED'
}

export type CognitiveTestAssessmentStageAction = {
  __typename?: 'CognitiveTestAssessmentStageAction';
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  kind: CognitiveKind;
  sectionCount: Scalars['Int'];
  stageId: Scalars['Int'];
  updatedAt: Scalars['Date'];
};

export type CognitiveTestAssessmentStageActionCandidate = {
  __typename?: 'CognitiveTestAssessmentStageActionCandidate';
  action: CognitiveTestAssessmentStageActionNested;
  assessmentId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['Date']>;
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  integrityMonitoringSession?: Maybe<IntegrityMonitoringSession>;
  resultStatus: CognitiveTestAssessmentStageActionCandidateResultStatus;
  stageCandidate: SmStageCandidateModel;
  startedAt?: Maybe<Scalars['Date']>;
  status: CognitiveTestAssessmentStageActionCandidateStatus;
  timeModifierPercentage?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['Date'];
};

export enum CognitiveTestAssessmentStageActionCandidateResultStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export enum CognitiveTestAssessmentStageActionCandidateStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export type CognitiveTestAssessmentStageActionNested = {
  __typename?: 'CognitiveTestAssessmentStageActionNested';
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  kind: CognitiveKind;
  sectionCount: Scalars['Int'];
  stageId: Scalars['Int'];
  updatedAt: Scalars['Date'];
};

export type CognitiveTestPracticeAssessment = {
  __typename?: 'CognitiveTestPracticeAssessment';
  assessmentId: Scalars['String'];
};

export type CollaborativeEditingForceStopArgs = {
  questionSubId: Scalars['String'];
  questionType: QuestionType;
};

export type CollaborativeEditingGetInfoArgs = {
  questionSubId: Scalars['String'];
  questionType: QuestionType;
};

export type CollaborativeEditingStartArgs = {
  questionSubId: Scalars['String'];
  questionType: QuestionType;
};

export type CollaborativeEditingStopArgs = {
  questionSubId: Scalars['String'];
  questionType: QuestionType;
};

export type CompaniesPaginatedFilters = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Scalars['String']>;
};

export type CompaniesPaginatedGqlModel = {
  __typename?: 'CompaniesPaginatedGQLModel';
  data?: Maybe<Array<Company>>;
  pageInfo?: Maybe<Pageinfo>;
};

export type Company = {
  __typename?: 'Company';
  aiInterviewConsentText?: Maybe<Scalars['String']>;
  aiInterviewDefaultConsentText: Scalars['String'];
  aiPrivateNetworking: Scalars['Boolean'];
  allowedEmailDomains?: Maybe<Array<Scalars['String']>>;
  alternativeSupportEmail?: Maybe<Scalars['String']>;
  areCognitiveTestsBlocked: Scalars['Boolean'];
  areMultiAssessmentStagesEnabled: Scalars['Boolean'];
  areRffSoftSkillsDisabled: Scalars['Boolean'];
  assessmentExpiryOption?: Maybe<AssessmentExpiryOption>;
  atsIdentifier?: Maybe<Scalars['String']>;
  atsPullJobsFromDate: Scalars['Date'];
  branding?: Maybe<CompanyBranding>;
  candidateReport?: Maybe<Report>;
  companyLifecycle: CompanyLifecycle;
  createdAt: Scalars['String'];
  csmUser?: Maybe<User>;
  emailCandidateReport: Scalars['Boolean'];
  enableCompanyCodingAssessments: Scalars['Boolean'];
  explicitConsentEmail?: Maybe<Scalars['String']>;
  explicitConsentNotificationEmail: Scalars['String'];
  generateCandidateReport: Scalars['Boolean'];
  generateManagerReport: Scalars['Boolean'];
  hideReports: Scalars['Boolean'];
  hiringProcessTemplatesCount: Scalars['Int'];
  id: Scalars['Int'];
  isAiInterviewEnabled: Scalars['Boolean'];
  isAiInterviewScoreHidingAvailable: Scalars['Boolean'];
  isAiShortlistNationalityScrutinyEnabled: Scalars['Boolean'];
  isAlternativeSupportEmailEnabled: Scalars['Boolean'];
  isApplicationAnswerEvidenceEnabled: Scalars['Boolean'];
  isAssigneeManagedViaIntegration: Scalars['Boolean'];
  isAtsIntegrated: Scalars['Boolean'];
  isAtsProgressionEnabled: Scalars['Boolean'];
  isAtsRoleCreationWithRequisitionEnabled: Scalars['Boolean'];
  isAtsRoleCreationWithoutRequisitionEnabled: Scalars['Boolean'];
  isConsentCaptureEnabled: Scalars['Boolean'];
  isHiringTeamMemberAddedEmailEnabled: Scalars['Boolean'];
  isIntegrityMonitoringAiInterviewDefaultEnabled: Scalars['Boolean'];
  isIntegrityMonitoringAssessmentDefaultEnabled: Scalars['Boolean'];
  isIntegrityMonitoringAvailable: Scalars['Boolean'];
  isInterviewGuideConfirmationEnabled: Scalars['Boolean'];
  isInterviewGuideScoresEnabled: Scalars['Boolean'];
  isLegalAcknowledgementsEnabled: Scalars['Boolean'];
  isLiveChatEnabled: Scalars['Boolean'];
  isPersonalityTestMandatory: Scalars['Boolean'];
  isRoleLiveEmailEnabled: Scalars['Boolean'];
  isRoleRequirementsEnabled: Scalars['Boolean'];
  isSchedulingEnabled: Scalars['Boolean'];
  isShortlistingEnabled: Scalars['Boolean'];
  isSkillsEvaluationScoreEnabled: Scalars['Boolean'];
  isSpottedZebraScoreEnabled: Scalars['Boolean'];
  isViewGuidanceEnabled: Scalars['Boolean'];
  isWhitelabelingEnabled: Scalars['Boolean'];
  logoUrl?: Maybe<Scalars['String']>;
  managerReport?: Maybe<Report>;
  name: Scalars['String'];
  projectTeamEmailSettings: ProjectTeamEmailSettings;
  reasonableAdjustmentsOption: ReasonableAdjustmentsOption;
  rfuModelType: CompanyRfuModelType;
  skillsProfileTemplatesCount: Scalars['Int'];
  supportEmail: Scalars['String'];
  usesBehaviouralLabel: Scalars['Boolean'];
  uuid?: Maybe<Scalars['String']>;
};

/** Access levels for company users */
export enum CompanyAccessLevel {
  FullAccess = 'FULL_ACCESS',
  LimitedAccess = 'LIMITED_ACCESS',
  StandardAccess = 'STANDARD_ACCESS'
}

export type CompanyBranding = {
  __typename?: 'CompanyBranding';
  accentColor1?: Maybe<Scalars['String']>;
  accentColor2?: Maybe<Scalars['String']>;
  careersLinkUrl?: Maybe<Scalars['String']>;
  companyId: Scalars['Int'];
  id: Scalars['Int'];
  logoUrl?: Maybe<Scalars['String']>;
  signInBackgroundUrl?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
  websiteLinkUrl?: Maybe<Scalars['String']>;
};

export type CompanyDefaultReports = {
  __typename?: 'CompanyDefaultReports';
  candidateReport: Report;
  managerReport: Report;
};

export type CompanyEmployeeFileUploadArgs = {
  companyId: Scalars['Int'];
};

export type CompanyEmployeeFileUploadLineModel = {
  __typename?: 'CompanyEmployeeFileUploadLineModel';
  companyId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Date']>;
  customFields?: Maybe<Scalars['JSON']>;
  deletedAt?: Maybe<Scalars['Date']>;
  department?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  employeeId?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['Date']>;
  firstName?: Maybe<Scalars['String']>;
  hrManagerEmployeeId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  jobTitle?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
  szUserId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type CompanyEmployeeFileUploadModel = {
  __typename?: 'CompanyEmployeeFileUploadModel';
  apply: Scalars['Boolean'];
  companyId: Scalars['Int'];
  creates?: Maybe<Array<CompanyEmployeeFileUploadLineModel>>;
  deletes?: Maybe<Array<CompanyEmployeeFileUploadLineModel>>;
  errorMessage?: Maybe<Scalars['String']>;
  errorMessages?: Maybe<Array<Scalars['String']>>;
  errors?: Maybe<Array<CompanyEmployeeFileUploadLineModel>>;
  noChanges?: Maybe<Array<CompanyEmployeeFileUploadLineModel>>;
  updates?: Maybe<Array<CompanyEmployeeFileUploadLineModel>>;
};

export type CompanyEmployeeModel = {
  __typename?: 'CompanyEmployeeModel';
  companyId: Scalars['Int'];
  createdAt: Scalars['Date'];
  customFields?: Maybe<Scalars['JSON']>;
  deletedAt?: Maybe<Scalars['Date']>;
  department?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  employeeId: Scalars['String'];
  endDate?: Maybe<Scalars['Date']>;
  firstName: Scalars['String'];
  hrManagerEmployeeId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  jobTitle?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  startDate?: Maybe<Scalars['Date']>;
  szUserId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['Date'];
};

export type CompanyEmployeeModelPaginated = {
  __typename?: 'CompanyEmployeeModelPaginated';
  data?: Maybe<Array<CompanyEmployeeModel>>;
  pageInfo?: Maybe<Pageinfo>;
};

export type CompanyEmployeeOrderByArgs = {
  email?: InputMaybe<OrderByArgs>;
  employeeId?: InputMaybe<OrderByArgs>;
  endDate?: InputMaybe<OrderByArgs>;
  firstName?: InputMaybe<OrderByArgs>;
  lastName?: InputMaybe<OrderByArgs>;
  startDate?: InputMaybe<OrderByArgs>;
  szUserId?: InputMaybe<OrderByArgs>;
};

export type CompanyEmployeeSelectField = Field & {
  __typename?: 'CompanyEmployeeSelectField';
  dynamicSelectOptions?: Maybe<Scalars['String']>;
  fieldInstanceType: FieldInstanceType;
  fieldOwnerId?: Maybe<Scalars['Int']>;
  fieldOwnerName?: Maybe<Scalars['String']>;
  fieldOwnerType?: Maybe<FieldOwnerType>;
  fieldType: FieldType;
  formManagerType: FormManagerType;
  hint?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isArchived: Scalars['Boolean'];
  isFreetextField?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  question?: Maybe<Scalars['String']>;
  settings?: Maybe<FieldSettingsModel>;
  txtData?: Maybe<Scalars['String']>;
};

export enum CompanyLifecycle {
  Churned = 'CHURNED',
  Demo = 'DEMO',
  Internal = 'INTERNAL',
  Live = 'LIVE',
  Poc = 'POC'
}

export type CompanyMaybeUserEmployeeModel = {
  __typename?: 'CompanyMaybeUserEmployeeModel';
  email: Scalars['String'];
  employeeId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  isCompanyEmployee: Scalars['Boolean'];
  isUser: Scalars['Boolean'];
  lastName: Scalars['String'];
  userId?: Maybe<Scalars['Int']>;
};

export type CompanyMeetingConfigurationModel = {
  __typename?: 'CompanyMeetingConfigurationModel';
  companyId: Scalars['Int'];
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['String'];
  metadata?: Maybe<MeetingMetadataModel>;
  updatedAt: Scalars['Date'];
};

export type CompanyProjects = {
  __typename?: 'CompanyProjects';
  company: Company;
  id: Scalars['Int'];
  numberOfCompletedInTimeFrameStageCandidates: Scalars['Int'];
  numberOfStageCandidates: Scalars['Int'];
  percentageOfCompletedStageCandidates: Scalars['Float'];
  projects: Array<ProjectWithStageCandidates>;
};

export enum CompanyRfuModelType {
  BehaviourBased = 'BEHAVIOUR_BASED',
  ValueBased = 'VALUE_BASED'
}

export type CompanyRole = {
  __typename?: 'CompanyRole';
  companyId: Scalars['Int'];
  companyUuid: Scalars['String'];
  id: Scalars['Int'];
  isPasswordDisabled?: Maybe<Scalars['Boolean']>;
  role: Role;
  roleId: Scalars['Int'];
  samlAuthInfos?: Maybe<Array<SamlAuthInfoModel>>;
  twoFactorEnabled: Scalars['Boolean'];
};

/** Everything that replaces one company's scheduling preferences */
export type CompanySchedulingSettingsInput = {
  /** How many minutes before an interview starts a candidate may still cancel or reschedule it. Omit to keep the stored value */
  candidateActionCutoffMinutes?: InputMaybe<Scalars['Int']>;
  /** Whether the Spotted Zebra note taker joins new interviews by default */
  includeSpot: Scalars['Boolean'];
  /** How long a new interview runs, in minutes */
  interviewDurationMinutes: Scalars['Int'];
  /** How long a new candidate booking link stays valid for */
  linkExpiryDays: SchedulingLinkExpiryDays;
  /** The IANA timezone name the working hours are read in; a UTC offset is refused */
  timezone: Scalars['String'];
  workingHours: CompanyWorkingHoursInput;
};

/** One company's scheduling preferences */
export type CompanySchedulingSettingsModel = {
  __typename?: 'CompanySchedulingSettingsModel';
  /** How many minutes before an interview starts a candidate may still cancel or reschedule it */
  candidateActionCutoffMinutes: Scalars['Int'];
  /** Whether the Spotted Zebra note taker joins new interviews by default */
  includeSpot: Scalars['Boolean'];
  /** How long a new interview runs, in minutes */
  interviewDurationMinutes: Scalars['Int'];
  /** How long a new candidate booking link stays valid for */
  linkExpiryDays: SchedulingLinkExpiryDays;
  /** The IANA timezone name the working hours are read in */
  timezone: Scalars['String'];
  workingHours: CompanyWorkingHoursModel;
};

export type CompanySettingChangeModel = {
  __typename?: 'CompanySettingChangeModel';
  changedByDisplay?: Maybe<Scalars['String']>;
  changedById?: Maybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  id: Scalars['Int'];
  mutationName: Scalars['String'];
  newValue?: Maybe<Scalars['String']>;
  occurredAt: Scalars['DateTime'];
  oldValue?: Maybe<Scalars['String']>;
  setting: Scalars['String'];
  source: CompanySettingChangeSource;
};

export type CompanySettingChangeOrderArgs = {
  direction?: SortOption;
  field?: CompanySettingChangeOrderField;
};

export enum CompanySettingChangeOrderField {
  ChangedBy = 'CHANGED_BY',
  OccurredAt = 'OCCURRED_AT',
  Setting = 'SETTING'
}

export enum CompanySettingChangeSource {
  AtsIntegration = 'ATS_INTEGRATION',
  Company = 'COMPANY'
}

export type CompanySignatureModel = {
  __typename?: 'CompanySignatureModel';
  company?: Maybe<Company>;
  companyId: Scalars['Int'];
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['Int'];
  isDefault: Scalars['Boolean'];
  signature: Scalars['String'];
  signatureEmail: Scalars['String'];
  updatedAt: Scalars['Date'];
};

export type CompanyUser = {
  __typename?: 'CompanyUser';
  /** User's current access level for this workspace */
  accessLevel?: Maybe<IdentityPermissionRole>;
  /** Timestamp when the user was first added to this workspace (company role created_at) */
  addedAt?: Maybe<Scalars['DateTime']>;
  group?: Maybe<UserGroupModel>;
  /** True if user has logged in (accepted invitation), false if still pending. Derived from user.password IS NOT NULL. */
  hasAcceptedInvitation?: Maybe<Scalars['Boolean']>;
  inProjectTeam?: Maybe<AssignmentStatus>;
  inStageCandidate?: Maybe<AssignmentStatus>;
  inUserGroup?: Maybe<AssignmentStatus>;
  /** Timestamp of user's last access to this workspace */
  lastAccessedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
};

export type CompanyUserInfo = {
  __typename?: 'CompanyUserInfo';
  company: Company;
  companyUserAcrossAllRoles: CompanyUsersCount;
  companyUserAcrossEachRole: Array<CompanyUsersWithRolesCount>;
};

export type CompanyUserInfoPaginated = {
  __typename?: 'CompanyUserInfoPaginated';
  companyUserInfo: Array<CompanyUserInfo>;
  total: Scalars['Int'];
};

export type CompanyUserModelPaginated = {
  __typename?: 'CompanyUserModelPaginated';
  data?: Maybe<Array<CompanyUser>>;
  pageInfo?: Maybe<Pageinfo>;
};

export enum CompanyUserType {
  Group = 'GROUP',
  User = 'USER'
}

export type CompanyUsersArgs = {
  /** Filter users by access level(s). Returns users matching any of the specified levels. */
  accessLevels?: InputMaybe<Array<CompanyAccessLevel>>;
  /** The company id */
  companyId: Scalars['Int'];
  /** Exclude specific users from results by email or user ID. */
  exclude?: InputMaybe<CompanyUsersExcludeFilter>;
  membersPreviewCount?: InputMaybe<Scalars['Int']>;
  /** Optional project id for filtering */
  projectId?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  /** Optional stage candidate id for filtering */
  stageCandidateId?: InputMaybe<Scalars['Int']>;
  /** Optional user group id for filtering */
  userGroupId?: InputMaybe<Scalars['Int']>;
  userType?: InputMaybe<CompanyUserType>;
};

export type CompanyUsersCount = {
  __typename?: 'CompanyUsersCount';
  companyId: Scalars['Int'];
  totalUsers: Scalars['Int'];
  totalUsersWithPassword: Scalars['Int'];
};

export type CompanyUsersExcludeFilter = {
  /** Emails of users to exclude from results */
  emails?: InputMaybe<Array<Scalars['String']>>;
  /** IDs of users to exclude from results */
  userIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** Fields available for sorting company users */
export enum CompanyUsersOrderField {
  AccessLevel = 'ACCESS_LEVEL',
  AddedAt = 'ADDED_AT',
  Email = 'EMAIL',
  LastAccessedAt = 'LAST_ACCESSED_AT',
  Name = 'NAME'
}

export type CompanyUsersOrderOptions = {
  direction?: InputMaybe<SortOption>;
  field?: InputMaybe<CompanyUsersOrderField>;
};

export type CompanyUsersWithRolesCount = {
  __typename?: 'CompanyUsersWithRolesCount';
  companyId: Scalars['Int'];
  roleName: IdentityPermissionRole;
  totalUsers: Scalars['Int'];
  totalUsersWithPassword: Scalars['Int'];
};

/** The working day interview slots are offered in, in the company's timezone */
export type CompanyWorkingHoursInput = {
  /** Wall-clock end of the day, as HH:mm */
  end: Scalars['String'];
  /** Wall-clock start of the day, as HH:mm */
  start: Scalars['String'];
};

/** The working day interview slots are offered in, in the company's timezone */
export type CompanyWorkingHoursModel = {
  __typename?: 'CompanyWorkingHoursModel';
  /** Wall-clock end of the day, as HH:mm */
  end: Scalars['String'];
  /** Wall-clock start of the day, as HH:mm */
  start: Scalars['String'];
};

export type Conference = {
  __typename?: 'Conference';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['Int'];
  endedAt?: Maybe<Scalars['DateTime']>;
  /** Grammatical form chosen by the candidate for gendered locales; null for other locales. */
  grammaticalGender?: Maybe<GrammaticalGender>;
  id: Scalars['ID'];
  livekitConfig: LivekitConfig;
  /** Locale chosen by the candidate when joining (CR-224). */
  locale?: Maybe<SupportedLocale>;
  recording?: Maybe<RecordingInfo>;
  /** Number of demo sessions remaining for this conference */
  remainingDemoCount: Scalars['Int'];
  transcript: ConferenceTranscript;
  updatedAt: Scalars['DateTime'];
};

export type ConferenceToken = {
  __typename?: 'ConferenceToken';
  token: Scalars['String'];
};

export type ConferenceTranscript = {
  __typename?: 'ConferenceTranscript';
  utterances: Array<TranscriptUtterance>;
};

export enum ContentClassification {
  Negative = 'NEGATIVE',
  Neutral = 'NEUTRAL',
  Positive = 'POSITIVE'
}

export enum ContentRoleLevel {
  Apprentice = 'APPRENTICE',
  IndividualContributor = 'INDIVIDUAL_CONTRIBUTOR',
  Leader = 'LEADER',
  Manager = 'MANAGER',
  ManagerOfManagers = 'MANAGER_OF_MANAGERS',
  TechnicalExpert = 'TECHNICAL_EXPERT'
}

export type ContentStageBlockInput = {
  imageUrl?: InputMaybe<Scalars['String']>;
  kind: ContentStageBlockKind;
  paragraph?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  videoUrl?: InputMaybe<Scalars['String']>;
};

export enum ContentStageBlockKind {
  Image = 'IMAGE',
  Text = 'TEXT',
  Video = 'VIDEO'
}

export type ContentStageBlockModel = {
  __typename?: 'ContentStageBlockModel';
  imageUrl?: Maybe<Scalars['String']>;
  kind: ContentStageBlockKind;
  paragraph?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  videoUrl?: Maybe<Scalars['String']>;
};

export type ContentStageCandidateModel = {
  __typename?: 'ContentStageCandidateModel';
  completedAt?: Maybe<Scalars['Date']>;
  createdAt: Scalars['Date'];
  id: Scalars['Int'];
  kind: GenericStageKind;
  projectCandidate: ProjectCandidate;
  projectCandidateId: Scalars['Int'];
  stageId: Scalars['Int'];
  status: ContentStageCandidateStatus;
  subId: Scalars['ID'];
};

export enum ContentStageCandidateStatus {
  Completed = 'COMPLETED',
  NotStarted = 'NOT_STARTED'
}

export type ContentStageModel = {
  __typename?: 'ContentStageModel';
  blocks: Array<ContentStageBlockModel>;
  createdAt: Scalars['Date'];
  description: Scalars['String'];
  estimatedDurationMinutes: Scalars['Int'];
  id: Scalars['Int'];
  imageUrl?: Maybe<Scalars['String']>;
  kind: GenericStageKind;
  name: Scalars['String'];
  project: Project;
  projectId: Scalars['Int'];
  subId: Scalars['ID'];
};

export type ContentValidatiorPieceModel = {
  __typename?: 'ContentValidatiorPieceModel';
  numOfIqContent: Scalars['String'];
  numOfSsContent: Scalars['String'];
  numOfSsSpContent: Scalars['String'];
  numOfTraitContent: Scalars['String'];
  softSkillId?: Maybe<Scalars['Int']>;
  softSkillName?: Maybe<Scalars['String']>;
  traitId?: Maybe<Scalars['Int']>;
  traitName?: Maybe<Scalars['String']>;
};

export type ContentValidator = {
  __typename?: 'ContentValidator';
  content: Array<ContentValidatiorPieceModel>;
  count?: Maybe<Scalars['Int']>;
};

export type ContentViewerViewStageCandidateManagerReportModel = {
  __typename?: 'ContentViewerViewStageCandidateManagerReportModel';
  pollingStatus?: Maybe<PollingStatus>;
  pollingStatusMessage?: Maybe<Scalars['String']>;
  pollingSubStatus?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type ContentViewerViewStageCandidateProjectJobRoleModel = {
  __typename?: 'ContentViewerViewStageCandidateProjectJobRoleModel';
  id: Scalars['Int'];
  jobRoleId: Scalars['Int'];
  jobRoleName: Scalars['String'];
  projectId: Scalars['Int'];
  projectName: Scalars['String'];
  reports: Array<ContentViewerViewStageCandidateProjectJobRoleReportModel>;
  skillsProfileId: Scalars['Int'];
};

export type ContentViewerViewStageCandidateProjectJobRoleReportModel = {
  __typename?: 'ContentViewerViewStageCandidateProjectJobRoleReportModel';
  subType?: Maybe<ReportSubType>;
  type: ReportType;
  url: Scalars['String'];
};

export type ContentViewerViewStageCandidateReportModel = {
  __typename?: 'ContentViewerViewStageCandidateReportModel';
  pollingStatus?: Maybe<PollingStatus>;
  pollingStatusMessage?: Maybe<Scalars['String']>;
  pollingSubStatus?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export enum ContextualScorePositionType {
  Strength = 'STRENGTH',
  Weakness = 'WEAKNESS'
}

export type CreateFormFieldByFieldIdArgs = {
  displayOrder?: InputMaybe<Scalars['Int']>;
  fieldId: Scalars['Int'];
  isOptional: Scalars['Boolean'];
};

export type CreateMeetingAttendeeArgs = {
  email: Scalars['String'];
  isOrganiser: Scalars['Boolean'];
  name?: Scalars['String'];
  userId?: InputMaybe<Scalars['Int']>;
};

export type CreateProjectManagerInput = {
  actorRole?: InputMaybe<ActorRole>;
  userId: Scalars['Int'];
};

export enum DataSourceType {
  EmployeeAssessment = 'EMPLOYEE_ASSESSMENT',
  EmployeeSurvey = 'EMPLOYEE_SURVEY',
  Industry = 'INDUSTRY',
  JdReview = 'JD_REVIEW',
  ManagerSurvey = 'MANAGER_SURVEY'
}

export type DateField = Field & {
  __typename?: 'DateField';
  fieldInstanceType: FieldInstanceType;
  fieldOwnerId?: Maybe<Scalars['Int']>;
  fieldOwnerName?: Maybe<Scalars['String']>;
  fieldOwnerType?: Maybe<FieldOwnerType>;
  fieldType: FieldType;
  formManagerType: FormManagerType;
  hint?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isArchived: Scalars['Boolean'];
  name: Scalars['String'];
  question?: Maybe<Scalars['String']>;
  settings?: Maybe<FieldSettingsModel>;
  txtData?: Maybe<Scalars['String']>;
};

export type DateFilter = {
  from?: InputMaybe<Scalars['Date']>;
  to?: InputMaybe<Scalars['Date']>;
};

export type DateRangeInput = {
  from?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};

/** Outcome of one scheduling dead-letter replay run: how many messages were requested, how many were actually republished, and how many remain on the dead-letter queue afterwards. */
export type DeadLetterReplayReport = {
  __typename?: 'DeadLetterReplayReport';
  /** The dead-letter queue ready depth after this run, via `channel.checkQueue` (excludes messages checked out but not yet acked or nacked). */
  remaining: Scalars['Int'];
  /** The number of dead letters actually republished. */
  replayed: Scalars['Int'];
  /** The requested replay limit for this run. */
  requested: Scalars['Int'];
};

export enum DeiAgeRange {
  N18_30 = 'N18_30',
  N31_40 = 'N31_40',
  N41_50 = 'N41_50',
  N51_65 = 'N51_65',
  N65Plus = 'N65_PLUS',
  NLessthan_18 = 'N_LESSTHAN_18',
  PreferNotToSay = 'PREFER_NOT_TO_SAY'
}

export type DeiConsentEventModel = {
  __typename?: 'DeiConsentEventModel';
  actorUserId?: Maybe<Scalars['Int']>;
  event: DeiConsentEventType;
  occurredAt: Scalars['Date'];
};

export enum DeiConsentEventType {
  Declined = 'DECLINED',
  Given = 'GIVEN',
  Reopened = 'REOPENED',
  Revoked = 'REVOKED'
}

export enum DeiDisabilityIdentify {
  ChronicIllness = 'CHRONIC_ILLNESS',
  IntellectualDisability = 'INTELLECTUAL_DISABILITY',
  MentalHealthCondition = 'MENTAL_HEALTH_CONDITION',
  NeurodivergentCondition = 'NEURODIVERGENT_CONDITION',
  None = 'NONE',
  Other = 'OTHER',
  PhysicalImpairment = 'PHYSICAL_IMPAIRMENT',
  PreferNotToSay = 'PREFER_NOT_TO_SAY',
  SensoryImpairment = 'SENSORY_IMPAIRMENT',
  SpeechImpairment = 'SPEECH_IMPAIRMENT'
}

export enum DeiEthnicity {
  Asian = 'ASIAN',
  Black = 'BLACK',
  Hispanic = 'HISPANIC',
  IndigenousPeoples = 'INDIGENOUS_PEOPLES',
  MiddleEasternNorthAfrican = 'MIDDLE_EASTERN_NORTH_AFRICAN',
  Mixed = 'MIXED',
  Other = 'OTHER',
  PacificIslander = 'PACIFIC_ISLANDER',
  PreferNotToSay = 'PREFER_NOT_TO_SAY',
  White = 'WHITE'
}

export enum DeiFreeSchoolMeals {
  No = 'NO',
  NotApplicable = 'NOT_APPLICABLE',
  PreferNotToSay = 'PREFER_NOT_TO_SAY',
  Yes = 'YES'
}

export enum DeiGender {
  Female = 'FEMALE',
  GenderQueer = 'GENDER_QUEER',
  Intersex = 'INTERSEX',
  Male = 'MALE',
  NonBinary = 'NON_BINARY',
  Other = 'OTHER',
  PreferNotToSay = 'PREFER_NOT_TO_SAY'
}

export enum DeiNeurodivergenceIdentify {
  Adhd = 'ADHD',
  Autism = 'AUTISM',
  Dyscalculia = 'DYSCALCULIA',
  Dyslexia = 'DYSLEXIA',
  Dyspraxia = 'DYSPRAXIA',
  None = 'NONE',
  Other = 'OTHER',
  PreferNotToSay = 'PREFER_NOT_TO_SAY',
  Tourette = 'TOURETTE'
}

export enum DeiReligiousBelief {
  Agnosticism = 'AGNOSTICISM',
  Buddhism = 'BUDDHISM',
  Christianity = 'CHRISTIANITY',
  Hinduism = 'HINDUISM',
  Islam = 'ISLAM',
  Judaism = 'JUDAISM',
  Other = 'OTHER',
  PreferNotToSay = 'PREFER_NOT_TO_SAY',
  Secular = 'SECULAR',
  Sikhism = 'SIKHISM',
  Spiritual = 'SPIRITUAL'
}

export enum DeiSexualOrientation {
  Asexual = 'ASEXUAL',
  Bisexual = 'BISEXUAL',
  Gay = 'GAY',
  Lesbian = 'LESBIAN',
  Other = 'OTHER',
  Pansexual = 'PANSEXUAL',
  PreferNotToSay = 'PREFER_NOT_TO_SAY',
  Queer = 'QUEER',
  Straight = 'STRAIGHT'
}

export type DeiStageActionCandidateModel = {
  __typename?: 'DeiStageActionCandidateModel';
  consentEvents: Array<DeiConsentEventModel>;
  createdAt: Scalars['Date'];
  hasActiveConsent: Scalars['Boolean'];
  pastResponses?: Maybe<DeiStageActionCandidateResponsesModel>;
  responses: DeiStageActionCandidateResponsesModel;
  stageAction: DeiStageActionModel;
  stageCandidate: SmStageCandidateModel;
  status: DeiStageActionCandidateStatus;
  updatedAt: Scalars['Date'];
};

export type DeiStageActionCandidateResponsesInput = {
  ageRange?: InputMaybe<DeiAgeRange>;
  disabilityIdentify?: InputMaybe<Array<DeiDisabilityIdentify>>;
  disabilityIdentifyOther?: InputMaybe<Scalars['String']>;
  ethnicity?: InputMaybe<DeiEthnicity>;
  freeSchoolMeals?: InputMaybe<DeiFreeSchoolMeals>;
  genderIdentity?: InputMaybe<DeiGender>;
  hasDisability?: InputMaybe<DeiYesNo>;
  hasNeurodiversity?: InputMaybe<DeiYesNo>;
  hasTransgenderIdentity?: InputMaybe<DeiYesNo>;
  neurodivergenceIdentify?: InputMaybe<Array<DeiNeurodivergenceIdentify>>;
  neurodivergenceIdentifyOther?: InputMaybe<Scalars['String']>;
  religiousBelief?: InputMaybe<DeiReligiousBelief>;
  sexualOrientation?: InputMaybe<DeiSexualOrientation>;
};

export type DeiStageActionCandidateResponsesModel = {
  __typename?: 'DeiStageActionCandidateResponsesModel';
  ageRange?: Maybe<DeiAgeRange>;
  disabilityIdentify?: Maybe<Array<DeiDisabilityIdentify>>;
  disabilityIdentifyOther?: Maybe<Scalars['String']>;
  ethnicity?: Maybe<DeiEthnicity>;
  freeSchoolMeals?: Maybe<DeiFreeSchoolMeals>;
  genderIdentity?: Maybe<DeiGender>;
  hasDisability?: Maybe<DeiYesNo>;
  hasNeurodiversity?: Maybe<DeiYesNo>;
  hasTransgenderIdentity?: Maybe<DeiYesNo>;
  neurodivergenceIdentify?: Maybe<Array<DeiNeurodivergenceIdentify>>;
  neurodivergenceIdentifyOther?: Maybe<Scalars['String']>;
  religiousBelief?: Maybe<DeiReligiousBelief>;
  sexualOrientation?: Maybe<DeiSexualOrientation>;
};

export enum DeiStageActionCandidateStatus {
  Declined = 'DECLINED',
  Editable = 'EDITABLE',
  Submitted = 'SUBMITTED'
}

export type DeiStageActionFieldsInput = {
  hasAgeRangeField: Scalars['Boolean'];
  hasDisabilityField: Scalars['Boolean'];
  hasDisabilityIdentifyField: Scalars['Boolean'];
  hasEthnicityField: Scalars['Boolean'];
  hasFreeSchoolMealsField: Scalars['Boolean'];
  hasGenderIdentityField: Scalars['Boolean'];
  hasNeurodivergenceIdentifyField: Scalars['Boolean'];
  hasNeurodiversityField: Scalars['Boolean'];
  hasReligiousBeliefsField: Scalars['Boolean'];
  hasSexualOrientationField: Scalars['Boolean'];
};

export type DeiStageActionFieldsModel = {
  __typename?: 'DeiStageActionFieldsModel';
  hasAgeRangeField: Scalars['Boolean'];
  hasDisabilityField: Scalars['Boolean'];
  hasDisabilityIdentifyField: Scalars['Boolean'];
  hasEthnicityField: Scalars['Boolean'];
  hasFreeSchoolMealsField: Scalars['Boolean'];
  hasGenderIdentityField: Scalars['Boolean'];
  hasNeurodivergenceIdentifyField: Scalars['Boolean'];
  hasNeurodiversityField: Scalars['Boolean'];
  hasReligiousBeliefsField: Scalars['Boolean'];
  hasSexualOrientationField: Scalars['Boolean'];
};

export type DeiStageActionModel = {
  __typename?: 'DeiStageActionModel';
  completedCount: Scalars['Int'];
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  fields: DeiStageActionFieldsModel;
  stageId: Scalars['Int'];
  submittedCount: Scalars['Int'];
  updatedAt: Scalars['Date'];
};

export type DeiStageActionTemplateFieldsInput = {
  hasAgeRangeField: Scalars['Boolean'];
  hasDisabilityField: Scalars['Boolean'];
  hasDisabilityIdentifyField: Scalars['Boolean'];
  hasEthnicityField: Scalars['Boolean'];
  hasFreeSchoolMealsField: Scalars['Boolean'];
  hasGenderIdentityField: Scalars['Boolean'];
  hasNeurodivergenceIdentifyField: Scalars['Boolean'];
  hasNeurodiversityField: Scalars['Boolean'];
  hasReligiousBeliefsField: Scalars['Boolean'];
  hasSexualOrientationField: Scalars['Boolean'];
};

export type DeiStageActionTemplateFieldsModel = {
  __typename?: 'DeiStageActionTemplateFieldsModel';
  hasAgeRangeField: Scalars['Boolean'];
  hasDisabilityField: Scalars['Boolean'];
  hasDisabilityIdentifyField: Scalars['Boolean'];
  hasEthnicityField: Scalars['Boolean'];
  hasFreeSchoolMealsField: Scalars['Boolean'];
  hasGenderIdentityField: Scalars['Boolean'];
  hasNeurodivergenceIdentifyField: Scalars['Boolean'];
  hasNeurodiversityField: Scalars['Boolean'];
  hasReligiousBeliefsField: Scalars['Boolean'];
  hasSexualOrientationField: Scalars['Boolean'];
};

export type DeiStageActionTemplateModel = {
  __typename?: 'DeiStageActionTemplateModel';
  companyId: Scalars['Int'];
  createdAt: Scalars['Date'];
  fields: DeiStageActionTemplateFieldsModel;
  updatedAt: Scalars['Date'];
};

export enum DeiYesNo {
  No = 'NO',
  PreferNotToSay = 'PREFER_NOT_TO_SAY',
  Yes = 'YES'
}

export type DeleteByIdArgs = {
  id: Scalars['Int'];
};

export type DeleteFormFieldByFieldIdArgs = {
  fieldId: Scalars['Int'];
};

export type DeleteResult = {
  __typename?: 'DeleteResult';
  affected?: Maybe<Scalars['Int']>;
};

export type DeleteResultModel = {
  __typename?: 'DeleteResultModel';
  affected?: Maybe<Scalars['Int']>;
};

export type DemoConferenceToken = {
  __typename?: 'DemoConferenceToken';
  /** Number of demo sessions remaining for this conference */
  remainingDemos: Scalars['Int'];
  token: Scalars['String'];
};

export type DirectAccessInfo = {
  __typename?: 'DirectAccessInfo';
  actorRole?: Maybe<ActorRole>;
  hasAccess: Scalars['Boolean'];
};

export type DispatchEligibilityInviteForShortlistStageCandidateResultModel = {
  __typename?: 'DispatchEligibilityInviteForShortlistStageCandidateResultModel';
  /** One of: `SENT`, `SKIPPED_PORTAL_DISABLED`, `SKIPPED_NO_QUESTIONNAIRE`, `SKIPPED_NOT_ON_STAGE`, `SKIPPED_ALREADY_INVITED`. The SKIPPED_* outcomes are deliberate no-sends; a dispatch failure surfaces as a GraphQL error instead and releases the idempotency claim, so the call is safe to repeat. */
  outcome: Scalars['String'];
  /** True when the eligibility-questions invite email was sent. */
  sent: Scalars['Boolean'];
  /** The shortlist stage candidate subId that was processed. */
  shortlistStageCandidateSubId: Scalars['String'];
};

export enum DisplayScoreType {
  Grade = 'GRADE',
  None = 'NONE',
  Percentile = 'PERCENTILE',
  StenScore = 'STEN_SCORE',
  ZScore = 'Z_SCORE'
}

export type DlxRejectedEvent = {
  __typename?: 'DlxRejectedEvent';
  createdAt: Scalars['String'];
  deathQueue: Scalars['String'];
  deletedAt: Scalars['String'];
  event: Scalars['String'];
  id: Scalars['Int'];
  rejectedCount: Scalars['Int'];
  rejectedStatus: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type DuplicateBlueprintGroup = {
  __typename?: 'DuplicateBlueprintGroup';
  /** Assessment Stage ID (null for interview stage blueprints) */
  assessmentStageId?: Maybe<Scalars['Int']>;
  /** The blueprint that will be kept (has best generation status) */
  blueprintToKeep: DuplicateBlueprintInfo;
  /** All blueprints in this duplicate group */
  blueprints: Array<DuplicateBlueprintInfo>;
  /** Blueprints that will be soft-deleted */
  blueprintsToDelete: Array<DuplicateBlueprintInfo>;
  /** Interview Stage ID (null for assessment stage blueprints) */
  interviewStageId?: Maybe<Scalars['Int']>;
  /** Project Job Role ID */
  projectJobRoleId: Scalars['Int'];
};

export type DuplicateBlueprintInfo = {
  __typename?: 'DuplicateBlueprintInfo';
  /** Assessment Stage ID (null for interview stage blueprints) */
  assessmentStageId?: Maybe<Scalars['Int']>;
  /** When the blueprint was created */
  createdAt: Scalars['DateTime'];
  /** Generation status of the blueprint */
  generationStatus: Scalars['String'];
  /** Blueprint ID */
  id: Scalars['Int'];
  /** Interview Stage ID (null for assessment stage blueprints) */
  interviewStageId?: Maybe<Scalars['Int']>;
  /** Whether this blueprint is part of a valid version chain (has previousVersionId pointing to existing blueprint) */
  isPartOfChain: Scalars['Boolean'];
  /** Job role name */
  jobRoleName?: Maybe<Scalars['String']>;
  /** ID of the next version in the chain (null if head/latest) */
  nextVersionId?: Maybe<Scalars['Int']>;
  /** ID of the previous version in the chain (null if first version) */
  previousVersionId?: Maybe<Scalars['Int']>;
  /** Status of the previous version if exists (DRAFT, PUBLISHED, ARCHIVED) */
  previousVersionStatus?: Maybe<Scalars['String']>;
  /** Project Job Role ID */
  projectJobRoleId: Scalars['Int'];
  /** Project name */
  projectName?: Maybe<Scalars['String']>;
  /** Stage name */
  stageName?: Maybe<Scalars['String']>;
  /** Blueprint status (DRAFT, PUBLISHED, ARCHIVED) */
  status: Scalars['String'];
  /** Blueprint SubID (UUID) */
  subId: Scalars['String'];
  /** Version number of the blueprint */
  version: Scalars['Int'];
  /** Whether this blueprint will be deleted in the cleanup */
  willBeDeleted: Scalars['Boolean'];
};

export type DurationArgs = {
  unit: Scalars['String'];
  value: Scalars['Float'];
};

export type DurationModel = {
  __typename?: 'DurationModel';
  unit: Scalars['String'];
  value: Scalars['Float'];
};

export type EditingInfoModel = {
  __typename?: 'EditingInfoModel';
  editingStartedAt: Scalars['Date'];
  editingUserId: Scalars['Float'];
};

export type EditingResultModel = {
  __typename?: 'EditingResultModel';
  editingInfo?: Maybe<EditingInfoModel>;
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type EmploymentGap = {
  __typename?: 'EmploymentGap';
  from: Scalars['String'];
  months: Scalars['Int'];
  to: Scalars['String'];
};

export type EnglishProficiencyAnswerOption = {
  __typename?: 'EnglishProficiencyAnswerOption';
  index: Scalars['Int'];
  text: Scalars['String'];
};

export type EnglishProficiencyAssessment = {
  __typename?: 'EnglishProficiencyAssessment';
  id: Scalars['ID'];
  questions: Array<EnglishProficiencyQuestion>;
  remainingSeconds: Scalars['Int'];
  responses: Array<EnglishProficiencyResponse>;
  submittedAt?: Maybe<Scalars['Date']>;
};

export type EnglishProficiencyAssessmentStageAction = {
  __typename?: 'EnglishProficiencyAssessmentStageAction';
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  requiredCefrLevel: CefrLevel;
  stageId: Scalars['Int'];
  updatedAt: Scalars['Date'];
};

export type EnglishProficiencyAssessmentStageActionCandidate = {
  __typename?: 'EnglishProficiencyAssessmentStageActionCandidate';
  action: EnglishProficiencyAssessmentStageActionNested;
  assessmentId?: Maybe<Scalars['String']>;
  cefrLevel?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['Date']>;
  createdAt: Scalars['Date'];
  expiresAt?: Maybe<Scalars['Date']>;
  hasPassed?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  integrityMonitoringSession?: Maybe<IntegrityMonitoringSession>;
  rawScore?: Maybe<Scalars['Int']>;
  responses: Array<EnglishProficiencyReportResponse>;
  stageCandidate: SmStageCandidateModel;
  startedAt?: Maybe<Scalars['Date']>;
  status: EnglishProficiencyAssessmentStageActionCandidateStatus;
  updatedAt: Scalars['Date'];
};

export enum EnglishProficiencyAssessmentStageActionCandidateStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export type EnglishProficiencyAssessmentStageActionNested = {
  __typename?: 'EnglishProficiencyAssessmentStageActionNested';
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  requiredCefrLevel: CefrLevel;
  stageId: Scalars['Int'];
  updatedAt: Scalars['Date'];
};

export type EnglishProficiencyAsset = {
  __typename?: 'EnglishProficiencyAsset';
  kind: EnglishProficiencyAssetKind;
  url: Scalars['String'];
};

export enum EnglishProficiencyAssetKind {
  Audio = 'AUDIO',
  Image = 'IMAGE'
}

export type EnglishProficiencyMultipleChoiceQuestion = EnglishProficiencyQuestion & {
  __typename?: 'EnglishProficiencyMultipleChoiceQuestion';
  answers: Array<EnglishProficiencyAnswerOption>;
  asset?: Maybe<EnglishProficiencyAsset>;
  category: Scalars['String'];
  index: Scalars['Int'];
  instructions: Scalars['String'];
  kind: EnglishProficiencyQuestionKind;
  passage?: Maybe<EnglishProficiencyPassage>;
  tags: Array<Scalars['String']>;
  text: Scalars['String'];
};

export type EnglishProficiencyPassage = {
  __typename?: 'EnglishProficiencyPassage';
  body: Scalars['String'];
  title: Scalars['String'];
};

export type EnglishProficiencyQuestion = {
  asset?: Maybe<EnglishProficiencyAsset>;
  category: Scalars['String'];
  index: Scalars['Int'];
  instructions: Scalars['String'];
  kind: EnglishProficiencyQuestionKind;
  passage?: Maybe<EnglishProficiencyPassage>;
  tags: Array<Scalars['String']>;
  text: Scalars['String'];
};

export enum EnglishProficiencyQuestionKind {
  MultipleChoice = 'MULTIPLE_CHOICE',
  ShortAnswer = 'SHORT_ANSWER'
}

export type EnglishProficiencyReportResponse = {
  __typename?: 'EnglishProficiencyReportResponse';
  blankAnswers?: Maybe<Array<Scalars['String']>>;
  category: Scalars['String'];
  isCorrect: Scalars['Boolean'];
  questionIndex: Scalars['Int'];
  questionText: Scalars['String'];
  selectedAnswerText?: Maybe<Scalars['String']>;
  tags: Array<Scalars['String']>;
};

export type EnglishProficiencyResponse = {
  __typename?: 'EnglishProficiencyResponse';
  blankAnswers?: Maybe<Array<Scalars['String']>>;
  questionIndex: Scalars['Int'];
  selectedAnswerIndex?: Maybe<Scalars['Int']>;
  selectedAnswerText?: Maybe<Scalars['String']>;
};

export type EnglishProficiencySavedResponse = {
  __typename?: 'EnglishProficiencySavedResponse';
  remainingSeconds: Scalars['Int'];
  saved: Scalars['Boolean'];
};

export type EnglishProficiencyShortAnswerQuestion = EnglishProficiencyQuestion & {
  __typename?: 'EnglishProficiencyShortAnswerQuestion';
  asset?: Maybe<EnglishProficiencyAsset>;
  blankCount: Scalars['Int'];
  category: Scalars['String'];
  clue: Scalars['String'];
  index: Scalars['Int'];
  instructions: Scalars['String'];
  kind: EnglishProficiencyQuestionKind;
  passage?: Maybe<EnglishProficiencyPassage>;
  tags: Array<Scalars['String']>;
  text: Scalars['String'];
};

export type EnsureIscResultModel = {
  __typename?: 'EnsureIscResultModel';
  /** Total duration of the operation execution in milliseconds. */
  durationMs: Scalars['Int'];
  /** Number of required (Stage, Candidate) pairs that already existed. */
  existingIscCount: Scalars['Int'];
  /** Indicates if the operation was executed in dry-run mode (no changes persisted). */
  isDryRun: Scalars['Boolean'];
  /** Number of missing (Stage, Candidate) pairs that were actually created (0 in dry-run). */
  iscsCreatedCount: Scalars['Int'];
  /** Number of (Stage, Candidate) pairs that were identified as missing. */
  iscsToCreateCount: Scalars['Int'];
  /** Number of unique, active projects processed. */
  processedProjectCount: Scalars['Int'];
  /** Array of unique IDs of the active projects processed. */
  processedProjectIds: Array<Scalars['Int']>;
  /** Total number of active interview stages processed within the relevant projects. */
  processedStageCount: Scalars['Int'];
  /** Number of unique project candidates associated with the processed projects. */
  relevantCandidateCount: Scalars['Int'];
  /** Total number of (Stage, Candidate) pairs that should exist for processed stages/candidates. */
  requiredIscPairCount: Scalars['Int'];
};

export type EntityLanguageModel = {
  __typename?: 'EntityLanguageModel';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  entityId: Scalars['Int'];
  entityType: EntityType;
  id: Scalars['Int'];
  language: Language;
  updatedAt: Scalars['Date'];
};

export enum EntityType {
  Project = 'PROJECT'
}

/** Summary of evaluation results including RSP skill count and category-level scores */
export type EvaluationResultsSummaryModel = {
  __typename?: 'EvaluationResultsSummaryModel';
  /** Average scores grouped by skill category */
  categoryScores: Array<CategoryScoreModel>;
  /** Total number of unique skills from evaluations using the RSP */
  totalSkillsInRsp: Scalars['Int'];
};

/** Candidate feedback summary submitted by an evaluator */
export type EvaluatorCandidateFeedbackModel = {
  __typename?: 'EvaluatorCandidateFeedbackModel';
  /** Feedback text content (HTML) */
  content: Scalars['String'];
  status: InterviewCandidateFeedbackStatus;
};

/** Individual evaluator info and their evaluation status */
export type EvaluatorResultModel = {
  __typename?: 'EvaluatorResultModel';
  /** Candidate feedback submitted by this evaluator. Null if the evaluator skipped or did not submit feedback. */
  candidateFeedback?: Maybe<EvaluatorCandidateFeedbackModel>;
  /** InterviewEvaluation UUID */
  evaluationId: Scalars['String'];
  /** InterviewEvaluator UUID */
  evaluatorId: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  /** Recommended hiring decision. Null if not yet decided. */
  recommendedDecision?: Maybe<InterviewRecommendedDecision>;
  /** Evaluation status for this role (PENDING, COMPLETED, or SKIPPED) */
  status: InterviewEvaluationStatus;
  /** When the evaluation was submitted or skipped. Null while PENDING. */
  statusChangedAt?: Maybe<Scalars['Date']>;
  /** User ID of the evaluator */
  userId: Scalars['Int'];
};

/** Individual evaluator's score for a specific skill */
export type EvaluatorSkillScoreModel = {
  __typename?: 'EvaluatorSkillScoreModel';
  /** InterviewEvaluation UUID */
  evaluationId: Scalars['String'];
  /** InterviewEvaluator UUID */
  evaluatorId: Scalars['String'];
  firstName: Scalars['String'];
  /** Whether this score was generated by AI */
  isAIScored: Scalars['Boolean'];
  lastName: Scalars['String'];
  /** Score given by this evaluator (0-100) */
  score: Scalars['Int'];
  /** User ID of the evaluator */
  userId: Scalars['Int'];
};

export type ExperienceSummaryEntry = {
  __typename?: 'ExperienceSummaryEntry';
  company: Scalars['String'];
  directReports?: Maybe<Scalars['Int']>;
  endDate?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  teamSize?: Maybe<Scalars['Int']>;
  tenureMonths?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type ExternalAssessmentCodeScoreModel = {
  __typename?: 'ExternalAssessmentCodeScoreModel';
  /** Candidates coding challenge score from the raw platform data in percentage (if available) */
  codeScorePercentage: Scalars['Float'];
  /** Platform type where this assessment was taken */
  externalPlatformType: ExternalPlatformType;
  /** Name of the assessment candidate took */
  name: Scalars['String'];
  /** Report URL with the detailed results of the assessment (if platform supports it) */
  reportUrl: Scalars['String'];
  /** Amount of time the candidate took to complete the challenge based on the data from the platform (if available) */
  timeTakenMinutes: Scalars['Int'];
};

export type ExternalAssessmentFinalScoreModel = {
  __typename?: 'ExternalAssessmentFinalScoreModel';
  /** Platform type where this assessment was taken */
  externalPlatformType: ExternalPlatformType;
  /** Candidates final score from the raw platform data in percentage */
  finalScorePercentage: Scalars['Float'];
  /** Name of the assessment candidate took */
  name: Scalars['String'];
  /** Report URL with the detailed results of the assessment (if platform supports it) */
  reportUrl: Scalars['String'];
  /** Amount of time the candidate took to complete the challenge based on the data from the platform (if available) */
  timeTakenMinutes: Scalars['Int'];
};

export type ExternalAssessmentMcqScoreModel = {
  __typename?: 'ExternalAssessmentMcqScoreModel';
  /** Platform type where this assessment was taken */
  externalPlatformType: ExternalPlatformType;
  /** Candidates multi-choice questions score from the raw platform data in percentage (if available) */
  mcqScorePercentage: Scalars['Float'];
  /** Name of the assessment candidate took */
  name: Scalars['String'];
  /** Report URL with the detailed results of the assessment (if platform supports it) */
  reportUrl: Scalars['String'];
  /** Amount of time the candidate took to complete the challenge based on the data from the platform (if available) */
  timeTakenMinutes: Scalars['Int'];
};

export enum ExternalPlatformType {
  Coderbyte = 'CODERBYTE'
}

/** A wall-clock working window in an IANA zone */
export type FallbackWorkingWindowModel = {
  __typename?: 'FallbackWorkingWindowModel';
  /** Wall-clock end of the day, as HH:mm */
  end: Scalars['String'];
  /** Wall-clock start of the day, as HH:mm */
  start: Scalars['String'];
  /** The IANA zone the window is read in */
  timezone: Scalars['String'];
};

export type Field = {
  fieldInstanceType: FieldInstanceType;
  fieldOwnerId?: Maybe<Scalars['Int']>;
  fieldOwnerName?: Maybe<Scalars['String']>;
  fieldOwnerType?: Maybe<FieldOwnerType>;
  fieldType: FieldType;
  formManagerType: FormManagerType;
  hint?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isArchived: Scalars['Boolean'];
  name: Scalars['String'];
  question?: Maybe<Scalars['String']>;
  settings?: Maybe<FieldSettingsModel>;
  txtData?: Maybe<Scalars['String']>;
};

export enum FieldInstanceType {
  /** Multiple - Information is not shared between forms */
  Multiple = 'MULTIPLE',
  /** Singleton - All forms share the same information */
  Singleton = 'SINGLETON'
}

export enum FieldOwnerType {
  CompanyFieldOwner = 'COMPANY_FIELD_OWNER',
  SzFieldOwner = 'SZ_FIELD_OWNER'
}

export type FieldSettingsArgs = {
  allowFreeText?: InputMaybe<Scalars['Boolean']>;
  searchable?: InputMaybe<Scalars['Boolean']>;
};

export type FieldSettingsModel = {
  __typename?: 'FieldSettingsModel';
  allowFreeText?: Maybe<Scalars['Boolean']>;
  searchable?: Maybe<Scalars['Boolean']>;
};

export enum FieldType {
  CompanyEmployeeSelectField = 'COMPANY_EMPLOYEE_SELECT_FIELD',
  /** Date */
  DateField = 'DATE_FIELD',
  /** Long text */
  LongTextField = 'LONG_TEXT_FIELD',
  /** Multiple select */
  MultipleSelectField = 'MULTIPLE_SELECT_FIELD',
  /** Short text */
  ShortTextField = 'SHORT_TEXT_FIELD',
  /** Single select */
  SingleSelectField = 'SINGLE_SELECT_FIELD'
}

export type FileExportScheduledTask = ScheduledTask & {
  __typename?: 'FileExportScheduledTask';
  args: ScheduledTaskArgs;
  blob?: Maybe<MonolithBlobModel>;
  error?: Maybe<Scalars['String']>;
  kind: ScheduledTaskKind;
  status: ScheduledTaskStatus;
  subId: Scalars['String'];
};

export type FilterMomentRange = {
  from?: InputMaybe<Scalars['Date']>;
  to?: InputMaybe<Scalars['Date']>;
};

export type FindProjectCandidatesPaginatedAiInterviewStageFilterArgs = {
  /** True keeps only interviews the hiring team wrote a note on. Combines with the score range. */
  hasNote?: InputMaybe<Scalars['Boolean']>;
  /** Keeps only candidates who interviewed on one of these interview guide blueprint versions (blueprint ids). Candidates who have not started have no version. */
  interviewGuideBlueprintIds?: InputMaybe<Array<Scalars['Int']>>;
  summaryScoreGte?: InputMaybe<Scalars['Float']>;
  summaryScoreLte?: InputMaybe<Scalars['Float']>;
};

export type FindProjectCandidatesPaginatedFilterArgs = {
  allAttempts?: Scalars['Boolean'];
  assessmentStatus?: InputMaybe<Array<ProjectCandidateAssessmentStatusFilter>>;
  dateAdded?: InputMaybe<DateFilter>;
  dateInvited?: InputMaybe<DateFilter>;
  dateUpdated?: InputMaybe<DateFilter>;
  interviewStageCandidateIds?: InputMaybe<InterviewStageCandidateIdFilter>;
  nameOrEmailContains?: InputMaybe<Scalars['String']>;
  overallScorePercentileGte?: InputMaybe<Scalars['Float']>;
  overallScorePercentileLte?: InputMaybe<Scalars['Float']>;
};

export type FindProjectCandidatesPaginatedOrderArgs = {
  direction?: SortOption;
  field?: FindProjectCandidatesPaginatedOrderField;
  fieldReferenceId?: InputMaybe<Scalars['ID']>;
};

export enum FindProjectCandidatesPaginatedOrderField {
  AiInterviewGuideVersion = 'AI_INTERVIEW_GUIDE_VERSION',
  AiInterviewIntegrityFlags = 'AI_INTERVIEW_INTEGRITY_FLAGS',
  AiInterviewScore = 'AI_INTERVIEW_SCORE',
  AiInterviewStatus = 'AI_INTERVIEW_STATUS',
  AssessmentScore = 'ASSESSMENT_SCORE',
  AssessmentStatus = 'ASSESSMENT_STATUS',
  DateAdded = 'DATE_ADDED',
  DateInvited = 'DATE_INVITED',
  DateUpdated = 'DATE_UPDATED',
  Decision = 'DECISION',
  Name = 'NAME',
  ShortlistedStatus = 'SHORTLISTED_STATUS',
  ShortlistCriteriaScore = 'SHORTLIST_CRITERIA_SCORE',
  ShortlistCriterionResult = 'SHORTLIST_CRITERION_RESULT',
  Stage = 'STAGE',
  StageDateAdded = 'STAGE_DATE_ADDED'
}

export type FindProjectCandidatesPaginatedProgressionFilterArgs = {
  projectCandidateStatuses?: InputMaybe<Array<ProgressionStatus>>;
  stageFilters?: InputMaybe<FindProjectCandidatesPaginatedProgressionStageFilterArgs>;
};

export type FindProjectCandidatesPaginatedProgressionStageFilterArgs = {
  dateAdded?: InputMaybe<DateFilter>;
  stageIds: Array<Scalars['Int']>;
  stageStatuses?: InputMaybe<Array<StageProgressionStatus>>;
  stageTypes: Array<StageType>;
};

export type FindProjectCandidatesPaginatedShortlistStageFilterArgs = {
  matchScoreGte?: InputMaybe<Scalars['Float']>;
  matchScoreLte?: InputMaybe<Scalars['Float']>;
  /** Splits candidates by their answers to the stage's application questions that are shown in the table and have a preferred answer. A skipped question counts as missed. */
  preferredAnswers?: InputMaybe<ProjectCandidatePreferredAnswersFilter>;
  shortlisted?: InputMaybe<ProjectCandidateShortlistedFilter>;
};

/** The time one candidate's interview is booked at */
export type FixedInterviewTimeInput = {
  /** The draft request the time is for */
  requestId: Scalars['ID'];
  /** When the interview starts */
  startsAt: Scalars['DateTime'];
};

export type FocusedSoftSkill = SoftSkill & {
  __typename?: 'FocusedSoftSkill';
  broadSoftSkills: Array<BasicBroadSoftSkill>;
  category: SoftSkillCategory;
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  examples: Array<Scalars['String']>;
  granularity: SoftSkillGranularity;
  /** @deprecated Please use subId instead */
  id: Scalars['Int'];
  measurementConstructType?: Maybe<MeasurementConstructType>;
  name: Scalars['String'];
  similarSoftSkills: Array<BasicBroadSoftSkill>;
  softSkillTraits?: Maybe<Array<SoftSkillTrait>>;
  subId: Scalars['ID'];
  taxonomyVersion: Scalars['Int'];
  updatedAt: Scalars['Date'];
};

export type Form = {
  __typename?: 'Form';
  formFields?: Maybe<Array<FormField>>;
  formManagerType: FormManagerType;
  formOwner: FormOwner;
  formOwnerName: Scalars['String'];
  formType: FormType;
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type FormBuilder = {
  __typename?: 'FormBuilder';
  availableFields?: Maybe<Array<Field>>;
  form?: Maybe<Form>;
};

export type FormCandidateModel = {
  __typename?: 'FormCandidateModel';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  form: Form;
  formId: Scalars['Int'];
  id: Scalars['Int'];
  stageCandidate?: Maybe<SmStageCandidateModel>;
  stageCandidateId: Scalars['Int'];
  status: FormCandidateStatus;
  subId: Scalars['String'];
  updatedAt: Scalars['Date'];
};

export enum FormCandidateStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export type FormField = {
  __typename?: 'FormField';
  displayOrder: Scalars['Int'];
  field: Field;
  form: Form;
  id: Scalars['Int'];
  isOptional: Scalars['Boolean'];
};

export enum FormManagerType {
  Apprentice = 'APPRENTICE',
  /** Candidate Information */
  Ci = 'CI',
  /** Global - all forms can use this */
  Global = 'GLOBAL',
  /** Manager survey */
  ManagerSurvey = 'MANAGER_SURVEY',
  /** Quality of hire */
  QualityOfHire = 'QUALITY_OF_HIRE',
  Rs = 'RS',
  /** Talent reveiw */
  TalentReview = 'TALENT_REVIEW'
}

export type FormOwner = {
  __typename?: 'FormOwner';
  form: Form;
  formId: Scalars['Int'];
  formOwnerId: Scalars['Int'];
  id: Scalars['Int'];
};

export type FormReportFormOwners = {
  __typename?: 'FormReportFormOwners';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type FormReportIndividualQueries = {
  __typename?: 'FormReportIndividualQueries';
  associatedIds?: Maybe<Array<Scalars['Int']>>;
  formManagerTypes?: Maybe<Array<FormManagerType>>;
  formTypes?: Maybe<Array<FormType>>;
};

export enum FormType {
  ApprenticeForm = 'APPRENTICE_FORM',
  AweApprenticeForm = 'AWE_APPRENTICE_FORM',
  AweDsus = 'AWE_DSUS',
  CdForm = 'CD_FORM',
  CiForm = 'CI_FORM',
  GradForm = 'GRAD_FORM',
  MsEmployeeForm = 'MS_EMPLOYEE_FORM',
  MsManagerForm = 'MS_MANAGER_FORM',
  RsForm = 'RS_FORM',
  TrForm = 'TR_FORM',
  UndergradForm = 'UNDERGRAD_FORM'
}

export type GenerateStageIndirectInvitationUrlModel = {
  __typename?: 'GenerateStageIndirectInvitationUrlModel';
  url: Scalars['String'];
};

export enum GenericStageKind {
  ContentStage = 'CONTENT_STAGE',
  OfferStage = 'OFFER_STAGE'
}

export type GetHiringProcessTemplatesFilterArgs = {
  includeArchived?: Scalars['Boolean'];
  keyword?: InputMaybe<Scalars['String']>;
};

export type GetHiringProcessTemplatesOrderArgs = {
  direction: SortOption;
  field: HiringProcessTemplateOrderField;
};

export enum GetOption {
  OrDefault = 'OR_DEFAULT',
  OrEmptyArray = 'OR_EMPTY_ARRAY',
  OrNull = 'OR_NULL',
  OrThrow = 'OR_THROW'
}

export type GetSkillsProfileTemplatesFilterArgs = {
  includeArchived?: Scalars['Boolean'];
  keyword?: InputMaybe<Scalars['String']>;
};

export type GetSkillsProfileTemplatesOrderArgs = {
  direction: SortOption;
  field: SkillsProfileTemplateOrderField;
};

export enum Grade {
  A = 'A',
  APlus = 'A_PLUS',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E'
}

export type GradeBandUnion = IgBehaviourGradeBandModel | InterviewGuideCustomGradeBandModel | InterviewGuideFinalDecisionGradeBandModel | SoftSkillSelfAssessmentGradeBandModel | StatisticalGradeBandModel | TechnicalSkillSelfAssessmentGradeBandModel | TrCustomGradeBandModel;

export enum GradingMethod {
  Percentile = 'PERCENTILE',
  Sten = 'STEN'
}

export enum GrammaticalGender {
  Feminine = 'FEMININE',
  Masculine = 'MASCULINE'
}

export type GroupInfo = {
  __typename?: 'GroupInfo';
  actorRole: ActorRole;
  name: Scalars['String'];
};

export type HiringManager = {
  externalId: Scalars['String'];
};

export type HiringProcessDeadlineSettingsUpdatePayload = {
  __typename?: 'HiringProcessDeadlineSettingsUpdatePayload';
  extendedCandidatesCount: Scalars['Int'];
  project: Project;
};

export enum HiringProcessDeadlineType {
  Absolute = 'ABSOLUTE',
  Relative = 'RELATIVE'
}

export enum HiringProcessDeadlineUnit {
  Days = 'DAYS',
  Weeks = 'WEEKS'
}

export type HiringProcessTemplate = {
  __typename?: 'HiringProcessTemplate';
  company: Company;
  companyId: Scalars['Int'];
  createdAt: Scalars['Date'];
  createdByUser?: Maybe<User>;
  createdByUserId?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['Date']>;
  description: Scalars['String'];
  id: Scalars['Int'];
  latestVersion?: Maybe<HiringProcessTemplateVersion>;
  name: Scalars['String'];
  versions: Array<HiringProcessTemplateVersion>;
};

export enum HiringProcessTemplateInapplicabilityReason {
  AiInterviewNotEnabled = 'AI_INTERVIEW_NOT_ENABLED',
  MultiAssessmentStagesDisabled = 'MULTI_ASSESSMENT_STAGES_DISABLED',
  ShortlistingNotEnabled = 'SHORTLISTING_NOT_ENABLED',
  StageTypeLimitExceeded = 'STAGE_TYPE_LIMIT_EXCEEDED'
}

export type HiringProcessTemplateOption = {
  __typename?: 'HiringProcessTemplateOption';
  inapplicabilityReason?: Maybe<HiringProcessTemplateInapplicabilityReason>;
  isApplicable: Scalars['Boolean'];
  stages: Array<HiringProcessTemplateVersionStage>;
  template: HiringProcessTemplate;
  version: HiringProcessTemplateVersion;
};

export enum HiringProcessTemplateOrderField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  PublishedAt = 'PUBLISHED_AT'
}

export type HiringProcessTemplatePaginated = {
  __typename?: 'HiringProcessTemplatePaginated';
  archivedCount: Scalars['Int'];
  page: Pageinfo;
  templates: Array<HiringProcessTemplate>;
};

export type HiringProcessTemplateStageInput = {
  isLocked?: Scalars['Boolean'];
  name: Scalars['String'];
  stageType: HiringProcessTemplateStageType;
};

export enum HiringProcessTemplateStageType {
  AiInterview = 'AI_INTERVIEW',
  Assessment = 'ASSESSMENT',
  Interview = 'INTERVIEW',
  Shortlist = 'SHORTLIST'
}

export type HiringProcessTemplateVersion = {
  __typename?: 'HiringProcessTemplateVersion';
  createdAt: Scalars['Date'];
  createdByUser?: Maybe<User>;
  createdByUserId?: Maybe<Scalars['Int']>;
  fixed: Scalars['Boolean'];
  id: Scalars['Int'];
  stages: Array<HiringProcessTemplateVersionStage>;
  template: HiringProcessTemplate;
  templateId: Scalars['Int'];
  version: Scalars['Int'];
};

export type HiringProcessTemplateVersionStage = {
  __typename?: 'HiringProcessTemplateVersionStage';
  id: Scalars['Int'];
  isLocked: Scalars['Boolean'];
  name: Scalars['String'];
  order: Scalars['Int'];
  stageType: HiringProcessTemplateStageType;
  templateVersionId: Scalars['Int'];
  version: HiringProcessTemplateVersion;
};

export type HiringTeamUser = {
  __typename?: 'HiringTeamUser';
  companyId: Scalars['Int'];
  companyName: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id: Scalars['Int'];
  lastName: Scalars['String'];
};

export type IAssessmentDataQuestionModel = {
  questionSubId: Scalars['String'];
  timestamp: Scalars['Date'];
  traitId?: InputMaybe<Scalars['Int']>;
};

export type IIgBehaviourResultScoreModel = {
  igEvaluation: IgBehaviourEvaluation;
};

export type IProjectRequestUserApprovalCreateOneArgs = {
  projectRequestUserId: Scalars['Int'];
};

export type IProjectRequestUserApprovalUpdateOneArgs = {
  approvalRequestDate?: InputMaybe<Scalars['DateTime']>;
  approvalStatus?: InputMaybe<ProjectRequestUserApprovalStatus>;
  id: Scalars['Int'];
};

export type IProjectRequestUserCreateOneWithEmployeeCheckArgs = {
  approvalId?: InputMaybe<Scalars['Int']>;
  email: Scalars['String'];
  projectRequestId: Scalars['Int'];
  type: ProjectRequestUserType;
};

export type ISoftSkillSelfAssessmentScoreModel = {
  proficiency: SoftSkillSelfAssessmentProficiencyLevel;
};

export type IStatisticalResultScoreModel = {
  grade: Grade;
  percentile: Scalars['Float'];
  stenScore: Scalars['Float'];
  zScore: Scalars['Float'];
};

export type ITechnicalSkillSelfAssessmentScoreModel = {
  technicalProficiency: TechnicalSkillSelfAssessmentProficiencyLevel;
};

export enum IdentityPermissionRole {
  Admin = 'ADMIN',
  AdminE2ETest = 'ADMIN_E2E_TEST',
  ApiManager = 'API_MANAGER',
  Authenticator = 'AUTHENTICATOR',
  Authorizer = 'AUTHORIZER',
  Candidate = 'CANDIDATE',
  CompanyCandidate = 'COMPANY_CANDIDATE',
  FullAccess = 'FULL_ACCESS',
  LimitedAccess = 'LIMITED_ACCESS',
  Migrator = 'MIGRATOR',
  Scheduler = 'SCHEDULER',
  StandardAccess = 'STANDARD_ACCESS',
  SzApi = 'SZ_API',
  SzSuperAdmin = 'SZ_SUPER_ADMIN',
  WebhookHandler = 'WEBHOOK_HANDLER'
}

export type IdentityProviderModel = {
  __typename?: 'IdentityProviderModel';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  subId: Scalars['String'];
  updatedAt: Scalars['Date'];
};

export enum IgBehaviourEvaluation {
  Good = 'GOOD',
  Na = 'NA',
  Poor = 'POOR'
}

export type IgBehaviourGradeBandModel = {
  __typename?: 'IgBehaviourGradeBandModel';
  displayText: Scalars['String'];
  igEvaluation: IgBehaviourEvaluation;
  position: Scalars['Int'];
};

export type IgBehaviourResultScoreModel = {
  __typename?: 'IgBehaviourResultScoreModel';
  igEvaluation: IgBehaviourEvaluation;
};

export type IgCustomResultScoreModel = {
  __typename?: 'IgCustomResultScoreModel';
  igCustomEvaluation: InterviewGuideCustomEvaluation;
};

export type IgFinalDecisionResultScoreModel = {
  __typename?: 'IgFinalDecisionResultScoreModel';
  igFinalDecisionEvaluation: InterviewGuideFinalDecisionEvaluation;
};

export type InductiveItemModel = {
  __typename?: 'InductiveItemModel';
  isCompleted: Scalars['Boolean'];
  question?: Maybe<InductiveQuestionModel>;
  remainingQuestions: Scalars['Int'];
  remainingTime: Scalars['Int'];
  /** @deprecated Please use new property `isCompleted` if you wish to know whether the assessment is completed or not! */
  testCandidateStatus: TestStatus;
  totalQuestions: Scalars['Int'];
};

export type InductiveOptionModel = {
  __typename?: 'InductiveOptionModel';
  imageUrl: Scalars['String'];
  key: Scalars['Int'];
  subId: Scalars['String'];
};

export type InductiveQuestionModel = {
  __typename?: 'InductiveQuestionModel';
  difficulty: Scalars['Float'];
  imageUrls: Array<Maybe<Scalars['String']>>;
  options: Array<InductiveOptionModel>;
  subId: Scalars['String'];
  text: Scalars['String'];
  timeLimit: Scalars['Int'];
};

export type InputScoreModel = {
  customEvaluation?: InputMaybe<Scalars['String']>;
  customScore?: InputMaybe<Scalars['Float']>;
  grade?: InputMaybe<Grade>;
  percentile?: InputMaybe<Scalars['Float']>;
  stenScore?: InputMaybe<Scalars['Float']>;
  zScore?: InputMaybe<Scalars['Float']>;
};

export type IntegrityEvent = {
  __typename?: 'IntegrityEvent';
  createdAt: Scalars['DateTime'];
  endedAt?: Maybe<Scalars['Float']>;
  eventType: IntegrityEventType;
  id: Scalars['ID'];
  metadata?: Maybe<Scalars['JSONObject']>;
  startedAt: Scalars['Float'];
};

export type IntegrityEventInput = {
  endedAt?: InputMaybe<Scalars['Float']>;
  eventType: IntegrityEventType;
  metadata?: InputMaybe<Scalars['JSONObject']>;
  startedAt: Scalars['Float'];
};

export enum IntegrityEventType {
  CameraDeviceSwitched = 'CAMERA_DEVICE_SWITCHED',
  CameraTurnedOff = 'CAMERA_TURNED_OFF',
  DeveloperConsoleOpened = 'DEVELOPER_CONSOLE_OPENED',
  MultipleFacesDetected = 'MULTIPLE_FACES_DETECTED',
  NoFaceDetected = 'NO_FACE_DETECTED',
  PastedFromExternalSources = 'PASTED_FROM_EXTERNAL_SOURCES',
  PhoneDetected = 'PHONE_DETECTED',
  TabSwitch = 'TAB_SWITCH',
  WindowResize = 'WINDOW_RESIZE'
}

export type IntegrityMonitoringSession = {
  __typename?: 'IntegrityMonitoringSession';
  browserVersion?: Maybe<Scalars['String']>;
  deviceOs?: Maybe<Scalars['String']>;
  deviceType?: Maybe<Scalars['String']>;
  endedAt?: Maybe<Scalars['DateTime']>;
  events: Array<IntegrityEvent>;
  flagsCount: Scalars['Int'];
  id: Scalars['ID'];
  metadata?: Maybe<Scalars['JSONObject']>;
  screenIsExtended?: Maybe<Scalars['Boolean']>;
  startedAt: Scalars['DateTime'];
  timezone?: Maybe<Scalars['String']>;
  verdict?: Maybe<IntegrityMonitoringSessionVerdict>;
};

export enum IntegrityMonitoringSessionVerdict {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type InterviewAutosuggestionEventPayload = {
  __typename?: 'InterviewAutosuggestionEventPayload';
  confidenceRating: Scalars['Float'];
  createdAt: Scalars['Date'];
  createdBy: Scalars['Int'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['String'];
  interviewId: Scalars['String'];
  interviewStageCandidateId?: Maybe<Scalars['Int']>;
  isAccepted?: Maybe<Scalars['Boolean']>;
  projectJobRoleId?: Maybe<Scalars['Int']>;
  skills: Array<SkillEventPayload>;
  status: InterviewSkillsEvaluationStatusV2;
  updatedAt: Scalars['Date'];
};

export type InterviewAutosuggestionModelV2 = {
  __typename?: 'InterviewAutosuggestionModelV2';
  confidenceRating: Scalars['Float'];
  createdAt: Scalars['Date'];
  createdBy: Scalars['Int'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['String'];
  interviewId: Scalars['String'];
  interviewStageCandidateId?: Maybe<Scalars['Int']>;
  isAccepted?: Maybe<Scalars['Boolean']>;
  projectJobRoleId?: Maybe<Scalars['Int']>;
  skills: Array<SkillModel>;
  status: InterviewSkillsEvaluationStatusV2;
  updatedAt: Scalars['Date'];
};

export enum InterviewCandidateFeedbackStatus {
  Error = 'ERROR',
  Generated = 'GENERATED',
  Generating = 'GENERATING',
  ModifiedByUser = 'MODIFIED_BY_USER'
}

export type InterviewDecisionModelV2 = {
  __typename?: 'InterviewDecisionModelV2';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['String'];
  interviewEvaluation?: Maybe<InterviewEvaluationModel>;
  interviewEvaluationId: Scalars['String'];
  recommendedDecision?: Maybe<InterviewRecommendedDecision>;
  updatedAt: Scalars['Date'];
};

/** Evaluation decision data for a single interview linked to a stage candidate */
export type InterviewEvaluationDecisionsModel = {
  __typename?: 'InterviewEvaluationDecisionsModel';
  /** When the interview was created */
  createdAt: Scalars['Date'];
  /** All evaluators assigned to this interview with their decision data */
  evaluators: Array<EvaluatorResultModel>;
  /** Interview id */
  interviewId: Scalars['String'];
  /** Interview name */
  interviewName: Scalars['String'];
  /** True when the viewer is an evaluator who has not yet submitted */
  isResultsHidden: Scalars['Boolean'];
  /** Meeting UUID linked to this interview */
  meetingId: Scalars['String'];
};

export type InterviewEvaluationEventPayload = {
  __typename?: 'InterviewEvaluationEventPayload';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  evaluator?: Maybe<InterviewEvaluatorEventPayload>;
  id: Scalars['String'];
  interviewEvaluatorId: Scalars['String'];
  interviewStageCandidateId?: Maybe<Scalars['Int']>;
  projectJobRoleId?: Maybe<Scalars['Int']>;
  skillsEvaluation?: Maybe<SkillsEvaluationEventPayload>;
  updatedAt: Scalars['Date'];
};

export type InterviewEvaluationModel = {
  __typename?: 'InterviewEvaluationModel';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  evaluator?: Maybe<InterviewEvaluatorModel>;
  id: Scalars['String'];
  interviewDecision?: Maybe<InterviewDecisionModelV2>;
  interviewEvaluatorId: Scalars['String'];
  interviewStageCandidateId?: Maybe<Scalars['Int']>;
  projectJobRoleId?: Maybe<Scalars['Int']>;
  skillsEvaluation?: Maybe<SkillsEvaluationModelV2>;
  /** Current status of this evaluation (PENDING, COMPLETED, or SKIPPED) */
  status: InterviewEvaluationStatus;
  /** Timestamp when the evaluation was submitted (COMPLETED) or skipped (SKIPPED). Null while PENDING. */
  statusChangedAt?: Maybe<Scalars['Date']>;
  updatedAt: Scalars['Date'];
};

/** Aggregated evaluation results for an interview scoped to a project job role */
export type InterviewEvaluationResultsModel = {
  __typename?: 'InterviewEvaluationResultsModel';
  /** All evaluators assigned to this interview, regardless of status */
  evaluators: Array<EvaluatorResultModel>;
  /** Interview UUID */
  interviewId: Scalars['String'];
  /** Project job role ID */
  projectJobRoleId: Scalars['Int'];
  /** Per-skill aggregated scores across all completed evaluations */
  skillResults: Array<SkillResultModel>;
  /** Summary with RSP skill count and category-level averages */
  summary: EvaluationResultsSummaryModel;
};

/** Status of an interview evaluation for a specific project job role. PENDING is the initial state; COMPLETED and SKIPPED are final. */
export enum InterviewEvaluationStatus {
  /** Evaluator has completed their evaluation for this role (final, irreversible) */
  Completed = 'COMPLETED',
  /** Evaluation has not yet been submitted or skipped */
  Pending = 'PENDING',
  /** Evaluator has chosen to skip this evaluation (final, irreversible) */
  Skipped = 'SKIPPED'
}

export type InterviewEvaluatorEventPayload = {
  __typename?: 'InterviewEvaluatorEventPayload';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['String'];
  interviewId: Scalars['String'];
  updatedAt: Scalars['Date'];
  userId: Scalars['Int'];
};

export type InterviewEvaluatorModel = {
  __typename?: 'InterviewEvaluatorModel';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['String'];
  interview?: Maybe<InterviewV2Model>;
  interviewId: Scalars['String'];
  updatedAt: Scalars['Date'];
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

export type InterviewEventPayload = {
  __typename?: 'InterviewEventPayload';
  createdAt: Scalars['Date'];
  createdBy: Scalars['Int'];
  deletedAt?: Maybe<Scalars['Date']>;
  evaluators: Array<InterviewEvaluatorEventPayload>;
  id: Scalars['String'];
  linkedInterviewStageCandidateId?: Maybe<Scalars['Int']>;
  linkedProjectJobRoleId?: Maybe<Scalars['Int']>;
  meetingId: Scalars['String'];
  metadata: Scalars['JSON'];
  name: Scalars['String'];
  projectCandidateSubId?: Maybe<Scalars['String']>;
  status: InterviewV2Status;
  updatedAt: Scalars['Date'];
};

export type InterviewGuideBlueprintEventPayload = {
  __typename?: 'InterviewGuideBlueprintEventPayload';
  companyId: Scalars['Int'];
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  duration: Scalars['Int'];
  editingStartedAt?: Maybe<Scalars['Date']>;
  editingUserId?: Maybe<Scalars['Float']>;
  estimatedDuration: Scalars['Int'];
  generationStatus: InterviewGuideBlueprintGenerationStatus;
  id: Scalars['Int'];
  interviewStageId?: Maybe<Scalars['Int']>;
  isQuestionListModified: Scalars['Boolean'];
  isQuestionsEdited: Scalars['Boolean'];
  lastUpdatedAt: Scalars['Date'];
  lastUpdatedById?: Maybe<Scalars['Int']>;
  minorVersion: Scalars['Int'];
  nextVersionId?: Maybe<Scalars['Int']>;
  previousVersionId?: Maybe<Scalars['Int']>;
  projectJobRoleId?: Maybe<Scalars['Int']>;
  publishedAt?: Maybe<Scalars['Date']>;
  publishedById?: Maybe<Scalars['Int']>;
  questions: Array<InterviewGuideBlueprintQuestionModel>;
  questionsCompleted: Scalars['Int'];
  questionsFailed: Scalars['Int'];
  questionsGenerating: Scalars['Int'];
  status: InterviewGuideBlueprintStatus;
  subId: Scalars['ID'];
  updatedAt: Scalars['Date'];
  version: Scalars['Int'];
};

export enum InterviewGuideBlueprintGenerationStatus {
  Completed = 'COMPLETED',
  GeneratingQuestions = 'GENERATING_QUESTIONS',
  GeneratingSkeleton = 'GENERATING_SKELETON',
  GenerationFailed = 'GENERATION_FAILED',
  NotStarted = 'NOT_STARTED',
  SkeletonReady = 'SKELETON_READY'
}

export type InterviewGuideBlueprintModel = {
  __typename?: 'InterviewGuideBlueprintModel';
  assessmentStage?: Maybe<SmStageModel>;
  assessmentStageId?: Maybe<Scalars['Int']>;
  cachedLocales: Array<SupportedLocale>;
  canPublish: Scalars['Boolean'];
  canRetry: Scalars['Boolean'];
  /** The number of candidate interview guides on this version. A regenerated guide counts towards the version it was regenerated onto, and guides soft-deleted on a retake are not counted. */
  candidatesAssessedCount: Scalars['Int'];
  companyId: Scalars['Int'];
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  duration: Scalars['Int'];
  estimatedDuration: Scalars['Int'];
  generationStatus: InterviewGuideBlueprintGenerationStatus;
  /** True once any candidate has entered this AI interview stage, in any status, so a new major version would leave scores incomparable. Always false for human interview stages. */
  hasAiInterviewCandidates: Scalars['Boolean'];
  /** True while candidates have not yet finished this AI interview stage, so an edit would give them different interviews. Always false for human interview stages. */
  hasPendingAiInterviewCandidates: Scalars['Boolean'];
  id: Scalars['ID'];
  interviewStage?: Maybe<InterviewStage>;
  interviewStageId?: Maybe<Scalars['Int']>;
  /** True when the company has AI interviews switched off, so only Spotted Zebra users may change this guide. Always false for human interview stages. */
  isAiInterviewSelfServeDisabled: Scalars['Boolean'];
  isQuestionListModified: Scalars['Boolean'];
  isQuestionsEdited: Scalars['Boolean'];
  lastPublishedinterviewGuideBlueprint: InterviewGuideBlueprintModel;
  lastUpdatedAt: Scalars['Date'];
  lastUpdatedById?: Maybe<Scalars['Int']>;
  minorVersion: Scalars['Int'];
  nextVersion?: Maybe<InterviewGuideBlueprintModel>;
  nextVersionId?: Maybe<Scalars['Int']>;
  originSubId?: Maybe<Scalars['String']>;
  previousVersion?: Maybe<InterviewGuideBlueprintModel>;
  previousVersionId?: Maybe<Scalars['Int']>;
  projectJobRole?: Maybe<ProjectJobRoleModel>;
  projectJobRoleId?: Maybe<Scalars['Int']>;
  publishedAt?: Maybe<Scalars['Date']>;
  publishedById?: Maybe<Scalars['Int']>;
  publishedByUser?: Maybe<User>;
  questions: Array<InterviewGuideBlueprintQuestionModel>;
  questionsCompleted: Scalars['Int'];
  questionsFailed: Scalars['Int'];
  questionsGenerating: Scalars['Int'];
  status: InterviewGuideBlueprintStatus;
  subId: Scalars['String'];
  updatedAt: Scalars['Date'];
  version: Scalars['Int'];
  /** Every published version of this blueprint, including this one unless it is a draft, newest first. */
  versions: Array<InterviewGuideBlueprintModel>;
};

/** Types of questions in the InterviewGuideBlueprintQuestionCreate mutation */
export enum InterviewGuideBlueprintQuestionCreateQuestionType {
  AssessmentQuestion = 'ASSESSMENT_QUESTION',
  NonQuestion = 'NON_QUESTION',
  UserQuestion = 'USER_QUESTION'
}

export enum InterviewGuideBlueprintQuestionGenerationStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Generating = 'GENERATING',
  NotApplicable = 'NOT_APPLICABLE',
  NotGenerated = 'NOT_GENERATED',
  Regenerating = 'REGENERATING'
}

export type InterviewGuideBlueprintQuestionModel = {
  __typename?: 'InterviewGuideBlueprintQuestionModel';
  blueprint: InterviewGuideBlueprintModel;
  blueprintId: Scalars['Float'];
  content?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  duration: Scalars['Float'];
  editingStartedAt?: Maybe<Scalars['Date']>;
  editingUserId?: Maybe<Scalars['Float']>;
  extraContent?: Maybe<Scalars['String']>;
  generationError?: Maybe<Scalars['String']>;
  generationStatus?: Maybe<InterviewGuideBlueprintQuestionGenerationStatus>;
  id: Scalars['ID'];
  isEditable: Scalars['Boolean'];
  isEdited: Scalars['Boolean'];
  isMandatory: Scalars['Boolean'];
  isPlaceholder: Scalars['Boolean'];
  lastUpdatedById?: Maybe<Scalars['Float']>;
  position: Scalars['Float'];
  retryCount: Scalars['Int'];
  skillCoverage?: Maybe<Array<Scalars['String']>>;
  softSkillJunctions: Array<InterviewGuideBlueprintQuestionSoftSkill>;
  softSkills?: Maybe<Array<SoftSkill>>;
  starter?: Maybe<Scalars['String']>;
  subId: Scalars['String'];
  subtype?: Maybe<InterviewGuideBlueprintQuestionSubtype>;
  technicalSkills?: Maybe<Array<TechnicalSkill>>;
  topic?: Maybe<Scalars['String']>;
  type: InterviewGuideBlueprintQuestionType;
  updatedAt: Scalars['Date'];
};

export type InterviewGuideBlueprintQuestionSoftSkill = {
  __typename?: 'InterviewGuideBlueprintQuestionSoftSkill';
  indicators: Array<SoftSkillIndicator>;
  softSkill: SoftSkill;
};

export enum InterviewGuideBlueprintQuestionSubtype {
  Behavioral = 'BEHAVIORAL',
  Motivational = 'MOTIVATIONAL',
  Reflective = 'REFLECTIVE',
  SituationalJudgement = 'SITUATIONAL_JUDGEMENT'
}

/** Types of questions in the interview guide blueprint */
export enum InterviewGuideBlueprintQuestionType {
  AiQuestion = 'AI_QUESTION',
  AssessmentQuestion = 'ASSESSMENT_QUESTION',
  CustomizedAiQuestion = 'CUSTOMIZED_AI_QUESTION',
  NonQuestion = 'NON_QUESTION',
  UserQuestion = 'USER_QUESTION'
}

export type InterviewGuideBlueprintQuestionUpdateData = {
  content?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Int']>;
  extraContent?: InputMaybe<Scalars['String']>;
};

export enum InterviewGuideBlueprintStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type InterviewGuideContentTemplateAffectedCountModel = {
  __typename?: 'InterviewGuideContentTemplateAffectedCountModel';
  cigCount: Scalars['Int'];
  igbCount: Scalars['Int'];
};

export type InterviewGuideContentTemplateModel = {
  __typename?: 'InterviewGuideContentTemplateModel';
  companyId: Scalars['Int'];
  createdAt: Scalars['Date'];
  introContent?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Date'];
  wrapUpContent?: Maybe<Scalars['String']>;
};

export enum InterviewGuideCustomEvaluation {
  Exceptional = 'EXCEPTIONAL',
  Good = 'GOOD',
  Poor = 'POOR',
  Reasonable = 'REASONABLE',
  VeryGood = 'VERY_GOOD',
  VeryPoor = 'VERY_POOR'
}

export type InterviewGuideCustomGradeBandModel = {
  __typename?: 'InterviewGuideCustomGradeBandModel';
  displayText: Scalars['String'];
  igCustomEvaluation: InterviewGuideCustomEvaluation;
  position: Scalars['Int'];
};

export enum InterviewGuideFinalDecisionEvaluation {
  Hire = 'HIRE',
  Reject = 'REJECT',
  TalentPool = 'TALENT_POOL'
}

export type InterviewGuideFinalDecisionGradeBandModel = {
  __typename?: 'InterviewGuideFinalDecisionGradeBandModel';
  displayText: Scalars['String'];
  igFinalDecisionEvaluation: InterviewGuideFinalDecisionEvaluation;
  position: Scalars['Int'];
};

export type InterviewQuestionRoleLevel = {
  __typename?: 'InterviewQuestionRoleLevel';
  classification: ContentClassification;
  feedback?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  mainQuestion?: Maybe<Scalars['String']>;
  reasonForQuestion?: Maybe<Scalars['String']>;
  roleLevel: ContentRoleLevel;
  softSkill: SoftSkill;
  softSkillId: Scalars['Float'];
  subQuestions?: Maybe<Array<Scalars['String']>>;
  summary?: Maybe<Scalars['String']>;
  trait?: Maybe<Trait>;
  traitId: Scalars['Float'];
};

export type InterviewQuestionRoleLevelContentUploadLineModel = {
  __typename?: 'InterviewQuestionRoleLevelContentUploadLineModel';
  classification: ContentClassification;
  feedback: Scalars['String'];
  mainQuestion: Scalars['String'];
  reasonForQuestion: Scalars['String'];
  roleLevel: ContentRoleLevel;
  softSkillSlug: Scalars['String'];
  subQuestion1: Scalars['String'];
  subQuestion2: Scalars['String'];
  subQuestion3: Scalars['String'];
  summary: Scalars['String'];
  traitSlug: Scalars['String'];
};

export type InterviewQuestionRoleLevelContentUploadModel = {
  __typename?: 'InterviewQuestionRoleLevelContentUploadModel';
  apply: Scalars['Boolean'];
  creates?: Maybe<Array<InterviewQuestionRoleLevelContentUploadLineModel>>;
  deletes?: Maybe<Array<InterviewQuestionRoleLevelContentUploadLineModel>>;
  errorMessage?: Maybe<Scalars['String']>;
  errorMessages?: Maybe<Array<Scalars['String']>>;
  errors?: Maybe<Array<InterviewQuestionRoleLevelContentUploadLineModel>>;
  noChanges?: Maybe<Array<InterviewQuestionRoleLevelContentUploadLineModel>>;
  updates?: Maybe<Array<InterviewQuestionRoleLevelContentUploadLineModel>>;
};

export type InterviewQuestionRoleLevelPaginatedModel = {
  __typename?: 'InterviewQuestionRoleLevelPaginatedModel';
  count?: Maybe<Scalars['Float']>;
  interviewQuestionContent?: Maybe<Array<InterviewQuestionRoleLevel>>;
};

export enum InterviewRecommendedDecision {
  No = 'NO',
  StrongNo = 'STRONG_NO',
  StrongYes = 'STRONG_YES',
  Yes = 'YES'
}

export enum InterviewSkillsEvaluationStatusV2 {
  Done = 'DONE',
  Error = 'ERROR',
  InProgress = 'IN_PROGRESS'
}

export type InterviewStage = {
  __typename?: 'InterviewStage';
  activeBlueprints?: Maybe<Array<InterviewGuideBlueprintModel>>;
  createdAt: Scalars['Date'];
  duration: Scalars['Int'];
  focus: InterviewStageFocus;
  id: Scalars['Int'];
  name: Scalars['String'];
  order: Scalars['Int'];
  projectId: Scalars['Int'];
  publishedBlueprints?: Maybe<Array<InterviewGuideBlueprintModel>>;
  softSkills: Array<SoftSkill>;
  subId: Scalars['ID'];
  technicalSkills: Array<TechnicalSkill>;
  updatedAt: Scalars['Date'];
};

export type InterviewStageCandidate = {
  __typename?: 'InterviewStageCandidate';
  createdAt: Scalars['Date'];
  id: Scalars['Int'];
  projectCandidateId: Scalars['Int'];
  stageId: Scalars['Int'];
  subId: Scalars['ID'];
  updatedAt: Scalars['Date'];
};

export type InterviewStageCandidateIdFilter = {
  in?: InputMaybe<Array<Scalars['Int']>>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export enum InterviewStageFocus {
  CoreSkills = 'CORE_SKILLS',
  SpecialistSkills = 'SPECIALIST_SKILLS',
  ValuesAlignment = 'VALUES_ALIGNMENT'
}

export type InterviewStageUpdateData = {
  duration?: InputMaybe<Scalars['Int']>;
  focus?: InputMaybe<InterviewStageFocus>;
  name?: InputMaybe<Scalars['String']>;
};

export type InterviewV2Model = {
  __typename?: 'InterviewV2Model';
  createdAt: Scalars['Date'];
  createdBy: Scalars['Int'];
  deletedAt?: Maybe<Scalars['Date']>;
  evaluators: Array<InterviewEvaluatorModel>;
  id: Scalars['String'];
  linkedInterviewStageCandidateId?: Maybe<Scalars['Int']>;
  linkedProjectJobRoleId?: Maybe<Scalars['Int']>;
  meetingId: Scalars['String'];
  metadata: Scalars['JSON'];
  name: Scalars['String'];
  projectCandidateSubId?: Maybe<Scalars['String']>;
  status: InterviewV2Status;
  updatedAt: Scalars['Date'];
};

export enum InterviewV2Status {
  Error = 'ERROR',
  InProgress = 'IN_PROGRESS',
  New = 'NEW',
  Processing = 'PROCESSING'
}

/** One interviewer's availability over the window */
export type InterviewerAvailabilityModel = {
  __typename?: 'InterviewerAvailabilityModel';
  access: CalendarAccessState;
  /** Empty unless their calendar is accessible */
  busy: Array<BusyBlockModel>;
  confidence: AvailabilityConfidence;
  /** Present only while confidence is low */
  fallbackWindow?: Maybe<FallbackWorkingWindowModel>;
  /** Present exactly when confidence is low */
  lowConfidenceReason?: Maybe<AvailabilityLowConfidenceReason>;
  /** True when a refresh of their calendar is on its way (queued by this preview, or the first sync of a newly connected calendar); read again shortly to see it */
  syncRequested: Scalars['Boolean'];
  userId: Scalars['Int'];
};

export enum InvitationLastActionType {
  Accepted = 'ACCEPTED',
  Bounced = 'BOUNCED',
  Clicked = 'CLICKED',
  Deferred = 'DEFERRED',
  Delivered = 'DELIVERED',
  DispatchedToSendgrid = 'DISPATCHED_TO_SENDGRID',
  Dropped = 'DROPPED',
  NotSent = 'NOT_SENT',
  Opened = 'OPENED',
  Processed = 'PROCESSED'
}

export type InvitationModel = {
  __typename?: 'InvitationModel';
  companyId: Scalars['Float'];
  email: Scalars['String'];
  expiresAt?: Maybe<Scalars['Date']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['Float'];
  invitationToken: Scalars['String'];
  issuedAt: Scalars['Date'];
  lastActionType?: Maybe<InvitationLastActionType>;
  lastName?: Maybe<Scalars['String']>;
  status: InvitationStatusCode;
  targetId: Scalars['Float'];
  updatedAt: Scalars['Date'];
  url: Scalars['String'];
};

/** Entity that holds the invitation session */
export type InvitationSession = {
  __typename?: 'InvitationSession';
  areInternalCandidates: Scalars['Boolean'];
  candidates?: Maybe<Array<InvitationSessionCandidate>>;
  companyId: Scalars['String'];
  completedAt?: Maybe<Scalars['Date']>;
  completedCandidates?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Date'];
  defaultProjectId?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['Date']>;
  failedCandidates?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  inviteToAssessment: Scalars['Boolean'];
  locale: SupportedLocale;
  name: Scalars['String'];
  sendEmail: Scalars['Boolean'];
  skippedCandidates?: Maybe<Scalars['Int']>;
  source: InvitationSessionSource;
  stageSubId?: Maybe<Scalars['String']>;
  stageType?: Maybe<Scalars['String']>;
  status: InvitationSessionStatus;
  totalCandidates?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['Date'];
  userEmail?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

/** Child entity of the invitation session that holds the candidate that has to be invited */
export type InvitationSessionCandidate = {
  __typename?: 'InvitationSessionCandidate';
  applicationDate?: Maybe<Scalars['Date']>;
  applicationId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['Date']>;
  createdAt: Scalars['Date'];
  email: Scalars['String'];
  error?: Maybe<Scalars['String']>;
  externalUserId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id: Scalars['String'];
  invitationSession: InvitationSession;
  lastName: Scalars['String'];
  locale?: Maybe<SupportedLocale>;
  locationId?: Maybe<Scalars['String']>;
  locationName?: Maybe<Scalars['String']>;
  managerEmail?: Maybe<Scalars['String']>;
  managerUserId?: Maybe<Scalars['String']>;
  projectId?: Maybe<Scalars['String']>;
  requisitionId?: Maybe<Scalars['String']>;
  requisitionName?: Maybe<Scalars['String']>;
  stageCandidateId?: Maybe<Scalars['String']>;
  status: InvitationSessionCandidateStatus;
  updatedAt: Scalars['Date'];
  userId?: Maybe<Scalars['String']>;
};

/** Status of the invitation session single candidate. */
export enum InvitationSessionCandidateStatus {
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Skipped = 'SKIPPED'
}

export type InvitationSessionPaginated = {
  __typename?: 'InvitationSessionPaginated';
  data?: Maybe<Array<InvitationSession>>;
  pageInfo?: Maybe<Pageinfo>;
};

export enum InvitationSessionSort {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  UploadedBy = 'UPLOADED_BY'
}

/** Source of the invitation session. */
export enum InvitationSessionSource {
  Csv = 'CSV',
  Icims = 'ICIMS',
  Kombo = 'KOMBO',
  Stackone = 'STACKONE'
}

/** Status of the invitation session. */
export enum InvitationSessionStatus {
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Failed = 'FAILED',
  Partial = 'PARTIAL',
  Processing = 'PROCESSING'
}

export enum InvitationStatusCode {
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  Pending = 'PENDING'
}

export type InvitationStatusResult = {
  __typename?: 'InvitationStatusResult';
  isCompleted: Scalars['Boolean'];
  isExpired: Scalars['Boolean'];
};

export enum InvitationType {
  Candidate = 'CANDIDATE',
  Company = 'COMPANY',
  TalentReview = 'TALENT_REVIEW'
}

export type InvivitationTokenProcessingResult = {
  __typename?: 'InvivitationTokenProcessingResult';
  invitationProcessingResult: Scalars['String'];
};

export enum IqFooterType {
  Hints = 'HINTS',
  IqFeedback = 'IQ_FEEDBACK',
  None = 'NONE'
}

export enum JobRoleFamily {
  AgricultureHorticultureOutdoors = 'AGRICULTURE_HORTICULTURE_OUTDOORS',
  BusinessManagementOperations = 'BUSINESS_MANAGEMENT_OPERATIONS',
  ClericalAdministrative = 'CLERICAL_ADMINISTRATIVE',
  CommunitySocialServices = 'COMMUNITY_SOCIAL_SERVICES',
  ConstructionExtractionArchitecture = 'CONSTRUCTION_EXTRACTION_ARCHITECTURE',
  CustomerClientSupport = 'CUSTOMER_CLIENT_SUPPORT',
  DesignMediaWriting = 'DESIGN_MEDIA_WRITING',
  EducationTraining = 'EDUCATION_TRAINING',
  Engineering = 'ENGINEERING',
  Finance = 'FINANCE',
  Healthcare = 'HEALTHCARE',
  HospitalityFoodTourism = 'HOSPITALITY_FOOD_TOURISM',
  HumanResources = 'HUMAN_RESOURCES',
  InformationTechnologyComputerScience = 'INFORMATION_TECHNOLOGY_COMPUTER_SCIENCE',
  LawCompliancePublicSafety = 'LAW_COMPLIANCE_PUBLIC_SAFETY',
  MaintenanceRepairInstallation = 'MAINTENANCE_REPAIR_INSTALLATION',
  ManufacturingProduction = 'MANUFACTURING_PRODUCTION',
  MarketingPublicRelations = 'MARKETING_PUBLIC_RELATIONS',
  Military = 'MILITARY',
  NotEmployed = 'NOT_EMPLOYED',
  PerformingArts = 'PERFORMING_ARTS',
  PersonalServices = 'PERSONAL_SERVICES',
  Sales = 'SALES',
  ScienceResearch = 'SCIENCE_RESEARCH',
  SocialAnalysisPlanning = 'SOCIAL_ANALYSIS_PLANNING',
  Students = 'STUDENTS',
  Transportation = 'TRANSPORTATION',
  UnclassifiedJobFamily = 'UNCLASSIFIED_JOB_FAMILY'
}

export type JobRoleFindManyPaginatedFiltersArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  createdAtFrom?: InputMaybe<Scalars['Date']>;
  createdAtTo?: InputMaybe<Scalars['Date']>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
  search?: InputMaybe<Scalars['String']>;
  skillsProfileSourceInputs?: InputMaybe<JobRoleSkillsProfileSourceInputsFilter>;
  source?: InputMaybe<JobRoleSource>;
};

export type JobRoleFindManyPaginatedOrderArgs = {
  direction?: InputMaybe<SortOption>;
  field?: InputMaybe<JobRoleFindManyPaginatedOrderField>;
};

export enum JobRoleFindManyPaginatedOrderField {
  CompanyName = 'COMPANY_NAME',
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT'
}

export type JobRoleModel = {
  __typename?: 'JobRoleModel';
  companyId: Scalars['Int'];
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  family?: Maybe<JobRoleFamily>;
  id: Scalars['Int'];
  isAttachedToStage: Scalars['Boolean'];
  name: Scalars['String'];
  qualifier?: Maybe<Scalars['String']>;
  roleLevel: ContentRoleLevel;
  skillsProfiles: Array<SuccessProfile>;
  source: JobRoleSource;
  subId: Scalars['String'];
  updatedAt: Scalars['Date'];
};

export type JobRolePaginated = {
  __typename?: 'JobRolePaginated';
  data: Array<JobRolePaginatedData>;
  page: Pageinfo;
};

export type JobRolePaginatedData = {
  __typename?: 'JobRolePaginatedData';
  company: Company;
  companyId: Scalars['Int'];
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  family?: Maybe<JobRoleFamily>;
  id: Scalars['Int'];
  name: Scalars['String'];
  projectsCount: Scalars['Int'];
  qualifier?: Maybe<Scalars['String']>;
  roleLevel: ContentRoleLevel;
  skillsProfiles: Array<SuccessProfile>;
  source: JobRoleSource;
  subId: Scalars['String'];
  updatedAt: Scalars['Date'];
};

export enum JobRoleSkillsProfileSourceInputsFilter {
  HasIntakeMeetingOnly = 'HAS_INTAKE_MEETING_ONLY',
  HasJobDescriptionAndIntakeMeeting = 'HAS_JOB_DESCRIPTION_AND_INTAKE_MEETING',
  HasJobDescriptionOnly = 'HAS_JOB_DESCRIPTION_ONLY',
  NoInputs = 'NO_INPUTS'
}

export enum JobRoleSource {
  RoleRequirements = 'ROLE_REQUIREMENTS',
  SzAdmin = 'SZ_ADMIN'
}

export type JoinConferenceInput = {
  /** Controls whether agent interruptions are allowed. Default behaviour is true. */
  allowAgentInterruptions?: InputMaybe<Scalars['Boolean']>;
  avatar: Avatar;
  /** Grammatical form the interviewer uses to address the candidate. Only applies to gendered locales. */
  grammaticalGender?: InputMaybe<GrammaticalGender>;
  /** Locale the candidate is taking the conference in (CR-224). */
  locale?: InputMaybe<SupportedLocale>;
};

export type KomboClearJobsResponse = {
  __typename?: 'KomboClearJobsResponse';
  deletedCount: Scalars['Int'];
  dryRun: Scalars['Boolean'];
  success: Scalars['Boolean'];
};

export type KomboIntegrationModel = {
  __typename?: 'KomboIntegrationModel';
  assessmentConnectedAt?: Maybe<Scalars['Date']>;
  assessmentIntegrationId?: Maybe<Scalars['String']>;
  atsConnectedAt?: Maybe<Scalars['Date']>;
  atsIntegrationId?: Maybe<Scalars['String']>;
  companyId: Scalars['Int'];
  createdAt: Scalars['Date'];
  enabled: Scalars['Boolean'];
  endUserEmail?: Maybe<Scalars['String']>;
  endUserOrgName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  latestSyncRun?: Maybe<KomboSyncRunModel>;
  syncEnabled: Scalars['Boolean'];
  tool: Scalars['String'];
  updatedAt: Scalars['Date'];
};

export type KomboIntegrationPaginated = {
  __typename?: 'KomboIntegrationPaginated';
  data?: Maybe<Array<KomboIntegrationModel>>;
  pageInfo?: Maybe<Pageinfo>;
};

export type KomboJobHiringTeamMemberModel = {
  __typename?: 'KomboJobHiringTeamMemberModel';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  komboId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Scalars['String']>>;
  sourceAtsId?: Maybe<Scalars['String']>;
};

export type KomboJobModel = {
  __typename?: 'KomboJobModel';
  companyId: Scalars['Int'];
  createdAt: Scalars['Date'];
  department?: Maybe<Scalars['String']>;
  hiringTeamMembers?: Maybe<Array<KomboJobHiringTeamMemberModel>>;
  id: Scalars['String'];
  integrationId: Scalars['String'];
  jobCode?: Maybe<Scalars['String']>;
  komboId?: Maybe<Scalars['String']>;
  locationCity?: Maybe<Scalars['String']>;
  locationCountry?: Maybe<Scalars['String']>;
  locationRaw?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  remoteCreatedAt?: Maybe<Scalars['Date']>;
  remoteUpdatedAt?: Maybe<Scalars['Date']>;
  sourceAtsId?: Maybe<Scalars['String']>;
  stages?: Maybe<Array<KomboJobStageModel>>;
  status?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Date'];
};

export type KomboJobProjectModel = {
  __typename?: 'KomboJobProjectModel';
  companyId: Scalars['Int'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  jobId: Scalars['String'];
  projectId: Scalars['Int'];
  updatedAt: Scalars['Date'];
};

export enum KomboJobSortField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  RemoteCreatedAt = 'REMOTE_CREATED_AT'
}

export type KomboJobStageModel = {
  __typename?: 'KomboJobStageModel';
  id: Scalars['String'];
  index?: Maybe<Scalars['Int']>;
  komboId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  sourceAtsId?: Maybe<Scalars['String']>;
};

export enum KomboJobStatus {
  Archived = 'ARCHIVED',
  Closed = 'CLOSED',
  Draft = 'DRAFT',
  Open = 'OPEN'
}

export type KomboJobWithProject = {
  __typename?: 'KomboJobWithProject';
  job: KomboJobModel;
  jobProject?: Maybe<KomboJobProjectModel>;
};

export type KomboJobWithProjectPaginated = {
  __typename?: 'KomboJobWithProjectPaginated';
  data?: Maybe<Array<KomboJobWithProject>>;
  pageInfo?: Maybe<Pageinfo>;
};

export type KomboSyncRunModel = {
  __typename?: 'KomboSyncRunModel';
  companyId: Scalars['Int'];
  completedAt?: Maybe<Scalars['Date']>;
  createdAt: Scalars['Date'];
  error?: Maybe<Scalars['String']>;
  /** Record count of the last completed full sync of the same type — the best available guess at this run's final size (Kombo exposes no total count). Null on delta or job-scoped runs. */
  estimatedTotalCount?: Maybe<Scalars['Int']>;
  fullSync: Scalars['Boolean'];
  id: Scalars['String'];
  recordCount?: Maybe<Scalars['Int']>;
  /** Kombo remote job id this run is scoped to (link / publish / backfill application pulls); null for company-wide runs. */
  scopeKomboJobId?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['Date']>;
  status: KomboSyncRunStatus;
  trigger: KomboSyncRunTrigger;
};

export enum KomboSyncRunStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Paused = 'PAUSED',
  Pending = 'PENDING',
  Running = 'RUNNING'
}

export enum KomboSyncRunTrigger {
  IntegrationCreated = 'INTEGRATION_CREATED',
  Manual = 'MANUAL',
  ManualBackfill = 'MANUAL_BACKFILL',
  ProjectLinked = 'PROJECT_LINKED',
  ProjectPublished = 'PROJECT_PUBLISHED',
  Webhook = 'WEBHOOK'
}

export type KomboSyncStatusModel = {
  __typename?: 'KomboSyncStatusModel';
  cachedJobCount: Scalars['Int'];
  integrationId?: Maybe<Scalars['String']>;
  lastSyncAt?: Maybe<Scalars['Date']>;
  lastSyncError?: Maybe<Scalars['String']>;
  lastSyncRecordCount?: Maybe<Scalars['Int']>;
  syncEnabled: Scalars['Boolean'];
};

export enum Language {
  Afar = 'AFAR',
  Afrikaans = 'AFRIKAANS',
  Akan = 'AKAN',
  Albanian = 'ALBANIAN',
  Amharic = 'AMHARIC',
  Arabic = 'ARABIC',
  Aragonese = 'ARAGONESE',
  Armenian = 'ARMENIAN',
  Assamese = 'ASSAMESE',
  Avaric = 'AVARIC',
  Avestan = 'AVESTAN',
  Aymara = 'AYMARA',
  Azerbaijani = 'AZERBAIJANI',
  Bambara = 'BAMBARA',
  Bashkir = 'BASHKIR',
  Basque = 'BASQUE',
  Belarusian = 'BELARUSIAN',
  Bengali = 'BENGALI',
  Bislama = 'BISLAMA',
  Bosnian = 'BOSNIAN',
  Breton = 'BRETON',
  Bulgarian = 'BULGARIAN',
  Burmese = 'BURMESE',
  CatalanValencian = 'CATALAN_VALENCIAN',
  CentralKhmer = 'CENTRAL_KHMER',
  Chamorro = 'CHAMORRO',
  Chechen = 'CHECHEN',
  ChichewaChewaNyanja = 'CHICHEWA_CHEWA_NYANJA',
  Chinese = 'CHINESE',
  Chuvash = 'CHUVASH',
  Cornish = 'CORNISH',
  Corsican = 'CORSICAN',
  Cree = 'CREE',
  Croatian = 'CROATIAN',
  Czech = 'CZECH',
  Danish = 'DANISH',
  DivehiDhivehiMaldivian = 'DIVEHI_DHIVEHI_MALDIVIAN',
  DutchFlemish = 'DUTCH_FLEMISH',
  Dzongkha = 'DZONGKHA',
  English = 'ENGLISH',
  Esperanto = 'ESPERANTO',
  Estonian = 'ESTONIAN',
  Ewe = 'EWE',
  Faroese = 'FAROESE',
  Fijian = 'FIJIAN',
  Finnish = 'FINNISH',
  French = 'FRENCH',
  Fulah = 'FULAH',
  Gaelic = 'GAELIC',
  Galician = 'GALICIAN',
  Ganda = 'GANDA',
  Georgian = 'GEORGIAN',
  German = 'GERMAN',
  GreekModern = 'GREEK_MODERN',
  Guarani = 'GUARANI',
  Gujarati = 'GUJARATI',
  Haitian = 'HAITIAN',
  Hausa = 'HAUSA',
  Hebrew = 'HEBREW',
  Herero = 'HERERO',
  Hindi = 'HINDI',
  HiriMotu = 'HIRI_MOTU',
  Hungarian = 'HUNGARIAN',
  Icelandic = 'ICELANDIC',
  Ido = 'IDO',
  Igbo = 'IGBO',
  Indonesian = 'INDONESIAN',
  Interlingua = 'INTERLINGUA',
  Interlingue = 'INTERLINGUE',
  Inuktitut = 'INUKTITUT',
  Inupiaq = 'INUPIAQ',
  Irish = 'IRISH',
  Italian = 'ITALIAN',
  Japanese = 'JAPANESE',
  Javanese = 'JAVANESE',
  KalaallisutGreenlandic = 'KALAALLISUT_GREENLANDIC',
  Kannada = 'KANNADA',
  Kanuri = 'KANURI',
  Kashmiri = 'KASHMIRI',
  Kazakh = 'KAZAKH',
  KikuyuGikuyu = 'KIKUYU_GIKUYU',
  Kinyarwanda = 'KINYARWANDA',
  KirghizKyrgyz = 'KIRGHIZ_KYRGYZ',
  Komi = 'KOMI',
  Kongo = 'KONGO',
  Korean = 'KOREAN',
  KuanyamaKwanyama = 'KUANYAMA_KWANYAMA',
  Kurdish = 'KURDISH',
  Lao = 'LAO',
  Latin = 'LATIN',
  Latvian = 'LATVIAN',
  LimburganLimburgerLimburgish = 'LIMBURGAN_LIMBURGER_LIMBURGISH',
  Lingala = 'LINGALA',
  Lithuanian = 'LITHUANIAN',
  LubaKatanga = 'LUBA_KATANGA',
  LuxembourgishLetzeburgesch = 'LUXEMBOURGISH_LETZEBURGESCH',
  Macedonian = 'MACEDONIAN',
  Malagasy = 'MALAGASY',
  Malay = 'MALAY',
  Malayalam = 'MALAYALAM',
  Maltese = 'MALTESE',
  Manx = 'MANX',
  Maori = 'MAORI',
  Marathi = 'MARATHI',
  Marshallese = 'MARSHALLESE',
  Mongolian = 'MONGOLIAN',
  Nauru = 'NAURU',
  NavajoNavaho = 'NAVAJO_NAVAHO',
  Ndonga = 'NDONGA',
  Nepali = 'NEPALI',
  NorthernSami = 'NORTHERN_SAMI',
  NorthNdebele = 'NORTH_NDEBELE',
  Norwegian = 'NORWEGIAN',
  NorwegianBokmal = 'NORWEGIAN_BOKMAL',
  NorwegianNynorsk = 'NORWEGIAN_NYNORSK',
  Occitan = 'OCCITAN',
  Ojibwa = 'OJIBWA',
  OldSlavonic = 'OLD_SLAVONIC',
  Oriya = 'ORIYA',
  Oromo = 'OROMO',
  OssetianOssetic = 'OSSETIAN_OSSETIC',
  Pali = 'PALI',
  PashtoPushto = 'PASHTO_PUSHTO',
  Persian = 'PERSIAN',
  Polish = 'POLISH',
  Portuguese = 'PORTUGUESE',
  PunjabiPanjabi = 'PUNJABI_PANJABI',
  Quechua = 'QUECHUA',
  RomanianMoldavian = 'ROMANIAN_MOLDAVIAN',
  Romansh = 'ROMANSH',
  Rundi = 'RUNDI',
  Russian = 'RUSSIAN',
  Samoan = 'SAMOAN',
  Sango = 'SANGO',
  Sanskrit = 'SANSKRIT',
  Sardinian = 'SARDINIAN',
  Serbian = 'SERBIAN',
  Shona = 'SHONA',
  SichuanYiNuosu = 'SICHUAN_YI_NUOSU',
  Sindhi = 'SINDHI',
  SinhalaSinhalese = 'SINHALA_SINHALESE',
  Slovak = 'SLOVAK',
  Slovenian = 'SLOVENIAN',
  Somali = 'SOMALI',
  SouthernSotho = 'SOUTHERN_SOTHO',
  SouthNdebele = 'SOUTH_NDEBELE',
  SpanishCastilian = 'SPANISH_CASTILIAN',
  Sundanese = 'SUNDANESE',
  Swahili = 'SWAHILI',
  Swati = 'SWATI',
  Swedish = 'SWEDISH',
  Tagalog = 'TAGALOG',
  Tahitian = 'TAHITIAN',
  Tajik = 'TAJIK',
  Tamil = 'TAMIL',
  Tatar = 'TATAR',
  Telugu = 'TELUGU',
  Thai = 'THAI',
  Tibetan = 'TIBETAN',
  Tigrinya = 'TIGRINYA',
  Tonga = 'TONGA',
  Tsonga = 'TSONGA',
  Tswana = 'TSWANA',
  Turkish = 'TURKISH',
  Turkmen = 'TURKMEN',
  Twi = 'TWI',
  Uighur = 'UIGHUR',
  Ukrainian = 'UKRAINIAN',
  Urdu = 'URDU',
  Uzbek = 'UZBEK',
  Venda = 'VENDA',
  Vietnamese = 'VIETNAMESE',
  Volapuk = 'VOLAPUK',
  Walloon = 'WALLOON',
  Welsh = 'WELSH',
  WesternFrisian = 'WESTERN_FRISIAN',
  Wolof = 'WOLOF',
  Xhosa = 'XHOSA',
  Yiddish = 'YIDDISH',
  Yoruba = 'YORUBA',
  ZhuangChuang = 'ZHUANG_CHUANG',
  Zulu = 'ZULU'
}

export enum LivekitAgentName {
  AiInterviewer = 'AI_INTERVIEWER',
  AiInterviewerCascade = 'AI_INTERVIEWER_CASCADE',
  AiInterviewerGemini = 'AI_INTERVIEWER_GEMINI'
}

export type LivekitConfig = {
  __typename?: 'LivekitConfig';
  agentAvatarId?: Maybe<Scalars['String']>;
  agentVoiceId?: Maybe<Scalars['String']>;
  allowAgentInterruptions: Scalars['Boolean'];
  isTimingAgentEnabled: Scalars['Boolean'];
};

export type LocationLinkCreateArgs = {
  companyId: Scalars['Int'];
  locationName: Scalars['String'];
  projectId: Scalars['Int'];
  userGroupId: Scalars['Int'];
};

export type LocationLinkCreateOneResult = {
  __typename?: 'LocationLinkCreateOneResult';
  error?: Maybe<Scalars['String']>;
  link?: Maybe<LocationLinkModel>;
  status: Scalars['String'];
};

export type LocationLinkDeleteManyArgs = {
  locationId?: InputMaybe<Scalars['Int']>;
  projectId?: InputMaybe<Scalars['Int']>;
  userGroupId?: InputMaybe<Scalars['Int']>;
};

export type LocationLinkFindManyArgs = {
  locationId?: InputMaybe<Scalars['Int']>;
  projectId?: InputMaybe<Scalars['Int']>;
  userGroupId?: InputMaybe<Scalars['Int']>;
};

export type LocationLinkModel = {
  __typename?: 'LocationLinkModel';
  id: Scalars['Int'];
  locationId: Scalars['Int'];
  projectId: Scalars['Int'];
  userGroupId: Scalars['Int'];
};

export type LongTextField = Field & {
  __typename?: 'LongTextField';
  fieldInstanceType: FieldInstanceType;
  fieldOwnerId?: Maybe<Scalars['Int']>;
  fieldOwnerName?: Maybe<Scalars['String']>;
  fieldOwnerType?: Maybe<FieldOwnerType>;
  fieldType: FieldType;
  formManagerType: FormManagerType;
  hint?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isArchived: Scalars['Boolean'];
  name: Scalars['String'];
  question?: Maybe<Scalars['String']>;
  settings?: Maybe<FieldSettingsModel>;
  textBoxHeight?: Maybe<Scalars['Int']>;
  txtData?: Maybe<Scalars['String']>;
};

export enum MeasurementConstructType {
  Behavior = 'BEHAVIOR',
  CalculatedOnSsSummary = 'CALCULATED_ON_SS_SUMMARY',
  Cognitive = 'COGNITIVE',
  Values = 'VALUES'
}

/** An artifact attached to a meeting (recording, transcript, or summary) */
export type MeetingArtifactModel = {
  __typename?: 'MeetingArtifactModel';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  /** Content tag/hash for idempotency */
  eTag?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  /** Last time this artifact was viewed/accessed */
  lastViewedAt?: Maybe<Scalars['DateTime']>;
  /** Locales associated with this artifact */
  locales?: Maybe<Array<Scalars['String']>>;
  /** Parent meeting ID */
  meetingId: Scalars['String'];
  /** Artifact-specific metadata */
  metadata?: Maybe<Scalars['JSON']>;
  /** Associated participant ID for per-participant artifacts */
  participantId?: Maybe<Scalars['String']>;
  /** Source URI or storage key */
  src?: Maybe<Scalars['String']>;
  /** Processing status of the artifact */
  status: MeetingArtifactStatus;
  /** Template ID used for summary generation */
  templateId?: Maybe<Scalars['String']>;
  /** Type of artifact */
  type: MeetingArtifactType;
  updatedAt: Scalars['Date'];
};

export enum MeetingArtifactStatus {
  Failed = 'failed',
  Processing = 'processing',
  Ready = 'ready'
}

export enum MeetingArtifactType {
  Recording = 'recording',
  Summary = 'summary',
  Transcript = 'transcript'
}

export type MeetingAttendeeModel = {
  __typename?: 'MeetingAttendeeModel';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  email: Scalars['String'];
  id: Scalars['String'];
  isOrganiser: Scalars['Boolean'];
  name: Scalars['String'];
  updatedAt: Scalars['Date'];
  /** Company user data — null for external/candidate attendees */
  user?: Maybe<UserModel>;
  userId?: Maybe<Scalars['Int']>;
};

export enum MeetingCalendarPlatform {
  Meet = 'meet',
  Teams = 'teams',
  Unknown = 'unknown',
  Zoom = 'zoom'
}

export type MeetingFeatures = {
  recording?: Scalars['Boolean'];
  summary?: Scalars['Boolean'];
  transcript?: Scalars['Boolean'];
};

/** Links a meeting to an external calendar entry for deduplication */
export type MeetingIdentityModel = {
  __typename?: 'MeetingIdentityModel';
  /** Cross-copy logical identifier (e.g., iCalUID) */
  correlationId: Scalars['String'];
  /** Per-occurrence identifier for recurring events */
  correlationInstance: Scalars['String'];
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  /** External calendar ID from the provider (e.g., Google calendar email) */
  externalCalendarId: Scalars['String'];
  /** Provider's event identifier for this calendar entry */
  externalEventId: Scalars['String'];
  id: Scalars['String'];
  updatedAt: Scalars['Date'];
};

/** Links a meeting to hiring domain identifiers */
export type MeetingLinkModel = {
  __typename?: 'MeetingLinkModel';
  /** Company ID from the workspace context */
  companyId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['String'];
  /** Interview stage candidate ID for interview pipelines */
  interviewStageCandidateId?: Maybe<Scalars['Int']>;
  /** Candidate ID from the projects domain */
  projectCandidateId?: Maybe<Scalars['Int']>;
  /** Candidate subscription ID */
  projectCandidateSubId?: Maybe<Scalars['String']>;
  /** Project ID from the projects domain */
  projectId?: Maybe<Scalars['Int']>;
  /** Job role ID from the projects domain */
  projectJobRoleId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['Date'];
};

export type MeetingMetadataArgs = {
  templates: Scalars['JSON'];
};

export type MeetingMetadataModel = {
  __typename?: 'MeetingMetadataModel';
  templates: Scalars['JSON'];
};

export type MeetingModel = {
  __typename?: 'MeetingModel';
  attendees?: Maybe<Array<MeetingAttendeeModel>>;
  companyId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Date'];
  date: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['Date']>;
  hasSubmittedEvaluation?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  interviewStageCandidateId?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  ownerId: Scalars['Int'];
  projectCandidateId?: Maybe<Scalars['Int']>;
  projectCandidateSubId?: Maybe<Scalars['String']>;
  projectId?: Maybe<Scalars['Int']>;
  projectJobRoleId?: Maybe<Scalars['Int']>;
  recordingConfig?: Maybe<RecordingConfigModel>;
  status: MeetingStatus;
  summaries: Array<MeetingSummaryModel>;
  transcriptConfig?: Maybe<TranscriptConfigModel>;
  type: MeetingScope;
  updatedAt: Scalars['Date'];
};

/** A meeting with all related entities */
export type MeetingModelV2 = {
  __typename?: 'MeetingModelV2';
  /** Meeting artifacts (recordings, transcripts, summaries) */
  artifacts: Array<MeetingArtifactModel>;
  /** Associated bot ID if a bot session exists */
  botId?: Maybe<Scalars['String']>;
  /** When the meeting pipeline completed */
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  /** Scheduled end time in UTC */
  endAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  /** External calendar identities for deduplication */
  identities: Array<MeetingIdentityModel>;
  /** Link to hiring domain identifiers */
  link?: Maybe<MeetingLinkModel>;
  /** Meeting participants */
  participants: Array<MeetingParticipantModel>;
  /** Conferencing or calendar provider */
  provider?: Maybe<MeetingProvider>;
  /** Scheduled start time in UTC */
  startAt?: Maybe<Scalars['DateTime']>;
  /** Pipeline status of the meeting lifecycle */
  status: MeetingStatusV2;
  /** Human-friendly title of the meeting */
  title: Scalars['String'];
  /** Business classification (interview/intake/general) */
  type: MeetingScope;
  updatedAt: Scalars['Date'];
  /** Primary join URL for the conferencing system */
  url?: Maybe<Scalars['String']>;
};

export type MeetingParticipantArgs = {
  email: Scalars['String'];
  isOrganiser?: InputMaybe<Scalars['Boolean']>;
};

/** A participant in a meeting */
export type MeetingParticipantModel = {
  __typename?: 'MeetingParticipantModel';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  /** Email address of the participant */
  email: Scalars['String'];
  id: Scalars['String'];
  /** Whether this participant is the meeting organiser */
  isOrganiser: Scalars['Boolean'];
  /** Display name of the participant */
  name?: Maybe<Scalars['String']>;
  /** RSVP status of the participant */
  rsvp?: Maybe<MeetingParticipantRsvp>;
  updatedAt: Scalars['Date'];
  /** Company user data — null for external/candidate participants */
  user?: Maybe<UserModel>;
  /** Internal user ID if the participant is a known user */
  userId?: Maybe<Scalars['Int']>;
};

export enum MeetingParticipantRsvp {
  Accepted = 'accepted',
  Declined = 'declined',
  NotResponded = 'notResponded',
  Tentative = 'tentative'
}

export enum MeetingProvider {
  Google = 'google',
  Microsoft = 'microsoft',
  Unknown = 'unknown',
  Zoom = 'zoom'
}

export enum MeetingRecodingStatus {
  Error = 'error',
  Generated = 'generated'
}

export enum MeetingScope {
  General = 'general',
  Intake = 'intake',
  Interview = 'interview'
}

export enum MeetingStatus {
  Done = 'done',
  Error = 'error',
  Recording = 'recording',
  Summarising = 'summarising',
  Transcribing = 'transcribing'
}

export enum MeetingStatusV2 {
  Done = 'done',
  Error = 'error',
  Recording = 'recording',
  Summarising = 'summarising',
  Transcribing = 'transcribing',
  Upcoming = 'upcoming'
}

export type MeetingSummaryModel = {
  __typename?: 'MeetingSummaryModel';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  generatedAt?: Maybe<Scalars['Date']>;
  id: Scalars['String'];
  lastViewedAt?: Maybe<Scalars['Date']>;
  meetingId: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  ownerId: Scalars['Int'];
  src?: Maybe<Scalars['String']>;
  status: MeetingSummaryStatus;
  templateId: Scalars['String'];
  updatedAt: Scalars['Date'];
};

export enum MeetingSummaryStatus {
  Error = 'error',
  Generated = 'generated',
  Processing = 'processing'
}

export enum MeetingTranscriptStatus {
  Error = 'error',
  Generated = 'generated',
  Transcribing = 'transcribing'
}

export type MeetingTypeModel = {
  __typename?: 'MeetingTypeModel';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  keywords?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  scope: MeetingScope;
  templateId: Scalars['String'];
  updatedAt: Scalars['Date'];
};

export type MeetingUserCalendarModel = {
  __typename?: 'MeetingUserCalendarModel';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  externalCalendarId: Scalars['String'];
  id: Scalars['String'];
  ownerId?: Maybe<Scalars['Int']>;
  platformName: UserCalendarPlatform;
  updatedAt: Scalars['Date'];
  userId: Scalars['Int'];
};

export enum Method {
  CalendarIntegration = 'calendarIntegration',
  Email = 'email'
}

export type MfaResult = {
  __typename?: 'MfaResult';
  mfaAccessToken: Scalars['String'];
};

export type MonolithBlobModel = {
  __typename?: 'MonolithBlobModel';
  acl: Acl;
  bucket: Scalars['String'];
  contentEncoding?: Maybe<Scalars['String']>;
  contentType?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  expiryDate?: Maybe<Scalars['Date']>;
  extension: Scalars['String'];
  id: Scalars['ID'];
  key: Scalars['String'];
  ownerService: Scalars['String'];
  publishedName: Scalars['String'];
  updatedAt: Scalars['Date'];
  url: Scalars['String'];
};

export type MotivationResultScoreModel = {
  __typename?: 'MotivationResultScoreModel';
  isFlagged: Scalars['Boolean'];
  motivationScore: Scalars['Float'];
};

export type MultiSelectField = Field & {
  __typename?: 'MultiSelectField';
  fieldInstanceType: FieldInstanceType;
  fieldOwnerId?: Maybe<Scalars['Int']>;
  fieldOwnerName?: Maybe<Scalars['String']>;
  fieldOwnerType?: Maybe<FieldOwnerType>;
  fieldType: FieldType;
  formManagerType: FormManagerType;
  hint?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isArchived: Scalars['Boolean'];
  isFreetextField?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  question?: Maybe<Scalars['String']>;
  selectOptions?: Maybe<Scalars['String']>;
  settings?: Maybe<FieldSettingsModel>;
  txtData?: Maybe<Scalars['String']>;
};

export type MultipartCompletedPart = {
  ETag: Scalars['String'];
  PartNumber: Scalars['Float'];
};

export type MultipartUpload = {
  __typename?: 'MultipartUpload';
  key: Scalars['String'];
  signedUrls: Array<Scalars['String']>;
  uploadId: Scalars['String'];
};

export type MultipartUploadResponseModel = {
  __typename?: 'MultipartUploadResponseModel';
  key: Scalars['String'];
  signedUrls: Array<Scalars['String']>;
  uploadId: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  AdminBackfillParticipantUserIds: BackfillUserIdsResult;
  AdminResultsCsvFileExport: FileExportScheduledTask;
  AdminSendMeetingSummaryEmails: SendSummaryEmailsResult;
  /** Records that the candidate declines AI interview consent and notifies the company support address. */
  AiInterviewConsentDecline: AiInterviewConsent;
  /** Records that the candidate consents to AI transcription and scoring for this AI interview, for the text currently shown. */
  AiInterviewConsentGive: AiInterviewConsent;
  AnswerCreate?: Maybe<Answer>;
  AnswerDelete?: Maybe<DeleteResult>;
  AnswerUpdate?: Maybe<Answer>;
  ApiKeyCompanyDisable: Scalars['Boolean'];
  ApiKeyCompanyGenerate: AmApiKeyModel;
  ApiKeyDisable: Scalars['Boolean'];
  ApiKeyDisableUser: Scalars['Boolean'];
  ApiKeyUserGenerate: AmApiKeyModel;
  ApiUserCreateOne: ApiUserModel;
  ApiUserResetClientSecret: ApiUserModel;
  ApiUserUpdateOne: ApiUserModel;
  ArchiveHiringProcessTemplate: Scalars['Boolean'];
  ArchiveSkillsProfileTemplate: Scalars['Boolean'];
  BehaviourContentCreateOne: BehaviourContentModel;
  BehaviourContentDeleteOne: DeleteResult;
  BehaviourContentUpdateOne: BehaviourContentModel;
  BehaviourCreateOne: BehaviourModel;
  BehaviourDeleteOne: DeleteResult;
  BehaviourFromCsvRowsCreateMany: Scalars['String'];
  BehaviourUpdateOne: BehaviourModel;
  BulkUpdateCandidateShortlist: Array<ShortlistStageCandidate>;
  CalibrationFileUpload: CalibrationFileUploadModel;
  CandidateAcceptIndirectInvitation: CandidateAcceptIndirectInvitationResult;
  CandidateFeedbackGenerateOneV2: CandidateFeedbackModelV2;
  CandidateFeedbackUpdateOneV2: CandidateFeedbackModelV2;
  CandidateInterviewGuideConfirm: Scalars['Boolean'];
  CandidateInterviewGuideCreate: CandidateInterviewGuideModel;
  /** Populate an assessment question for a candidate guide. */
  CandidateInterviewGuidePopulateAssessmentQuestion: CandidateInterviewGuideQuestionModel;
  CandidateInterviewGuideQuestionCreateOne: CandidateInterviewGuideQuestionModel;
  CandidateInterviewGuideQuestionDeleteOne: CandidateInterviewGuideQuestionModel;
  /** Generate and save a new AI-powered interview question for a candidate guide. */
  CandidateInterviewGuideQuestionGenerate: CandidateInterviewGuideQuestionModel;
  /** Regenerate an existing AI-powered interview question in a candidate guide while preserving the skills it was originally intended to assess. This allows users to get a new formulation or framing of the question while maintaining the same skill coverage. */
  CandidateInterviewGuideQuestionRegenerate: CandidateInterviewGuideQuestionModel;
  /** Reorder a question to a new position. Updates only affected questions for optimal performance. Returns true on success; frontend should handle reordering optimistically. */
  CandidateInterviewGuideQuestionReorder: Scalars['Boolean'];
  CandidateInterviewGuideQuestionUpdateOne: CandidateInterviewGuideQuestionModel;
  CandidateInterviewGuideRegenerate: CandidateInterviewGuideModel;
  /** Requests an Interview Guide PDF generation and returns a unique requestId to subscribe to lifecycle events. */
  CandidateInterviewGuideRequestPdf: Scalars['String'];
  CandidateInviteMany: Array<ProjectCandidate>;
  ClientAuthenticate: AuthCodeResult;
  ClientMFAAuthenticate: AuthCodeResultCookie;
  ClientRegisterAccount: AuthCodeResult;
  CompanyAllowedEmailDomainsUpdate: Array<Scalars['String']>;
  CompanyBrandingUpsert: CompanyBranding;
  CompanyConsentCaptureUpdate: Company;
  CompanyCreateUser: User;
  CompanyEmployeeCreate: CompanyEmployeeModel;
  CompanyEmployeeDeleteOne: DeleteResult;
  CompanyEmployeeFileUpload: CompanyEmployeeFileUploadModel;
  CompanyEmployeeSyncWithUserCompanyInfo?: Maybe<Array<CompanyEmployeeModel>>;
  CompanyEmployeeUpdate: CompanyEmployeeModel;
  CompanyMeetingConfigurationCreateOne: CompanyMeetingConfigurationModel;
  CompanyMeetingConfigurationUpdateOne: CompanyMeetingConfigurationModel;
  /** Remove a user from a workspace. Removes all company roles but keeps the user account intact (they may belong to other workspaces). Requires FULL_ACCESS permission. */
  CompanyRemoveUser: Scalars['Boolean'];
  CompanyResendInvite: Scalars['Boolean'];
  CompanyRoleUpsert: CompanyRole;
  CompanySignatureCreateOne: CompanySignatureModel;
  CompanySignatureDeleteOne: DeleteResult;
  CompanySignatureSoftDeleteOne: DeleteResult;
  CompanySignatureUpdateOne: CompanySignatureModel;
  CompanyStageCandidateDeleteOne: DeleteResult;
  /** Update a user's access level for a workspace. Replaces all existing company roles with the new role. Requires FULL_ACCESS permission and caller can only assign roles they themselves have. */
  CompanyUpdateUserRole: User;
  ContentStageCandidateMarkComplete: MyRoleContentStage;
  CreateAssessmentBrowserSwitchCandidateTrackingEvent: Scalars['Boolean'];
  CreateCompanyUser: User;
  CreateHiringProcessTemplate: HiringProcessTemplate;
  CreateHiringProcessTemplateVersion: HiringProcessTemplate;
  CreateInterviewGuideBlueprintsForInterviewStage: InterviewGuideBlueprintModel;
  CreateInterviewGuideBlueprintsForProjectJobRole: InterviewGuideBlueprintModel;
  CreateSkillsProfileTemplate: SkillsProfileTemplate;
  CreateSkillsProfileTemplateVersion: SkillsProfileTemplate;
  /** @deprecated Use archiveAssessmentStageDeiAction instead */
  DeiStageActionArchive: DeiStageActionModel;
  DeiStageActionCandidateClearAllForCandidate: Scalars['Int'];
  DeiStageActionCandidateDeclineConsent: DeiStageActionCandidateModel;
  DeiStageActionCandidateGiveConsent: DeiStageActionCandidateModel;
  DeiStageActionCandidateReopen: DeiStageActionCandidateModel;
  DeiStageActionCandidateRevokeConsent: DeiStageActionCandidateModel;
  DeiStageActionCandidateSubmitResponses: DeiStageActionCandidateModel;
  DeiStageActionTemplateUpsert: DeiStageActionTemplateModel;
  /** @deprecated Use unarchiveAssessmentStageDeiAction instead */
  DeiStageActionUnarchive: DeiStageActionModel;
  /** @deprecated Use upsertAssessmentStageDeiAction instead */
  DeiStageActionUpsert: DeiStageActionModel;
  DeleteMonolithBlob: Scalars['Boolean'];
  DeleteShortlistStageResume: Scalars['Boolean'];
  E2eCookie: AuthenticationResultE2eCookie;
  ExchangeAuthCode: AuthenticationResult;
  FieldCreate?: Maybe<Field>;
  FieldDelete?: Maybe<DeleteResult>;
  FieldUpdate?: Maybe<Field>;
  FormAddField?: Maybe<Form>;
  FormBuilderCreate?: Maybe<FormBuilder>;
  FormBuilderUpdate?: Maybe<FormBuilder>;
  FormCreate?: Maybe<Form>;
  FormDelete?: Maybe<DeleteResult>;
  FormFieldRemove?: Maybe<Form>;
  FormFieldUpdate?: Maybe<Form>;
  FormUpdate?: Maybe<Form>;
  GenerateRSP: SkillsProfileSource;
  IdentityProviderCreateOne: IdentityProviderModel;
  IdentityProviderDeleteOne: DeleteResult;
  IdentityProviderRestoreOne?: Maybe<IdentityProviderModel>;
  IdentityProviderSoftDeleteOne: DeleteResult;
  IdentityProviderUpdateOne: IdentityProviderModel;
  InitializeShortlistCalibrationBorderlineQuestions: ShortlistCalibrationBorderlineQuestions;
  InterviewAutosuggestionUpdateOneV2: InterviewAutosuggestionModelV2;
  InterviewDecisionCreateOneV2: InterviewDecisionModelV2;
  InterviewDecisionDeleteOneV2: DeleteResult;
  InterviewDecisionUpdateOneV2: InterviewDecisionModelV2;
  InterviewDeleteOneV2: DeleteResult;
  /** Submit an interview evaluation as COMPLETED or SKIPPED. This action is final and irreversible. COMPLETED requires the skills evaluation to be submitted first. */
  InterviewEvaluationSubmit: InterviewEvaluationModel;
  InterviewGuideBlueprintPublish: InterviewGuideBlueprintModel;
  InterviewGuideBlueprintQuestionAddSoftSkill: InterviewGuideBlueprintQuestionModel;
  InterviewGuideBlueprintQuestionCreate: InterviewGuideBlueprintQuestionModel;
  InterviewGuideBlueprintQuestionDelete: InterviewGuideBlueprintQuestionModel;
  InterviewGuideBlueprintQuestionGenerate: InterviewGuideBlueprintQuestionModel;
  /** Regenerate an existing AI-powered interview question in a blueprint while preserving the skills it was originally intended to assess. This allows users to get a new formulation or framing of the question while maintaining the same skill coverage. */
  InterviewGuideBlueprintQuestionRegenerate: InterviewGuideBlueprintQuestionModel;
  InterviewGuideBlueprintQuestionRemoveSoftSkill: InterviewGuideBlueprintQuestionModel;
  /** Reorder a question to a new position. Updates only affected questions for optimal performance. Returns true on success; frontend should handle reordering optimistically. */
  InterviewGuideBlueprintQuestionReorder: Scalars['Boolean'];
  /** Retry AI generation for a question that failed. Only works for questions with generationStatus FAILED and retryCount < MAX_RETRIES (2). Publishes GENERATION_STARTED, GENERATION_COMPLETED, or GENERATION_FAILED events. */
  InterviewGuideBlueprintQuestionRetry: InterviewGuideBlueprintQuestionModel;
  InterviewGuideBlueprintQuestionUpdate: InterviewGuideBlueprintQuestionModel;
  InterviewGuideBlueprintQuestionUpdateSoftSkill: InterviewGuideBlueprintQuestionModel;
  InterviewGuideBlueprintRegenerateQuestions: Scalars['Boolean'];
  InterviewGuideContentTemplateUpsert: InterviewGuideContentTemplateModel;
  InterviewQuestionRoleLevelContentUpdate?: Maybe<InterviewQuestionRoleLevel>;
  InterviewQuestionRoleLevelContentUpload: InterviewQuestionRoleLevelContentUploadModel;
  InterviewStageDelete: Scalars['Boolean'];
  InterviewStageUpdate: InterviewStage;
  InterviewStageUpdateDuration: InterviewStage;
  InterviewUpdateOneV2: InterviewV2Model;
  InvitationCreate: InvitationModel;
  InvitationDeleteMany: DeleteResult;
  InvitationDeleteOne: DeleteResult;
  InvitationUpdate: InvitationModel;
  JobRoleCreateOne: JobRoleModel;
  JobRoleDeleteOne: DeleteResult;
  JobRoleDuplicate: JobRoleModel;
  JobRoleSoftDeleteOne: DeleteResult;
  JobRoleUpdateOne: JobRoleModel;
  LocationLinkCreateMany: Array<LocationLinkCreateOneResult>;
  LocationLinkCreateOne: LocationLinkCreateOneResult;
  LocationLinkDeleteMany: Array<LocationLinkModel>;
  MarkCandidateAsHired: ProjectCandidate;
  MarkCandidatesAsHired: Array<ProjectCandidate>;
  MeetingCreateOne: MeetingModel;
  MeetingDeleteOne: Scalars['Boolean'];
  MeetingGenerateTranslatedTranscript?: Maybe<Scalars['String']>;
  MeetingParticipantCreateMany: MeetingModel;
  MeetingRecordingCompleteUpload: MeetingModel;
  MeetingRecordingCreateUpload: RecordingUploadModel;
  MeetingRecordingDeleteUpload: DeleteResultModel;
  MeetingSummaryGenerateOne: MeetingSummaryModel;
  MeetingSummaryUpdateOne: MeetingSummaryModel;
  MeetingTypeCreateOne: MeetingTypeModel;
  MeetingTypeUpdateOne: MeetingTypeModel;
  MeetingUpdateOne: MeetingModel;
  MeetingUserCalendarDeleteOne: DeleteResultModel;
  OverwriteInterviewStageSkills: InterviewStage;
  ProgressCandidate: ProjectCandidate;
  ProgressCandidates: ProgressCandidatesPayload;
  ProjectAddInterviewStage: Project;
  ProjectAddShortlistStage: ProjectAddShortlistStage;
  ProjectArtifactCompleteJobDescriptionUpload: Project;
  ProjectArtifactDeleteJobDescription: Project;
  ProjectArtifactInitiateJobDescriptionUpload: SinglepartUpload;
  ProjectArtifactLinkMeeting: Project;
  ProjectArtifactUnlinkMeeting: Project;
  ProjectCandidateDelete: Scalars['Boolean'];
  ProjectCandidateInviteMany: Array<ProjectCandidate>;
  ProjectCandidateInviteToAssessment: ProjectCandidate;
  ProjectCandidateUpdateDeadline: ProjectCandidate;
  ProjectCandidateUpsertAssignees: ProjectCandidate;
  ProjectCollaboratorsCreateMany: Array<ProjectCollaboratorRole>;
  ProjectCollaboratorsDeleteMany: Array<ProjectCollaboratorDeleteManyResult>;
  ProjectCollaboratorsUpdateRole: ProjectCollaboratorRole;
  ProjectDelete: DeleteResult;
  ProjectJobRoleCreateOne: ProjectJobRoleModel;
  ProjectJobRoleDeleteOne: DeleteResult;
  ProjectJobRoleSetMain: ProjectJobRoleModel;
  ProjectJobRoleSoftDeleteOne: DeleteResult;
  ProjectRequestCreateOne: ProjectRequestModel;
  ProjectRequestDeleteOne: DeleteResult;
  ProjectRequestFileUpload: Scalars['String'];
  ProjectRequestFileUploadDeleteOne: DeleteResult;
  ProjectRequestFileUploadSoftDeleteOne: DeleteResult;
  ProjectRequestLinkProject: ProjectRequestModel;
  ProjectRequestRequestJobSpecification: Scalars['Boolean'];
  ProjectRequestRequestManagerSurvey: Scalars['Boolean'];
  ProjectRequestRestoreOne?: Maybe<ProjectRequestModel>;
  ProjectRequestSoftDeleteOne: DeleteResult;
  ProjectRequestUpdateManagerSurvey: ProjectRequestModel;
  ProjectRequestUpdateOne: ProjectRequestModel;
  ProjectRequestUserApprovalCreateMany: Array<ProjectRequestUserApprovalModel>;
  ProjectRequestUserApprovalCreateOne: ProjectRequestUserApprovalModel;
  ProjectRequestUserApprovalDeleteOne: DeleteResult;
  ProjectRequestUserApprovalSoftDeleteOne: DeleteResult;
  ProjectRequestUserApprovalUpdateMany: Array<ProjectRequestUserApprovalModel>;
  ProjectRequestUserApprovalUpdateOne: ProjectRequestUserApprovalModel;
  ProjectRequestUserCreateMany: Array<ProjectRequestUserModel>;
  ProjectRequestUserCreateOne: ProjectRequestUserModel;
  ProjectRequestUserDeleteOne: DeleteResult;
  ProjectRequestUserSoftDeleteOne: DeleteResult;
  ProjectRequestUserUpdateOne: ProjectRequestUserModel;
  ProjectSetCompanySignature: Project;
  ProjectStagesReorder: Array<ProjectStageOrderModel>;
  ProjectUpdateStatus: Project;
  ProjectUserDeleteOne: ProjectUser;
  ProjectUserUpdateOne: ProjectUser;
  ProjectWizardCreateAiInterviewAssessmentStage: Project;
  ProjectWizardCreateAssessmentStage: Project;
  ProjectWizardCreateInterviewStage: Project;
  ProjectWizardCreateProject: Project;
  ProjectWizardCreateShortlistStage: ProjectAddShortlistStage;
  ProjectWizardInterviewStageDelete: Scalars['Boolean'];
  ProjectWizardInterviewStageUpdate: InterviewStage;
  ProjectWizardInterviewStageUpdateDuration: InterviewStage;
  ProjectWizardProjectCollaboratorsCreateMany: Array<ProjectCollaboratorRole>;
  ProjectWizardProjectCollaboratorsDeleteMany: Array<ProjectCollaboratorDeleteManyResult>;
  ProjectWizardShortlistStageDelete: Scalars['Boolean'];
  ProjectWizardStageDeleteOne: DeleteResult;
  ProjectWizardUpdateAiInterviewAssessmentStage: SmStageModel;
  ProjectWizardUpdateStageReportEmailSettings: SmStageModel;
  ProjectWizardUpdateStatus: Project;
  QCalcGetNextQuestion: QCalcResponse;
  QuestionnaireSubmitResponses: MyRoleQuestionnaireStage;
  RejectCandidates: RejectCandidatesPayload;
  ReportAssignmentCreate?: Maybe<ReportAssignment>;
  ReportAssignmentDelete?: Maybe<DeleteResult>;
  ReportAssignmentUpdate?: Maybe<ReportAssignment>;
  ReportConfigCreate?: Maybe<ReportConfig>;
  ReportConfigDelete?: Maybe<DeleteResult>;
  ReportCopy?: Maybe<Report>;
  ReportCreate?: Maybe<Report>;
  ReportDelete?: Maybe<DeleteResult>;
  /** @deprecated Please use either StageResultsReportRenderCreate, or SuccessProfileReportRenderCreate */
  ReportRenderCreate?: Maybe<ReportRender>;
  ReportRenderDelete?: Maybe<DeleteResult>;
  ReportUpdate?: Maybe<Report>;
  ReportUpdateIsArchived?: Maybe<Report>;
  RequeueRejectedEvent?: Maybe<DlxRejectedEvent>;
  ResetShortlistStageCandidateQuestionnaire: ShortlistStageCandidate;
  RespondantFormDeleteByRespondantAndAssociatedId?: Maybe<DeleteResult>;
  RespondantFormDeleteByRespondantId?: Maybe<DeleteResult>;
  RespondantFormUpdate?: Maybe<RespondantForm>;
  ResultCreateManySoftSkillsProfileFromSc: Array<ResultModel>;
  ResultCreateManyTechnicalSkillsProfileFromSc: Array<ResultModel>;
  ResultCreateOneBehaviour: ResultModel;
  ResultCreateOnePspSoftSkill: ResultModel;
  ResultCreateOnePspTechnicalSkill: ResultModel;
  ResultDeleteMany: DeleteResult;
  ResultUpdateOneBehaviour: ResultModel;
  RetryResumeProcessing: Scalars['Boolean'];
  /** Archives up to 100 roles for the caller's organisation, regardless of status, unlinking each role's ATS requisition. Reports per role: unknown ids, other companies' roles and already-archived roles come back as NOT_FOUND rather than failing the request. Cannot be undone from the company app. */
  RoleBatchArchive: RoleBatchResultModel;
  /** Pins roles for the active workspace, appended in request order. Accepts up to 100 ids, but a user may hold only 5 pins, so this succeeds only while the newly pinned roles fit: all or nothing, rejected with code ROLE_PIN_LIMIT_EXCEEDED. Idempotent — already-pinned roles keep their position and do not count against the limit. Rejected with ROLE_NOT_PINNABLE when any role is not available to the caller. */
  RoleBatchPin: Array<RoleModel>;
  /** Unpins up to 100 roles in the active workspace. Idempotent — ids that are not pinned are not an error. Re-pinning afterwards places those roles at the bottom of the group. */
  RoleBatchUnpin: Array<RoleModel>;
  /** Closes up to 100 Published roles, or reopens up to 100 Closed ones. Reports per role: a role whose status does not qualify comes back as NOT_PUBLISHED or NOT_CLOSED rather than failing the request. Only CLOSED and PUBLISHED are accepted as targets. */
  RoleBatchUpdateStatus: RoleBatchResultModel;
  RoleLinkRequisition: RoleModel;
  /** Pins a role to the bottom of the pinned group for the active workspace. Idempotent — pinning an already-pinned role does not move it. Rejects a sixth pin with code ROLE_PIN_LIMIT_EXCEEDED. */
  RolePin: Array<RoleModel>;
  /** Reorders stages in the hiring pipeline by updating their order indices. */
  RoleStagesReorder: Array<RoleStageOrderModel>;
  RoleUnlinkRequisition: RoleModel;
  /** Unpins a role in the active workspace. Idempotent — unpinning a role that is not pinned is not an error. Re-pinning afterwards places the role at the bottom of the group. */
  RoleUnpin: Array<RoleModel>;
  RoleWizardAddSoftSkills: RoleModel;
  /** Adds team members to the role. All users must belong to the same company. Existing members are skipped. */
  RoleWizardAddTeamMembers: RoleModel;
  RoleWizardAddTechnicalSkills: RoleModel;
  /** Applies a hiring process template's latest version to a draft role, creating its stages in template order. */
  RoleWizardApplyHiringProcessTemplate: RoleModel;
  /** Archives a role. Archived roles are read-only and cannot be published or edited. */
  RoleWizardArchive: RoleModel;
  /** Clears every non-Offer stage from a draft role, returning it to the hiring process build-method chooser. */
  RoleWizardClearHiringProcess: RoleModel;
  /** Completes a job description upload and attaches the file to the role. */
  RoleWizardCompleteJobDescriptionUpload: RoleModel;
  /** Confirms the RSP and creates assessment/interview stages. Role stays in DRAFT. */
  RoleWizardConfirmRSP: RoleModel;
  /** Creates the role in DRAFT status with the caller as the initial team member. */
  RoleWizardCreate: RoleModel;
  /** Adds an AI interview assessment stage to the role. Validates CREATE_ASSESSMENT_STAGE policy. */
  RoleWizardCreateAiInterviewAssessmentStage: RoleModel;
  /** Adds an assessment stage to the role. Validates CREATE_ASSESSMENT_STAGE policy. */
  RoleWizardCreateAssessmentStage: RoleModel;
  /** Adds a content stage to the role. Validates CREATE_CONTENT_STAGE policy. */
  RoleWizardCreateContentStage: RoleModel;
  /** Adds an interview stage to the role. Validates CREATE_INTERVIEW_STAGE policy. */
  RoleWizardCreateInterviewStage: RoleModel;
  /** Adds a shortlist stage to the role. Validates CREATE_SHORTLIST_STAGE policy. */
  RoleWizardCreateShortlistStage: RoleModel;
  /** Deletes a content stage by id. Validates REMOVE_CONTENT_STAGE policy. */
  RoleWizardDeleteContentStage: RoleModel;
  /** Deletes an interview stage by UUID. Validates REMOVE_INTERVIEW_STAGE policy. */
  RoleWizardDeleteInterviewStage: RoleModel;
  /** Deletes the attached job description. No-ops if no file is attached. */
  RoleWizardDeleteJobDescription: RoleModel;
  /** Deletes a shortlist stage by UUID. Validates REMOVE_SHORTLIST_STAGE policy. */
  RoleWizardDeleteShortlistStage: RoleModel;
  /** Deletes a stage by id. Validates REMOVE_ASSESSMENT_STAGE policy on the role. */
  RoleWizardDeleteStage: DeleteResult;
  /** Triggers RSP skill generation for the role. skillsProfileId is resolved automatically. */
  RoleWizardGenerateSkills: RoleModel;
  /** Initiates a job description upload. Call CompleteJobDescriptionUpload after uploading to attach. */
  RoleWizardInitiateJobDescriptionUpload: SinglepartUpload;
  /** Links an intake meeting to the role. Only allowed for DRAFT roles. */
  RoleWizardLinkIntakeMeeting: RoleModel;
  /** Removes the applied hiring process template from a draft role, clearing every non-Offer stage. */
  RoleWizardRemoveHiringProcessTemplate: RoleModel;
  /** Removes all skills from the role's success profile and resets skill generation state. */
  RoleWizardRemoveRSPSkills: RoleModel;
  RoleWizardRemoveSoftSkill: RoleModel;
  /** Removes a team member from the role. The last remaining member cannot be removed. */
  RoleWizardRemoveTeamMember: RoleModel;
  RoleWizardRemoveTechnicalSkill: RoleModel;
  /** Archives a role for the caller's organisation, regardless of its current status. Cannot be undone from the company app. */
  RoleWizardRoleArchive: RoleModel;
  /** Transitions a role to a new status. Invalid status transitions throw. */
  RoleWizardRoleUpdateStatus: RoleModel;
  /** Removes the intake meeting link from the role. Only allowed for DRAFT roles. */
  RoleWizardUnlinkIntakeMeeting: RoleModel;
  RoleWizardUnlinkRequisition: RoleModel;
  /** Updates role fields. Validates UPDATE_PROJECT_NAME policy when name is supplied. */
  RoleWizardUpdate: RoleModel;
  /** Updates an AI interview assessment stage. No policy validation, mirrors project-level behaviour. */
  RoleWizardUpdateAiInterviewAssessmentStage: RoleModel;
  /** Updates the report and email settings of an assessment stage. Validates UPDATE_ASSESSMENT_STAGE_REPORT_AND_EMAIL policy. */
  RoleWizardUpdateAssessmentStageEmailSettings: RoleModel;
  /** Updates a content stage. Validates UPDATE_CONTENT_STAGE policy. */
  RoleWizardUpdateContentStage: RoleModel;
  /** Updates the name, duration, or focus of an interview stage. Validates UPDATE_INTERVIEW_STAGE_NAME and UPDATE_INTERVIEW_STAGE_DURATION policies. */
  RoleWizardUpdateInterviewStage: RoleModel;
  /** Sets or clears the skills profile template applied to the role, resets and regenerates RSP skills accordingly. */
  RoleWizardUpdateSkillsProfileTemplate: RoleModel;
  RssAssessmentCandidateReopenAllSubmittedForStageCandidate: Array<RssAssessmentCandidateModel>;
  RssAssessmentCandidateSubmitOne: RssAssessmentCandidateModel;
  /** @deprecated Use createAssessmentStageRssAction instead */
  RssAssessmentCreateMany: Array<RssAssessmentModel>;
  /** @deprecated Use deleteAssessmentStageRssAction instead */
  RssAssessmentDeleteMany: DeleteResult;
  SamlAuthInfoCreateOne: SamlAuthInfoModel;
  SamlAuthInfoDeleteOne: DeleteResult;
  SamlAuthInfoRestoreOne?: Maybe<SamlAuthInfoModel>;
  SamlAuthInfoSoftDeleteOne: DeleteResult;
  SamlAuthInfoUpdateOne: SamlAuthInfoModel;
  ScheduleCandidatesDebriefExport: FileExportScheduledTask;
  ScheduleROICsvFileExport: FileExportScheduledTask;
  ScheduleStageCandidateResultsCsvFileExport: FileExportScheduledTask;
  ScheduledCandidateUsageCsvFileExport: FileExportScheduledTask;
  SchedulingDeadLetterReplay: DeadLetterReplayReport;
  ShortlistCandidate: ShortlistStageCandidate;
  ShortlistStageConfigure: ShortlistStage;
  ShortlistStageDelete: Scalars['Boolean'];
  /** Full-replace of the stage's eligibility questionnaire. An empty items list deletes it. Returns null when the questionnaire was removed. */
  ShortlistStageQuestionnaireConfigure?: Maybe<Questionnaire>;
  /** Toggles auto progression/rejection on the stage's eligibility questionnaire — for post-publish settings. Enabling requires a questionnaire. */
  ShortlistStageUpdateAutoProgression: ShortlistStage;
  ShortlistStageUpdateCriteria: ShortlistStage;
  /** Renames the stage without touching criteria or calibration — for post-publish settings. */
  ShortlistStageUpdateName: ShortlistStage;
  SkillsEvaluationUpdateOneV2: SkillsEvaluationModelV2;
  SkillsProfileSourceAddSoftSkills: SkillsProfileSource;
  SkillsProfileSourceAddTechnicalSkills: SkillsProfileSource;
  SkillsProfileSourceArchiveSoftSkill: SkillsProfileSource;
  SkillsProfileSourceArchiveTechnicalSkill: SkillsProfileSource;
  SkillsProfileSourceCompleteIntakeMeetingUpload: SkillsProfileSource;
  SkillsProfileSourceCompleteJobDescriptionUpload: SkillsProfileSource;
  SkillsProfileSourceCreate: SkillsProfileSource;
  SkillsProfileSourceDelete: Scalars['Boolean'];
  SkillsProfileSourceDeleteIntakeMeeting: SkillsProfileSource;
  SkillsProfileSourceDeleteJobDescription: SkillsProfileSource;
  SkillsProfileSourceGenerateSkills: SkillsProfileSource;
  SkillsProfileSourceInitiateIntakeMeetingUpload: MultipartUpload;
  SkillsProfileSourceInitiateJobDescriptionUpload: SinglepartUpload;
  SkillsProfileSourceLinkMeeting: SkillsProfileSource;
  SkillsProfileSourceLinkUpcomingMeeting: SkillsProfileSource;
  SkillsProfileSourceRemoveSoftSkill: SkillsProfileSource;
  SkillsProfileSourceRemoveTechnicalSkill: SkillsProfileSource;
  SkillsProfileSourceSignOff: SkillsProfileSource;
  SkillsProfileSourceUnlinkMeeting: SkillsProfileSource;
  SkillsProfileSourceUnlinkUpcomingMeeting: SkillsProfileSource;
  SkillsProfileSourceUpdate: SkillsProfileSource;
  SkillsProfileSourceUpsertCollaborators: SkillsProfileSource;
  SoftSkillAddTrait?: Maybe<SoftSkill>;
  SoftSkillBulkUpdateTraits?: Maybe<SoftSkill>;
  SoftSkillCreate?: Maybe<SoftSkill>;
  SoftSkillDeleteTrait?: Maybe<SoftSkill>;
  SoftSkillRestore: SoftSkill;
  SoftSkillRoleLevelContentCsvFileExport: FileExportScheduledTask;
  SoftSkillRoleLevelContentUpdate?: Maybe<SoftSkillRoleLevelContent>;
  SoftSkillRoleLevelContentUpload: Scalars['Boolean'];
  SoftSkillSoftDelete: SoftSkill;
  SoftSkillSuccessProfileContentCreate?: Maybe<SoftSkillSuccessProfileContent>;
  SoftSkillSuccessProfileContentDelete?: Maybe<DeleteResult>;
  SoftSkillSuccessProfileContentUpdate?: Maybe<SoftSkillSuccessProfileContent>;
  SoftSkillTypeSuccessProfileContentCreate?: Maybe<SoftSkillTypeSuccessProfileContent>;
  SoftSkillTypeSuccessProfileContentDelete?: Maybe<DeleteResult>;
  SoftSkillTypeSuccessProfileContentUpdate?: Maybe<SoftSkillTypeSuccessProfileContent>;
  SoftSkillUpdate: SoftSkill;
  StageBrandingUpsert: StageBranding;
  StageCandidateAcceptIndirectInvitation: SmStageCandidateModel;
  StageCandidateDeleteOne: DeleteResult;
  StageCandidatePledgeAnticheating: Scalars['Boolean'];
  StageCandidateReprocessOne: Scalars['Boolean'];
  StageCandidateResetOne: Scalars['Boolean'];
  StageCandidateSubmitAdjustmentQuestionnaire: SmStageCandidateModel;
  StageCandidateUpdateDeadline: SmStageCandidateModel;
  StageCreate: SmStageModel;
  /** @deprecated Use deleteAssessmentStage mutation instead! */
  StageDeleteOne: DeleteResult;
  StageResultsReportRenderCreate?: Maybe<ReportRender>;
  /** @deprecated Use updateAssessmentStage instead! */
  StageUpdate: SmStageModel;
  SuccessProfileAddSoftSkills: SuccessProfile;
  SuccessProfileAddTechnicalSkills: SuccessProfile;
  SuccessProfileConfirm: SuccessProfile;
  /** @deprecated use SuccessProfileCreateOne instead */
  SuccessProfileCreate: SuccessProfile;
  SuccessProfileCreateOne: SuccessProfile;
  SuccessProfileDelete: DeleteResult;
  SuccessProfileDeleteMany?: Maybe<DeleteResult>;
  SuccessProfileGenerateSkills: SuccessProfile;
  SuccessProfileRemoveSoftSkill: SuccessProfile;
  SuccessProfileRemoveTechnicalSkill: SuccessProfile;
  SuccessProfileReportRenderCreate?: Maybe<ReportRender>;
  SuccessProfileSoftSkillsOverwrite: SuccessProfile;
  SuccessProfileTechnicalSkillCreateMany: Array<SuccessProfileTechnicalSkill>;
  SuccessProfileTechnicalSkillCreateOne: SuccessProfileTechnicalSkill;
  SuccessProfileTechnicalSkillDeleteMany: DeleteResult;
  SuccessProfileTechnicalSkillDeleteOne: DeleteResult;
  SuccessProfileTechnicalSkillOverwriteMany: Array<SuccessProfileTechnicalSkill>;
  SuccessProfileTechnicalSkillSoftDeleteMany: DeleteResult;
  SuccessProfileTechnicalSkillSoftDeleteOne: DeleteResult;
  SuccessProfileTechnicalSkillUpdateMany: Array<SuccessProfileTechnicalSkill>;
  SuccessProfileTechnicalSkillUpdateOne: SuccessProfileTechnicalSkill;
  SuccessProfileTechnicalSkillsOverwrite: SuccessProfile;
  /** @deprecated use SuccessProfileUpdateOne instead */
  SuccessProfileUpdate: SuccessProfile;
  SuccessProfileUpdateOne: SuccessProfile;
  SummaryTemplateCreateOne: SummaryTemplateResponseModel;
  SummaryTemplateDeleteOne: DeleteResultModel;
  SummaryTemplateUpdateOne: SummaryTemplateResponseModel;
  SzAdminReportRenderRetry: Array<ReportRender>;
  SzSkillsMergeCreateMany: Array<SzSkillsMerge>;
  SzSkillsMergeCreateOne: SzSkillsMerge;
  SzSkillsMergeDeleteMany: DeleteResult;
  SzSkillsMergeDeleteOne: DeleteResult;
  SzSkillsMergeSoftDeleteMany: DeleteResult;
  SzSkillsMergeSoftDeleteOne: DeleteResult;
  SzSkillsMergeUpdateMany: Array<SzSkillsMerge>;
  SzSkillsMergeUpdateOne: SzSkillsMerge;
  TechnicalSkillCreateOne: TechnicalSkill;
  TechnicalSkillIconUpload: Scalars['String'];
  TechnicalSkillRestore: TechnicalSkill;
  TechnicalSkillSoftDelete: TechnicalSkill;
  TechnicalSkillUpdate: TechnicalSkill;
  TraitCreate?: Maybe<Trait>;
  TraitDelete?: Maybe<DeleteResult>;
  TraitRoleLevelContentUpdate?: Maybe<TraitRoleLevelContent>;
  TraitRoleLevelContentUpload: Scalars['Boolean'];
  TraitSoftSkillContextCreateOne: TraitSoftSkillContextModel;
  TraitSoftSkillContextDeleteMany: DeleteResult;
  TraitSoftSkillContextDeleteOne: DeleteResult;
  TraitSoftSkillContextFileUpload: TraitSoftSkillContextFileUploadModel;
  TraitTestTypeReplaceMany?: Maybe<Array<TraitTestTypeModel>>;
  TraitUpdate?: Maybe<Trait>;
  TraitUpdateIsArchived?: Maybe<Trait>;
  UnarchiveHiringProcessTemplate: HiringProcessTemplate;
  UnarchiveSkillsProfileTemplate: SkillsProfileTemplate;
  UnmarkCandidateAsHired: ProjectCandidate;
  UnmarkCandidatesAsHired: Array<ProjectCandidate>;
  UnrejectCandidate: ProjectCandidate;
  UnrejectCandidates: Array<ProjectCandidate>;
  UnshortlistCandidate: ShortlistStageCandidate;
  UpcomingMeetingAddBot: UpcomingMeetingModel;
  UpcomingMeetingDeleteMany: DeleteResultModel;
  UpcomingMeetingRemoveBot: UpcomingMeetingModel;
  UpcomingMeetingUpdateOne: UpcomingMeetingModel;
  UpdateHiringProcessTemplate: HiringProcessTemplate;
  /** Requires (or stops requiring) candidate consent before this role's AI interview. Enabling needs the company's consent capture switch on. */
  UpdateProjectAiInterviewConsentEnabled: Project;
  /** Updates the role's candidate portal landing page (cover photo, title, intro) — for post-publish settings. */
  UpdateProjectCandidatePortalBranding: Project;
  /** Turns the role's candidate portal on or off — for post-publish settings. Enabling requires the company's whitelabeling entitlement; disabling also clears the hiring process deadline and reminder cadence. */
  UpdateProjectCandidatePortalEnabled: Project;
  /** Updates the role's candidate-portal hiring process deadline (relative or absolute) and reminder email cadence — for post-publish settings. With `applyAbsoluteDeadlineToInvitedCandidates`, an absolute date is also stamped on already-invited candidates whose own deadline is earlier or missing (CR-453). */
  UpdateProjectHiringProcessDeadlineSettings: HiringProcessDeadlineSettingsUpdatePayload;
  UpdateProjectIntegrityMonitoring: Project;
  UpdateProjectLocales: Project;
  UpdateProjectName: Project;
  UpdateSkillsProfileTemplate: SkillsProfileTemplate;
  /** @deprecated Use updateAssessmentStageEmailSettings instead */
  UpdateStageReportEmailSettings: SmStageModel;
  UserAnonymise: User;
  UserCompanyInfoCreate: UserCompanyInfo;
  UserCompanyInfoDeleteOne: DeleteResult;
  UserCompanyInfoUpdate: UserCompanyInfo;
  UserCreate: User;
  UserDelete: DeleteResult;
  UserDeleteByEmail: DeleteResult;
  UserGroupCreateOne: UserGroupModel;
  UserGroupDeleteOne: Scalars['Boolean'];
  UserGroupMembersCreateMany: Scalars['Boolean'];
  UserGroupMembersDeleteMany: Scalars['Boolean'];
  UserGroupUpdateOne: UserGroupModel;
  UserMeetingConfigurationCreateOne: UserMeetingConfigurationModel;
  UserMeetingConfigurationUpdateOne: UserMeetingConfigurationModel;
  UserRoleCreate?: Maybe<UserRole>;
  UserRoleDelete: DeleteResult;
  UserRoleUpdate: UserRole;
  UserSettingsCreate: UserSettings;
  UserSettingsDeleteOne: DeleteResult;
  UserSettingsUpdate: UserSettings;
  UserUpdate: User;
  WidgetConfigCreate?: Maybe<WidgetConfig>;
  WidgetConfigDelete?: Maybe<DeleteResult>;
  WidgetConfigUpdate?: Maybe<WidgetConfig>;
  WidgetConfigUpdateMany?: Maybe<Array<WidgetConfig>>;
  WidgetCreate?: Maybe<Widget>;
  WidgetDelete?: Maybe<DeleteResult>;
  WidgetDeleteScreenShot: Widget;
  WidgetOptionCreate?: Maybe<WidgetOption>;
  WidgetOptionDelete?: Maybe<DeleteResult>;
  WidgetOptionUpdate?: Maybe<WidgetOption>;
  WidgetOptionUpdateIsArchived?: Maybe<WidgetOption>;
  WidgetOptionUploadBrandedSoftSkillImage: MonolithBlobModel;
  WidgetOptionUploadCoverPageImage: MonolithBlobModel;
  WidgetUpdate?: Maybe<Widget>;
  WidgetUpdateIsArchived?: Maybe<Widget>;
  WidgetUploadScreenShot: Widget;
  addCoderbyteToAssessmentStage: CoderbyteAssessmentStageAction;
  addCognitiveTestToAssessmentStage: CognitiveTestAssessmentStageAction;
  addEnglishProficiencyToAssessmentStage: EnglishProficiencyAssessmentStageAction;
  addPersonalityTestToAssessmentStage: PersonalityTestAssessmentStageAction;
  archiveAssessmentStageDeiAction: DeiStageActionModel;
  authenticate: AuthenticationResult;
  authenticateAiAgent: AuthenticationResult;
  authenticateApi: AuthenticationResult;
  /** Fans out the ats_application_id backfill across every company that has a Kombo integration. Sequential, not parallel. Returns aggregate counters plus a per-company breakdown. Same eligibility filter and matching strategy as the per-company variant. */
  backfillAtsApplicationIdsForAllIntegratedCompanies: BackfillAtsApplicationIdsForAllIntegratedCompaniesResultModel;
  /** Backfills `project_candidate.ats_application_id` for the given company's project candidates that originated from an ATS sync but lack the column. Walks every linked Kombo job, matches PCs to ATS applications by lowercased email, persists the canonical SDK id. Idempotent. */
  backfillAtsApplicationIdsForCompany: BackfillAtsApplicationIdsForCompanyResultModel;
  /** Backfills `sm_stage_candidate` rows for project candidates created via the ATS integration whose current stage is an assessment stage. Mirrors what `ProjectCandidateInviterService.processAssessmentInvite` does on the manual invite path. Idempotent. */
  backfillAtsAssessmentStageCandidates: BackfillAtsAssessmentStageCandidatesResultModel;
  /** Fans the rejection-reason backfill across every company that has a Kombo integration. Sequential both within and across companies, so on a large tenant it can outlive the HTTP timeout in front of this mutation. Nothing is lost when that happens — the writes are not transactional and the whole thing is idempotent — but the operator sees an error on a run that partly succeeded and must re-run to read real counters. Prefer `backfillAtsRejectionReasonsForCompany` per company in production and use this only when those runs come back small. Returns aggregate counters plus a per-company breakdown. */
  backfillAtsRejectionReasonsForAllIntegratedCompanies: BackfillAtsRejectionReasonsForAllIntegratedCompaniesResultModel;
  /** Backfills `project_candidate.ats_rejection_reason` for the given company's already-rejected ATS project candidates (EM-151). They don't re-emit application events unless the application changes upstream, so the mirror stays null for them without this. Resolves each application from the gateway's own synced cache — no Kombo API calls. Idempotent, so safe to re-run as a repair. `noApplicationId` in the result is a diagnostic, not a precondition — it counts every rejected PC with no ats_application_id, mostly manually-invited candidates that never had an ATS application, so it will not reach zero. Prefer this per-company mutation over the all-integrated one for large tenants. */
  backfillAtsRejectionReasonsForCompany: BackfillAtsRejectionReasonsForCompanyResultModel;
  /** Ensures CandidateInterviewGuide records are correctly linked to InterviewStageCandidate records (backfill). */
  backfillCandidateInterviewGuides: BackfillCandidateInterviewGuideModel;
  /** Retro-materialise stuck Kombo applications for a single project by re-triggering the same `SYNC_JOB_APPLICATIONS` chain `linkProject` uses, with `fullSync: true` (so the company-wide `updated_after` watermark is NOT applied — that's the BL-1378 regression that left older applications behind). The project must be PUBLISHED and linked to a Kombo job. Idempotent: gateway dedupes by remote id and the materialiser dedupes via `findOneByProjectAndUser`. Use as the operational alternative to unlink/relink for Roles stuck behind the regression. */
  backfillKomboApplicationsForProject: BackfillKomboApplicationsForProjectResultModel;
  /** Cancels a candidate's scheduling request and, when it is booked, its interview */
  cancelSchedulingRequest: SchedulingRequestModel;
  /** Cleans up duplicate DRAFT blueprints for the same stage/job role combination. Keeps the blueprint with the best generation status (COMPLETED preferred over GENERATION_FAILED). Returns detailed information about duplicate groups including affected projects and job roles. */
  cleanupDuplicateBlueprints: CleanupDuplicateBlueprintsResult;
  /** Removes relationships between questions and skills that start with forbidden prefixes (e.g., "right for", "cognitive"). */
  cleanupForbiddenSkillRelations: CleanupForbiddenSkillRelationsResult;
  cleanupStaleEditingSessions: CleanupResultModel;
  createAssessmentStageRssAction: RssAssessmentModel;
  /** Mints a single-use SSO link into the company Coderbyte workspace, creating the caller's Coderbyte account on their first crossing. The returned URL expires within seconds — navigate to it immediately rather than storing it or rendering it into a link. */
  createCoderbyteSsoLink: CoderbyteSsoLink;
  createCompany: Company;
  createProject: Project;
  createProjectFile: ProjectFile;
  /** Opens a short-lived upload for one scheduling material */
  createRequestMaterialUpload: RequestMaterialUploadModel;
  /** Raises one draft scheduling request per selected candidate */
  createSchedulingRequests: SchedulingBatchModel;
  deauthenticate: Scalars['Boolean'];
  deleteAiInterviewAssessmentStageAction: Scalars['Boolean'];
  deleteAssessmentStage: Scalars['Boolean'];
  deleteAssessmentStageRssAction: Scalars['Boolean'];
  deleteCompany: Scalars['Boolean'];
  /** Removes an unsent draft batch: its requests, their offered slots and its seats. Succeeds when nothing is left to remove */
  discardSchedulingDraft: Scalars['Boolean'];
  disconnectOrgCalendar: OrgCalendarDisconnectModel;
  /** TEMPORARY backfill: sends the eligibility-questions invite email to one shortlist stage candidate. Skips (without sending) when the role has no candidate portal, the stage has no questionnaire, the candidate is no longer on the stage, or an invite was already recorded (`invite_method` set) - so repeat calls send at most one email. A send failure releases the claim and surfaces as an error; re-run the mutation to retry. */
  dispatchEligibilityInviteForShortlistStageCandidate: DispatchEligibilityInviteForShortlistStageCandidateResultModel;
  editProject: Project;
  editProjectArchiving: Project;
  editProjectCandidateReportState: Project;
  editProjectState: Project;
  endIntegrityMonitoringSession: IntegrityMonitoringSession;
  /** Ensures InterviewStageCandidate records exist for active stages/projects. */
  ensureInterviewStageCandidates: EnsureIscResultModel;
  finishAiInterview: AiInterviewAssessmentStageActionCandidate;
  forceStopEditingQuestion: Scalars['Boolean'];
  /** Generate a shareable workspace link with automatic workspace switching */
  generateShareLink: Scalars['String'];
  initiateAiInterview: AiInterviewAssessmentStageActionCandidate;
  initiateVerification: VerificationSession;
  joinConference: ConferenceToken;
  joinDemoConference: DemoConferenceToken;
  /** Cancel a running sync for a company. The sync stops after the current page — a new sync starts fresh. */
  komboCancelSync: KomboSyncRunModel;
  /** Clear all cached Kombo jobs for a company. Use dryRun: true to preview how many jobs would be deleted without actually deleting them. */
  komboClearJobs: KomboClearJobsResponse;
  /** Create or update a Kombo integration for a company (upsert). Accepts atsIntegrationId and/or assessmentIntegrationId — at least one must be provided. Each provided ID is validated against the Kombo API before persisting. Sets the corresponding connectedAt timestamp for each ID. Publishes INTEGRATION_CREATED events that trigger job sync (ATS) and/or assessment package registration (ASSESSMENT). */
  komboCreateIntegration: KomboIntegrationModel;
  /** Force-delete the Kombo integration for a company. Clears all cached jobs and publishes INTEGRATION_DELETED events for each connected ID. */
  komboDeleteIntegration: Scalars['Boolean'];
  /** Disconnect one or both Kombo integration types from a company. Pass ats: true and/or assessment: true to disconnect the corresponding integration. At least one must be true. Nulls the integration ID and its connectedAt timestamp. Publishes an INTEGRATION_DELETED event for each disconnected ID. Returns the updated record, or null if both IDs are now null (record auto-deleted and cached jobs cleared). */
  komboDisconnectIntegration?: Maybe<KomboIntegrationModel>;
  /** Link a project to a cached Kombo job (1:1 mapping). The jobId must be the internal UUID from the kombo_job cache table. Triggers hiring team sync from the job to the project. */
  komboLinkProject: KomboJobProjectModel;
  /** Re-push the company's assessment packages to its ATS via Kombo. Fire-and-forget: returns true once the refresh has been dispatched; no-ops when the company has no enabled assessment integration. */
  komboSetAssessmentPackages: Scalars['Boolean'];
  /** Enable or disable the entire Kombo integration for a company. When disabled, all processing stops: no webhooks processed, no syncs, no assessment orders. */
  komboToggleEnabled: KomboIntegrationModel;
  /** Enable or disable job sync for a company. When sync is disabled, webhook events are still processed (assessment orders work) but data-changed sync is skipped. Use as a kill switch for bad data. */
  komboToggleSyncEnabled: KomboIntegrationModel;
  /** Unlink a project from its Kombo job. Soft-deletes the link record. Does not remove team members (additive-only model). */
  komboUnlinkProject: Scalars['Boolean'];
  mfaAccessToken: MfaResult;
  mfaAuthenticate: AuthenticationResultCookie;
  /** Replaces the interview times a draft batch offers its candidates */
  offerSlots: Array<OfferedSlotModel>;
  overwriteAssessmentStageSkills: AssessmentStage;
  processInvitation: InvivitationTokenProcessingResult;
  projectWizardDeleteAssessmentStage: Scalars['Boolean'];
  projectWizardUpdateAssessmentStage: AssessmentStage;
  projectWizardUpdateAssessmentStageEmailSettings: AssessmentStage;
  /** Creates the company its own Coderbyte organization and records it as awaiting its API key. Billable, in every environment. Refuses if CODERBYTE_ALLOWED_COMPANY_IDS is set and does not name the company. */
  provisionCoderbyteWorkspace: CoderbyteWorkspace;
  refreshCoderbyteAssessmentDetails: CoderbyteAssessmentStageAction;
  registerAccount: AuthenticationResult;
  removeCoderbyteFromAssessmentStage: Scalars['Boolean'];
  removeCognitiveTestFromAssessmentStage: Scalars['Boolean'];
  removeEnglishProficiencyFromAssessmentStage: Scalars['Boolean'];
  removePersonalityTestFromAssessmentStage: Scalars['Boolean'];
  /** Removes AI-generated questions (AI_QUESTION and CUSTOMIZED_AI_QUESTION types) that have no skills attached/tagged. */
  removeUntaggedAiQuestions: RemoveUntaggedAiQuestionsResult;
  renameCoderbyteAssessment: CoderbyteAssessmentStageAction;
  /** Offers a sent scheduling request a fresh round of slots, with a new link */
  reofferSchedulingRequest: SchedulingRequestModel;
  replaceCompanySchedulingSettings: CompanySchedulingSettingsModel;
  reportIntegrityEvents: Scalars['Boolean'];
  requestMfaCode: Scalars['Boolean'];
  requestPasswordRecovery: Scalars['Boolean'];
  requestTokenRefresh: AuthenticationResult;
  /** Moves a booked interview, by offering the candidate fresh slots or to a time the recruiter names */
  rescheduleSchedulingRequest: SchedulingRescheduleResultModel;
  resetAiInterview: AiInterviewAssessmentStageActionCandidate;
  resetCoderbyteAssessment: CoderbyteAssessmentStageActionCandidate;
  resetCognitiveTest: CognitiveTestAssessmentStageActionCandidate;
  resetEnglishProficiencyAssessment: EnglishProficiencyAssessmentStageActionCandidate;
  resetPersonalityTest: PersonalityTestAssessmentStageActionCandidate;
  retryCoderbyteAssessmentResults: Array<CoderbyteResultRetry>;
  /** Saves a reviewer's annotation on one AI interview score (skill–indicator line). Every save keeps the previous version. The AI score never changes. */
  saveAiInterviewScoreAnnotation: AiInterviewScore;
  saveEnglishProficiencyResponse: EnglishProficiencySavedResponse;
  /** Saves an existing draft batch again */
  saveSchedulingDraft: SchedulingBatchModel;
  /** Exchange global JWT for company-scoped JWT by selecting a workspace */
  selectWorkspace: AuthenticationResult;
  /** Sends a draft batch: emails each candidate a booking link, or, with fixedTimes, books every request at its time */
  sendSchedulingRequests: SchedulingSendReportModel;
  /** Toggle whether AI Interview results are pushed back to the ATS as an application result link when scoring completes ("Result link + order" when enabled, "Assessment order only" when disabled). Opt-in (defaults to disabled). Persists on the gateway-side integration row; survives restarts. Returns the post-update canonical Settings. */
  setAtsAiInterviewResultsEnabled: AtsSettingsGqlModel;
  /** Replace the allowlist of rejection reasons recruiters can pick in the reject modal. Omit/null `ids` (or pass an empty list) to clear the filter and show every reason. Persists on the gateway-side integration row. Returns the post-update canonical Settings. */
  setAtsAllowedRejectionReasonIds: AtsSettingsGqlModel;
  /** Toggle whether ATS applications are surfaced in SZ for a company. Maps to the Miro "Application tracking on/off" setting. Persists on the gateway-side integration row; survives restarts. Returns the post-update canonical Settings. */
  setAtsApplicationTrackingEnabled: AtsSettingsGqlModel;
  /** Toggle whether Online Assessment results are pushed back to the ATS as an application result link when a result completes ("Result link + order" when enabled, "Assessment order only" when disabled). Order-closing is unchanged in both options. Opt-in (defaults to disabled). Persists on the gateway-side integration row; survives restarts. Returns the post-update canonical Settings. */
  setAtsAssessmentResultsEnabled: AtsSettingsGqlModel;
  /** Set when SZ materialises candidates from ATS applications: ALL pulls every applicant on a linked job (the legacy default), MAPPED_STAGES creates candidates only when their application enters a mapped ATS stage. Persists on the gateway-side integration row. Returns the post-update canonical Settings. */
  setAtsCandidatePullMode: AtsSettingsGqlModel;
  /** Toggle whether the ATS hiring-team sync may grant SZ access for a company (create accounts for unmatched members and add users of other companies to this one). When disabled, only members who are already users of this company are added to the role team; everyone else is skipped and logged, and gets added by a later sync once an admin makes them a company user. Defaults to enabled. Persists on the gateway-side integration row. Returns the post-update canonical Settings. */
  setAtsHiringTeamUserProvisioningEnabled: AtsSettingsGqlModel;
  /** Toggle whether Interview Evaluation results are pushed back to the ATS as an application result link on submit. Opt-in (defaults to disabled). Persists on the gateway-side integration row; survives restarts. Returns the post-update canonical Settings. */
  setAtsInterviewEvaluationResultsEnabled: AtsSettingsGqlModel;
  /** Toggle rejection write-back for a company: SZ rejections are mirrored to the ATS. Persists on the gateway-side integration row; survives restarts. Returns the post-update canonical Settings. */
  setAtsProgressionEnabled: AtsSettingsGqlModel;
  /** Set the ATS user remote ID outbound rejections are performed on behalf of (Workable integrations only at send time — sent as remote_fields.workable.on_behalf_of_user_remote_id so Workable-side rejection automations key off a real user). Omit/null (or blank, normalised gateway-side) to clear. Persists on the gateway-side integration row. Returns the post-update canonical Settings. */
  setAtsRejectOnBehalfOfUserRemoteId: AtsSettingsGqlModel;
  /** Update per-result-type result delivery config in one call: the order-result switch, the result-link switch, and each tool's passthrough switch plus its field mapping (iCIMS custom fields via sendToAtsFields/fieldIds, Workday custom objects via sendToWorkdayObjects/objectAlias/fieldAliases). Entries are partial per result type; a provided fieldIds or fieldAliases object replaces that type's mapping wholesale (blank values clear), while toggling a switch off leaves the mapping stored. iCIMS keys are rejected for non-iCIMS integrations and Workday keys for non-Workday ones; sendAssessmentOrder is rejected for AI_SHORTLIST and INTERVIEW_EVALUATION (no orders). completionStageRef names the ATS stage a completed application is moved to; send null or blank to clear it, and note it is rejected for AI_SHORTLIST and INTERVIEW_EVALUATION and when it names a stage already used in the stage map. Returns the post-update canonical Settings. */
  setAtsResultPushConfig: AtsSettingsGqlModel;
  /** Replace the per-tenant ATS stage map wholesale. Each entry pairs an SZ stage type with a provider-native ATS stage ref (plus Workday step ids, one per process variant, on Workday integrations). Omit/null `entries` (or pass an empty list) to clear the map. The gateway validates the whole list before any write — unknown stage types, duplicate types, a step id under two stage types, two step-less entries on one ref and non-Workday step ids are rejected with no partial write. Returns the post-update canonical Settings. */
  setAtsStageMap: AtsSettingsGqlModel;
  /** Toggle progression write-back for a company: SZ stage moves into mapped stage types are mirrored to the ATS (outbound move-to-stage), mapped Offer included. Off keeps that direction one-way — the ATS drives, SZ reacts. Opt-in (defaults to disabled). Persists on the gateway-side integration row. Returns the post-update canonical Settings. */
  setAtsStagePushEnabled: AtsSettingsGqlModel;
  /** Replace the per-stage rejection reasons wholesale: for each ATS stage, the rejection reasons valid there. Keyed by any stage in atsAllStages, not only mapped ones; stages can be left out. Omit/null `entries` (or pass an empty list) to clear it. Workday integrations only, since only Workday rejects a reason that is invalid for the stage. The gateway validates the whole list before any write — duplicate stages and blank or repeated reason ids are rejected with no partial write. Reasons outside the global allow-list are accepted (they are simply never offered). Returns the post-update canonical Settings. */
  setAtsStageRejectionReasons: AtsSettingsGqlModel;
  /** Stores the password for the workspace's Coderbyte admin account. Coderbyte emails a temporary one on creation which must be reset there first; record the working password here. A workspace only becomes active once it has both this and an API key. */
  setCoderbyteWorkspaceAdminPassword: CoderbyteWorkspace;
  /** Stores the workspace API key and brings the workspace into service. The key is proved against Coderbyte before being written, so a mistyped paste is rejected here rather than weeks later. Write-only — the key is never readable back through the API. */
  setCoderbyteWorkspaceApiKey: CoderbyteWorkspace;
  setIndirectInviteSSO: Scalars['Boolean'];
  setIntegrityMonitoringSessionVerdict: IntegrityMonitoringSession;
  setProjectCobranding: Scalars['Boolean'];
  startAiInterviewIntegrityMonitoringSession: IntegrityMonitoringSession;
  startCoderbyteAssessment: CoderbyteAssessmentStageActionCandidateStart;
  startCognitiveTestAssessment: CognitiveTestAssessmentStageActionCandidate;
  startCognitiveTestIntegrityMonitoringSession: IntegrityMonitoringSession;
  startCognitiveTestPracticeAssessment: CognitiveTestPracticeAssessment;
  startEditingQuestion: EditingResultModel;
  startEnglishProficiencyAssessment: EnglishProficiencyAssessmentStageActionCandidate;
  startEnglishProficiencyIntegrityMonitoringSession: IntegrityMonitoringSession;
  startOrgCalendarConsent: OrgCalendarConsentStartModel;
  startPersonalityTestAssessment: PersonalityTestAssessmentStageActionCandidate;
  startPersonalityTestIntegrityMonitoringSession: IntegrityMonitoringSession;
  stopEditingQuestion: Scalars['Boolean'];
  submitAiInterviewFeedback: AiInterviewAssessmentStageActionCandidate;
  submitEnglishProficiencyAssessment: Scalars['Boolean'];
  /** Translates the conference transcript into the given locale, populating each utterance with the translated text. No-op for utterances that already have it. */
  translateConferenceTranscript: Conference;
  /** Re-runs the canonical ATS pipeline (materialise project candidate + download CV + upload to the project's first shortlist stage) for a single application, identified by its canonical SDK id. Force-uploads the CV even when the project candidate already has a resume; use this to repair candidates that hit the link race or the swallowed-error CV upload failure. Idempotent on materialise; potentially destructive only via shortlist stage resume (which keeps version history). */
  triggerAtsCvUploadForApplication: TriggerAtsCvUploadForApplicationResultModel;
  unarchiveAssessmentStageDeiAction: DeiStageActionModel;
  updateAiInterviewActionStageAction: AiInterviewAssessmentStageAction;
  updateAiInterviewAssessmentStageActionIsAvatarEnabled: AiInterviewAssessmentStageAction;
  updateAiInterviewAssessmentStageActionIsTimingAgentEnabled: AiInterviewAssessmentStageAction;
  updateAiInterviewAssessmentStageActionLivekitAgentName: AiInterviewAssessmentStageAction;
  /** Saves the hiring team's note on an AI interview. An empty note clears it. */
  updateAiInterviewCandidateNote: AiInterviewAssessmentStageActionCandidate;
  updateAssessmentStage: AssessmentStage;
  updateAssessmentStageEmailSettings: AssessmentStage;
  updateCoderbyteAssessmentTechnicalSkills: CoderbyteAssessmentStageAction;
  updateCoderbyteAssessmentTimeAllowance: CoderbyteAssessmentStageActionCandidate;
  updateCognitiveTestSectionCount: CognitiveTestAssessmentStageAction;
  updateCognitiveTestTimeAllowance: CognitiveTestAssessmentStageActionCandidate;
  updateCompany: Company;
  updateEnglishProficiencyRequiredCefrLevel: EnglishProficiencyAssessmentStageAction;
  updateIdentityPassword: Scalars['Boolean'];
  /** Adds or removes interviewers on a booked interview without moving it; the candidate is not told */
  updateInterviewPanel: UpdateInterviewPanelResultModel;
  updateMyLocalePreference: User;
  updatePersonalityTestQuestionsPerTraitCount: PersonalityTestAssessmentStageAction;
  updatePersonalityTestSelectedLocales: PersonalityTestAssessmentStageAction;
  updateStageScoringConfig: SmStageModel;
  uploadCompanyLogo: Scalars['String'];
  uploadFile: UploadResult;
  upsertAssessmentStageDeiAction: DeiStageActionModel;
  /** Re-checks the stored key against Coderbyte and stamps keyVerifiedAt on success. Never suspends the workspace on failure — a revoked key and a network blip are indistinguishable, so that stays a human decision. */
  verifyCoderbyteWorkspaceApiKey: CoderbyteWorkspace;
};


export type MutationAdminBackfillParticipantUserIdsArgs = {
  batchSize?: InputMaybe<Scalars['Int']>;
};


export type MutationAdminResultsCsvFileExportArgs = {
  exportLevel?: InputMaybe<AdminResultsExportLevel>;
  includeDeiData?: InputMaybe<Scalars['Boolean']>;
  includeFormsData?: InputMaybe<Scalars['Boolean']>;
  lastDateOfCandidateActionFrom?: InputMaybe<Scalars['Date']>;
  lastDateOfCandidateActionTo?: InputMaybe<Scalars['Date']>;
  scoreType?: InputMaybe<AdminResultsExportScoreType>;
  stageIds: Array<Scalars['Int']>;
};


export type MutationAdminSendMeetingSummaryEmailsArgs = {
  meetingIds?: InputMaybe<Array<Scalars['String']>>;
  participantEmails?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationAiInterviewConsentDeclineArgs = {
  aiInterviewAssessmentStageActionCandidateId: Scalars['ID'];
};


export type MutationAiInterviewConsentGiveArgs = {
  aiInterviewAssessmentStageActionCandidateId: Scalars['ID'];
};


export type MutationAnswerCreateArgs = {
  associatedId: Scalars['Int'];
  fieldId: Scalars['Int'];
  formId: Scalars['Int'];
  respondantId: Scalars['Int'];
  response: Scalars['String'];
};


export type MutationAnswerDeleteArgs = {
  id: Scalars['Int'];
};


export type MutationAnswerUpdateArgs = {
  associatedId?: InputMaybe<Scalars['Int']>;
  fieldId?: InputMaybe<Scalars['Int']>;
  formId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  respondantId?: InputMaybe<Scalars['Int']>;
  response?: InputMaybe<Scalars['String']>;
};


export type MutationApiKeyCompanyDisableArgs = {
  companyId: Scalars['Int'];
  permission?: InputMaybe<IdentityPermissionRole>;
};


export type MutationApiKeyCompanyGenerateArgs = {
  companyId: Scalars['Int'];
  permission: IdentityPermissionRole;
};


export type MutationApiKeyDisableArgs = {
  key: Scalars['String'];
};


export type MutationApiKeyDisableUserArgs = {
  userEmail?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Int']>;
  userSubId?: InputMaybe<Scalars['String']>;
};


export type MutationApiKeyUserGenerateArgs = {
  userEmail?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Int']>;
  userSubId?: InputMaybe<Scalars['String']>;
};


export type MutationApiUserCreateOneArgs = {
  companyId: Scalars['Int'];
  hasClientSecret?: InputMaybe<Scalars['Boolean']>;
  ownerId: Scalars['Int'];
  ownerType: ApiUserOwnerType;
};


export type MutationApiUserResetClientSecretArgs = {
  clientId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  hasClientSecret?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  ownerId?: InputMaybe<Scalars['Int']>;
  ownerType?: InputMaybe<ApiUserOwnerType>;
  puppetUserId?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};


export type MutationApiUserUpdateOneArgs = {
  clientId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  hasClientSecret?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  ownerId?: InputMaybe<Scalars['Int']>;
  ownerType?: InputMaybe<ApiUserOwnerType>;
  puppetUserId?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};


export type MutationArchiveHiringProcessTemplateArgs = {
  id: Scalars['Int'];
};


export type MutationArchiveSkillsProfileTemplateArgs = {
  id: Scalars['Int'];
};


export type MutationBehaviourContentCreateOneArgs = {
  behaviourId: Scalars['Int'];
  negativeSummary: Scalars['String'];
  positiveSummary: Scalars['String'];
  roleLevel?: InputMaybe<ContentRoleLevel>;
};


export type MutationBehaviourContentDeleteOneArgs = {
  behaviourId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  negativeSummary?: InputMaybe<Scalars['String']>;
  positiveSummary?: InputMaybe<Scalars['String']>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
};


export type MutationBehaviourContentUpdateOneArgs = {
  behaviourId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  negativeSummary?: InputMaybe<Scalars['String']>;
  positiveSummary?: InputMaybe<Scalars['String']>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
};


export type MutationBehaviourCreateOneArgs = {
  contextIds?: InputMaybe<Array<Scalars['Int']>>;
  internalName: Scalars['String'];
};


export type MutationBehaviourDeleteOneArgs = {
  contextIds?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['Int']>;
  internalName?: InputMaybe<Scalars['String']>;
};


export type MutationBehaviourFromCsvRowsCreateManyArgs = {
  dto: Array<BehaviourFromCsvRowsCreateManyArgs>;
};


export type MutationBehaviourUpdateOneArgs = {
  contextIds?: InputMaybe<Array<Scalars['Int']>>;
  id: Scalars['Int'];
  internalName?: InputMaybe<Scalars['String']>;
};


export type MutationBulkUpdateCandidateShortlistArgs = {
  ids: Array<Scalars['ID']>;
  isShortlisted: Scalars['Boolean'];
};


export type MutationCalibrationFileUploadArgs = {
  apply: Scalars['Boolean'];
  args: CalibrationFileUploadArgs;
  file: Scalars['Upload'];
};


export type MutationCandidateAcceptIndirectInvitationArgs = {
  hiringManagers?: InputMaybe<Array<HiringManager>>;
  stageId: Scalars['Int'];
};


export type MutationCandidateFeedbackGenerateOneV2Args = {
  interviewEvaluationId: Scalars['String'];
};


export type MutationCandidateFeedbackUpdateOneV2Args = {
  id: Scalars['String'];
  payload: Scalars['String'];
};


export type MutationCandidateInterviewGuideConfirmArgs = {
  subId: Scalars['ID'];
};


export type MutationCandidateInterviewGuideCreateArgs = {
  interviewGuideBlueprintId: Scalars['Int'];
  interviewStageCandidateId: Scalars['Int'];
};


export type MutationCandidateInterviewGuidePopulateAssessmentQuestionArgs = {
  subId: Scalars['ID'];
};


export type MutationCandidateInterviewGuideQuestionCreateOneArgs = {
  candidateInterviewGuideId: Scalars['Int'];
  content?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Int']>;
  extraContent?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<CandidateInterviewGuideQuestionCreateQuestionType>;
};


export type MutationCandidateInterviewGuideQuestionDeleteOneArgs = {
  subId: Scalars['ID'];
};


export type MutationCandidateInterviewGuideQuestionGenerateArgs = {
  guideSubId: Scalars['ID'];
  position?: InputMaybe<Scalars['Int']>;
  skills: Array<Scalars['String']>;
  subtype: InterviewGuideBlueprintQuestionSubtype;
};


export type MutationCandidateInterviewGuideQuestionRegenerateArgs = {
  subId: Scalars['String'];
};


export type MutationCandidateInterviewGuideQuestionReorderArgs = {
  fromPosition: Scalars['Int'];
  subId: Scalars['String'];
  toPosition: Scalars['Int'];
};


export type MutationCandidateInterviewGuideQuestionUpdateOneArgs = {
  data: CandidateInterviewGuideQuestionUpdateData;
  subId: Scalars['String'];
};


export type MutationCandidateInterviewGuideRegenerateArgs = {
  subId: Scalars['String'];
};


export type MutationCandidateInterviewGuideRequestPdfArgs = {
  candidateInterviewGuideSubId: Scalars['String'];
};


export type MutationCandidateInviteManyArgs = {
  settings: ProjectCandidateInvitationSettings;
  stageInviteSettings: CandidateStageInviteSettings;
  userDetails: Array<ProjectCandidateUserDetails>;
};


export type MutationClientAuthenticateArgs = {
  clientType?: InputMaybe<ClientType>;
  email: Scalars['String'];
  mfaCookie?: InputMaybe<Array<Scalars['String']>>;
  password: Scalars['String'];
  workspaceId?: InputMaybe<Scalars['Int']>;
};


export type MutationClientMfaAuthenticateArgs = {
  mfaAccessToken: Scalars['String'];
  mfaCode: Scalars['String'];
};


export type MutationClientRegisterAccountArgs = {
  companyId?: InputMaybe<Scalars['Float']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  invitationToken?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Language>;
  lastName: Scalars['String'];
  locale?: InputMaybe<SupportedLocale>;
  password: Scalars['String'];
  projectId?: InputMaybe<Scalars['Float']>;
};


export type MutationCompanyAllowedEmailDomainsUpdateArgs = {
  allowedEmailDomains: Array<Scalars['String']>;
  id: Scalars['Int'];
};


export type MutationCompanyBrandingUpsertArgs = {
  accentColor1?: InputMaybe<Scalars['String']>;
  accentColor2?: InputMaybe<Scalars['String']>;
  careersLinkUrl?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  signInBackgroundUrl?: InputMaybe<Scalars['String']>;
  textColor?: InputMaybe<Scalars['String']>;
  websiteLinkUrl?: InputMaybe<Scalars['String']>;
};


export type MutationCompanyConsentCaptureUpdateArgs = {
  consentText?: InputMaybe<Scalars['String']>;
  explicitConsentEmail?: InputMaybe<Scalars['String']>;
  isEnabled: Scalars['Boolean'];
};


export type MutationCompanyCreateUserArgs = {
  companyId: Scalars['Float'];
  email: Scalars['String'];
  externalId?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Language>;
  lastName?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<SupportedLocale>;
  role?: InputMaybe<IdentityPermissionRole>;
  roles?: InputMaybe<Array<IdentityPermissionRole>>;
  sendInvite: Scalars['Boolean'];
};


export type MutationCompanyEmployeeCreateArgs = {
  companyId: Scalars['Int'];
  customFields?: InputMaybe<UserCompanyInfoCustomFieldsArgs>;
  department?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  employeeId: Scalars['String'];
  endDate?: InputMaybe<Scalars['Date']>;
  firstName: Scalars['String'];
  hrManagerEmployeeId?: InputMaybe<Scalars['String']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  startDate?: InputMaybe<Scalars['Date']>;
};


export type MutationCompanyEmployeeDeleteOneArgs = {
  id: Scalars['Int'];
};


export type MutationCompanyEmployeeFileUploadArgs = {
  apply: Scalars['Boolean'];
  args: CompanyEmployeeFileUploadArgs;
  file: Scalars['Upload'];
};


export type MutationCompanyEmployeeSyncWithUserCompanyInfoArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  customFields?: InputMaybe<UserCompanyInfoCustomFieldsArgs>;
  department?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeId?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['String']>>;
  endDate?: InputMaybe<Scalars['Date']>;
  firstName?: InputMaybe<Scalars['String']>;
  hrManagerEmployeeId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Date']>;
};


export type MutationCompanyEmployeeUpdateArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  customFields?: InputMaybe<UserCompanyInfoCustomFieldsArgs>;
  department?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Date']>;
  firstName?: InputMaybe<Scalars['String']>;
  hrManagerEmployeeId?: InputMaybe<Scalars['String']>;
  id: Scalars['Float'];
  isArchived?: InputMaybe<Scalars['Boolean']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Date']>;
};


export type MutationCompanyMeetingConfigurationCreateOneArgs = {
  metadata: MeetingMetadataArgs;
};


export type MutationCompanyMeetingConfigurationUpdateOneArgs = {
  metadata: MeetingMetadataArgs;
};


export type MutationCompanyRemoveUserArgs = {
  companyId: Scalars['Int'];
  userId: Scalars['Int'];
};


export type MutationCompanyResendInviteArgs = {
  companyId: Scalars['Float'];
  userId: Scalars['Float'];
};


export type MutationCompanyRoleUpsertArgs = {
  companyId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  isPasswordDisabled?: InputMaybe<Scalars['Boolean']>;
  roleId: Scalars['Int'];
  samlAuthInfoIds?: InputMaybe<Array<Scalars['Int']>>;
  twoFactorEnabled?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCompanySignatureCreateOneArgs = {
  companyId: Scalars['Int'];
  isDefault: Scalars['Boolean'];
  signature: Scalars['String'];
  signatureEmail: Scalars['String'];
};


export type MutationCompanySignatureDeleteOneArgs = {
  id: Scalars['Int'];
};


export type MutationCompanySignatureSoftDeleteOneArgs = {
  id: Scalars['Int'];
};


export type MutationCompanySignatureUpdateOneArgs = {
  id: Scalars['Int'];
  isDefault?: InputMaybe<Scalars['Boolean']>;
  signature?: InputMaybe<Scalars['String']>;
  signatureEmail?: InputMaybe<Scalars['String']>;
};


export type MutationCompanyStageCandidateDeleteOneArgs = {
  subId: Scalars['String'];
};


export type MutationCompanyUpdateUserRoleArgs = {
  companyId: Scalars['Int'];
  newRole: IdentityPermissionRole;
  userId: Scalars['Int'];
};


export type MutationContentStageCandidateMarkCompleteArgs = {
  contentStageCandidateId: Scalars['Int'];
};


export type MutationCreateAssessmentBrowserSwitchCandidateTrackingEventArgs = {
  assessmentId?: InputMaybe<Scalars['Int']>;
  assessmentSubId?: InputMaybe<Scalars['String']>;
  assessmentTimeSeconds?: InputMaybe<Scalars['Int']>;
  type: AssessmentBrowserSwitchCandidateTrackingEvent;
};


export type MutationCreateCompanyUserArgs = {
  companyId: Scalars['Float'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  roles: Array<IdentityPermissionRole>;
};


export type MutationCreateHiringProcessTemplateArgs = {
  description: Scalars['String'];
  fixed?: Scalars['Boolean'];
  name: Scalars['String'];
  stages: Array<HiringProcessTemplateStageInput>;
};


export type MutationCreateHiringProcessTemplateVersionArgs = {
  fixed?: Scalars['Boolean'];
  stages: Array<HiringProcessTemplateStageInput>;
  templateId: Scalars['Int'];
};


export type MutationCreateInterviewGuideBlueprintsForInterviewStageArgs = {
  interviewStageId: Scalars['Float'];
};


export type MutationCreateInterviewGuideBlueprintsForProjectJobRoleArgs = {
  projectJobRoleId: Scalars['Float'];
};


export type MutationCreateSkillsProfileTemplateArgs = {
  description: Scalars['String'];
  fixed?: Scalars['Boolean'];
  name: Scalars['String'];
  softSkills: Array<SkillsProfileTemplateSkillInput>;
  technicalSkills: Array<SkillsProfileTemplateSkillInput>;
};


export type MutationCreateSkillsProfileTemplateVersionArgs = {
  fixed?: Scalars['Boolean'];
  softSkills: Array<SkillsProfileTemplateSkillInput>;
  technicalSkills: Array<SkillsProfileTemplateSkillInput>;
  templateId: Scalars['Int'];
};


export type MutationDeiStageActionArchiveArgs = {
  stageId: Scalars['Int'];
};


export type MutationDeiStageActionCandidateClearAllForCandidateArgs = {
  userId: Scalars['Int'];
};


export type MutationDeiStageActionCandidateDeclineConsentArgs = {
  stageCandidateId: Scalars['Int'];
};


export type MutationDeiStageActionCandidateGiveConsentArgs = {
  stageCandidateId: Scalars['Int'];
};


export type MutationDeiStageActionCandidateReopenArgs = {
  stageCandidateId: Scalars['Int'];
};


export type MutationDeiStageActionCandidateRevokeConsentArgs = {
  stageCandidateId: Scalars['Int'];
};


export type MutationDeiStageActionCandidateSubmitResponsesArgs = {
  responses: DeiStageActionCandidateResponsesInput;
  stageCandidateId: Scalars['Int'];
};


export type MutationDeiStageActionTemplateUpsertArgs = {
  companyId: Scalars['Int'];
  fields: DeiStageActionTemplateFieldsInput;
};


export type MutationDeiStageActionUnarchiveArgs = {
  fields?: InputMaybe<DeiStageActionFieldsInput>;
  stageId: Scalars['Int'];
};


export type MutationDeiStageActionUpsertArgs = {
  fields: DeiStageActionFieldsInput;
  stageId: Scalars['Int'];
};


export type MutationDeleteMonolithBlobArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteShortlistStageResumeArgs = {
  resumeSubId: Scalars['ID'];
};


export type MutationE2eCookieArgs = {
  email: Scalars['String'];
};


export type MutationExchangeAuthCodeArgs = {
  authCode: Scalars['String'];
  clientType?: InputMaybe<ClientType>;
  workspaceId?: InputMaybe<Scalars['Int']>;
};


export type MutationFieldCreateArgs = {
  fieldInstanceType: FieldInstanceType;
  fieldOwnerId?: InputMaybe<Scalars['Int']>;
  fieldOwnerType: FieldOwnerType;
  fieldType: FieldType;
  formManagerType: FormManagerType;
  hint?: InputMaybe<Scalars['String']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  question?: InputMaybe<Scalars['String']>;
  selectOptions?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<FieldSettingsArgs>;
};


export type MutationFieldDeleteArgs = {
  id: Scalars['Int'];
};


export type MutationFieldUpdateArgs = {
  hint?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  isArchived?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  question?: InputMaybe<Scalars['String']>;
  selectOptions?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<FieldSettingsArgs>;
};


export type MutationFormAddFieldArgs = {
  displayOrder?: InputMaybe<Scalars['Int']>;
  fieldId: Scalars['Int'];
  formId: Scalars['Int'];
  isOptional: Scalars['Boolean'];
};


export type MutationFormBuilderCreateArgs = {
  addFields?: InputMaybe<Array<CreateFormFieldByFieldIdArgs>>;
  formManagerType: FormManagerType;
  formOwnerId: Scalars['Int'];
  formType: FormType;
  name: Scalars['String'];
};


export type MutationFormBuilderUpdateArgs = {
  addFields?: InputMaybe<Array<CreateFormFieldByFieldIdArgs>>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  removeFields?: InputMaybe<Array<DeleteFormFieldByFieldIdArgs>>;
  updateFields?: InputMaybe<Array<UpdateFormFieldByFieldIdArgs>>;
};


export type MutationFormCreateArgs = {
  formManagerType: FormManagerType;
  formOwnerId: Scalars['Int'];
  formType: FormType;
  name: Scalars['String'];
};


export type MutationFormDeleteArgs = {
  id: Scalars['Int'];
};


export type MutationFormFieldRemoveArgs = {
  fieldId: Scalars['Int'];
  formId: Scalars['Int'];
};


export type MutationFormFieldUpdateArgs = {
  displayOrder?: InputMaybe<Scalars['Int']>;
  formFieldId?: InputMaybe<Scalars['Int']>;
  formId?: InputMaybe<Scalars['Int']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
};


export type MutationFormUpdateArgs = {
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
};


export type MutationGenerateRspArgs = {
  subId: Scalars['ID'];
};


export type MutationIdentityProviderCreateOneArgs = {
  name: Scalars['String'];
};


export type MutationIdentityProviderDeleteOneArgs = {
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  subId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};


export type MutationIdentityProviderRestoreOneArgs = {
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  subId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};


export type MutationIdentityProviderSoftDeleteOneArgs = {
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  subId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};


export type MutationIdentityProviderUpdateOneArgs = {
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
};


export type MutationInitializeShortlistCalibrationBorderlineQuestionsArgs = {
  subId: Scalars['ID'];
};


export type MutationInterviewAutosuggestionUpdateOneV2Args = {
  id: Scalars['String'];
  isAccepted?: InputMaybe<Scalars['Boolean']>;
};


export type MutationInterviewDecisionCreateOneV2Args = {
  interviewEvaluationId: Scalars['String'];
  recommendedDecision: InterviewRecommendedDecision;
};


export type MutationInterviewDecisionDeleteOneV2Args = {
  id: Scalars['String'];
};


export type MutationInterviewDecisionUpdateOneV2Args = {
  id: Scalars['String'];
  recommendedDecision: InterviewRecommendedDecision;
};


export type MutationInterviewDeleteOneV2Args = {
  id: Scalars['String'];
};


export type MutationInterviewEvaluationSubmitArgs = {
  id: Scalars['String'];
  status: InterviewEvaluationStatus;
};


export type MutationInterviewGuideBlueprintPublishArgs = {
  subId: Scalars['ID'];
};


export type MutationInterviewGuideBlueprintQuestionAddSoftSkillArgs = {
  indicators?: InputMaybe<Array<SoftSkillIndicatorInput>>;
  questionSubId: Scalars['String'];
  softSkillId: Scalars['Int'];
};


export type MutationInterviewGuideBlueprintQuestionCreateArgs = {
  blueprintId: Scalars['Int'];
  content?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Int']>;
  extraContent?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  subtype?: InputMaybe<InterviewGuideBlueprintQuestionSubtype>;
  type?: InputMaybe<InterviewGuideBlueprintQuestionCreateQuestionType>;
};


export type MutationInterviewGuideBlueprintQuestionDeleteArgs = {
  subId: Scalars['ID'];
};


export type MutationInterviewGuideBlueprintQuestionGenerateArgs = {
  blueprintId: Scalars['Int'];
  position?: InputMaybe<Scalars['Int']>;
  skills: Array<Scalars['String']>;
  subtype: InterviewGuideBlueprintQuestionSubtype;
};


export type MutationInterviewGuideBlueprintQuestionRegenerateArgs = {
  subId: Scalars['String'];
};


export type MutationInterviewGuideBlueprintQuestionRemoveSoftSkillArgs = {
  questionSubId: Scalars['String'];
  softSkillId: Scalars['Int'];
};


export type MutationInterviewGuideBlueprintQuestionReorderArgs = {
  fromPosition: Scalars['Int'];
  subId: Scalars['String'];
  toPosition: Scalars['Int'];
};


export type MutationInterviewGuideBlueprintQuestionRetryArgs = {
  subId: Scalars['String'];
};


export type MutationInterviewGuideBlueprintQuestionUpdateArgs = {
  data: InterviewGuideBlueprintQuestionUpdateData;
  subId: Scalars['String'];
};


export type MutationInterviewGuideBlueprintQuestionUpdateSoftSkillArgs = {
  indicators: Array<SoftSkillIndicatorInput>;
  questionSubId: Scalars['String'];
  softSkillId: Scalars['Int'];
};


export type MutationInterviewGuideBlueprintRegenerateQuestionsArgs = {
  duration?: InputMaybe<Scalars['Int']>;
  subId: Scalars['String'];
};


export type MutationInterviewGuideContentTemplateUpsertArgs = {
  introContent?: InputMaybe<Scalars['String']>;
  updateExistingIntroFieldsInGuides?: InputMaybe<Scalars['Boolean']>;
  updateExistingWrapUpFieldsInGuides?: InputMaybe<Scalars['Boolean']>;
  wrapUpContent?: InputMaybe<Scalars['String']>;
};


export type MutationInterviewQuestionRoleLevelContentUpdateArgs = {
  feedback?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  mainQuestion?: InputMaybe<Scalars['String']>;
  reasonForQuestion?: InputMaybe<Scalars['String']>;
  subQuestions?: InputMaybe<Array<Scalars['String']>>;
  summary?: InputMaybe<Scalars['String']>;
};


export type MutationInterviewQuestionRoleLevelContentUploadArgs = {
  file: Scalars['Upload'];
};


export type MutationInterviewStageDeleteArgs = {
  subId: Scalars['ID'];
};


export type MutationInterviewStageUpdateArgs = {
  data: InterviewStageUpdateData;
  subId: Scalars['ID'];
};


export type MutationInterviewStageUpdateDurationArgs = {
  duration: Scalars['Int'];
  subId: Scalars['ID'];
};


export type MutationInterviewUpdateOneV2Args = {
  id: Scalars['String'];
  linkedInterviewStageCandidateId?: InputMaybe<Scalars['Int']>;
  linkedProjectJobRoleId?: InputMaybe<Scalars['Int']>;
  meetingId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  projectCandidateSubId?: InputMaybe<Scalars['String']>;
  stageCandidateId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<InterviewV2Status>;
};


export type MutationInvitationCreateArgs = {
  companyId: Scalars['Int'];
  email?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['Date']>;
  firstName?: InputMaybe<Scalars['String']>;
  invitationType: InvitationType;
  language?: InputMaybe<Language>;
  lastActionType?: InputMaybe<InvitationLastActionType>;
  lastName?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<SupportedLocale>;
  projectSubId?: InputMaybe<Scalars['String']>;
  shouldCreateAccount?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<InvitationStatusCode>;
  targetId: Scalars['Int'];
};


export type MutationInvitationDeleteManyArgs = {
  ids: Array<Scalars['Int']>;
};


export type MutationInvitationDeleteOneArgs = {
  id: Scalars['Int'];
};


export type MutationInvitationUpdateArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['Date']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  invitationType?: InputMaybe<InvitationType>;
  language?: InputMaybe<Language>;
  lastActionType?: InputMaybe<InvitationLastActionType>;
  lastName?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<SupportedLocale>;
  projectSubId?: InputMaybe<Scalars['String']>;
  shouldCreateAccount?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<InvitationStatusCode>;
  targetId?: InputMaybe<Scalars['Int']>;
};


export type MutationJobRoleCreateOneArgs = {
  companyId: Scalars['Int'];
  family?: InputMaybe<JobRoleFamily>;
  name: Scalars['String'];
  qualifier?: InputMaybe<Scalars['String']>;
  roleLevel: ContentRoleLevel;
  source?: InputMaybe<JobRoleSource>;
};


export type MutationJobRoleDeleteOneArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  family?: InputMaybe<JobRoleFamily>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nameOrQualifierContains?: InputMaybe<Scalars['String']>;
  qualifier?: InputMaybe<Scalars['String']>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
  subId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};


export type MutationJobRoleDuplicateArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  family?: InputMaybe<JobRoleFamily>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nameOrQualifierContains?: InputMaybe<Scalars['String']>;
  qualifier?: InputMaybe<Scalars['String']>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
  subId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};


export type MutationJobRoleSoftDeleteOneArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  family?: InputMaybe<JobRoleFamily>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nameOrQualifierContains?: InputMaybe<Scalars['String']>;
  qualifier?: InputMaybe<Scalars['String']>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
  subId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};


export type MutationJobRoleUpdateOneArgs = {
  family?: InputMaybe<JobRoleFamily>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  qualifier?: InputMaybe<Scalars['String']>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
};


export type MutationLocationLinkCreateManyArgs = {
  links: Array<LocationLinkCreateArgs>;
};


export type MutationLocationLinkCreateOneArgs = {
  companyId: Scalars['Int'];
  locationName: Scalars['String'];
  projectId: Scalars['Int'];
  userGroupId: Scalars['Int'];
};


export type MutationLocationLinkDeleteManyArgs = {
  args: LocationLinkDeleteManyArgs;
};


export type MutationMarkCandidateAsHiredArgs = {
  subId: Scalars['ID'];
};


export type MutationMarkCandidatesAsHiredArgs = {
  subIds: Array<Scalars['ID']>;
};


export type MutationMeetingCreateOneArgs = {
  attendees?: Array<CreateMeetingAttendeeArgs>;
  date: Scalars['DateTime'];
  id?: InputMaybe<Scalars['String']>;
  interviewStageCandidateId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  projectCandidateId?: InputMaybe<Scalars['Int']>;
  projectCandidateSubId?: InputMaybe<Scalars['String']>;
  projectJobRoleId?: InputMaybe<Scalars['Int']>;
  recordingConfig?: InputMaybe<Array<RecordingConfigArgs>>;
  status?: MeetingStatus;
  transcriptConfig?: InputMaybe<Array<TranscriptConfigArgs>>;
  type?: MeetingScope;
};


export type MutationMeetingDeleteOneArgs = {
  meetingId: Scalars['String'];
};


export type MutationMeetingGenerateTranslatedTranscriptArgs = {
  id: Scalars['String'];
};


export type MutationMeetingParticipantCreateManyArgs = {
  meetingId: Scalars['ID'];
  participants: Array<MeetingParticipantArgs>;
};


export type MutationMeetingRecordingCompleteUploadArgs = {
  attendees?: Array<CreateMeetingAttendeeArgs>;
  date: Scalars['DateTime'];
  id?: InputMaybe<Scalars['String']>;
  interviewStageCandidateId?: InputMaybe<Scalars['Int']>;
  key: Scalars['String'];
  mediaFormat?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  parts: Array<MultipartCompletedPart>;
  projectCandidateId?: InputMaybe<Scalars['Int']>;
  projectCandidateSubId?: InputMaybe<Scalars['String']>;
  projectJobRoleId?: InputMaybe<Scalars['Int']>;
  status?: MeetingStatus;
  type?: MeetingScope;
  updatedBy?: InputMaybe<Scalars['Int']>;
  uploadId: Scalars['String'];
};


export type MutationMeetingRecordingCreateUploadArgs = {
  mediaFormat: Scalars['String'];
  name: Scalars['String'];
  parts: Scalars['Int'];
};


export type MutationMeetingRecordingDeleteUploadArgs = {
  key: Scalars['String'];
  uploadId: Scalars['String'];
};


export type MutationMeetingSummaryGenerateOneArgs = {
  meetingId: Scalars['String'];
  templateId: Scalars['String'];
};


export type MutationMeetingSummaryUpdateOneArgs = {
  id: Scalars['String'];
  payload: Scalars['String'];
};


export type MutationMeetingTypeCreateOneArgs = {
  description?: InputMaybe<Scalars['String']>;
  keywords?: InputMaybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  scope: MeetingScope;
  templateId: Scalars['String'];
};


export type MutationMeetingTypeUpdateOneArgs = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  keywords?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<MeetingScope>;
  templateId?: InputMaybe<Scalars['String']>;
};


export type MutationMeetingUpdateOneArgs = {
  date?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  interviewStageCandidateId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  projectCandidateId?: InputMaybe<Scalars['Int']>;
  projectCandidateSubId?: InputMaybe<Scalars['String']>;
  projectJobRoleId?: InputMaybe<Scalars['Int']>;
  recordingConfig?: InputMaybe<Array<RecordingConfigArgs>>;
  transcriptConfig?: InputMaybe<Array<TranscriptConfigArgs>>;
  type?: InputMaybe<MeetingScope>;
};


export type MutationMeetingUserCalendarDeleteOneArgs = {
  externalCalendarId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};


export type MutationOverwriteInterviewStageSkillsArgs = {
  id: Scalars['ID'];
  skillsProfileId: Scalars['Int'];
  softSkillIds: Array<Scalars['Int']>;
  technicalSkillIds: Array<Scalars['Int']>;
};


export type MutationProgressCandidateArgs = {
  inviteMethod?: InputMaybe<StageCandidateInviteMethod>;
  stageId: Scalars['Int'];
  stageType: StageType;
  subId: Scalars['ID'];
};


export type MutationProgressCandidatesArgs = {
  deadlineInEmail?: InputMaybe<Scalars['Date']>;
  inviteMethod?: InputMaybe<StageCandidateInviteMethod>;
  stageId: Scalars['Int'];
  stageType: StageType;
  subIds: Array<Scalars['ID']>;
};


export type MutationProjectAddInterviewStageArgs = {
  duration?: Scalars['Int'];
  focus?: InputMaybe<InterviewStageFocus>;
  name: Scalars['String'];
  subId: Scalars['ID'];
};


export type MutationProjectAddShortlistStageArgs = {
  name: Scalars['String'];
  subId: Scalars['ID'];
};


export type MutationProjectArtifactCompleteJobDescriptionUploadArgs = {
  args: ProjectCompleteJobDescriptionUploadArgs;
  projectSubId: Scalars['ID'];
};


export type MutationProjectArtifactDeleteJobDescriptionArgs = {
  projectSubId: Scalars['ID'];
};


export type MutationProjectArtifactInitiateJobDescriptionUploadArgs = {
  args: ProjectInitiateJobDescriptionUploadArgs;
  projectSubId: Scalars['ID'];
};


export type MutationProjectArtifactLinkMeetingArgs = {
  meetingId: Scalars['ID'];
  projectSubId: Scalars['ID'];
};


export type MutationProjectArtifactUnlinkMeetingArgs = {
  projectSubId: Scalars['ID'];
};


export type MutationProjectCandidateDeleteArgs = {
  subId: Scalars['ID'];
};


export type MutationProjectCandidateInviteManyArgs = {
  assessmentInviteSettings?: InputMaybe<ProjectCandidateAssessmentInviteSettings>;
  projectSubId: Scalars['ID'];
  settings: ProjectCandidateInvitationSettings;
  userDetails: Array<ProjectCandidateUserDetails>;
};


export type MutationProjectCandidateInviteToAssessmentArgs = {
  assessmentInviteSettings: ProjectCandidateAssessmentInviteSettings;
  settings: ProjectCandidateInvitationSettingsWithoutAssignees;
  subId: Scalars['ID'];
};


export type MutationProjectCandidateUpdateDeadlineArgs = {
  deadlineAt?: InputMaybe<Scalars['Date']>;
  subId: Scalars['ID'];
};


export type MutationProjectCandidateUpsertAssigneesArgs = {
  args: ProjectCandidateUpsertAssigneesArgs;
  subId: Scalars['ID'];
};


export type MutationProjectCollaboratorsCreateManyArgs = {
  collaborators: Array<ProjectCollaboratorCreateOneArgs>;
};


export type MutationProjectCollaboratorsDeleteManyArgs = {
  collaborators: Array<Scalars['Int']>;
};


export type MutationProjectCollaboratorsUpdateRoleArgs = {
  newActorRole?: InputMaybe<ActorRole>;
  projectTeamMemberId: Scalars['Int'];
};


export type MutationProjectDeleteArgs = {
  id: Scalars['Int'];
};


export type MutationProjectJobRoleCreateOneArgs = {
  isMainRole?: InputMaybe<Scalars['Boolean']>;
  jobRoleId: Scalars['Int'];
  projectId: Scalars['Int'];
  skillsProfileId: Scalars['Int'];
};


export type MutationProjectJobRoleDeleteOneArgs = {
  id: Scalars['Int'];
};


export type MutationProjectJobRoleSetMainArgs = {
  id: Scalars['Int'];
};


export type MutationProjectJobRoleSoftDeleteOneArgs = {
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['Int']>;
  jobRoleId?: InputMaybe<Scalars['Int']>;
  projectId?: InputMaybe<Scalars['Int']>;
  skillsProfileId?: InputMaybe<Scalars['Int']>;
  subId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};


export type MutationProjectRequestCreateOneArgs = {
  approvalRequestDate?: InputMaybe<Scalars['DateTime']>;
  companyId: Scalars['Int'];
  creatorId: Scalars['Int'];
  projectName: Scalars['String'];
  status?: InputMaybe<ProjectRequestStatus>;
};


export type MutationProjectRequestDeleteOneArgs = {
  id: Scalars['Int'];
};


export type MutationProjectRequestFileUploadArgs = {
  args: ProjectRequestFileUploadArgs;
  file: Scalars['Upload'];
};


export type MutationProjectRequestFileUploadDeleteOneArgs = {
  id: Scalars['Int'];
};


export type MutationProjectRequestFileUploadSoftDeleteOneArgs = {
  blobId?: InputMaybe<Scalars['Int']>;
  fileName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  projectRequestId?: InputMaybe<Scalars['Int']>;
};


export type MutationProjectRequestLinkProjectArgs = {
  id: Scalars['Int'];
  projectId: Scalars['Int'];
};


export type MutationProjectRequestRequestJobSpecificationArgs = {
  id: Scalars['Int'];
  projectRequestUserIds: Array<Scalars['Int']>;
};


export type MutationProjectRequestRequestManagerSurveyArgs = {
  id: Scalars['Int'];
  projectRequestUserIds: Array<Scalars['Int']>;
  surveyLink: Scalars['String'];
};


export type MutationProjectRequestRestoreOneArgs = {
  approvalRequestDate?: InputMaybe<Scalars['DateTime']>;
  companyId?: InputMaybe<Scalars['Int']>;
  creatorId?: InputMaybe<Scalars['Int']>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']>;
  managerSurveyId?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['Int']>;
  projectName?: InputMaybe<Scalars['String']>;
  relationDepth?: InputMaybe<RelationDepth>;
  status?: InputMaybe<ProjectRequestStatus>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type MutationProjectRequestSoftDeleteOneArgs = {
  approvalRequestDate?: InputMaybe<Scalars['DateTime']>;
  companyId?: InputMaybe<Scalars['Int']>;
  creatorId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  managerSurveyId?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['Int']>;
  projectName?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ProjectRequestStatus>;
};


export type MutationProjectRequestUpdateManagerSurveyArgs = {
  id: Scalars['Int'];
  managerSurveyId: Scalars['String'];
};


export type MutationProjectRequestUpdateOneArgs = {
  approvalRequestDate?: InputMaybe<Scalars['DateTime']>;
  companyId?: InputMaybe<Scalars['Int']>;
  creatorId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  managerSurveyId?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['Int']>;
  projectName?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ProjectRequestStatus>;
};


export type MutationProjectRequestUserApprovalCreateManyArgs = {
  dto: Array<IProjectRequestUserApprovalCreateOneArgs>;
};


export type MutationProjectRequestUserApprovalCreateOneArgs = {
  approvalRequestDate?: InputMaybe<Scalars['DateTime']>;
  approvalStatus?: InputMaybe<ProjectRequestUserApprovalStatus>;
  projectRequestUserId: Scalars['Int'];
};


export type MutationProjectRequestUserApprovalDeleteOneArgs = {
  id: Scalars['Int'];
};


export type MutationProjectRequestUserApprovalSoftDeleteOneArgs = {
  approvalRequestDate?: InputMaybe<Scalars['DateTime']>;
  approvalStatus?: InputMaybe<ProjectRequestUserApprovalStatus>;
  id?: InputMaybe<Scalars['Int']>;
};


export type MutationProjectRequestUserApprovalUpdateManyArgs = {
  dto: Array<IProjectRequestUserApprovalUpdateOneArgs>;
};


export type MutationProjectRequestUserApprovalUpdateOneArgs = {
  approvalRequestDate?: InputMaybe<Scalars['DateTime']>;
  approvalStatus?: InputMaybe<ProjectRequestUserApprovalStatus>;
  id: Scalars['Int'];
};


export type MutationProjectRequestUserCreateManyArgs = {
  dto: Array<IProjectRequestUserCreateOneWithEmployeeCheckArgs>;
};


export type MutationProjectRequestUserCreateOneArgs = {
  approvalId?: InputMaybe<Scalars['Int']>;
  email: Scalars['String'];
  projectRequestId: Scalars['Int'];
  type: ProjectRequestUserType;
};


export type MutationProjectRequestUserDeleteOneArgs = {
  id: Scalars['Int'];
};


export type MutationProjectRequestUserSoftDeleteOneArgs = {
  approvalId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  projectRequestId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<ProjectRequestUserType>;
  userId?: InputMaybe<Scalars['Int']>;
};


export type MutationProjectRequestUserUpdateOneArgs = {
  approvalId?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  projectRequestId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<ProjectRequestUserType>;
};


export type MutationProjectSetCompanySignatureArgs = {
  companySignatureId?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['Int'];
};


export type MutationProjectStagesReorderArgs = {
  stageOrderArgs: Array<ProjectStageOrderArgs>;
};


export type MutationProjectUpdateStatusArgs = {
  projectId: Scalars['Int'];
  status: ProjectStatus;
};


export type MutationProjectUserDeleteOneArgs = {
  projectId: Scalars['Float'];
  userId: Scalars['Float'];
};


export type MutationProjectUserUpdateOneArgs = {
  actorRole: ActorRole;
  projectId: Scalars['Int'];
  userId: Scalars['Int'];
};


export type MutationProjectWizardCreateAiInterviewAssessmentStageArgs = {
  aiInterviewStageActionDuration: Scalars['Int'];
  aiInterviewStageActionKnowledgeBase?: InputMaybe<Scalars['String']>;
  aiInterviewStageActionName: Scalars['String'];
  isIntegrityMonitoringEnabled?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  projectId: Scalars['Int'];
  stageActionLocales?: InputMaybe<Array<AssessmentStageActionLocales>>;
};


export type MutationProjectWizardCreateAssessmentStageArgs = {
  additionalAssessmentTypes?: InputMaybe<Array<AdditionalAssessmentType>>;
  autoProgressionThreshold?: InputMaybe<Scalars['Int']>;
  candidateReportId?: InputMaybe<Scalars['Int']>;
  emailCandidateReport: Scalars['Boolean'];
  isAutoProgressionEnabled?: InputMaybe<Scalars['Boolean']>;
  isIntegrityMonitoringEnabled?: InputMaybe<Scalars['Boolean']>;
  managerReportId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  projectId: Scalars['Int'];
  projectTeamEmailSettings: ProjectTeamEmailSettingsArgs;
  skillsProfileId: Scalars['Int'];
  stageActionLocales?: InputMaybe<Array<AssessmentStageActionLocales>>;
};


export type MutationProjectWizardCreateInterviewStageArgs = {
  companyId: Scalars['Int'];
  duration: Scalars['Int'];
  focus?: InputMaybe<InterviewStageFocus>;
  name: Scalars['String'];
  projectId: Scalars['Int'];
};


export type MutationProjectWizardCreateProjectArgs = {
  companyId: Scalars['Int'];
  jobRoleId: Scalars['Int'];
  locales: Array<SupportedLocale>;
  managers: Array<CreateProjectManagerInput>;
  name: Scalars['String'];
  skillProfileId: Scalars['Int'];
};


export type MutationProjectWizardCreateShortlistStageArgs = {
  name: Scalars['String'];
  subId: Scalars['ID'];
};


export type MutationProjectWizardInterviewStageDeleteArgs = {
  subId: Scalars['ID'];
};


export type MutationProjectWizardInterviewStageUpdateArgs = {
  data: InterviewStageUpdateData;
  subId: Scalars['ID'];
};


export type MutationProjectWizardInterviewStageUpdateDurationArgs = {
  duration: Scalars['Int'];
  subId: Scalars['ID'];
};


export type MutationProjectWizardProjectCollaboratorsCreateManyArgs = {
  collaborators: Array<ProjectCollaboratorCreateOneArgs>;
};


export type MutationProjectWizardProjectCollaboratorsDeleteManyArgs = {
  collaborators: Array<Scalars['Int']>;
};


export type MutationProjectWizardShortlistStageDeleteArgs = {
  subId: Scalars['ID'];
};


export type MutationProjectWizardStageDeleteOneArgs = {
  id: Scalars['Int'];
};


export type MutationProjectWizardUpdateAiInterviewAssessmentStageArgs = {
  aiInterviewStageActionDuration?: InputMaybe<Scalars['Int']>;
  aiInterviewStageActionKnowledgeBase?: InputMaybe<Scalars['String']>;
  aiInterviewStageActionName?: InputMaybe<Scalars['String']>;
  isIntegrityMonitoringEnabled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  stageActionLocales?: InputMaybe<Array<AssessmentStageActionLocales>>;
  stageId: Scalars['Int'];
};


export type MutationProjectWizardUpdateStageReportEmailSettingsArgs = {
  candidateReportId?: InputMaybe<Scalars['Int']>;
  emailCandidateReport: Scalars['Boolean'];
  id: Scalars['Int'];
  managerReportId?: InputMaybe<Scalars['Int']>;
  projectTeamEmailSettings: ProjectTeamEmailSettingsArgs;
};


export type MutationProjectWizardUpdateStatusArgs = {
  projectId: Scalars['Int'];
  status: ProjectStatus;
};


export type MutationQCalcGetNextQuestionArgs = {
  answers?: InputMaybe<Array<AssessmentDataAnswerGqlModel>>;
  assessmentSubId: Scalars['String'];
  nQuestions?: Scalars['Int'];
};


export type MutationQuestionnaireSubmitResponsesArgs = {
  responses: Array<QuestionnaireItemResponseGqlInput>;
  shortlistStageCandidateId: Scalars['Int'];
};


export type MutationRejectCandidatesArgs = {
  rejectionReasonId?: InputMaybe<Scalars['String']>;
  subIds: Array<Scalars['ID']>;
};


export type MutationReportAssignmentCreateArgs = {
  assignedId: Scalars['Int'];
  assignedType: RAssignedType;
  reportId: Scalars['Int'];
};


export type MutationReportAssignmentDeleteArgs = {
  id: Scalars['Int'];
};


export type MutationReportAssignmentUpdateArgs = {
  assignedId: Scalars['Int'];
  assignedType: RAssignedType;
  id: Scalars['Int'];
  reportId: Scalars['Int'];
};


export type MutationReportConfigCreateArgs = {
  newPageBefore?: InputMaybe<Scalars['Boolean']>;
  position: Scalars['Int'];
  reportId: Scalars['Int'];
  widgetConfigsToUpsert?: InputMaybe<Array<WidgetConfigUpsertOneBatchedWithReportConfigArgs>>;
  widgetId: Scalars['Int'];
};


export type MutationReportConfigDeleteArgs = {
  id: Scalars['Int'];
};


export type MutationReportCopyArgs = {
  copyReportId: Scalars['Int'];
  footerType?: InputMaybe<ReportFooterType>;
  name: Scalars['String'];
  ownerId: Scalars['Int'];
  ownerType: ReportOwnerType;
  subType?: InputMaybe<ReportSubType>;
  type: ReportType;
};


export type MutationReportCreateArgs = {
  footerType?: InputMaybe<ReportFooterType>;
  name: Scalars['String'];
  ownerId: Scalars['Int'];
  ownerType: ReportOwnerType;
  subType?: InputMaybe<ReportSubType>;
  type: ReportType;
};


export type MutationReportDeleteArgs = {
  id: Scalars['Int'];
};


export type MutationReportRenderCreateArgs = {
  dataSourceId: Scalars['Int'];
  dontSendEmailToCandidate?: InputMaybe<Scalars['Boolean']>;
  reportId: Scalars['Int'];
  reportRenderType: ReportRenderType;
};


export type MutationReportRenderDeleteArgs = {
  id: Scalars['Int'];
};


export type MutationReportUpdateArgs = {
  footerType?: InputMaybe<ReportFooterType>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  reportConfigsToCreate?: InputMaybe<Array<ReportConfigCreateOneBatchedWithReportArgs>>;
  reportConfigsToDelete?: InputMaybe<Array<DeleteByIdArgs>>;
  reportConfigsToUpdate?: InputMaybe<Array<ReportConfigUpdateOneArgs>>;
  subType?: InputMaybe<ReportSubType>;
  type?: InputMaybe<ReportType>;
};


export type MutationReportUpdateIsArchivedArgs = {
  id: Scalars['Int'];
  isArchived: Scalars['Boolean'];
};


export type MutationRequeueRejectedEventArgs = {
  id: Scalars['Int'];
};


export type MutationResetShortlistStageCandidateQuestionnaireArgs = {
  id: Scalars['ID'];
};


export type MutationRespondantFormDeleteByRespondantAndAssociatedIdArgs = {
  associatedId: Scalars['Int'];
  id: Scalars['Int'];
};


export type MutationRespondantFormDeleteByRespondantIdArgs = {
  id: Scalars['Int'];
};


export type MutationRespondantFormUpdateArgs = {
  answers?: InputMaybe<Array<UpdateRespondantFormAnswerArgs>>;
  associatedId: Scalars['Int'];
  formOwnerId: Scalars['Int'];
  formType: FormType;
  projectId?: InputMaybe<Scalars['Int']>;
  respondantId?: InputMaybe<Scalars['Int']>;
};


export type MutationResultCreateManySoftSkillsProfileFromScArgs = {
  args: Array<ResultSoftSkillProfileCreateOneFromSc>;
};


export type MutationResultCreateManyTechnicalSkillsProfileFromScArgs = {
  args: Array<ResultTechnicalSkillProfileCreateOneFromSc>;
};


export type MutationResultCreateOneBehaviourArgs = {
  copiedFrom?: InputMaybe<Scalars['Int']>;
  doneBy: Scalars['Int'];
  doneFor: Scalars['Int'];
  label?: InputMaybe<Scalars['String']>;
  manuallyAdjustedBy?: InputMaybe<Scalars['Int']>;
  measurementId: Scalars['Int'];
  measurementType: ResultMeasurementType;
  normGroupStatisticsId?: InputMaybe<Scalars['Int']>;
  projectId?: InputMaybe<Scalars['Int']>;
  projectJobRoleId?: InputMaybe<Scalars['Int']>;
  score: IIgBehaviourResultScoreModel;
};


export type MutationResultCreateOnePspSoftSkillArgs = {
  score: ISoftSkillSelfAssessmentScoreModel;
  softSkillId: Scalars['Int'];
};


export type MutationResultCreateOnePspTechnicalSkillArgs = {
  score: ITechnicalSkillSelfAssessmentScoreModel;
  technicalSkillId: Scalars['Int'];
};


export type MutationResultDeleteManyArgs = {
  copiedFrom?: InputMaybe<Scalars['Int']>;
  copiedFroms?: InputMaybe<Array<Scalars['Int']>>;
  doneBy?: InputMaybe<Scalars['Int']>;
  doneBys?: InputMaybe<Array<Scalars['Int']>>;
  doneFor?: InputMaybe<Scalars['Int']>;
  doneFors?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  label?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<Array<Scalars['String']>>;
  manuallyAdjustedBy?: InputMaybe<Scalars['Int']>;
  manuallyAdjustedBys?: InputMaybe<Array<Scalars['Int']>>;
  measurementId?: InputMaybe<Scalars['Int']>;
  measurementIds?: InputMaybe<Array<Scalars['Int']>>;
  measurementType?: InputMaybe<ResultMeasurementType>;
  measurementTypes?: InputMaybe<Array<ResultMeasurementType>>;
  normGroupStatisticsId?: InputMaybe<Scalars['Int']>;
  onlyLatest?: InputMaybe<Scalars['Boolean']>;
  onlyLatestVersionPerLabel?: InputMaybe<Scalars['Boolean']>;
  previousVersionId?: InputMaybe<Scalars['Int']>;
  previousVersionIds?: InputMaybe<Array<Scalars['Int']>>;
  projectId?: InputMaybe<Scalars['Int']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  projectJobRoleId?: InputMaybe<Scalars['Int']>;
  projectJobRoleIds?: InputMaybe<Array<Scalars['Int']>>;
  scoreType?: InputMaybe<ResultScoreType>;
  scoreTypes?: InputMaybe<Array<ResultScoreType>>;
  version?: InputMaybe<Scalars['Int']>;
  versions?: InputMaybe<Array<Scalars['Int']>>;
};


export type MutationResultUpdateOneBehaviourArgs = {
  copiedFrom?: InputMaybe<Scalars['Int']>;
  doneBy: Scalars['Int'];
  doneFor: Scalars['Int'];
  id: Scalars['Int'];
  label?: InputMaybe<Scalars['String']>;
  manuallyAdjustedBy?: InputMaybe<Scalars['Int']>;
  measurementId: Scalars['Int'];
  measurementType: ResultMeasurementType;
  normGroupStatisticsId?: InputMaybe<Scalars['Int']>;
  projectId?: InputMaybe<Scalars['Int']>;
  projectJobRoleId?: InputMaybe<Scalars['Int']>;
  score: IIgBehaviourResultScoreModel;
};


export type MutationRetryResumeProcessingArgs = {
  resumeSubId: Scalars['ID'];
};


export type MutationRoleBatchArchiveArgs = {
  roleIds: Array<Scalars['Int']>;
};


export type MutationRoleBatchPinArgs = {
  roleIds: Array<Scalars['Int']>;
};


export type MutationRoleBatchUnpinArgs = {
  roleIds: Array<Scalars['Int']>;
};


export type MutationRoleBatchUpdateStatusArgs = {
  roleIds: Array<Scalars['Int']>;
  status: RoleStatus;
};


export type MutationRoleLinkRequisitionArgs = {
  removeCandidates?: Scalars['Boolean'];
  requisitionId: Scalars['String'];
  roleId: Scalars['Int'];
};


export type MutationRolePinArgs = {
  roleId: Scalars['Int'];
};


export type MutationRoleStagesReorderArgs = {
  stageOrderArgs: Array<RoleStageOrderArgs>;
};


export type MutationRoleUnlinkRequisitionArgs = {
  id: Scalars['Int'];
  removeCandidates?: Scalars['Boolean'];
};


export type MutationRoleUnpinArgs = {
  roleId: Scalars['Int'];
};


export type MutationRoleWizardAddSoftSkillsArgs = {
  roleId: Scalars['Int'];
  softSkillSubIds: Array<Scalars['String']>;
};


export type MutationRoleWizardAddTeamMembersArgs = {
  roleId: Scalars['Int'];
  teamMembers: Array<RoleTeamMemberInput>;
};


export type MutationRoleWizardAddTechnicalSkillsArgs = {
  roleId: Scalars['Int'];
  skills: Array<TechnicalSkillInput>;
};


export type MutationRoleWizardApplyHiringProcessTemplateArgs = {
  roleId: Scalars['Int'];
  templateId: Scalars['Int'];
};


export type MutationRoleWizardArchiveArgs = {
  roleId: Scalars['Int'];
};


export type MutationRoleWizardClearHiringProcessArgs = {
  roleId: Scalars['Int'];
};


export type MutationRoleWizardCompleteJobDescriptionUploadArgs = {
  etag: Scalars['String'];
  key: Scalars['String'];
  roleId: Scalars['Int'];
  uploadId: Scalars['String'];
};


export type MutationRoleWizardConfirmRspArgs = {
  roleId: Scalars['Int'];
};


export type MutationRoleWizardCreateArgs = {
  companyId: Scalars['Int'];
  family: JobRoleFamily;
  name: Scalars['String'];
  requisitionId?: InputMaybe<Scalars['String']>;
  roleLevel: ContentRoleLevel;
};


export type MutationRoleWizardCreateAiInterviewAssessmentStageArgs = {
  aiInterviewStageActionDuration: Scalars['Int'];
  aiInterviewStageActionKnowledgeBase?: InputMaybe<Scalars['String']>;
  aiInterviewStageActionName: Scalars['String'];
  id: Scalars['Int'];
  isIntegrityMonitoringEnabled?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  stageActionLocales?: InputMaybe<Array<AssessmentStageActionLocales>>;
};


export type MutationRoleWizardCreateAssessmentStageArgs = {
  additionalAssessmentTypes?: InputMaybe<Array<AdditionalAssessmentType>>;
  autoProgressionThreshold?: InputMaybe<Scalars['Int']>;
  candidateReportId?: InputMaybe<Scalars['Int']>;
  emailCandidateReport: Scalars['Boolean'];
  id: Scalars['Int'];
  isAutoProgressionEnabled?: InputMaybe<Scalars['Boolean']>;
  isIntegrityMonitoringEnabled?: InputMaybe<Scalars['Boolean']>;
  managerReportId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  projectTeamEmailSettings: ProjectTeamEmailSettingsArgs;
  skillsProfileId: Scalars['Int'];
  stageActionLocales?: InputMaybe<Array<AssessmentStageActionLocales>>;
};


export type MutationRoleWizardCreateContentStageArgs = {
  blocks: Array<ContentStageBlockInput>;
  description: Scalars['String'];
  estimatedDurationMinutes: Scalars['Int'];
  imageUrl?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  roleId: Scalars['Int'];
};


export type MutationRoleWizardCreateInterviewStageArgs = {
  companyId: Scalars['Int'];
  duration: Scalars['Int'];
  focus?: InputMaybe<InterviewStageFocus>;
  id: Scalars['Int'];
  name: Scalars['String'];
};


export type MutationRoleWizardCreateShortlistStageArgs = {
  name: Scalars['String'];
  roleId: Scalars['Int'];
};


export type MutationRoleWizardDeleteContentStageArgs = {
  roleId: Scalars['Int'];
  stageId: Scalars['Int'];
};


export type MutationRoleWizardDeleteInterviewStageArgs = {
  roleId: Scalars['Int'];
  stageId: Scalars['Int'];
};


export type MutationRoleWizardDeleteJobDescriptionArgs = {
  roleId: Scalars['Int'];
};


export type MutationRoleWizardDeleteShortlistStageArgs = {
  roleId: Scalars['Int'];
  stageId: Scalars['Int'];
};


export type MutationRoleWizardDeleteStageArgs = {
  roleId: Scalars['Int'];
  stageId: Scalars['Int'];
};


export type MutationRoleWizardGenerateSkillsArgs = {
  roleId: Scalars['Int'];
};


export type MutationRoleWizardInitiateJobDescriptionUploadArgs = {
  contentType: Scalars['String'];
  fileName: Scalars['String'];
  roleId: Scalars['Int'];
};


export type MutationRoleWizardLinkIntakeMeetingArgs = {
  meetingId: Scalars['String'];
  roleId: Scalars['Int'];
};


export type MutationRoleWizardRemoveHiringProcessTemplateArgs = {
  roleId: Scalars['Int'];
};


export type MutationRoleWizardRemoveRspSkillsArgs = {
  roleId: Scalars['Int'];
};


export type MutationRoleWizardRemoveSoftSkillArgs = {
  roleId: Scalars['Int'];
  softSkillSubId: Scalars['String'];
};


export type MutationRoleWizardRemoveTeamMemberArgs = {
  roleId: Scalars['Int'];
  userId: Scalars['Int'];
};


export type MutationRoleWizardRemoveTechnicalSkillArgs = {
  roleId: Scalars['Int'];
  technicalSkillId: Scalars['Int'];
};


export type MutationRoleWizardRoleArchiveArgs = {
  roleId: Scalars['Int'];
};


export type MutationRoleWizardRoleUpdateStatusArgs = {
  id: Scalars['Int'];
  status: RoleStatus;
};


export type MutationRoleWizardUnlinkIntakeMeetingArgs = {
  roleId: Scalars['Int'];
};


export type MutationRoleWizardUnlinkRequisitionArgs = {
  id: Scalars['Int'];
};


export type MutationRoleWizardUpdateArgs = {
  candidatePortalEnabled?: InputMaybe<Scalars['Boolean']>;
  candidatePortalIntro?: InputMaybe<Scalars['String']>;
  candidatePortalTitle?: InputMaybe<Scalars['String']>;
  coverPhotoUrl?: InputMaybe<Scalars['String']>;
  family?: InputMaybe<JobRoleFamily>;
  hiringProcessAbsoluteDeadlineAt?: InputMaybe<Scalars['Date']>;
  hiringProcessDeadlineType?: InputMaybe<HiringProcessDeadlineType>;
  hiringProcessRelativeDeadlineAmount?: InputMaybe<Scalars['Int']>;
  hiringProcessRelativeDeadlineUnit?: InputMaybe<HiringProcessDeadlineUnit>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  reminderEmailCadenceDays?: InputMaybe<Scalars['Int']>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
};


export type MutationRoleWizardUpdateAiInterviewAssessmentStageArgs = {
  aiInterviewStageActionDuration?: InputMaybe<Scalars['Int']>;
  aiInterviewStageActionKnowledgeBase?: InputMaybe<Scalars['String']>;
  aiInterviewStageActionName?: InputMaybe<Scalars['String']>;
  isIntegrityMonitoringEnabled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  roleId: Scalars['Int'];
  stageActionLocales?: InputMaybe<Array<AssessmentStageActionLocales>>;
  stageId: Scalars['Int'];
};


export type MutationRoleWizardUpdateAssessmentStageEmailSettingsArgs = {
  candidateReportId?: InputMaybe<Scalars['Int']>;
  emailCandidateReport: Scalars['Boolean'];
  managerReportId?: InputMaybe<Scalars['Int']>;
  projectTeamEmailSettings: ProjectTeamEmailSettingsArgs;
  roleId: Scalars['Int'];
  stageId: Scalars['Int'];
};


export type MutationRoleWizardUpdateContentStageArgs = {
  blocks?: InputMaybe<Array<ContentStageBlockInput>>;
  description?: InputMaybe<Scalars['String']>;
  estimatedDurationMinutes?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  roleId: Scalars['Int'];
  stageId: Scalars['Int'];
};


export type MutationRoleWizardUpdateInterviewStageArgs = {
  duration?: InputMaybe<Scalars['Int']>;
  focus?: InputMaybe<InterviewStageFocus>;
  name?: InputMaybe<Scalars['String']>;
  roleId: Scalars['Int'];
  stageId: Scalars['Int'];
};


export type MutationRoleWizardUpdateSkillsProfileTemplateArgs = {
  roleId: Scalars['Int'];
  templateId?: InputMaybe<Scalars['Int']>;
};


export type MutationRssAssessmentCandidateReopenAllSubmittedForStageCandidateArgs = {
  stageCandidateId: Scalars['Int'];
};


export type MutationRssAssessmentCandidateSubmitOneArgs = {
  id: Scalars['Int'];
};


export type MutationRssAssessmentCreateManyArgs = {
  dto: Array<RssAssessmentCreateOneArgs>;
};


export type MutationRssAssessmentDeleteManyArgs = {
  ids: Array<Scalars['Int']>;
};


export type MutationSamlAuthInfoCreateOneArgs = {
  cert: Scalars['String'];
  entryPoint: Scalars['String'];
  identityProviderId: Scalars['Int'];
  issuer: Scalars['String'];
  signatureAlgorithm?: InputMaybe<Scalars['String']>;
  wantAssertionsSigned?: InputMaybe<Scalars['Boolean']>;
  wantAuthResponseSigned?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSamlAuthInfoDeleteOneArgs = {
  cert?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  entryPoint?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  identityProviderId?: InputMaybe<Scalars['Int']>;
  issuer?: InputMaybe<Scalars['String']>;
  signatureAlgorithm?: InputMaybe<Scalars['String']>;
  subId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  wantAssertionsSigned?: InputMaybe<Scalars['Boolean']>;
  wantAuthResponseSigned?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSamlAuthInfoRestoreOneArgs = {
  cert?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  entryPoint?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  identityProviderId?: InputMaybe<Scalars['Int']>;
  issuer?: InputMaybe<Scalars['String']>;
  signatureAlgorithm?: InputMaybe<Scalars['String']>;
  subId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  wantAssertionsSigned?: InputMaybe<Scalars['Boolean']>;
  wantAuthResponseSigned?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSamlAuthInfoSoftDeleteOneArgs = {
  cert?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  entryPoint?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  identityProviderId?: InputMaybe<Scalars['Int']>;
  issuer?: InputMaybe<Scalars['String']>;
  signatureAlgorithm?: InputMaybe<Scalars['String']>;
  subId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  wantAssertionsSigned?: InputMaybe<Scalars['Boolean']>;
  wantAuthResponseSigned?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSamlAuthInfoUpdateOneArgs = {
  cert?: InputMaybe<Scalars['String']>;
  entryPoint?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  identityProviderId?: InputMaybe<Scalars['Int']>;
  issuer?: InputMaybe<Scalars['String']>;
  signatureAlgorithm?: InputMaybe<Scalars['String']>;
  wantAssertionsSigned?: InputMaybe<Scalars['Boolean']>;
  wantAuthResponseSigned?: InputMaybe<Scalars['Boolean']>;
};


export type MutationScheduleCandidatesDebriefExportArgs = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  includeRejected?: InputMaybe<Scalars['Boolean']>;
  projectId: Scalars['Int'];
};


export type MutationScheduleRoiCsvFileExportArgs = {
  projectIds: Array<Scalars['Int']>;
};


export type MutationScheduleStageCandidateResultsCsvFileExportArgs = {
  exportLevel: CandidateResultsExportLevel;
  includeFormsData?: InputMaybe<Scalars['Boolean']>;
  lastDateOfCandidateActionFrom?: InputMaybe<Scalars['Date']>;
  lastDateOfCandidateActionTo?: InputMaybe<Scalars['Date']>;
  projectId: Scalars['Int'];
  stageId?: InputMaybe<Scalars['Int']>;
};


export type MutationScheduledCandidateUsageCsvFileExportArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  stageCandidateCreatedAtFrom?: InputMaybe<Scalars['Date']>;
  stageCandidateCreatedAtTo?: InputMaybe<Scalars['Date']>;
};


export type MutationSchedulingDeadLetterReplayArgs = {
  limit: Scalars['Int'];
};


export type MutationShortlistCandidateArgs = {
  id: Scalars['ID'];
};


export type MutationShortlistStageConfigureArgs = {
  applicationQuestionDrafts?: InputMaybe<Array<ShortlistStageApplicationQuestionDraft>>;
  borderlineQuestionsId?: InputMaybe<Scalars['String']>;
  calibrationAnswers?: InputMaybe<CalibrationAnswersInput>;
  criterionDrafts: Array<ShortlistStageCriterionDraft>;
  id: Scalars['ID'];
  weightingStrategy?: InputMaybe<ShortlistStageWeightingStrategy>;
};


export type MutationShortlistStageDeleteArgs = {
  subId: Scalars['ID'];
};


export type MutationShortlistStageQuestionnaireConfigureArgs = {
  id: Scalars['ID'];
  isAutoProgressionEnabled?: InputMaybe<Scalars['Boolean']>;
  items: Array<QuestionnaireItemDraftInput>;
};


export type MutationShortlistStageUpdateAutoProgressionArgs = {
  id: Scalars['ID'];
  isAutoProgressionEnabled: Scalars['Boolean'];
};


export type MutationShortlistStageUpdateCriteriaArgs = {
  criterionDrafts: Array<ShortlistStageCriterionDraft>;
  id: Scalars['ID'];
};


export type MutationShortlistStageUpdateNameArgs = {
  id: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationSkillsEvaluationUpdateOneV2Args = {
  id: Scalars['String'];
  isUserUpdate?: InputMaybe<Scalars['Boolean']>;
  skills?: InputMaybe<Array<SkillArgs>>;
};


export type MutationSkillsProfileSourceAddSoftSkillsArgs = {
  args: Array<SkillsProfileSourceAddSoftSkillsArgs>;
  subId: Scalars['ID'];
};


export type MutationSkillsProfileSourceAddTechnicalSkillsArgs = {
  args: Array<SkillsProfileSourceAddTechnicalSkillsArgs>;
  subId: Scalars['ID'];
};


export type MutationSkillsProfileSourceArchiveSoftSkillArgs = {
  args: SkillsProfileSourceRemoveSoftSkillArgs;
  subId: Scalars['ID'];
};


export type MutationSkillsProfileSourceArchiveTechnicalSkillArgs = {
  args: SkillsProfileSourceRemoveTechnicalSkillArgs;
  subId: Scalars['ID'];
};


export type MutationSkillsProfileSourceCompleteIntakeMeetingUploadArgs = {
  args: SkillsProfileSourceCompleteIntakeMeetingUploadArgs;
  subId: Scalars['ID'];
};


export type MutationSkillsProfileSourceCompleteJobDescriptionUploadArgs = {
  args: SkillsProfileSourceCompleteJobDescriptionUploadArgs;
  subId: Scalars['ID'];
};


export type MutationSkillsProfileSourceCreateArgs = {
  collaborators: Array<SkillsProfileSourceCollaboratorArgs>;
  companyId: Scalars['Int'];
  jobRoleMetadata: SkillsProfileSourceJobRoleMetadataArgs;
};


export type MutationSkillsProfileSourceDeleteArgs = {
  subId: Scalars['ID'];
};


export type MutationSkillsProfileSourceDeleteIntakeMeetingArgs = {
  subId: Scalars['ID'];
};


export type MutationSkillsProfileSourceDeleteJobDescriptionArgs = {
  subId: Scalars['ID'];
};


export type MutationSkillsProfileSourceGenerateSkillsArgs = {
  subId: Scalars['ID'];
};


export type MutationSkillsProfileSourceInitiateIntakeMeetingUploadArgs = {
  args: SkillsProfileSourceInitiateIntakeMeetingUploadArgs;
  subId: Scalars['ID'];
};


export type MutationSkillsProfileSourceInitiateJobDescriptionUploadArgs = {
  args: SkillsProfileSourceInitiateJobDescriptionUploadArgs;
  subId: Scalars['ID'];
};


export type MutationSkillsProfileSourceLinkMeetingArgs = {
  meetingId: Scalars['ID'];
  subId: Scalars['ID'];
};


export type MutationSkillsProfileSourceLinkUpcomingMeetingArgs = {
  subId: Scalars['ID'];
  upcomingMeetingSharedId: Scalars['ID'];
};


export type MutationSkillsProfileSourceRemoveSoftSkillArgs = {
  args: SkillsProfileSourceRemoveSoftSkillArgs;
  subId: Scalars['ID'];
};


export type MutationSkillsProfileSourceRemoveTechnicalSkillArgs = {
  args: SkillsProfileSourceRemoveTechnicalSkillArgs;
  subId: Scalars['ID'];
};


export type MutationSkillsProfileSourceSignOffArgs = {
  args: SkillsProfileSourceSignOffArgs;
  subId: Scalars['ID'];
};


export type MutationSkillsProfileSourceUnlinkMeetingArgs = {
  subId: Scalars['ID'];
};


export type MutationSkillsProfileSourceUnlinkUpcomingMeetingArgs = {
  subId: Scalars['ID'];
};


export type MutationSkillsProfileSourceUpdateArgs = {
  args: SkillsProfileSourceUpdateArgs;
  subId: Scalars['ID'];
};


export type MutationSkillsProfileSourceUpsertCollaboratorsArgs = {
  args: SkillsProfileSourceUpsertCollaboratorsArgs;
  subId: Scalars['ID'];
};


export type MutationSoftSkillAddTraitArgs = {
  addEmptyContent?: InputMaybe<Scalars['Boolean']>;
  orientation: Orientation;
  softSkillId: Scalars['Int'];
  traitId: Scalars['Int'];
  weight: Scalars['Float'];
};


export type MutationSoftSkillBulkUpdateTraitsArgs = {
  softSkillTraits: Array<BulkUpdateSoftSkillTraitArgsSingle>;
};


export type MutationSoftSkillCreateArgs = {
  category: SoftSkillCategory;
  childSubIds?: InputMaybe<Array<Scalars['ID']>>;
  companyId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  examples?: InputMaybe<Array<Scalars['String']>>;
  granularity?: InputMaybe<SoftSkillGranularity>;
  measurementConstructType?: InputMaybe<MeasurementConstructType>;
  name: Scalars['String'];
  parentSubIds?: InputMaybe<Array<Scalars['ID']>>;
  softSkillId?: InputMaybe<Scalars['Int']>;
  taxonomyVersion?: InputMaybe<Scalars['Int']>;
};


export type MutationSoftSkillDeleteTraitArgs = {
  softSkillId: Scalars['Int'];
  traitId: Scalars['Int'];
};


export type MutationSoftSkillRestoreArgs = {
  subId: Scalars['ID'];
};


export type MutationSoftSkillRoleLevelContentUpdateArgs = {
  candidateContent?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  hiringManagerContent?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  internalCandidateContent?: InputMaybe<Scalars['String']>;
};


export type MutationSoftSkillRoleLevelContentUploadArgs = {
  file: Scalars['Upload'];
};


export type MutationSoftSkillSoftDeleteArgs = {
  subId: Scalars['ID'];
};


export type MutationSoftSkillSuccessProfileContentCreateArgs = {
  description: Scalars['String'];
  roleLevel: ContentRoleLevel;
  shortDescription: Scalars['String'];
  softSkillId: Scalars['Int'];
};


export type MutationSoftSkillSuccessProfileContentDeleteArgs = {
  id: Scalars['Int'];
};


export type MutationSoftSkillSuccessProfileContentUpdateArgs = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  roleLevel?: InputMaybe<ContentRoleLevel>;
  shortDescription?: InputMaybe<Scalars['String']>;
  softSkillId?: InputMaybe<Scalars['Int']>;
};


export type MutationSoftSkillTypeSuccessProfileContentCreateArgs = {
  description: Scalars['String'];
  softSkillType: SoftSkillType;
};


export type MutationSoftSkillTypeSuccessProfileContentDeleteArgs = {
  id: Scalars['Int'];
};


export type MutationSoftSkillTypeSuccessProfileContentUpdateArgs = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  softSkillType?: InputMaybe<SoftSkillType>;
};


export type MutationSoftSkillUpdateArgs = {
  args: SoftSkillUpdateArgs;
  subId: Scalars['ID'];
};


export type MutationStageBrandingUpsertArgs = {
  description?: InputMaybe<Scalars['String']>;
  estimatedTimeMinutes?: InputMaybe<Scalars['Int']>;
  stageSubId: Scalars['ID'];
  stageType: StageType;
  thumbnailUrl?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationStageCandidateAcceptIndirectInvitationArgs = {
  hiringManagers?: InputMaybe<Array<HiringManager>>;
  projectId?: InputMaybe<Scalars['Int']>;
  stageId: Scalars['Int'];
};


export type MutationStageCandidateDeleteOneArgs = {
  subId: Scalars['String'];
};


export type MutationStageCandidatePledgeAnticheatingArgs = {
  id: Scalars['Int'];
};


export type MutationStageCandidateReprocessOneArgs = {
  applicationId?: InputMaybe<Scalars['String']>;
  candidateId?: InputMaybe<Scalars['Int']>;
  doneBy?: InputMaybe<Scalars['Int']>;
  hasPledgedAnticheating?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  stageId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<StageCandidateStatus>;
  subId?: InputMaybe<Scalars['String']>;
};


export type MutationStageCandidateResetOneArgs = {
  applicationId?: InputMaybe<Scalars['String']>;
  candidateId?: InputMaybe<Scalars['Int']>;
  doneBy?: InputMaybe<Scalars['Int']>;
  hasPledgedAnticheating?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  stageId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<StageCandidateStatus>;
  subId?: InputMaybe<Scalars['String']>;
};


export type MutationStageCandidateSubmitAdjustmentQuestionnaireArgs = {
  responses: Array<AdjustmentQuestionnaireResponse>;
  stageCandidateId: Scalars['Int'];
};


export type MutationStageCandidateUpdateDeadlineArgs = {
  deadlineAt?: InputMaybe<Scalars['Date']>;
  id: Scalars['Int'];
};


export type MutationStageCreateArgs = {
  additionalAssessmentTypes?: InputMaybe<Array<AdditionalAssessmentType>>;
  aiInterviewStageActionDuration?: InputMaybe<Scalars['Int']>;
  aiInterviewStageActionKnowledgeBase?: InputMaybe<Scalars['String']>;
  aiInterviewStageActionName?: InputMaybe<Scalars['String']>;
  autoProgressionThreshold?: InputMaybe<Scalars['Int']>;
  candidateReportId?: InputMaybe<Scalars['Int']>;
  cognitiveMode: CognitiveMode;
  emailCandidateReport: Scalars['Boolean'];
  enableF2fInterviews?: InputMaybe<Scalars['Boolean']>;
  endTime?: InputMaybe<Scalars['Date']>;
  formId?: InputMaybe<Scalars['Int']>;
  hasAdjustmentQuestionnaire?: InputMaybe<Scalars['Boolean']>;
  hasCalibration?: InputMaybe<Scalars['Boolean']>;
  isAutoProgressionEnabled?: InputMaybe<Scalars['Boolean']>;
  isIntegrityMonitoringEnabled?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<AssessmentStageKind>;
  managerReportId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  projectId: Scalars['Int'];
  projectTeamEmailSettings?: InputMaybe<ProjectTeamEmailSettingsArgs>;
  startTime?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<StageStatus>;
};


export type MutationStageDeleteOneArgs = {
  id: Scalars['Int'];
};


export type MutationStageResultsReportRenderCreateArgs = {
  dataSourceId: Scalars['Int'];
  dontSendEmailToCandidate?: InputMaybe<Scalars['Boolean']>;
  projectJobRoleId: Scalars['Int'];
  reportId: Scalars['Int'];
  reportRenderType: ReportRenderType;
};


export type MutationStageUpdateArgs = {
  additionalAssessmentTypes?: InputMaybe<Array<AdditionalAssessmentType>>;
  aiInterviewStageActionDuration?: InputMaybe<Scalars['Int']>;
  aiInterviewStageActionKnowledgeBase?: InputMaybe<Scalars['String']>;
  aiInterviewStageActionName?: InputMaybe<Scalars['String']>;
  assessmentExpiryOption?: InputMaybe<AssessmentExpiryOptionArgs>;
  autoProgressionThreshold?: InputMaybe<Scalars['Int']>;
  candidateReportId?: InputMaybe<Scalars['Int']>;
  cognitiveMode?: InputMaybe<CognitiveMode>;
  emailCandidateReport?: InputMaybe<Scalars['Boolean']>;
  enableF2fInterviews?: InputMaybe<Scalars['Boolean']>;
  endTime?: InputMaybe<Scalars['Date']>;
  formId?: InputMaybe<Scalars['Int']>;
  hasAdjustmentQuestionnaire?: InputMaybe<Scalars['Boolean']>;
  hasCalibration?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  isAutoProgressionEnabled?: InputMaybe<Scalars['Boolean']>;
  isIntegrityMonitoringEnabled?: InputMaybe<Scalars['Boolean']>;
  managerReportId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  projectTeamEmailSettings?: InputMaybe<ProjectTeamEmailSettingsArgs>;
  startTime?: InputMaybe<Scalars['Date']>;
};


export type MutationSuccessProfileAddSoftSkillsArgs = {
  softSkillSubId: Scalars['ID'];
  successProfileId: Scalars['Int'];
};


export type MutationSuccessProfileAddTechnicalSkillsArgs = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  successProfileId: Scalars['Int'];
};


export type MutationSuccessProfileConfirmArgs = {
  selectedAssessments: SuccessProfileSelectedAssessments;
  successProfileId: Scalars['Int'];
};


export type MutationSuccessProfileCreateArgs = {
  calculationMethod: CalculationMethod;
  gradingMethod: GradingMethod;
  jobRoleId: Scalars['Int'];
  softSkills: Array<SuccessProfileSoftSkillCreateOneArgs>;
};


export type MutationSuccessProfileCreateOneArgs = {
  calculationMethod: CalculationMethod;
  gradingMethod: GradingMethod;
  jobRoleId: Scalars['Int'];
};


export type MutationSuccessProfileDeleteArgs = {
  id: Scalars['Int'];
};


export type MutationSuccessProfileDeleteManyArgs = {
  calculationMethod?: InputMaybe<CalculationMethod>;
  gradingMethod?: InputMaybe<GradingMethod>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  jobRoleId?: InputMaybe<Scalars['Int']>;
  jobRoleIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type MutationSuccessProfileGenerateSkillsArgs = {
  id: Scalars['Float'];
};


export type MutationSuccessProfileRemoveSoftSkillArgs = {
  softSkillSubId: Scalars['ID'];
  successProfileId: Scalars['Int'];
};


export type MutationSuccessProfileRemoveTechnicalSkillArgs = {
  successProfileId: Scalars['Int'];
  technicalSkillId: Scalars['Int'];
};


export type MutationSuccessProfileReportRenderCreateArgs = {
  dataSourceId: Scalars['Int'];
  dontSendEmailToCandidate?: InputMaybe<Scalars['Boolean']>;
  reportId: Scalars['Int'];
  reportRenderType: ReportRenderType;
};


export type MutationSuccessProfileSoftSkillsOverwriteArgs = {
  id: Scalars['Int'];
  softSkills: Array<SuccessProfileSoftSkillCreateOneArgs>;
};


export type MutationSuccessProfileTechnicalSkillCreateManyArgs = {
  dto: Array<SuccessProfileTechnicalSkillCreateOneArgs>;
};


export type MutationSuccessProfileTechnicalSkillCreateOneArgs = {
  successProfileId?: InputMaybe<Scalars['Int']>;
  technicalSkillId: Scalars['Int'];
};


export type MutationSuccessProfileTechnicalSkillDeleteManyArgs = {
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  successProfileId?: InputMaybe<Scalars['Int']>;
  successProfileIds?: InputMaybe<Array<Scalars['Int']>>;
  technicalSkillId?: InputMaybe<Scalars['Int']>;
  technicalSkillIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type MutationSuccessProfileTechnicalSkillDeleteOneArgs = {
  id?: InputMaybe<Scalars['Int']>;
  successProfileId?: InputMaybe<Scalars['Int']>;
  technicalSkillId?: InputMaybe<Scalars['Int']>;
};


export type MutationSuccessProfileTechnicalSkillOverwriteManyArgs = {
  dto: Array<SuccessProfileTechnicalSkillCreateOneArgs>;
};


export type MutationSuccessProfileTechnicalSkillSoftDeleteManyArgs = {
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  successProfileId?: InputMaybe<Scalars['Int']>;
  successProfileIds?: InputMaybe<Array<Scalars['Int']>>;
  technicalSkillId?: InputMaybe<Scalars['Int']>;
  technicalSkillIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type MutationSuccessProfileTechnicalSkillSoftDeleteOneArgs = {
  id?: InputMaybe<Scalars['Int']>;
  successProfileId?: InputMaybe<Scalars['Int']>;
  technicalSkillId?: InputMaybe<Scalars['Int']>;
};


export type MutationSuccessProfileTechnicalSkillUpdateManyArgs = {
  dto: Array<SuccessProfileTechnicalSkillUpdateOneArgs>;
};


export type MutationSuccessProfileTechnicalSkillUpdateOneArgs = {
  id: Scalars['Int'];
  successProfileId?: InputMaybe<Scalars['Int']>;
  technicalSkillId?: InputMaybe<Scalars['Int']>;
};


export type MutationSuccessProfileTechnicalSkillsOverwriteArgs = {
  id: Scalars['Int'];
  technicalSkills: Array<SuccessProfileTechnicalSkillCreateOneArgs>;
};


export type MutationSuccessProfileUpdateArgs = {
  calculationMethod: CalculationMethod;
  gradingMethod: GradingMethod;
  id: Scalars['Int'];
  jobRoleId?: InputMaybe<Scalars['Int']>;
  softSkills: Array<SuccessProfileSoftSkillCreateOneArgs>;
};


export type MutationSuccessProfileUpdateOneArgs = {
  calculationMethod: CalculationMethod;
  gradingMethod: GradingMethod;
  id: Scalars['Int'];
  jobRoleId?: InputMaybe<Scalars['Int']>;
};


export type MutationSummaryTemplateCreateOneArgs = {
  isReady?: Scalars['Boolean'];
  longDescription?: InputMaybe<Scalars['String']>;
  messages?: Array<TemplateMessageArgs>;
  modelName?: Scalars['String'];
  name: Scalars['String'];
  scope: SummaryTemplateScope;
  sections?: InputMaybe<Array<TemplateSectionArgs>>;
  seed?: Scalars['Int'];
  sharedWith?: InputMaybe<Array<Scalars['Int']>>;
  shortDescription?: InputMaybe<Scalars['String']>;
  temperature?: Scalars['Float'];
  topP?: Scalars['Float'];
  type: TemplateType;
};


export type MutationSummaryTemplateDeleteOneArgs = {
  id: Scalars['String'];
};


export type MutationSummaryTemplateUpdateOneArgs = {
  id: Scalars['String'];
  isReady?: InputMaybe<Scalars['Boolean']>;
  longDescription?: InputMaybe<Scalars['String']>;
  messages?: InputMaybe<Array<TemplateMessageArgs>>;
  modelName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<SummaryTemplateScope>;
  sections?: InputMaybe<Array<TemplateSectionArgs>>;
  seed?: InputMaybe<Scalars['Int']>;
  sharedWith?: InputMaybe<Array<Scalars['Int']>>;
  shortDescription?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<Scalars['Float']>;
  topP?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<TemplateType>;
};


export type MutationSzAdminReportRenderRetryArgs = {
  reportRenderSubIds: Array<Scalars['String']>;
};


export type MutationSzSkillsMergeCreateManyArgs = {
  dto: Array<SzSkillsMergeCreateOneArgs>;
};


export type MutationSzSkillsMergeCreateOneArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  iconBlobId?: InputMaybe<Scalars['Int']>;
  measurementConstructType?: InputMaybe<MeasurementConstructType>;
  name: Scalars['String'];
  originId: Scalars['Int'];
  skillType: SkillType;
};


export type MutationSzSkillsMergeDeleteManyArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']>>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  description?: InputMaybe<Scalars['String']>;
  iconBlobId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  measurementConstructType?: InputMaybe<MeasurementConstructType>;
  measurementConstructTypes?: InputMaybe<Array<MeasurementConstructType>>;
  name?: InputMaybe<Scalars['String']>;
  originId?: InputMaybe<Scalars['Int']>;
  originIds?: InputMaybe<Array<Scalars['Int']>>;
  skillType?: InputMaybe<SkillType>;
  skillTypes?: InputMaybe<Array<SkillType>>;
};


export type MutationSzSkillsMergeDeleteOneArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  iconBlobId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  measurementConstructType?: InputMaybe<MeasurementConstructType>;
  name?: InputMaybe<Scalars['String']>;
  originId?: InputMaybe<Scalars['Int']>;
  skillType?: InputMaybe<SkillType>;
};


export type MutationSzSkillsMergeSoftDeleteManyArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']>>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  description?: InputMaybe<Scalars['String']>;
  iconBlobId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  measurementConstructType?: InputMaybe<MeasurementConstructType>;
  measurementConstructTypes?: InputMaybe<Array<MeasurementConstructType>>;
  name?: InputMaybe<Scalars['String']>;
  originId?: InputMaybe<Scalars['Int']>;
  originIds?: InputMaybe<Array<Scalars['Int']>>;
  skillType?: InputMaybe<SkillType>;
  skillTypes?: InputMaybe<Array<SkillType>>;
};


export type MutationSzSkillsMergeSoftDeleteOneArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  iconBlobId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  measurementConstructType?: InputMaybe<MeasurementConstructType>;
  name?: InputMaybe<Scalars['String']>;
  originId?: InputMaybe<Scalars['Int']>;
  skillType?: InputMaybe<SkillType>;
};


export type MutationSzSkillsMergeUpdateManyArgs = {
  dto: Array<SzSkillsMergeUpdateOneArgs>;
};


export type MutationSzSkillsMergeUpdateOneArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  iconBlobId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  measurementConstructType?: InputMaybe<MeasurementConstructType>;
  name?: InputMaybe<Scalars['String']>;
  originId?: InputMaybe<Scalars['Int']>;
  skillType?: InputMaybe<SkillType>;
};


export type MutationTechnicalSkillCreateOneArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  iconBlobId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  skillCategoryId?: InputMaybe<Scalars['Int']>;
};


export type MutationTechnicalSkillIconUploadArgs = {
  file: Scalars['Upload'];
  id: Scalars['Int'];
};


export type MutationTechnicalSkillRestoreArgs = {
  subId: Scalars['ID'];
};


export type MutationTechnicalSkillSoftDeleteArgs = {
  subId: Scalars['ID'];
};


export type MutationTechnicalSkillUpdateArgs = {
  args: TechnicalSkillUpdateArgs;
  subId: Scalars['ID'];
};


export type MutationTraitCreateArgs = {
  description: Scalars['String'];
  name: Scalars['String'];
};


export type MutationTraitDeleteArgs = {
  id: Scalars['Int'];
};


export type MutationTraitRoleLevelContentUpdateArgs = {
  content?: InputMaybe<Scalars['String']>;
  developmentContent?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  summary?: InputMaybe<Scalars['String']>;
};


export type MutationTraitRoleLevelContentUploadArgs = {
  file: Scalars['Upload'];
};


export type MutationTraitSoftSkillContextCreateOneArgs = {
  behaviourIds?: InputMaybe<Array<Scalars['Int']>>;
  softSkillId?: InputMaybe<Scalars['Int']>;
  traitId: Scalars['Int'];
};


export type MutationTraitSoftSkillContextDeleteManyArgs = {
  behaviourIds?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  softSkillId?: InputMaybe<Scalars['Int']>;
  softSkillIds?: InputMaybe<Array<Scalars['Int']>>;
  traitId?: InputMaybe<Scalars['Int']>;
  traitIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type MutationTraitSoftSkillContextDeleteOneArgs = {
  behaviourIds?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['Int']>;
  softSkillId?: InputMaybe<Scalars['Int']>;
  traitId?: InputMaybe<Scalars['Int']>;
};


export type MutationTraitSoftSkillContextFileUploadArgs = {
  apply: Scalars['Boolean'];
  file: Scalars['Upload'];
};


export type MutationTraitTestTypeReplaceManyArgs = {
  dto: Array<TraitTestTypesUpdateOneArgs>;
};


export type MutationTraitUpdateArgs = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  isArchived: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
};


export type MutationTraitUpdateIsArchivedArgs = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  isArchived: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
};


export type MutationUnarchiveHiringProcessTemplateArgs = {
  id: Scalars['Int'];
};


export type MutationUnarchiveSkillsProfileTemplateArgs = {
  id: Scalars['Int'];
};


export type MutationUnmarkCandidateAsHiredArgs = {
  subId: Scalars['ID'];
};


export type MutationUnmarkCandidatesAsHiredArgs = {
  subIds: Array<Scalars['ID']>;
};


export type MutationUnrejectCandidateArgs = {
  subId: Scalars['ID'];
};


export type MutationUnrejectCandidatesArgs = {
  subIds: Array<Scalars['ID']>;
};


export type MutationUnshortlistCandidateArgs = {
  id: Scalars['ID'];
};


export type MutationUpcomingMeetingAddBotArgs = {
  id: Scalars['String'];
};


export type MutationUpcomingMeetingDeleteManyArgs = {
  olderThanNumberOfDays?: InputMaybe<Scalars['Int']>;
};


export type MutationUpcomingMeetingRemoveBotArgs = {
  id: Scalars['String'];
};


export type MutationUpcomingMeetingUpdateOneArgs = {
  attendees?: InputMaybe<Array<Attendee>>;
  botId?: InputMaybe<Scalars['String']>;
  calendarId?: InputMaybe<Scalars['String']>;
  calendarPlatform?: InputMaybe<MeetingCalendarPlatform>;
  conferencingPlatform?: InputMaybe<MeetingCalendarPlatform>;
  date?: InputMaybe<Scalars['DateTime']>;
  externalMeetingId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  interviewStageCandidateId?: InputMaybe<Scalars['Int']>;
  method?: InputMaybe<Method>;
  name?: InputMaybe<Scalars['String']>;
  projectCandidateId?: InputMaybe<Scalars['Int']>;
  projectCandidateSubId?: InputMaybe<Scalars['String']>;
  projectJobRoleId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<MeetingScope>;
  url?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateHiringProcessTemplateArgs = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateProjectAiInterviewConsentEnabledArgs = {
  enabled: Scalars['Boolean'];
  id: Scalars['Int'];
};


export type MutationUpdateProjectCandidatePortalBrandingArgs = {
  candidatePortalIntro?: InputMaybe<Scalars['String']>;
  candidatePortalTitle?: InputMaybe<Scalars['String']>;
  coverPhotoUrl?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};


export type MutationUpdateProjectCandidatePortalEnabledArgs = {
  enabled: Scalars['Boolean'];
  id: Scalars['Int'];
};


export type MutationUpdateProjectHiringProcessDeadlineSettingsArgs = {
  applyAbsoluteDeadlineToInvitedCandidates?: InputMaybe<Scalars['Boolean']>;
  hiringProcessAbsoluteDeadlineAt?: InputMaybe<Scalars['Date']>;
  hiringProcessDeadlineType?: InputMaybe<HiringProcessDeadlineType>;
  hiringProcessRelativeDeadlineAmount?: InputMaybe<Scalars['Int']>;
  hiringProcessRelativeDeadlineUnit?: InputMaybe<HiringProcessDeadlineUnit>;
  id: Scalars['Int'];
  reminderEmailCadenceDays?: InputMaybe<Scalars['Int']>;
};


export type MutationUpdateProjectIntegrityMonitoringArgs = {
  id: Scalars['Int'];
  isIntegrityMonitoringEnabled: Scalars['Boolean'];
};


export type MutationUpdateProjectLocalesArgs = {
  id: Scalars['Int'];
  locales?: InputMaybe<Array<SupportedLocale>>;
  primaryLocale?: InputMaybe<SupportedLocale>;
};


export type MutationUpdateProjectNameArgs = {
  id: Scalars['Int'];
  name: Scalars['String'];
};


export type MutationUpdateSkillsProfileTemplateArgs = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateStageReportEmailSettingsArgs = {
  candidateReportId?: InputMaybe<Scalars['Int']>;
  emailCandidateReport: Scalars['Boolean'];
  id: Scalars['Int'];
  managerReportId?: InputMaybe<Scalars['Int']>;
  projectTeamEmailSettings: ProjectTeamEmailSettingsArgs;
};


export type MutationUserAnonymiseArgs = {
  subId: Scalars['ID'];
};


export type MutationUserCompanyInfoCreateArgs = {
  companyId: Scalars['Int'];
  customFields?: InputMaybe<UserCompanyInfoCustomFieldsArgs>;
  department?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Date']>;
  hrManagerEmployeeId?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Date']>;
  userId: Scalars['Int'];
};


export type MutationUserCompanyInfoDeleteOneArgs = {
  id: Scalars['Int'];
};


export type MutationUserCompanyInfoUpdateArgs = {
  customFields?: InputMaybe<UserCompanyInfoCustomFieldsArgs>;
  department?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Date']>;
  hrManagerEmployeeId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  jobTitle?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Date']>;
};


export type MutationUserCreateArgs = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  isPasswordDisabled?: InputMaybe<Scalars['Boolean']>;
  isPuppet?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Language>;
  lastName: Scalars['String'];
  locale?: InputMaybe<SupportedLocale>;
  password?: InputMaybe<Scalars['String']>;
};


export type MutationUserDeleteArgs = {
  id: Scalars['Int'];
};


export type MutationUserDeleteByEmailArgs = {
  email: Scalars['String'];
};


export type MutationUserGroupCreateOneArgs = {
  companyId: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};


export type MutationUserGroupDeleteOneArgs = {
  subId: Scalars['String'];
};


export type MutationUserGroupMembersCreateManyArgs = {
  groupSubId: Scalars['String'];
  userIds: Array<Scalars['Int']>;
};


export type MutationUserGroupMembersDeleteManyArgs = {
  groupSubId: Scalars['String'];
  userIds: Array<Scalars['Int']>;
};


export type MutationUserGroupUpdateOneArgs = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  subId: Scalars['String'];
};


export type MutationUserMeetingConfigurationCreateOneArgs = {
  metadata: MeetingMetadataArgs;
};


export type MutationUserMeetingConfigurationUpdateOneArgs = {
  metadata: MeetingMetadataArgs;
};


export type MutationUserRoleCreateArgs = {
  companyId: Scalars['Float'];
  externalId?: InputMaybe<Scalars['String']>;
  role: IdentityPermissionRole;
  userId: Scalars['Float'];
};


export type MutationUserRoleDeleteArgs = {
  id: Scalars['Int'];
};


export type MutationUserRoleUpdateArgs = {
  companyId?: InputMaybe<Scalars['Float']>;
  externalId?: InputMaybe<Scalars['String']>;
  id: Scalars['Float'];
  role?: InputMaybe<IdentityPermissionRole>;
};


export type MutationUserSettingsCreateArgs = {
  settings: UserSettingsOptionsArgs;
  userId: Scalars['Int'];
};


export type MutationUserSettingsDeleteOneArgs = {
  id: Scalars['Int'];
};


export type MutationUserSettingsUpdateArgs = {
  id: Scalars['Int'];
  settings: UserSettingsOptionsArgs;
};


export type MutationUserUpdateArgs = {
  email?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  isPasswordDisabled?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Language>;
  lastName?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<SupportedLocale>;
  twoFactorCode?: InputMaybe<Scalars['String']>;
};


export type MutationWidgetConfigCreateArgs = {
  reportConfigId: Scalars['Int'];
  settings?: InputMaybe<Scalars['String']>;
  widgetOptionId: Scalars['Int'];
};


export type MutationWidgetConfigDeleteArgs = {
  id: Scalars['Int'];
};


export type MutationWidgetConfigUpdateArgs = {
  id: Scalars['Int'];
  settings?: InputMaybe<Scalars['String']>;
};


export type MutationWidgetConfigUpdateManyArgs = {
  widgetConfigUpdates: Array<WidgetConfigUpdateOneArgs>;
};


export type MutationWidgetCreateArgs = {
  name: Scalars['String'];
  type: WidgetType;
};


export type MutationWidgetDeleteArgs = {
  id: Scalars['Int'];
};


export type MutationWidgetDeleteScreenShotArgs = {
  id: Scalars['Int'];
};


export type MutationWidgetOptionCreateArgs = {
  defaultValue?: InputMaybe<Scalars['String']>;
  fieldType: WidgetOptionFieldType;
  name: Scalars['String'];
  question?: InputMaybe<Scalars['String']>;
  widgetId: Scalars['Int'];
};


export type MutationWidgetOptionDeleteArgs = {
  id: Scalars['Int'];
};


export type MutationWidgetOptionUpdateArgs = {
  defaultValue?: InputMaybe<Scalars['String']>;
  fieldType: WidgetOptionFieldType;
  id: Scalars['Int'];
  name: Scalars['String'];
  question?: InputMaybe<Scalars['String']>;
};


export type MutationWidgetOptionUpdateIsArchivedArgs = {
  id: Scalars['Int'];
  isArchived: Scalars['Boolean'];
};


export type MutationWidgetOptionUploadBrandedSoftSkillImageArgs = {
  file: Scalars['Upload'];
};


export type MutationWidgetOptionUploadCoverPageImageArgs = {
  file: Scalars['Upload'];
};


export type MutationWidgetUpdateArgs = {
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<WidgetType>;
};


export type MutationWidgetUpdateIsArchivedArgs = {
  id: Scalars['Int'];
  isArchived: Scalars['Boolean'];
};


export type MutationWidgetUploadScreenShotArgs = {
  file: Scalars['Upload'];
  id: Scalars['Int'];
};


export type MutationAddCoderbyteToAssessmentStageArgs = {
  coderbyteTestId: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  stageId: Scalars['ID'];
  technicalSkillIds: Array<Scalars['Int']>;
};


export type MutationAddCognitiveTestToAssessmentStageArgs = {
  kind: CognitiveKind;
  stageId: Scalars['ID'];
};


export type MutationAddEnglishProficiencyToAssessmentStageArgs = {
  requiredCefrLevel: CefrLevel;
  stageId: Scalars['ID'];
};


export type MutationAddPersonalityTestToAssessmentStageArgs = {
  questionsPerTraitCount?: InputMaybe<Scalars['Int']>;
  selectedLocales?: InputMaybe<Array<SupportedLocale>>;
  stageId: Scalars['ID'];
};


export type MutationArchiveAssessmentStageDeiActionArgs = {
  stageId: Scalars['ID'];
};


export type MutationAuthenticateArgs = {
  clientType?: InputMaybe<ClientType>;
  email: Scalars['String'];
  mfaCookie?: InputMaybe<Array<Scalars['String']>>;
  password: Scalars['String'];
  workspaceId?: InputMaybe<Scalars['Int']>;
};


export type MutationAuthenticateAiAgentArgs = {
  secret: Scalars['String'];
};


export type MutationAuthenticateApiArgs = {
  clientId: Scalars['String'];
  clientSecret?: InputMaybe<Scalars['String']>;
};


export type MutationBackfillAtsApplicationIdsForAllIntegratedCompaniesArgs = {
  dryRun?: Scalars['Boolean'];
};


export type MutationBackfillAtsApplicationIdsForCompanyArgs = {
  companyId: Scalars['Int'];
  dryRun?: Scalars['Boolean'];
};


export type MutationBackfillAtsAssessmentStageCandidatesArgs = {
  dryRun?: Scalars['Boolean'];
  projectId: Scalars['Int'];
};


export type MutationBackfillAtsRejectionReasonsForAllIntegratedCompaniesArgs = {
  dryRun?: Scalars['Boolean'];
};


export type MutationBackfillAtsRejectionReasonsForCompanyArgs = {
  companyId: Scalars['Int'];
  dryRun?: Scalars['Boolean'];
};


export type MutationBackfillCandidateInterviewGuidesArgs = {
  cigIds?: InputMaybe<Array<Scalars['Int']>>;
  dryRun?: Scalars['Boolean'];
};


export type MutationBackfillKomboApplicationsForProjectArgs = {
  projectId: Scalars['Int'];
};


export type MutationCancelSchedulingRequestArgs = {
  requestId: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationCleanupDuplicateBlueprintsArgs = {
  dryRun?: Scalars['Boolean'];
};


export type MutationCleanupForbiddenSkillRelationsArgs = {
  dryRun?: Scalars['Boolean'];
};


export type MutationCleanupStaleEditingSessionsArgs = {
  timeoutMinutes?: InputMaybe<Scalars['Float']>;
};


export type MutationCreateAssessmentStageRssActionArgs = {
  stageId: Scalars['ID'];
  type: RssAssessmentType;
};


export type MutationCreateCoderbyteSsoLinkArgs = {
  companyId: Scalars['Int'];
};


export type MutationCreateCompanyArgs = {
  candidateReportId?: InputMaybe<Scalars['Int']>;
  companyLifecycle?: InputMaybe<CompanyLifecycle>;
  expiresAt?: InputMaybe<Scalars['Date']>;
  hideReports?: InputMaybe<Scalars['Boolean']>;
  isSkillsEvaluationScoreEnabled?: InputMaybe<Scalars['Boolean']>;
  managerReportId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};


export type MutationCreateProjectArgs = {
  companyId: Scalars['Float'];
  expiresAt?: InputMaybe<Scalars['Date']>;
  locales?: InputMaybe<Array<SupportedLocale>>;
  managers?: InputMaybe<Array<CreateProjectManagerInput>>;
  moduleType?: InputMaybe<ProjectModuleType>;
  name: Scalars['String'];
  productSolution: ProductSolution;
  requireSheetsExport?: Scalars['Boolean'];
};


export type MutationCreateProjectFileArgs = {
  downloadUrl: Scalars['String'];
  id: Scalars['Float'];
};


export type MutationCreateRequestMaterialUploadArgs = {
  contentType: Scalars['String'];
  stageId: Scalars['Int'];
};


export type MutationCreateSchedulingRequestsArgs = {
  details: SchedulingRequestDetailsInput;
  stageCandidateIds: Array<Scalars['Int']>;
  stageId: Scalars['Int'];
};


export type MutationDeauthenticateArgs = {
  accessToken: Scalars['String'];
};


export type MutationDeleteAiInterviewAssessmentStageActionArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteAssessmentStageArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteAssessmentStageRssActionArgs = {
  stageId: Scalars['ID'];
  type: RssAssessmentType;
};


export type MutationDeleteCompanyArgs = {
  id: Scalars['Int'];
};


export type MutationDiscardSchedulingDraftArgs = {
  batchId: Scalars['ID'];
  stageId: Scalars['Int'];
};


export type MutationDispatchEligibilityInviteForShortlistStageCandidateArgs = {
  shortlistStageCandidateSubId: Scalars['String'];
};


export type MutationEditProjectArgs = {
  companyId: Scalars['Float'];
  expiresAt?: InputMaybe<Scalars['Date']>;
  id: Scalars['Int'];
  isAiInterviewScoreHidden?: InputMaybe<Scalars['Boolean']>;
  isIntegrityMonitoringEnabled?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<SupportedLocale>>;
  managers?: InputMaybe<Array<CreateProjectManagerInput>>;
  name: Scalars['String'];
  primaryLocale?: InputMaybe<SupportedLocale>;
  productSolution?: InputMaybe<ProductSolution>;
  requireSheetsExport?: Scalars['Boolean'];
};


export type MutationEditProjectArchivingArgs = {
  id: Scalars['Int'];
  state: Scalars['Boolean'];
};


export type MutationEditProjectCandidateReportStateArgs = {
  id: Scalars['Int'];
  renderCandidateReport: Scalars['Boolean'];
};


export type MutationEditProjectStateArgs = {
  id: Scalars['Int'];
  state: Scalars['Boolean'];
};


export type MutationEndIntegrityMonitoringSessionArgs = {
  sessionId: Scalars['ID'];
};


export type MutationEnsureInterviewStageCandidatesArgs = {
  dryRun?: Scalars['Boolean'];
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type MutationFinishAiInterviewArgs = {
  id: Scalars['ID'];
};


export type MutationForceStopEditingQuestionArgs = {
  args: CollaborativeEditingForceStopArgs;
};


export type MutationGenerateShareLinkArgs = {
  url: Scalars['String'];
  workspaceId: Scalars['Int'];
};


export type MutationInitiateAiInterviewArgs = {
  id: Scalars['ID'];
};


export type MutationJoinConferenceArgs = {
  id: Scalars['ID'];
  input: JoinConferenceInput;
};


export type MutationJoinDemoConferenceArgs = {
  id: Scalars['ID'];
  input: JoinConferenceInput;
};


export type MutationKomboCancelSyncArgs = {
  companyId: Scalars['Int'];
};


export type MutationKomboClearJobsArgs = {
  companyId: Scalars['Int'];
  dryRun?: InputMaybe<Scalars['Boolean']>;
};


export type MutationKomboCreateIntegrationArgs = {
  assessmentIntegrationId?: InputMaybe<Scalars['String']>;
  atsIntegrationId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['Int'];
};


export type MutationKomboDeleteIntegrationArgs = {
  companyId: Scalars['Int'];
};


export type MutationKomboDisconnectIntegrationArgs = {
  assessment?: InputMaybe<Scalars['Boolean']>;
  ats?: InputMaybe<Scalars['Boolean']>;
  companyId: Scalars['Int'];
};


export type MutationKomboLinkProjectArgs = {
  companyId: Scalars['Int'];
  jobId: Scalars['String'];
  projectId: Scalars['Int'];
};


export type MutationKomboSetAssessmentPackagesArgs = {
  companyId: Scalars['Int'];
};


export type MutationKomboToggleEnabledArgs = {
  companyId: Scalars['Int'];
  enabled: Scalars['Boolean'];
};


export type MutationKomboToggleSyncEnabledArgs = {
  companyId: Scalars['Int'];
  enabled: Scalars['Boolean'];
};


export type MutationKomboUnlinkProjectArgs = {
  projectId: Scalars['Int'];
};


export type MutationMfaAccessTokenArgs = {
  clientDomainType: ClientDomainType;
  clientType?: InputMaybe<ClientType>;
  email: Scalars['String'];
  mfaCookie?: InputMaybe<Array<Scalars['String']>>;
  password: Scalars['String'];
  workspaceId?: InputMaybe<Scalars['Int']>;
};


export type MutationMfaAuthenticateArgs = {
  mfaAccessToken: Scalars['String'];
  mfaCode: Scalars['String'];
};


export type MutationOfferSlotsArgs = {
  batchId: Scalars['ID'];
  slots: Array<SlotWindowInput>;
  stageId: Scalars['Int'];
};


export type MutationOverwriteAssessmentStageSkillsArgs = {
  id: Scalars['ID'];
  skillsProfileId: Scalars['Int'];
  softSkillIds: Array<Scalars['Int']>;
  technicalSkillIds: Array<Scalars['Int']>;
};


export type MutationProcessInvitationArgs = {
  invitationToken: Scalars['String'];
  subId: Scalars['String'];
};


export type MutationProjectWizardDeleteAssessmentStageArgs = {
  id: Scalars['ID'];
};


export type MutationProjectWizardUpdateAssessmentStageArgs = {
  id: Scalars['ID'];
  input: UpdateAssessmentStageInput;
};


export type MutationProjectWizardUpdateAssessmentStageEmailSettingsArgs = {
  id: Scalars['ID'];
  input: UpdateAssessmentStageEmailSettingsInput;
};


export type MutationProvisionCoderbyteWorkspaceArgs = {
  companyId: Scalars['Int'];
};


export type MutationRefreshCoderbyteAssessmentDetailsArgs = {
  id: Scalars['ID'];
};


export type MutationRegisterAccountArgs = {
  companyId?: InputMaybe<Scalars['Float']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  invitationToken?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Language>;
  lastName: Scalars['String'];
  locale?: InputMaybe<SupportedLocale>;
  password: Scalars['String'];
  projectId?: InputMaybe<Scalars['Float']>;
};


export type MutationRemoveCoderbyteFromAssessmentStageArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveCognitiveTestFromAssessmentStageArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveEnglishProficiencyFromAssessmentStageArgs = {
  id: Scalars['ID'];
};


export type MutationRemovePersonalityTestFromAssessmentStageArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveUntaggedAiQuestionsArgs = {
  dryRun?: Scalars['Boolean'];
};


export type MutationRenameCoderbyteAssessmentArgs = {
  id: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationReofferSchedulingRequestArgs = {
  requestId: Scalars['ID'];
  slots: Array<SlotWindowInput>;
  version: Scalars['Int'];
};


export type MutationReplaceCompanySchedulingSettingsArgs = {
  input: CompanySchedulingSettingsInput;
};


export type MutationReportIntegrityEventsArgs = {
  events: Array<IntegrityEventInput>;
  sessionId: Scalars['ID'];
};


export type MutationRequestMfaCodeArgs = {
  clientDomainType: ClientDomainType;
  mfaAccessToken: Scalars['String'];
};


export type MutationRequestPasswordRecoveryArgs = {
  clientDomainType: ClientDomainType;
  email: Scalars['String'];
  language?: InputMaybe<Language>;
};


export type MutationRequestTokenRefreshArgs = {
  accessToken: Scalars['String'];
  clientType?: InputMaybe<ClientType>;
  refreshToken: Scalars['String'];
};


export type MutationRescheduleSchedulingRequestArgs = {
  confirmBusy?: Scalars['Boolean'];
  fixedStartsAt?: InputMaybe<Scalars['DateTime']>;
  mode: SchedulingRescheduleMode;
  requestId: Scalars['ID'];
  slots?: InputMaybe<Array<SlotWindowInput>>;
  version: Scalars['Int'];
};


export type MutationResetAiInterviewArgs = {
  id: Scalars['ID'];
};


export type MutationResetCoderbyteAssessmentArgs = {
  id: Scalars['ID'];
};


export type MutationResetCognitiveTestArgs = {
  id: Scalars['ID'];
};


export type MutationResetEnglishProficiencyAssessmentArgs = {
  id: Scalars['ID'];
};


export type MutationResetPersonalityTestArgs = {
  id: Scalars['ID'];
};


export type MutationRetryCoderbyteAssessmentResultsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationSaveAiInterviewScoreAnnotationArgs = {
  input: AiInterviewScoreAnnotationInput;
  scoreId: Scalars['Int'];
};


export type MutationSaveEnglishProficiencyResponseArgs = {
  blankAnswers?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  questionIndex: Scalars['Int'];
  selectedAnswerIndex?: InputMaybe<Scalars['Int']>;
};


export type MutationSaveSchedulingDraftArgs = {
  batchId: Scalars['ID'];
  details: SchedulingRequestDetailsInput;
  stageCandidateIds: Array<Scalars['Int']>;
  stageId: Scalars['Int'];
};


export type MutationSelectWorkspaceArgs = {
  workspaceId: Scalars['Int'];
};


export type MutationSendSchedulingRequestsArgs = {
  batchId: Scalars['ID'];
  confirmBusy?: Scalars['Boolean'];
  fixedTimes?: InputMaybe<Array<FixedInterviewTimeInput>>;
  includeAssessmentReport?: Scalars['Boolean'];
  includeInterviewGuide?: Scalars['Boolean'];
  materials?: InputMaybe<Array<RequestMaterialInput>>;
  stageId: Scalars['Int'];
};


export type MutationSetAtsAiInterviewResultsEnabledArgs = {
  companyId: Scalars['Int'];
  enabled: Scalars['Boolean'];
};


export type MutationSetAtsAllowedRejectionReasonIdsArgs = {
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationSetAtsApplicationTrackingEnabledArgs = {
  companyId: Scalars['Int'];
  enabled: Scalars['Boolean'];
};


export type MutationSetAtsAssessmentResultsEnabledArgs = {
  companyId: Scalars['Int'];
  enabled: Scalars['Boolean'];
};


export type MutationSetAtsCandidatePullModeArgs = {
  companyId: Scalars['Int'];
  mode: AtsCandidatePullMode;
};


export type MutationSetAtsHiringTeamUserProvisioningEnabledArgs = {
  companyId: Scalars['Int'];
  enabled: Scalars['Boolean'];
};


export type MutationSetAtsInterviewEvaluationResultsEnabledArgs = {
  companyId: Scalars['Int'];
  enabled: Scalars['Boolean'];
};


export type MutationSetAtsProgressionEnabledArgs = {
  companyId: Scalars['Int'];
  enabled: Scalars['Boolean'];
};


export type MutationSetAtsRejectOnBehalfOfUserRemoteIdArgs = {
  companyId: Scalars['Int'];
  userRemoteId?: InputMaybe<Scalars['String']>;
};


export type MutationSetAtsResultPushConfigArgs = {
  companyId: Scalars['Int'];
  configs: Array<AtsResultPushConfigInput>;
};


export type MutationSetAtsStageMapArgs = {
  companyId: Scalars['Int'];
  entries?: InputMaybe<Array<AtsStageMapEntryInput>>;
};


export type MutationSetAtsStagePushEnabledArgs = {
  companyId: Scalars['Int'];
  enabled: Scalars['Boolean'];
};


export type MutationSetAtsStageRejectionReasonsArgs = {
  companyId: Scalars['Int'];
  entries?: InputMaybe<Array<AtsStageRejectionReasonsEntryInput>>;
};


export type MutationSetCoderbyteWorkspaceAdminPasswordArgs = {
  adminPassword: Scalars['String'];
  companyId: Scalars['Int'];
};


export type MutationSetCoderbyteWorkspaceApiKeyArgs = {
  apiKey: Scalars['String'];
  companyId: Scalars['Int'];
};


export type MutationSetIndirectInviteSsoArgs = {
  id: Scalars['Int'];
  indirectInviteSSO: Scalars['Boolean'];
};


export type MutationSetIntegrityMonitoringSessionVerdictArgs = {
  sessionId: Scalars['ID'];
  verdict: IntegrityMonitoringSessionVerdict;
};


export type MutationSetProjectCobrandingArgs = {
  cobrandingEnabled: Scalars['Boolean'];
  id: Scalars['Int'];
};


export type MutationStartAiInterviewIntegrityMonitoringSessionArgs = {
  aiInterviewAssessmentStageActionCandidateId: Scalars['ID'];
  input: StartIntegrityMonitoringSessionInput;
};


export type MutationStartCoderbyteAssessmentArgs = {
  id: Scalars['ID'];
};


export type MutationStartCognitiveTestAssessmentArgs = {
  id: Scalars['ID'];
};


export type MutationStartCognitiveTestIntegrityMonitoringSessionArgs = {
  cognitiveTestAssessmentStageActionCandidateId: Scalars['ID'];
  input: StartIntegrityMonitoringSessionInput;
};


export type MutationStartCognitiveTestPracticeAssessmentArgs = {
  id: Scalars['ID'];
};


export type MutationStartEditingQuestionArgs = {
  args: CollaborativeEditingStartArgs;
};


export type MutationStartEnglishProficiencyAssessmentArgs = {
  id: Scalars['ID'];
};


export type MutationStartEnglishProficiencyIntegrityMonitoringSessionArgs = {
  englishProficiencyAssessmentStageActionCandidateId: Scalars['ID'];
  input: StartIntegrityMonitoringSessionInput;
};


export type MutationStartPersonalityTestAssessmentArgs = {
  id: Scalars['ID'];
  locale?: InputMaybe<SupportedLocale>;
};


export type MutationStartPersonalityTestIntegrityMonitoringSessionArgs = {
  input: StartIntegrityMonitoringSessionInput;
  personalityTestAssessmentStageActionCandidateId: Scalars['ID'];
};


export type MutationStopEditingQuestionArgs = {
  args: CollaborativeEditingStopArgs;
};


export type MutationSubmitAiInterviewFeedbackArgs = {
  feedback: Scalars['JSONObject'];
  id: Scalars['ID'];
};


export type MutationSubmitEnglishProficiencyAssessmentArgs = {
  id: Scalars['ID'];
};


export type MutationTranslateConferenceTranscriptArgs = {
  id: Scalars['ID'];
  locale: SupportedLocale;
};


export type MutationTriggerAtsCvUploadForApplicationArgs = {
  applicationId: Scalars['String'];
  companyId: Scalars['Int'];
};


export type MutationUnarchiveAssessmentStageDeiActionArgs = {
  fields?: InputMaybe<DeiStageActionFieldsInput>;
  stageId: Scalars['ID'];
};


export type MutationUpdateAiInterviewActionStageActionArgs = {
  id: Scalars['ID'];
  input: AiInterviewAssessmentStageActionUpdateInput;
};


export type MutationUpdateAiInterviewAssessmentStageActionIsAvatarEnabledArgs = {
  id: Scalars['ID'];
  isAvatarEnabled: Scalars['Boolean'];
};


export type MutationUpdateAiInterviewAssessmentStageActionIsTimingAgentEnabledArgs = {
  id: Scalars['ID'];
  isTimingAgentEnabled: Scalars['Boolean'];
};


export type MutationUpdateAiInterviewAssessmentStageActionLivekitAgentNameArgs = {
  id: Scalars['ID'];
  livekitAgentName: LivekitAgentName;
};


export type MutationUpdateAiInterviewCandidateNoteArgs = {
  id: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateAssessmentStageArgs = {
  id: Scalars['ID'];
  input: UpdateAssessmentStageInput;
};


export type MutationUpdateAssessmentStageEmailSettingsArgs = {
  id: Scalars['ID'];
  input: UpdateAssessmentStageEmailSettingsInput;
};


export type MutationUpdateCoderbyteAssessmentTechnicalSkillsArgs = {
  id: Scalars['ID'];
  technicalSkillIds: Array<Scalars['Int']>;
};


export type MutationUpdateCoderbyteAssessmentTimeAllowanceArgs = {
  id: Scalars['ID'];
  timeModifierPercentage: Scalars['Float'];
};


export type MutationUpdateCognitiveTestSectionCountArgs = {
  id: Scalars['ID'];
  sectionCount: Scalars['Int'];
};


export type MutationUpdateCognitiveTestTimeAllowanceArgs = {
  id: Scalars['ID'];
  timeModifierPercentage: Scalars['Float'];
};


export type MutationUpdateCompanyArgs = {
  aiInterviewConsentText?: InputMaybe<Scalars['String']>;
  aiPrivateNetworking?: InputMaybe<Scalars['Boolean']>;
  alternativeSupportEmail?: InputMaybe<Scalars['String']>;
  areCognitiveTestsBlocked?: InputMaybe<Scalars['Boolean']>;
  areMultiAssessmentStagesEnabled?: InputMaybe<Scalars['Boolean']>;
  areRffSoftSkillsDisabled?: InputMaybe<Scalars['Boolean']>;
  assessmentExpiryOption?: InputMaybe<AssessmentExpiryOptionArgs>;
  atsPullJobsFromDate?: InputMaybe<Scalars['Date']>;
  candidateReportId?: InputMaybe<Scalars['Int']>;
  companyLifecycle?: InputMaybe<CompanyLifecycle>;
  csmUserId?: InputMaybe<Scalars['Int']>;
  emailCandidateReport?: InputMaybe<Scalars['Boolean']>;
  enableCompanyCodingAssessments?: InputMaybe<Scalars['Boolean']>;
  expiresAt?: InputMaybe<Scalars['Date']>;
  explicitConsentEmail?: InputMaybe<Scalars['String']>;
  generateCandidateReport?: InputMaybe<Scalars['Boolean']>;
  generateManagerReport?: InputMaybe<Scalars['Boolean']>;
  hideReports?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  isAiInterviewEnabled?: InputMaybe<Scalars['Boolean']>;
  isAiInterviewScoreHidingAvailable?: InputMaybe<Scalars['Boolean']>;
  isAiShortlistNationalityScrutinyEnabled?: InputMaybe<Scalars['Boolean']>;
  isAlternativeSupportEmailEnabled?: InputMaybe<Scalars['Boolean']>;
  isApplicationAnswerEvidenceEnabled?: InputMaybe<Scalars['Boolean']>;
  isAssigneeManagedViaIntegration?: InputMaybe<Scalars['Boolean']>;
  isAtsRoleCreationWithRequisitionEnabled?: InputMaybe<Scalars['Boolean']>;
  isAtsRoleCreationWithoutRequisitionEnabled?: InputMaybe<Scalars['Boolean']>;
  isConsentCaptureEnabled?: InputMaybe<Scalars['Boolean']>;
  isHiringTeamMemberAddedEmailEnabled?: InputMaybe<Scalars['Boolean']>;
  isIntegrityMonitoringAiInterviewDefaultEnabled?: InputMaybe<Scalars['Boolean']>;
  isIntegrityMonitoringAssessmentDefaultEnabled?: InputMaybe<Scalars['Boolean']>;
  isIntegrityMonitoringAvailable?: InputMaybe<Scalars['Boolean']>;
  isInterviewGuideConfirmationEnabled?: InputMaybe<Scalars['Boolean']>;
  isInterviewGuideScoresEnabled?: InputMaybe<Scalars['Boolean']>;
  isLegalAcknowledgementsEnabled?: InputMaybe<Scalars['Boolean']>;
  isLiveChatEnabled?: InputMaybe<Scalars['Boolean']>;
  isPersonalityTestMandatory?: InputMaybe<Scalars['Boolean']>;
  isRoleLiveEmailEnabled?: InputMaybe<Scalars['Boolean']>;
  isRoleRequirementsEnabled?: InputMaybe<Scalars['Boolean']>;
  isSchedulingEnabled?: InputMaybe<Scalars['Boolean']>;
  isShortlistingEnabled?: InputMaybe<Scalars['Boolean']>;
  isSkillsEvaluationScoreEnabled?: InputMaybe<Scalars['Boolean']>;
  isSpottedZebraScoreEnabled?: InputMaybe<Scalars['Boolean']>;
  isViewGuidanceEnabled?: InputMaybe<Scalars['Boolean']>;
  isWhitelabelingEnabled?: InputMaybe<Scalars['Boolean']>;
  managerReportId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  projectTeamEmailSettings?: InputMaybe<ProjectTeamEmailSettingsArgs>;
  reasonableAdjustmentsOption?: InputMaybe<ReasonableAdjustmentsOptionArgs>;
  rfuModelType?: InputMaybe<CompanyRfuModelType>;
};


export type MutationUpdateEnglishProficiencyRequiredCefrLevelArgs = {
  id: Scalars['ID'];
  requiredCefrLevel: CefrLevel;
};


export type MutationUpdateIdentityPasswordArgs = {
  newPassword: Scalars['String'];
  recoveryToken: Scalars['String'];
};


export type MutationUpdateInterviewPanelArgs = {
  addUserIds: Array<Scalars['Int']>;
  confirmBusy?: Scalars['Boolean'];
  removeUserIds: Array<Scalars['Int']>;
  requestId: Scalars['ID'];
  version: Scalars['Int'];
};


export type MutationUpdateMyLocalePreferenceArgs = {
  locale: SupportedLocale;
};


export type MutationUpdatePersonalityTestQuestionsPerTraitCountArgs = {
  id: Scalars['ID'];
  questionsPerTraitCount: Scalars['Int'];
};


export type MutationUpdatePersonalityTestSelectedLocalesArgs = {
  id: Scalars['ID'];
  selectedLocales: Array<SupportedLocale>;
};


export type MutationUpdateStageScoringConfigArgs = {
  components: Array<StageScoringComponentConfigInput>;
  stageId: Scalars['Int'];
};


export type MutationUploadCompanyLogoArgs = {
  file: Scalars['Upload'];
  id: Scalars['Int'];
};


export type MutationUploadFileArgs = {
  file: Scalars['Upload'];
};


export type MutationUpsertAssessmentStageDeiActionArgs = {
  fields: DeiStageActionFieldsInput;
  stageId: Scalars['ID'];
};


export type MutationVerifyCoderbyteWorkspaceApiKeyArgs = {
  companyId: Scalars['Int'];
};

export type MyRole = {
  __typename?: 'MyRole';
  candidateJourney: Array<MyRoleCandidateJourneyStage>;
  candidatePortalEnabled: Scalars['Boolean'];
  candidatePortalIntro?: Maybe<Scalars['String']>;
  candidatePortalTitle?: Maybe<Scalars['String']>;
  company: MyRoleCompany;
  contentStages: Array<MyRoleContentStage>;
  coverPhotoUrl?: Maybe<Scalars['String']>;
  deadlineAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  questionnaireStages: Array<MyRoleQuestionnaireStage>;
  stages: Array<MyRoleStage>;
};


export type MyRoleContentStagesArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type MyRoleQuestionnaireStagesArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type MyRoleStagesArgs = {
  id?: InputMaybe<Scalars['ID']>;
};

export type MyRoleCandidateJourneyStage = {
  __typename?: 'MyRoleCandidateJourneyStage';
  description?: Maybe<Scalars['String']>;
  estimatedTimeMinutes?: Maybe<Scalars['Int']>;
  stageId?: Maybe<Scalars['ID']>;
  stageType: StageType;
  status: CandidateJourneyStageStatus;
  thumbnailUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type MyRoleCompany = {
  __typename?: 'MyRoleCompany';
  branding?: Maybe<CompanyBranding>;
  id: Scalars['Int'];
  isLiveChatEnabled: Scalars['Boolean'];
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  reasonableAdjustmentsOption?: Maybe<ReasonableAdjustmentsOption>;
  supportEmail: Scalars['String'];
  usesBehaviouralLabel: Scalars['Boolean'];
};

export type MyRoleContentStage = {
  __typename?: 'MyRoleContentStage';
  blocks: Array<ContentStageBlockModel>;
  contentStageCandidateId: Scalars['Int'];
  description: Scalars['String'];
  estimatedDurationMinutes: Scalars['Int'];
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  status: ContentStageCandidateStatus;
};

export type MyRoleQuestionnaireItem = {
  __typename?: 'MyRoleQuestionnaireItem';
  answer?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  order: Scalars['Int'];
  text: Scalars['String'];
};

export type MyRoleQuestionnaireStage = {
  __typename?: 'MyRoleQuestionnaireStage';
  id: Scalars['ID'];
  items: Array<MyRoleQuestionnaireItem>;
  name: Scalars['String'];
  shortlistStageCandidateId: Scalars['Int'];
  status: QuestionnaireCandidateStatus;
};

export type MyRoleStage = {
  __typename?: 'MyRoleStage';
  actions: MyRoleStageActions;
  candidateStatus: StageCandidateStatus;
  deadlineAt?: Maybe<Scalars['Date']>;
  endTime?: Maybe<Scalars['Date']>;
  hasAdjustmentQuestionnaire: Scalars['Boolean'];
  hasCompletedAdjustmentQuestionnaire: Scalars['Boolean'];
  hasPledgedAnticheating: Scalars['Boolean'];
  id: Scalars['ID'];
  isIntegrityMonitoringEnabled: Scalars['Boolean'];
  kind: AssessmentStageKind;
  name: Scalars['String'];
  stageCandidateId: Scalars['Int'];
  stageStatus: StageStatus;
};

export type MyRoleStageActions = {
  __typename?: 'MyRoleStageActions';
  aiInterviewActions: Array<MyRoleStageAiInterviewAction>;
  coderbyteAction?: Maybe<MyRoleStageCoderbyteAction>;
  cognitiveTestActions: Array<MyRoleStageCognitiveTestAction>;
  deiAction?: Maybe<MyRoleStageDeiAction>;
  englishProficiencyAction?: Maybe<MyRoleStageEnglishProficiencyAction>;
  formActions: Array<MyRoleStageFormAction>;
  personalityTestAction?: Maybe<MyRoleStagePersonalityTestAction>;
  softRssAssessmentAction?: Maybe<MyRoleStageRssAssessmentAction>;
  technicalRssAssessmentAction?: Maybe<MyRoleStageRssAssessmentAction>;
};

export type MyRoleStageAiInterviewAction = {
  __typename?: 'MyRoleStageAiInterviewAction';
  conferenceId?: Maybe<Scalars['ID']>;
  duration: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
  status: AiInterviewAssessmentStageActionCandidateStatus;
};

export type MyRoleStageCoderbyteAction = {
  __typename?: 'MyRoleStageCoderbyteAction';
  allowedTimeSeconds?: Maybe<Scalars['Int']>;
  estimatedTimeSeconds?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  status: CoderbyteAssessmentStageActionCandidateStatus;
  timeModifierPercentage: Scalars['Float'];
};

export type MyRoleStageCognitiveTestAction = {
  __typename?: 'MyRoleStageCognitiveTestAction';
  allowedSectionTimeSeconds: Scalars['Int'];
  allowedTimeSeconds: Scalars['Int'];
  id: Scalars['ID'];
  kind: CognitiveKind;
  status: CognitiveTestAssessmentStageActionCandidateStatus;
  timeModifierPercentage: Scalars['Float'];
};

export type MyRoleStageDeiAction = {
  __typename?: 'MyRoleStageDeiAction';
  id: Scalars['Int'];
  status: DeiStageActionCandidateStatus;
};

export type MyRoleStageEnglishProficiencyAction = {
  __typename?: 'MyRoleStageEnglishProficiencyAction';
  allowedTimeSeconds: Scalars['Int'];
  id: Scalars['ID'];
  status: EnglishProficiencyAssessmentStageActionCandidateStatus;
};

export type MyRoleStageFormAction = {
  __typename?: 'MyRoleStageFormAction';
  formType: FormType;
  id: Scalars['Int'];
  status: FormCandidateStatus;
};

export type MyRoleStagePersonalityTestAction = {
  __typename?: 'MyRoleStagePersonalityTestAction';
  estimatedTimeSeconds: Scalars['Int'];
  id: Scalars['ID'];
  selectedLocales: Array<SupportedLocale>;
  status: PersonalityTestAssessmentStageActionCandidateStatus;
};

export type MyRoleStageRssAssessmentAction = {
  __typename?: 'MyRoleStageRssAssessmentAction';
  id: Scalars['Int'];
  status: RssAssessmentCandidateStatus;
};

export type NewStructuredScoreModel = {
  __typename?: 'NewStructuredScoreModel';
  children?: Maybe<Array<NewStructuredScoreModel>>;
  copiedFrom?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  doneBy: Scalars['Int'];
  doneFor: Scalars['Int'];
  id: Scalars['Int'];
  label?: Maybe<Scalars['String']>;
  manuallyAdjustedBy?: Maybe<Scalars['Int']>;
  measurementId: Scalars['Int'];
  measurementType: ResultMeasurementType;
  order?: Maybe<Scalars['Int']>;
  previousVersionId?: Maybe<Scalars['Int']>;
  projectId?: Maybe<Scalars['Int']>;
  projectJobRoleId?: Maybe<Scalars['Int']>;
  score: ResultScoreUnion;
  scoreType: ResultScoreType;
  updatedAt: Scalars['Date'];
  version: Scalars['Int'];
};

export type NormGroupModel = {
  __typename?: 'NormGroupModel';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['Int'];
  jobRoleFamily?: Maybe<JobRoleFamily>;
  roleLevel?: Maybe<ContentRoleLevel>;
  trait: Trait;
  traitId: Scalars['Int'];
  updatedAt: Scalars['Date'];
};

export enum NormGroupType {
  AdministrativeStaff = 'ADMINISTRATIVE_STAFF',
  CogAdministrativeOperationalNonGraduate = 'COG_ADMINISTRATIVE_OPERATIONAL_NON_GRADUATE',
  CogApprenticesSchoolLeaversEntryLevelStaff = 'COG_APPRENTICES_SCHOOL_LEAVERS_ENTRY_LEVEL_STAFF',
  CogGradsManagersProfessionalsExecutives = 'COG_GRADS_MANAGERS_PROFESSIONALS_EXECUTIVES',
  Executives = 'EXECUTIVES',
  Finance = 'FINANCE',
  FirstLineManagers = 'FIRST_LINE_MANAGERS',
  GeneralPopulation = 'GENERAL_POPULATION',
  Graduates = 'GRADUATES',
  HealthProfessionals = 'HEALTH_PROFESSIONALS',
  Hr = 'HR',
  LegalProfessionals = 'LEGAL_PROFESSIONALS',
  ManagementConsultants = 'MANAGEMENT_CONSULTANTS',
  MarketingProfessionals = 'MARKETING_PROFESSIONALS',
  MiddleManagers = 'MIDDLE_MANAGERS',
  SalesProfessionals = 'SALES_PROFESSIONALS',
  Stem = 'STEM',
  Teaching = 'TEACHING'
}

export type NumericRangeInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type NumericalOptionModel = {
  __typename?: 'NumericalOptionModel';
  key: Scalars['Int'];
  subId: Scalars['String'];
  text: Scalars['String'];
};

export type NumericalQuestionModel = {
  __typename?: 'NumericalQuestionModel';
  difficulty: Scalars['Float'];
  options: Array<NumericalOptionModel>;
  subId: Scalars['String'];
  text: Scalars['String'];
};

export type NumericalTestletModel = {
  __typename?: 'NumericalTestletModel';
  imageUrl: Scalars['String'];
  isCompleted: Scalars['Boolean'];
  questions: Array<NumericalQuestionModel>;
  remainingQuestions: Scalars['Int'];
  remainingTime: Scalars['Int'];
  /** @deprecated Please use new property `isCompleted` if you wish to know whether the assessment is completed or not! */
  testCandidateStatus: TestStatus;
  timeLimit: Scalars['Int'];
  totalQuestions: Scalars['Int'];
};

export type OfferStageCandidateModel = {
  __typename?: 'OfferStageCandidateModel';
  createdAt: Scalars['Date'];
  id: Scalars['Int'];
  kind: GenericStageKind;
  projectCandidate: ProjectCandidate;
  projectCandidateId: Scalars['Int'];
  stage: OfferStageModel;
  stageId: Scalars['Int'];
  subId: Scalars['ID'];
};

export type OfferStageModel = {
  __typename?: 'OfferStageModel';
  createdAt: Scalars['Date'];
  id: Scalars['Int'];
  kind: GenericStageKind;
  name: Scalars['String'];
  project: Project;
  projectId: Scalars['Int'];
  subId: Scalars['ID'];
};

/** An interview window offered to a batch */
export type OfferedSlotModel = {
  __typename?: 'OfferedSlotModel';
  endsAt: Scalars['DateTime'];
  /** Whether an interviewer's calendar is already busy for this window */
  overBusy: Scalars['Boolean'];
  /** The seat standing for this window */
  seatId: Scalars['ID'];
  startsAt: Scalars['DateTime'];
};

export type OffsetBasedPaginationArgs = {
  page?: Scalars['Int'];
  size?: Scalars['Int'];
};

export type OmnisearchAll = {
  __typename?: 'OmnisearchAll';
  candidates: CandidateSearchPage;
  myRolesApplies: Scalars['Boolean'];
  myRolesDefault: Scalars['Boolean'];
  roles: RoleSearchPage;
};

export type OmnisearchPageArgs = {
  page?: Scalars['Int'];
  size?: Scalars['Int'];
};

export type OmnisearchRecents = {
  __typename?: 'OmnisearchRecents';
  candidates: Array<RecentCandidate>;
  roles: Array<RecentRole>;
};

export type OptionModel = {
  __typename?: 'OptionModel';
  key: Scalars['Int'];
  subId: Scalars['String'];
};

export type OrderByArgs = {
  direction?: InputMaybe<OrderByDirection>;
  nullLow?: InputMaybe<Scalars['Boolean']>;
  priority: Scalars['Int'];
};

export enum OrderByDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type OrgCalendarConnectionHistoryModel = {
  __typename?: 'OrgCalendarConnectionHistoryModel';
  previouslyConnected: Scalars['Boolean'];
};

export type OrgCalendarConsentRefusalModel = {
  __typename?: 'OrgCalendarConsentRefusalModel';
  createdAt: Scalars['DateTime'];
  missingPermissions: Array<Scalars['String']>;
  reasonCode: OrgCalendarRemediationCode;
};

export type OrgCalendarConsentStartModel = {
  __typename?: 'OrgCalendarConsentStartModel';
  consentUrl: Scalars['String'];
  expiresAt: Scalars['Float'];
};

export type OrgCalendarDisconnectModel = {
  __typename?: 'OrgCalendarDisconnectModel';
  connectionsFrozen: Scalars['Int'];
  grantId?: Maybe<Scalars['String']>;
};

export type OrgCalendarGrantModel = {
  __typename?: 'OrgCalendarGrantModel';
  consentInFlight: Scalars['Boolean'];
  grantedScopes: Array<Scalars['String']>;
  id: Scalars['String'];
  lastProbeAt?: Maybe<Scalars['DateTime']>;
  provider: CalendarProviderV2;
  remediationCode?: Maybe<OrgCalendarRemediationCode>;
  status: OrgCalendarGrantStatus;
  tenantId: Scalars['String'];
  verifiedAt?: Maybe<Scalars['DateTime']>;
};

export enum OrgCalendarGrantStatus {
  Active = 'active',
  Failed = 'failed',
  NeedsAdminConsent = 'needsAdminConsent',
  Revoked = 'revoked'
}

export enum OrgCalendarRemediationCode {
  CalendarReadBlocked = 'calendarReadBlocked',
  ConsentDeclined = 'consentDeclined',
  ExpiredState = 'expiredState',
  InvalidState = 'invalidState',
  MissingPermission = 'missingPermission',
  SchedulingDisabled = 'schedulingDisabled',
  TenantMismatch = 'tenantMismatch',
  TryAgain = 'tryAgain'
}

export enum Orientation {
  Inverted = 'INVERTED',
  Standard = 'STANDARD'
}

export type Pageinfo = {
  __typename?: 'Pageinfo';
  currentPage: Scalars['Int'];
  itemsOnPage: Scalars['Int'];
  itemsTotal: Scalars['Int'];
  pageTotal: Scalars['Int'];
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type PaginatedCompanySettingChangesModel = {
  __typename?: 'PaginatedCompanySettingChangesModel';
  data?: Maybe<Array<CompanySettingChangeModel>>;
  pageInfo?: Maybe<Pageinfo>;
};

export type PaginatedMeetingModel = {
  __typename?: 'PaginatedMeetingModel';
  data: Array<MeetingModel>;
  total: Scalars['Int'];
};

export type PaginatedProjectsModel = {
  __typename?: 'PaginatedProjectsModel';
  data?: Maybe<Array<Project>>;
  pageInfo?: Maybe<Pageinfo>;
};

export type PaginatedSoftSkillGqlModel = {
  __typename?: 'PaginatedSoftSkillGQLModel';
  data?: Maybe<Array<SoftSkill>>;
  pageInfo?: Maybe<Pageinfo>;
};

export type PaginatedSummaryTemplateModel = {
  __typename?: 'PaginatedSummaryTemplateModel';
  data: Array<SummaryTemplateModel>;
  total: Scalars['Int'];
};

export type PaginatedSzSkillsMerge = {
  __typename?: 'PaginatedSzSkillsMerge';
  skills: Array<SzSkillsMergeWithAvailability>;
  total: Scalars['Int'];
};

export type PaginatedTechnicalSkill = {
  __typename?: 'PaginatedTechnicalSkill';
  technicalSkills: Array<TechnicalSkill>;
  total: Scalars['Int'];
};

export type PaginatedTechnicalSkillModel = {
  __typename?: 'PaginatedTechnicalSkillModel';
  data?: Maybe<Array<TechnicalSkill>>;
  pageInfo?: Maybe<Pageinfo>;
};

export type PaginatedUnifiedMeeting = {
  __typename?: 'PaginatedUnifiedMeeting';
  data: Array<UnifiedMeeting>;
  total: Scalars['Int'];
};

export type PaginatedUpcomingMeetingModel = {
  __typename?: 'PaginatedUpcomingMeetingModel';
  data: Array<UpcomingMeetingModel>;
  total: Scalars['Int'];
};

/** Status of the Candidate Interview Guide PDF generation lifecycle */
export enum PdfGenerationStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export type PersonalInfoSpecifics = {
  __typename?: 'PersonalInfoSpecifics';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type PersonalityItemModel = {
  __typename?: 'PersonalityItemModel';
  isCompleted: Scalars['Boolean'];
  questions: Array<PersonalityQuestionModel>;
  remainingQuestions: Scalars['Int'];
  /** @deprecated Please use new property `isCompleted` if you wish to know whether the assessment is completed or not! */
  testCandidateStatus: TestStatus;
  totalQuestions: Scalars['Int'];
};

export type PersonalityOptionModel = {
  __typename?: 'PersonalityOptionModel';
  key: Scalars['Int'];
  subId: Scalars['String'];
  text: Scalars['String'];
  value: Scalars['Float'];
};

export type PersonalityQuestionModel = {
  __typename?: 'PersonalityQuestionModel';
  difficulty: Scalars['Float'];
  options: Array<PersonalityOptionModel>;
  orientation: QuestionOrientation;
  subId: Scalars['String'];
  text: Scalars['String'];
};

export type PersonalityTestAssessmentStageAction = {
  __typename?: 'PersonalityTestAssessmentStageAction';
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  questionsPerTraitCount: Scalars['Int'];
  selectedLocales: Array<SupportedLocale>;
  stageId: Scalars['Int'];
  updatedAt: Scalars['Date'];
};

export type PersonalityTestAssessmentStageActionCandidate = {
  __typename?: 'PersonalityTestAssessmentStageActionCandidate';
  action: PersonalityTestAssessmentStageActionNested;
  assessmentId?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['Date']>;
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  integrityMonitoringSession?: Maybe<IntegrityMonitoringSession>;
  locale?: Maybe<SupportedLocale>;
  resultStatus: PersonalityTestAssessmentStageActionCandidateResultStatus;
  stageCandidate: SmStageCandidateModel;
  startedAt?: Maybe<Scalars['Date']>;
  status: PersonalityTestAssessmentStageActionCandidateStatus;
  updatedAt: Scalars['Date'];
};

export enum PersonalityTestAssessmentStageActionCandidateResultStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export enum PersonalityTestAssessmentStageActionCandidateStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export type PersonalityTestAssessmentStageActionNested = {
  __typename?: 'PersonalityTestAssessmentStageActionNested';
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  questionsPerTraitCount: Scalars['Int'];
  selectedLocales: Array<SupportedLocale>;
  stageId: Scalars['Int'];
  updatedAt: Scalars['Date'];
};

export enum PollingStatus {
  Error = 'ERROR',
  Generating = 'GENERATING',
  Idling = 'IDLING',
  Ready = 'READY'
}

export enum ProductSolution {
  EarlyCareerHiring = 'EARLY_CAREER_HIRING',
  Learning = 'LEARNING',
  ProfessionalHiring = 'PROFESSIONAL_HIRING',
  Reskilling = 'RESKILLING',
  SuccessionPlanning = 'SUCCESSION_PLANNING',
  VolumeHiring = 'VOLUME_HIRING'
}

export type ProgressCandidatesPayload = {
  __typename?: 'ProgressCandidatesPayload';
  atsWritebackFailures: Array<AtsProgressionWritebackFailure>;
  atsWritebackSuccess?: Maybe<AtsProgressionWritebackSuccess>;
  projectCandidates: Array<ProjectCandidate>;
};

export enum ProgressionEventPerformedByType {
  Ats = 'ATS',
  System = 'SYSTEM',
  User = 'USER'
}

export enum ProgressionStatus {
  Active = 'ACTIVE',
  Hired = 'HIRED',
  Rejected = 'REJECTED'
}

export type Project = {
  __typename?: 'Project';
  /** @deprecated Use "assessmentStagesV2" and find the stage with kind === AI_INTERVIEW client-side. Singular stage accessors on Project are being phased out in favour of the array-based "assessmentStagesV2". */
  aiInterviewStage?: Maybe<AssessmentStage>;
  applicationQuestions: Array<RoleApplicationQuestion>;
  /** @deprecated Use "assessmentStagesV2" and find the stage with kind === ASSESSMENT client-side. Singular stage accessors on Project are being phased out in favour of the array-based "assessmentStagesV2". */
  assessmentStage?: Maybe<AssessmentStage>;
  assessmentStages: Array<SmStageModel>;
  assessmentStagesV2: Array<AssessmentStage>;
  candidatePortalEnabled: Scalars['Boolean'];
  candidatePortalIntro?: Maybe<Scalars['String']>;
  candidatePortalTitle?: Maybe<Scalars['String']>;
  company?: Maybe<ProjectCompany>;
  companyId?: Maybe<Scalars['Float']>;
  companySignatureId?: Maybe<Scalars['Int']>;
  completedAssessmentsCount: Scalars['Int'];
  contentStages: Array<ContentStageModel>;
  coverPhotoUrl?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  hiringProcessAbsoluteDeadlineAt?: Maybe<Scalars['Date']>;
  hiringProcessDeadlineType?: Maybe<HiringProcessDeadlineType>;
  hiringProcessRelativeDeadlineAmount?: Maybe<Scalars['Int']>;
  hiringProcessRelativeDeadlineUnit?: Maybe<HiringProcessDeadlineUnit>;
  hiringProcessTemplateVersion?: Maybe<HiringProcessTemplateVersion>;
  id: Scalars['Int'];
  idVerificationEnabled: Scalars['Boolean'];
  indirectInviteSSOEnabled?: Maybe<Scalars['Boolean']>;
  interviewStages: Array<InterviewStage>;
  isAiInterviewExplicitConsentEnabled: Scalars['Boolean'];
  isAiInterviewScoreHidden: Scalars['Boolean'];
  isArchived: Scalars['Boolean'];
  isIntegrityMonitoringEnabled: Scalars['Boolean'];
  isStopped: Scalars['Boolean'];
  jobDescriptionLocales?: Maybe<Array<Scalars['String']>>;
  jobDescriptionUrl?: Maybe<Scalars['String']>;
  lastCandidateActivity?: Maybe<Scalars['Date']>;
  locales: Array<SupportedLocale>;
  /** @deprecated Please use "teamMembers" instead! */
  managers?: Maybe<Array<ProjectManager>>;
  moduleType: ProjectModuleType;
  name: Scalars['String'];
  offerStage?: Maybe<OfferStageModel>;
  primaryLocale: SupportedLocale;
  productSolution?: Maybe<ProductSolution>;
  projectCandidatesCount: Scalars['Int'];
  projectRequest?: Maybe<ProjectRequestModel>;
  publishedAt?: Maybe<Scalars['Date']>;
  publishedBy?: Maybe<User>;
  reminderEmailCadenceDays?: Maybe<Scalars['Int']>;
  renderCandidateReport: Scalars['Boolean'];
  requireSheetsExport: Scalars['Boolean'];
  shortlistCalibrationBorderlineQuestions?: Maybe<ShortlistCalibrationBorderlineQuestions>;
  shortlistCriteriaSuggestionStatus?: Maybe<ProjectShortlistCriteriaSuggestionStatus>;
  shortlistCriteriaSuggestions?: Maybe<Array<ProjectShortlistCriteriaSuggestion>>;
  shortlistStages: Array<ShortlistStage>;
  source: ProjectSource;
  status: ProjectStatus;
  subId: Scalars['String'];
  teamMembers?: Maybe<Array<ProjectManager>>;
  updatedAt: Scalars['String'];
  updatedBy?: Maybe<User>;
  version: Scalars['Float'];
};

export enum ProjectAction {
  AddAssessmentStageAction = 'ADD_ASSESSMENT_STAGE_ACTION',
  AddProjectCandidate = 'ADD_PROJECT_CANDIDATE',
  CompanyAppCandidateResultExport = 'COMPANY_APP_CANDIDATE_RESULT_EXPORT',
  CreateAssessmentStage = 'CREATE_ASSESSMENT_STAGE',
  CreateContentStage = 'CREATE_CONTENT_STAGE',
  CreateInterviewStage = 'CREATE_INTERVIEW_STAGE',
  CreateProjectJobRole = 'CREATE_PROJECT_JOB_ROLE',
  CreateShortlistStage = 'CREATE_SHORTLIST_STAGE',
  DecisionKitActions = 'DECISION_KIT_ACTIONS',
  InviteAssessmentStageCandidate = 'INVITE_ASSESSMENT_STAGE_CANDIDATE',
  LinkRspSoftSkill = 'LINK_RSP_SOFT_SKILL',
  LinkRspTechnicalSkill = 'LINK_RSP_TECHNICAL_SKILL',
  RemoveAssessmentStage = 'REMOVE_ASSESSMENT_STAGE',
  RemoveAssessmentStageAction = 'REMOVE_ASSESSMENT_STAGE_ACTION',
  RemoveAssessmentStageCandidate = 'REMOVE_ASSESSMENT_STAGE_CANDIDATE',
  RemoveContentStage = 'REMOVE_CONTENT_STAGE',
  RemoveInterviewStage = 'REMOVE_INTERVIEW_STAGE',
  RemoveProjectCandidate = 'REMOVE_PROJECT_CANDIDATE',
  RemoveProjectJobRole = 'REMOVE_PROJECT_JOB_ROLE',
  RemoveShortlistStage = 'REMOVE_SHORTLIST_STAGE',
  SetMainProjectJobRole = 'SET_MAIN_PROJECT_JOB_ROLE',
  UnlinkRspSoftSkill = 'UNLINK_RSP_SOFT_SKILL',
  UnlinkRspTechnicalSkill = 'UNLINK_RSP_TECHNICAL_SKILL',
  UpdateAssessmentStageName = 'UPDATE_ASSESSMENT_STAGE_NAME',
  UpdateAssessmentStageReportAndEmail = 'UPDATE_ASSESSMENT_STAGE_REPORT_AND_EMAIL',
  UpdateAssessmentStageStartEndDate = 'UPDATE_ASSESSMENT_STAGE_START_END_DATE',
  UpdateCandidateAssignees = 'UPDATE_CANDIDATE_ASSIGNEES',
  UpdateCandidateDeadline = 'UPDATE_CANDIDATE_DEADLINE',
  UpdateCognitiveMode = 'UPDATE_COGNITIVE_MODE',
  UpdateContentStage = 'UPDATE_CONTENT_STAGE',
  UpdateInterviewStageDuration = 'UPDATE_INTERVIEW_STAGE_DURATION',
  UpdateInterviewStageName = 'UPDATE_INTERVIEW_STAGE_NAME',
  UpdateJobRoleFamily = 'UPDATE_JOB_ROLE_FAMILY',
  UpdateJobRoleLevel = 'UPDATE_JOB_ROLE_LEVEL',
  UpdateJobRoleName = 'UPDATE_JOB_ROLE_NAME',
  UpdateProjectAiInterviewConsent = 'UPDATE_PROJECT_AI_INTERVIEW_CONSENT',
  UpdateProjectCandidatePortalBranding = 'UPDATE_PROJECT_CANDIDATE_PORTAL_BRANDING',
  UpdateProjectCobranding = 'UPDATE_PROJECT_COBRANDING',
  UpdateProjectHiringProcessDeadline = 'UPDATE_PROJECT_HIRING_PROCESS_DEADLINE',
  UpdateProjectIndirectInviteSsoSignUp = 'UPDATE_PROJECT_INDIRECT_INVITE_SSO_SIGN_UP',
  UpdateProjectLanguages = 'UPDATE_PROJECT_LANGUAGES',
  UpdateProjectName = 'UPDATE_PROJECT_NAME',
  UpdateProjectSolution = 'UPDATE_PROJECT_SOLUTION',
  UpdateProjectTeamMembers = 'UPDATE_PROJECT_TEAM_MEMBERS',
  UpdateRspSkillWeight = 'UPDATE_RSP_SKILL_WEIGHT',
  UpdateRspTraitWeight = 'UPDATE_RSP_TRAIT_WEIGHT',
  UpdateShortlistStageName = 'UPDATE_SHORTLIST_STAGE_NAME'
}

export type ProjectAddShortlistStage = {
  __typename?: 'ProjectAddShortlistStage';
  project: Project;
  shortlistStage: ShortlistStage;
};

export type ProjectCandidate = {
  __typename?: 'ProjectCandidate';
  assessmentStageCandidates: Array<SmStageCandidateModel>;
  assignees: Array<ProjectManager>;
  atsApplicationUrl?: Maybe<Scalars['String']>;
  atsRejectionReasonName?: Maybe<Scalars['String']>;
  atsStage?: Maybe<Scalars['String']>;
  candidateProfile?: Maybe<ProjectCandidateProfile>;
  contentStageCandidates: Array<ContentStageCandidateModel>;
  createdAt: Scalars['Date'];
  currentStageId?: Maybe<Scalars['Int']>;
  currentStageType?: Maybe<StageType>;
  deadlineAt?: Maybe<Scalars['Date']>;
  expiresAt?: Maybe<Scalars['Date']>;
  interviewStageCandidates: Array<InterviewStageCandidate>;
  isExpired: Scalars['Boolean'];
  offerStageCandidate?: Maybe<OfferStageCandidateModel>;
  otherAttempts: Array<BasicProjectCandidate>;
  progressionData: CandidateProgressionData;
  progressionStatus: ProgressionStatus;
  project: Project;
  shortlistStageCandidates: Array<ShortlistStageCandidate>;
  subId: Scalars['ID'];
  updatedAt: Scalars['Date'];
  user: User;
};

export type ProjectCandidateAssessmentInviteSettings = {
  assessmentStageSubId: Scalars['ID'];
  deadlineInEmail?: InputMaybe<Scalars['Date']>;
};

export enum ProjectCandidateAssessmentStatusFilter {
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  Invited = 'INVITED',
  InProgress = 'IN_PROGRESS',
  NotInvited = 'NOT_INVITED',
  Processing = 'PROCESSING'
}

export type ProjectCandidateInvitationSettings = {
  areInternalCandidates: Scalars['Boolean'];
  assignees: Array<Scalars['Int']>;
  supportedLocale: SupportedLocale;
};

export type ProjectCandidateInvitationSettingsWithoutAssignees = {
  areInternalCandidates: Scalars['Boolean'];
  supportedLocale: SupportedLocale;
};

export enum ProjectCandidateOrderField {
  AssessmentStatus = 'ASSESSMENT_STATUS',
  DateAdded = 'DATE_ADDED',
  DateInvited = 'DATE_INVITED',
  DateUpdated = 'DATE_UPDATED',
  Name = 'NAME',
  Stage = 'STAGE',
  State = 'STATE'
}

export enum ProjectCandidatePreferredAnswersFilter {
  GaveAllPreferredAnswers = 'GAVE_ALL_PREFERRED_ANSWERS',
  MissedOneOrMore = 'MISSED_ONE_OR_MORE'
}

export type ProjectCandidateProfile = {
  __typename?: 'ProjectCandidateProfile';
  additionalExperience?: Maybe<Array<Scalars['String']>>;
  candidateLocation?: Maybe<Scalars['String']>;
  certifications?: Maybe<Array<Scalars['String']>>;
  createdAt: Scalars['Date'];
  currentSeniorityLevel?: Maybe<Scalars['String']>;
  education?: Maybe<Array<Scalars['String']>>;
  employmentGaps?: Maybe<Array<EmploymentGap>>;
  experience?: Maybe<Array<Scalars['String']>>;
  experienceSummary?: Maybe<Array<ExperienceSummaryEntry>>;
  highestEducationLevel?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  industries?: Maybe<Array<ResumeExtractedDataIndustry>>;
  interests?: Maybe<Array<Scalars['String']>>;
  isEnglishLanguage: Scalars['Boolean'];
  language?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Scalars['String']>>;
  other?: Maybe<Array<Scalars['String']>>;
  personalInfo?: Maybe<Array<Scalars['String']>>;
  personalSpecifics?: Maybe<PersonalInfoSpecifics>;
  skills?: Maybe<Array<Scalars['String']>>;
  source: ProjectCandidateProfileSource;
  summary?: Maybe<Scalars['String']>;
  totalYearsExperience?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['Date'];
};

export enum ProjectCandidateProfileSource {
  ExternalService = 'EXTERNAL_SERVICE',
  ProjectCandidateProfile = 'PROJECT_CANDIDATE_PROFILE',
  Resume = 'RESUME'
}

export enum ProjectCandidateShortlistedFilter {
  NotShortlisted = 'NOT_SHORTLISTED',
  Shortlisted = 'SHORTLISTED'
}

export type ProjectCandidateStageBreakdown = {
  __typename?: 'ProjectCandidateStageBreakdown';
  candidatesCount: Scalars['Int'];
  category: ProjectCandidateStageCategory;
  completedCount?: Maybe<Scalars['Int']>;
};

export enum ProjectCandidateStageCategory {
  AiInterview = 'AI_INTERVIEW',
  ContentStage = 'CONTENT_STAGE',
  InterviewStage = 'INTERVIEW_STAGE',
  NotInAStage = 'NOT_IN_A_STAGE',
  OfferStage = 'OFFER_STAGE',
  OnlineAssessment = 'ONLINE_ASSESSMENT',
  ShortlistStage = 'SHORTLIST_STAGE'
}

export type ProjectCandidateUpsertAssigneesArgs = {
  projectTeamMemberIds: Array<Scalars['Int']>;
};

export type ProjectCandidateUserDetails = {
  email: Scalars['String'];
  familyName: Scalars['String'];
  givenName: Scalars['String'];
};

export type ProjectCandidatesArgs = {
  projectSubId?: InputMaybe<Scalars['ID']>;
  userSubId?: InputMaybe<Scalars['ID']>;
};

export type ProjectCandidatesFilterArgs = {
  allAttempts?: Scalars['Boolean'];
  assessmentStatus?: InputMaybe<Array<ProjectCandidateAssessmentStatusFilter>>;
  dateAdded?: InputMaybe<DateFilter>;
  dateInvited?: InputMaybe<DateFilter>;
  dateUpdated?: InputMaybe<DateFilter>;
  nameOrEmailContains?: InputMaybe<Scalars['String']>;
};

export type ProjectCandidatesOrderArgs = {
  direction?: SortOption;
  field?: ProjectCandidateOrderField;
};

export type ProjectCandidatesPaginated = {
  __typename?: 'ProjectCandidatesPaginated';
  data?: Maybe<Array<ProjectCandidate>>;
  pageInfo?: Maybe<Pageinfo>;
};

export type ProjectCobrandingModel = {
  __typename?: 'ProjectCobrandingModel';
  accentColor1?: Maybe<Scalars['String']>;
  companyLogoUrl?: Maybe<Scalars['String']>;
  companyName: Scalars['String'];
  name: Scalars['String'];
};

export type ProjectCollaborator = {
  __typename?: 'ProjectCollaborator';
  /** The decorative role that user got assigned for this particular project. Optional. */
  actorRole?: Maybe<ActorRole>;
  group?: Maybe<ProjectCollaboratorGroup>;
  groupId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  user?: Maybe<ProjectCollaboratorUser>;
  userId?: Maybe<Scalars['Int']>;
};

export type ProjectCollaboratorArgs = {
  collaboratorType?: InputMaybe<ProjectCollaboratorType>;
  membersPreviewCount?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['Int'];
  search?: InputMaybe<Scalars['String']>;
};

export type ProjectCollaboratorCreateOneArgs = {
  actorRole?: InputMaybe<ActorRole>;
  groupId?: InputMaybe<Scalars['Int']>;
  isAutogenerated?: InputMaybe<Scalars['Boolean']>;
  projectId: Scalars['Int'];
  userId?: InputMaybe<Scalars['Int']>;
};

export type ProjectCollaboratorDeleteManyResult = {
  __typename?: 'ProjectCollaboratorDeleteManyResult';
  collaboratorId: Scalars['Int'];
  error?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type ProjectCollaboratorGroup = {
  __typename?: 'ProjectCollaboratorGroup';
  companyId: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  membersCount: Scalars['Int'];
  membersPreview: Array<ProjectCollaboratorGroupMembersPreview>;
  name: Scalars['String'];
  subId: Scalars['String'];
};

export type ProjectCollaboratorGroupMembersPreview = {
  __typename?: 'ProjectCollaboratorGroupMembersPreview';
  avatarUrl?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastName?: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
};

export type ProjectCollaboratorIndividual = {
  __typename?: 'ProjectCollaboratorIndividual';
  avatarUrl?: Maybe<Scalars['String']>;
  calculatedActorRole?: Maybe<ActorRole>;
  /** Array of actual access roles that user holds for company that owns project */
  companyRoles?: Maybe<Array<Maybe<IdentityPermissionRole>>>;
  directAccess: DirectAccessInfo;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  groups?: Maybe<Array<Maybe<GroupInfo>>>;
  id: Scalars['Int'];
  lastName?: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
};

export type ProjectCollaboratorIndividualPaginated = {
  __typename?: 'ProjectCollaboratorIndividualPaginated';
  data?: Maybe<Array<ProjectCollaboratorIndividual>>;
  pageInfo?: Maybe<Pageinfo>;
};

export enum ProjectCollaboratorOrderField {
  FirstName = 'FIRST_NAME'
}

export type ProjectCollaboratorOrderOptions = {
  direction: SortOption;
  field: ProjectCollaboratorOrderField;
};

export type ProjectCollaboratorPaginated = {
  __typename?: 'ProjectCollaboratorPaginated';
  data?: Maybe<Array<ProjectCollaborator>>;
  pageInfo?: Maybe<Pageinfo>;
};

export type ProjectCollaboratorRole = {
  __typename?: 'ProjectCollaboratorRole';
  /** The decorative role that user got assigned for this particular project. Optional. */
  actorRole?: Maybe<ActorRole>;
  groupId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  projectId: Scalars['Int'];
  userId?: Maybe<Scalars['Int']>;
};

export enum ProjectCollaboratorType {
  Group = 'GROUP',
  User = 'USER'
}

export type ProjectCollaboratorUser = {
  __typename?: 'ProjectCollaboratorUser';
  avatarUrl?: Maybe<Scalars['String']>;
  /** Array of actual access roles that user holds for company that owns project */
  companyRoles?: Maybe<Array<Maybe<IdentityPermissionRole>>>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastName?: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
};

export type ProjectCompany = {
  __typename?: 'ProjectCompany';
  candidateReport?: Maybe<Report>;
  emailCandidateReport: Scalars['Boolean'];
  enableCompanyCodingAssessments: Scalars['Boolean'];
  generateCandidateReport: Scalars['Boolean'];
  generateManagerReport: Scalars['Boolean'];
  hideReports: Scalars['Boolean'];
  id: Scalars['Int'];
  logoUrl?: Maybe<Scalars['String']>;
  managerReport?: Maybe<Report>;
  name: Scalars['String'];
  projectTeamEmailSettings: ProjectTeamEmailSettings;
};

export type ProjectCompanyId = {
  __typename?: 'ProjectCompanyId';
  companyId: Scalars['Int'];
};

export type ProjectCompleteJobDescriptionUploadArgs = {
  etag: Scalars['String'];
  key: Scalars['String'];
  uploadId: Scalars['String'];
};

export type ProjectFile = {
  __typename?: 'ProjectFile';
  downloadUrl: Scalars['String'];
  id: Scalars['Int'];
};

export type ProjectFilterArgs = {
  /** True for roles currently linked to an ATS requisition, false for roles without one. Omit for no filtering. Link status comes from the ATS service, so the query fails rather than returning unfiltered results when it cannot be reached. */
  atsLinked?: InputMaybe<Scalars['Boolean']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  dateCreated?: InputMaybe<DateFilter>;
  dateLastEdited?: InputMaybe<DateFilter>;
  datePublished?: InputMaybe<DateFilter>;
  fromCompletedAssessmentCount?: InputMaybe<Scalars['Int']>;
  fromProjectCandidatesCount?: InputMaybe<Scalars['Int']>;
  /** Restricts results to projects where any of these users is on the hiring team, directly or via a user group they belong to. */
  hiringTeamUserIds?: InputMaybe<Array<Scalars['Int']>>;
  meetingId?: InputMaybe<Scalars['String']>;
  /** When true, restricts results to projects where the caller is a hiring team member, either directly or via a user group they belong to. */
  onlyMyHiringTeamRoles?: InputMaybe<Scalars['Boolean']>;
  /** Per-stage-type rules the role must all satisfy. A stage type with no rule is not filtered on. */
  stageTypeFilters?: InputMaybe<Array<ProjectStageTypeFilterArgs>>;
  statuses?: InputMaybe<Array<ProjectStatus>>;
  textSearch?: InputMaybe<Scalars['String']>;
  toCompletedAssessmentCount?: InputMaybe<Scalars['Int']>;
  toProjectCandidatesCount?: InputMaybe<Scalars['Int']>;
  withAdminAppDrafts?: Scalars['Boolean'];
  withDIG?: ProjectTriboolFilter;
  withDeleted?: ProjectTriboolFilter;
  withStages?: ProjectWithStagesFilter;
  withStopped?: ProjectTriboolFilter;
};

export type ProjectIndividualArgs = {
  projectId: Scalars['Int'];
  search?: InputMaybe<Scalars['String']>;
};

export type ProjectInitiateJobDescriptionUploadArgs = {
  contentType: Scalars['String'];
  fileName: Scalars['String'];
};

export enum ProjectJobDescriptionProcessingStatus {
  Failed = 'FAILED',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING'
}

export type ProjectJobRoleModel = {
  __typename?: 'ProjectJobRoleModel';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['Int'];
  isLocalizedBenchmarkGroup?: Maybe<Scalars['Boolean']>;
  isMainRole: Scalars['Boolean'];
  jobRole: JobRoleModel;
  jobRoleId: Scalars['Int'];
  project: Project;
  projectId: Scalars['Int'];
  skillsProfile: SuccessProfile;
  skillsProfileId: Scalars['Int'];
  subId: Scalars['String'];
  updatedAt: Scalars['Date'];
};

export type ProjectJobRoleWithConfidenceModel = {
  __typename?: 'ProjectJobRoleWithConfidenceModel';
  confidenceRating: Scalars['Float'];
  projectJobRole: ProjectJobRoleModel;
};

export type ProjectManager = {
  __typename?: 'ProjectManager';
  /** The decorative role that user got assigned for this particular project. Optional. */
  actorRole?: Maybe<ActorRole>;
  avatarUrl?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  group?: Maybe<UserGroupModel>;
  groupId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  lastName?: Maybe<Scalars['String']>;
  projectId: Scalars['Int'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']>;
};

export type ProjectMeetingLinkedStatus = {
  __typename?: 'ProjectMeetingLinkedStatus';
  isLinked: Scalars['Boolean'];
  meetingId: Scalars['ID'];
};

export enum ProjectModuleType {
  Hiring = 'HIRING',
  TalentReview = 'TALENT_REVIEW'
}

export type ProjectNested = {
  __typename?: 'ProjectNested';
  id: Scalars['ID'];
};

export type ProjectOrderArgs = {
  direction?: SortOption;
  field?: ProjectOrderField;
};

export enum ProjectOrderField {
  CompanyName = 'COMPANY_NAME',
  ProjectActivity = 'PROJECT_ACTIVITY',
  ProjectCandidatesCount = 'PROJECT_CANDIDATES_COUNT',
  ProjectCompletedAssessmentCount = 'PROJECT_COMPLETED_ASSESSMENT_COUNT',
  ProjectCreatedAt = 'PROJECT_CREATED_AT',
  ProjectName = 'PROJECT_NAME',
  ProjectPublishedAt = 'PROJECT_PUBLISHED_AT',
  ProjectStages = 'PROJECT_STAGES',
  ProjectStatus = 'PROJECT_STATUS',
  ProjectUpdatedAt = 'PROJECT_UPDATED_AT',
  Status = 'STATUS'
}

export type ProjectRequestFileUploadArgs = {
  fileName: Scalars['String'];
  projectRequestId: Scalars['Int'];
};

export type ProjectRequestFileUploadModel = {
  __typename?: 'ProjectRequestFileUploadModel';
  blob?: Maybe<MonolithBlobModel>;
  blobId: Scalars['Int'];
  fileName: Scalars['String'];
  id: Scalars['Int'];
  projectRequest?: Maybe<ProjectRequestModel>;
  projectRequestId?: Maybe<Scalars['Int']>;
};

export type ProjectRequestModel = {
  __typename?: 'ProjectRequestModel';
  approvalRequestDate?: Maybe<Scalars['Date']>;
  companyId: Scalars['Int'];
  createdAt: Scalars['Date'];
  creator?: Maybe<User>;
  creatorId: Scalars['Int'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['Int'];
  managerSurveyId?: Maybe<Scalars['String']>;
  projectId?: Maybe<Scalars['Int']>;
  projectName: Scalars['String'];
  status: ProjectRequestStatus;
  updatedAt: Scalars['Date'];
};

export enum ProjectRequestStatus {
  ConfirmMatch = 'CONFIRM_MATCH',
  JobSpecsRecieved = 'JOB_SPECS_RECIEVED',
  ProjectCreated = 'PROJECT_CREATED',
  RequiresProject = 'REQUIRES_PROJECT'
}

export type ProjectRequestUserApprovalModel = {
  __typename?: 'ProjectRequestUserApprovalModel';
  approvalRequestDate: Scalars['Date'];
  approvalStatus: ProjectRequestUserApprovalStatus;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['Int'];
  updatedAt: Scalars['Date'];
};

export enum ProjectRequestUserApprovalStatus {
  Approved = 'APPROVED',
  Denied = 'DENIED',
  Sent = 'SENT'
}

export type ProjectRequestUserModel = {
  __typename?: 'ProjectRequestUserModel';
  approval?: Maybe<ProjectRequestUserApprovalModel>;
  approvalId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  projectRequest?: Maybe<ProjectRequestModel>;
  projectRequestId?: Maybe<Scalars['Int']>;
  type: ProjectRequestUserType;
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

export enum ProjectRequestUserType {
  AdditionalContact = 'ADDITIONAL_CONTACT',
  Manager = 'MANAGER',
  Recruiter = 'RECRUITER'
}

export type ProjectShortlistCriteriaSuggestion = {
  __typename?: 'ProjectShortlistCriteriaSuggestion';
  id: Scalars['ID'];
  sortOrder: Scalars['Int'];
  text: Scalars['String'];
};

export enum ProjectShortlistCriteriaSuggestionStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  NotStarted = 'NOT_STARTED',
  Processing = 'PROCESSING'
}

export enum ProjectSource {
  AdminApp = 'ADMIN_APP',
  RoleKickoff = 'ROLE_KICKOFF'
}

export enum ProjectStageAssessmentStatusFilter {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export type ProjectStageOrderArgs = {
  order: Scalars['Int'];
  stageId: Scalars['Int'];
  stageType: StageType;
};

export type ProjectStageOrderModel = {
  __typename?: 'ProjectStageOrderModel';
  activeCandidatesCount: Scalars['Int'];
  hiringProcessTemplateVersionStageId?: Maybe<Scalars['Int']>;
  order: Scalars['Int'];
  projectId: Scalars['Int'];
  stageActionName?: Maybe<Scalars['String']>;
  stageId: Scalars['Int'];
  stageName?: Maybe<Scalars['String']>;
  stageSubId?: Maybe<Scalars['ID']>;
  stageSubType?: Maybe<AssessmentStageKind>;
  stageType: StageType;
};

export type ProjectStageTypeFilterArgs = {
  assessmentStatus?: InputMaybe<ProjectStageAssessmentStatusFilter>;
  category: ProjectCandidateStageCategory;
  hasStageType: Scalars['Boolean'];
  interviewLinked?: InputMaybe<Scalars['Boolean']>;
  minCandidates?: InputMaybe<Scalars['Int']>;
};

export enum ProjectStatus {
  Closed = 'CLOSED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Review = 'REVIEW'
}

export enum ProjectTeamEmailMode {
  AccessBased = 'ACCESS_BASED',
  AssigneeBased = 'ASSIGNEE_BASED',
  Disabled = 'DISABLED',
  ProjectRoleAndAssigneeBased = 'PROJECT_ROLE_AND_ASSIGNEE_BASED',
  ProjectRoleBased = 'PROJECT_ROLE_BASED'
}

export type ProjectTeamEmailSettings = {
  __typename?: 'ProjectTeamEmailSettings';
  actorRoles: Array<ActorRole>;
  mode: ProjectTeamEmailMode;
};

export type ProjectTeamEmailSettingsArgs = {
  actorRoles: Array<ActorRole>;
  mode: ProjectTeamEmailMode;
};

export enum ProjectTriboolFilter {
  All = 'ALL',
  Only = 'ONLY',
  OnlyNot = 'ONLY_NOT'
}

export type ProjectUser = {
  __typename?: 'ProjectUser';
  actorRole?: Maybe<ActorRole>;
  project: Project;
  user: User;
};

export type ProjectWithStageCandidates = {
  __typename?: 'ProjectWithStageCandidates';
  id: Scalars['Int'];
  name: Scalars['String'];
  numberOfCompletedInTimeFrameStageCandidates: Scalars['Int'];
  numberOfStageCandidates: Scalars['Int'];
  percentageOfCompletedStageCandidates: Scalars['Float'];
};

export enum ProjectWithStagesFilter {
  All = 'ALL',
  DoesNotHaveStage = 'DOES_NOT_HAVE_STAGE',
  HasAssessmentStage = 'HAS_ASSESSMENT_STAGE',
  HasAssessmentStageAndInterviewStage = 'HAS_ASSESSMENT_STAGE_AND_INTERVIEW_STAGE',
  HasAssessmentStageOrInterviewStage = 'HAS_ASSESSMENT_STAGE_OR_INTERVIEW_STAGE',
  HasInterviewStage = 'HAS_INTERVIEW_STAGE',
  OnlyHasAssessmentStage = 'ONLY_HAS_ASSESSMENT_STAGE',
  OnlyHasInterviewStage = 'ONLY_HAS_INTERVIEW_STAGE'
}

export type QCalcPersonalityDisplayedAnswerModel = {
  __typename?: 'QCalcPersonalityDisplayedAnswerModel';
  ability?: Maybe<Scalars['Float']>;
  answerText?: Maybe<Scalars['String']>;
  answerValue?: Maybe<Scalars['Float']>;
  grade?: Maybe<Grade>;
  percentile?: Maybe<Scalars['Float']>;
  questionDifficulty?: Maybe<Scalars['Float']>;
  questionOrientation: QuestionOrientation;
  questionText: Scalars['String'];
  stenScore?: Maybe<Scalars['Float']>;
  zScore?: Maybe<Scalars['Float']>;
};

export type QCalcResponse = InductiveItemModel | NumericalTestletModel | PersonalityItemModel | TrItemModel | VerbalTestletModel;

export type QCalcTestletDisplayedAnswerModel = {
  __typename?: 'QCalcTestletDisplayedAnswerModel';
  answerText?: Maybe<Scalars['String']>;
  correctOptionText: Scalars['String'];
  inTime: Scalars['Boolean'];
  isCorrect: Scalars['Boolean'];
  questionDifficulty: Scalars['Float'];
  questionText: Scalars['String'];
};

export type QCalcTrDisplayedAnswerModel = {
  __typename?: 'QCalcTrDisplayedAnswerModel';
  answerText?: Maybe<Scalars['String']>;
  answerValue?: Maybe<Scalars['Float']>;
  questionOrientation: QuestionOrientation;
  questionText: Scalars['String'];
  score: Scalars['Float'];
};

export type Query = {
  __typename?: 'Query';
  Answer?: Maybe<Answer>;
  Answers?: Maybe<Array<Answer>>;
  ApiKeyCompanyFindMany: Array<AmApiKeyModel>;
  ApiKeyFindAll: Array<AmApiKeyModel>;
  ApiKeyUserFindOne?: Maybe<AmApiKeyModel>;
  ApiUserFindMany?: Maybe<Array<Maybe<ApiUserModel>>>;
  ApiUserFindOne?: Maybe<ApiUserModel>;
  AssessmentStageActionSupportedLocales: Array<SupportedLocale>;
  AssessmentStageResults: AssessmentStageResultsOutput;
  BehaviourContentFindOne: BehaviourContentModel;
  BehaviourFindOne?: Maybe<BehaviourModel>;
  CalibrationConfigExtendedGenerateOne: CalibrationConfigExtendedModel;
  CalibrationConfigFindOne?: Maybe<CalibrationConfigModel>;
  CalibrationConfigGenerateMany: Array<CalibrationConfigModel>;
  CalibrationConfigGenerateOne?: Maybe<CalibrationConfigModel>;
  CandidateFeedbackFindOneV2?: Maybe<CandidateFeedbackModelV2>;
  CandidateInterviewGuide: CandidateInterviewGuideModel;
  CandidateInterviewGuideForProjectCandidate: Array<CandidateInterviewGuideModel>;
  /** Every stage of one candidate's pipeline, in pipeline order, each carrying the headline result for its stage type. Stages the candidate has not reached are returned with no result rather than omitted. All scores are scoped to the candidate's main role. */
  CandidateOverviewStageResults: Array<CandidateOverviewStageResult>;
  CompaniesPaginated: CompaniesPaginatedGqlModel;
  CompanyAllowedEmailDomains?: Maybe<Array<Scalars['String']>>;
  CompanyEmployee?: Maybe<CompanyEmployeeModel>;
  CompanyEmployeeCompanyWriteAccess?: Maybe<Array<Scalars['Int']>>;
  CompanyEmployeeFindMany?: Maybe<Array<CompanyEmployeeModel>>;
  CompanyEmployeeFindOne?: Maybe<CompanyEmployeeModel>;
  CompanyEmployeeFreeTextSearchPaginate?: Maybe<CompanyEmployeeModelPaginated>;
  CompanyEmployees?: Maybe<Array<CompanyEmployeeModel>>;
  CompanyFindManyUsersWithRoles: CompanyUserInfoPaginated;
  CompanyFindUsers: Array<Maybe<User>>;
  CompanyFindUsersPaginated: UserModelPaginated;
  CompanyGetDefaultReports: CompanyDefaultReports;
  CompanyMaybeUserEmployeeFindMany?: Maybe<Array<CompanyMaybeUserEmployeeModel>>;
  CompanyMeetingConfigurationFindOne?: Maybe<CompanyMeetingConfigurationModel>;
  CompanyRole?: Maybe<CompanyRole>;
  CompanyRoles: Array<CompanyRole>;
  CompanySignature?: Maybe<CompanySignatureModel>;
  CompanySignatureFindMany?: Maybe<Array<CompanySignatureModel>>;
  CompanySignatureFindOne?: Maybe<CompanySignatureModel>;
  CompanySignatures?: Maybe<Array<CompanySignatureModel>>;
  /** Fetch paginated list of users and groups in a company with optional filtering by search, user type, and access levels. */
  CompanyUsersFindManyPaginated: CompanyUserModelPaginated;
  ContentViewerViewStageCandidateManagerReport: ContentViewerViewStageCandidateManagerReportModel;
  ContentViewerViewStageCandidateReport: ContentViewerViewStageCandidateReportModel;
  DeiStageAction?: Maybe<DeiStageActionModel>;
  DeiStageActionTemplate?: Maybe<DeiStageActionTemplateModel>;
  DynamicEnum?: Maybe<Scalars['String']>;
  /** @deprecated Use Project.locales */
  EntityLanguageFindMany?: Maybe<Array<EntityLanguageModel>>;
  Field?: Maybe<Field>;
  Fields?: Maybe<Array<Field>>;
  FindManyAssessmentBrowserSwitchCandidateTrackingEvent?: Maybe<Array<AssessmentCandidateBrowserSwitchTrackingEventModel>>;
  FindOneAssessmentBrowserSwitchCandidateTrackingEvent?: Maybe<AssessmentCandidateBrowserSwitchTrackingEventModel>;
  FindOneCandidatesDebriefCsvFileExportScheduledTask: FileExportScheduledTask;
  FindOneROICsvFileExportScheduledTask: FileExportScheduledTask;
  FindOneStageCandidateResultsCsvFileExportScheduledTask: FileExportScheduledTask;
  FindProjectCandidatesPaginated: ProjectCandidatesPaginated;
  FindProjectStageOrderByStage?: Maybe<ProjectStageOrderModel>;
  FindProjectStageOrdersByProject: Array<ProjectStageOrderModel>;
  /** Returns the order record for a specific stage, or null if the stage has no order entry. */
  FindRoleStageOrderByStage?: Maybe<RoleStageOrderModel>;
  /** Returns all stage order records for a role, in pipeline order. */
  FindRoleStageOrdersByRole: Array<RoleStageOrderModel>;
  FindScheduledTask: FileExportScheduledTask;
  FixContentPiece?: Maybe<ContentValidatiorPieceModel>;
  Form?: Maybe<Form>;
  FormBuilder?: Maybe<FormBuilder>;
  FormBuilderFindByOwnerAndType?: Maybe<FormBuilder>;
  FormReportFindAssociatedIds?: Maybe<FormReportIndividualQueries>;
  FormReportFindFormManagerTypes?: Maybe<FormReportIndividualQueries>;
  FormReportFindFormOwners?: Maybe<Array<FormReportFormOwners>>;
  FormReportFindFormTypes?: Maybe<FormReportIndividualQueries>;
  Forms?: Maybe<Array<Form>>;
  GetAdditionalAssessmentsTimeEstimates: Array<SkillsProfileSourceAdditionalAvailableAssessment>;
  GetAuthenticationMethods: Array<AuthenticationMethodModel>;
  GetCurrentProjectCollaborator?: Maybe<ProjectCollaborator>;
  GetDlxQueueMessageCount?: Maybe<Scalars['Float']>;
  GetHiringProcessTemplate?: Maybe<HiringProcessTemplate>;
  GetHiringProcessTemplateOptions: Array<HiringProcessTemplateOption>;
  GetHiringProcessTemplateVersion?: Maybe<HiringProcessTemplateVersion>;
  GetHiringProcessTemplateVersions: Array<HiringProcessTemplateVersion>;
  GetHiringProcessTemplates: HiringProcessTemplatePaginated;
  GetSkillsProfileTemplate?: Maybe<SkillsProfileTemplate>;
  GetSkillsProfileTemplateVersion?: Maybe<SkillsProfileTemplateVersion>;
  GetSkillsProfileTemplateVersions: Array<SkillsProfileTemplateVersion>;
  GetSkillsProfileTemplates: SkillsProfileTemplatePaginated;
  GetStageActionSummaries: Array<StageActionSummary>;
  /** Users of the given companies, for the roles list's hiring team filter. One row per user per company. */
  HiringTeamUsersFindMany: Array<HiringTeamUser>;
  IdentityProviderFindMany?: Maybe<Array<IdentityProviderModel>>;
  IdentityProviderFindOne?: Maybe<IdentityProviderModel>;
  InterviewAutosuggestionFindManyV2: Array<InterviewAutosuggestionModelV2>;
  InterviewDecisionFindOneV2?: Maybe<InterviewDecisionModelV2>;
  /** Get evaluation decision summaries for all interviews linked to an interview stage candidate */
  InterviewEvaluationDecisionsByStageCandidateFindMany: Array<InterviewEvaluationDecisionsModel>;
  InterviewEvaluationFindOne: InterviewEvaluationModel;
  /** Get aggregated evaluation results for an interview scoped to a project job role */
  InterviewEvaluationResultsFindOne: InterviewEvaluationResultsModel;
  InterviewEvaluatorFindOne: InterviewEvaluatorModel;
  InterviewFindManyByProjectCandidateV2: Array<InterviewV2Model>;
  InterviewFindManyV2: Array<InterviewV2Model>;
  InterviewFindOneV2?: Maybe<InterviewV2Model>;
  InterviewGuideBlueprint: InterviewGuideBlueprintModel;
  InterviewGuideContentTemplate?: Maybe<InterviewGuideContentTemplateModel>;
  InterviewGuideContentTemplateAffectedCount: InterviewGuideContentTemplateAffectedCountModel;
  InterviewQuestionRoleLevelContent: InterviewQuestionRoleLevel;
  InterviewQuestionRoleLevelContentFindManyAndCount: InterviewQuestionRoleLevelPaginatedModel;
  InterviewQuestionRoleLevelContents: Array<InterviewQuestionRoleLevel>;
  InterviewStage: InterviewStage;
  InterviewStages: Array<InterviewStage>;
  Invitation?: Maybe<InvitationModel>;
  InvitationFindMany?: Maybe<Array<InvitationModel>>;
  InvitationFindOne?: Maybe<InvitationModel>;
  InvitationSessionFindManyPaginated: InvitationSessionPaginated;
  InvitationSessionFindOne: InvitationSession;
  Invitations?: Maybe<Array<InvitationModel>>;
  JobRoleFindMany: Array<JobRoleModel>;
  JobRoleFindManyPaginated: JobRolePaginated;
  JobRoleFindOne?: Maybe<JobRoleModel>;
  LocationLinkFindMany: Array<LocationLinkModel>;
  MeetingCreateShareLink: Scalars['String'];
  MeetingFindMany: PaginatedMeetingModel;
  MeetingFindOne?: Maybe<MeetingModel>;
  MeetingTypeFindMany: Array<MeetingTypeModel>;
  MeetingTypeFindOne: MeetingTypeModel;
  MeetingUserCalendarFindMany: Array<MeetingUserCalendarModel>;
  MeetingUserCalendarFindOne?: Maybe<MeetingUserCalendarModel>;
  /** Returns the caller's pinned roles for their active workspace, oldest pin first. Archived roles and roles the caller can no longer see are omitted. */
  PinnedRoles: Array<RoleModel>;
  ProjectArtifactGetJobDescriptionUrl?: Maybe<Scalars['String']>;
  ProjectCandidate: ProjectCandidate;
  ProjectCandidateFindOneByInterviewStageCandidateId: ProjectCandidate;
  ProjectCandidates: ProjectCandidatesPaginated;
  /** How many of a role's active candidates would have their hiring process deadline extended to `deadlineAt` (their own deadline is earlier, or missing). Previews the "also apply to already-invited candidates" option of the deadline settings (CR-453). Requires STANDARD_ACCESS on the project's company. */
  ProjectCandidatesDeadlineExtensionCount: Scalars['Int'];
  ProjectCollaboratorsFindManyPaginated?: Maybe<ProjectCollaboratorPaginated>;
  /** Fetches a paginated list of individual project collaborators based on specified filters, including project ID and search criteria. It returns consolidated list of users that are on the project, either directly or through group, where each user appears only once */
  ProjectCollaboratorsIndividualFindManyPaginated?: Maybe<ProjectCollaboratorIndividualPaginated>;
  ProjectFindMany?: Maybe<Array<Project>>;
  ProjectFindManyByCompany: Array<Project>;
  ProjectFindManysByCompanyWithStageCandidateRange: Array<CompanyProjects>;
  ProjectGetAllowedTransitions: Array<ProjectStatus>;
  ProjectGetCandidateStageBreakdown: Array<ProjectCandidateStageBreakdown>;
  ProjectGetInterviewLinkCount: Scalars['Int'];
  ProjectJobRoleFindMany: Array<ProjectJobRoleModel>;
  ProjectJobRoleFindOne?: Maybe<ProjectJobRoleModel>;
  ProjectJobRoleRecent: Array<ProjectJobRoleModel>;
  ProjectJobRoleSearch: Array<ProjectJobRoleWithConfidenceModel>;
  ProjectRequest?: Maybe<ProjectRequestModel>;
  ProjectRequestFileUpload?: Maybe<ProjectRequestFileUploadModel>;
  ProjectRequestFileUploadFindMany: Array<ProjectRequestFileUploadModel>;
  ProjectRequestFileUploadFindOne?: Maybe<ProjectRequestFileUploadModel>;
  ProjectRequestFileUploads: Array<ProjectRequestFileUploadModel>;
  ProjectRequestFindMany?: Maybe<Array<ProjectRequestModel>>;
  ProjectRequestFindOne?: Maybe<ProjectRequestModel>;
  ProjectRequestUser?: Maybe<ProjectRequestUserModel>;
  ProjectRequestUserApproval?: Maybe<ProjectRequestUserApprovalModel>;
  ProjectRequestUserApprovalFindMany: Array<ProjectRequestUserApprovalModel>;
  ProjectRequestUserApprovalFindOne?: Maybe<ProjectRequestUserApprovalModel>;
  ProjectRequestUserApprovals: Array<ProjectRequestUserApprovalModel>;
  ProjectRequestUserFindMany: Array<ProjectRequestUserModel>;
  ProjectRequestUserFindOne?: Maybe<ProjectRequestUserModel>;
  ProjectRequestUsers: Array<ProjectRequestUserModel>;
  ProjectRequests: Array<ProjectRequestModel>;
  ProjectUserFindMany: Array<ProjectUser>;
  ProjectValidatePolicyActions: Array<Scalars['Boolean']>;
  ProjectWizardSkillsProfileSourcesByProjectId: Array<SkillsProfileSource>;
  Projects: PaginatedProjectsModel;
  QCalcTestDataCacheGetSupportedLocales: Array<Maybe<Scalars['String']>>;
  Report?: Maybe<Report>;
  ReportAssignment?: Maybe<ReportAssignment>;
  ReportAssignmentFindMany?: Maybe<Array<ReportAssignment>>;
  ReportAssignmentFindStageReport?: Maybe<ReportAssignment>;
  ReportAssignments?: Maybe<Array<ReportAssignment>>;
  ReportConfig?: Maybe<ReportConfig>;
  ReportConfigFindMany?: Maybe<Array<ReportConfig>>;
  ReportConfigs?: Maybe<Array<ReportConfig>>;
  ReportFindMany?: Maybe<Array<Report>>;
  ReportRender?: Maybe<ReportRender>;
  ReportRenderDeleteMany?: Maybe<DeleteResult>;
  ReportRenderFindMany?: Maybe<Array<ReportRender>>;
  ReportRenderFindOne?: Maybe<ReportRender>;
  ReportRenderWithDataApi?: Maybe<ReportRender>;
  ReportRenders: Array<ReportRender>;
  Reports?: Maybe<Array<Report>>;
  ReportsFindByCompany?: Maybe<Array<Report>>;
  RespondantForm?: Maybe<RespondantForm>;
  ResultValidatedSkills: ResultValidatedSkillsPaginatedModel;
  RoleFindMany: Array<Role>;
  RoleRequisitionHistory: RoleRequisitionHistoryModel;
  /** Returns available assessments for the role RSP. Used before RoleWizardConfirmRSP. */
  RoleWizardAvailableAssessments: SuccessProfileAvailableAssessments;
  /** Checks whether any of the supplied meeting ids are already linked to a role. */
  RoleWizardCheckMeetingLinks: Array<ProjectMeetingLinkedStatus>;
  RoleWizardFindRequisitionsPaginated: RequisitionPaginatedModel;
  /** Returns a pre-signed download URL for the job description, or null if none is attached. */
  RoleWizardGetJobDescriptionUrl?: Maybe<Scalars['String']>;
  /** Returns company-scoped roles matching the supplied filters. */
  RoleWizardRoleFindMany: RolePaginatedModel;
  /** Returns null when the role does not exist or belongs to a different company. */
  RoleWizardRoleFindOne?: Maybe<RoleModel>;
  Roles: Array<Role>;
  /** Counts company-scoped roles where the caller is a hiring team member, directly or via a user group. Applies only the structural subset of the supplied filters. */
  RolesHiringTeamMembershipCount: Scalars['Int'];
  RssAssessmentCandidateOpenOne: RssCandidateOpenOneModel;
  /** @deprecated Please use "query RssAsssessmentFindAllForStage" instead! */
  RssAssessmentFindMany: Array<RssAssessmentModel>;
  RssAsssessmentFindAllForStage: Array<RssAssessmentModel>;
  SamlAuthInfoFindMany?: Maybe<Array<SamlAuthInfoModel>>;
  SamlAuthInfoFindOne?: Maybe<SamlAuthInfoModel>;
  SharedMeetingFindOne: SharedMeetingModel;
  ShortlistStageResumes: Array<ShortlistStageResume>;
  ShortlistedCandidatesCount: Scalars['Int'];
  SkillCategoryFindMany: Array<SkillCategory>;
  SkillsEvaluationFindOneV2?: Maybe<SkillsEvaluationModelV2>;
  SkillsProfileOpenOne: SkillsProfileOpenOneModel;
  SkillsProfileSource: SkillsProfileSource;
  SkillsProfileSourceAvailableAssessments: SkillsProfileSourceAvailableAssessments;
  SkillsProfileSourceByJobRoleId?: Maybe<SkillsProfileSource>;
  SkillsProfileSourceByMeetingId?: Maybe<SkillsProfileSource>;
  SkillsProfileSourceCheckMeetingLinks: SkillsProfileSourceMeetingLinks;
  SkillsProfileSourceGetJobDescriptionUrl?: Maybe<Scalars['String']>;
  SkillsProfileSources: SkillsProfileSourcesPaginated;
  SoftSkill?: Maybe<SoftSkill>;
  SoftSkillFindMany?: Maybe<Array<SoftSkill>>;
  SoftSkillFindManyPaginated: PaginatedSoftSkillGqlModel;
  SoftSkillGetAllValidForProject: Array<SoftSkill>;
  SoftSkillRoleLevelContent: SoftSkillRoleLevelContent;
  SoftSkillRoleLevelContentFindManyAndCount: SoftSkillRoleLevelContentPaginated;
  SoftSkillRoleLevelContents: Array<SoftSkillRoleLevelContent>;
  SoftSkillSuccessProfileContent: SoftSkillSuccessProfileContent;
  SoftSkillSuccessProfileContentFindManyAndCount: SoftSkillSuccessProfileContentPaginated;
  SoftSkillSuccessProfileContents: Array<SoftSkillSuccessProfileContent>;
  SoftSkillTraitFindManyBySoftSkill?: Maybe<Array<SoftSkillTrait>>;
  SoftSkillTraitFindManyBySoftSkills?: Maybe<Array<SoftSkillTrait>>;
  SoftSkillTraits?: Maybe<Array<SoftSkillTrait>>;
  SoftSkillTypeSuccessProfileContent: SoftSkillTypeSuccessProfileContent;
  SoftSkillTypeSuccessProfileContentFindMany: Array<SoftSkillTypeSuccessProfileContent>;
  SoftSkillTypeSuccessProfileContentFindOne: SoftSkillTypeSuccessProfileContent;
  SoftSkillTypeSuccessProfileContents: Array<SoftSkillTypeSuccessProfileContent>;
  SoftSkills?: Maybe<Array<SoftSkill>>;
  /** @deprecated Use assessmentStage query instead! */
  Stage?: Maybe<SmStageModel>;
  StageCandidateFindById?: Maybe<SmStageCandidateModel>;
  StageCandidateFindBySubId?: Maybe<SmStageCandidateModel>;
  StageCandidateFindMany?: Maybe<Array<SmStageCandidateModel>>;
  StageCandidateFindOne?: Maybe<SmStageCandidateModel>;
  StageCandidateSkillsProfileResultsFindOne: StageCandidateSkillsProfileResultsModel;
  /** @deprecated Please use query AssessmentStageResults instead! */
  StageCandidateStatisticsByProjectJobRoleFindMany: StageCandidateStatisticsByProjectJobRoleFindManyOutput;
  /** @deprecated Please use query AssessmentStageResults instead! */
  StageCandidateStatisticsFindMany: StageCandidateStatisticsFindManyOutput;
  StageCandidateStatisticsFindOne: StageCandidateStatisticsModel;
  /** @deprecated Use `ProjectFindMany` and load the `assessmentStage` property the return type to fetch assessmentStages by project! */
  StageFindMany?: Maybe<Array<SmStageModel>>;
  /** @deprecated Either use `assessmentStage` query or load a project with the `assessmentStage` property loaded. */
  StageFindOne?: Maybe<SmStageModel>;
  /** @deprecated Use the "inviteUrl" property on AssessmentStage instead! */
  StageGenerateIndirectInvitationUrl: GenerateStageIndirectInvitationUrlModel;
  StageProgressSummary?: Maybe<StageCandidateStatisticsFindManyOutput>;
  /** @deprecated Please use query AssessmentStageResults instead! */
  StageResultsSummary: StageCandidateStatisticsByProjectJobRoleFindManyOutput;
  /** @deprecated Success Profile no longer has a link with Project. If you're looking for the Success Profiles connected to a Project, fetch the linked ProjectJobRoles. */
  SuccessProfile?: Maybe<SuccessProfile>;
  SuccessProfileAvailableAssessments: SuccessProfileAvailableAssessments;
  SuccessProfileFindMany?: Maybe<Array<SuccessProfile>>;
  SuccessProfileTechnicalSkill?: Maybe<SuccessProfileTechnicalSkill>;
  SuccessProfileTechnicalSkillFindMany: Array<SuccessProfileTechnicalSkill>;
  SuccessProfileTechnicalSkillFindOne?: Maybe<SuccessProfileTechnicalSkill>;
  SuccessProfileTechnicalSkills: Array<SuccessProfileTechnicalSkill>;
  SuccessProfiles?: Maybe<Array<SuccessProfile>>;
  SummaryTemplateFindMany: PaginatedSummaryTemplateModel;
  SummaryTemplateFindOne?: Maybe<SummaryTemplateModel>;
  SzSkillsMerge?: Maybe<SzSkillsMerge>;
  SzSkillsMergeFindMany: Array<SzSkillsMerge>;
  SzSkillsMergeFindOne?: Maybe<SzSkillsMerge>;
  SzSkillsMergeFreeTextSearchPaginated: PaginatedSzSkillsMerge;
  TechnicalSkill: TechnicalSkill;
  /** @deprecated Please use TechnicalSkillFindManyPaginated instead */
  TechnicalSkillFindMany: Array<TechnicalSkill>;
  TechnicalSkillFindManyPaginated: PaginatedTechnicalSkillModel;
  TechnicalSkillFreeTextSearchPaginated: PaginatedTechnicalSkill;
  Trait?: Maybe<Trait>;
  TraitFindManyBySoftSkillId?: Maybe<Array<Trait>>;
  TraitRoleLevelContent: TraitRoleLevelContent;
  TraitRoleLevelContentFindManyAndCount: TraitRoleLevelContentPaginatedModel;
  TraitRoleLevelContents: Array<TraitRoleLevelContent>;
  TraitSoftSkillContextCsvGenerateAndUpload?: Maybe<MonolithBlobModel>;
  TraitSoftSkillContextFindMany?: Maybe<Array<TraitSoftSkillContextModel>>;
  TraitSoftSkillContextFindOne?: Maybe<TraitSoftSkillContextModel>;
  Traits?: Maybe<Array<Trait>>;
  TranslatedProjectCandidateProfile: ProjectCandidateProfile;
  TranslatedShortlistStageCandidateCitations: Array<ShortlistStageCandidateCriterionResult>;
  UnifiedMeetings: PaginatedUnifiedMeeting;
  UpcomingMeetingFindBySharedId?: Maybe<UpcomingMeetingModel>;
  UpcomingMeetingFindMany: PaginatedUpcomingMeetingModel;
  UpcomingMeetingFindOne?: Maybe<UpcomingMeetingModel>;
  User?: Maybe<User>;
  UserCompanyInfo?: Maybe<UserCompanyInfo>;
  UserCompanyInfoFindMany?: Maybe<Array<UserCompanyInfo>>;
  UserCompanyInfoFindOne?: Maybe<UserCompanyInfo>;
  UserCompanyInfos?: Maybe<Array<UserCompanyInfo>>;
  UserFreeTextSearchPaginate?: Maybe<UserModelPaginated>;
  UserGroupFindManyPaginated: UserGroupPaginatedModel;
  UserGroupFindOne: UserGroupModel;
  UserGroupMemberFindManyPaginated: UserModelPaginated;
  UserMeetingConfigurationFindOne?: Maybe<UserMeetingConfigurationModel>;
  UserSettings?: Maybe<UserSettings>;
  UserSettingsFindMany?: Maybe<Array<UserSettings>>;
  UserSettingsFindOne?: Maybe<UserSettings>;
  UserSettingss?: Maybe<Array<UserSettings>>;
  Users?: Maybe<Array<User>>;
  ValidateContent?: Maybe<ContentValidator>;
  ValidateContentPiece?: Maybe<ContentValidatiorPieceModel>;
  Widget?: Maybe<Widget>;
  WidgetConfig?: Maybe<WidgetConfig>;
  WidgetConfigFindMany?: Maybe<Array<WidgetConfig>>;
  WidgetConfigs?: Maybe<Array<WidgetConfig>>;
  WidgetFindMany?: Maybe<Array<Widget>>;
  WidgetOption?: Maybe<WidgetOption>;
  WidgetOptionFindMany?: Maybe<Array<WidgetOption>>;
  WidgetOptions?: Maybe<Array<WidgetOption>>;
  Widgets?: Maybe<Array<Widget>>;
  aiInterviewAssessmentStageAction?: Maybe<AiInterviewAssessmentStageAction>;
  aiInterviewAssessmentStageActionCandidate: AiInterviewAssessmentStageActionCandidate;
  aiInterviewAssessmentStageActionCandidateByConferenceId: AiInterviewAssessmentStageActionCandidate;
  aiInterviewAssessmentStageActionCandidateRoleStage: AiInterviewAssessmentStageActionCandidateRoleStage;
  assessmentStage: AssessmentStage;
  /** The company's FULL ATS rejection-reason catalogue, ignoring the allowlist. Used by the admin client's Integrations settings to configure the allowlist. Admin-only. */
  atsAllRejectionReasons: Array<RejectionReasonGqlModel>;
  /** The company's tenant-wide distinct ATS stage catalogue — the option set for stage-map configuration. Stages whose provider-native ref is not yet back-filled are excluded; missingRefCount says how many were, so an empty list can be told apart from an unsynced integration. Admin-only. */
  atsAllStages: AtsStageCatalogueGqlModel;
  /** Read the per-customer ATS settings (progression / application-tracking flags). Returns null when the company has no active Kombo integration. Admin-only. */
  atsSettings?: Maybe<AtsSettingsGqlModel>;
  /** Interviewer calendar access and busy time over a window, for choosing interview times */
  availabilityPreview: AvailabilityPreviewModel;
  /** Whether each candidate has an assessment report and an interview guide to link on the hiring team's invite */
  candidateMaterialsAvailability: Array<CandidateMaterialsAvailabilityModel>;
  coderbyteAssessmentDetails?: Maybe<CoderbyteAssessmentStageActionDetails>;
  coderbyteAvailableAssessments: Array<CoderbyteAvailableAssessment>;
  /** A company's Coderbyte workspace, or null if it has none. */
  coderbyteWorkspace?: Maybe<CoderbyteWorkspace>;
  /** Reveals the stored Coderbyte admin password. Its own operation rather than a field, so a secret only leaves the server when something asked for it outright. Every call is logged. */
  coderbyteWorkspaceAdminPassword?: Maybe<Scalars['String']>;
  /** Reveals the stored workspace API key. Its own operation rather than a field, so a secret only leaves the server when something asked for it outright. Every call is logged. */
  coderbyteWorkspaceApiKey?: Maybe<Scalars['String']>;
  /** Every company with a Coderbyte workspace, newest first. Backs the integrations dashboard. */
  coderbyteWorkspaces: Array<CoderbyteWorkspace>;
  cognitiveTestAssessmentStageActionCandidate: CognitiveTestAssessmentStageActionCandidate;
  companies?: Maybe<Array<Company>>;
  company?: Maybe<Company>;
  companyFindManyByIds?: Maybe<Array<Company>>;
  companySchedulingSettings: CompanySchedulingSettingsModel;
  companySettingChanges: PaginatedCompanySettingChangesModel;
  conference: Conference;
  englishProficiencyAssessment: EnglishProficiencyAssessment;
  englishProficiencyAssessmentStageActionCandidate: EnglishProficiencyAssessmentStageActionCandidate;
  generateCoderbyteTechnicalSkills: Array<TechnicalSkill>;
  getAllProjectFiles: Array<ProjectFile>;
  getAllProjects: Array<Project>;
  getCompanyId: ProjectCompanyId;
  getEditingInfo?: Maybe<EditingInfoModel>;
  getFormReportCSV?: Maybe<Scalars['String']>;
  getInvitationStatus: InvitationStatusResult;
  getProjectById?: Maybe<Project>;
  getProjectCobranding: ProjectCobrandingModel;
  getProjectSamlAuthInfo: Scalars['String'];
  hello: Scalars['String'];
  /** Whether this company has a Coderbyte workspace in service, and so whether `createCoderbyteSsoLink` has anywhere to send the caller. False for a caller who holds no role at the company. */
  isCoderbyteWorkspaceAvailable: Scalars['Boolean'];
  /** List all Kombo integrations (paginated). Each integration represents a company's connection to an ATS via Kombo, with separate IDs for ATS sync and assessment operations. */
  komboIntegrationsFindManyPaginated: KomboIntegrationPaginated;
  /** Get the Kombo integration for a specific company. Returns null if the company has no Kombo integration. */
  komboIntegrationsFindOne?: Maybe<KomboIntegrationModel>;
  /** Get a single cached Kombo job by its internal ID, along with its linked project (if any). */
  komboJobFindOne?: Maybe<KomboJobWithProject>;
  /** List cached Kombo jobs for a company (paginated). Supports filtering by status, search term, and whether a project is linked. Each result includes the job and its linked project (if any). */
  komboJobsFindManyPaginated: KomboJobWithProjectPaginated;
  /** Get sync history for a company (most recent first). */
  komboSyncHistory: Array<KomboSyncRunModel>;
  /** Get a specific sync run by ID. */
  komboSyncRun?: Maybe<KomboSyncRunModel>;
  /** Get the sync health status for a company's Kombo integration. Returns sync state, last sync timestamp, error info, and cached job count. */
  komboSyncStatus?: Maybe<KomboSyncStatusModel>;
  /** A candidate's most recent cancelled scheduling request at a stage, for the drawer to show while nothing newer stands; null when none was cancelled */
  latestCancelledSchedulingRequest?: Maybe<SchedulingCancellationModel>;
  me: User;
  myRole: MyRole;
  myRoles: Array<MyRole>;
  omnisearch: OmnisearchAll;
  omnisearchCandidates: CandidateSearchPage;
  omnisearchResolveRecents: OmnisearchRecents;
  omnisearchRoles: RoleSearchPage;
  orgCalendarConnectionHistory: OrgCalendarConnectionHistoryModel;
  orgCalendarConsentRefusals: Array<OrgCalendarConsentRefusalModel>;
  orgCalendarGrant?: Maybe<OrgCalendarGrantModel>;
  personalityTestAssessmentStageActionCandidate: PersonalityTestAssessmentStageActionCandidate;
  /** Rejection reasons recently used on a role, for the "Recent reasons" section of the reject modal. Pass `projectId` alone to aggregate across the whole role, or add `stageId` to narrow to rejections made from that stage. Distinct, most-recent first. Requires STANDARD_ACCESS on the project's company. */
  recentRejectionReasons: Array<RecentRejectionReasonGqlModel>;
  /** Get recently accessed workspaces for the current user */
  recentWorkspaces: Array<WorkspaceModel>;
  /** The company's ATS rejection-reason catalogue, fetched live from the connected ATS for the reject modal. Returns an empty list when the company has no ATS integration, the integration has no named reasons, or the gateway is unavailable — never an error. The `id` round-trips verbatim to the ATS on reject. When an allowlist is configured for the company, only allowlisted reasons are returned. */
  rejectionReasons: Array<RejectionReasonGqlModel>;
  /** The rejection reasons offered for rejecting these candidates: `rejectionReasons`, further narrowed to the reasons valid at every candidate's current ATS stage when the company has per-stage rejection reasons configured (Workday only today, since only Workday rejects an invalid reason). `isStageScoped` is true when that narrowing applied, so an empty list can be told apart from an unavailable catalogue. Refuses more than 2,000 `subIds`. */
  rejectionReasonsForCandidates: RejectionReasonsForCandidatesGqlModel;
  /** Resolve a share link token to get workspace and URL information */
  resolveShareLink: ShareLinkDataModel;
  /** A saved batch read back to reopen the wizard: its requests, with their interview details, and the interviewers they name */
  schedulingBatch: SchedulingSavedBatchModel;
  /** The interview times a batch already offers, to reopen it */
  schedulingBatchSlots: Array<OfferedSlotModel>;
  /** A sent scheduling request's candidate booking link, for the recruiter to copy. Refused when the link would open nothing the candidate can act on: a draft, a cancelled, declined or expired request, or an offer whose link has run out */
  schedulingBookingLink: Scalars['String'];
  /** How the request's current interviewers have replied to the calendar invitation, for the drawer */
  schedulingInterviewerReplies: SchedulingInterviewerRepliesModel;
  /** One candidate's scheduling request, for the drawer */
  schedulingRequest: SchedulingRequestModel;
  /** The interview times a sent request offers its candidate right now: what their booking link shows, for the drawer. A batch's chosen slots can still include an earlier round's times, so the drawer reads this instead */
  schedulingRequestOfferedSlots: Array<OfferedSlotModel>;
  /** What has happened to one candidate's scheduling request, oldest first, for the drawer */
  schedulingRequestTimeline: Array<SchedulingTimelineEntryModel>;
  /** Interview scheduling state for every candidate at a stage */
  stageSchedulingProjection: Array<StageSchedulingRowModel>;
  /** Get all workspaces available to the current user (paginated) */
  workspaces: WorkspacesResponse;
};


export type QueryAnswerArgs = {
  id: Scalars['Int'];
};


export type QueryAnswersArgs = {
  associatedId?: InputMaybe<Scalars['Int']>;
  associatedIds?: InputMaybe<Array<Scalars['Int']>>;
  fieldId?: InputMaybe<Scalars['Int']>;
  fields?: InputMaybe<Array<Scalars['Int']>>;
  formId?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  respondantId?: InputMaybe<Scalars['Int']>;
  respondantIds?: InputMaybe<Array<Scalars['Int']>>;
  response?: InputMaybe<Scalars['String']>;
};


export type QueryApiKeyCompanyFindManyArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  getOption?: InputMaybe<GetOption>;
  permission?: InputMaybe<IdentityPermissionRole>;
  relationDepth?: InputMaybe<RelationDepth>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryApiKeyUserFindOneArgs = {
  getOption?: InputMaybe<GetOption>;
  relationDepth?: InputMaybe<RelationDepth>;
  userEmail?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Int']>;
  userSubId?: InputMaybe<Scalars['String']>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryApiUserFindManyArgs = {
  clientId?: InputMaybe<Scalars['String']>;
  clientIds?: InputMaybe<Array<Scalars['String']>>;
  companyId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  getOption?: InputMaybe<GetOption>;
  hasClientSecret?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  ownerId?: InputMaybe<Scalars['Int']>;
  ownerIds?: InputMaybe<Array<Scalars['Int']>>;
  ownerType?: InputMaybe<ApiUserOwnerType>;
  puppetUserId?: InputMaybe<Scalars['Int']>;
  puppetUserIds?: InputMaybe<Array<Scalars['Int']>>;
  relationDepth?: InputMaybe<RelationDepth>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryApiUserFindOneArgs = {
  clientId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  getOption?: InputMaybe<GetOption>;
  hasClientSecret?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  ownerId?: InputMaybe<Scalars['Int']>;
  ownerType?: InputMaybe<ApiUserOwnerType>;
  puppetUserId?: InputMaybe<Scalars['Int']>;
  relationDepth?: InputMaybe<RelationDepth>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryAssessmentStageActionSupportedLocalesArgs = {
  kind: AssessmentStageActionKind;
};


export type QueryAssessmentStageResultsArgs = {
  filter?: InputMaybe<AssessmentStageResultsFilterArgs>;
  order?: InputMaybe<AssessmentStageResultsOrderArgs>;
  paginate?: InputMaybe<OffsetBasedPaginationArgs>;
  projectJobRoleId?: InputMaybe<Scalars['Int']>;
  stageId: Scalars['Int'];
};


export type QueryBehaviourContentFindOneArgs = {
  behaviourId?: InputMaybe<Scalars['Int']>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']>;
  negativeSummary?: InputMaybe<Scalars['String']>;
  positiveSummary?: InputMaybe<Scalars['String']>;
  relationDepth?: InputMaybe<RelationDepth>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryBehaviourFindOneArgs = {
  contextIds?: InputMaybe<Array<Scalars['Int']>>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']>;
  internalName?: InputMaybe<Scalars['String']>;
  relationDepth?: InputMaybe<RelationDepth>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryCalibrationConfigExtendedGenerateOneArgs = {
  doneBy: Scalars['Int'];
  projectJobRoleId?: InputMaybe<Scalars['Int']>;
  scoreType: ResultScoreType;
  stageCandidateId: Scalars['Int'];
};


export type QueryCalibrationConfigFindOneArgs = {
  ig?: InputMaybe<Scalars['Boolean']>;
  projectId: Scalars['Int'];
};


export type QueryCalibrationConfigGenerateManyArgs = {
  ig?: InputMaybe<Scalars['Boolean']>;
  projectId?: InputMaybe<Scalars['Int']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryCalibrationConfigGenerateOneArgs = {
  ig?: InputMaybe<Scalars['Boolean']>;
  projectId: Scalars['Int'];
};


export type QueryCandidateFeedbackFindOneV2Args = {
  id?: InputMaybe<Scalars['String']>;
  interviewEvaluationId?: InputMaybe<Scalars['String']>;
};


export type QueryCandidateInterviewGuideArgs = {
  locale?: InputMaybe<SupportedLocale>;
  subId: Scalars['ID'];
};


export type QueryCandidateInterviewGuideForProjectCandidateArgs = {
  projectCandidateSubId: Scalars['ID'];
};


export type QueryCandidateOverviewStageResultsArgs = {
  projectCandidateSubId: Scalars['ID'];
};


export type QueryCompaniesPaginatedArgs = {
  filters?: InputMaybe<CompaniesPaginatedFilters>;
  includeCompanyIds?: InputMaybe<Array<Scalars['Int']>>;
  pagination?: InputMaybe<OffsetBasedPaginationArgs>;
};


export type QueryCompanyAllowedEmailDomainsArgs = {
  id: Scalars['Float'];
};


export type QueryCompanyEmployeeArgs = {
  id: Scalars['Int'];
};


export type QueryCompanyEmployeeFindManyArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  customFields?: InputMaybe<UserCompanyInfoCustomFieldsArgs>;
  department?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  employeeId?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['String']>>;
  endDate?: InputMaybe<Scalars['Date']>;
  firstName?: InputMaybe<Scalars['String']>;
  getOption?: InputMaybe<GetOption>;
  hrManagerEmployeeId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  relationDepth?: InputMaybe<RelationDepth>;
  startDate?: InputMaybe<Scalars['Date']>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryCompanyEmployeeFindOneArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  customFields?: InputMaybe<UserCompanyInfoCustomFieldsArgs>;
  department?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Date']>;
  firstName?: InputMaybe<Scalars['String']>;
  getOption?: InputMaybe<GetOption>;
  hrManagerEmployeeId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  relationDepth?: InputMaybe<RelationDepth>;
  startDate?: InputMaybe<Scalars['Date']>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryCompanyEmployeeFreeTextSearchPaginateArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  freetext?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<CompanyEmployeeOrderByArgs>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCompanyFindManyUsersWithRolesArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  skip: Scalars['Int'];
  take: Scalars['Int'];
  userRoles: Array<IdentityPermissionRole>;
};


export type QueryCompanyFindUsersArgs = {
  id: Scalars['Int'];
};


export type QueryCompanyFindUsersPaginatedArgs = {
  id: Scalars['Int'];
  skip: Scalars['Int'];
  take: Scalars['Int'];
};


export type QueryCompanyMaybeUserEmployeeFindManyArgs = {
  companyId: Scalars['Float'];
};


export type QueryCompanyRoleArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['Int']>;
  isPasswordDisabled?: InputMaybe<Scalars['Boolean']>;
  roleId?: InputMaybe<Scalars['Int']>;
  twoFactorEnabled?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};


export type QueryCompanyRolesArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdAts?: InputMaybe<Array<Scalars['Date']>>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedAts?: InputMaybe<Array<Scalars['Date']>>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  isPasswordDisabled?: InputMaybe<Scalars['Boolean']>;
  roleId?: InputMaybe<Scalars['Int']>;
  roleIds?: InputMaybe<Array<Scalars['Int']>>;
  twoFactorEnabled?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedAts?: InputMaybe<Array<Scalars['Date']>>;
};


export type QueryCompanySignatureArgs = {
  id: Scalars['Int'];
};


export type QueryCompanySignatureFindManyArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  relationDepth?: InputMaybe<RelationDepth>;
  signature?: InputMaybe<Scalars['String']>;
  signatureEmail?: InputMaybe<Scalars['String']>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryCompanySignatureFindOneArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  relationDepth?: InputMaybe<RelationDepth>;
  signature?: InputMaybe<Scalars['String']>;
  signatureEmail?: InputMaybe<Scalars['String']>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryCompanyUsersFindManyPaginatedArgs = {
  args: CompanyUsersArgs;
  order?: CompanyUsersOrderOptions;
  paginate?: OffsetBasedPaginationArgs;
};


export type QueryContentViewerViewStageCandidateManagerReportArgs = {
  stageCandidateSub: Scalars['String'];
};


export type QueryContentViewerViewStageCandidateReportArgs = {
  stageCandidateSub: Scalars['String'];
};


export type QueryDeiStageActionArgs = {
  stageId: Scalars['Int'];
};


export type QueryDeiStageActionTemplateArgs = {
  companyId: Scalars['Int'];
};


export type QueryEntityLanguageFindManyArgs = {
  entityId?: InputMaybe<Scalars['Int']>;
  entityIds?: InputMaybe<Array<Scalars['Int']>>;
  entityType?: InputMaybe<EntityType>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  language?: InputMaybe<Language>;
  relationDepth?: InputMaybe<RelationDepth>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryFieldArgs = {
  id: Scalars['Int'];
};


export type QueryFieldsArgs = {
  fieldType?: InputMaybe<FieldType>;
  formManagerType?: InputMaybe<FormManagerType>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  question?: InputMaybe<Scalars['String']>;
};


export type QueryFindManyAssessmentBrowserSwitchCandidateTrackingEventArgs = {
  assessmentId?: InputMaybe<Scalars['Int']>;
  assessmentIds?: InputMaybe<Array<Scalars['Int']>>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdAts?: InputMaybe<Array<Scalars['Date']>>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedAts?: InputMaybe<Array<Scalars['Date']>>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  subId?: InputMaybe<Scalars['String']>;
  subIds?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<AssessmentBrowserSwitchCandidateTrackingEvent>;
  types?: InputMaybe<Array<AssessmentBrowserSwitchCandidateTrackingEvent>>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedAts?: InputMaybe<Array<Scalars['Date']>>;
};


export type QueryFindOneAssessmentBrowserSwitchCandidateTrackingEventArgs = {
  assessmentId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['Int']>;
  subId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<AssessmentBrowserSwitchCandidateTrackingEvent>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};


export type QueryFindOneCandidatesDebriefCsvFileExportScheduledTaskArgs = {
  id?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ScheduledTaskStatus>;
  subId?: InputMaybe<Scalars['String']>;
  triggeredBy?: InputMaybe<Scalars['Int']>;
};


export type QueryFindOneRoiCsvFileExportScheduledTaskArgs = {
  id?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ScheduledTaskStatus>;
  subId?: InputMaybe<Scalars['String']>;
  triggeredBy?: InputMaybe<Scalars['Int']>;
};


export type QueryFindOneStageCandidateResultsCsvFileExportScheduledTaskArgs = {
  id?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ScheduledTaskStatus>;
  subId?: InputMaybe<Scalars['String']>;
  triggeredBy?: InputMaybe<Scalars['Int']>;
};


export type QueryFindProjectCandidatesPaginatedArgs = {
  aiInterviewStageFilters?: InputMaybe<FindProjectCandidatesPaginatedAiInterviewStageFilterArgs>;
  args: ProjectCandidatesArgs;
  generalFilters?: FindProjectCandidatesPaginatedFilterArgs;
  order?: FindProjectCandidatesPaginatedOrderArgs;
  pagination?: OffsetBasedPaginationArgs;
  progressionFilters: FindProjectCandidatesPaginatedProgressionFilterArgs;
  shortlistStageFilters?: InputMaybe<FindProjectCandidatesPaginatedShortlistStageFilterArgs>;
};


export type QueryFindProjectStageOrderByStageArgs = {
  stageId: Scalars['Int'];
  stageType: StageType;
};


export type QueryFindProjectStageOrdersByProjectArgs = {
  projectId: Scalars['Int'];
};


export type QueryFindRoleStageOrderByStageArgs = {
  stageId: Scalars['Int'];
  stageType: StageType;
};


export type QueryFindRoleStageOrdersByRoleArgs = {
  roleId: Scalars['Int'];
};


export type QueryFindScheduledTaskArgs = {
  id?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ScheduledTaskStatus>;
  subId?: InputMaybe<Scalars['String']>;
  triggeredBy?: InputMaybe<Scalars['Int']>;
};


export type QueryFixContentPieceArgs = {
  softSkillId: Scalars['Int'];
  traitIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryFormArgs = {
  id: Scalars['Int'];
};


export type QueryFormBuilderArgs = {
  id: Scalars['Int'];
};


export type QueryFormBuilderFindByOwnerAndTypeArgs = {
  formManagerType?: InputMaybe<FormManagerType>;
  formOwnerId?: InputMaybe<Scalars['Int']>;
  formType?: InputMaybe<FormType>;
};


export type QueryFormReportFindAssociatedIdsArgs = {
  formManagerType?: InputMaybe<FormManagerType>;
  formOwnerId?: InputMaybe<Scalars['Int']>;
  formType?: InputMaybe<FormType>;
};


export type QueryFormReportFindFormOwnersArgs = {
  formManagerType: FormManagerType;
  formType: FormType;
};


export type QueryFormReportFindFormTypesArgs = {
  formManagerType: FormManagerType;
};


export type QueryFormsArgs = {
  formManagerType?: InputMaybe<FormManagerType>;
  formOwnerId?: InputMaybe<Scalars['Int']>;
  formType?: InputMaybe<FormType>;
  name?: InputMaybe<Scalars['String']>;
};


export type QueryGetAuthenticationMethodsArgs = {
  email: Scalars['String'];
};


export type QueryGetCurrentProjectCollaboratorArgs = {
  projectId: Scalars['Int'];
};


export type QueryGetHiringProcessTemplateArgs = {
  templateId: Scalars['Int'];
};


export type QueryGetHiringProcessTemplateOptionsArgs = {
  companyId: Scalars['Int'];
};


export type QueryGetHiringProcessTemplateVersionArgs = {
  versionId: Scalars['Int'];
};


export type QueryGetHiringProcessTemplateVersionsArgs = {
  templateId: Scalars['Int'];
};


export type QueryGetHiringProcessTemplatesArgs = {
  filterArgs?: GetHiringProcessTemplatesFilterArgs;
  orderArgs?: GetHiringProcessTemplatesOrderArgs;
  pagination?: OffsetBasedPaginationArgs;
};


export type QueryGetSkillsProfileTemplateArgs = {
  templateId: Scalars['Int'];
};


export type QueryGetSkillsProfileTemplateVersionArgs = {
  versionId: Scalars['Int'];
};


export type QueryGetSkillsProfileTemplateVersionsArgs = {
  templateId: Scalars['Int'];
};


export type QueryGetSkillsProfileTemplatesArgs = {
  filterArgs?: GetSkillsProfileTemplatesFilterArgs;
  orderArgs?: GetSkillsProfileTemplatesOrderArgs;
  pagination?: OffsetBasedPaginationArgs;
};


export type QueryGetStageActionSummariesArgs = {
  stageId?: InputMaybe<Scalars['Int']>;
  stageSubId?: InputMaybe<Scalars['ID']>;
};


export type QueryHiringTeamUsersFindManyArgs = {
  companyIds: Array<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryIdentityProviderFindManyArgs = {
  createdAt?: InputMaybe<Scalars['Date']>;
  createdAts?: InputMaybe<Array<Scalars['Date']>>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedAts?: InputMaybe<Array<Scalars['Date']>>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Scalars['String']>;
  names?: InputMaybe<Array<Scalars['String']>>;
  subId?: InputMaybe<Scalars['String']>;
  subIds?: InputMaybe<Array<Scalars['String']>>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedAts?: InputMaybe<Array<Scalars['Date']>>;
};


export type QueryIdentityProviderFindOneArgs = {
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  subId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};


export type QueryInterviewAutosuggestionFindManyV2Args = {
  interviewId: Scalars['String'];
};


export type QueryInterviewDecisionFindOneV2Args = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryInterviewEvaluationDecisionsByStageCandidateFindManyArgs = {
  interviewStageCandidateId: Scalars['Int'];
};


export type QueryInterviewEvaluationFindOneArgs = {
  interviewEvaluatorId: Scalars['String'];
  interviewStageCandidateId?: InputMaybe<Scalars['Int']>;
  projectJobRoleId?: InputMaybe<Scalars['Int']>;
};


export type QueryInterviewEvaluationResultsFindOneArgs = {
  interviewId: Scalars['String'];
  interviewStageCandidateId?: InputMaybe<Scalars['Int']>;
  projectJobRoleId: Scalars['Int'];
};


export type QueryInterviewEvaluatorFindOneArgs = {
  id?: InputMaybe<Scalars['String']>;
  interviewId: Scalars['String'];
};


export type QueryInterviewFindManyByProjectCandidateV2Args = {
  projectCandidateSubId: Scalars['String'];
  projectJobRoleId?: InputMaybe<Scalars['Int']>;
};


export type QueryInterviewFindManyV2Args = {
  linkedInterviewStageCandidateId: Scalars['Int'];
  linkedProjectJobRoleId: Scalars['Int'];
};


export type QueryInterviewFindOneV2Args = {
  id?: InputMaybe<Scalars['String']>;
  linkedInterviewStageCandidateId?: InputMaybe<Scalars['Int']>;
  linkedProjectJobRoleId?: InputMaybe<Scalars['Int']>;
  meetingId?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<Scalars['String']>;
  projectCandidateSubId?: InputMaybe<Scalars['String']>;
  stageCandidateId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<InterviewV2Status>;
};


export type QueryInterviewGuideBlueprintArgs = {
  locale?: InputMaybe<SupportedLocale>;
  subId: Scalars['ID'];
};


export type QueryInterviewQuestionRoleLevelContentArgs = {
  classification?: InputMaybe<ContentClassification>;
  feedback?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  mainQuestion?: InputMaybe<Scalars['String']>;
  reasonForQuestion?: InputMaybe<Scalars['String']>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
  softSkillId?: InputMaybe<Scalars['Int']>;
  subQuestions?: InputMaybe<Array<Scalars['String']>>;
  summary?: InputMaybe<Scalars['String']>;
  traitId?: InputMaybe<Scalars['Int']>;
};


export type QueryInterviewQuestionRoleLevelContentFindManyAndCountArgs = {
  classification?: InputMaybe<ContentClassification>;
  classifications?: InputMaybe<Array<ContentClassification>>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  feedback?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  mainQuestion?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<Scalars['String']>>;
  page?: InputMaybe<Scalars['Int']>;
  reasonForQuestion?: InputMaybe<Scalars['String']>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
  roleLevels?: InputMaybe<Array<ContentRoleLevel>>;
  softSkillId?: InputMaybe<Scalars['Int']>;
  softSkillIds?: InputMaybe<Array<Scalars['Int']>>;
  subQuestions?: InputMaybe<Array<Scalars['String']>>;
  summary?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
  traitId?: InputMaybe<Scalars['Int']>;
  traitIds?: InputMaybe<Array<Scalars['Int']>>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type QueryInterviewQuestionRoleLevelContentsArgs = {
  classification?: InputMaybe<ContentClassification>;
  classifications?: InputMaybe<Array<ContentClassification>>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  feedback?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  mainQuestion?: InputMaybe<Scalars['String']>;
  reasonForQuestion?: InputMaybe<Scalars['String']>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
  roleLevels?: InputMaybe<Array<ContentRoleLevel>>;
  softSkillId?: InputMaybe<Scalars['Int']>;
  softSkillIds?: InputMaybe<Array<Scalars['Int']>>;
  subQuestions?: InputMaybe<Array<Scalars['String']>>;
  summary?: InputMaybe<Scalars['String']>;
  traitId?: InputMaybe<Scalars['Int']>;
  traitIds?: InputMaybe<Array<Scalars['Int']>>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type QueryInterviewStageArgs = {
  subId: Scalars['ID'];
};


export type QueryInterviewStagesArgs = {
  projectSubId: Scalars['ID'];
};


export type QueryInvitationArgs = {
  id: Scalars['Int'];
};


export type QueryInvitationFindManyArgs = {
  baseUrl?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  expiresAt?: InputMaybe<Scalars['Date']>;
  firstName?: InputMaybe<Scalars['String']>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  invitationToken?: InputMaybe<Scalars['String']>;
  invitationType?: InputMaybe<InvitationType>;
  language?: InputMaybe<Language>;
  lastActionType?: InputMaybe<InvitationLastActionType>;
  lastName?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<SupportedLocale>;
  projectSubId?: InputMaybe<Scalars['String']>;
  relationDepth?: InputMaybe<RelationDepth>;
  status?: InputMaybe<InvitationStatusCode>;
  targetId?: InputMaybe<Scalars['Int']>;
  url?: InputMaybe<Scalars['String']>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryInvitationFindOneArgs = {
  baseUrl?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['Date']>;
  firstName?: InputMaybe<Scalars['String']>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']>;
  invitationToken?: InputMaybe<Scalars['String']>;
  invitationType?: InputMaybe<InvitationType>;
  language?: InputMaybe<Language>;
  lastActionType?: InputMaybe<InvitationLastActionType>;
  lastName?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<SupportedLocale>;
  projectSubId?: InputMaybe<Scalars['String']>;
  relationDepth?: InputMaybe<RelationDepth>;
  status?: InputMaybe<InvitationStatusCode>;
  targetId?: InputMaybe<Scalars['Int']>;
  url?: InputMaybe<Scalars['String']>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryInvitationSessionFindManyPaginatedArgs = {
  companyIds?: InputMaybe<Array<Scalars['String']>>;
  dateRange?: InputMaybe<FilterMomentRange>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  skip: Scalars['Int'];
  sortField?: InputMaybe<InvitationSessionSort>;
  sortOrder?: InputMaybe<SortOption>;
  sources?: InputMaybe<Array<InvitationSessionSource>>;
  statuses?: InputMaybe<Array<InvitationSessionStatus>>;
  take: Scalars['Int'];
};


export type QueryInvitationSessionFindOneArgs = {
  id: Scalars['String'];
};


export type QueryJobRoleFindManyArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdAts?: InputMaybe<Array<Scalars['Date']>>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedAts?: InputMaybe<Array<Scalars['Date']>>;
  families?: InputMaybe<Array<JobRoleFamily>>;
  family?: InputMaybe<JobRoleFamily>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Scalars['String']>;
  nameOrQualifierContains?: InputMaybe<Scalars['String']>;
  names?: InputMaybe<Array<Scalars['String']>>;
  qualifier?: InputMaybe<Scalars['String']>;
  qualifiers?: InputMaybe<Array<Scalars['String']>>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
  roleLevels?: InputMaybe<Array<ContentRoleLevel>>;
  subId?: InputMaybe<Scalars['String']>;
  subIds?: InputMaybe<Array<Scalars['String']>>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedAts?: InputMaybe<Array<Scalars['Date']>>;
};


export type QueryJobRoleFindManyPaginatedArgs = {
  filters?: InputMaybe<JobRoleFindManyPaginatedFiltersArgs>;
  order?: InputMaybe<JobRoleFindManyPaginatedOrderArgs>;
  pagination?: InputMaybe<OffsetBasedPaginationArgs>;
};


export type QueryJobRoleFindOneArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  family?: InputMaybe<JobRoleFamily>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nameOrQualifierContains?: InputMaybe<Scalars['String']>;
  qualifier?: InputMaybe<Scalars['String']>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
  subId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};


export type QueryLocationLinkFindManyArgs = {
  args?: InputMaybe<LocationLinkFindManyArgs>;
};


export type QueryMeetingCreateShareLinkArgs = {
  meetingId: Scalars['String'];
  sharedFeatures?: MeetingFeatures;
  summaryId: Scalars['String'];
};


export type QueryMeetingFindManyArgs = {
  attendeeEmails?: InputMaybe<Array<Scalars['String']>>;
  direction?: InputMaybe<SortOrder>;
  fromDate?: InputMaybe<Scalars['Date']>;
  name?: InputMaybe<Scalars['String']>;
  onlyMyMeetings?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<MeetingStatus>>;
  take?: InputMaybe<Scalars['Int']>;
  toDate?: InputMaybe<Scalars['Date']>;
  types?: InputMaybe<Array<MeetingScope>>;
};


export type QueryMeetingFindOneArgs = {
  id: Scalars['String'];
};


export type QueryMeetingTypeFindOneArgs = {
  id?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<MeetingScope>;
};


export type QueryMeetingUserCalendarFindManyArgs = {
  externalCalendarId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  platformName?: InputMaybe<UserCalendarPlatform>;
};


export type QueryMeetingUserCalendarFindOneArgs = {
  externalCalendarId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  platformName?: InputMaybe<UserCalendarPlatform>;
};


export type QueryProjectArtifactGetJobDescriptionUrlArgs = {
  projectSubId: Scalars['ID'];
};


export type QueryProjectCandidateArgs = {
  subId: Scalars['ID'];
};


export type QueryProjectCandidateFindOneByInterviewStageCandidateIdArgs = {
  interviewStageCandidateId: Scalars['ID'];
};


export type QueryProjectCandidatesArgs = {
  args: ProjectCandidatesArgs;
  filters?: ProjectCandidatesFilterArgs;
  order?: ProjectCandidatesOrderArgs;
  pagination?: OffsetBasedPaginationArgs;
};


export type QueryProjectCandidatesDeadlineExtensionCountArgs = {
  deadlineAt: Scalars['Date'];
  projectId: Scalars['Int'];
};


export type QueryProjectCollaboratorsFindManyPaginatedArgs = {
  args: ProjectCollaboratorArgs;
  order?: ProjectCollaboratorOrderOptions;
  paginate?: OffsetBasedPaginationArgs;
};


export type QueryProjectCollaboratorsIndividualFindManyPaginatedArgs = {
  args: ProjectIndividualArgs;
  paginate?: OffsetBasedPaginationArgs;
};


export type QueryProjectFindManyArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  companySignatureId?: InputMaybe<Scalars['Int']>;
  creatorId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isStopped?: InputMaybe<Scalars['Boolean']>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  moduleType?: InputMaybe<ProjectModuleType>;
  name?: InputMaybe<Scalars['String']>;
  subId?: InputMaybe<Scalars['String']>;
};


export type QueryProjectFindManyByCompanyArgs = {
  companyId: Scalars['Int'];
};


export type QueryProjectFindManysByCompanyWithStageCandidateRangeArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  companySignatureId?: InputMaybe<Scalars['Int']>;
  creatorId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isStopped?: InputMaybe<Scalars['Boolean']>;
  managerIds?: InputMaybe<Array<Scalars['Int']>>;
  moduleType?: InputMaybe<ProjectModuleType>;
  name?: InputMaybe<Scalars['String']>;
  stageCandidateCreatedAtFrom?: InputMaybe<Scalars['Date']>;
  stageCandidateCreatedAtTo?: InputMaybe<Scalars['Date']>;
  subId?: InputMaybe<Scalars['String']>;
};


export type QueryProjectGetAllowedTransitionsArgs = {
  app: SzApp;
  projectId: Scalars['Int'];
};


export type QueryProjectGetCandidateStageBreakdownArgs = {
  projectId: Scalars['Int'];
};


export type QueryProjectGetInterviewLinkCountArgs = {
  projectId: Scalars['Int'];
};


export type QueryProjectJobRoleFindManyArgs = {
  createdAt?: InputMaybe<Scalars['Date']>;
  createdAts?: InputMaybe<Array<Scalars['Date']>>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedAts?: InputMaybe<Array<Scalars['Date']>>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  isMainRole?: InputMaybe<Scalars['Boolean']>;
  jobRoleId?: InputMaybe<Scalars['Int']>;
  jobRoleIds?: InputMaybe<Array<Scalars['Int']>>;
  projectId?: InputMaybe<Scalars['Int']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  skillsProfileId?: InputMaybe<Scalars['Int']>;
  skillsProfileIds?: InputMaybe<Array<Scalars['Int']>>;
  subId?: InputMaybe<Scalars['String']>;
  subIds?: InputMaybe<Array<Scalars['String']>>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedAts?: InputMaybe<Array<Scalars['Date']>>;
};


export type QueryProjectJobRoleFindOneArgs = {
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['Int']>;
  jobRoleId?: InputMaybe<Scalars['Int']>;
  projectId?: InputMaybe<Scalars['Int']>;
  skillsProfileId?: InputMaybe<Scalars['Int']>;
  subId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};


export type QueryProjectJobRoleRecentArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryProjectJobRoleSearchArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryProjectRequestArgs = {
  id: Scalars['Int'];
};


export type QueryProjectRequestFileUploadArgs = {
  id: Scalars['Int'];
};


export type QueryProjectRequestFileUploadFindManyArgs = {
  blobId?: InputMaybe<Scalars['Int']>;
  fileName?: InputMaybe<Scalars['String']>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  projectRequestId?: InputMaybe<Scalars['Int']>;
  projectRequestIds?: InputMaybe<Array<Scalars['Int']>>;
  relationDepth?: InputMaybe<RelationDepth>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryProjectRequestFileUploadFindOneArgs = {
  blobId?: InputMaybe<Scalars['Int']>;
  fileName?: InputMaybe<Scalars['String']>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']>;
  projectRequestId?: InputMaybe<Scalars['Int']>;
  relationDepth?: InputMaybe<RelationDepth>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryProjectRequestFindManyArgs = {
  approvalRequestDate?: InputMaybe<Scalars['DateTime']>;
  companyId?: InputMaybe<Scalars['Int']>;
  creatorId?: InputMaybe<Scalars['Int']>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  managerSurveyId?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['Int']>;
  projectName?: InputMaybe<Scalars['String']>;
  relationDepth?: InputMaybe<RelationDepth>;
  status?: InputMaybe<ProjectRequestStatus>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryProjectRequestFindOneArgs = {
  approvalRequestDate?: InputMaybe<Scalars['DateTime']>;
  companyId?: InputMaybe<Scalars['Int']>;
  creatorId?: InputMaybe<Scalars['Int']>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']>;
  managerSurveyId?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['Int']>;
  projectName?: InputMaybe<Scalars['String']>;
  relationDepth?: InputMaybe<RelationDepth>;
  status?: InputMaybe<ProjectRequestStatus>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryProjectRequestUserArgs = {
  id: Scalars['Int'];
};


export type QueryProjectRequestUserApprovalArgs = {
  id: Scalars['Int'];
};


export type QueryProjectRequestUserApprovalFindManyArgs = {
  approvalRequestDate?: InputMaybe<Scalars['DateTime']>;
  approvalStatus?: InputMaybe<ProjectRequestUserApprovalStatus>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  projectRequestUserIds?: InputMaybe<Array<Scalars['Int']>>;
  relationDepth?: InputMaybe<RelationDepth>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryProjectRequestUserApprovalFindOneArgs = {
  approvalRequestDate?: InputMaybe<Scalars['DateTime']>;
  approvalStatus?: InputMaybe<ProjectRequestUserApprovalStatus>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']>;
  relationDepth?: InputMaybe<RelationDepth>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryProjectRequestUserFindManyArgs = {
  approvalId?: InputMaybe<Scalars['Int']>;
  approvalIds?: InputMaybe<Array<Scalars['Int']>>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  projectRequestId?: InputMaybe<Scalars['Int']>;
  projectRequestIds?: InputMaybe<Array<Scalars['Int']>>;
  relationDepth?: InputMaybe<RelationDepth>;
  type?: InputMaybe<ProjectRequestUserType>;
  userId?: InputMaybe<Scalars['Int']>;
  userIds?: InputMaybe<Array<Scalars['Int']>>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryProjectRequestUserFindOneArgs = {
  approvalId?: InputMaybe<Scalars['Int']>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']>;
  projectRequestId?: InputMaybe<Scalars['Int']>;
  relationDepth?: InputMaybe<RelationDepth>;
  type?: InputMaybe<ProjectRequestUserType>;
  userId?: InputMaybe<Scalars['Int']>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryProjectUserFindManyArgs = {
  includeArchivedProjects?: InputMaybe<Scalars['Boolean']>;
  includeClosedProjects?: InputMaybe<Scalars['Boolean']>;
  userIds: Array<Scalars['Int']>;
};


export type QueryProjectValidatePolicyActionsArgs = {
  actions: Array<ProjectAction>;
  app: SzApp;
  projectId: Scalars['Int'];
};


export type QueryProjectWizardSkillsProfileSourcesByProjectIdArgs = {
  projectId: Scalars['Int'];
};


export type QueryProjectsArgs = {
  filters?: ProjectFilterArgs;
  order?: ProjectOrderArgs;
  pagination?: OffsetBasedPaginationArgs;
};


export type QueryQCalcTestDataCacheGetSupportedLocalesArgs = {
  testSubType?: InputMaybe<TestSubType>;
  testType: TestType;
};


export type QueryReportArgs = {
  id: Scalars['Int'];
};


export type QueryReportAssignmentArgs = {
  id: Scalars['Int'];
};


export type QueryReportAssignmentFindManyArgs = {
  assignedId?: InputMaybe<Scalars['Int']>;
  assignedType?: InputMaybe<RAssignedType>;
  id?: InputMaybe<Scalars['Int']>;
  reportId?: InputMaybe<Scalars['Int']>;
  subType?: InputMaybe<ReportSubType>;
  type?: InputMaybe<ReportType>;
};


export type QueryReportAssignmentFindStageReportArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  projectId?: InputMaybe<Scalars['Int']>;
  stageId?: InputMaybe<Scalars['Int']>;
  subType: ReportSubType;
  type: ReportType;
};


export type QueryReportConfigArgs = {
  id: Scalars['Int'];
};


export type QueryReportConfigFindManyArgs = {
  id?: InputMaybe<Scalars['Int']>;
  newPageBefore?: InputMaybe<Scalars['Boolean']>;
  position?: InputMaybe<Scalars['Int']>;
  reportId?: InputMaybe<Scalars['Int']>;
  widgetConfigsToUpsert?: InputMaybe<Array<WidgetConfigUpsertOneBatchedWithReportConfigArgs>>;
  widgetId?: InputMaybe<Scalars['Int']>;
};


export type QueryReportFindManyArgs = {
  footerType?: InputMaybe<ReportFooterType>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Scalars['Int']>;
  ownerType?: InputMaybe<ReportOwnerType>;
  subType?: InputMaybe<ReportSubType>;
  type?: InputMaybe<ReportType>;
};


export type QueryReportRenderArgs = {
  subId: Scalars['String'];
};


export type QueryReportRenderDeleteManyArgs = {
  dataSourceId?: InputMaybe<Scalars['Int']>;
  dataSourceIds?: InputMaybe<Array<Scalars['Int']>>;
  dontSendEmailToCandidate?: InputMaybe<Scalars['Boolean']>;
  footerType?: InputMaybe<ReportFooterType>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Scalars['Int']>;
  ownerType?: InputMaybe<ReportOwnerType>;
  projectJobRoleId?: InputMaybe<Scalars['Int']>;
  projectJobRoleIds?: InputMaybe<Array<Scalars['Int']>>;
  reportId?: InputMaybe<Scalars['Int']>;
  reportRenderStatus?: InputMaybe<Scalars['String']>;
  reportRenderStatuses?: InputMaybe<Array<ReportRenderStatus>>;
  reportRenderType?: InputMaybe<ReportRenderType>;
  subId?: InputMaybe<Scalars['String']>;
  subType?: InputMaybe<ReportSubType>;
  type?: InputMaybe<ReportType>;
};


export type QueryReportRenderFindManyArgs = {
  dataSourceId?: InputMaybe<Scalars['Int']>;
  dataSourceIds?: InputMaybe<Array<Scalars['Int']>>;
  dontSendEmailToCandidate?: InputMaybe<Scalars['Boolean']>;
  footerType?: InputMaybe<ReportFooterType>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Scalars['Int']>;
  ownerType?: InputMaybe<ReportOwnerType>;
  projectJobRoleId?: InputMaybe<Scalars['Int']>;
  projectJobRoleIds?: InputMaybe<Array<Scalars['Int']>>;
  relationDepth?: InputMaybe<RelationDepth>;
  reportId?: InputMaybe<Scalars['Int']>;
  reportRenderStatus?: InputMaybe<Scalars['String']>;
  reportRenderStatuses?: InputMaybe<Array<ReportRenderStatus>>;
  reportRenderType?: InputMaybe<ReportRenderType>;
  subId?: InputMaybe<Scalars['String']>;
  subType?: InputMaybe<ReportSubType>;
  type?: InputMaybe<ReportType>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryReportRenderFindOneArgs = {
  dataSourceId?: InputMaybe<Scalars['Int']>;
  dontSendEmailToCandidate?: InputMaybe<Scalars['Boolean']>;
  footerType?: InputMaybe<ReportFooterType>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Scalars['Int']>;
  ownerType?: InputMaybe<ReportOwnerType>;
  projectJobRoleId?: InputMaybe<Scalars['Int']>;
  relationDepth?: InputMaybe<RelationDepth>;
  reportId?: InputMaybe<Scalars['Int']>;
  reportRenderStatus?: InputMaybe<Scalars['String']>;
  reportRenderType?: InputMaybe<ReportRenderType>;
  subId?: InputMaybe<Scalars['String']>;
  subType?: InputMaybe<ReportSubType>;
  type?: InputMaybe<ReportType>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryReportRenderWithDataApiArgs = {
  identitySubId: Scalars['String'];
  subId: Scalars['String'];
};


export type QueryReportsFindByCompanyArgs = {
  footerType?: InputMaybe<ReportFooterType>;
  includeSharedReports: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Scalars['Int']>;
  ownerType?: InputMaybe<ReportOwnerType>;
  subType?: InputMaybe<ReportSubType>;
  type?: InputMaybe<ReportType>;
};


export type QueryRespondantFormArgs = {
  associatedId: Scalars['Int'];
  formOwnerId: Scalars['Int'];
  formType: FormType;
  projectId?: InputMaybe<Scalars['Int']>;
  respondantId?: InputMaybe<Scalars['Int']>;
};


export type QueryResultValidatedSkillsArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  skip: Scalars['Int'];
  take: Scalars['Int'];
};


export type QueryRoleFindManyArgs = {
  description?: InputMaybe<Scalars['String']>;
  filterForIdentity?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Scalars['String']>;
  names?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<RoleType>;
  types?: InputMaybe<Array<RoleType>>;
};


export type QueryRoleRequisitionHistoryArgs = {
  roleId: Scalars['Int'];
};


export type QueryRoleWizardAvailableAssessmentsArgs = {
  roleId: Scalars['Int'];
};


export type QueryRoleWizardCheckMeetingLinksArgs = {
  meetingIds: Array<Scalars['ID']>;
};


export type QueryRoleWizardFindRequisitionsPaginatedArgs = {
  companyId: Scalars['Int'];
  keyword?: InputMaybe<Scalars['String']>;
  pagination?: OffsetBasedPaginationArgs;
};


export type QueryRoleWizardGetJobDescriptionUrlArgs = {
  roleId: Scalars['Int'];
};


export type QueryRoleWizardRoleFindManyArgs = {
  filters?: ProjectFilterArgs;
  order?: ProjectOrderArgs;
  pagination?: OffsetBasedPaginationArgs;
  withPinnedRoles?: Scalars['Boolean'];
};


export type QueryRoleWizardRoleFindOneArgs = {
  id: Scalars['Int'];
};


export type QueryRolesHiringTeamMembershipCountArgs = {
  filters?: ProjectFilterArgs;
};


export type QueryRssAssessmentCandidateOpenOneArgs = {
  id: Scalars['Int'];
};


export type QueryRssAssessmentFindManyArgs = {
  createdAt?: InputMaybe<Scalars['Date']>;
  createdAts?: InputMaybe<Array<Scalars['Date']>>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedAts?: InputMaybe<Array<Scalars['Date']>>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  stageId?: InputMaybe<Scalars['Int']>;
  stageIds?: InputMaybe<Array<Scalars['Int']>>;
  subId?: InputMaybe<Scalars['String']>;
  subIds?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<RssAssessmentType>;
  types?: InputMaybe<Array<RssAssessmentType>>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedAts?: InputMaybe<Array<Scalars['Date']>>;
};


export type QueryRssAsssessmentFindAllForStageArgs = {
  stageId: Scalars['Int'];
};


export type QuerySamlAuthInfoFindManyArgs = {
  cert?: InputMaybe<Scalars['String']>;
  certs?: InputMaybe<Array<Scalars['String']>>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdAts?: InputMaybe<Array<Scalars['Date']>>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  deletedAts?: InputMaybe<Array<Scalars['Date']>>;
  entryPoint?: InputMaybe<Scalars['String']>;
  entryPoints?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['Int']>;
  identityProviderId?: InputMaybe<Scalars['Int']>;
  identityProviderIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  issuer?: InputMaybe<Scalars['String']>;
  issuers?: InputMaybe<Array<Scalars['String']>>;
  signatureAlgorithm?: InputMaybe<Scalars['String']>;
  signatureAlgorithms?: InputMaybe<Array<Scalars['String']>>;
  subId?: InputMaybe<Scalars['String']>;
  subIds?: InputMaybe<Array<Scalars['String']>>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedAts?: InputMaybe<Array<Scalars['Date']>>;
  wantAssertionsSigned?: InputMaybe<Scalars['Boolean']>;
  wantAuthResponseSigned?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySamlAuthInfoFindOneArgs = {
  cert?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  entryPoint?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  identityProviderId?: InputMaybe<Scalars['Int']>;
  issuer?: InputMaybe<Scalars['String']>;
  signatureAlgorithm?: InputMaybe<Scalars['String']>;
  subId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  wantAssertionsSigned?: InputMaybe<Scalars['Boolean']>;
  wantAuthResponseSigned?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySharedMeetingFindOneArgs = {
  shareLinkId: Scalars['String'];
};


export type QueryShortlistStageResumesArgs = {
  shortlistStageSubId: Scalars['ID'];
  source?: InputMaybe<ShortlistStageResumeSource>;
  statuses: Array<ShortlistStageResumeProcessingStatus>;
};


export type QueryShortlistedCandidatesCountArgs = {
  stageId: Scalars['ID'];
};


export type QuerySkillCategoryFindManyArgs = {
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Scalars['String']>;
  names?: InputMaybe<Array<Scalars['String']>>;
  relationDepth?: InputMaybe<RelationDepth>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QuerySkillsEvaluationFindOneV2Args = {
  id: Scalars['String'];
};


export type QuerySkillsProfileSourceArgs = {
  subId: Scalars['ID'];
};


export type QuerySkillsProfileSourceAvailableAssessmentsArgs = {
  subId: Scalars['ID'];
};


export type QuerySkillsProfileSourceByJobRoleIdArgs = {
  jobRoleId: Scalars['Int'];
};


export type QuerySkillsProfileSourceByMeetingIdArgs = {
  meetingId: Scalars['ID'];
};


export type QuerySkillsProfileSourceCheckMeetingLinksArgs = {
  meetingIds: Array<Scalars['ID']>;
  upcomingMeetingSharedIds: Array<Scalars['ID']>;
};


export type QuerySkillsProfileSourceGetJobDescriptionUrlArgs = {
  subId: Scalars['ID'];
};


export type QuerySkillsProfileSourcesArgs = {
  filters?: InputMaybe<SkillsProfileSourcesFiltersArgs>;
  order?: InputMaybe<SkillsProfileSourcesOrderArgs>;
  pagination: OffsetBasedPaginationArgs;
};


export type QuerySoftSkillArgs = {
  subId: Scalars['ID'];
};


export type QuerySoftSkillFindManyArgs = {
  category?: InputMaybe<SoftSkillCategory>;
  childSubIds?: InputMaybe<Array<Scalars['ID']>>;
  companyId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  examples?: InputMaybe<Array<Scalars['String']>>;
  granularity?: InputMaybe<SoftSkillGranularity>;
  iconBlobId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  measurementConstructType?: InputMaybe<MeasurementConstructType>;
  name?: InputMaybe<Scalars['String']>;
  names?: InputMaybe<Array<Scalars['String']>>;
  parentSubIds?: InputMaybe<Array<Scalars['ID']>>;
  taxonomyVersion?: InputMaybe<Scalars['Int']>;
  traitId?: InputMaybe<Scalars['Int']>;
};


export type QuerySoftSkillFindManyPaginatedArgs = {
  filters?: InputMaybe<SoftSkillFindManyPaginatedFilters>;
  order?: InputMaybe<SoftSkillFindManyPaginatedOrder>;
  pagination?: InputMaybe<OffsetBasedPaginationArgs>;
  semanticSearch?: InputMaybe<SoftSkillSemanticSearchArgs>;
};


export type QuerySoftSkillGetAllValidForProjectArgs = {
  projectId: Scalars['Int'];
};


export type QuerySoftSkillRoleLevelContentArgs = {
  candidateContent?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  grade?: InputMaybe<Grade>;
  hiringManagerContent?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  internalCandidateContent?: InputMaybe<Scalars['String']>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
  softSkillId?: InputMaybe<Scalars['Int']>;
};


export type QuerySoftSkillRoleLevelContentFindManyAndCountArgs = {
  candidateContent?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  description?: InputMaybe<Scalars['String']>;
  grade?: InputMaybe<Grade>;
  grades?: InputMaybe<Array<Grade>>;
  hiringManagerContent?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  internalCandidateContent?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<Scalars['String']>>;
  page?: InputMaybe<Scalars['Int']>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
  roleLevels?: InputMaybe<Array<ContentRoleLevel>>;
  softSkillId?: InputMaybe<Scalars['Int']>;
  softSkillIds?: InputMaybe<Array<Scalars['Int']>>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QuerySoftSkillRoleLevelContentsArgs = {
  candidateContent?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  description?: InputMaybe<Scalars['String']>;
  grade?: InputMaybe<Grade>;
  grades?: InputMaybe<Array<Grade>>;
  hiringManagerContent?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  internalCandidateContent?: InputMaybe<Scalars['String']>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
  roleLevels?: InputMaybe<Array<ContentRoleLevel>>;
  softSkillId?: InputMaybe<Scalars['Int']>;
  softSkillIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type QuerySoftSkillSuccessProfileContentArgs = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
  shortDescription?: InputMaybe<Scalars['String']>;
  softSkillId?: InputMaybe<Scalars['Int']>;
};


export type QuerySoftSkillSuccessProfileContentFindManyAndCountArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  description?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  order?: InputMaybe<Array<Scalars['String']>>;
  page?: InputMaybe<Scalars['Int']>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
  roleLevels?: InputMaybe<Array<ContentRoleLevel>>;
  shortDescription?: InputMaybe<Scalars['String']>;
  softSkillId?: InputMaybe<Scalars['Int']>;
  softSkillIds?: InputMaybe<Array<Scalars['Int']>>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QuerySoftSkillSuccessProfileContentsArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  description?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
  roleLevels?: InputMaybe<Array<ContentRoleLevel>>;
  shortDescription?: InputMaybe<Scalars['String']>;
  softSkillId?: InputMaybe<Scalars['Int']>;
  softSkillIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type QuerySoftSkillTraitFindManyBySoftSkillArgs = {
  id: Scalars['Int'];
};


export type QuerySoftSkillTraitFindManyBySoftSkillsArgs = {
  ids: Array<Scalars['Int']>;
};


export type QuerySoftSkillTraitsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  orientation?: InputMaybe<Orientation>;
  softSkillIds?: InputMaybe<Array<Scalars['Int']>>;
  traitIds?: InputMaybe<Array<Scalars['Int']>>;
  weight?: InputMaybe<Scalars['Float']>;
};


export type QuerySoftSkillTypeSuccessProfileContentArgs = {
  id: Scalars['Int'];
};


export type QuerySoftSkillTypeSuccessProfileContentFindManyArgs = {
  description?: InputMaybe<Scalars['String']>;
  getOption?: InputMaybe<GetOption>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  relationDepth?: InputMaybe<RelationDepth>;
  softSkillType?: InputMaybe<SoftSkillType>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QuerySoftSkillTypeSuccessProfileContentFindOneArgs = {
  description?: InputMaybe<Scalars['String']>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']>;
  relationDepth?: InputMaybe<RelationDepth>;
  softSkillType?: InputMaybe<SoftSkillType>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryStageArgs = {
  id: Scalars['Int'];
};


export type QueryStageCandidateFindByIdArgs = {
  id: Scalars['Int'];
};


export type QueryStageCandidateFindBySubIdArgs = {
  subId: Scalars['String'];
};


export type QueryStageCandidateFindManyArgs = {
  applicationId?: InputMaybe<Scalars['String']>;
  candidateId?: InputMaybe<Scalars['Int']>;
  createdAtFrom?: InputMaybe<Scalars['Date']>;
  createdAtTo?: InputMaybe<Scalars['Date']>;
  doneBy?: InputMaybe<Scalars['Int']>;
  getOption?: InputMaybe<GetOption>;
  hasPledgedAnticheating?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  lastDateOfCandidateActionFrom?: InputMaybe<Scalars['Date']>;
  lastDateOfCandidateActionTo?: InputMaybe<Scalars['Date']>;
  relationDepth?: InputMaybe<RelationDepth>;
  stageId?: InputMaybe<Scalars['Int']>;
  stageIds?: InputMaybe<Array<Scalars['Int']>>;
  status?: InputMaybe<StageCandidateStatus>;
  statuses?: InputMaybe<Array<StageCandidateStatus>>;
  subId?: InputMaybe<Scalars['String']>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryStageCandidateFindOneArgs = {
  applicationId?: InputMaybe<Scalars['String']>;
  candidateId?: InputMaybe<Scalars['Int']>;
  doneBy?: InputMaybe<Scalars['Int']>;
  getOption?: InputMaybe<GetOption>;
  hasPledgedAnticheating?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  relationDepth?: InputMaybe<RelationDepth>;
  stageId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<StageCandidateStatus>;
  subId?: InputMaybe<Scalars['String']>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryStageCandidateSkillsProfileResultsFindOneArgs = {
  projectJobRoleId: Scalars['Int'];
  stageCandidateId: Scalars['Int'];
};


export type QueryStageCandidateStatisticsByProjectJobRoleFindManyArgs = {
  filter?: InputMaybe<StageCandidateStatisticsByProjectJobRoleFindManyFilterArgs>;
  order?: InputMaybe<StageCandidateStatisticsByProjectJobRoleFindManyOrderArgs>;
  paginate?: InputMaybe<OffsetBasedPaginationArgs>;
  projectJobRoleId: Scalars['Int'];
};


export type QueryStageCandidateStatisticsFindManyArgs = {
  filter?: InputMaybe<StageCandidateStatisticsFindManyFilterArgs>;
  order?: InputMaybe<StageCandidateStatisticsFindManyOrderArgs>;
  paginate?: InputMaybe<OffsetBasedPaginationArgs>;
  projectId: Scalars['Int'];
  projectJobRoleId?: InputMaybe<Scalars['Int']>;
  stageId?: InputMaybe<Scalars['Int']>;
};


export type QueryStageCandidateStatisticsFindOneArgs = {
  stageCandidateId: Scalars['Int'];
};


export type QueryStageFindManyArgs = {
  aiInterviewStageActionDuration?: InputMaybe<Scalars['Int']>;
  aiInterviewStageActionKnowledgeBase?: InputMaybe<Scalars['String']>;
  aiInterviewStageActionName?: InputMaybe<Scalars['String']>;
  autoProgressionThreshold?: InputMaybe<Scalars['Int']>;
  candidateReportId?: InputMaybe<Scalars['Int']>;
  cognitiveMode?: InputMaybe<CognitiveMode>;
  emailCandidateReport?: InputMaybe<Scalars['Boolean']>;
  enableF2fInterviews?: InputMaybe<Scalars['Boolean']>;
  endTime?: InputMaybe<Scalars['Date']>;
  formId?: InputMaybe<Scalars['Int']>;
  getOption?: InputMaybe<GetOption>;
  hasAdjustmentQuestionnaire?: InputMaybe<Scalars['Boolean']>;
  hasCalibration?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  isAutoProgressionEnabled?: InputMaybe<Scalars['Boolean']>;
  isIntegrityMonitoringEnabled?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<AssessmentStageKind>;
  managerReportId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['Int']>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  projectTeamEmailSettings?: InputMaybe<ProjectTeamEmailSettingsArgs>;
  relationDepth?: InputMaybe<RelationDepth>;
  startTime?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<StageStatus>;
  subId?: InputMaybe<Scalars['String']>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryStageFindOneArgs = {
  aiInterviewStageActionDuration?: InputMaybe<Scalars['Int']>;
  aiInterviewStageActionKnowledgeBase?: InputMaybe<Scalars['String']>;
  aiInterviewStageActionName?: InputMaybe<Scalars['String']>;
  autoProgressionThreshold?: InputMaybe<Scalars['Int']>;
  candidateReportId?: InputMaybe<Scalars['Int']>;
  cognitiveMode?: InputMaybe<CognitiveMode>;
  emailCandidateReport?: InputMaybe<Scalars['Boolean']>;
  enableF2fInterviews?: InputMaybe<Scalars['Boolean']>;
  endTime?: InputMaybe<Scalars['Date']>;
  formId?: InputMaybe<Scalars['Int']>;
  getOption?: InputMaybe<GetOption>;
  hasAdjustmentQuestionnaire?: InputMaybe<Scalars['Boolean']>;
  hasCalibration?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  isAutoProgressionEnabled?: InputMaybe<Scalars['Boolean']>;
  isIntegrityMonitoringEnabled?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<AssessmentStageKind>;
  managerReportId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['Int']>;
  projectTeamEmailSettings?: InputMaybe<ProjectTeamEmailSettingsArgs>;
  relationDepth?: InputMaybe<RelationDepth>;
  startTime?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<StageStatus>;
  subId?: InputMaybe<Scalars['String']>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryStageGenerateIndirectInvitationUrlArgs = {
  id: Scalars['Int'];
  language?: InputMaybe<Language>;
  locale?: InputMaybe<SupportedLocale>;
};


export type QueryStageProgressSummaryArgs = {
  filter?: InputMaybe<StageCandidateStatisticsFindManyFilterArgs>;
  order?: InputMaybe<StageCandidateStatisticsFindManyOrderArgs>;
  paginate?: InputMaybe<OffsetBasedPaginationArgs>;
  projectId: Scalars['Int'];
  projectJobRoleId?: InputMaybe<Scalars['Int']>;
  stageId?: InputMaybe<Scalars['Int']>;
};


export type QueryStageResultsSummaryArgs = {
  filter?: InputMaybe<StageCandidateStatisticsByProjectJobRoleFindManyFilterArgs>;
  order?: InputMaybe<StageCandidateStatisticsByProjectJobRoleFindManyOrderArgs>;
  paginate?: InputMaybe<OffsetBasedPaginationArgs>;
  projectJobRoleId: Scalars['Int'];
};


export type QuerySuccessProfileArgs = {
  projectId: Scalars['Int'];
};


export type QuerySuccessProfileAvailableAssessmentsArgs = {
  successProfileId: Scalars['Float'];
};


export type QuerySuccessProfileFindManyArgs = {
  calculationMethod?: InputMaybe<CalculationMethod>;
  gradingMethod?: InputMaybe<GradingMethod>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  jobRoleId?: InputMaybe<Scalars['Int']>;
  jobRoleIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type QuerySuccessProfileTechnicalSkillArgs = {
  id: Scalars['Int'];
};


export type QuerySuccessProfileTechnicalSkillFindManyArgs = {
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  relationDepth?: InputMaybe<RelationDepth>;
  successProfileId?: InputMaybe<Scalars['Int']>;
  successProfileIds?: InputMaybe<Array<Scalars['Int']>>;
  technicalSkillId?: InputMaybe<Scalars['Int']>;
  technicalSkillIds?: InputMaybe<Array<Scalars['Int']>>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QuerySuccessProfileTechnicalSkillFindOneArgs = {
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']>;
  relationDepth?: InputMaybe<RelationDepth>;
  successProfileId?: InputMaybe<Scalars['Int']>;
  technicalSkillId?: InputMaybe<Scalars['Int']>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QuerySummaryTemplateFindManyArgs = {
  direction?: InputMaybe<SortOrder>;
  id?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  isReady?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  names?: InputMaybe<Array<Scalars['String']>>;
  scope?: InputMaybe<SummaryTemplateScope>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<TemplateType>;
  types?: InputMaybe<Array<TemplateType>>;
};


export type QuerySummaryTemplateFindOneArgs = {
  id?: InputMaybe<Scalars['String']>;
  isReady?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Scalars['Int']>;
  scope?: InputMaybe<SummaryTemplateScope>;
  type?: InputMaybe<TemplateType>;
};


export type QuerySzSkillsMergeArgs = {
  id: Scalars['Int'];
};


export type QuerySzSkillsMergeFindManyArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']>>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  description?: InputMaybe<Scalars['String']>;
  getOption?: InputMaybe<GetOption>;
  iconBlobId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  measurementConstructType?: InputMaybe<MeasurementConstructType>;
  measurementConstructTypes?: InputMaybe<Array<MeasurementConstructType>>;
  name?: InputMaybe<Scalars['String']>;
  originId?: InputMaybe<Scalars['Int']>;
  originIds?: InputMaybe<Array<Scalars['Int']>>;
  relationDepth?: InputMaybe<RelationDepth>;
  skillType?: InputMaybe<SkillType>;
  skillTypes?: InputMaybe<Array<SkillType>>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QuerySzSkillsMergeFindOneArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  getOption?: InputMaybe<GetOption>;
  iconBlobId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  measurementConstructType?: InputMaybe<MeasurementConstructType>;
  name?: InputMaybe<Scalars['String']>;
  originId?: InputMaybe<Scalars['Int']>;
  relationDepth?: InputMaybe<RelationDepth>;
  skillType?: InputMaybe<SkillType>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QuerySzSkillsMergeFreeTextSearchPaginatedArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  freetext?: InputMaybe<Scalars['String']>;
  getOption?: InputMaybe<GetOption>;
  iconBlobId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  measurementConstructType?: InputMaybe<MeasurementConstructType>;
  name?: InputMaybe<Scalars['String']>;
  originId?: InputMaybe<Scalars['Int']>;
  relationDepth?: InputMaybe<RelationDepth>;
  skillType?: InputMaybe<SkillType>;
  skip: Scalars['Int'];
  take: Scalars['Int'];
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryTechnicalSkillArgs = {
  subId: Scalars['ID'];
};


export type QueryTechnicalSkillFindManyArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  getOption?: InputMaybe<GetOption>;
  iconBlobId?: InputMaybe<Scalars['Int']>;
  iconBlobIds?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Scalars['String']>;
  names?: InputMaybe<Array<Scalars['String']>>;
  relationDepth?: InputMaybe<RelationDepth>;
  skillCategoryId?: InputMaybe<Scalars['Int']>;
  skillCategoryIds?: InputMaybe<Array<Scalars['Int']>>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryTechnicalSkillFindManyPaginatedArgs = {
  filters?: InputMaybe<TechnicalSkillFindManyPaginatedFilters>;
  order?: InputMaybe<TechnicalSkillFindManyPaginatedOrder>;
  pagination?: InputMaybe<OffsetBasedPaginationArgs>;
  semanticSearch?: InputMaybe<TechnicalSkillSemanticSearchArgs>;
};


export type QueryTechnicalSkillFreeTextSearchPaginatedArgs = {
  freetext?: InputMaybe<Scalars['String']>;
  getOption?: InputMaybe<GetOption>;
  relationDepth?: InputMaybe<RelationDepth>;
  skillCategoryIds?: InputMaybe<Array<Scalars['Int']>>;
  skillCategoryNames?: InputMaybe<Array<Scalars['String']>>;
  skip: Scalars['Int'];
  sortField?: InputMaybe<TechnicalSkillSortField>;
  sortOrder?: InputMaybe<SortOption>;
  take: Scalars['Int'];
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryTraitArgs = {
  id: Scalars['Int'];
};


export type QueryTraitFindManyBySoftSkillIdArgs = {
  id: Scalars['Int'];
};


export type QueryTraitRoleLevelContentArgs = {
  classification?: InputMaybe<ContentClassification>;
  content?: InputMaybe<Scalars['String']>;
  developmentContent?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
  softSkillId?: InputMaybe<Scalars['Int']>;
  summary?: InputMaybe<Scalars['String']>;
  traitId?: InputMaybe<Scalars['Int']>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTraitRoleLevelContentFindManyAndCountArgs = {
  classification?: InputMaybe<ContentClassification>;
  classifications?: InputMaybe<Array<ContentClassification>>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  content?: InputMaybe<Scalars['String']>;
  developmentContent?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  order?: InputMaybe<Array<Scalars['String']>>;
  page?: InputMaybe<Scalars['Int']>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
  roleLevels?: InputMaybe<Array<ContentRoleLevel>>;
  softSkillId?: InputMaybe<Scalars['Int']>;
  softSkillIds?: InputMaybe<Array<Scalars['Int']>>;
  summary?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
  traitId?: InputMaybe<Scalars['Int']>;
  traitIds?: InputMaybe<Array<Scalars['Int']>>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTraitRoleLevelContentsArgs = {
  classification?: InputMaybe<ContentClassification>;
  classifications?: InputMaybe<Array<ContentClassification>>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  content?: InputMaybe<Scalars['String']>;
  developmentContent?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
  roleLevels?: InputMaybe<Array<ContentRoleLevel>>;
  softSkillId?: InputMaybe<Scalars['Int']>;
  softSkillIds?: InputMaybe<Array<Scalars['Int']>>;
  summary?: InputMaybe<Scalars['String']>;
  traitId?: InputMaybe<Scalars['Int']>;
  traitIds?: InputMaybe<Array<Scalars['Int']>>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTraitSoftSkillContextCsvGenerateAndUploadArgs = {
  behaviourIds?: InputMaybe<Array<Scalars['Int']>>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  relationDepth?: InputMaybe<RelationDepth>;
  softSkillId?: InputMaybe<Scalars['Int']>;
  softSkillIds?: InputMaybe<Array<Scalars['Int']>>;
  traitId?: InputMaybe<Scalars['Int']>;
  traitIds?: InputMaybe<Array<Scalars['Int']>>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryTraitSoftSkillContextFindManyArgs = {
  behaviourIds?: InputMaybe<Array<Scalars['Int']>>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  relationDepth?: InputMaybe<RelationDepth>;
  softSkillId?: InputMaybe<Scalars['Int']>;
  softSkillIds?: InputMaybe<Array<Scalars['Int']>>;
  traitId?: InputMaybe<Scalars['Int']>;
  traitIds?: InputMaybe<Array<Scalars['Int']>>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryTraitSoftSkillContextFindOneArgs = {
  behaviourIds?: InputMaybe<Array<Scalars['Int']>>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']>;
  relationDepth?: InputMaybe<RelationDepth>;
  softSkillId?: InputMaybe<Scalars['Int']>;
  traitId?: InputMaybe<Scalars['Int']>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryTraitsArgs = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  names?: InputMaybe<Array<Scalars['String']>>;
  softSkillId?: InputMaybe<Scalars['Int']>;
  softSkillIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryTranslatedProjectCandidateProfileArgs = {
  projectCandidateProfileId: Scalars['ID'];
};


export type QueryTranslatedShortlistStageCandidateCitationsArgs = {
  shortlistStageCandidateId: Scalars['ID'];
};


export type QueryUnifiedMeetingsArgs = {
  filters?: InputMaybe<UnifiedMeetingsFilters>;
  pagination: OffsetBasedPaginationArgs;
};


export type QueryUpcomingMeetingFindBySharedIdArgs = {
  sharedId: Scalars['String'];
};


export type QueryUpcomingMeetingFindManyArgs = {
  botId?: InputMaybe<Scalars['Boolean']>;
  direction?: InputMaybe<SortOrder>;
  fromDate?: InputMaybe<Scalars['Date']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
  toDate?: InputMaybe<Scalars['Date']>;
  types?: InputMaybe<Array<MeetingScope>>;
};


export type QueryUpcomingMeetingFindOneArgs = {
  botId?: InputMaybe<Scalars['String']>;
  calendarId?: InputMaybe<Scalars['String']>;
  externalMeetingId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  sharedId?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};


export type QueryUserArgs = {
  email?: InputMaybe<Scalars['String']>;
  filterFakeUsers?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isPasswordDisabled?: InputMaybe<Scalars['Boolean']>;
  isPuppet?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Language>;
  lastName?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<SupportedLocale>;
  recoveryToken?: InputMaybe<Scalars['String']>;
  refreshToken?: InputMaybe<Scalars['String']>;
  subId?: InputMaybe<Scalars['String']>;
  twoFactorCode?: InputMaybe<Scalars['String']>;
};


export type QueryUserCompanyInfoArgs = {
  id: Scalars['Int'];
};


export type QueryUserCompanyInfoFindManyArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  department?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['String']>>;
  endDate?: InputMaybe<Scalars['Date']>;
  getOption?: InputMaybe<GetOption>;
  hrManagerEmployeeId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  jobTitle?: InputMaybe<Scalars['String']>;
  relationDepth?: InputMaybe<RelationDepth>;
  startDate?: InputMaybe<Scalars['Date']>;
  userId?: InputMaybe<Scalars['Int']>;
  userIds?: InputMaybe<Array<Scalars['Int']>>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryUserCompanyInfoFindOneArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Date']>;
  getOption?: InputMaybe<GetOption>;
  hrManagerEmployeeId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  relationDepth?: InputMaybe<RelationDepth>;
  startDate?: InputMaybe<Scalars['Date']>;
  userId?: InputMaybe<Scalars['Int']>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryUserFreeTextSearchPaginateArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  filterFakeUsers?: InputMaybe<Scalars['Boolean']>;
  freetext: Scalars['String'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryUserGroupFindManyPaginatedArgs = {
  args: UserGroupFindManyArgs;
  paginate?: OffsetBasedPaginationArgs;
};


export type QueryUserGroupFindOneArgs = {
  subId: Scalars['String'];
};


export type QueryUserGroupMemberFindManyPaginatedArgs = {
  args: UserGroupMemberFindManyArgs;
  paginate?: OffsetBasedPaginationArgs;
};


export type QueryUserSettingsArgs = {
  id: Scalars['Int'];
};


export type QueryUserSettingsFindManyArgs = {
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  relationDepth?: InputMaybe<RelationDepth>;
  userId?: InputMaybe<Scalars['Int']>;
  userIds?: InputMaybe<Array<Scalars['Int']>>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryUserSettingsFindOneArgs = {
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']>;
  relationDepth?: InputMaybe<RelationDepth>;
  userId?: InputMaybe<Scalars['Int']>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryUsersArgs = {
  email?: InputMaybe<Scalars['String']>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  filterFakeUsers?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  isPasswordDisabled?: InputMaybe<Scalars['Boolean']>;
  isPuppet?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Language>;
  lastName?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<SupportedLocale>;
  recoveryToken?: InputMaybe<Scalars['String']>;
  refreshToken?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  subIds?: InputMaybe<Array<Scalars['String']>>;
  twoFactorCode?: InputMaybe<Scalars['String']>;
};


export type QueryValidateContentArgs = {
  page?: InputMaybe<Scalars['Int']>;
  softSkillIds?: InputMaybe<Array<Scalars['Int']>>;
  take?: InputMaybe<Scalars['Int']>;
  traitIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryValidateContentPieceArgs = {
  softSkillId: Scalars['Int'];
  traitIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryWidgetArgs = {
  id: Scalars['Int'];
};


export type QueryWidgetConfigArgs = {
  id: Scalars['Int'];
};


export type QueryWidgetConfigFindManyArgs = {
  id?: InputMaybe<Scalars['Int']>;
  reportConfigId?: InputMaybe<Scalars['Int']>;
  settings?: InputMaybe<Scalars['String']>;
  widgetOptionId?: InputMaybe<Scalars['Int']>;
};


export type QueryWidgetFindManyArgs = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<WidgetType>;
};


export type QueryWidgetOptionArgs = {
  id: Scalars['Int'];
};


export type QueryWidgetOptionFindManyArgs = {
  defaultValue?: InputMaybe<Scalars['String']>;
  fieldType?: InputMaybe<WidgetOptionFieldType>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  question?: InputMaybe<Scalars['String']>;
  widgetId?: InputMaybe<Scalars['Int']>;
};


export type QueryAiInterviewAssessmentStageActionArgs = {
  id: Scalars['ID'];
};


export type QueryAiInterviewAssessmentStageActionCandidateArgs = {
  id: Scalars['ID'];
};


export type QueryAiInterviewAssessmentStageActionCandidateByConferenceIdArgs = {
  conferenceId: Scalars['ID'];
};


export type QueryAiInterviewAssessmentStageActionCandidateRoleStageArgs = {
  id: Scalars['ID'];
};


export type QueryAssessmentStageArgs = {
  id: Scalars['ID'];
};


export type QueryAtsAllRejectionReasonsArgs = {
  companyId: Scalars['Int'];
};


export type QueryAtsAllStagesArgs = {
  companyId: Scalars['Int'];
};


export type QueryAtsSettingsArgs = {
  companyId: Scalars['Int'];
};


export type QueryAvailabilityPreviewArgs = {
  from: Scalars['DateTime'];
  interviewerUserIds: Array<Scalars['Int']>;
  projectId: Scalars['Int'];
  to: Scalars['DateTime'];
};


export type QueryCandidateMaterialsAvailabilityArgs = {
  stageCandidateIds: Array<Scalars['Int']>;
  stageId: Scalars['Int'];
};


export type QueryCoderbyteAssessmentDetailsArgs = {
  coderbyteTestId: Scalars['String'];
  companyId: Scalars['Int'];
};


export type QueryCoderbyteAvailableAssessmentsArgs = {
  companyId: Scalars['Int'];
  refresh?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCoderbyteWorkspaceArgs = {
  companyId: Scalars['Int'];
};


export type QueryCoderbyteWorkspaceAdminPasswordArgs = {
  companyId: Scalars['Int'];
};


export type QueryCoderbyteWorkspaceApiKeyArgs = {
  companyId: Scalars['Int'];
};


export type QueryCognitiveTestAssessmentStageActionCandidateArgs = {
  id: Scalars['ID'];
};


export type QueryCompanyArgs = {
  id: Scalars['Int'];
};


export type QueryCompanyFindManyByIdsArgs = {
  ids: Array<Scalars['Int']>;
};


export type QueryCompanySettingChangesArgs = {
  companyId: Scalars['Int'];
  order?: CompanySettingChangeOrderArgs;
  pagination?: OffsetBasedPaginationArgs;
  settingKeys?: InputMaybe<Array<Scalars['String']>>;
  settingSearch?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<CompanySettingChangeSource>;
};


export type QueryConferenceArgs = {
  id: Scalars['ID'];
};


export type QueryEnglishProficiencyAssessmentArgs = {
  id: Scalars['ID'];
};


export type QueryEnglishProficiencyAssessmentStageActionCandidateArgs = {
  id: Scalars['ID'];
};


export type QueryGenerateCoderbyteTechnicalSkillsArgs = {
  coderbyteTestId: Scalars['String'];
  projectId: Scalars['Int'];
  refresh?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetAllProjectFilesArgs = {
  id: Scalars['Float'];
};


export type QueryGetCompanyIdArgs = {
  id: Scalars['Float'];
};


export type QueryGetEditingInfoArgs = {
  args: CollaborativeEditingGetInfoArgs;
};


export type QueryGetFormReportCsvArgs = {
  associatedId: Scalars['Int'];
  formManagerType: FormManagerType;
  formOwnerId: Scalars['Int'];
  formType: FormType;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetInvitationStatusArgs = {
  invitationToken: Scalars['String'];
};


export type QueryGetProjectByIdArgs = {
  id: Scalars['Float'];
};


export type QueryGetProjectCobrandingArgs = {
  subId: Scalars['String'];
};


export type QueryGetProjectSamlAuthInfoArgs = {
  id: Scalars['Float'];
};


export type QueryIsCoderbyteWorkspaceAvailableArgs = {
  companyId: Scalars['Int'];
};


export type QueryKomboIntegrationsFindManyPaginatedArgs = {
  skip: Scalars['Int'];
  take: Scalars['Int'];
};


export type QueryKomboIntegrationsFindOneArgs = {
  companyId: Scalars['Int'];
};


export type QueryKomboJobFindOneArgs = {
  id: Scalars['String'];
};


export type QueryKomboJobsFindManyPaginatedArgs = {
  companyId: Scalars['Int'];
  hasProjectLinked?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  skip: Scalars['Int'];
  sortField?: InputMaybe<KomboJobSortField>;
  sortOrder?: InputMaybe<SortOption>;
  statuses?: InputMaybe<Array<KomboJobStatus>>;
  take: Scalars['Int'];
};


export type QueryKomboSyncHistoryArgs = {
  companyId: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryKomboSyncRunArgs = {
  id: Scalars['String'];
};


export type QueryKomboSyncStatusArgs = {
  companyId: Scalars['Int'];
};


export type QueryLatestCancelledSchedulingRequestArgs = {
  stageCandidateId: Scalars['Int'];
  stageId: Scalars['Int'];
};


export type QueryMyRoleArgs = {
  id: Scalars['ID'];
};


export type QueryOmnisearchArgs = {
  myRoles?: Scalars['Boolean'];
  query: Scalars['String'];
};


export type QueryOmnisearchCandidatesArgs = {
  direction?: InputMaybe<SortOption>;
  myRoles?: Scalars['Boolean'];
  pagination?: OmnisearchPageArgs;
  query: Scalars['String'];
  sort?: CandidateSearchSort;
};


export type QueryOmnisearchResolveRecentsArgs = {
  projectCandidateSubIds: Array<Scalars['ID']>;
  projectSubIds: Array<Scalars['ID']>;
};


export type QueryOmnisearchRolesArgs = {
  direction?: InputMaybe<SortOption>;
  myRoles?: Scalars['Boolean'];
  pagination?: OmnisearchPageArgs;
  query: Scalars['String'];
  sort?: RoleSearchSort;
  statuses?: InputMaybe<Array<ProjectStatus>>;
};


export type QueryPersonalityTestAssessmentStageActionCandidateArgs = {
  id: Scalars['ID'];
};


export type QueryRecentRejectionReasonsArgs = {
  projectId: Scalars['Int'];
  stageId?: InputMaybe<Scalars['Int']>;
};


export type QueryRecentWorkspacesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryRejectionReasonsArgs = {
  companyId: Scalars['Int'];
};


export type QueryRejectionReasonsForCandidatesArgs = {
  companyId: Scalars['Int'];
  subIds: Array<Scalars['ID']>;
};


export type QueryResolveShareLinkArgs = {
  token: Scalars['String'];
};


export type QuerySchedulingBatchArgs = {
  batchId: Scalars['ID'];
  stageId: Scalars['Int'];
};


export type QuerySchedulingBatchSlotsArgs = {
  batchId: Scalars['ID'];
  stageId: Scalars['Int'];
};


export type QuerySchedulingBookingLinkArgs = {
  requestId: Scalars['ID'];
};


export type QuerySchedulingInterviewerRepliesArgs = {
  requestId: Scalars['ID'];
};


export type QuerySchedulingRequestArgs = {
  requestId: Scalars['ID'];
};


export type QuerySchedulingRequestOfferedSlotsArgs = {
  requestId: Scalars['ID'];
  stageId: Scalars['Int'];
};


export type QuerySchedulingRequestTimelineArgs = {
  requestId: Scalars['ID'];
};


export type QueryStageSchedulingProjectionArgs = {
  stageId: Scalars['Int'];
};


export type QueryWorkspacesArgs = {
  accessType?: InputMaybe<WorkspaceAccessType>;
  includeProjectCount?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};

export type QuestionModel = {
  __typename?: 'QuestionModel';
  options: Array<OptionModel>;
  subId: Scalars['String'];
  text: Scalars['String'];
};

export enum QuestionOrientation {
  Inverted = 'INVERTED',
  Standard = 'STANDARD'
}

/** The type of question being edited */
export enum QuestionType {
  Blueprint = 'BLUEPRINT',
  Candidate = 'CANDIDATE'
}

export type Questionnaire = {
  __typename?: 'Questionnaire';
  id: Scalars['ID'];
  items: Array<QuestionnaireItem>;
};

export enum QuestionnaireCandidateStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  NotStarted = 'NOT_STARTED'
}

export type QuestionnaireItem = {
  __typename?: 'QuestionnaireItem';
  correctAnswer: Scalars['Boolean'];
  id: Scalars['ID'];
  order: Scalars['Int'];
  text: Scalars['String'];
};

export type QuestionnaireItemDraftInput = {
  correctAnswer: Scalars['Boolean'];
  order: Scalars['Int'];
  text: Scalars['String'];
};

export type QuestionnaireItemResponse = {
  __typename?: 'QuestionnaireItemResponse';
  answer: Scalars['Boolean'];
  id: Scalars['ID'];
  itemId: Scalars['ID'];
};

export type QuestionnaireItemResponseGqlInput = {
  answer: Scalars['Boolean'];
  itemId: Scalars['ID'];
};

export type QuestionnaireResult = {
  __typename?: 'QuestionnaireResult';
  id: Scalars['ID'];
  responses: Array<QuestionnaireItemResponse>;
  status: QuestionnaireResultStatus;
};

export enum QuestionnaireResultStatus {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Passed = 'PASSED'
}

export enum RAssignedType {
  Company = 'COMPANY',
  Project = 'PROJECT',
  Stage = 'STAGE'
}

export type ReasonableAdjustmentsOption = {
  __typename?: 'ReasonableAdjustmentsOption';
  kind: ReasonableAdjustmentsOptionKind;
  value?: Maybe<Scalars['String']>;
};

export type ReasonableAdjustmentsOptionArgs = {
  kind: ReasonableAdjustmentsOptionKind;
  value?: InputMaybe<Scalars['String']>;
};

export enum ReasonableAdjustmentsOptionKind {
  ContactCompanyEmail = 'CONTACT_COMPANY_EMAIL',
  ContactCompanyGeneric = 'CONTACT_COMPANY_GENERIC',
  ContactCompanyUrl = 'CONTACT_COMPANY_URL',
  EmailSz = 'EMAIL_SZ',
  SelfServe = 'SELF_SERVE'
}

export type RecentCandidate = {
  __typename?: 'RecentCandidate';
  application: CandidateApplication;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  requestedId: Scalars['ID'];
  userSubId: Scalars['ID'];
};

export type RecentRejectionReasonGqlModel = {
  __typename?: 'RecentRejectionReasonGQLModel';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type RecentRole = {
  __typename?: 'RecentRole';
  createdAt: Scalars['DateTime'];
  isMine: Scalars['Boolean'];
  name: Scalars['String'];
  projectId: Scalars['Int'];
  projectSubId: Scalars['ID'];
  requestedId: Scalars['ID'];
  requisitionCode?: Maybe<Scalars['String']>;
  requisitionLocation?: Maybe<RequisitionLocationModel>;
  status: ProjectStatus;
};

export type RecordingAvailable = {
  __typename?: 'RecordingAvailable';
  /** Recording duration in milliseconds */
  durationMs?: Maybe<Scalars['Int']>;
  /** Recording file size in bytes */
  sizeBytes?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type RecordingConfigArgs = {
  duration?: InputMaybe<DurationArgs>;
  format?: InputMaybe<Scalars['String']>;
  generatedAt?: InputMaybe<Scalars['Date']>;
  src?: InputMaybe<Scalars['String']>;
  status: MeetingRecodingStatus;
};

export type RecordingConfigModel = {
  __typename?: 'RecordingConfigModel';
  duration?: Maybe<DurationModel>;
  format?: Maybe<Scalars['String']>;
  generatedAt?: Maybe<Scalars['DateTime']>;
  src?: Maybe<Scalars['String']>;
  status: MeetingRecodingStatus;
};

export type RecordingInfo = RecordingAvailable | RecordingUnavailable;

export type RecordingUnavailable = {
  __typename?: 'RecordingUnavailable';
  status: RecordingUnavailableStatus;
};

/** Status of an unavailable recording */
export enum RecordingUnavailableStatus {
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type RecordingUploadModel = {
  __typename?: 'RecordingUploadModel';
  id: Scalars['String'];
  multipartUploadData: MultipartUploadResponseModel;
};

export type RejectCandidatesPayload = {
  __typename?: 'RejectCandidatesPayload';
  atsWritebackFailures: Array<AtsWritebackFailure>;
  projectCandidates: Array<ProjectCandidate>;
};

export type RejectionReasonGqlModel = {
  __typename?: 'RejectionReasonGQLModel';
  id: Scalars['String'];
  name: Scalars['String'];
  remoteId: Scalars['String'];
};

export type RejectionReasonsForCandidatesGqlModel = {
  __typename?: 'RejectionReasonsForCandidatesGQLModel';
  /** True when the list was narrowed to the candidates' Workday stages. An empty list is then a real answer (no valid reason), not an unavailable catalogue. */
  isStageScoped: Scalars['Boolean'];
  reasons: Array<RejectionReasonGqlModel>;
};

export enum RelationDepth {
  Basic = 'BASIC',
  Full = 'FULL',
  FullWithExternal = 'FULL_WITH_EXTERNAL',
  NoRelations = 'NO_RELATIONS'
}

export type RemoveUntaggedAiQuestionsResult = {
  __typename?: 'RemoveUntaggedAiQuestionsResult';
  /** Number of blueprint AI questions (AI_QUESTION and CUSTOMIZED_AI_QUESTION types) checked for removal. */
  blueprintQuestionsChecked: Scalars['Int'];
  /** Number of blueprint AI questions (AI_QUESTION and CUSTOMIZED_AI_QUESTION types) removed. */
  blueprintQuestionsRemoved: Scalars['Int'];
  /** Number of candidate AI questions (AI_QUESTION and CUSTOMIZED_AI_QUESTION types) checked for removal. */
  candidateQuestionsChecked: Scalars['Int'];
  /** Number of candidate AI questions (AI_QUESTION and CUSTOMIZED_AI_QUESTION types) removed. */
  candidateQuestionsRemoved: Scalars['Int'];
  /** Total duration of the operation execution in milliseconds. */
  durationMs: Scalars['Int'];
  /** Indicates if the operation was executed in dry-run mode (no changes persisted). */
  isDryRun: Scalars['Boolean'];
  /** Total number of AI questions (AI_QUESTION and CUSTOMIZED_AI_QUESTION types) removed across all tables. */
  totalQuestionsRemoved: Scalars['Int'];
};

export type Report = {
  __typename?: 'Report';
  company?: Maybe<Company>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  footerType: ReportFooterType;
  id: Scalars['Int'];
  isArchived: Scalars['Boolean'];
  name: Scalars['String'];
  ownerId: Scalars['Int'];
  ownerType: ReportOwnerType;
  reportConfigs?: Maybe<Array<ReportConfig>>;
  reportRenders?: Maybe<Array<ReportRender>>;
  subType?: Maybe<ReportSubType>;
  type: ReportType;
  updatedAt: Scalars['Date'];
};

export type ReportAssignment = {
  __typename?: 'ReportAssignment';
  assignedId: Scalars['Int'];
  assignedType: RAssignedType;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['Int'];
  inheritsSetting?: Maybe<Scalars['Boolean']>;
  report: Report;
  reportId: Scalars['Int'];
  updatedAt: Scalars['Date'];
};

export type ReportConfig = {
  __typename?: 'ReportConfig';
  id: Scalars['Int'];
  newPageBefore: Scalars['Boolean'];
  position: Scalars['Int'];
  report: Report;
  reportId: Scalars['Int'];
  widget: Widget;
  widgetConfigs?: Maybe<Array<WidgetConfig>>;
  widgetId: Scalars['Int'];
};

export type ReportConfigCreateOneBatchedWithReportArgs = {
  newPageBefore?: InputMaybe<Scalars['Boolean']>;
  position: Scalars['Int'];
  widgetConfigsToUpsert?: InputMaybe<Array<WidgetConfigUpsertOneBatchedWithReportConfigArgs>>;
  widgetId: Scalars['Int'];
};

export type ReportConfigUpdateOneArgs = {
  id: Scalars['Int'];
  newPageBefore?: InputMaybe<Scalars['Boolean']>;
  position: Scalars['Int'];
  widgetConfigsToUpsert?: InputMaybe<Array<WidgetConfigUpsertOneBatchedWithReportConfigArgs>>;
};

export enum ReportFooterType {
  Default = 'DEFAULT',
  Simple = 'SIMPLE'
}

export enum ReportOwnerType {
  /** Company owner */
  Company = 'COMPANY',
  /** User owner */
  User = 'USER'
}

export type ReportRender = {
  __typename?: 'ReportRender';
  blob?: Maybe<MonolithBlobModel>;
  blobId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Date'];
  dataSourceId: Scalars['Int'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['Int'];
  projectJobRoleId?: Maybe<Scalars['Int']>;
  report: Report;
  reportId: Scalars['Int'];
  reportRenderStatus?: Maybe<ReportRenderStatus>;
  reportRenderType?: Maybe<ReportRenderType>;
  statusMessage?: Maybe<Scalars['String']>;
  subId: Scalars['String'];
  updatedAt: Scalars['Date'];
  widgetRenders?: Maybe<Array<WidgetRender>>;
};

export enum ReportRenderStatus {
  CollectingData = 'COLLECTING_DATA',
  Complete = 'COMPLETE',
  CompleteEmailed = 'COMPLETE_EMAILED',
  CompleteEmailing = 'COMPLETE_EMAILING',
  Failed = 'FAILED',
  Initialisation = 'INITIALISATION',
  Rendering = 'RENDERING'
}

export enum ReportRenderType {
  Csv = 'CSV',
  Data = 'DATA',
  Pdf = 'PDF'
}

export enum ReportSubType {
  /** Stage results candidate */
  StageResultsCandidate = 'STAGE_RESULTS_CANDIDATE',
  /** Stage results manager */
  StageResultsManager = 'STAGE_RESULTS_MANAGER',
  /** Sp report full */
  SuccessProfileFull = 'SUCCESS_PROFILE_FULL',
  /** Sp report partial */
  SuccessProfilePartial = 'SUCCESS_PROFILE_PARTIAL'
}

export enum ReportType {
  /** Stage results */
  StageResults = 'STAGE_RESULTS',
  /** Success profile results */
  SuccessProfile = 'SUCCESS_PROFILE'
}

export type RequestMaterialInput = {
  /** Who the material is for */
  audience: SchedulingMaterialAudience;
  /** The type of the uploaded file; required with uploadKey */
  contentType?: InputMaybe<Scalars['String']>;
  /** The name shown for the material */
  label: Scalars['String'];
  /** The uploadKey createRequestMaterialUpload returned */
  uploadKey?: InputMaybe<Scalars['String']>;
  /** An https link; set this or uploadKey, never both */
  url?: InputMaybe<Scalars['String']>;
};

/** A short-lived upload destination for one scheduling material */
export type RequestMaterialUploadModel = {
  __typename?: 'RequestMaterialUploadModel';
  /** When the upload URL stops accepting the file */
  expiresAt: Scalars['DateTime'];
  /** The key to reference the uploaded file by when sending */
  uploadKey: Scalars['String'];
  /** The URL to PUT the file to */
  uploadUrl: Scalars['String'];
};

export type RequisitionLinkEventModel = {
  __typename?: 'RequisitionLinkEventModel';
  candidatesRemoved: Scalars['Boolean'];
  eventType: RequisitionLinkEventType;
  id: Scalars['Int'];
  occurredAt: Scalars['DateTime'];
  performedByType: RequisitionLinkPerformedByType;
  performedByUser?: Maybe<User>;
  performedByUserId?: Maybe<Scalars['Int']>;
  requisitionCode?: Maybe<Scalars['String']>;
  requisitionId: Scalars['String'];
  requisitionTitle?: Maybe<Scalars['String']>;
};

export enum RequisitionLinkEventType {
  Linked = 'LINKED',
  Unlinked = 'UNLINKED'
}

export enum RequisitionLinkPerformedByType {
  System = 'SYSTEM',
  User = 'USER'
}

export type RequisitionLocationModel = {
  __typename?: 'RequisitionLocationModel';
  city?: Maybe<Scalars['String']>;
  /** Country as the ATS sends it: usually an ISO 3166-1 alpha-2 code, otherwise free text. */
  country?: Maybe<Scalars['String']>;
};

export type RequisitionModel = {
  __typename?: 'RequisitionModel';
  code?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isLinked: Scalars['Boolean'];
  location?: Maybe<RequisitionLocationModel>;
  remoteUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type RequisitionPaginatedModel = {
  __typename?: 'RequisitionPaginatedModel';
  page: Pageinfo;
  requisitions: Array<RequisitionModel>;
};

export type RespondantFieldWithAnswers = {
  __typename?: 'RespondantFieldWithAnswers';
  answer?: Maybe<Scalars['String']>;
  displayOrder: Scalars['Int'];
  field?: Maybe<Field>;
  isOptional: Scalars['Boolean'];
  selectOptionAnswerIsFreeText?: Maybe<Scalars['Boolean']>;
};

export type RespondantForm = {
  __typename?: 'RespondantForm';
  associatedId: Scalars['Int'];
  formId: Scalars['Int'];
  formOwnerId: Scalars['Int'];
  formType: FormType;
  isComplete: Scalars['Boolean'];
  respondantFieldWithAnswers: Array<RespondantFieldWithAnswers>;
  submittedFormLogId?: Maybe<Scalars['Int']>;
};

export enum ResponseType {
  CompanyEmployeeSelectResponse = 'COMPANY_EMPLOYEE_SELECT_RESPONSE',
  DateResponse = 'DATE_RESPONSE',
  LongTextResponse = 'LONG_TEXT_RESPONSE',
  MultipleSelectResponse = 'MULTIPLE_SELECT_RESPONSE',
  ShortTextResponse = 'SHORT_TEXT_RESPONSE',
  SingleSelectResponse = 'SINGLE_SELECT_RESPONSE'
}

export enum ResultMeasurementType {
  Behaviour = 'BEHAVIOUR',
  InterviewGuide = 'INTERVIEW_GUIDE',
  SoftSkill = 'SOFT_SKILL',
  SuccessProfile = 'SUCCESS_PROFILE',
  TechnicalSkill = 'TECHNICAL_SKILL',
  Trait = 'TRAIT'
}

export type ResultModel = {
  __typename?: 'ResultModel';
  copiedFrom?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  doneBy: Scalars['Int'];
  doneFor: Scalars['Int'];
  id: Scalars['Int'];
  label?: Maybe<Scalars['String']>;
  manuallyAdjustedBy?: Maybe<Scalars['Int']>;
  measurementId: Scalars['Int'];
  measurementType: ResultMeasurementType;
  previousVersionId?: Maybe<Scalars['Int']>;
  projectId?: Maybe<Scalars['Int']>;
  projectJobRoleId?: Maybe<Scalars['Int']>;
  score: ResultScoreUnion;
  scoreType: ResultScoreType;
  updatedAt: Scalars['Date'];
  version: Scalars['Int'];
};

export enum ResultScoreType {
  ExternalAssessmentCode = 'EXTERNAL_ASSESSMENT_CODE',
  ExternalAssessmentFinal = 'EXTERNAL_ASSESSMENT_FINAL',
  ExternalAssessmentMcq = 'EXTERNAL_ASSESSMENT_MCQ',
  IgBehaviour = 'IG_BEHAVIOUR',
  IgCustom = 'IG_CUSTOM',
  IgFinalDecision = 'IG_FINAL_DECISION',
  Motivation = 'MOTIVATION',
  RoleSoftSkillsProfile = 'ROLE_SOFT_SKILLS_PROFILE',
  RoleTechnicalSkillsProfile = 'ROLE_TECHNICAL_SKILLS_PROFILE',
  Statistical = 'STATISTICAL',
  TrCustom = 'TR_CUSTOM'
}

export type ResultScoreUnion = ExternalAssessmentCodeScoreModel | ExternalAssessmentFinalScoreModel | ExternalAssessmentMcqScoreModel | IgBehaviourResultScoreModel | IgCustomResultScoreModel | IgFinalDecisionResultScoreModel | MotivationResultScoreModel | SoftSkillSelfAssessmentScoreModel | StatisticalResultScoreModel | TechnicalSkillSelfAssessmentScoreModel | TrCustomResultScoreModel;

export type ResultSoftSkillProfileCreateOneFromSc = {
  score: ISoftSkillSelfAssessmentScoreModel;
  softSkillId: Scalars['Int'];
  stageCandidateId: Scalars['Int'];
};

export type ResultTechnicalSkillProfileCreateOneFromSc = {
  score: ITechnicalSkillSelfAssessmentScoreModel;
  stageCandidateId: Scalars['Int'];
  technicalSkillId: Scalars['Int'];
};

export type ResultValidatedSkillsModel = {
  __typename?: 'ResultValidatedSkillsModel';
  company: Company;
  totalValidateSkills: Scalars['Int'];
};

export type ResultValidatedSkillsPaginatedModel = {
  __typename?: 'ResultValidatedSkillsPaginatedModel';
  resultValidatedSkills: Array<ResultValidatedSkillsModel>;
  total: Scalars['Int'];
};

export enum ResumeExtractedDataIndustry {
  Accounting = 'ACCOUNTING',
  AerospaceAndDefence = 'AEROSPACE_AND_DEFENCE',
  Agriculture = 'AGRICULTURE',
  Automotive = 'AUTOMOTIVE',
  CharityAndNonProfit = 'CHARITY_AND_NON_PROFIT',
  ConstructionAndEngineering = 'CONSTRUCTION_AND_ENGINEERING',
  ConsultingAndProfessionalServices = 'CONSULTING_AND_PROFESSIONAL_SERVICES',
  Education = 'EDUCATION',
  EnergyAndUtilities = 'ENERGY_AND_UTILITIES',
  EntertainmentAndMedia = 'ENTERTAINMENT_AND_MEDIA',
  FashionAndApparel = 'FASHION_AND_APPAREL',
  FinancialServices = 'FINANCIAL_SERVICES',
  FoodAndBeverage = 'FOOD_AND_BEVERAGE',
  GovernmentAndPublicSector = 'GOVERNMENT_AND_PUBLIC_SECTOR',
  HealthcareAndPharmaceuticals = 'HEALTHCARE_AND_PHARMACEUTICALS',
  HospitalityAndTourism = 'HOSPITALITY_AND_TOURISM',
  Insurance = 'INSURANCE',
  Legal = 'LEGAL',
  LogisticsAndSupplyChain = 'LOGISTICS_AND_SUPPLY_CHAIN',
  Manufacturing = 'MANUFACTURING',
  MiningAndMetals = 'MINING_AND_METALS',
  RealEstateAndProperty = 'REAL_ESTATE_AND_PROPERTY',
  RetailAndECommerce = 'RETAIL_AND_E_COMMERCE',
  Technology = 'TECHNOLOGY',
  Telecommunications = 'TELECOMMUNICATIONS'
}

export type Role = {
  __typename?: 'Role';
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  type: RoleType;
  uuid?: Maybe<Scalars['String']>;
};

export type RoleApplicationQuestion = {
  __typename?: 'RoleApplicationQuestion';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  options?: Maybe<Array<RoleApplicationQuestionOption>>;
  preconditionOptions?: Maybe<Array<Scalars['String']>>;
  preconditionQuestionId?: Maybe<Scalars['ID']>;
  required: Scalars['Boolean'];
  shortName?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type: RoleApplicationQuestionType;
};

export type RoleApplicationQuestionOption = {
  __typename?: 'RoleApplicationQuestionOption';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export enum RoleApplicationQuestionType {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  MultiSelect = 'MULTI_SELECT',
  Number = 'NUMBER',
  SingleSelect = 'SINGLE_SELECT',
  Text = 'TEXT'
}

export type RoleAtsCandidatePull = {
  __typename?: 'RoleAtsCandidatePull';
  isAwaitingCandidates: Scalars['Boolean'];
  pullMode: AtsCandidatePullMode;
  state: AtsCandidatePullState;
};

/** A role a batch action did not change, with the reason why. */
export type RoleBatchFailureModel = {
  __typename?: 'RoleBatchFailureModel';
  reason: RoleBatchFailureReason;
  roleId: Scalars['Int'];
};

/** Why a single role in a batch archive or status change did not change. */
export enum RoleBatchFailureReason {
  Failed = 'FAILED',
  Forbidden = 'FORBIDDEN',
  NotClosed = 'NOT_CLOSED',
  NotFound = 'NOT_FOUND',
  NotPublished = 'NOT_PUBLISHED'
}

/** The outcome of a batch role action, role by role. A mixed selection is expected, so skipped roles are reported rather than failing the request. */
export type RoleBatchResultModel = {
  __typename?: 'RoleBatchResultModel';
  /** The roles that did not change, each with a reason. Empty when every role changed. */
  failed: Array<RoleBatchFailureModel>;
  /** The roles that changed, as they are now. Empty when nothing qualified. */
  succeeded: Array<RoleModel>;
};

export type RoleHit = {
  __typename?: 'RoleHit';
  createdAt: Scalars['DateTime'];
  isMine: Scalars['Boolean'];
  match: SearchMatch;
  name: Scalars['String'];
  projectId: Scalars['Int'];
  projectSubId: Scalars['ID'];
  requisitionCode?: Maybe<Scalars['String']>;
  requisitionLocation?: Maybe<RequisitionLocationModel>;
  status: ProjectStatus;
};

export type RoleModel = {
  __typename?: 'RoleModel';
  aiInterviewStage?: Maybe<AssessmentStage>;
  applicationQuestions: Array<RoleApplicationQuestion>;
  assessmentStage?: Maybe<AssessmentStage>;
  assessmentStages: Array<AssessmentStage>;
  /** Progress of pulling candidates in from the linked ATS requisition. Null when the role is not linked, not published, or the ATS gateway can't answer. */
  atsCandidatePull?: Maybe<RoleAtsCandidatePull>;
  candidatePortalEnabled: Scalars['Boolean'];
  candidatePortalIntro?: Maybe<Scalars['String']>;
  candidatePortalTitle?: Maybe<Scalars['String']>;
  company: Company;
  companyId: Scalars['Int'];
  contentStages: Array<ContentStageModel>;
  coverPhotoUrl?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  creatorUser?: Maybe<User>;
  creatorUserId?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  hiringProcessAbsoluteDeadlineAt?: Maybe<Scalars['Date']>;
  hiringProcessDeadlineType?: Maybe<HiringProcessDeadlineType>;
  hiringProcessRelativeDeadlineAmount?: Maybe<Scalars['Int']>;
  hiringProcessRelativeDeadlineUnit?: Maybe<HiringProcessDeadlineUnit>;
  hiringProcessTemplateVersion?: Maybe<HiringProcessTemplateVersion>;
  id: Scalars['Int'];
  indirectInviteSSOEnabled: Scalars['Boolean'];
  inputsChangedAt?: Maybe<Scalars['Date']>;
  interviewStages: Array<InterviewStage>;
  isAiInterviewExplicitConsentEnabled: Scalars['Boolean'];
  isArchived: Scalars['Boolean'];
  isIntegrityMonitoringEnabled: Scalars['Boolean'];
  /** Whether the calling user has pinned this role in their active workspace. Private to the caller — two users see different values for the same role. */
  isPinned: Scalars['Boolean'];
  isRSPConfirmed: Scalars['Boolean'];
  isStopped: Scalars['Boolean'];
  jobDescriptionFileName?: Maybe<Scalars['String']>;
  jobDescriptionLocales?: Maybe<Array<Scalars['String']>>;
  jobDescriptionProcessingStatus?: Maybe<ProjectJobDescriptionProcessingStatus>;
  jobDescriptionUploadedAt?: Maybe<Scalars['Date']>;
  jobRole?: Maybe<JobRoleModel>;
  lastCandidateActivity?: Maybe<Scalars['Date']>;
  locales: Array<SupportedLocale>;
  meetingId?: Maybe<Scalars['ID']>;
  moduleType: ProjectModuleType;
  name: Scalars['String'];
  primaryLocale: SupportedLocale;
  productSolution?: Maybe<ProductSolution>;
  publishedAt?: Maybe<Scalars['Date']>;
  publishedByUser?: Maybe<User>;
  publishedByUserId?: Maybe<Scalars['Int']>;
  reminderEmailCadenceDays?: Maybe<Scalars['Int']>;
  requisition?: Maybe<RequisitionModel>;
  roleCandidatesCount?: Maybe<Scalars['Int']>;
  shortlistCalibrationBorderlineQuestions?: Maybe<ShortlistCalibrationBorderlineQuestions>;
  shortlistCriteriaSuggestionStatus?: Maybe<ProjectShortlistCriteriaSuggestionStatus>;
  shortlistCriteriaSuggestions?: Maybe<Array<ProjectShortlistCriteriaSuggestion>>;
  shortlistStages: Array<ShortlistStage>;
  skillGenerationStatus?: Maybe<SkillsProfileSkillGenerationStatus>;
  skillsGeneratedAt?: Maybe<Scalars['Date']>;
  skillsProfile?: Maybe<SuccessProfile>;
  source: ProjectSource;
  status: ProjectStatus;
  subId: Scalars['ID'];
  teamMembers: Array<ProjectManager>;
  updatedAt: Scalars['Date'];
  updatedByUser?: Maybe<User>;
  updatedByUserId?: Maybe<Scalars['Int']>;
};

export type RolePaginatedModel = {
  __typename?: 'RolePaginatedModel';
  page: Pageinfo;
  roles: Array<RoleModel>;
};

export type RoleRequisitionHistoryModel = {
  __typename?: 'RoleRequisitionHistoryModel';
  candidateCount: Scalars['Int'];
  candidatesRemovedAtLastUnlink: Scalars['Boolean'];
  events: Array<RequisitionLinkEventModel>;
  lastUnlinkedRequisitionCode?: Maybe<Scalars['String']>;
  lastUnlinkedRequisitionId?: Maybe<Scalars['String']>;
};

export type RoleSearchPage = {
  __typename?: 'RoleSearchPage';
  hasMore: Scalars['Boolean'];
  hits: Array<RoleHit>;
  partial: Scalars['Boolean'];
};

export enum RoleSearchSort {
  Created = 'CREATED',
  Name = 'NAME',
  Published = 'PUBLISHED',
  Relevance = 'RELEVANCE'
}

export type RoleStageOrderArgs = {
  order: Scalars['Int'];
  stageId: Scalars['Int'];
  stageType: StageType;
};

export type RoleStageOrderModel = {
  __typename?: 'RoleStageOrderModel';
  activeCandidatesCount: Scalars['Int'];
  hiringProcessTemplateVersionStageId?: Maybe<Scalars['Int']>;
  order: Scalars['Int'];
  roleId: Scalars['Int'];
  stageActionName?: Maybe<Scalars['String']>;
  stageId: Scalars['Int'];
  stageName?: Maybe<Scalars['String']>;
  stageSubId?: Maybe<Scalars['ID']>;
  stageSubType?: Maybe<AssessmentStageKind>;
  stageType: StageType;
};

export enum RoleStatus {
  Closed = 'CLOSED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Review = 'REVIEW'
}

export type RoleTeamMemberInput = {
  actorRole: ActorRole;
  userId: Scalars['Int'];
};

export enum RoleType {
  Company = 'COMPANY',
  External = 'EXTERNAL',
  SzProtected = 'SZ_PROTECTED',
  SzSingleton = 'SZ_SINGLETON'
}

export type RssAssessmentCandidateModel = {
  __typename?: 'RssAssessmentCandidateModel';
  createdAt: Scalars['Date'];
  id: Scalars['Int'];
  rssAssessment: RssAssessmentModel;
  rssAssessmentId: Scalars['Int'];
  stageCandidate?: Maybe<SmStageCandidateModel>;
  stageCandidateId: Scalars['Int'];
  status: RssAssessmentCandidateStatus;
  subId: Scalars['String'];
  updatedAt: Scalars['Date'];
};

export enum RssAssessmentCandidateStatus {
  NotStarted = 'NOT_STARTED',
  OpenForChanges = 'OPEN_FOR_CHANGES',
  Submitted = 'SUBMITTED'
}

export type RssAssessmentCreateOneArgs = {
  stageId: Scalars['Int'];
  type: RssAssessmentType;
};

export type RssAssessmentModel = {
  __typename?: 'RssAssessmentModel';
  createdAt: Scalars['Date'];
  id: Scalars['Int'];
  stage?: Maybe<SmStageModel>;
  stageId: Scalars['Int'];
  subId: Scalars['String'];
  type: RssAssessmentType;
};

export enum RssAssessmentType {
  SoftSkill = 'SOFT_SKILL',
  TechnicalSkill = 'TECHNICAL_SKILL'
}

export type RssCandidateOpenOneModel = {
  __typename?: 'RssCandidateOpenOneModel';
  gradeBands: Array<GradeBandUnion>;
  rssAssessmentCandidate: RssAssessmentCandidateModel;
  skillsWithResults: Array<SkillWithResultModel>;
};

export type SamlAuthInfoModel = {
  __typename?: 'SamlAuthInfoModel';
  cert: Scalars['String'];
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  entryPoint: Scalars['String'];
  id: Scalars['Int'];
  identityProvider: IdentityProviderModel;
  identityProviderId: Scalars['Int'];
  issuer: Scalars['String'];
  signatureAlgorithm: Scalars['String'];
  subId: Scalars['String'];
  updatedAt: Scalars['Date'];
  wantAssertionsSigned: Scalars['Boolean'];
  wantAuthResponseSigned: Scalars['Boolean'];
};

export type ScheduleCandidatesDebriefExportArgs = {
  __typename?: 'ScheduleCandidatesDebriefExportArgs';
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  includeRejected?: Maybe<Scalars['Boolean']>;
  projectId: Scalars['Int'];
};

export type ScheduleRoiCsvFileExportArgs = {
  __typename?: 'ScheduleROICsvFileExportArgs';
  projectIds: Array<Scalars['Int']>;
};

export type ScheduleStageCandidateResultsCsvFileExportArgs = {
  __typename?: 'ScheduleStageCandidateResultsCsvFileExportArgs';
  exportLevel: CandidateResultsExportLevel;
  includeFormsData?: Maybe<Scalars['Boolean']>;
  lastDateOfCandidateActionFrom?: Maybe<Scalars['Date']>;
  lastDateOfCandidateActionTo?: Maybe<Scalars['Date']>;
  projectId: Scalars['Int'];
  stageId?: Maybe<Scalars['Int']>;
};

export type ScheduledTask = {
  args: ScheduledTaskArgs;
  error?: Maybe<Scalars['String']>;
  kind: ScheduledTaskKind;
  status: ScheduledTaskStatus;
  subId: Scalars['String'];
};

export type ScheduledTaskArgs = AdminResultsExportRunnerArgs | ScheduleCandidatesDebriefExportArgs | ScheduleRoiCsvFileExportArgs | ScheduleStageCandidateResultsCsvFileExportArgs;

export enum ScheduledTaskKind {
  AdminResultsExport = 'ADMIN_RESULTS_EXPORT',
  CandidatesDebriefExport = 'CANDIDATES_DEBRIEF_EXPORT',
  CandidateUsageCsvFileExport = 'CANDIDATE_USAGE_CSV_FILE_EXPORT',
  RoiCsvFileExport = 'ROI_CSV_FILE_EXPORT',
  SoftSkillRoleLevelContentExport = 'SOFT_SKILL_ROLE_LEVEL_CONTENT_EXPORT',
  StageCandidateResultsCsvFileExport = 'STAGE_CANDIDATE_RESULTS_CSV_FILE_EXPORT'
}

export enum ScheduledTaskStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Running = 'RUNNING',
  Scheduled = 'SCHEDULED'
}

/** Who caused a scheduling timeline entry: a recruiter, the candidate, an interviewer, or the system on its own */
export enum SchedulingActivityActorKind {
  Candidate = 'candidate',
  Interviewer = 'interviewer',
  Recruiter = 'recruiter',
  System = 'system'
}

/** A set of scheduling requests raised together for one stage */
export type SchedulingBatchModel = {
  __typename?: 'SchedulingBatchModel';
  batchId: Scalars['ID'];
  requests: Array<SchedulingRequestModel>;
  /** Stage candidates skipped because they have been rejected from the project */
  skippedRejectedStageCandidateIds: Array<Scalars['Int']>;
  /** Stage candidates skipped because they already had a live scheduling request */
  skippedStageCandidateIds: Array<Scalars['Int']>;
};

/** The interviewers busy at the time chosen for one request */
export type SchedulingBusyInterviewersModel = {
  __typename?: 'SchedulingBusyInterviewersModel';
  requestId: Scalars['ID'];
  userIds: Array<Scalars['Int']>;
};

/** Provider-reported free/busy classification of an interval */
export enum SchedulingBusyType {
  Busy = 'busy',
  OutOfOffice = 'outOfOffice',
  Tentative = 'tentative'
}

/** A candidate's most recent cancelled scheduling request at a stage, and why it was cancelled */
export type SchedulingCancellationModel = {
  __typename?: 'SchedulingCancellationModel';
  /** True when the candidate cancelled the interview by declining every new time the hiring team offered */
  cancelledByDeclining: Scalars['Boolean'];
  /** What the candidate wrote when declining the new times; null when they wrote nothing, or when the request was not cancelled by their decline. Candidate-supplied free text: render it as text, never as markup */
  candidateNote?: Maybe<Scalars['String']>;
  request: SchedulingRequestModel;
};

/** Conferencing choice for a scheduling request */
export enum SchedulingConferencing {
  None = 'none',
  Teams = 'teams'
}

/** Where a candidate is in interview scheduling for one stage, as shown in the Interview column */
export enum SchedulingInterviewState {
  Booked = 'booked',
  DeclinedAllSlots = 'declinedAllSlots',
  Expired = 'expired',
  NotScheduled = 'notScheduled',
  Rescheduling = 'rescheduling',
  SlotsOffered = 'slotsOffered'
}

/** An interviewer a saved batch names, resolved by user id */
export type SchedulingInterviewerModel = {
  __typename?: 'SchedulingInterviewerModel';
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  userId: Scalars['Int'];
};

/** The replies of one scheduling request's current interviewers to the calendar invitation */
export type SchedulingInterviewerRepliesModel = {
  __typename?: 'SchedulingInterviewerRepliesModel';
  /** When the panel event's replies were last read; null until the first read */
  lastCheckedAt?: Maybe<Scalars['DateTime']>;
  /** One reply per current interviewer, in the order of the request's panel; empty when not tracked */
  replies: Array<SchedulingInterviewerReplyModel>;
  /** False when no Outlook panel event exists to read replies from (a calendar-file-only or not yet booked interview): show "Replies not tracked", never "No one has replied" */
  tracked: Scalars['Boolean'];
};

/** One current interviewer's reply to the calendar invitation */
export type SchedulingInterviewerReplyModel = {
  __typename?: 'SchedulingInterviewerReplyModel';
  /** True for the recruiter who sent the request and sits on the panel: they organise the event, so the calendar never reports a reply for them and none is expected */
  isOrganiser: Scalars['Boolean'];
  /** The calendar's time for the reply; null until they reply */
  respondedAt?: Maybe<Scalars['DateTime']>;
  /** The reply; none until they reply, and always none for the organiser */
  response: SchedulingRsvpResponseStatus;
  userId: Scalars['Int'];
};

/** How many days a candidate booking link stays valid for */
export enum SchedulingLinkExpiryDays {
  Five = 'five',
  Fourteen = 'fourteen',
  Seven = 'seven',
  Three = 'three',
  Two = 'two'
}

/** A link the hiring team invite can carry for each candidate */
export enum SchedulingLinkMaterial {
  AssessmentReport = 'assessmentReport',
  InterviewGuide = 'interviewGuide'
}

/** Who a scheduling material is intended for */
export enum SchedulingMaterialAudience {
  Candidate = 'candidate',
  HiringTeam = 'hiringTeam'
}

/** A requested link that is not on one request hiring team invite */
export type SchedulingMissingMaterialModel = {
  __typename?: 'SchedulingMissingMaterialModel';
  material: SchedulingLinkMaterial;
  reason: SchedulingMissingMaterialReason;
  requestId: Scalars['ID'];
};

/** Why a requested link is not on the hiring team invite */
export enum SchedulingMissingMaterialReason {
  LookupFailed = 'lookupFailed',
  NotAvailable = 'notAvailable'
}

export type SchedulingRequestDetailsInput = {
  /** Which conferencing system hosts the interview, if any */
  conferencing: SchedulingConferencing;
  /** How long the interview runs, in minutes */
  durationMinutes: Scalars['Int'];
  /** Whether the Spotted Zebra note taker joins the interview */
  includeSpot: Scalars['Boolean'];
  /** The kind of interview being scheduled */
  interviewType?: InputMaybe<Scalars['String']>;
  /** The users who will interview the candidates */
  interviewerUserIds: Array<Scalars['Int']>;
  /** How many days the candidate booking link stays valid for */
  linkExpiryDays: SchedulingLinkExpiryDays;
  /** Where the interview takes place */
  locationKind: Scalars['String'];
  /** Whether the candidate receives a booking email */
  sendCandidateEmail: Scalars['Boolean'];
  /** Whether the interviewers receive a calendar invitation */
  sendInterviewerInvite: Scalars['Boolean'];
};

/** One candidate's interview scheduling request */
export type SchedulingRequestModel = {
  __typename?: 'SchedulingRequestModel';
  /** The batch the request was raised in */
  batchId: Scalars['ID'];
  candidateUserId: Scalars['Int'];
  conferencing: SchedulingConferencing;
  createdAt: Scalars['DateTime'];
  /** The candidate's own words when they declined every offered slot, if they left any */
  declineReasonText?: Maybe<Scalars['String']>;
  durationMinutes: Scalars['Int'];
  id: Scalars['ID'];
  includeSpot: Scalars['Boolean'];
  interviewType?: Maybe<Scalars['String']>;
  interviewerUserIds: Array<Scalars['Int']>;
  /** When the candidate booking link stops working */
  linkExpiresAt: Scalars['DateTime'];
  /** How long the booking link lives once sent, as the recruiter chose it */
  linkExpiryDays: SchedulingLinkExpiryDays;
  locationKind: Scalars['String'];
  /** How many rounds of slots have been offered so far */
  offerRound: Scalars['Int'];
  sendCandidateEmail: Scalars['Boolean'];
  sendInterviewerInvite: Scalars['Boolean'];
  stageCandidateId: Scalars['Int'];
  stageId: Scalars['Int'];
  status: SchedulingRequestStatus;
  updatedAt: Scalars['DateTime'];
  /** Changes on every write to the request; sent back with a recruiter action so a request changed in between is refused */
  version: Scalars['Int'];
};

/** Lifecycle state of one scheduling request for one candidate at one stage */
export enum SchedulingRequestStatus {
  Booked = 'booked',
  Cancelled = 'cancelled',
  Declined = 'declined',
  Draft = 'draft',
  Expired = 'expired',
  Offered = 'offered',
  Rescheduling = 'rescheduling'
}

/** How a recruiter moves a booked interview */
export enum SchedulingRescheduleMode {
  FixedTime = 'fixedTime',
  Reoffer = 'reoffer'
}

/** What rescheduling an interview did */
export type SchedulingRescheduleResultModel = {
  __typename?: 'SchedulingRescheduleResultModel';
  /** False only for a fixed time some interviewer is busy at, sent without confirmBusy: nothing was written */
  applied: Scalars['Boolean'];
  /** The interviewers busy at the fixed time, by user id */
  busyInterviewerIds: Array<Scalars['Int']>;
  request: SchedulingRequestModel;
};

/** An interviewer's reply to the calendar invitation; no reply at all reads as none */
export enum SchedulingRsvpResponseStatus {
  Accepted = 'accepted',
  Declined = 'declined',
  None = 'none',
  Tentative = 'tentative'
}

/** A saved batch as the Schedule interviews wizard reopens it: its requests and the interviewers they name */
export type SchedulingSavedBatchModel = {
  __typename?: 'SchedulingSavedBatchModel';
  batchId: Scalars['ID'];
  /** Every interviewer the batch names, in no particular order; an id the directory no longer knows is absent */
  interviewers: Array<SchedulingInterviewerModel>;
  requests: Array<SchedulingRequestModel>;
};

/** What sending a batch did to one of its scheduling requests */
export enum SchedulingSendOutcome {
  AlreadySent = 'alreadySent',
  NotSendable = 'notSendable',
  Sent = 'sent'
}

/** What sending a batch did to one of its scheduling requests */
export type SchedulingSendOutcomeModel = {
  __typename?: 'SchedulingSendOutcomeModel';
  outcome: SchedulingSendOutcome;
  refusal?: Maybe<SchedulingSendRefusal>;
  requestId: Scalars['ID'];
};

/** Why a scheduling request was not sent */
export enum SchedulingSendRefusal {
  BatchHasUnsendableRequest = 'batchHasUnsendableRequest',
  CandidateRejected = 'candidateRejected',
  InterviewerBusy = 'interviewerBusy',
  NoBookableSlot = 'noBookableSlot'
}

/** What sending one scheduling batch did */
export type SchedulingSendReportModel = {
  __typename?: 'SchedulingSendReportModel';
  batchId: Scalars['ID'];
  /** When a batch with fixed times was held back, the interviewers busy at each request’s time. Nothing was sent: send again with confirmBusy to book over it */
  busyInterviewers: Array<SchedulingBusyInterviewersModel>;
  /** Report and guide links the recruiter asked for that a request invite does not carry; empty unless the batch was sent now */
  missingMaterials: Array<SchedulingMissingMaterialModel>;
  /** One outcome per live request in the batch */
  outcomes: Array<SchedulingSendOutcomeModel>;
  /** Whether every request in the batch was sent */
  sent: Scalars['Boolean'];
};

/** What happened to a scheduling request at one point on its timeline */
export enum SchedulingTimelineEntryKind {
  Booked = 'booked',
  Cancelled = 'cancelled',
  CandidateAskedForOtherTimes = 'candidateAskedForOtherTimes',
  Declined = 'declined',
  Expired = 'expired',
  InterviewerDeclined = 'interviewerDeclined',
  Offered = 'offered',
  PanelChanged = 'panelChanged',
  Rescheduling = 'rescheduling'
}

/** One entry on a scheduling request's timeline: what happened, who caused it and when */
export type SchedulingTimelineEntryModel = {
  __typename?: 'SchedulingTimelineEntryModel';
  /** Who caused the entry: never the person themselves, only their part */
  actorKind: SchedulingActivityActorKind;
  /** The recruiter or interviewer who caused the entry, when known; never a candidate */
  actorUserId?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  kind: SchedulingTimelineEntryKind;
  occurredAt: Scalars['DateTime'];
};

export enum ScoreComponent {
  Coderbyte = 'CODERBYTE',
  CognitiveSummary = 'COGNITIVE_SUMMARY',
  EnglishProficiency = 'ENGLISH_PROFICIENCY',
  Psychometric = 'PSYCHOMETRIC'
}

export enum ScoreComponentKind {
  Compensatory = 'COMPENSATORY',
  Knockout = 'KNOCKOUT'
}

export type ScoreModel = {
  __typename?: 'ScoreModel';
  customEvaluation?: Maybe<Scalars['String']>;
  customScore?: Maybe<Scalars['Float']>;
  grade?: Maybe<Grade>;
  percentile?: Maybe<Scalars['Float']>;
  stenScore?: Maybe<Scalars['Float']>;
  zScore?: Maybe<Scalars['Float']>;
};

export type SearchMatch = {
  __typename?: 'SearchMatch';
  field: SearchMatchField;
  tier: Scalars['Int'];
};

export enum SearchMatchField {
  Email = 'EMAIL',
  Name = 'NAME',
  RequisitionCode = 'REQUISITION_CODE'
}

/** Result of admin send summary emails operation */
export type SendSummaryEmailsResult = {
  __typename?: 'SendSummaryEmailsResult';
  /** Total meetings for which emails were successfully dispatched */
  meetingsEmailed: Scalars['Int'];
  /** Total meetings for which email dispatch failed */
  meetingsFailed: Scalars['Int'];
  /** Total meetings processed */
  meetingsProcessed: Scalars['Int'];
};

export type ShareLinkDataModel = {
  __typename?: 'ShareLinkDataModel';
  /** The original URL that the share link points to */
  url: Scalars['String'];
  /** The ID of the workspace associated with the share link */
  workspaceId: Scalars['Int'];
};

export type SharedMeetingModel = {
  __typename?: 'SharedMeetingModel';
  companyId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Date'];
  date: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['Date']>;
  hasSubmittedEvaluation?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  interviewStageCandidateId?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  projectCandidateId?: Maybe<Scalars['Int']>;
  projectCandidateSubId?: Maybe<Scalars['String']>;
  projectId?: Maybe<Scalars['Int']>;
  projectJobRoleId?: Maybe<Scalars['Int']>;
  recordingConfig?: Maybe<RecordingConfigModel>;
  status: MeetingStatus;
  summary?: Maybe<MeetingSummaryModel>;
  transcriptConfig?: Maybe<TranscriptConfigModel>;
  type: MeetingScope;
  updatedAt: Scalars['Date'];
};

export type ShortTextField = Field & {
  __typename?: 'ShortTextField';
  fieldInstanceType: FieldInstanceType;
  fieldOwnerId?: Maybe<Scalars['Int']>;
  fieldOwnerName?: Maybe<Scalars['String']>;
  fieldOwnerType?: Maybe<FieldOwnerType>;
  fieldType: FieldType;
  formManagerType: FormManagerType;
  hint?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isArchived: Scalars['Boolean'];
  name: Scalars['String'];
  question?: Maybe<Scalars['String']>;
  settings?: Maybe<FieldSettingsModel>;
  txtData?: Maybe<Scalars['String']>;
};

export enum ShortlistCalibrationAnswer {
  FullEvidence = 'FULL_EVIDENCE',
  NoEvidence = 'NO_EVIDENCE',
  PotentialEvidence = 'POTENTIAL_EVIDENCE'
}

export enum ShortlistCalibrationBorderlineCases {
  AdjacentDomain = 'ADJACENT_DOMAIN',
  AdjacentExperience = 'ADJACENT_EXPERIENCE',
  NearMatch = 'NEAR_MATCH',
  SecondaryCapacity = 'SECONDARY_CAPACITY',
  StronglyImpliedExperience = 'STRONGLY_IMPLIED_EXPERIENCE'
}

export type ShortlistCalibrationBorderlineQuestions = {
  __typename?: 'ShortlistCalibrationBorderlineQuestions';
  generationErrorMessage?: Maybe<Scalars['String']>;
  generationStatus: ShortlistCalibrationBorderlineQuestionsStatus;
  id: Scalars['ID'];
  questions?: Maybe<Array<ShortlistCalibrationBorderlineQuestionsEntry>>;
};

export type ShortlistCalibrationBorderlineQuestionsEntry = {
  __typename?: 'ShortlistCalibrationBorderlineQuestionsEntry';
  case: ShortlistCalibrationBorderlineCases;
  criterion?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
};

export enum ShortlistCalibrationBorderlineQuestionsStatus {
  Error = 'ERROR',
  Pending = 'PENDING',
  Running = 'RUNNING',
  Success = 'SUCCESS'
}

export type ShortlistCalibrationConfigEntry = {
  __typename?: 'ShortlistCalibrationConfigEntry';
  answer?: Maybe<ShortlistCalibrationAnswer>;
  case: ShortlistCalibrationBorderlineCases;
  criterion?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
};

export type ShortlistStage = {
  __typename?: 'ShortlistStage';
  applicationQuestions: Array<ShortlistStageApplicationQuestion>;
  branding?: Maybe<StageBranding>;
  calibrationConfig?: Maybe<ShortlistStageCalibrationConfig>;
  createdAt: Scalars['Date'];
  criteria: Array<ShortlistStageCriterion>;
  id: Scalars['Int'];
  isAutoProgressionEnabled: Scalars['Boolean'];
  name: Scalars['String'];
  order: Scalars['Int'];
  projectId: Scalars['Int'];
  questionnaire?: Maybe<Questionnaire>;
  subId: Scalars['ID'];
  updatedAt: Scalars['Date'];
  weightingStrategy: ShortlistStageWeightingStrategy;
};

export type ShortlistStageApplicationQuestion = {
  __typename?: 'ShortlistStageApplicationQuestion';
  display: Scalars['Boolean'];
  isKnockOut: Scalars['Boolean'];
  preferredAnswer?: Maybe<ApplicationQuestionPreferredAnswer>;
  questionId: Scalars['ID'];
  sortOrder: Scalars['Int'];
};

export type ShortlistStageApplicationQuestionDraft = {
  display: Scalars['Boolean'];
  isKnockOut: Scalars['Boolean'];
  /** Omit to clear the preferred answer. */
  preferredAnswer?: InputMaybe<ApplicationQuestionPreferredAnswerInput>;
  /** The screening question this configuration is for. */
  questionId: Scalars['ID'];
};

export type ShortlistStageCalibrationConfig = {
  __typename?: 'ShortlistStageCalibrationConfig';
  config?: Maybe<Array<ShortlistCalibrationConfigEntry>>;
  configuredByUser?: Maybe<User>;
  configuredByUserId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
};

export type ShortlistStageCandidate = {
  __typename?: 'ShortlistStageCandidate';
  applicationQuestionAnswers: Array<ShortlistStageCandidateApplicationQuestionAnswer>;
  createdAt: Scalars['DateTime'];
  criteriaScore?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  isKnockedOut: Scalars['Boolean'];
  isShortlisted: Scalars['Boolean'];
  questionnaireResult?: Maybe<QuestionnaireResult>;
  shortlistStageCandidateCriterionResults?: Maybe<Array<ShortlistStageCandidateCriterionResult>>;
  stage?: Maybe<ShortlistStage>;
};

export type ShortlistStageCandidateApplicationQuestionAnswer = {
  __typename?: 'ShortlistStageCandidateApplicationQuestionAnswer';
  /** Null where the candidate did not answer the question. */
  answer?: Maybe<ApplicationQuestionAnswerValue>;
  /** Null while the stage has no preferred answer configured for the question, so there is nothing to judge the answer against. */
  preferred?: Maybe<ApplicationQuestionAnswerPreference>;
  /** The screening question this answer was given for. */
  questionId: Scalars['ID'];
  /** The question as the candidate was asked it, never the shortened display name used for table columns. */
  questionTitle: Scalars['String'];
  questionType: RoleApplicationQuestionType;
};

export type ShortlistStageCandidateCriterionResult = {
  __typename?: 'ShortlistStageCandidateCriterionResult';
  citations: Array<Citation>;
  citationsTranslated?: Maybe<Array<Citation>>;
  evidenceLevel: ShortlistStageCandidateCriterionResultEvidenceLevel;
  id: Scalars['ID'];
  justification: Scalars['String'];
  shortlistStageCriterion?: Maybe<ShortlistStageCriterion>;
};

export enum ShortlistStageCandidateCriterionResultEvidenceLevel {
  FullEvidence = 'FULL_EVIDENCE',
  NoEvidence = 'NO_EVIDENCE',
  PotentialEvidence = 'POTENTIAL_EVIDENCE'
}

export type ShortlistStageCriterion = {
  __typename?: 'ShortlistStageCriterion';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  isKnockOut: Scalars['Boolean'];
  prohibitedCriteriaCategory?: Maybe<Scalars['String']>;
  prohibitedCriteriaPromptStatus?: Maybe<ShortlistStageCriterionProhibitedCriteriaPromptStatus>;
  rubricGenerationStatus: ShortlistStageCriterionRubricGenerationStatus;
  shortName?: Maybe<Scalars['String']>;
  sortOrder: Scalars['Int'];
  source: ShortlistStageCriterionSource;
  text: Scalars['String'];
  updatedAt: Scalars['Date'];
};

export type ShortlistStageCriterionDraft = {
  id?: InputMaybe<Scalars['ID']>;
  isKnockOut?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<ShortlistStageCriterionSource>;
  text: Scalars['String'];
};

export enum ShortlistStageCriterionProhibitedCriteriaPromptStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export enum ShortlistStageCriterionRubricGenerationStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING'
}

export enum ShortlistStageCriterionSource {
  AiGenerated = 'AI_GENERATED',
  AiModified = 'AI_MODIFIED',
  UserCreated = 'USER_CREATED'
}

export type ShortlistStageResume = {
  __typename?: 'ShortlistStageResume';
  createdAt: Scalars['Date'];
  createdByUserId?: Maybe<Scalars['Int']>;
  fileName?: Maybe<Scalars['String']>;
  fileSizeBytes: Scalars['Int'];
  id: Scalars['Int'];
  processingErrorCode?: Maybe<ShortlistStageResumeProcessingErrorCode>;
  processingStatus: ShortlistStageResumeProcessingStatus;
  projectCandidateSubId?: Maybe<Scalars['ID']>;
  shortlistStageId: Scalars['Int'];
  source: ShortlistStageResumeSource;
  subId: Scalars['ID'];
  updatedAt: Scalars['Date'];
};

export enum ShortlistStageResumeProcessingErrorCode {
  ExtractDataFailed = 'EXTRACT_DATA_FAILED',
  InvalidFile = 'INVALID_FILE',
  MissingEmail = 'MISSING_EMAIL',
  Other = 'OTHER',
  RedactDataFailed = 'REDACT_DATA_FAILED'
}

export enum ShortlistStageResumeProcessingStatus {
  AwaitingProcessing = 'AWAITING_PROCESSING',
  Failed = 'FAILED',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING'
}

export enum ShortlistStageResumeSource {
  ExternalService = 'EXTERNAL_SERVICE',
  UserUpload = 'USER_UPLOAD'
}

export enum ShortlistStageWeightingStrategy {
  Even = 'EVEN',
  Ranking = 'RANKING'
}

export type SingleSelectField = Field & {
  __typename?: 'SingleSelectField';
  fieldInstanceType: FieldInstanceType;
  fieldOwnerId?: Maybe<Scalars['Int']>;
  fieldOwnerName?: Maybe<Scalars['String']>;
  fieldOwnerType?: Maybe<FieldOwnerType>;
  fieldType: FieldType;
  formManagerType: FormManagerType;
  hint?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isArchived: Scalars['Boolean'];
  isFreetextField?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  question?: Maybe<Scalars['String']>;
  selectOptions?: Maybe<Scalars['String']>;
  settings?: Maybe<FieldSettingsModel>;
  txtData?: Maybe<Scalars['String']>;
};

export type SinglepartUpload = {
  __typename?: 'SinglepartUpload';
  key: Scalars['String'];
  signedUrl: Scalars['String'];
  uploadId: Scalars['String'];
};

export type SkillArgs = {
  behaviours?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
  evidenceFound?: Scalars['Boolean'];
  group?: InputMaybe<Scalars['String']>;
  /** Omit to leave the scoring untouched; null reverts to the AI score; a number records a human score. */
  humanScore?: InputMaybe<Scalars['Int']>;
  /** @deprecated Derived by the server from the stored scores; ignored. */
  isAIScored?: Scalars['Boolean'];
  name: Scalars['String'];
  negativeEvidence?: Array<SkillEvidenceArgs>;
  positiveEvidence?: Array<SkillEvidenceArgs>;
  score: Scalars['Int'];
  summary?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type SkillCategory = {
  __typename?: 'SkillCategory';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  updatedAt: Scalars['Date'];
};

export type SkillEventPayload = {
  __typename?: 'SkillEventPayload';
  aiScore: Scalars['Int'];
  behaviours: Array<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  evidenceFound: Scalars['Boolean'];
  group?: Maybe<SkillsEvaluationSkillGroup>;
  humanScore?: Maybe<Scalars['Int']>;
  humanScoredAt?: Maybe<Scalars['DateTime']>;
  humanScoredBy?: Maybe<Scalars['Int']>;
  isAIScored: Scalars['Boolean'];
  name: Scalars['String'];
  negativeEvidence: Array<SkillEvidenceEventPayload>;
  positiveEvidence: Array<SkillEvidenceEventPayload>;
  score: Scalars['Int'];
  summary: Scalars['String'];
  type?: Maybe<SkillsEvaluationSkillType>;
};

export type SkillEvidenceArgs = {
  citations: Array<Scalars['String']>;
  text: Scalars['String'];
};

export type SkillEvidenceEventPayload = {
  __typename?: 'SkillEvidenceEventPayload';
  citations: Array<Scalars['String']>;
  text: Scalars['String'];
};

export type SkillEvidenceModel = {
  __typename?: 'SkillEvidenceModel';
  citations: Array<Scalars['String']>;
  text: Scalars['String'];
};

export type SkillModel = {
  __typename?: 'SkillModel';
  aiScore: Scalars['Int'];
  behaviours: Array<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  evidenceFound: Scalars['Boolean'];
  group?: Maybe<SkillsEvaluationSkillGroup>;
  humanScore?: Maybe<Scalars['Int']>;
  humanScoredAt?: Maybe<Scalars['DateTime']>;
  humanScoredBy?: Maybe<Scalars['Int']>;
  isAIScored: Scalars['Boolean'];
  name: Scalars['String'];
  negativeEvidence: Array<SkillEvidenceModel>;
  positiveEvidence: Array<SkillEvidenceModel>;
  score: Scalars['Int'];
  summary: Scalars['String'];
  type?: Maybe<SkillsEvaluationSkillType>;
};

/** Aggregated score for a single skill across all completed evaluations */
export type SkillResultModel = {
  __typename?: 'SkillResultModel';
  /** Average score across all completed evaluations that scored this skill (0-100) */
  aggregateScore: Scalars['Float'];
  /** Individual scores from each evaluator */
  evaluatorScores: Array<EvaluatorSkillScoreModel>;
  /** Skill category (RIGHT_FOR_THE_ROLE / JOB / FUTURE) */
  group?: Maybe<SkillsEvaluationSkillGroup>;
  /** Skill name */
  name: Scalars['String'];
  /** SOFT_SKILL or TECHNICAL_SKILL */
  type?: Maybe<SkillsEvaluationSkillType>;
};

export enum SkillType {
  SoftSkill = 'SOFT_SKILL',
  TechnicalSkill = 'TECHNICAL_SKILL'
}

export type SkillUnion = BroadSoftSkill | FocusedSoftSkill | TechnicalSkill;

export type SkillWithResultModel = {
  __typename?: 'SkillWithResultModel';
  result?: Maybe<ResultModel>;
  skill: SkillUnion;
};

export type SkillsEvaluationEventPayload = {
  __typename?: 'SkillsEvaluationEventPayload';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['String'];
  interviewEvaluationId: Scalars['String'];
  isUsingRsp: Scalars['Boolean'];
  skills: Array<SkillEventPayload>;
  status: InterviewSkillsEvaluationStatusV2;
  updatedAt: Scalars['Date'];
};

export type SkillsEvaluationModelV2 = {
  __typename?: 'SkillsEvaluationModelV2';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['String'];
  interviewEvaluationId: Scalars['String'];
  isUsingRsp: Scalars['Boolean'];
  skills: Array<SkillModel>;
  status: InterviewSkillsEvaluationStatusV2;
  updatedAt: Scalars['Date'];
};

export enum SkillsEvaluationSkillGroup {
  RightForTheFuture = 'RIGHT_FOR_THE_FUTURE',
  RightForTheJob = 'RIGHT_FOR_THE_JOB',
  RightForTheRole = 'RIGHT_FOR_THE_ROLE'
}

export enum SkillsEvaluationSkillType {
  SoftSkill = 'SOFT_SKILL',
  TechnicalSkill = 'TECHNICAL_SKILL'
}

export type SkillsProfileOpenOneModel = {
  __typename?: 'SkillsProfileOpenOneModel';
  skillsWithResults: Array<SpSkillWithResultModel>;
  softSkillGradeBands: Array<SoftSkillSelfAssessmentGradeBandModel>;
  technicalSkillGradeBands: Array<TechnicalSkillSelfAssessmentGradeBandModel>;
};

export enum SkillsProfileSkillGenerationStatus {
  Failed = 'FAILED',
  Generated = 'GENERATED',
  Processing = 'PROCESSING'
}

export enum SkillsProfileSkillSource {
  Admin = 'ADMIN',
  Ai = 'AI',
  System = 'SYSTEM',
  TemplateLocked = 'TEMPLATE_LOCKED',
  TemplateRecommended = 'TEMPLATE_RECOMMENDED',
  User = 'USER'
}

export type SkillsProfileSource = {
  __typename?: 'SkillsProfileSource';
  collaborators: Array<SkillsProfileSourceCollaboratorGqlModel>;
  company: Company;
  confirmedAt?: Maybe<Scalars['Date']>;
  confirmedBy?: Maybe<User>;
  createdAt: Scalars['Date'];
  creator: User;
  dataSources: SkillsProfileSourceDataSources;
  generatedAt?: Maybe<Scalars['Date']>;
  incompleteInputsGeneration: Scalars['Boolean'];
  inputErrorGeneration: Scalars['Boolean'];
  inputsChangedAt?: Maybe<Scalars['Date']>;
  isConfirmed: Scalars['Boolean'];
  jobRole?: Maybe<JobRoleModel>;
  jobRoleMetadata: SkillsProfileSourceJobRoleMetadata;
  skillGenerationStatus?: Maybe<SkillsProfileSourceSkillGenerationStatus>;
  skillsProfile?: Maybe<SuccessProfile>;
  softSkills: Array<SkillsProfileSourceSoftSkill>;
  status: SkillsProfileSourceStatus;
  subId: Scalars['String'];
  technicalSkills: Array<SkillsProfileSourceTechnicalSkill>;
  updatedAt: Scalars['Date'];
};

export type SkillsProfileSourceAddSoftSkillsArgs = {
  softSkillSubId: Scalars['ID'];
};

export type SkillsProfileSourceAddTechnicalSkillsArgs = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type SkillsProfileSourceAdditionalAvailableAssessment = {
  __typename?: 'SkillsProfileSourceAdditionalAvailableAssessment';
  timeRequirementMinutes?: Maybe<Scalars['Int']>;
  timeRequirementMinutesMax?: Maybe<Scalars['Int']>;
  timeRequirementMinutesMin?: Maybe<Scalars['Int']>;
  type: AdditionalAssessmentType;
};

export type SkillsProfileSourceAvailableAssessment = {
  __typename?: 'SkillsProfileSourceAvailableAssessment';
  requirement: SkillsProfileSourceAvailableAssessmentRequirement;
  timeRequirementMinutes: Scalars['Int'];
};

export enum SkillsProfileSourceAvailableAssessmentRequirement {
  Available = 'AVAILABLE',
  Recommended = 'RECOMMENDED',
  Required = 'REQUIRED'
}

export type SkillsProfileSourceAvailableAssessments = {
  __typename?: 'SkillsProfileSourceAvailableAssessments';
  additionalAssessments: Array<SkillsProfileSourceAdditionalAvailableAssessment>;
  inductiveReasoningAssessment?: Maybe<SkillsProfileSourceAvailableAssessment>;
  numericalReasoningAssessment?: Maybe<SkillsProfileSourceAvailableAssessment>;
  personalityAssessment?: Maybe<SkillsProfileSourceAvailableAssessment>;
  verbalReasoningAssessment?: Maybe<SkillsProfileSourceAvailableAssessment>;
};

export type SkillsProfileSourceCollaboratorArgs = {
  role: SkillsProfileSourceCollaboratorRole;
  userId: Scalars['Int'];
};

export type SkillsProfileSourceCollaboratorGqlModel = {
  __typename?: 'SkillsProfileSourceCollaboratorGQLModel';
  role: SkillsProfileSourceCollaboratorRole;
  user: User;
};

export enum SkillsProfileSourceCollaboratorRole {
  HiringManager = 'HIRING_MANAGER',
  Recruiter = 'RECRUITER'
}

export type SkillsProfileSourceCompleteIntakeMeetingUploadArgs = {
  key: Scalars['String'];
  parts: Array<MultipartCompletedPart>;
  uploadId: Scalars['String'];
};

export type SkillsProfileSourceCompleteJobDescriptionUploadArgs = {
  etag: Scalars['String'];
  key: Scalars['String'];
  uploadId: Scalars['String'];
};

export type SkillsProfileSourceDataSources = {
  __typename?: 'SkillsProfileSourceDataSources';
  intakeMeeting: SkillsProfileSourceIntakeMeeting;
  jobDescription: SkillsProfileSourceJobDescription;
  meeting?: Maybe<SkillsProfileSourceMeeting>;
  upcomingMeeting?: Maybe<SkillsProfileSourceUpcomingMeeting>;
};

export type SkillsProfileSourceInitiateIntakeMeetingUploadArgs = {
  contentType: Scalars['String'];
  fileName: Scalars['String'];
  nParts: Scalars['Int'];
};

export type SkillsProfileSourceInitiateJobDescriptionUploadArgs = {
  contentType: Scalars['String'];
  fileName: Scalars['String'];
};

export type SkillsProfileSourceIntakeMeeting = {
  __typename?: 'SkillsProfileSourceIntakeMeeting';
  fileName?: Maybe<Scalars['String']>;
  status: SkillsProfileSourceIntakeMeetingProcessingStatus;
};

export enum SkillsProfileSourceIntakeMeetingProcessingStatus {
  Failed = 'FAILED',
  Missing = 'MISSING',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING'
}

export type SkillsProfileSourceJobDescription = {
  __typename?: 'SkillsProfileSourceJobDescription';
  fileName?: Maybe<Scalars['String']>;
  status: SkillsProfileSourceJobDescriptionProcessingStatus;
  uploadedAt?: Maybe<Scalars['Date']>;
};

export enum SkillsProfileSourceJobDescriptionProcessingStatus {
  Failed = 'FAILED',
  Missing = 'MISSING',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING'
}

export type SkillsProfileSourceJobRoleMetadata = {
  __typename?: 'SkillsProfileSourceJobRoleMetadata';
  family: JobRoleFamily;
  level: ContentRoleLevel;
  name: Scalars['String'];
};

export type SkillsProfileSourceJobRoleMetadataArgs = {
  family: JobRoleFamily;
  level: ContentRoleLevel;
  name: Scalars['String'];
};

export type SkillsProfileSourceJobRoleMetadataUpdateArgs = {
  family?: InputMaybe<JobRoleFamily>;
  level?: InputMaybe<ContentRoleLevel>;
  name?: InputMaybe<Scalars['String']>;
};

export type SkillsProfileSourceMeeting = {
  __typename?: 'SkillsProfileSourceMeeting';
  id: Scalars['ID'];
};

export type SkillsProfileSourceMeetingLinkedStatus = {
  __typename?: 'SkillsProfileSourceMeetingLinkedStatus';
  isLinked: Scalars['Boolean'];
  meetingId: Scalars['ID'];
};

export type SkillsProfileSourceMeetingLinks = {
  __typename?: 'SkillsProfileSourceMeetingLinks';
  meetings: Array<SkillsProfileSourceMeetingLinkedStatus>;
  upcomingMeetings: Array<SkillsProfileSourceUpcomingMeetingLinkedStatus>;
};

export enum SkillsProfileSourceOrder {
  CreatedAt = 'CREATED_AT',
  RoleName = 'ROLE_NAME',
  Status = 'STATUS',
  UpdatedAt = 'UPDATED_AT'
}

export type SkillsProfileSourceRemoveSoftSkillArgs = {
  removalComments?: InputMaybe<Scalars['String']>;
  removalReasons: Array<SkillsProfileSourceSkillRemovalReason>;
  softSkillSubId: Scalars['ID'];
};

export type SkillsProfileSourceRemoveTechnicalSkillArgs = {
  id: Scalars['Int'];
  removalComments?: InputMaybe<Scalars['String']>;
  removalReasons: Array<SkillsProfileSourceSkillRemovalReason>;
};

export type SkillsProfileSourceSelectedAssessments = {
  inductiveReasoningAssessment: Scalars['Boolean'];
  numericalReasoningAssessment: Scalars['Boolean'];
  personalityAssessment: Scalars['Boolean'];
  verbalReasoningAssessment: Scalars['Boolean'];
};

export type SkillsProfileSourceSignOffArgs = {
  selectedAssessments: SkillsProfileSourceSelectedAssessments;
};

export enum SkillsProfileSourceSkillGenerationStatus {
  Failed = 'FAILED',
  Generated = 'GENERATED',
  Processing = 'PROCESSING'
}

export enum SkillsProfileSourceSkillRemovalReason {
  DuplicateOrRedundant = 'DUPLICATE_OR_REDUNDANT',
  NotRelevant = 'NOT_RELEVANT',
  Other = 'OTHER',
  UnclearOrVague = 'UNCLEAR_OR_VAGUE'
}

export type SkillsProfileSourceSoftSkill = {
  __typename?: 'SkillsProfileSourceSoftSkill';
  addedByUser?: Maybe<User>;
  createdAt: Scalars['Date'];
  softSkill: SoftSkill;
  source: SkillsProfileSourceSoftSkillSource;
  updatedAt: Scalars['Date'];
};

export enum SkillsProfileSourceSoftSkillSource {
  Ai = 'AI',
  System = 'SYSTEM',
  User = 'USER'
}

export enum SkillsProfileSourceStatus {
  ActionRequired = 'ACTION_REQUIRED',
  Confirmed = 'CONFIRMED',
  Processing = 'PROCESSING',
  ReadyForReview = 'READY_FOR_REVIEW'
}

export type SkillsProfileSourceTechnicalSkill = {
  __typename?: 'SkillsProfileSourceTechnicalSkill';
  addedByUser?: Maybe<User>;
  createdAt: Scalars['Date'];
  technicalSkill: TechnicalSkill;
  updatedAt: Scalars['Date'];
};

export type SkillsProfileSourceUpcomingMeeting = {
  __typename?: 'SkillsProfileSourceUpcomingMeeting';
  sharedId: Scalars['ID'];
};

export type SkillsProfileSourceUpcomingMeetingLinkedStatus = {
  __typename?: 'SkillsProfileSourceUpcomingMeetingLinkedStatus';
  isLinked: Scalars['Boolean'];
  upcomingMeetingSharedId: Scalars['ID'];
};

export type SkillsProfileSourceUpdateArgs = {
  jobRoleMetadata: SkillsProfileSourceJobRoleMetadataUpdateArgs;
};

export type SkillsProfileSourceUpsertCollaboratorsArgs = {
  collaborators: Array<SkillsProfileSourceCollaboratorArgs>;
};

export type SkillsProfileSourcesFiltersArgs = {
  search?: InputMaybe<Scalars['String']>;
};

export type SkillsProfileSourcesOrderArgs = {
  direction?: InputMaybe<SortOption>;
  field?: InputMaybe<SkillsProfileSourceOrder>;
};

export type SkillsProfileSourcesPaginated = {
  __typename?: 'SkillsProfileSourcesPaginated';
  page: Pageinfo;
  skillsProfileSources: Array<SkillsProfileSource>;
};

export type SkillsProfileTemplate = {
  __typename?: 'SkillsProfileTemplate';
  company: Company;
  companyId: Scalars['Int'];
  createdAt: Scalars['Date'];
  createdByUser?: Maybe<User>;
  createdByUserId?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['Date']>;
  description: Scalars['String'];
  id: Scalars['Int'];
  latestVersion?: Maybe<SkillsProfileTemplateVersion>;
  name: Scalars['String'];
};

export enum SkillsProfileTemplateOrderField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  PublishedAt = 'PUBLISHED_AT'
}

export type SkillsProfileTemplatePaginated = {
  __typename?: 'SkillsProfileTemplatePaginated';
  archivedCount: Scalars['Int'];
  page: Pageinfo;
  templates: Array<SkillsProfileTemplate>;
};

export type SkillsProfileTemplateSkill = {
  __typename?: 'SkillsProfileTemplateSkill';
  id: Scalars['Int'];
  isLocked: Scalars['Boolean'];
};

export type SkillsProfileTemplateSkillInput = {
  isLocked: Scalars['Boolean'];
  skillId: Scalars['Int'];
};

export type SkillsProfileTemplateVersion = {
  __typename?: 'SkillsProfileTemplateVersion';
  createdAt: Scalars['Date'];
  createdByUser?: Maybe<User>;
  createdByUserId?: Maybe<Scalars['Int']>;
  fixed: Scalars['Boolean'];
  id: Scalars['Int'];
  softSkills: Array<SkillsProfileTemplateSkill>;
  technicalSkills: Array<SkillsProfileTemplateSkill>;
  template: SkillsProfileTemplate;
  templateId: Scalars['Int'];
  version: Scalars['Int'];
};

/** One interview window offered to a candidate */
export type SlotWindowInput = {
  /** When the interview ends */
  endsAt: Scalars['DateTime'];
  /** When the interview starts */
  startsAt: Scalars['DateTime'];
};

export type SmStageCandidateModel = {
  __typename?: 'SmStageCandidateModel';
  actionCandidates: StageCandidateActionCandidates;
  aiInterviewAction?: Maybe<AiInterviewAssessmentStageActionCandidate>;
  applicationId?: Maybe<Scalars['String']>;
  assignees: Array<ProjectManager>;
  /** @deprecated Please use doneFor instead! */
  candidateId: Scalars['Int'];
  candidateProjectManagerIds?: Maybe<Array<Scalars['Int']>>;
  cognitiveTestActionCandidates: Array<CognitiveTestAssessmentStageActionCandidate>;
  companyId?: Maybe<Scalars['Int']>;
  completedAt?: Maybe<Scalars['Date']>;
  createdAt: Scalars['Date'];
  deadlineAt?: Maybe<Scalars['Date']>;
  deiStageActionCandidate?: Maybe<DeiStageActionCandidateModel>;
  deletedAt?: Maybe<Scalars['Date']>;
  doneBy: Scalars['Int'];
  doneByUser: User;
  doneFor: Scalars['Int'];
  doneForUser: User;
  formCandidates?: Maybe<Array<Maybe<FormCandidateModel>>>;
  hasCompletedAdjustmentQuestionnaire: Scalars['Boolean'];
  hasPledgedAnticheating: Scalars['Boolean'];
  hiringManagers: Array<User>;
  id: Scalars['Int'];
  interviewGuideBlueprints: Array<CandidateInterviewGuideModel>;
  isNew: Scalars['Boolean'];
  lastDateOfCandidateAction?: Maybe<Scalars['Date']>;
  personalityTestActionCandidate?: Maybe<PersonalityTestAssessmentStageActionCandidate>;
  projectCandidate: BasicProjectCandidate;
  results?: Maybe<Array<ResultModel>>;
  rssAssessmentCandidates?: Maybe<Array<RssAssessmentCandidateModel>>;
  shouldContactUs: Scalars['Boolean'];
  spottedZebraScore?: Maybe<SpottedZebraScore>;
  stage: SmStageModel;
  stageId: Scalars['Int'];
  status: StageCandidateStatus;
  subId: Scalars['String'];
  updatedAt: Scalars['Date'];
};

export type SmStageModel = {
  __typename?: 'SmStageModel';
  additionalAssessmentTypes: Array<AdditionalAssessmentType>;
  aiInterview?: Maybe<AiInterviewAssessmentStageAction>;
  assessmentExpiryOption?: Maybe<AssessmentExpiryOption>;
  availableActions: Array<StageAvailableActionModel>;
  candidateReport?: Maybe<Report>;
  coderbyte?: Maybe<CoderbyteAssessmentStageAction>;
  cognitiveMode: CognitiveMode;
  cognitiveTest?: Maybe<CognitiveTestAssessmentStageAction>;
  cognitiveTests: Array<CognitiveTestAssessmentStageAction>;
  createdAt: Scalars['Date'];
  deiStageAction?: Maybe<DeiStageActionModel>;
  deiStageActionTemplate?: Maybe<DeiStageActionTemplateModel>;
  deletedAt?: Maybe<Scalars['Date']>;
  emailCandidateReport: Scalars['Boolean'];
  enableF2fInterviews: Scalars['Boolean'];
  endTime?: Maybe<Scalars['Date']>;
  englishProficiency?: Maybe<EnglishProficiencyAssessmentStageAction>;
  formId?: Maybe<Scalars['Int']>;
  hasAdjustmentQuestionnaire: Scalars['Boolean'];
  hasCalibration: Scalars['Boolean'];
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  isIntegrityMonitoringEnabled: Scalars['Boolean'];
  kind: AssessmentStageKind;
  managerReport?: Maybe<Report>;
  name: Scalars['String'];
  order: Scalars['Int'];
  personalityTest?: Maybe<PersonalityTestAssessmentStageAction>;
  projectId: Scalars['Int'];
  projectTeamEmailSettings: ProjectTeamEmailSettings;
  rssAssessmentIds?: Maybe<Array<Scalars['Int']>>;
  rssAssessments: Array<RssAssessmentModel>;
  scoringConfig?: Maybe<StageScoringConfig>;
  softSkills: Array<SoftSkill>;
  startTime?: Maybe<Scalars['Date']>;
  status: StageStatus;
  subId: Scalars['String'];
  technicalSkills: Array<TechnicalSkill>;
  updatedAt: Scalars['Date'];
};


export type SmStageModelCognitiveTestArgs = {
  kind: CognitiveKind;
};

export type SoftSkill = {
  category: SoftSkillCategory;
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  examples: Array<Scalars['String']>;
  granularity: SoftSkillGranularity;
  /** @deprecated Please use subId instead */
  id: Scalars['Int'];
  measurementConstructType?: Maybe<MeasurementConstructType>;
  name: Scalars['String'];
  softSkillTraits?: Maybe<Array<SoftSkillTrait>>;
  subId: Scalars['ID'];
  taxonomyVersion: Scalars['Int'];
  updatedAt: Scalars['Date'];
};

export enum SoftSkillCategory {
  CognitiveSummary = 'COGNITIVE_SUMMARY',
  RightForTheFuture = 'RIGHT_FOR_THE_FUTURE',
  RightForTheRole = 'RIGHT_FOR_THE_ROLE',
  RightForUs = 'RIGHT_FOR_US'
}

export enum SoftSkillContentHeaderType {
  InterviewInstructions = 'INTERVIEW_INSTRUCTIONS',
  None = 'NONE'
}

export type SoftSkillFindManyPaginatedFilters = {
  category?: InputMaybe<SoftSkillCategory>;
  companyId?: InputMaybe<Scalars['Int']>;
  companySpecificOnly?: InputMaybe<Scalars['Boolean']>;
  granularity?: InputMaybe<SoftSkillGranularity>;
  name?: InputMaybe<Scalars['String']>;
  taxonomyVersion?: InputMaybe<Scalars['Int']>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type SoftSkillFindManyPaginatedOrder = {
  direction?: InputMaybe<SortOption>;
  field?: InputMaybe<SoftSkillSortField>;
};

export enum SoftSkillGranularity {
  Broad = 'BROAD',
  Focused = 'FOCUSED'
}

export enum SoftSkillImageType {
  CategoryImage = 'CATEGORY_IMAGE',
  SoftSkillImage = 'SOFT_SKILL_IMAGE'
}

export type SoftSkillIndicator = {
  description: Scalars['String'];
  indicator: Scalars['String'];
  probe: Scalars['String'];
  reason: Scalars['String'];
  trigger: Scalars['String'];
};

export type SoftSkillIndicatorInput = {
  description: Scalars['String'];
  indicator: Scalars['String'];
  negative_evidence: SoftSkillIndicatorV2NegativeEvidenceInput;
  probe: Scalars['String'];
  reason: Scalars['String'];
  scores: Array<SoftSkillIndicatorV2ScoreInput>;
  trigger: Scalars['String'];
};

export type SoftSkillIndicatorV1 = SoftSkillIndicator & {
  __typename?: 'SoftSkillIndicatorV1';
  description: Scalars['String'];
  indicator: Scalars['String'];
  probe: Scalars['String'];
  reason: Scalars['String'];
  rubric_1: Scalars['String'];
  rubric_2: Scalars['String'];
  rubric_3: Scalars['String'];
  rubric_4: Scalars['String'];
  rubric_5: Scalars['String'];
  trigger: Scalars['String'];
};

export type SoftSkillIndicatorV2 = SoftSkillIndicator & {
  __typename?: 'SoftSkillIndicatorV2';
  description: Scalars['String'];
  indicator: Scalars['String'];
  negative_evidence: SoftSkillIndicatorV2NegativeEvidence;
  probe: Scalars['String'];
  reason: Scalars['String'];
  scores: Array<SoftSkillIndicatorV2Score>;
  trigger: Scalars['String'];
};

export type SoftSkillIndicatorV2NegativeEvidence = {
  __typename?: 'SoftSkillIndicatorV2NegativeEvidence';
  red_flags: Array<SoftSkillIndicatorV2Pattern>;
  score_reducing_patterns: Array<SoftSkillIndicatorV2Pattern>;
};

export type SoftSkillIndicatorV2NegativeEvidenceInput = {
  red_flags: Array<SoftSkillIndicatorV2PatternInput>;
  score_reducing_patterns: Array<SoftSkillIndicatorV2PatternInput>;
};

export type SoftSkillIndicatorV2Pattern = {
  __typename?: 'SoftSkillIndicatorV2Pattern';
  example: Scalars['String'];
  pattern: Scalars['String'];
};

export type SoftSkillIndicatorV2PatternInput = {
  example: Scalars['String'];
  pattern: Scalars['String'];
};

export type SoftSkillIndicatorV2Score = {
  __typename?: 'SoftSkillIndicatorV2Score';
  differentiation: Scalars['String'];
  gateway_criteria: Array<Scalars['String']>;
  label: Scalars['String'];
  score: Scalars['Int'];
};

export type SoftSkillIndicatorV2ScoreInput = {
  differentiation: Scalars['String'];
  gateway_criteria: Array<Scalars['String']>;
  label: Scalars['String'];
  score: Scalars['Int'];
};

export type SoftSkillRoleLevelContent = {
  __typename?: 'SoftSkillRoleLevelContent';
  candidateContent?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  grade: Grade;
  gradeDescription?: Maybe<Scalars['String']>;
  hiringManagerContent?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  internalCandidateContent?: Maybe<Scalars['String']>;
  roleLevel: ContentRoleLevel;
  scoreRange?: Maybe<Scalars['String']>;
  softSkill: SoftSkill;
  softSkillId?: Maybe<Scalars['Int']>;
};

export type SoftSkillRoleLevelContentPaginated = {
  __typename?: 'SoftSkillRoleLevelContentPaginated';
  count?: Maybe<Scalars['Float']>;
  softSkillContent?: Maybe<Array<SoftSkillRoleLevelContent>>;
};

export type SoftSkillRoleLevelContentUploadLineModel = {
  __typename?: 'SoftSkillRoleLevelContentUploadLineModel';
  candidateContent: Scalars['String'];
  description: Scalars['String'];
  grade: Grade;
  hiringManagerContent: Scalars['String'];
  internalCandidateContent: Scalars['String'];
  roleLevel: ContentRoleLevel;
  softSkillSubId: Scalars['String'];
};

export type SoftSkillSelfAssessmentGradeBandModel = {
  __typename?: 'SoftSkillSelfAssessmentGradeBandModel';
  displayText: Scalars['String'];
  position: Scalars['Int'];
  proficiency: SoftSkillSelfAssessmentProficiencyLevel;
};

export enum SoftSkillSelfAssessmentProficiencyLevel {
  Beginner = 'BEGINNER',
  Expert = 'EXPERT',
  Intermediate = 'INTERMEDIATE'
}

export type SoftSkillSelfAssessmentScoreModel = {
  __typename?: 'SoftSkillSelfAssessmentScoreModel';
  proficiency: SoftSkillSelfAssessmentProficiencyLevel;
};

export type SoftSkillSemanticSearchArgs = {
  threshold?: InputMaybe<Scalars['Float']>;
  value: Scalars['String'];
};

export enum SoftSkillSortField {
  Category = 'Category',
  Granularity = 'Granularity',
  Name = 'Name',
  Taxonomy = 'Taxonomy'
}

export type SoftSkillSuccessProfileContent = {
  __typename?: 'SoftSkillSuccessProfileContent';
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  roleLevel: ContentRoleLevel;
  shortDescription?: Maybe<Scalars['String']>;
  softSkill: SoftSkill;
  softSkillId: Scalars['Int'];
};

export type SoftSkillSuccessProfileContentPaginated = {
  __typename?: 'SoftSkillSuccessProfileContentPaginated';
  count?: Maybe<Scalars['Float']>;
  softSkillContent?: Maybe<Array<SoftSkillSuccessProfileContent>>;
};

export type SoftSkillTrait = {
  __typename?: 'SoftSkillTrait';
  id?: Maybe<Scalars['Int']>;
  orientation: Orientation;
  softSkill?: Maybe<SoftSkill>;
  softSkillId?: Maybe<Scalars['Int']>;
  softSkillName?: Maybe<Scalars['String']>;
  trait?: Maybe<Trait>;
  traitId?: Maybe<Scalars['Int']>;
  traitName?: Maybe<Scalars['String']>;
  weight: Scalars['Float'];
};

export type SoftSkillTraitUpsertArgs = {
  orientation: Orientation;
  traitId: Scalars['Int'];
  weight: Scalars['Float'];
};

export enum SoftSkillType {
  Core = 'CORE',
  Differentiator = 'DIFFERENTIATOR',
  Diversity = 'DIVERSITY'
}

export type SoftSkillTypeSuccessProfileContent = {
  __typename?: 'SoftSkillTypeSuccessProfileContent';
  description: Scalars['String'];
  id: Scalars['Int'];
  softSkillType: SoftSkillType;
};

export type SoftSkillUpdateArgs = {
  category?: InputMaybe<SoftSkillCategory>;
  childSubIds?: InputMaybe<Array<Scalars['ID']>>;
  companyId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  examples?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Scalars['String']>;
  parentSubIds?: InputMaybe<Array<Scalars['ID']>>;
  siblingSubIds?: InputMaybe<Array<Scalars['ID']>>;
  softSkillTraits?: InputMaybe<Array<SoftSkillTraitUpsertArgs>>;
  taxonomyVersion?: InputMaybe<Scalars['Int']>;
};

export enum SortOption {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type SpSkillWithResultModel = {
  __typename?: 'SpSkillWithResultModel';
  result: ResultModel;
  skill: SkillUnion;
};

export type SpottedZebraScore = {
  __typename?: 'SpottedZebraScore';
  components: Array<SpottedZebraScoreComponent>;
  error?: Maybe<TotalScoreError>;
  formulaVersion: Scalars['Int'];
  isKnockedOut: Scalars['Boolean'];
  knockedOutBy: Array<ScoreComponent>;
  value?: Maybe<Scalars['Int']>;
};

export type SpottedZebraScoreComponent = {
  __typename?: 'SpottedZebraScoreComponent';
  detail?: Maybe<Scalars['String']>;
  key: ScoreComponent;
  kind: ScoreComponentKind;
  met?: Maybe<Scalars['Boolean']>;
  score?: Maybe<Scalars['Int']>;
  weight: Scalars['Float'];
};

export enum StageActionAvailability {
  AlreadyExists = 'ALREADY_EXISTS',
  Available = 'AVAILABLE',
  NotAvailable = 'NOT_AVAILABLE'
}

export type StageActionSummary = {
  __typename?: 'StageActionSummary';
  estimatedTime?: Maybe<Scalars['Int']>;
  stageActionKind: AssessmentStageActionKind;
};

export type StageAvailableActionModel = {
  __typename?: 'StageAvailableActionModel';
  availability: StageActionAvailability;
  kind: AssessmentStageActionKind;
  name: Scalars['String'];
};

export type StageBranding = {
  __typename?: 'StageBranding';
  description?: Maybe<Scalars['String']>;
  estimatedTimeMinutes?: Maybe<Scalars['Int']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type StageCandidateActionCandidates = {
  __typename?: 'StageCandidateActionCandidates';
  aiInterview?: Maybe<AiInterviewAssessmentStageActionCandidate>;
  coderbyte?: Maybe<CoderbyteAssessmentStageActionCandidate>;
  cognitiveTests: Array<CognitiveTestAssessmentStageActionCandidate>;
  dei?: Maybe<DeiStageActionCandidateModel>;
  englishProficiency?: Maybe<EnglishProficiencyAssessmentStageActionCandidate>;
  forms: Array<FormCandidateModel>;
  personalityTest?: Maybe<PersonalityTestAssessmentStageActionCandidate>;
  roleSkillSelfAssessments: Array<RssAssessmentCandidateModel>;
};

export enum StageCandidateInviteMethod {
  Ats = 'ATS',
  Csv = 'CSV',
  Email = 'EMAIL',
  Url = 'URL'
}

export enum StageCandidateSkillsProfileCategory {
  CognitiveSummary = 'COGNITIVE_SUMMARY',
  GeneralSkills = 'GENERAL_SKILLS',
  RightForTheFuture = 'RIGHT_FOR_THE_FUTURE',
  RightForTheRole = 'RIGHT_FOR_THE_ROLE',
  RightForUs = 'RIGHT_FOR_US'
}

export type StageCandidateSkillsProfileCategoryResultsModel = {
  __typename?: 'StageCandidateSkillsProfileCategoryResultsModel';
  name: StageCandidateSkillsProfileCategory;
  score?: Maybe<StatisticalResultScoreModel>;
  skills: Array<StageCandidateSkillsProfileSkillResultModel>;
};

export type StageCandidateSkillsProfileResultsModel = {
  __typename?: 'StageCandidateSkillsProfileResultsModel';
  categories: Array<StageCandidateSkillsProfileCategoryResultsModel>;
  projectJobRoleId: Scalars['Int'];
  score?: Maybe<StatisticalResultScoreModel>;
  skillsProfileId: Scalars['Int'];
  stageCandidateCreatedAt: Scalars['Date'];
  stageCandidateId: Scalars['Int'];
  stageCandidateLastDateOfCandidateAction?: Maybe<Scalars['Date']>;
  stageCandidateStatus: StageCandidateStatus;
};

export type StageCandidateSkillsProfileSkillResultModel = {
  __typename?: 'StageCandidateSkillsProfileSkillResultModel';
  id: Scalars['Int'];
  name: Scalars['String'];
  score?: Maybe<ResultScoreUnion>;
  type: SkillType;
};

export type StageCandidateStatisticsByProjectJobRoleFindManyFilterArgs = {
  lastDateOfCandidateActionGte?: InputMaybe<Scalars['Date']>;
  lastDateOfCandidateActionLte?: InputMaybe<Scalars['Date']>;
  nameOrEmailLike?: InputMaybe<Scalars['String']>;
  overallScorePercentileGte?: InputMaybe<Scalars['Float']>;
  overallScorePercentileLte?: InputMaybe<Scalars['Float']>;
};

export type StageCandidateStatisticsByProjectJobRoleFindManyOrderArgs = {
  direction?: InputMaybe<SortOption>;
  field?: InputMaybe<StageCandidateStatisticsByProjectJobRoleOrderField>;
};

export type StageCandidateStatisticsByProjectJobRoleFindManyOutput = {
  __typename?: 'StageCandidateStatisticsByProjectJobRoleFindManyOutput';
  page: Pageinfo;
  projectJobRole: ProjectJobRoleModel;
  stageCandidatesStatisticsByJobRole: Array<StageCandidateStatisticsByProjectJobRoleModel>;
};

export type StageCandidateStatisticsByProjectJobRoleModel = {
  __typename?: 'StageCandidateStatisticsByProjectJobRoleModel';
  cognitiveCombinedScore?: Maybe<StatisticalResultScoreModel>;
  cognitiveSummaryScore?: Maybe<StatisticalResultScoreModel>;
  overallScore?: Maybe<StatisticalResultScoreModel>;
  projectJobRole: ProjectJobRoleModel;
  rightForTheFutureScore?: Maybe<StatisticalResultScoreModel>;
  rightForTheRoleScore?: Maybe<StatisticalResultScoreModel>;
  rightForUsScore?: Maybe<StatisticalResultScoreModel>;
  stageCandidate: SmStageCandidateModel;
};

export enum StageCandidateStatisticsByProjectJobRoleOrderField {
  CognitiveCombinedScore = 'CognitiveCombinedScore',
  CognitiveSummaryScore = 'CognitiveSummaryScore',
  LastDateOfCandidateAction = 'LastDateOfCandidateAction',
  Name = 'Name',
  OverallScore = 'OverallScore',
  RightForTheFutureScore = 'RightForTheFutureScore',
  RightForTheRoleScore = 'RightForTheRoleScore',
  RightForUsScore = 'RightForUsScore'
}

export type StageCandidateStatisticsFindManyFilterArgs = {
  createdAtGte?: InputMaybe<Scalars['Date']>;
  createdAtLte?: InputMaybe<Scalars['Date']>;
  lastDateOfCandidateActionGte?: InputMaybe<Scalars['Date']>;
  lastDateOfCandidateActionLte?: InputMaybe<Scalars['Date']>;
  nameOrEmailContains?: InputMaybe<Scalars['String']>;
  progressionStatusIn?: InputMaybe<Array<ProgressionStatus>>;
  stageProgressionStatusIn?: InputMaybe<Array<StageProgressionStatus>>;
  statusIn?: InputMaybe<Array<StageCandidateStatus>>;
};

export type StageCandidateStatisticsFindManyOrderArgs = {
  direction?: InputMaybe<SortOption>;
  field?: InputMaybe<StageCandidateStatisticsOrderField>;
};

export type StageCandidateStatisticsFindManyOutput = {
  __typename?: 'StageCandidateStatisticsFindManyOutput';
  page: Pageinfo;
  stage: SmStageModel;
  stageCandidatesStatistics: Array<StageCandidateStatisticsModel>;
};

export type StageCandidateStatisticsModel = {
  __typename?: 'StageCandidateStatisticsModel';
  progressionStatus: ProgressionStatus;
  stageCandidate: SmStageCandidateModel;
  stageCandidateStatisticsProjectJobRoles: Array<StageCandidateStatisticsProjectJobRoleModel>;
};

export enum StageCandidateStatisticsOrderField {
  CreatedAt = 'CreatedAt',
  LastDateOfCandidateAction = 'LastDateOfCandidateAction',
  Name = 'Name',
  PsychometricOverall = 'PsychometricOverall',
  Status = 'Status'
}

export type StageCandidateStatisticsProjectJobRoleModel = {
  __typename?: 'StageCandidateStatisticsProjectJobRoleModel';
  cognitiveCombinedScore?: Maybe<StatisticalResultScoreModel>;
  cognitiveSummaryScore?: Maybe<StatisticalResultScoreModel>;
  overallScore?: Maybe<StatisticalResultScoreModel>;
  projectJobRole: ProjectJobRoleModel;
  reports: Array<StageCandidateStatisticsProjectJobRoleReportModel>;
  rightForTheFutureScore?: Maybe<StatisticalResultScoreModel>;
  rightForTheRoleScore?: Maybe<StatisticalResultScoreModel>;
  rightForUsScore?: Maybe<StatisticalResultScoreModel>;
};

export type StageCandidateStatisticsProjectJobRoleReportModel = {
  __typename?: 'StageCandidateStatisticsProjectJobRoleReportModel';
  blob: MonolithBlobModel;
  projectJobRoleId: Scalars['Int'];
  stageCandidateId: Scalars['Int'];
  subType?: Maybe<ReportSubType>;
  type: ReportType;
};

export enum StageCandidateStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  ManagerCompleted = 'MANAGER_COMPLETED',
  NotStarted = 'NOT_STARTED',
  Processing = 'PROCESSING',
  SignedOff = 'SIGNED_OFF'
}

export enum StageProgressionStatus {
  Pending = 'PENDING',
  Progressed = 'PROGRESSED',
  Rejected = 'REJECTED'
}

/** Interview scheduling state for one candidate at one stage */
export type StageSchedulingRowModel = {
  __typename?: 'StageSchedulingRowModel';
  /** When the booked interview starts */
  bookedStartsAt?: Maybe<Scalars['DateTime']>;
  candidateUserId: Scalars['Int'];
  /** When the candidate declined every offered slot */
  declinedAt?: Maybe<Scalars['DateTime']>;
  linkExpiresAt?: Maybe<Scalars['DateTime']>;
  offerRound?: Maybe<Scalars['Int']>;
  /** How many slots the candidate was offered */
  offeredSlotCount?: Maybe<Scalars['Int']>;
  requestId?: Maybe<Scalars['ID']>;
  /** Joins to the candidate row in the candidates table */
  stageCandidateId: Scalars['Int'];
  state: SchedulingInterviewState;
};

export type StageScoringComponentConfig = {
  __typename?: 'StageScoringComponentConfig';
  component: ScoreComponent;
  kind: ScoreComponentKind;
  threshold?: Maybe<Scalars['Int']>;
  weight: Scalars['Float'];
};

export type StageScoringComponentConfigInput = {
  component: ScoreComponent;
  kind: ScoreComponentKind;
  threshold?: InputMaybe<Scalars['Int']>;
  weight: Scalars['Float'];
};

export type StageScoringConfig = {
  __typename?: 'StageScoringConfig';
  components: Array<StageScoringComponentConfig>;
  version: Scalars['Int'];
};

export enum StageStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Scheduled = 'SCHEDULED'
}

export enum StageType {
  AssessmentStage = 'ASSESSMENT_STAGE',
  ContentStage = 'CONTENT_STAGE',
  InterviewStage = 'INTERVIEW_STAGE',
  OfferStage = 'OFFER_STAGE',
  ShortlistStage = 'SHORTLIST_STAGE'
}

export type StartIntegrityMonitoringSessionInput = {
  browserVersion?: InputMaybe<Scalars['String']>;
  deviceOs?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSONObject']>;
  screenIsExtended?: InputMaybe<Scalars['Boolean']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type StatisticalGradeBandModel = {
  __typename?: 'StatisticalGradeBandModel';
  displayText: Scalars['String'];
  grade: Grade;
  position: Scalars['Int'];
};

export type StatisticalResultScoreModel = {
  __typename?: 'StatisticalResultScoreModel';
  grade: Grade;
  percentile: Scalars['Float'];
  stenScore: Scalars['Float'];
  zScore: Scalars['Float'];
};

export type SuccessProfile = {
  __typename?: 'SuccessProfile';
  calculationMethod: CalculationMethod;
  confirmedAt?: Maybe<Scalars['Date']>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  gradingMethod: GradingMethod;
  id: Scalars['Int'];
  inputsChangedAt?: Maybe<Scalars['Date']>;
  isConfirmed: Scalars['Boolean'];
  jobRole: JobRoleModel;
  jobRoleId: Scalars['Int'];
  status: SuccessProfileStatus;
  successProfileSoftSkills?: Maybe<Array<SuccessProfileSoftSkill>>;
  successProfileTechnicalSkills?: Maybe<Array<SuccessProfileTechnicalSkill>>;
  templateVersion?: Maybe<SkillsProfileTemplateVersion>;
  templateVersionId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['Date'];
};

export type SuccessProfileAdditionalAvailableAssessment = {
  __typename?: 'SuccessProfileAdditionalAvailableAssessment';
  timeRequirementMinutes?: Maybe<Scalars['Int']>;
  timeRequirementMinutesMax?: Maybe<Scalars['Int']>;
  timeRequirementMinutesMin?: Maybe<Scalars['Int']>;
  type: AdditionalAssessmentType;
};

export type SuccessProfileAvailableAssessment = {
  __typename?: 'SuccessProfileAvailableAssessment';
  requirement: SuccessProfileAvailableAssessmentRequirement;
  timeRequirementMinutes: Scalars['Int'];
};

export enum SuccessProfileAvailableAssessmentRequirement {
  Available = 'AVAILABLE',
  Recommended = 'RECOMMENDED',
  Required = 'REQUIRED'
}

export type SuccessProfileAvailableAssessments = {
  __typename?: 'SuccessProfileAvailableAssessments';
  additionalAssessments: Array<SuccessProfileAdditionalAvailableAssessment>;
  inductiveReasoningAssessment?: Maybe<SuccessProfileAvailableAssessment>;
  numericalReasoningAssessment?: Maybe<SuccessProfileAvailableAssessment>;
  personalityAssessment?: Maybe<SuccessProfileAvailableAssessment>;
  verbalReasoningAssessment?: Maybe<SuccessProfileAvailableAssessment>;
};

export type SuccessProfileSelectedAssessments = {
  inductiveReasoningAssessment: Scalars['Boolean'];
  numericalReasoningAssessment: Scalars['Boolean'];
  personalityAssessment: Scalars['Boolean'];
  verbalReasoningAssessment: Scalars['Boolean'];
};

export type SuccessProfileSoftSkill = {
  __typename?: 'SuccessProfileSoftSkill';
  archivedAt?: Maybe<Scalars['Date']>;
  id: Scalars['Int'];
  includeInCalibration: Scalars['Boolean'];
  name: Scalars['String'];
  softSkill: SoftSkill;
  softSkillId: Scalars['Int'];
  source?: Maybe<SkillsProfileSkillSource>;
  successProfile: SuccessProfile;
  successProfileId: Scalars['Int'];
  successProfileSoftSkillDataSources?: Maybe<Array<SuccessProfileSoftSkillDataSource>>;
  successProfileSoftSkillTraits: Array<SuccessProfileSoftSkillTrait>;
  type: SoftSkillType;
  weight: Scalars['Float'];
};

export type SuccessProfileSoftSkillCreateOneArgs = {
  dataSources?: InputMaybe<Array<SuccessProfileSoftSkillDataSourceCreateOneBase>>;
  includeInCalibration?: InputMaybe<Scalars['Boolean']>;
  softSkillId: Scalars['Int'];
  successProfileId?: InputMaybe<Scalars['Int']>;
  traits?: InputMaybe<Array<SuccessProfileSoftSkillTraitCreateOneArgs>>;
  type: SoftSkillType;
  weight?: InputMaybe<Scalars['Float']>;
};

export type SuccessProfileSoftSkillDataSource = {
  __typename?: 'SuccessProfileSoftSkillDataSource';
  dataSourceType: DataSourceType;
  id: Scalars['Int'];
  orientation?: Maybe<Scalars['Int']>;
  softSkillType: SoftSkillType;
  successProfileSoftSkill: SuccessProfileSoftSkill;
  successProfileSoftSkillId: Scalars['Int'];
};

export type SuccessProfileSoftSkillDataSourceCreateOneBase = {
  dataSourceType: DataSourceType;
  softSkillType: SoftSkillType;
};

export type SuccessProfileSoftSkillTrait = {
  __typename?: 'SuccessProfileSoftSkillTrait';
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  orientation?: Maybe<Scalars['Int']>;
  softSkill: SoftSkill;
  softSkillId: Scalars['Int'];
  successProfileSoftSkill: SuccessProfileSoftSkill;
  successProfileSoftSkillId: Scalars['Int'];
  trait: Trait;
  traitId: Scalars['Int'];
  weight: Scalars['Float'];
};

export type SuccessProfileSoftSkillTraitCreateOneArgs = {
  orientation?: InputMaybe<Scalars['Int']>;
  softSkillId?: InputMaybe<Scalars['Int']>;
  successProfileSoftSkillId?: InputMaybe<Scalars['Int']>;
  traitId: Scalars['Int'];
  weight?: InputMaybe<Scalars['Float']>;
};

export enum SuccessProfileStatus {
  Complete = 'COMPLETE',
  MissingSoftSkills = 'MISSING_SOFT_SKILLS'
}

export type SuccessProfileTechnicalSkill = {
  __typename?: 'SuccessProfileTechnicalSkill';
  archivedAt?: Maybe<Scalars['Date']>;
  id: Scalars['Int'];
  source?: Maybe<SkillsProfileSkillSource>;
  successProfile?: Maybe<SuccessProfile>;
  successProfileId: Scalars['Int'];
  technicalSkill?: Maybe<TechnicalSkill>;
  technicalSkillId: Scalars['Int'];
};

export type SuccessProfileTechnicalSkillCreateOneArgs = {
  successProfileId?: InputMaybe<Scalars['Int']>;
  technicalSkillId: Scalars['Int'];
};

export type SuccessProfileTechnicalSkillUpdateOneArgs = {
  id: Scalars['Int'];
  successProfileId?: InputMaybe<Scalars['Int']>;
  technicalSkillId?: InputMaybe<Scalars['Int']>;
};

export type SummaryTemplateModel = {
  __typename?: 'SummaryTemplateModel';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['String'];
  isReady: Scalars['Boolean'];
  longDescription?: Maybe<Scalars['String']>;
  messages: Array<TemplateMessageModel>;
  modelName: Scalars['String'];
  name: Scalars['String'];
  ownerId: Scalars['Int'];
  scope: SummaryTemplateScope;
  sections?: Maybe<Array<TemplateSectionModel>>;
  seed: Scalars['Int'];
  sharedWith?: Maybe<Array<Scalars['Int']>>;
  shortDescription?: Maybe<Scalars['String']>;
  temperature: Scalars['Float'];
  topP: Scalars['Float'];
  type: TemplateType;
  updatedAt: Scalars['Date'];
};

export type SummaryTemplateResponseModel = SummaryTemplateModel | TemplateVerificationErrorModel;

export enum SummaryTemplateScope {
  Company = 'company',
  Personal = 'personal',
  System = 'system'
}

export enum SupportedLocale {
  Bulgarian = 'BULGARIAN',
  Chinese = 'CHINESE',
  ChineseTraditional = 'CHINESE_TRADITIONAL',
  Danish = 'DANISH',
  Dutch = 'DUTCH',
  English = 'ENGLISH',
  French = 'FRENCH',
  German = 'GERMAN',
  Hungarian = 'HUNGARIAN',
  Indonesian = 'INDONESIAN',
  Italian = 'ITALIAN',
  Korean = 'KOREAN',
  Malay = 'MALAY',
  Polish = 'POLISH',
  PortugueseBrazilian = 'PORTUGUESE_BRAZILIAN',
  SpanishEuropean = 'SPANISH_EUROPEAN',
  SpanishLatinAmerican = 'SPANISH_LATIN_AMERICAN',
  Thai = 'THAI',
  Turkish = 'TURKISH'
}

export enum SzApp {
  AdminApp = 'ADMIN_APP',
  CandidateApp = 'CANDIDATE_APP',
  CompanyApp = 'COMPANY_APP'
}

export enum SzMappedStageType {
  AiInterview = 'AI_INTERVIEW',
  AiShortlist = 'AI_SHORTLIST',
  Assessment = 'ASSESSMENT',
  Interview = 'INTERVIEW',
  Offer = 'OFFER'
}

export type SzSkillsMerge = {
  __typename?: 'SzSkillsMerge';
  category?: Maybe<SkillCategory>;
  categoryId?: Maybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<MonolithBlobModel>;
  iconBlobId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  measurementConstructType?: Maybe<MeasurementConstructType>;
  name: Scalars['String'];
  originId: Scalars['Int'];
  skillType: SkillType;
};

export type SzSkillsMergeCreateOneArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  iconBlobId?: InputMaybe<Scalars['Int']>;
  measurementConstructType?: InputMaybe<MeasurementConstructType>;
  name: Scalars['String'];
  originId: Scalars['Int'];
  skillType: SkillType;
};

export type SzSkillsMergeUpdateOneArgs = {
  categoryId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  iconBlobId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  measurementConstructType?: InputMaybe<MeasurementConstructType>;
  name?: InputMaybe<Scalars['String']>;
  originId?: InputMaybe<Scalars['Int']>;
  skillType?: InputMaybe<SkillType>;
};

export type SzSkillsMergeWithAvailability = {
  __typename?: 'SzSkillsMergeWithAvailability';
  alreadyExist: Scalars['Boolean'];
  result?: Maybe<ResultModel>;
  skill: SzSkillsMerge;
};

export type TechnicalSkill = {
  __typename?: 'TechnicalSkill';
  company?: Maybe<Company>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<MonolithBlobModel>;
  iconBlobId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  skillCategory?: Maybe<SkillCategory>;
  skillCategoryId?: Maybe<Scalars['Int']>;
  subId: Scalars['ID'];
  updatedAt: Scalars['Date'];
};

export type TechnicalSkillFindManyPaginatedFilters = {
  companyId?: InputMaybe<Scalars['Int']>;
  skillCategoryIds?: InputMaybe<Array<Scalars['Int']>>;
  skillCategoryNames?: InputMaybe<Array<Scalars['String']>>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type TechnicalSkillFindManyPaginatedOrder = {
  direction?: InputMaybe<SortOption>;
  field?: InputMaybe<TechnicalSkillSortField>;
};

export type TechnicalSkillInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type TechnicalSkillSelfAssessmentGradeBandModel = {
  __typename?: 'TechnicalSkillSelfAssessmentGradeBandModel';
  displayText: Scalars['String'];
  position: Scalars['Int'];
  technicalProficiency: TechnicalSkillSelfAssessmentProficiencyLevel;
};

export enum TechnicalSkillSelfAssessmentProficiencyLevel {
  Beginner = 'BEGINNER',
  Expert = 'EXPERT',
  Intermediate = 'INTERMEDIATE',
  NoKnowledge = 'NO_KNOWLEDGE'
}

export type TechnicalSkillSelfAssessmentScoreModel = {
  __typename?: 'TechnicalSkillSelfAssessmentScoreModel';
  technicalProficiency: TechnicalSkillSelfAssessmentProficiencyLevel;
};

export type TechnicalSkillSemanticSearchArgs = {
  threshold?: InputMaybe<Scalars['Float']>;
  value: Scalars['String'];
};

export enum TechnicalSkillSortField {
  Name = 'NAME'
}

export type TechnicalSkillUpdateArgs = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  skillCategoryId?: InputMaybe<Scalars['Int']>;
};

export type TemplateMessageArgs = {
  content: Scalars['String'];
  role: Scalars['String'];
};

export type TemplateMessageModel = {
  __typename?: 'TemplateMessageModel';
  content: Scalars['String'];
  role: Scalars['String'];
};

export type TemplateSectionArgs = {
  instructions?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type TemplateSectionErrorModel = {
  __typename?: 'TemplateSectionErrorModel';
  index: Scalars['Int'];
  instructions?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type TemplateSectionModel = {
  __typename?: 'TemplateSectionModel';
  instructions?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export enum TemplateType {
  CustomTemplate = 'customTemplate',
  General = 'general',
  HiringManager = 'hiringManager',
  Intake = 'intake',
  Qa = 'qa',
  Recruiter = 'recruiter',
  RetailSalesJunior = 'retailSalesJunior',
  RetailSalesSenior = 'retailSalesSenior',
  SalesManager = 'salesManager',
  SdrInsideSales = 'sdrInsideSales',
  SeniorAccountDirector = 'seniorAccountDirector',
  SpecialistSales = 'specialistSales'
}

export type TemplateVerificationErrorModel = {
  __typename?: 'TemplateVerificationErrorModel';
  error: Scalars['String'];
  invalidSections?: Maybe<Array<TemplateSectionErrorModel>>;
};

export enum TestFullType {
  CognitiveInductive = 'CognitiveInductive',
  CognitiveNumerical = 'CognitiveNumerical',
  CognitiveVerbal = 'CognitiveVerbal',
  Personality = 'Personality',
  TalentReview = 'TalentReview'
}

export enum TestStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export enum TestSubType {
  Inductive = 'INDUCTIVE',
  Numerical = 'NUMERICAL',
  Verbal = 'VERBAL'
}

export enum TestType {
  Cognitive = 'COGNITIVE',
  Personality = 'PERSONALITY',
  TalentReview = 'TALENT_REVIEW'
}

export enum TotalScoreError {
  MissingComponentScore = 'MISSING_COMPONENT_SCORE'
}

export enum TrCustomEvaluation {
  RisingTalent = 'RISING_TALENT',
  SolidContributor = 'SOLID_CONTRIBUTOR',
  StarTalent = 'STAR_TALENT',
  UnderperformingTalent = 'UNDERPERFORMING_TALENT'
}

export type TrCustomGradeBandModel = {
  __typename?: 'TrCustomGradeBandModel';
  displayText: Scalars['String'];
  evaluation: TrCustomEvaluation;
  position: Scalars['Int'];
};

export type TrCustomResultScoreModel = {
  __typename?: 'TrCustomResultScoreModel';
  evaluation: TrCustomEvaluation;
  score: Scalars['Float'];
};

export type TrItemModel = {
  __typename?: 'TrItemModel';
  isCompleted: Scalars['Boolean'];
  questions: Array<TrQuestionModel>;
  remainingQuestions: Scalars['Int'];
  /** @deprecated Please use new property `isCompleted` if you wish to know whether the assessment is completed or not! */
  testCandidateStatus: TestStatus;
  totalQuestions: Scalars['Int'];
};

export type TrOptionModel = {
  __typename?: 'TrOptionModel';
  key: Scalars['Int'];
  subId: Scalars['String'];
  text: Scalars['String'];
};

export type TrQuestionModel = {
  __typename?: 'TrQuestionModel';
  options: Array<TrOptionModel>;
  orientation: QuestionOrientation;
  subId: Scalars['String'];
  text: Scalars['String'];
};

export type Trait = {
  __typename?: 'Trait';
  description: Scalars['String'];
  id: Scalars['Int'];
  isArchived: Scalars['Boolean'];
  name: Scalars['String'];
  subId: Scalars['ID'];
  testTypes: Array<TraitTestTypeModel>;
};

export type TraitRoleLevelContent = {
  __typename?: 'TraitRoleLevelContent';
  classification: ContentClassification;
  content?: Maybe<Scalars['String']>;
  developmentContent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  roleLevel: ContentRoleLevel;
  softSkill: SoftSkill;
  softSkillId?: Maybe<Scalars['Int']>;
  summary?: Maybe<Scalars['String']>;
  trait?: Maybe<Trait>;
  traitId?: Maybe<Scalars['Int']>;
};

export type TraitRoleLevelContentPaginatedModel = {
  __typename?: 'TraitRoleLevelContentPaginatedModel';
  count?: Maybe<Scalars['Float']>;
  traitContent?: Maybe<Array<TraitRoleLevelContent>>;
};

export type TraitSoftSkillContextFileUploadLineModel = {
  __typename?: 'TraitSoftSkillContextFileUploadLineModel';
  internalName: Scalars['String'];
  level: Scalars['String'];
  negativeSummary: Scalars['String'];
  positiveSummary: Scalars['String'];
  softSkillId: Scalars['String'];
  traitId: Scalars['String'];
};

export type TraitSoftSkillContextFileUploadModel = {
  __typename?: 'TraitSoftSkillContextFileUploadModel';
  apply: Scalars['Boolean'];
  creates?: Maybe<Array<TraitSoftSkillContextFileUploadLineModel>>;
  deletes?: Maybe<Array<TraitSoftSkillContextFileUploadLineModel>>;
  errorMessage?: Maybe<Scalars['String']>;
  errorMessages?: Maybe<Array<Scalars['String']>>;
  errors?: Maybe<Array<TraitSoftSkillContextFileUploadLineModel>>;
  noChanges?: Maybe<Array<TraitSoftSkillContextFileUploadLineModel>>;
  updates?: Maybe<Array<TraitSoftSkillContextFileUploadLineModel>>;
  warnings: Array<Scalars['String']>;
};

export type TraitSoftSkillContextModel = {
  __typename?: 'TraitSoftSkillContextModel';
  behaviours: Array<BehaviourModel>;
  id: Scalars['Int'];
  softSkillId?: Maybe<Scalars['Int']>;
  traitId: Scalars['Int'];
};

export type TraitTestTypeModel = {
  __typename?: 'TraitTestTypeModel';
  id: Scalars['Int'];
  testSubType?: Maybe<TestSubType>;
  testType: TestType;
  trait?: Maybe<Trait>;
  traitId: Scalars['Int'];
};

export type TraitTestTypesUpdateOneArgs = {
  testSubType?: InputMaybe<TestSubType>;
  testType: TestType;
  traitId: Scalars['Int'];
};

export type TranscriptConfigArgs = {
  generatedAt?: InputMaybe<Scalars['Date']>;
  requestId?: InputMaybe<Scalars['String']>;
  src?: InputMaybe<Scalars['String']>;
  status: MeetingTranscriptStatus;
};

export type TranscriptConfigModel = {
  __typename?: 'TranscriptConfigModel';
  generatedAt?: Maybe<Scalars['DateTime']>;
  locales?: Maybe<Array<Scalars['String']>>;
  requestId?: Maybe<Scalars['String']>;
  src?: Maybe<Scalars['String']>;
  status: MeetingTranscriptStatus;
};

export enum TranscriptSpeaker {
  Agent = 'AGENT',
  User = 'USER'
}

export type TranscriptUtterance = {
  __typename?: 'TranscriptUtterance';
  /** Utterance start timestamp in milliseconds from the start */
  from: Scalars['Int'];
  speaker: TranscriptSpeaker;
  text: Scalars['String'];
  /** Utterance end timestamp in milliseconds from the start */
  to: Scalars['Int'];
};


export type TranscriptUtteranceTextArgs = {
  isOriginal?: InputMaybe<Scalars['Boolean']>;
  locale?: SupportedLocale;
};

export type TriggerAtsCvUploadForApplicationResultModel = {
  __typename?: 'TriggerAtsCvUploadForApplicationResultModel';
  /** The canonical SDK application id that was processed. */
  applicationId: Scalars['String'];
  /** True when the CV upload was attempted. The mutation forces an upload attempt regardless of whether the project candidate already has a resume; actual upload success/failure is in the logs (look for `Successfully uploaded CV to shortlist stage` or `CV upload failed`). */
  cvUploadAttempted: Scalars['Boolean'];
  /** True when the project candidate was found or created. False means the SDK adapter skipped (e.g., job not linked to project, candidate missing email); see logs for the exact reason. */
  materialised: Scalars['Boolean'];
};

export type UnifiedMeeting = MeetingModel | UpcomingMeetingModel;

export enum UnifiedMeetingKind {
  Meeting = 'meeting',
  UpcomingMeeting = 'upcomingMeeting'
}

export type UnifiedMeetingsFilters = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  kind?: InputMaybe<UnifiedMeetingKind>;
  searchTerm?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<MeetingScope>>;
};

export type UpcomingMeetingModel = {
  __typename?: 'UpcomingMeetingModel';
  attendees: Array<AttendeeModel>;
  botId?: Maybe<Scalars['String']>;
  calendarId: Scalars['String'];
  calendarPlatform: MeetingCalendarPlatform;
  conferencingPlatform: MeetingCalendarPlatform;
  createdAt: Scalars['Date'];
  date: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['Date']>;
  externalMeetingId: Scalars['String'];
  id: Scalars['String'];
  interviewStageCandidateId?: Maybe<Scalars['Int']>;
  method: Method;
  name: Scalars['String'];
  ownerId: Scalars['Int'];
  projectCandidateId?: Maybe<Scalars['Int']>;
  projectCandidateSubId?: Maybe<Scalars['String']>;
  projectJobRoleId?: Maybe<Scalars['Int']>;
  sharedId?: Maybe<Scalars['String']>;
  type: MeetingScope;
  updatedAt: Scalars['Date'];
  url?: Maybe<Scalars['String']>;
};

export type UpdateAssessmentStageEmailSettingsInput = {
  candidateReportId?: InputMaybe<Scalars['Int']>;
  emailCandidateReport?: InputMaybe<Scalars['Boolean']>;
  managerReportId?: InputMaybe<Scalars['Int']>;
  projectTeamEmailSettings?: InputMaybe<ProjectTeamEmailSettingsArgs>;
};

export type UpdateAssessmentStageInput = {
  additionalAssessmentTypes?: InputMaybe<Array<AdditionalAssessmentType>>;
  assessmentExpiryOption?: InputMaybe<AssessmentExpiryOptionArgs>;
  autoProgressionThreshold?: InputMaybe<Scalars['Int']>;
  candidateReportId?: InputMaybe<Scalars['Int']>;
  cognitiveMode: CognitiveMode;
  emailSettings?: InputMaybe<UpdateAssessmentStageEmailSettingsInput>;
  endTime?: InputMaybe<Scalars['Date']>;
  hasAdjustmentQuestionnaire?: InputMaybe<Scalars['Boolean']>;
  isAutoProgressionEnabled?: InputMaybe<Scalars['Boolean']>;
  isIntegrityMonitoringEnabled?: InputMaybe<Scalars['Boolean']>;
  managerReportId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['Date']>;
};

export type UpdateFormFieldByFieldIdArgs = {
  displayOrder?: InputMaybe<Scalars['Int']>;
  fieldId: Scalars['Int'];
  isOptional?: InputMaybe<Scalars['Boolean']>;
};

/** What one interview panel change did */
export type UpdateInterviewPanelResultModel = {
  __typename?: 'UpdateInterviewPanelResultModel';
  /** False only when an added interviewer is busy and the change was not confirmed */
  applied: Scalars['Boolean'];
  /** The added interviewers busy at the interview time; empty when the change was applied */
  busyInterviewerIds: Array<Scalars['Int']>;
  /** The request as committed; its version is unchanged when nothing was written */
  request: SchedulingRequestModel;
};

export type UpdateRespondantFormAnswerArgs = {
  fieldId: Scalars['Int'];
  response: Scalars['String'];
};

export type UploadResult = {
  __typename?: 'UploadResult';
  url: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  avatarUrl?: Maybe<Scalars['String']>;
  companyInfo?: Maybe<Array<UserCompanyInfo>>;
  email: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  groups?: Maybe<Array<UserGroupMemberModel>>;
  id: Scalars['Int'];
  identityVerificationResubmissionReason?: Maybe<Scalars['String']>;
  identityVerificationStatus: VerificationStatus;
  identityVerifiedAt?: Maybe<Scalars['Date']>;
  isInternal: Scalars['Boolean'];
  isPasswordDisabled?: Maybe<Scalars['Boolean']>;
  isPuppet: Scalars['Boolean'];
  /** @deprecated Please use "locale" instead! */
  language: Language;
  lastName: Scalars['String'];
  preferredLocale: UserLocalePreference;
  roles: Array<UserRole>;
  subId: Scalars['String'];
  twoFactorEnabled: Scalars['Boolean'];
};

export enum UserCalendarPlatform {
  GoogleCalendar = 'googleCalendar',
  MicrosoftOutlook = 'microsoftOutlook',
  Zoom = 'zoom'
}

export type UserCompanyInfo = {
  __typename?: 'UserCompanyInfo';
  companyId: Scalars['Int'];
  customFields?: Maybe<Scalars['JSON']>;
  customFieldsString?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  employeeId?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['Date']>;
  hrManagerEmployeeId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  jobTitle?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
  userId: Scalars['Int'];
};

export type UserCompanyInfoCustomFieldsArgs = {
  division?: InputMaybe<Scalars['String']>;
  function?: InputMaybe<Scalars['String']>;
  functionGroup?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  office?: InputMaybe<Scalars['String']>;
  officeCountry?: InputMaybe<Scalars['String']>;
  organisationLevel?: InputMaybe<Scalars['String']>;
};

export type UserGroupFindManyArgs = {
  companyId: Scalars['Int'];
};

export type UserGroupMemberFindManyArgs = {
  groupSubId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
};

export type UserGroupMemberModel = {
  __typename?: 'UserGroupMemberModel';
  group?: Maybe<UserGroupModel>;
  groupId: Scalars['Int'];
  id: Scalars['Int'];
  member?: Maybe<User>;
  memberId?: Maybe<Scalars['Int']>;
  subId: Scalars['String'];
};

export type UserGroupMemberPreview = {
  __typename?: 'UserGroupMemberPreview';
  avatarUrl?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastName?: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
};

export type UserGroupModel = {
  __typename?: 'UserGroupModel';
  companyId: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  members?: Maybe<Array<UserGroupMemberModel>>;
  membersCount?: Maybe<Scalars['Int']>;
  membersPreview?: Maybe<Array<UserGroupMemberPreview>>;
  name: Scalars['String'];
  projectsCount?: Maybe<Scalars['Int']>;
  projectsPreview?: Maybe<Array<UserGroupProjectPreview>>;
  subId: Scalars['String'];
};

export type UserGroupPaginatedModel = {
  __typename?: 'UserGroupPaginatedModel';
  data?: Maybe<Array<UserGroupModel>>;
  pageInfo?: Maybe<Pageinfo>;
};

export type UserGroupProjectPreview = {
  __typename?: 'UserGroupProjectPreview';
  id: Scalars['Int'];
  name: Scalars['String'];
  subId: Scalars['String'];
};

export type UserLocalePreference = {
  __typename?: 'UserLocalePreference';
  locale: SupportedLocale;
  source: UserLocalePreferenceSource;
};

export enum UserLocalePreferenceSource {
  Assigned = 'ASSIGNED',
  Selected = 'SELECTED'
}

export type UserMeetingConfigurationModel = {
  __typename?: 'UserMeetingConfigurationModel';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['String'];
  metadata?: Maybe<MeetingMetadataModel>;
  updatedAt: Scalars['Date'];
  userId: Scalars['Int'];
};

export type UserModel = {
  __typename?: 'UserModel';
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['Int'];
  lastName: Scalars['String'];
  subId: Scalars['String'];
};

export type UserModelPaginated = {
  __typename?: 'UserModelPaginated';
  data?: Maybe<Array<User>>;
  pageInfo?: Maybe<Pageinfo>;
};

export type UserRole = {
  __typename?: 'UserRole';
  companyRole: CompanyRole;
  companyRoleId: Scalars['Int'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  user: User;
  userId?: Maybe<Scalars['Int']>;
};

export type UserSettings = {
  __typename?: 'UserSettings';
  id: Scalars['Int'];
  settings?: Maybe<UserSettingsOptions>;
  userId: Scalars['Int'];
};

export type UserSettingsOptions = {
  __typename?: 'UserSettingsOptions';
  CM_lastVisitedModule?: Maybe<Scalars['Boolean']>;
  TR_displayOnboarding?: Maybe<Scalars['Boolean']>;
};

export type UserSettingsOptionsArgs = {
  CM_lastVisitedModule?: InputMaybe<Scalars['Boolean']>;
  TR_displayOnboarding?: InputMaybe<Scalars['Boolean']>;
};

export type VerbalOptionModel = {
  __typename?: 'VerbalOptionModel';
  key: Scalars['Int'];
  subId: Scalars['String'];
  text: Scalars['String'];
};

export type VerbalQuestionModel = {
  __typename?: 'VerbalQuestionModel';
  difficulty: Scalars['Float'];
  options: Array<VerbalOptionModel>;
  subId: Scalars['String'];
  text: Scalars['String'];
};

export type VerbalTestletModel = {
  __typename?: 'VerbalTestletModel';
  isCompleted: Scalars['Boolean'];
  questions: Array<VerbalQuestionModel>;
  remainingQuestions: Scalars['Int'];
  remainingTime: Scalars['Int'];
  /** @deprecated Please use new property `isCompleted` if you wish to know whether the assessment is completed or not! */
  testCandidateStatus: TestStatus;
  text: Scalars['String'];
  timeLimit: Scalars['Int'];
  totalQuestions: Scalars['Int'];
};

export type VerificationSession = {
  __typename?: 'VerificationSession';
  sessionUrl: Scalars['String'];
  status: VerificationStatus;
};

export enum VerificationStatus {
  Abandoned = 'ABANDONED',
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  NotStarted = 'NOT_STARTED',
  Pending = 'PENDING',
  ResubmissionRequested = 'RESUBMISSION_REQUESTED',
  Review = 'REVIEW'
}

export type WrdMerlinBrandedSkillsFeedbackModel = WidgetRenderData & {
  __typename?: 'WRDMerlinBrandedSkillsFeedbackModel';
  candidateFamilyName: Scalars['String'];
  candidateGivenName: Scalars['String'];
  companyLogoUrl?: Maybe<Scalars['String']>;
  driveAndDiscoverSoftSkill?: Maybe<WrdMerlinBrandedSkillsFeedbackSoftSkillModel>;
  enjoyTheRideSoftSkill?: Maybe<WrdMerlinBrandedSkillsFeedbackSoftSkillModel>;
  generatedAt?: Maybe<Scalars['Date']>;
  goTogetherSoftSkill?: Maybe<WrdMerlinBrandedSkillsFeedbackSoftSkillModel>;
  jobRoleName: Scalars['String'];
  ownYourCraftSoftSkill?: Maybe<WrdMerlinBrandedSkillsFeedbackSoftSkillModel>;
  projectName: Scalars['String'];
  subId?: Maybe<Scalars['String']>;
  weCareSoftSkill?: Maybe<WrdMerlinBrandedSkillsFeedbackSoftSkillModel>;
  widgetType: WidgetType;
};

export type WrdMerlinBrandedSkillsFeedbackSoftSkillModel = {
  __typename?: 'WRDMerlinBrandedSkillsFeedbackSoftSkillModel';
  developmentContents: Array<Scalars['String']>;
  internalCandidateContent?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  primerValue?: Maybe<Scalars['Float']>;
};

export type WrdStageCandidateSuccessProfileCognitiveSummaryScores = WidgetRenderData & {
  __typename?: 'WRDStageCandidateSuccessProfileCognitiveSummaryScores';
  barSize?: Maybe<Scalars['Int']>;
  children?: Maybe<Array<WrdContextualScore>>;
  cognitiveMode?: Maybe<CognitiveMode>;
  displayClassification: Scalars['String'];
  displayScoreType?: Maybe<DisplayScoreType>;
  id: Scalars['Int'];
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  score: ScoreModel;
  scores?: Maybe<Array<WrdSoftSkillScoreWithContent>>;
  subId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  widgetType: WidgetType;
};

export type Widget = {
  __typename?: 'Widget';
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['Int'];
  isArchived: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  reportConfigs?: Maybe<Array<ReportConfig>>;
  screenShotBlob?: Maybe<MonolithBlobModel>;
  screenShotBlobId?: Maybe<Scalars['Int']>;
  type: WidgetType;
  updatedAt: Scalars['Date'];
  widgetOptions?: Maybe<Array<WidgetOption>>;
};

export type WidgetConfig = {
  __typename?: 'WidgetConfig';
  id: Scalars['Int'];
  reportConfig?: Maybe<ReportConfig>;
  reportConfigId: Scalars['Int'];
  settings: Scalars['String'];
  widgetOption?: Maybe<WidgetOption>;
  widgetOptionId: Scalars['Int'];
};

export type WidgetConfigUpdateOneArgs = {
  id: Scalars['Int'];
  settings?: InputMaybe<Scalars['String']>;
};

export type WidgetConfigUpsertOneBatchedWithReportConfigArgs = {
  settings?: InputMaybe<Scalars['String']>;
  widgetOptionId: Scalars['Int'];
};

export type WidgetOption = {
  __typename?: 'WidgetOption';
  defaultValue?: Maybe<Scalars['String']>;
  fieldType: WidgetOptionFieldType;
  id: Scalars['Int'];
  isArchived: Scalars['Boolean'];
  name: Scalars['String'];
  question?: Maybe<Scalars['String']>;
  widget: Widget;
  widgetConfigs?: Maybe<Array<WidgetConfig>>;
  widgetId: Scalars['Int'];
};

export enum WidgetOptionFieldType {
  /** File upload */
  FileUploadField = 'FILE_UPLOAD_FIELD',
  /** Multiple select */
  MultipleSelectField = 'MULTIPLE_SELECT_FIELD',
  /** Short text */
  ShortTextField = 'SHORT_TEXT_FIELD',
  /** Single select */
  SingleSelectField = 'SINGLE_SELECT_FIELD'
}

export type WidgetRender = {
  __typename?: 'WidgetRender';
  newPageBefore: Scalars['Boolean'];
  position: Scalars['Int'];
  type: WidgetType;
  widgetConfigs?: Maybe<Array<WidgetConfig>>;
  widgetRenderData?: Maybe<WidgetRenderData>;
};

export type WidgetRenderData = {
  subId?: Maybe<Scalars['String']>;
  widgetType: WidgetType;
};

export enum WidgetType {
  /** Assessment link */
  AssessmentLink = 'ASSESSMENT_LINK',
  /** Assessment links */
  AssessmentLinks = 'ASSESSMENT_LINKS',
  /** Assessment summaries */
  AssessmentSummaries = 'ASSESSMENT_SUMMARIES',
  /** Assessment summary */
  AssessmentSummary = 'ASSESSMENT_SUMMARY',
  BrandedCoverPage = 'BRANDED_COVER_PAGE',
  /** Candidate and company details */
  CandidateCompany = 'CANDIDATE_COMPANY',
  /** (Internal) Contextual score */
  ContextualScore = 'CONTEXTUAL_SCORE',
  MerlinBrandedSkillsFeedback = 'MERLIN_BRANDED_SKILLS_FEEDBACK',
  /** Role level chart */
  RoleLevelChart = 'ROLE_LEVEL_CHART',
  /** Soft skills card */
  SoftSkillCard = 'SOFT_SKILL_CARD',
  /** Soft skills cards */
  SoftSkillCards = 'SOFT_SKILL_CARDS',
  /** Soft skills datasource */
  SoftSkillDataSource = 'SOFT_SKILL_DATA_SOURCE',
  /** Soft skill excluded */
  SoftSkillExcluded = 'SOFT_SKILL_EXCLUDED',
  /** (Internal) Soft skill score */
  SoftSkillScore = 'SOFT_SKILL_SCORE',
  /** (Internal) Soft skill score chart */
  SoftSkillScoreChart = 'SOFT_SKILL_SCORE_CHART',
  /** (Internal) Soft skill score top and bottom */
  SoftSkillScoreTopBottom = 'SOFT_SKILL_SCORE_TOP_BOTTOM',
  /** (Internal) Soft skill score with content */
  SoftSkillScoreWithContent = 'SOFT_SKILL_SCORE_WITH_CONTENT',
  /** Success profile cover page */
  SpCoverPage = 'SP_COVER_PAGE',
  /** Success profile explanation */
  SpExplanation = 'SP_EXPLANATION',
  /** Success profile header and footer */
  SpHeaderFooter = 'SP_HEADER_FOOTER',
  /** Soft skills detail */
  SpSoftSkillDetail = 'SP_SOFT_SKILL_DETAIL',
  /** Soft skills spider chart */
  SpSoftSkillSpider = 'SP_SOFT_SKILL_SPIDER',
  /** Soft skill type explanation */
  SpSoftSkillTypeExplanation = 'SP_SOFT_SKILL_TYPE_EXPLANATION',
  /** Stage results cover page */
  SrCoverPage = 'SR_COVER_PAGE',
  /** Information required for email */
  SrEmailContent = 'SR_EMAIL_CONTENT',
  StageCandidateHeader = 'STAGE_CANDIDATE_HEADER',
  StageCandidateHighlightedScores = 'STAGE_CANDIDATE_HIGHLIGHTED_SCORES',
  /** (Internal) Stage Candidate Soft skill score with content */
  StageCandidateSoftSkillScoreSummaryWithContent = 'STAGE_CANDIDATE_SOFT_SKILL_SCORE_SUMMARY_WITH_CONTENT',
  /** (Internal) Stage Candidate Soft skill score with content */
  StageCandidateSoftSkillScoreWithContent = 'STAGE_CANDIDATE_SOFT_SKILL_SCORE_WITH_CONTENT',
  StageCandidateSuccessProfileCognitiveSummaryScores = 'STAGE_CANDIDATE_SUCCESS_PROFILE_COGNITIVE_SUMMARY_SCORES',
  StageCandidateSuccessProfileScoreFinalScores = 'STAGE_CANDIDATE_SUCCESS_PROFILE_SCORE_FINAL_SCORES',
  StageCandidateSuccessProfileScoreSummaryWithContent = 'STAGE_CANDIDATE_SUCCESS_PROFILE_SCORE_SUMMARY_WITH_CONTENT',
  StageCandidateSuccessProfileScoreWithContent = 'STAGE_CANDIDATE_SUCCESS_PROFILE_SCORE_WITH_CONTENT',
  /** Static */
  Static = 'STATIC',
  /** (Internal) Success profile score */
  SuccessProfileScore = 'SUCCESS_PROFILE_SCORE',
  /** Success profile scores - chart */
  SuccessProfileScoreChart = 'SUCCESS_PROFILE_SCORE_CHART',
  /** Success profile scores - just final scores */
  SuccessProfileScoreFinalScores = 'SUCCESS_PROFILE_SCORE_FINAL_SCORES',
  /** Success profile scores - top and bottom soft skills */
  SuccessProfileScoreTopBottom = 'SUCCESS_PROFILE_SCORE_TOP_BOTTOM',
  /** Success profile scores - with content */
  SuccessProfileScoreWithContent = 'SUCCESS_PROFILE_SCORE_WITH_CONTENT',
  TestingWidget = 'TESTING_WIDGET',
  /** Test summary */
  TestSummary = 'TEST_SUMMARY',
  /** (Internal) trait score */
  TraitScore = 'TRAIT_SCORE',
  /** (Internal) trait score with content */
  TraitScoreWithContent = 'TRAIT_SCORE_WITH_CONTENT',
  /** (Internal) trait score with content and IQ */
  TraitScoreWithIq = 'TRAIT_SCORE_WITH_IQ',
  WidgetExample = 'WIDGET_EXAMPLE'
}

export enum WithDeletedChoice {
  All = 'ALL',
  OnlyArchived = 'ONLY_ARCHIVED',
  OnlyNotArchived = 'ONLY_NOT_ARCHIVED'
}

/** Type of access the user has to a workspace */
export enum WorkspaceAccessType {
  /** User has direct company roles in this workspace */
  DirectMember = 'DIRECT_MEMBER',
  /** User accesses via SZ admin privileges */
  SzAdminAccess = 'SZ_ADMIN_ACCESS'
}

export type WorkspaceModel = {
  __typename?: 'WorkspaceModel';
  accessType: WorkspaceAccessType;
  id: Scalars['ID'];
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  projectCount?: Maybe<Scalars['Float']>;
};

export type WorkspacesResponse = {
  __typename?: 'WorkspacesResponse';
  count: Scalars['Int'];
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  totalCount: Scalars['Int'];
  workspaces: Array<WorkspaceModel>;
};

export type WrdAssessmentLink = WidgetRenderData & {
  __typename?: 'WrdAssessmentLink';
  header: Scalars['String'];
  order: Scalars['Int'];
  subId?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  urlDisplayText: Scalars['String'];
  widgetType: WidgetType;
};

export type WrdAssessmentLinks = WidgetRenderData & {
  __typename?: 'WrdAssessmentLinks';
  assessmentLinks?: Maybe<Array<WrdAssessmentLink>>;
  subId?: Maybe<Scalars['String']>;
  widgetType: WidgetType;
};

export type WrdAssessmentSummaries = WidgetRenderData & {
  __typename?: 'WrdAssessmentSummaries';
  assessmentSummaries?: Maybe<Array<WrdAssessmentSummary>>;
  subId?: Maybe<Scalars['String']>;
  widgetType: WidgetType;
};

export type WrdAssessmentSummary = WidgetRenderData & {
  __typename?: 'WrdAssessmentSummary';
  order: Scalars['Int'];
  subId?: Maybe<Scalars['String']>;
  testSummaries: Array<WrdTestSummary>;
  totalTime: Scalars['Int'];
  widgetType: WidgetType;
};

export type WrdBrandedCoverPage = WidgetRenderData & {
  __typename?: 'WrdBrandedCoverPage';
  candidateFamilyName: Scalars['String'];
  candidateGivenName: Scalars['String'];
  companyLogoUrl?: Maybe<Scalars['String']>;
  generatedAt?: Maybe<Scalars['Date']>;
  jobRoleName: Scalars['String'];
  projectName: Scalars['String'];
  subId?: Maybe<Scalars['String']>;
  widgetType: WidgetType;
};

export type WrdCandidateCompany = WidgetRenderData & {
  __typename?: 'WrdCandidateCompany';
  candidateAvatarUrl?: Maybe<Scalars['String']>;
  candidateInitials: Scalars['String'];
  candidateName: Scalars['String'];
  companyLogo?: Maybe<Scalars['String']>;
  companyName: Scalars['String'];
  subId?: Maybe<Scalars['String']>;
  widgetType: WidgetType;
};

export type WrdContextualScore = WidgetRenderData & {
  __typename?: 'WrdContextualScore';
  barSize?: Maybe<Scalars['Int']>;
  children?: Maybe<Array<WrdContextualScore>>;
  displayClassification: Scalars['String'];
  displayScoreType?: Maybe<DisplayScoreType>;
  id: Scalars['Int'];
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  score: ScoreModel;
  subId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  widgetType: WidgetType;
};

export type WrdIgContent = WidgetRenderData & {
  __typename?: 'WrdIgContent';
  id: Scalars['Int'];
  interviewGuideId: Scalars['Int'];
  subId?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  widgetType: WidgetType;
};

export type WrdIgInterviewGuideCategories = WidgetRenderData & {
  __typename?: 'WrdIgInterviewGuideCategories';
  categories?: Maybe<Array<Maybe<WrdIgInterviewGuideCategory>>>;
  subId?: Maybe<Scalars['String']>;
  widgetType: WidgetType;
};

export type WrdIgInterviewGuideCategory = WidgetRenderData & {
  __typename?: 'WrdIgInterviewGuideCategory';
  id: Scalars['Int'];
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  subId?: Maybe<Scalars['String']>;
  widgetType: WidgetType;
};

export type WrdIgStep = WidgetRenderData & {
  __typename?: 'WrdIgStep';
  action?: Maybe<Scalars['String']>;
  durationInSeconds?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  interviewGuideId: Scalars['Int'];
  name: Scalars['String'];
  order: Scalars['Int'];
  staticQuestionName?: Maybe<Scalars['String']>;
  subId?: Maybe<Scalars['String']>;
  widgetType: WidgetType;
};

export type WrdInterviewGuide = WidgetRenderData & {
  __typename?: 'WrdInterviewGuide';
  contents?: Maybe<Array<Maybe<WrdIgContent>>>;
  id: Scalars['Int'];
  steps?: Maybe<Array<Maybe<WrdIgStep>>>;
  subId?: Maybe<Scalars['String']>;
  widgetType: WidgetType;
};

export type WrdInterviewGuideFlow = WidgetRenderData & {
  __typename?: 'WrdInterviewGuideFlow';
  contents?: Maybe<Array<Maybe<WrdIgContent>>>;
  id: Scalars['Int'];
  steps?: Maybe<Array<Maybe<WrdIgStep>>>;
  subId?: Maybe<Scalars['String']>;
  widgetType: WidgetType;
};

export type WrdInterviewGuideHowToUse = WidgetRenderData & {
  __typename?: 'WrdInterviewGuideHowToUse';
  contents?: Maybe<Array<Maybe<WrdIgContent>>>;
  id: Scalars['Int'];
  steps?: Maybe<Array<Maybe<WrdIgStep>>>;
  subId?: Maybe<Scalars['String']>;
  widgetType: WidgetType;
};

export type WrdRoleLevelChart = WidgetRenderData & {
  __typename?: 'WrdRoleLevelChart';
  contentRoleLevelsToDisplay?: Maybe<Array<ContentRoleLevel>>;
  roleLevel: ContentRoleLevel;
  subId?: Maybe<Scalars['String']>;
  widgetType: WidgetType;
};

export type WrdSoftSkillCard = WidgetRenderData & {
  __typename?: 'WrdSoftSkillCard';
  order: Scalars['Int'];
  softSkillDataSources?: Maybe<Array<WrdSoftSkillDataSource>>;
  softSkillId: Scalars['Int'];
  softSkillName: Scalars['String'];
  softSkillType: SoftSkillType;
  subId?: Maybe<Scalars['String']>;
  weight: Scalars['Float'];
  weightRatio: Scalars['Float'];
  widgetType: WidgetType;
};

export type WrdSoftSkillCards = WidgetRenderData & {
  __typename?: 'WrdSoftSkillCards';
  softSkillCards?: Maybe<Array<WrdSoftSkillCard>>;
  softSkillsExcluded?: Maybe<Array<WrdSoftSkillExcluded>>;
  subId?: Maybe<Scalars['String']>;
  widgetType: WidgetType;
};

export type WrdSoftSkillDataSource = WidgetRenderData & {
  __typename?: 'WrdSoftSkillDataSource';
  dataSourceType: DataSourceType;
  softSkillType: SoftSkillType;
  subId?: Maybe<Scalars['String']>;
  widgetType: WidgetType;
};

export type WrdSoftSkillExcluded = WidgetRenderData & {
  __typename?: 'WrdSoftSkillExcluded';
  category: Scalars['String'];
  companyId: Scalars['Int'];
  softSkillId: Scalars['Int'];
  softSkillName: Scalars['String'];
  subId?: Maybe<Scalars['String']>;
  widgetType: WidgetType;
};

export type WrdSoftSkillScore = WidgetRenderData & {
  __typename?: 'WrdSoftSkillScore';
  barSize?: Maybe<Scalars['Int']>;
  category?: Maybe<Scalars['String']>;
  children?: Maybe<Array<WrdTraitScore>>;
  displayClassification: Scalars['String'];
  displayScoreType?: Maybe<DisplayScoreType>;
  id: Scalars['Int'];
  measurementConstructType?: Maybe<MeasurementConstructType>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  score: ScoreModel;
  softSkillImageType?: Maybe<SoftSkillImageType>;
  subId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  widgetType: WidgetType;
};

export type WrdSoftSkillScoreChart = WidgetRenderData & {
  __typename?: 'WrdSoftSkillScoreChart';
  barSize?: Maybe<Scalars['Int']>;
  category?: Maybe<Scalars['String']>;
  children?: Maybe<Array<WrdTraitScore>>;
  displayClassification: Scalars['String'];
  displayScoreType?: Maybe<DisplayScoreType>;
  id: Scalars['Int'];
  measurementConstructType?: Maybe<MeasurementConstructType>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  score: ScoreModel;
  softSkillImageType?: Maybe<SoftSkillImageType>;
  subId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  widgetType: WidgetType;
};

export type WrdSoftSkillScoreTopBottom = WidgetRenderData & {
  __typename?: 'WrdSoftSkillScoreTopBottom';
  barSize?: Maybe<Scalars['Int']>;
  category?: Maybe<Scalars['String']>;
  children?: Maybe<Array<WrdTraitScoreWithContent>>;
  displayClassification: Scalars['String'];
  displayScoreType?: Maybe<DisplayScoreType>;
  id: Scalars['Int'];
  measurementConstructType?: Maybe<MeasurementConstructType>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  positionType?: Maybe<ContextualScorePositionType>;
  score: ScoreModel;
  softSkillImageType?: Maybe<SoftSkillImageType>;
  subId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  widgetType: WidgetType;
};

export type WrdSoftSkillScoreWithContent = WidgetRenderData & {
  __typename?: 'WrdSoftSkillScoreWithContent';
  barSize?: Maybe<Scalars['Int']>;
  category?: Maybe<Scalars['String']>;
  children?: Maybe<Array<WrdTraitScoreWithContent>>;
  description?: Maybe<Scalars['String']>;
  displayClassification: Scalars['String'];
  displayScoreType?: Maybe<DisplayScoreType>;
  feedback?: Maybe<Array<Maybe<Scalars['String']>>>;
  headerText?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  iqTrait?: Maybe<WrdTraitScoreWithIq>;
  isLowestScoring?: Maybe<Scalars['Boolean']>;
  measurementConstructType?: Maybe<MeasurementConstructType>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  score: ScoreModel;
  softSkillContentHeaderType?: Maybe<SoftSkillContentHeaderType>;
  softSkillImageType?: Maybe<SoftSkillImageType>;
  softSkillType?: Maybe<SoftSkillType>;
  subId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  weight?: Maybe<Scalars['Float']>;
  widgetType: WidgetType;
};

export type WrdSpCoverPage = WidgetRenderData & {
  __typename?: 'WrdSpCoverPage';
  companyLogo?: Maybe<Scalars['String']>;
  jobRoleName: Scalars['String'];
  projectId: Scalars['Int'];
  projectName: Scalars['String'];
  subId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  widgetType: WidgetType;
};

export type WrdSpExplanation = WidgetRenderData & {
  __typename?: 'WrdSpExplanation';
  softSkillExplanations?: Maybe<Array<WrdSpSoftSkillDetail>>;
  softSkillTypeExplanations?: Maybe<Array<WrdSpSoftSkillTypeExplanation>>;
  subId?: Maybe<Scalars['String']>;
  widgetType: WidgetType;
};

export type WrdSpHeaderFooter = WidgetRenderData & {
  __typename?: 'WrdSpHeaderFooter';
  companyLogo?: Maybe<Scalars['String']>;
  jobRoleName: Scalars['String'];
  projectId: Scalars['Int'];
  projectName: Scalars['String'];
  subId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  widgetType: WidgetType;
};

export type WrdSpSoftSkillDetail = WidgetRenderData & {
  __typename?: 'WrdSpSoftSkillDetail';
  description: Scalars['String'];
  order: Scalars['Int'];
  shortDescription: Scalars['String'];
  softSkillId: Scalars['Int'];
  softSkillName: Scalars['String'];
  softSkillType: SoftSkillType;
  subId?: Maybe<Scalars['String']>;
  weight: Scalars['Float'];
  weightRatio: Scalars['Float'];
  widgetType: WidgetType;
};

export type WrdSpSoftSkillSpider = WidgetRenderData & {
  __typename?: 'WrdSpSoftSkillSpider';
  projectName: Scalars['String'];
  spSoftSkillDetails?: Maybe<Array<WrdSpSoftSkillDetail>>;
  subId?: Maybe<Scalars['String']>;
  widgetType: WidgetType;
};

export type WrdSpSoftSkillTypeExplanation = WidgetRenderData & {
  __typename?: 'WrdSpSoftSkillTypeExplanation';
  description: Scalars['String'];
  softSkillType: SoftSkillType;
  subId?: Maybe<Scalars['String']>;
  widgetType: WidgetType;
};

export type WrdSrCoverPage = WidgetRenderData & {
  __typename?: 'WrdSrCoverPage';
  candidateAvatarUrl?: Maybe<Scalars['String']>;
  candidateInitials: Scalars['String'];
  candidateName: Scalars['String'];
  companyLogo?: Maybe<Scalars['String']>;
  companyName: Scalars['String'];
  jobRoleName: Scalars['String'];
  projectId: Scalars['Int'];
  projectName: Scalars['String'];
  stageName: Scalars['String'];
  subId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  widgetType: WidgetType;
};

export type WrdSrEmailContent = WidgetRenderData & {
  __typename?: 'WrdSrEmailContent';
  candidateAvatarUrl?: Maybe<Scalars['String']>;
  candidateInitials: Scalars['String'];
  candidateName: Scalars['String'];
  companyLogo?: Maybe<Scalars['String']>;
  companyName: Scalars['String'];
  gradeColor: Scalars['String'];
  gradeColorRGBA: Scalars['String'];
  jobRoleName: Scalars['String'];
  projectId: Scalars['Int'];
  projectName: Scalars['String'];
  score: Scalars['String'];
  stageName: Scalars['String'];
  subId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  widgetType: WidgetType;
};

export type WrdStageCandidateHeader = WidgetRenderData & {
  __typename?: 'WrdStageCandidateHeader';
  candidateAvatarUrl?: Maybe<Scalars['String']>;
  candidateInitials: Scalars['String'];
  candidateName: Scalars['String'];
  companyLogo?: Maybe<Scalars['String']>;
  companyName: Scalars['String'];
  projectName: Scalars['String'];
  subId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  widgetType: WidgetType;
};

export type WrdStageCandidateHighlightedScores = WidgetRenderData & {
  __typename?: 'WrdStageCandidateHighlightedScores';
  barSize?: Maybe<Scalars['Int']>;
  children?: Maybe<Array<WrdContextualScore>>;
  content?: Maybe<Scalars['String']>;
  displayClassification: Scalars['String'];
  displayScoreType?: Maybe<DisplayScoreType>;
  highlightedScores?: Maybe<Array<WrdSoftSkillScore>>;
  id: Scalars['Int'];
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  positionType?: Maybe<ContextualScorePositionType>;
  score: ScoreModel;
  subId?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  widgetType: WidgetType;
};

export type WrdStageCandidateSoftSkillScoreSummaryWithContent = WidgetRenderData & {
  __typename?: 'WrdStageCandidateSoftSkillScoreSummaryWithContent';
  barSize?: Maybe<Scalars['Int']>;
  category?: Maybe<Scalars['String']>;
  children?: Maybe<Array<WrdTraitScoreWithContent>>;
  description?: Maybe<Scalars['String']>;
  displayClassification: Scalars['String'];
  displayScoreType?: Maybe<DisplayScoreType>;
  feedback?: Maybe<Array<Maybe<Scalars['String']>>>;
  headerText?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  iqTrait?: Maybe<WrdTraitScoreWithIq>;
  isLowestScoring?: Maybe<Scalars['Boolean']>;
  measurementConstructType?: Maybe<MeasurementConstructType>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  score: ScoreModel;
  softSkillContentHeaderType?: Maybe<SoftSkillContentHeaderType>;
  softSkillImageType?: Maybe<SoftSkillImageType>;
  softSkillType?: Maybe<SoftSkillType>;
  subId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  weight?: Maybe<Scalars['Float']>;
  widgetType: WidgetType;
};

export type WrdStageCandidateSoftSkillScoreWithContent = WidgetRenderData & {
  __typename?: 'WrdStageCandidateSoftSkillScoreWithContent';
  barSize?: Maybe<Scalars['Int']>;
  category?: Maybe<Scalars['String']>;
  children?: Maybe<Array<WrdTraitScoreWithContent>>;
  description?: Maybe<Scalars['String']>;
  displayClassification: Scalars['String'];
  displayScoreType?: Maybe<DisplayScoreType>;
  feedback?: Maybe<Array<Maybe<Scalars['String']>>>;
  headerText?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  iqTrait?: Maybe<WrdTraitScoreWithIq>;
  isLowestScoring?: Maybe<Scalars['Boolean']>;
  measurementConstructType?: Maybe<MeasurementConstructType>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  score: ScoreModel;
  softSkillContentHeaderType?: Maybe<SoftSkillContentHeaderType>;
  softSkillImageType?: Maybe<SoftSkillImageType>;
  softSkillType?: Maybe<SoftSkillType>;
  subId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  weight?: Maybe<Scalars['Float']>;
  widgetType: WidgetType;
};

export type WrdStageCandidateSuccessProfileScoreFinalScores = WidgetRenderData & {
  __typename?: 'WrdStageCandidateSuccessProfileScoreFinalScores';
  barSize?: Maybe<Scalars['Int']>;
  children?: Maybe<Array<WrdSoftSkillScoreChart>>;
  displayClassification: Scalars['String'];
  displayScoreType?: Maybe<DisplayScoreType>;
  highlightedScores?: Maybe<Array<WrdSoftSkillScore>>;
  id: Scalars['Int'];
  manualScores?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  score: ScoreModel;
  subId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  widgetType: WidgetType;
};

export type WrdStageCandidateSuccessProfileScoreSummaryWithContent = WidgetRenderData & {
  __typename?: 'WrdStageCandidateSuccessProfileScoreSummaryWithContent';
  barSize?: Maybe<Scalars['Int']>;
  children?: Maybe<Array<WrdStageCandidateSoftSkillScoreSummaryWithContent>>;
  displayClassification: Scalars['String'];
  displayScoreType?: Maybe<DisplayScoreType>;
  highlightedScores?: Maybe<Array<WrdSoftSkillScore>>;
  id: Scalars['Int'];
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  score: ScoreModel;
  subId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  widgetType: WidgetType;
};

export type WrdStageCandidateSuccessProfileScoreWithContent = WidgetRenderData & {
  __typename?: 'WrdStageCandidateSuccessProfileScoreWithContent';
  barSize?: Maybe<Scalars['Int']>;
  children?: Maybe<Array<WrdStageCandidateSoftSkillScoreWithContent>>;
  displayClassification: Scalars['String'];
  displayScoreType?: Maybe<DisplayScoreType>;
  highlightedScores?: Maybe<Array<WrdSoftSkillScore>>;
  id: Scalars['Int'];
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  score: ScoreModel;
  subId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  widgetType: WidgetType;
};

export type WrdStatic = WidgetRenderData & {
  __typename?: 'WrdStatic';
  subId?: Maybe<Scalars['String']>;
  widgetType: WidgetType;
};

export type WrdSuccessProfileScore = WidgetRenderData & {
  __typename?: 'WrdSuccessProfileScore';
  barSize?: Maybe<Scalars['Int']>;
  children?: Maybe<Array<WrdSoftSkillScore>>;
  displayClassification: Scalars['String'];
  displayScoreType?: Maybe<DisplayScoreType>;
  id: Scalars['Int'];
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  score: ScoreModel;
  subId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  widgetType: WidgetType;
};

export type WrdSuccessProfileScoreChart = WidgetRenderData & {
  __typename?: 'WrdSuccessProfileScoreChart';
  barSize?: Maybe<Scalars['Int']>;
  children?: Maybe<Array<WrdSoftSkillScoreChart>>;
  displayClassification: Scalars['String'];
  displayScoreType?: Maybe<DisplayScoreType>;
  highlightedScores?: Maybe<Array<WrdSoftSkillScore>>;
  id: Scalars['Int'];
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  score: ScoreModel;
  subId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  widgetType: WidgetType;
};

export type WrdSuccessProfileScoreFinalScores = WidgetRenderData & {
  __typename?: 'WrdSuccessProfileScoreFinalScores';
  barSize?: Maybe<Scalars['Int']>;
  children?: Maybe<Array<WrdSoftSkillScoreChart>>;
  displayClassification: Scalars['String'];
  displayScoreType?: Maybe<DisplayScoreType>;
  highlightedScores?: Maybe<Array<WrdSoftSkillScore>>;
  id: Scalars['Int'];
  manualScores?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  score: ScoreModel;
  subId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  widgetType: WidgetType;
};

export type WrdSuccessProfileScoreTopBottom = WidgetRenderData & {
  __typename?: 'WrdSuccessProfileScoreTopBottom';
  barSize?: Maybe<Scalars['Int']>;
  children?: Maybe<Array<WrdSoftSkillScoreTopBottom>>;
  displayClassification: Scalars['String'];
  displayScoreType?: Maybe<DisplayScoreType>;
  id: Scalars['Int'];
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  score: ScoreModel;
  subId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  widgetType: WidgetType;
};

export type WrdSuccessProfileScoreWithContent = WidgetRenderData & {
  __typename?: 'WrdSuccessProfileScoreWithContent';
  barSize?: Maybe<Scalars['Int']>;
  children?: Maybe<Array<WrdSoftSkillScoreWithContent>>;
  displayClassification: Scalars['String'];
  displayScoreType?: Maybe<DisplayScoreType>;
  id: Scalars['Int'];
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  score: ScoreModel;
  subId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  widgetType: WidgetType;
};

export type WrdTestSummary = WidgetRenderData & {
  __typename?: 'WrdTestSummary';
  name: Scalars['String'];
  subId?: Maybe<Scalars['String']>;
  summary: Scalars['String'];
  time: Scalars['Int'];
  type: TestType;
  widgetType: WidgetType;
};

export type WrdTraitScore = WidgetRenderData & {
  __typename?: 'WrdTraitScore';
  barSize?: Maybe<Scalars['Int']>;
  children?: Maybe<Array<WrdContextualScore>>;
  displayClassification: Scalars['String'];
  displayScoreType?: Maybe<DisplayScoreType>;
  id: Scalars['Int'];
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  score: ScoreModel;
  subId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  widgetType: WidgetType;
};

export type WrdTraitScoreWithContent = WidgetRenderData & {
  __typename?: 'WrdTraitScoreWithContent';
  barSize?: Maybe<Scalars['Int']>;
  children?: Maybe<Array<WrdContextualScore>>;
  content?: Maybe<Scalars['String']>;
  displayClassification: Scalars['String'];
  displayScoreType?: Maybe<DisplayScoreType>;
  id: Scalars['Int'];
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  positionType?: Maybe<ContextualScorePositionType>;
  score: ScoreModel;
  subId?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  widgetType: WidgetType;
};

export type WrdTraitScoreWithIq = WidgetRenderData & {
  __typename?: 'WrdTraitScoreWithIq';
  barSize?: Maybe<Scalars['Int']>;
  children?: Maybe<Array<WrdContextualScore>>;
  content?: Maybe<Scalars['String']>;
  displayClassification: Scalars['String'];
  displayScoreType?: Maybe<DisplayScoreType>;
  id: Scalars['Int'];
  iqFeedback?: Maybe<Scalars['String']>;
  iqFooterType: IqFooterType;
  iqHints?: Maybe<Array<Scalars['String']>>;
  iqMainQuestion?: Maybe<Scalars['String']>;
  iqReasonForQuestion?: Maybe<Scalars['String']>;
  iqSubQuestions?: Maybe<Array<Scalars['String']>>;
  iqSummary?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  positionType?: Maybe<ContextualScorePositionType>;
  score: ScoreModel;
  subId?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  widgetType: WidgetType;
};

export type WrdWidgetExample = WidgetRenderData & {
  __typename?: 'WrdWidgetExample';
  name: Scalars['String'];
  subId?: Maybe<Scalars['String']>;
  summary: Scalars['String'];
  testType: TestType;
  time: Scalars['Int'];
  widgetType: WidgetType;
};

export type WrdWidgetTesting = WidgetRenderData & {
  __typename?: 'WrdWidgetTesting';
  subId?: Maybe<Scalars['String']>;
  test: Scalars['String'];
  widgetType: WidgetType;
};

/** One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string. */
export type __EnumValue = {
  __typename?: '__EnumValue';
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  isDeprecated: Scalars['Boolean'];
  deprecationReason?: Maybe<Scalars['String']>;
};

/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __Field = {
  __typename?: '__Field';
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  args: Array<__InputValue>;
  type: __Type;
  isDeprecated: Scalars['Boolean'];
  deprecationReason?: Maybe<Scalars['String']>;
};


/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __FieldArgsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']>;
};

/** Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value. */
export type __InputValue = {
  __typename?: '__InputValue';
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type: __Type;
  /** A GraphQL-formatted string representing the default value for this input value. */
  defaultValue?: Maybe<Scalars['String']>;
  isDeprecated: Scalars['Boolean'];
  deprecationReason?: Maybe<Scalars['String']>;
};

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __Type = {
  __typename?: '__Type';
  kind: __TypeKind;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  specifiedByURL?: Maybe<Scalars['String']>;
  fields?: Maybe<Array<__Field>>;
  interfaces?: Maybe<Array<__Type>>;
  possibleTypes?: Maybe<Array<__Type>>;
  enumValues?: Maybe<Array<__EnumValue>>;
  inputFields?: Maybe<Array<__InputValue>>;
  ofType?: Maybe<__Type>;
  isOneOf?: Maybe<Scalars['Boolean']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeEnumValuesArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeInputFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']>;
};

/** An enum describing what kind of type a given `__Type` is. */
export enum __TypeKind {
  /** Indicates this type is a scalar. */
  Scalar = 'SCALAR',
  /** Indicates this type is an object. `fields` and `interfaces` are valid fields. */
  Object = 'OBJECT',
  /** Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields. */
  Interface = 'INTERFACE',
  /** Indicates this type is a union. `possibleTypes` is a valid field. */
  Union = 'UNION',
  /** Indicates this type is an enum. `enumValues` is a valid field. */
  Enum = 'ENUM',
  /** Indicates this type is an input object. `inputFields` is a valid field. */
  InputObject = 'INPUT_OBJECT',
  /** Indicates this type is a list. `ofType` is a valid field. */
  List = 'LIST',
  /** Indicates this type is a non-null. `ofType` is a valid field. */
  NonNull = 'NON_NULL'
}

export type TechnicalSkillFragment = { __typename?: 'TechnicalSkill', id: number, createdAt: any, updatedAt: any, deletedAt?: any | null, iconBlobId?: number | null, name: string, description?: string | null, skillCategoryId?: number | null, subId: string, skillCategory?: { __typename?: 'SkillCategory', name: string } | null };

export type TechnicalSkillWithCompanyFragment = { __typename?: 'TechnicalSkill', id: number, createdAt: any, updatedAt: any, deletedAt?: any | null, iconBlobId?: number | null, name: string, description?: string | null, skillCategoryId?: number | null, subId: string, skillCategory?: { __typename?: 'SkillCategory', name: string } | null, company?: { __typename?: 'Company', id: number, name: string, logoUrl?: string | null, atsPullJobsFromDate: any, allowedEmailDomains?: Array<string> | null, areCognitiveTestsBlocked: boolean, areRffSoftSkillsDisabled: boolean, isInterviewGuideScoresEnabled: boolean, isLegalAcknowledgementsEnabled: boolean, isSkillsEvaluationScoreEnabled: boolean, isViewGuidanceEnabled: boolean, isAssigneeManagedViaIntegration: boolean, rfuModelType: CompanyRfuModelType, createdAt: string, hideReports: boolean, reasonableAdjustmentsOption: { __typename?: 'ReasonableAdjustmentsOption', kind: ReasonableAdjustmentsOptionKind, value?: string | null }, assessmentExpiryOption?: { __typename?: 'AssessmentExpiryOption', duration: number, unit: AssessmentExpiryOptionUnit } | null, managerReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, candidateReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null } | null };

export type TechnicalSkillNameFragment = { __typename?: 'TechnicalSkill', id: number, name: string, subId: string };

export type ShallowAssessmentStageFragment = { __typename?: 'AssessmentStage', id: string, name: string, kind: AssessmentStageKind, deletedAt?: any | null };

export type AssessmentStageFragmentFragment = { __typename?: 'AssessmentStage', id: string, name: string, kind: AssessmentStageKind, startTime?: any | null, endTime?: any | null, cognitiveMode: CognitiveMode, createdAt: any, updatedAt: any, deletedAt?: any | null, assessmentExpiryOption?: { __typename?: 'AssessmentExpiryOption', duration: number, unit: AssessmentExpiryOptionUnit } | null, emailSettings: { __typename?: 'AssessmentStageEmailSettings', emailCandidateReport: boolean, managerReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, candidateReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, projectTeamEmailSettings: { __typename?: 'ProjectTeamEmailSettings', mode: ProjectTeamEmailMode, actorRoles: Array<ActorRole> } }, actions: { __typename?: 'AssessmentStageActions', aiInterview?: { __typename?: 'AiInterviewAssessmentStageAction', id: string, name: string, duration: number, livekitAgentName: LivekitAgentName, isAvatarEnabled: boolean, isTimingAgentEnabled: boolean } | null, dei?: { __typename?: 'DeiStageActionModel', completedCount: number, submittedCount: number, createdAt: any, deletedAt?: any | null, stageId: number, updatedAt: any, fields: { __typename?: 'DeiStageActionFieldsModel', hasAgeRangeField: boolean, hasDisabilityField: boolean, hasEthnicityField: boolean, hasGenderIdentityField: boolean, hasNeurodiversityField: boolean, hasReligiousBeliefsField: boolean, hasSexualOrientationField: boolean, hasDisabilityIdentifyField: boolean, hasNeurodivergenceIdentifyField: boolean, hasFreeSchoolMealsField: boolean } } | null, personalityTest?: { __typename?: 'PersonalityTestAssessmentStageActionNested', id: string, questionsPerTraitCount: number, selectedLocales: Array<SupportedLocale> } | null, cognitiveTests: Array<{ __typename?: 'CognitiveTestAssessmentStageActionNested', id: string, kind: CognitiveKind, sectionCount: number }>, roleSkillSelfAssessments: Array<{ __typename?: 'RssAssessmentModel', id: number, type: RssAssessmentType, stageId: number }>, coderbyte?: { __typename?: 'CoderbyteAssessmentStageActionNested', id: string, name: string, coderbyteTestId: string, details: { __typename?: 'CoderbyteAssessmentStageActionDetails', timeLimitInMinutes?: number | null, isFrozen: boolean, challengeCount?: number | null, multipleChoiceCount?: number | null } } | null, englishProficiency?: { __typename?: 'EnglishProficiencyAssessmentStageActionNested', id: string, requiredCefrLevel: CefrLevel } | null }, availableActions: Array<{ __typename?: 'StageAvailableActionModel', availability: StageActionAvailability, name: string, kind: AssessmentStageActionKind }> };

export type BlobFragment = { __typename?: 'MonolithBlobModel', id: string, key: string, acl: Acl, extension: string, bucket: string, publishedName: string, url: string, contentType?: string | null, contentEncoding?: string | null, ownerService: string, createdAt: any, updatedAt: any, deletedAt?: any | null };

export type BlobUrlFragment = { __typename?: 'MonolithBlobModel', id: string, url: string };

export type ScheduledTaskBlobFragment = { __typename?: 'MonolithBlobModel', id: string, url: string, expiryDate?: any | null };

export type CompanyFragment = { __typename?: 'Company', id: number, name: string, logoUrl?: string | null, atsPullJobsFromDate: any, allowedEmailDomains?: Array<string> | null, areCognitiveTestsBlocked: boolean, areRffSoftSkillsDisabled: boolean, isInterviewGuideScoresEnabled: boolean, isLegalAcknowledgementsEnabled: boolean, isSkillsEvaluationScoreEnabled: boolean, isViewGuidanceEnabled: boolean, isAssigneeManagedViaIntegration: boolean, rfuModelType: CompanyRfuModelType, createdAt: string, hideReports: boolean, reasonableAdjustmentsOption: { __typename?: 'ReasonableAdjustmentsOption', kind: ReasonableAdjustmentsOptionKind, value?: string | null }, assessmentExpiryOption?: { __typename?: 'AssessmentExpiryOption', duration: number, unit: AssessmentExpiryOptionUnit } | null, managerReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, candidateReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null };

export type CompanySignatureModelFragment = { __typename?: 'CompanySignatureModel', id: number, companyId: number, isDefault: boolean, signature: string, signatureEmail: string };

export type CompanyEmployeeFragment = { __typename?: 'CompanyEmployeeModel', companyId: number, createdAt: any, customFields?: any | null, deletedAt?: any | null, department?: string | null, email: string, employeeId: string, endDate?: any | null, firstName: string, hrManagerEmployeeId?: string | null, id?: number | null, isArchived?: boolean | null, jobTitle?: string | null, lastName: string, startDate?: any | null, szUserId?: number | null, updatedAt: any };

export type CompanyRoleFragment = { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null };

export type CompanyUserInfoPaginatedFragment = { __typename?: 'CompanyUserInfoPaginated', total: number, companyUserInfo: Array<{ __typename?: 'CompanyUserInfo', company: { __typename?: 'Company', id: number, name: string, logoUrl?: string | null, atsPullJobsFromDate: any, allowedEmailDomains?: Array<string> | null, areCognitiveTestsBlocked: boolean, areRffSoftSkillsDisabled: boolean, isInterviewGuideScoresEnabled: boolean, isLegalAcknowledgementsEnabled: boolean, isSkillsEvaluationScoreEnabled: boolean, isViewGuidanceEnabled: boolean, isAssigneeManagedViaIntegration: boolean, rfuModelType: CompanyRfuModelType, createdAt: string, hideReports: boolean, reasonableAdjustmentsOption: { __typename?: 'ReasonableAdjustmentsOption', kind: ReasonableAdjustmentsOptionKind, value?: string | null }, assessmentExpiryOption?: { __typename?: 'AssessmentExpiryOption', duration: number, unit: AssessmentExpiryOptionUnit } | null, managerReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, candidateReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null }, companyUserAcrossAllRoles: { __typename?: 'CompanyUsersCount', companyId: number, totalUsers: number, totalUsersWithPassword: number }, companyUserAcrossEachRole: Array<{ __typename?: 'CompanyUsersWithRolesCount', companyId: number, totalUsersWithPassword: number, totalUsers: number, roleName: IdentityPermissionRole }> }> };

export type ShallowCompanyUserInfoPaginatedFragment = { __typename?: 'CompanyUserInfoPaginated', total: number, companyUserInfo: Array<{ __typename?: 'CompanyUserInfo', company: { __typename?: 'Company', id: number, name: string }, companyUserAcrossAllRoles: { __typename?: 'CompanyUsersCount', companyId: number, totalUsers: number, totalUsersWithPassword: number }, companyUserAcrossEachRole: Array<{ __typename?: 'CompanyUsersWithRolesCount', companyId: number, totalUsersWithPassword: number, totalUsers: number, roleName: IdentityPermissionRole }> }> };

export type CompanyUserInfoFragment = { __typename?: 'CompanyUserInfo', company: { __typename?: 'Company', id: number, name: string, logoUrl?: string | null, atsPullJobsFromDate: any, allowedEmailDomains?: Array<string> | null, areCognitiveTestsBlocked: boolean, areRffSoftSkillsDisabled: boolean, isInterviewGuideScoresEnabled: boolean, isLegalAcknowledgementsEnabled: boolean, isSkillsEvaluationScoreEnabled: boolean, isViewGuidanceEnabled: boolean, isAssigneeManagedViaIntegration: boolean, rfuModelType: CompanyRfuModelType, createdAt: string, hideReports: boolean, reasonableAdjustmentsOption: { __typename?: 'ReasonableAdjustmentsOption', kind: ReasonableAdjustmentsOptionKind, value?: string | null }, assessmentExpiryOption?: { __typename?: 'AssessmentExpiryOption', duration: number, unit: AssessmentExpiryOptionUnit } | null, managerReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, candidateReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null }, companyUserAcrossAllRoles: { __typename?: 'CompanyUsersCount', companyId: number, totalUsers: number, totalUsersWithPassword: number }, companyUserAcrossEachRole: Array<{ __typename?: 'CompanyUsersWithRolesCount', companyId: number, totalUsersWithPassword: number, totalUsers: number, roleName: IdentityPermissionRole }> };

export type CompanyUsersCountFragment = { __typename?: 'CompanyUsersCount', companyId: number, totalUsers: number, totalUsersWithPassword: number };

export type CompanyUsersWithRolesCountFragment = { __typename?: 'CompanyUsersWithRolesCount', companyId: number, totalUsersWithPassword: number, totalUsers: number, roleName: IdentityPermissionRole };

export type ShallowCompanyUserInfoFragment = { __typename?: 'CompanyUserInfo', company: { __typename?: 'Company', id: number, name: string }, companyUserAcrossAllRoles: { __typename?: 'CompanyUsersCount', companyId: number, totalUsers: number, totalUsersWithPassword: number }, companyUserAcrossEachRole: Array<{ __typename?: 'CompanyUsersWithRolesCount', companyId: number, totalUsersWithPassword: number, totalUsers: number, roleName: IdentityPermissionRole }> };

export type DeiStageActionFragment = { __typename?: 'DeiStageActionModel', completedCount: number, submittedCount: number, createdAt: any, deletedAt?: any | null, stageId: number, updatedAt: any, fields: { __typename?: 'DeiStageActionFieldsModel', hasAgeRangeField: boolean, hasDisabilityField: boolean, hasEthnicityField: boolean, hasGenderIdentityField: boolean, hasNeurodiversityField: boolean, hasReligiousBeliefsField: boolean, hasSexualOrientationField: boolean, hasDisabilityIdentifyField: boolean, hasNeurodivergenceIdentifyField: boolean, hasFreeSchoolMealsField: boolean } };

export type DeiFieldsFragment = { __typename?: 'DeiStageActionFieldsModel', hasAgeRangeField: boolean, hasDisabilityField: boolean, hasEthnicityField: boolean, hasGenderIdentityField: boolean, hasNeurodiversityField: boolean, hasReligiousBeliefsField: boolean, hasSexualOrientationField: boolean, hasDisabilityIdentifyField: boolean, hasNeurodivergenceIdentifyField: boolean, hasFreeSchoolMealsField: boolean };

export type DeiStageActionCandidateFragment = { __typename?: 'DeiStageActionCandidateModel', createdAt: any, status: DeiStageActionCandidateStatus, updatedAt: any, hasActiveConsent: boolean, consentEvents: Array<{ __typename?: 'DeiConsentEventModel', event: DeiConsentEventType, occurredAt: any, actorUserId?: number | null }> };

export type FormFragment = { __typename?: 'Form', formManagerType: FormManagerType, formOwnerName: string, formType: FormType, id: number, name: string };

export type FormCandidateModelFragment = { __typename?: 'FormCandidateModel', createdAt: any, deletedAt?: any | null, formId: number, id: number, stageCandidateId: number, status: FormCandidateStatus, subId: string, updatedAt: any, form: { __typename?: 'Form', formManagerType: FormManagerType, formOwnerName: string, formType: FormType, id: number, name: string } };

export type InterviewStageFragment = { __typename?: 'InterviewStage', subId: string, projectId: number, createdAt: any, duration: number, name: string, focus: InterviewStageFocus, softSkills: Array<{ __typename?: 'BasicBroadSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'BasicFocusedSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'BroadSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'FocusedSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory }>, technicalSkills: Array<{ __typename?: 'TechnicalSkill', id: number, subId: string, name: string }> };

export type ShallowInterviewStageFragment = { __typename?: 'InterviewStage', subId: string, name: string, createdAt: any };

export type JobRoleFragment = { __typename?: 'JobRoleModel', companyId: number, createdAt: any, deletedAt?: any | null, id: number, name: string, qualifier?: string | null, roleLevel: ContentRoleLevel, updatedAt: any, family?: JobRoleFamily | null, skillsProfiles: Array<{ __typename?: 'SuccessProfile', calculationMethod: CalculationMethod, createdAt: any, deletedAt?: any | null, gradingMethod: GradingMethod, id: number, jobRoleId: number, status: SuccessProfileStatus, updatedAt: any, successProfileTechnicalSkills?: Array<{ __typename?: 'SuccessProfileTechnicalSkill', id: number, successProfileId: number, technicalSkillId: number, technicalSkill?: { __typename?: 'TechnicalSkill', id: number, name: string, subId: string } | null }> | null, successProfileSoftSkills?: Array<{ __typename?: 'SuccessProfileSoftSkill', id: number, softSkillId: number, type: SoftSkillType, name: string, weight: number, includeInCalibration: boolean, softSkill: { __typename?: 'BasicBroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BasicFocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, focusedSoftSkills: Array<{ __typename?: 'BasicFocusedSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'FocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, broadSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null }, successProfileSoftSkillTraits: Array<{ __typename?: 'SuccessProfileSoftSkillTrait', id: number, orientation?: number | null, traitId: number, weight: number, name?: string | null }>, successProfileSoftSkillDataSources?: Array<{ __typename?: 'SuccessProfileSoftSkillDataSource', id: number, dataSourceType: DataSourceType, softSkillType: SoftSkillType }> | null }> | null }> };

export type JobRoleOverviewFragment = { __typename?: 'JobRoleModel', companyId: number, createdAt: any, deletedAt?: any | null, id: number, name: string, qualifier?: string | null, roleLevel: ContentRoleLevel, updatedAt: any, skillsProfiles: Array<{ __typename?: 'SuccessProfile', id: number, createdAt: any }> };

export type JobRolePaginatedDataFragment = { __typename?: 'JobRolePaginatedData', id: number, subId: string, createdAt: any, updatedAt: any, name: string, qualifier?: string | null, roleLevel: ContentRoleLevel, family?: JobRoleFamily | null, projectsCount: number, source: JobRoleSource, company: { __typename?: 'Company', id: number, name: string }, skillsProfiles: Array<{ __typename?: 'SuccessProfile', calculationMethod: CalculationMethod, createdAt: any, deletedAt?: any | null, gradingMethod: GradingMethod, id: number, jobRoleId: number, status: SuccessProfileStatus, updatedAt: any, successProfileSoftSkills?: Array<{ __typename?: 'SuccessProfileSoftSkill', id: number, softSkillId: number, name: string, softSkill: { __typename?: 'BasicBroadSoftSkill', subId: string, category: SoftSkillCategory } | { __typename?: 'BasicFocusedSoftSkill', subId: string, category: SoftSkillCategory } | { __typename?: 'BroadSoftSkill', subId: string, category: SoftSkillCategory } | { __typename?: 'FocusedSoftSkill', subId: string, category: SoftSkillCategory } }> | null }> };

export type JobRolePaginatedFragment = { __typename?: 'JobRolePaginated', data: Array<{ __typename?: 'JobRolePaginatedData', id: number, subId: string, createdAt: any, updatedAt: any, name: string, qualifier?: string | null, roleLevel: ContentRoleLevel, family?: JobRoleFamily | null, projectsCount: number, source: JobRoleSource, company: { __typename?: 'Company', id: number, name: string }, skillsProfiles: Array<{ __typename?: 'SuccessProfile', calculationMethod: CalculationMethod, createdAt: any, deletedAt?: any | null, gradingMethod: GradingMethod, id: number, jobRoleId: number, status: SuccessProfileStatus, updatedAt: any, successProfileSoftSkills?: Array<{ __typename?: 'SuccessProfileSoftSkill', id: number, softSkillId: number, name: string, softSkill: { __typename?: 'BasicBroadSoftSkill', subId: string, category: SoftSkillCategory } | { __typename?: 'BasicFocusedSoftSkill', subId: string, category: SoftSkillCategory } | { __typename?: 'BroadSoftSkill', subId: string, category: SoftSkillCategory } | { __typename?: 'FocusedSoftSkill', subId: string, category: SoftSkillCategory } }> | null }> }>, page: { __typename?: 'Pageinfo', skip?: number | null, take?: number | null, itemsOnPage: number, itemsTotal: number, pageTotal: number, currentPage: number } };

export type JobRoleNameFragment = { __typename?: 'JobRoleModel', name: string, id: number, roleLevel: ContentRoleLevel, family?: JobRoleFamily | null, skillsProfiles: Array<{ __typename?: 'SuccessProfile', id: number, successProfileTechnicalSkills?: Array<{ __typename?: 'SuccessProfileTechnicalSkill', id: number, technicalSkill?: { __typename?: 'TechnicalSkill', id: number, name: string, subId: string } | null }> | null, successProfileSoftSkills?: Array<{ __typename?: 'SuccessProfileSoftSkill', id: number, softSkillId: number, name: string, softSkill: { __typename?: 'BasicBroadSoftSkill', subId: string, category: SoftSkillCategory } | { __typename?: 'BasicFocusedSoftSkill', subId: string, category: SoftSkillCategory } | { __typename?: 'BroadSoftSkill', subId: string, category: SoftSkillCategory } | { __typename?: 'FocusedSoftSkill', subId: string, category: SoftSkillCategory } }> | null }> };

export type PageInfoFragment = { __typename?: 'Pageinfo', skip?: number | null, take?: number | null, itemsOnPage: number, itemsTotal: number, pageTotal: number, currentPage: number };

export type ProjectFragment = { __typename?: 'Project', companySignatureId?: number | null, createdAt: string, creatorId?: number | null, publishedAt?: any | null, source: ProjectSource, id: number, isArchived: boolean, isStopped: boolean, locales: Array<SupportedLocale>, primaryLocale: SupportedLocale, moduleType: ProjectModuleType, name: string, requireSheetsExport: boolean, updatedAt: string, version: number, productSolution?: ProductSolution | null, subId: string, indirectInviteSSOEnabled?: boolean | null, isIntegrityMonitoringEnabled: boolean, isAiInterviewScoreHidden: boolean, status: ProjectStatus, projectCandidatesCount: number, company?: { __typename?: 'ProjectCompany', id: number, name: string, logoUrl?: string | null } | null, publishedBy?: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } | null, teamMembers?: Array<{ __typename?: 'ProjectManager', email?: string | null, firstName?: string | null, id: number, lastName?: string | null, userId?: number | null }> | null, assessmentStagesV2: Array<{ __typename?: 'AssessmentStage', id: string, name: string, kind: AssessmentStageKind, startTime?: any | null, endTime?: any | null, cognitiveMode: CognitiveMode, createdAt: any, updatedAt: any, deletedAt?: any | null, assessmentExpiryOption?: { __typename?: 'AssessmentExpiryOption', duration: number, unit: AssessmentExpiryOptionUnit } | null, emailSettings: { __typename?: 'AssessmentStageEmailSettings', emailCandidateReport: boolean, managerReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, candidateReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, projectTeamEmailSettings: { __typename?: 'ProjectTeamEmailSettings', mode: ProjectTeamEmailMode, actorRoles: Array<ActorRole> } }, actions: { __typename?: 'AssessmentStageActions', aiInterview?: { __typename?: 'AiInterviewAssessmentStageAction', id: string, name: string, duration: number, livekitAgentName: LivekitAgentName, isAvatarEnabled: boolean, isTimingAgentEnabled: boolean } | null, dei?: { __typename?: 'DeiStageActionModel', completedCount: number, submittedCount: number, createdAt: any, deletedAt?: any | null, stageId: number, updatedAt: any, fields: { __typename?: 'DeiStageActionFieldsModel', hasAgeRangeField: boolean, hasDisabilityField: boolean, hasEthnicityField: boolean, hasGenderIdentityField: boolean, hasNeurodiversityField: boolean, hasReligiousBeliefsField: boolean, hasSexualOrientationField: boolean, hasDisabilityIdentifyField: boolean, hasNeurodivergenceIdentifyField: boolean, hasFreeSchoolMealsField: boolean } } | null, personalityTest?: { __typename?: 'PersonalityTestAssessmentStageActionNested', id: string, questionsPerTraitCount: number, selectedLocales: Array<SupportedLocale> } | null, cognitiveTests: Array<{ __typename?: 'CognitiveTestAssessmentStageActionNested', id: string, kind: CognitiveKind, sectionCount: number }>, roleSkillSelfAssessments: Array<{ __typename?: 'RssAssessmentModel', id: number, type: RssAssessmentType, stageId: number }>, coderbyte?: { __typename?: 'CoderbyteAssessmentStageActionNested', id: string, name: string, coderbyteTestId: string, details: { __typename?: 'CoderbyteAssessmentStageActionDetails', timeLimitInMinutes?: number | null, isFrozen: boolean, challengeCount?: number | null, multipleChoiceCount?: number | null } } | null, englishProficiency?: { __typename?: 'EnglishProficiencyAssessmentStageActionNested', id: string, requiredCefrLevel: CefrLevel } | null }, availableActions: Array<{ __typename?: 'StageAvailableActionModel', availability: StageActionAvailability, name: string, kind: AssessmentStageActionKind }> }>, interviewStages: Array<{ __typename?: 'InterviewStage', subId: string, projectId: number, createdAt: any, duration: number, name: string, focus: InterviewStageFocus, softSkills: Array<{ __typename?: 'BasicBroadSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'BasicFocusedSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'BroadSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'FocusedSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory }>, technicalSkills: Array<{ __typename?: 'TechnicalSkill', id: number, subId: string, name: string }> }>, creator?: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } | null, updatedBy?: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } | null };

export type ProjectTableItemFragment = { __typename?: 'Project', id: number, subId: string, name: string, createdAt: string, updatedAt: string, isStopped: boolean, isArchived: boolean, deletedAt?: string | null, projectCandidatesCount: number, publishedAt?: any | null, status: ProjectStatus, company?: { __typename?: 'ProjectCompany', id: number, name: string, logoUrl?: string | null } | null, assessmentStagesV2: Array<{ __typename?: 'AssessmentStage', id: string, name: string, kind: AssessmentStageKind, deletedAt?: any | null }>, interviewStages: Array<{ __typename?: 'InterviewStage', subId: string, name: string, createdAt: any }>, shortlistStages: Array<{ __typename?: 'ShortlistStage', subId: string }>, contentStages: Array<{ __typename?: 'ContentStageModel', subId: string }> };

export type ProjectBaseFragment = { __typename?: 'Project', id: number, status: ProjectStatus, subId: string, description?: string | null, name: string, version: number, creatorId?: number | null, isArchived: boolean, isStopped: boolean, renderCandidateReport: boolean, companyId?: number | null, companySignatureId?: number | null, moduleType: ProjectModuleType, productSolution?: ProductSolution | null, createdAt: string, updatedAt: string, deletedAt?: string | null, locales: Array<SupportedLocale>, primaryLocale: SupportedLocale, indirectInviteSSOEnabled?: boolean | null, publishedAt?: any | null, lastCandidateActivity?: any | null, source: ProjectSource };

export type ProjectCompanyFragment = { __typename?: 'ProjectCompany', id: number, name: string, logoUrl?: string | null };

export type ProjectJobRoleFragment = { __typename?: 'ProjectJobRoleModel', id: number, createdAt: any, skillsProfileId: number, isLocalizedBenchmarkGroup?: boolean | null, isMainRole: boolean, jobRole: { __typename?: 'JobRoleModel', name: string, id: number, roleLevel: ContentRoleLevel, family?: JobRoleFamily | null, skillsProfiles: Array<{ __typename?: 'SuccessProfile', id: number, successProfileTechnicalSkills?: Array<{ __typename?: 'SuccessProfileTechnicalSkill', id: number, technicalSkill?: { __typename?: 'TechnicalSkill', id: number, name: string, subId: string } | null }> | null, successProfileSoftSkills?: Array<{ __typename?: 'SuccessProfileSoftSkill', id: number, softSkillId: number, name: string, softSkill: { __typename?: 'BasicBroadSoftSkill', subId: string, category: SoftSkillCategory } | { __typename?: 'BasicFocusedSoftSkill', subId: string, category: SoftSkillCategory } | { __typename?: 'BroadSoftSkill', subId: string, category: SoftSkillCategory } | { __typename?: 'FocusedSoftSkill', subId: string, category: SoftSkillCategory } }> | null }> }, project: { __typename?: 'Project', id: number, productSolution?: ProductSolution | null } };

export type ProjectManagerFragment = { __typename?: 'ProjectManager', email?: string | null, firstName?: string | null, id: number, lastName?: string | null, userId?: number | null };

export type ProjectTeamEmailSettingsBaseFragment = { __typename?: 'ProjectTeamEmailSettings', mode: ProjectTeamEmailMode, actorRoles: Array<ActorRole> };

export type ProjectWithStageCandidatesFragment = { __typename?: 'ProjectWithStageCandidates', id: number, name: string, numberOfStageCandidates: number, percentageOfCompletedStageCandidates: number, numberOfCompletedInTimeFrameStageCandidates: number };

export type ReportAssignmentFragment = { __typename?: 'ReportAssignment', assignedId: number, assignedType: RAssignedType, id: number, inheritsSetting?: boolean | null, reportId: number, report: { __typename?: 'Report', id: number, name: string } };

export type ReportFragment = { __typename?: 'Report', id: number, name: string, type: ReportType, subType?: ReportSubType | null, footerType: ReportFooterType, isArchived: boolean, ownerId: number, ownerType: ReportOwnerType, createdAt: any, updatedAt: any, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string } | null, reportConfigs?: Array<{ __typename?: 'ReportConfig', id: number, newPageBefore: boolean, position: number, widgetConfigs?: Array<{ __typename?: 'WidgetConfig', id: number, settings: string, widgetOption?: { __typename?: 'WidgetOption', question?: string | null, fieldType: WidgetOptionFieldType, widgetId: number, id: number, defaultValue?: string | null } | null }> | null, widget: { __typename?: 'Widget', id: number, name?: string | null, isArchived: boolean, updatedAt: any, type: WidgetType } }> | null };

export type ReportListItemFragment = { __typename?: 'Report', id: number, name: string, type: ReportType, subType?: ReportSubType | null, isArchived: boolean, ownerId: number, ownerType: ReportOwnerType, createdAt: any, updatedAt: any, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string } | null };

export type ShallowReportFragment = { __typename?: 'Report', id: number, name: string, type: ReportType };

export type ResultValidatedSkillsModelFragment = { __typename?: 'ResultValidatedSkillsModel', totalValidateSkills: number, company: { __typename?: 'Company', id: number, name: string, logoUrl?: string | null, atsPullJobsFromDate: any, allowedEmailDomains?: Array<string> | null, areCognitiveTestsBlocked: boolean, areRffSoftSkillsDisabled: boolean, isInterviewGuideScoresEnabled: boolean, isLegalAcknowledgementsEnabled: boolean, isSkillsEvaluationScoreEnabled: boolean, isViewGuidanceEnabled: boolean, isAssigneeManagedViaIntegration: boolean, rfuModelType: CompanyRfuModelType, createdAt: string, hideReports: boolean, reasonableAdjustmentsOption: { __typename?: 'ReasonableAdjustmentsOption', kind: ReasonableAdjustmentsOptionKind, value?: string | null }, assessmentExpiryOption?: { __typename?: 'AssessmentExpiryOption', duration: number, unit: AssessmentExpiryOptionUnit } | null, managerReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, candidateReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null } };

export type ResultValidatedSkillsPaginatedModelFragment = { __typename?: 'ResultValidatedSkillsPaginatedModel', total: number, resultValidatedSkills: Array<{ __typename?: 'ResultValidatedSkillsModel', totalValidateSkills: number, company: { __typename?: 'Company', id: number, name: string, logoUrl?: string | null, atsPullJobsFromDate: any, allowedEmailDomains?: Array<string> | null, areCognitiveTestsBlocked: boolean, areRffSoftSkillsDisabled: boolean, isInterviewGuideScoresEnabled: boolean, isLegalAcknowledgementsEnabled: boolean, isSkillsEvaluationScoreEnabled: boolean, isViewGuidanceEnabled: boolean, isAssigneeManagedViaIntegration: boolean, rfuModelType: CompanyRfuModelType, createdAt: string, hideReports: boolean, reasonableAdjustmentsOption: { __typename?: 'ReasonableAdjustmentsOption', kind: ReasonableAdjustmentsOptionKind, value?: string | null }, assessmentExpiryOption?: { __typename?: 'AssessmentExpiryOption', duration: number, unit: AssessmentExpiryOptionUnit } | null, managerReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, candidateReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null } }> };

export type RoleFragment = { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType };

export type RssAssessmentFragment = { __typename?: 'RssAssessmentModel', id: number, type: RssAssessmentType, stageId: number };

export type RssAssessmentCandidateFragment = { __typename?: 'RssAssessmentCandidateModel', id: number, status: RssAssessmentCandidateStatus, updatedAt: any, rssAssessment: { __typename?: 'RssAssessmentModel', id: number, type: RssAssessmentType, stageId: number } };

export type ShortlistStageBaseFragment = { __typename?: 'ShortlistStage', subId: string, projectId: number, name: string, createdAt: any, updatedAt: any };

type BasicBroadSoftSkill_BasicBroadSoftSkill_Fragment = { __typename?: 'BasicBroadSoftSkill', subId: string, name: string };

type BasicBroadSoftSkill_BasicFocusedSoftSkill_Fragment = { __typename?: 'BasicFocusedSoftSkill', subId: string, name: string };

type BasicBroadSoftSkill_BroadSoftSkill_Fragment = { __typename?: 'BroadSoftSkill', subId: string, name: string };

type BasicBroadSoftSkill_FocusedSoftSkill_Fragment = { __typename?: 'FocusedSoftSkill', subId: string, name: string };

export type BasicBroadSoftSkillFragment = BasicBroadSoftSkill_BasicBroadSoftSkill_Fragment | BasicBroadSoftSkill_BasicFocusedSoftSkill_Fragment | BasicBroadSoftSkill_BroadSoftSkill_Fragment | BasicBroadSoftSkill_FocusedSoftSkill_Fragment;

type BasicFocusedSoftSkill_BasicBroadSoftSkill_Fragment = { __typename?: 'BasicBroadSoftSkill', subId: string, name: string };

type BasicFocusedSoftSkill_BasicFocusedSoftSkill_Fragment = { __typename?: 'BasicFocusedSoftSkill', subId: string, name: string };

type BasicFocusedSoftSkill_BroadSoftSkill_Fragment = { __typename?: 'BroadSoftSkill', subId: string, name: string };

type BasicFocusedSoftSkill_FocusedSoftSkill_Fragment = { __typename?: 'FocusedSoftSkill', subId: string, name: string };

export type BasicFocusedSoftSkillFragment = BasicFocusedSoftSkill_BasicBroadSoftSkill_Fragment | BasicFocusedSoftSkill_BasicFocusedSoftSkill_Fragment | BasicFocusedSoftSkill_BroadSoftSkill_Fragment | BasicFocusedSoftSkill_FocusedSoftSkill_Fragment;

type SoftSkill_BasicBroadSoftSkill_Fragment = { __typename?: 'BasicBroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null };

type SoftSkill_BasicFocusedSoftSkill_Fragment = { __typename?: 'BasicFocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null };

type SoftSkill_BroadSoftSkill_Fragment = { __typename?: 'BroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, focusedSoftSkills: Array<{ __typename?: 'BasicFocusedSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null };

type SoftSkill_FocusedSoftSkill_Fragment = { __typename?: 'FocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, broadSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null };

export type SoftSkillFragment = SoftSkill_BasicBroadSoftSkill_Fragment | SoftSkill_BasicFocusedSoftSkill_Fragment | SoftSkill_BroadSoftSkill_Fragment | SoftSkill_FocusedSoftSkill_Fragment;

export type SoftSkillTraitFragment = { __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null };

export type StageAvailableActionFragment = { __typename?: 'StageAvailableActionModel', availability: StageActionAvailability, name: string, kind: AssessmentStageActionKind };

export type SmStageModelFragment = { __typename?: 'SmStageModel', id: number, subId: string, name: string, kind: AssessmentStageKind, status: StageStatus, startTime?: any | null, endTime?: any | null, projectId: number, hasCalibration: boolean, createdAt: any, updatedAt: any, deletedAt?: any | null, emailCandidateReport: boolean, cognitiveMode: CognitiveMode, deiStageAction?: { __typename?: 'DeiStageActionModel', completedCount: number, submittedCount: number, createdAt: any, deletedAt?: any | null, stageId: number, updatedAt: any, fields: { __typename?: 'DeiStageActionFieldsModel', hasAgeRangeField: boolean, hasDisabilityField: boolean, hasEthnicityField: boolean, hasGenderIdentityField: boolean, hasNeurodiversityField: boolean, hasReligiousBeliefsField: boolean, hasSexualOrientationField: boolean, hasDisabilityIdentifyField: boolean, hasNeurodivergenceIdentifyField: boolean, hasFreeSchoolMealsField: boolean } } | null, availableActions: Array<{ __typename?: 'StageAvailableActionModel', availability: StageActionAvailability, name: string, kind: AssessmentStageActionKind }>, rssAssessments: Array<{ __typename?: 'RssAssessmentModel', id: number, type: RssAssessmentType, stageId: number }>, assessmentExpiryOption?: { __typename?: 'AssessmentExpiryOption', duration: number, unit: AssessmentExpiryOptionUnit } | null, managerReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, candidateReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, projectTeamEmailSettings: { __typename?: 'ProjectTeamEmailSettings', mode: ProjectTeamEmailMode, actorRoles: Array<ActorRole> } };

export type ShallowSmStageModelFragment = { __typename?: 'SmStageModel', id: number, name: string };

export type StageCandidateModelFragment = { __typename?: 'SmStageCandidateModel', id: number, subId: string, companyId?: number | null, doneFor: number, doneBy: number, lastDateOfCandidateAction?: any | null, status: StageCandidateStatus, deiStageActionCandidate?: { __typename?: 'DeiStageActionCandidateModel', createdAt: any, status: DeiStageActionCandidateStatus, updatedAt: any, hasActiveConsent: boolean, consentEvents: Array<{ __typename?: 'DeiConsentEventModel', event: DeiConsentEventType, occurredAt: any, actorUserId?: number | null }> } | null, stage: { __typename?: 'SmStageModel', id: number, name: string, projectId: number, cognitiveMode: CognitiveMode }, rssAssessmentCandidates?: Array<{ __typename?: 'RssAssessmentCandidateModel', id: number, status: RssAssessmentCandidateStatus, updatedAt: any, rssAssessment: { __typename?: 'RssAssessmentModel', id: number, type: RssAssessmentType, stageId: number } }> | null, formCandidates?: Array<{ __typename?: 'FormCandidateModel', createdAt: any, deletedAt?: any | null, formId: number, id: number, stageCandidateId: number, status: FormCandidateStatus, subId: string, updatedAt: any, form: { __typename?: 'Form', formManagerType: FormManagerType, formOwnerName: string, formType: FormType, id: number, name: string } } | null> | null, projectCandidate: { __typename?: 'BasicProjectCandidate', subId: string, isExpired: boolean, expiresAt?: any | null }, personalityTestActionCandidate?: { __typename?: 'PersonalityTestAssessmentStageActionCandidate', id: string, status: PersonalityTestAssessmentStageActionCandidateStatus, assessmentId?: string | null } | null, cognitiveTestActionCandidates: Array<{ __typename?: 'CognitiveTestAssessmentStageActionCandidate', id: string, status: CognitiveTestAssessmentStageActionCandidateStatus, assessmentId?: string | null, timeModifierPercentage?: number | null, action: { __typename?: 'CognitiveTestAssessmentStageActionNested', id: string, kind: CognitiveKind } }>, actionCandidates: { __typename?: 'StageCandidateActionCandidates', coderbyte?: { __typename?: 'CoderbyteAssessmentStageActionCandidate', id: string, status: CoderbyteAssessmentStageActionCandidateStatus, timeModifierPercentage: number, action?: { __typename?: 'CoderbyteAssessmentStageActionNested', id: string, name: string, coderbyteTestId: string, details: { __typename?: 'CoderbyteAssessmentStageActionDetails', timeLimitInMinutes?: number | null } } | null } | null, englishProficiency?: { __typename?: 'EnglishProficiencyAssessmentStageActionCandidate', id: string, status: EnglishProficiencyAssessmentStageActionCandidateStatus, assessmentId?: string | null } | null } };

export type SuccessProfileFragment = { __typename?: 'SuccessProfile', calculationMethod: CalculationMethod, createdAt: any, deletedAt?: any | null, gradingMethod: GradingMethod, id: number, jobRoleId: number, status: SuccessProfileStatus, updatedAt: any, successProfileTechnicalSkills?: Array<{ __typename?: 'SuccessProfileTechnicalSkill', id: number, successProfileId: number, technicalSkillId: number, technicalSkill?: { __typename?: 'TechnicalSkill', id: number, name: string, subId: string } | null }> | null, successProfileSoftSkills?: Array<{ __typename?: 'SuccessProfileSoftSkill', id: number, softSkillId: number, type: SoftSkillType, name: string, weight: number, includeInCalibration: boolean, softSkill: { __typename?: 'BasicBroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BasicFocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, focusedSoftSkills: Array<{ __typename?: 'BasicFocusedSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'FocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, broadSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null }, successProfileSoftSkillTraits: Array<{ __typename?: 'SuccessProfileSoftSkillTrait', id: number, orientation?: number | null, traitId: number, weight: number, name?: string | null }>, successProfileSoftSkillDataSources?: Array<{ __typename?: 'SuccessProfileSoftSkillDataSource', id: number, dataSourceType: DataSourceType, softSkillType: SoftSkillType }> | null }> | null };

export type SuccessProfileTechnicalSkillFragment = { __typename?: 'SuccessProfileTechnicalSkill', id: number, successProfileId: number, technicalSkillId: number, technicalSkill?: { __typename?: 'TechnicalSkill', id: number, name: string, subId: string } | null };

export type SuccessProfileSoftSkillFragment = { __typename?: 'SuccessProfileSoftSkill', id: number, softSkillId: number, type: SoftSkillType, name: string, weight: number, includeInCalibration: boolean, softSkill: { __typename?: 'BasicBroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BasicFocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, focusedSoftSkills: Array<{ __typename?: 'BasicFocusedSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'FocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, broadSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null }, successProfileSoftSkillTraits: Array<{ __typename?: 'SuccessProfileSoftSkillTrait', id: number, orientation?: number | null, traitId: number, weight: number, name?: string | null }>, successProfileSoftSkillDataSources?: Array<{ __typename?: 'SuccessProfileSoftSkillDataSource', id: number, dataSourceType: DataSourceType, softSkillType: SoftSkillType }> | null };

export type SuccessProfileSoftSkillTraitFragment = { __typename?: 'SuccessProfileSoftSkillTrait', id: number, orientation?: number | null, traitId: number, weight: number, name?: string | null };

export type SuccessProfileShallowFragment = { __typename?: 'SuccessProfile', calculationMethod: CalculationMethod, createdAt: any, deletedAt?: any | null, gradingMethod: GradingMethod, id: number, jobRoleId: number, status: SuccessProfileStatus, updatedAt: any };

export type SuccessProfileSkillWithOnlySoftSkillsFragment = { __typename?: 'SuccessProfile', calculationMethod: CalculationMethod, createdAt: any, deletedAt?: any | null, gradingMethod: GradingMethod, id: number, jobRoleId: number, status: SuccessProfileStatus, updatedAt: any, successProfileSoftSkills?: Array<{ __typename?: 'SuccessProfileSoftSkill', id: number, softSkillId: number, name: string, softSkill: { __typename?: 'BasicBroadSoftSkill', subId: string, category: SoftSkillCategory } | { __typename?: 'BasicFocusedSoftSkill', subId: string, category: SoftSkillCategory } | { __typename?: 'BroadSoftSkill', subId: string, category: SoftSkillCategory } | { __typename?: 'FocusedSoftSkill', subId: string, category: SoftSkillCategory } }> | null };

export type SuccessProfileSkillNamesFragment = { __typename?: 'SuccessProfile', id: number, successProfileTechnicalSkills?: Array<{ __typename?: 'SuccessProfileTechnicalSkill', id: number, technicalSkill?: { __typename?: 'TechnicalSkill', id: number, name: string, subId: string } | null }> | null, successProfileSoftSkills?: Array<{ __typename?: 'SuccessProfileSoftSkill', id: number, softSkillId: number, name: string, softSkill: { __typename?: 'BasicBroadSoftSkill', subId: string, category: SoftSkillCategory } | { __typename?: 'BasicFocusedSoftSkill', subId: string, category: SoftSkillCategory } | { __typename?: 'BroadSoftSkill', subId: string, category: SoftSkillCategory } | { __typename?: 'FocusedSoftSkill', subId: string, category: SoftSkillCategory } }> | null };

export type SuccessProfileSoftSkillNameAndCategoryFragment = { __typename?: 'SuccessProfileSoftSkill', id: number, softSkillId: number, name: string, softSkill: { __typename?: 'BasicBroadSoftSkill', subId: string, category: SoftSkillCategory } | { __typename?: 'BasicFocusedSoftSkill', subId: string, category: SoftSkillCategory } | { __typename?: 'BroadSoftSkill', subId: string, category: SoftSkillCategory } | { __typename?: 'FocusedSoftSkill', subId: string, category: SoftSkillCategory } };

export type SuccessProfileTechnicalSkillNameFragment = { __typename?: 'SuccessProfileTechnicalSkill', id: number, technicalSkill?: { __typename?: 'TechnicalSkill', id: number, name: string, subId: string } | null };

export type PersonalityTestActionFragment = { __typename?: 'PersonalityTestAssessmentStageActionNested', id: string, questionsPerTraitCount: number, selectedLocales: Array<SupportedLocale> };

export type CognitiveTestActionFragment = { __typename?: 'CognitiveTestAssessmentStageActionNested', id: string, kind: CognitiveKind, sectionCount: number };

export type CoderbyteStageActionFragment = { __typename?: 'CoderbyteAssessmentStageActionNested', id: string, name: string, coderbyteTestId: string, details: { __typename?: 'CoderbyteAssessmentStageActionDetails', timeLimitInMinutes?: number | null, isFrozen: boolean, challengeCount?: number | null, multipleChoiceCount?: number | null } };

export type EnglishProficiencyStageActionFragment = { __typename?: 'EnglishProficiencyAssessmentStageActionNested', id: string, requiredCefrLevel: CefrLevel };

export type PersonalityTestActionCandidateFragment = { __typename?: 'PersonalityTestAssessmentStageActionCandidate', id: string, status: PersonalityTestAssessmentStageActionCandidateStatus, assessmentId?: string | null };

export type CognitiveTestActionCandidateFragment = { __typename?: 'CognitiveTestAssessmentStageActionCandidate', id: string, status: CognitiveTestAssessmentStageActionCandidateStatus, assessmentId?: string | null, timeModifierPercentage?: number | null, action: { __typename?: 'CognitiveTestAssessmentStageActionNested', id: string, kind: CognitiveKind } };

export type CoderbyteActionCandidateFragment = { __typename?: 'CoderbyteAssessmentStageActionCandidate', id: string, status: CoderbyteAssessmentStageActionCandidateStatus, timeModifierPercentage: number, action?: { __typename?: 'CoderbyteAssessmentStageActionNested', id: string, name: string, coderbyteTestId: string, details: { __typename?: 'CoderbyteAssessmentStageActionDetails', timeLimitInMinutes?: number | null } } | null };

export type EnglishProficiencyActionCandidateFragment = { __typename?: 'EnglishProficiencyAssessmentStageActionCandidate', id: string, status: EnglishProficiencyAssessmentStageActionCandidateStatus, assessmentId?: string | null };

export type TraitFragment = { __typename?: 'Trait', id: number, subId: string, name: string, description: string, isArchived: boolean, testTypes: Array<{ __typename?: 'TraitTestTypeModel', id: number, testSubType?: TestSubType | null, testType: TestType, traitId: number }> };

export type TraitTestTypeFragment = { __typename?: 'TraitTestTypeModel', id: number, testSubType?: TestSubType | null, testType: TestType, traitId: number };

export type TraitSoftSkillContextFileUploadRowFragment = { __typename?: 'TraitSoftSkillContextFileUploadLineModel', internalName: string, level: string, negativeSummary: string, positiveSummary: string, softSkillId: string, traitId: string };

export type UserFragment = { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> };

export type UserRoleFragment = { __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } };

export type ContentValidatiorPieceModelFragment = { __typename?: 'ContentValidatiorPieceModel', softSkillId?: number | null, softSkillName?: string | null, traitId?: number | null, traitName?: string | null, numOfSsContent: string, numOfSsSpContent: string, numOfTraitContent: string, numOfIqContent: string };

export type WidgetFragment = { __typename?: 'Widget', id: number, name?: string | null, type: WidgetType, screenShotBlobId?: number | null, isArchived: boolean, updatedAt: any, screenShotBlob?: { __typename?: 'MonolithBlobModel', id: string, url: string } | null, widgetOptions?: Array<{ __typename?: 'WidgetOption', id: number, question?: string | null, fieldType: WidgetOptionFieldType, defaultValue?: string | null, isArchived: boolean }> | null, reportConfigs?: Array<{ __typename?: 'ReportConfig', id: number, reportId: number, newPageBefore: boolean }> | null };

export type DeleteAssessmentStageMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteAssessmentStageMutation = { __typename?: 'Mutation', deleteAssessmentStage: boolean };

export type UpdateAssessmentStageMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdateAssessmentStageInput;
}>;


export type UpdateAssessmentStageMutation = { __typename?: 'Mutation', updateAssessmentStage: { __typename?: 'AssessmentStage', id: string, name: string, kind: AssessmentStageKind, startTime?: any | null, endTime?: any | null, cognitiveMode: CognitiveMode, createdAt: any, updatedAt: any, deletedAt?: any | null, assessmentExpiryOption?: { __typename?: 'AssessmentExpiryOption', duration: number, unit: AssessmentExpiryOptionUnit } | null, emailSettings: { __typename?: 'AssessmentStageEmailSettings', emailCandidateReport: boolean, managerReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, candidateReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, projectTeamEmailSettings: { __typename?: 'ProjectTeamEmailSettings', mode: ProjectTeamEmailMode, actorRoles: Array<ActorRole> } }, actions: { __typename?: 'AssessmentStageActions', aiInterview?: { __typename?: 'AiInterviewAssessmentStageAction', id: string, name: string, duration: number, livekitAgentName: LivekitAgentName, isAvatarEnabled: boolean, isTimingAgentEnabled: boolean } | null, dei?: { __typename?: 'DeiStageActionModel', completedCount: number, submittedCount: number, createdAt: any, deletedAt?: any | null, stageId: number, updatedAt: any, fields: { __typename?: 'DeiStageActionFieldsModel', hasAgeRangeField: boolean, hasDisabilityField: boolean, hasEthnicityField: boolean, hasGenderIdentityField: boolean, hasNeurodiversityField: boolean, hasReligiousBeliefsField: boolean, hasSexualOrientationField: boolean, hasDisabilityIdentifyField: boolean, hasNeurodivergenceIdentifyField: boolean, hasFreeSchoolMealsField: boolean } } | null, personalityTest?: { __typename?: 'PersonalityTestAssessmentStageActionNested', id: string, questionsPerTraitCount: number, selectedLocales: Array<SupportedLocale> } | null, cognitiveTests: Array<{ __typename?: 'CognitiveTestAssessmentStageActionNested', id: string, kind: CognitiveKind, sectionCount: number }>, roleSkillSelfAssessments: Array<{ __typename?: 'RssAssessmentModel', id: number, type: RssAssessmentType, stageId: number }>, coderbyte?: { __typename?: 'CoderbyteAssessmentStageActionNested', id: string, name: string, coderbyteTestId: string, details: { __typename?: 'CoderbyteAssessmentStageActionDetails', timeLimitInMinutes?: number | null, isFrozen: boolean, challengeCount?: number | null, multipleChoiceCount?: number | null } } | null, englishProficiency?: { __typename?: 'EnglishProficiencyAssessmentStageActionNested', id: string, requiredCefrLevel: CefrLevel } | null }, availableActions: Array<{ __typename?: 'StageAvailableActionModel', availability: StageActionAvailability, name: string, kind: AssessmentStageActionKind }> } };

export type UpsertAssessmentStageDeiActionMutationVariables = Exact<{
  stageId: Scalars['ID'];
  fields: DeiStageActionFieldsInput;
}>;


export type UpsertAssessmentStageDeiActionMutation = { __typename?: 'Mutation', upsertAssessmentStageDeiAction: { __typename?: 'DeiStageActionModel', completedCount: number, submittedCount: number, createdAt: any, deletedAt?: any | null, stageId: number, updatedAt: any, fields: { __typename?: 'DeiStageActionFieldsModel', hasAgeRangeField: boolean, hasDisabilityField: boolean, hasEthnicityField: boolean, hasGenderIdentityField: boolean, hasNeurodiversityField: boolean, hasReligiousBeliefsField: boolean, hasSexualOrientationField: boolean, hasDisabilityIdentifyField: boolean, hasNeurodivergenceIdentifyField: boolean, hasFreeSchoolMealsField: boolean } } };

export type ArchiveAssessmentStageDeiActionMutationVariables = Exact<{
  stageId: Scalars['ID'];
}>;


export type ArchiveAssessmentStageDeiActionMutation = { __typename?: 'Mutation', archiveAssessmentStageDeiAction: { __typename?: 'DeiStageActionModel', completedCount: number, submittedCount: number, createdAt: any, deletedAt?: any | null, stageId: number, updatedAt: any, fields: { __typename?: 'DeiStageActionFieldsModel', hasAgeRangeField: boolean, hasDisabilityField: boolean, hasEthnicityField: boolean, hasGenderIdentityField: boolean, hasNeurodiversityField: boolean, hasReligiousBeliefsField: boolean, hasSexualOrientationField: boolean, hasDisabilityIdentifyField: boolean, hasNeurodivergenceIdentifyField: boolean, hasFreeSchoolMealsField: boolean } } };

export type UnarchiveAssessmentStageDeiActionMutationVariables = Exact<{
  stageId: Scalars['ID'];
  fields?: InputMaybe<DeiStageActionFieldsInput>;
}>;


export type UnarchiveAssessmentStageDeiActionMutation = { __typename?: 'Mutation', unarchiveAssessmentStageDeiAction: { __typename?: 'DeiStageActionModel', completedCount: number, submittedCount: number, createdAt: any, deletedAt?: any | null, stageId: number, updatedAt: any, fields: { __typename?: 'DeiStageActionFieldsModel', hasAgeRangeField: boolean, hasDisabilityField: boolean, hasEthnicityField: boolean, hasGenderIdentityField: boolean, hasNeurodiversityField: boolean, hasReligiousBeliefsField: boolean, hasSexualOrientationField: boolean, hasDisabilityIdentifyField: boolean, hasNeurodivergenceIdentifyField: boolean, hasFreeSchoolMealsField: boolean } } };

export type UpdateAiInterviewAssessmentStageActionLivekitAgentNameMutationVariables = Exact<{
  id: Scalars['ID'];
  livekitAgentName: LivekitAgentName;
}>;


export type UpdateAiInterviewAssessmentStageActionLivekitAgentNameMutation = { __typename?: 'Mutation', updateAiInterviewAssessmentStageActionLivekitAgentName: { __typename?: 'AiInterviewAssessmentStageAction', id: string, livekitAgentName: LivekitAgentName } };

export type UpdateAiInterviewAssessmentStageActionIsAvatarEnabledMutationVariables = Exact<{
  id: Scalars['ID'];
  isAvatarEnabled: Scalars['Boolean'];
}>;


export type UpdateAiInterviewAssessmentStageActionIsAvatarEnabledMutation = { __typename?: 'Mutation', updateAiInterviewAssessmentStageActionIsAvatarEnabled: { __typename?: 'AiInterviewAssessmentStageAction', id: string, isAvatarEnabled: boolean } };

export type UpdateAiInterviewAssessmentStageActionIsTimingAgentEnabledMutationVariables = Exact<{
  id: Scalars['ID'];
  isTimingAgentEnabled: Scalars['Boolean'];
}>;


export type UpdateAiInterviewAssessmentStageActionIsTimingAgentEnabledMutation = { __typename?: 'Mutation', updateAiInterviewAssessmentStageActionIsTimingAgentEnabled: { __typename?: 'AiInterviewAssessmentStageAction', id: string, isTimingAgentEnabled: boolean } };

export type CreateAssessmentStageRssActionMutationVariables = Exact<{
  stageId: Scalars['ID'];
  type: RssAssessmentType;
}>;


export type CreateAssessmentStageRssActionMutation = { __typename?: 'Mutation', createAssessmentStageRssAction: { __typename?: 'RssAssessmentModel', id: number, type: RssAssessmentType, stageId: number } };

export type DeleteAssessmentStageRssActionMutationVariables = Exact<{
  stageId: Scalars['ID'];
  type: RssAssessmentType;
}>;


export type DeleteAssessmentStageRssActionMutation = { __typename?: 'Mutation', deleteAssessmentStageRssAction: boolean };

export type SetAtsProgressionEnabledMutationVariables = Exact<{
  companyId: Scalars['Int'];
  enabled: Scalars['Boolean'];
}>;


export type SetAtsProgressionEnabledMutation = { __typename?: 'Mutation', setAtsProgressionEnabled: { __typename?: 'AtsSettingsGQLModel', companyId: number, progressionEnabled: boolean, applicationTrackingEnabled: boolean, interviewEvaluationResultsEnabled: boolean, aiInterviewResultsEnabled: boolean, assessmentResultsEnabled: boolean } };

export type SetAtsInterviewEvaluationResultsEnabledMutationVariables = Exact<{
  companyId: Scalars['Int'];
  enabled: Scalars['Boolean'];
}>;


export type SetAtsInterviewEvaluationResultsEnabledMutation = { __typename?: 'Mutation', setAtsInterviewEvaluationResultsEnabled: { __typename?: 'AtsSettingsGQLModel', companyId: number, progressionEnabled: boolean, applicationTrackingEnabled: boolean, interviewEvaluationResultsEnabled: boolean, aiInterviewResultsEnabled: boolean, assessmentResultsEnabled: boolean } };

export type SetAtsAiInterviewResultsEnabledMutationVariables = Exact<{
  companyId: Scalars['Int'];
  enabled: Scalars['Boolean'];
}>;


export type SetAtsAiInterviewResultsEnabledMutation = { __typename?: 'Mutation', setAtsAiInterviewResultsEnabled: { __typename?: 'AtsSettingsGQLModel', companyId: number, progressionEnabled: boolean, applicationTrackingEnabled: boolean, interviewEvaluationResultsEnabled: boolean, aiInterviewResultsEnabled: boolean, assessmentResultsEnabled: boolean } };

export type SetAtsAssessmentResultsEnabledMutationVariables = Exact<{
  companyId: Scalars['Int'];
  enabled: Scalars['Boolean'];
}>;


export type SetAtsAssessmentResultsEnabledMutation = { __typename?: 'Mutation', setAtsAssessmentResultsEnabled: { __typename?: 'AtsSettingsGQLModel', companyId: number, progressionEnabled: boolean, applicationTrackingEnabled: boolean, interviewEvaluationResultsEnabled: boolean, aiInterviewResultsEnabled: boolean, assessmentResultsEnabled: boolean } };

export type SetAtsResultPushConfigMutationVariables = Exact<{
  companyId: Scalars['Int'];
  configs: Array<AtsResultPushConfigInput> | AtsResultPushConfigInput;
}>;


export type SetAtsResultPushConfigMutation = { __typename?: 'Mutation', setAtsResultPushConfig: { __typename?: 'AtsSettingsGQLModel', companyId: number, progressionEnabled: boolean, applicationTrackingEnabled: boolean, interviewEvaluationResultsEnabled: boolean, aiInterviewResultsEnabled: boolean, assessmentResultsEnabled: boolean, aiShortlistResultsEnabled: boolean, allowedRejectionReasonIds?: Array<string> | null, rejectOnBehalfOfUserRemoteId?: string | null, candidatePullMode: AtsCandidatePullMode, stagePushEnabled: boolean, hiringTeamUserProvisioningEnabled: boolean, resultPush: Array<{ __typename?: 'AtsResultPushConfigGQLModel', resultType: AtsResultType, sendAssessmentOrder: boolean, sendResultLink: boolean, sendToAtsFields: boolean, sendToWorkdayObjects: boolean, objectAlias: string, completionStageRef?: string | null, fieldIds: { __typename?: 'AtsResultPushFieldIdsGQLModel', score?: string | null, resultUrl?: string | null, completionDate?: string | null, orderStatus?: string | null, integrityRisk?: string | null }, fieldAliases: { __typename?: 'AtsWorkdayFieldAliasesGQLModel', score?: string | null, resultUrl?: string | null, completionDate?: string | null, interviewName?: string | null, evaluatorName?: string | null, recommendedDecision?: string | null, evaluationId?: string | null, orderStatus?: string | null } }>, stageMap: Array<{ __typename?: 'AtsStageMapEntryGQLModel', szStageType: SzMappedStageType, atsStageRef: string, workdayStepIds: Array<string> }>, stageRejectionReasons: Array<{ __typename?: 'AtsStageRejectionReasonsEntryGQLModel', atsStageRef: string, rejectionReasonIds: Array<string>, defaultAutoRejectReasonId?: string | null }> } };

export type SetAtsAllowedRejectionReasonIdsMutationVariables = Exact<{
  companyId: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type SetAtsAllowedRejectionReasonIdsMutation = { __typename?: 'Mutation', setAtsAllowedRejectionReasonIds: { __typename?: 'AtsSettingsGQLModel', companyId: number, progressionEnabled: boolean, applicationTrackingEnabled: boolean, interviewEvaluationResultsEnabled: boolean, aiInterviewResultsEnabled: boolean, assessmentResultsEnabled: boolean, aiShortlistResultsEnabled: boolean, allowedRejectionReasonIds?: Array<string> | null, rejectOnBehalfOfUserRemoteId?: string | null, candidatePullMode: AtsCandidatePullMode, stagePushEnabled: boolean, hiringTeamUserProvisioningEnabled: boolean, resultPush: Array<{ __typename?: 'AtsResultPushConfigGQLModel', resultType: AtsResultType, sendAssessmentOrder: boolean, sendResultLink: boolean, sendToAtsFields: boolean, sendToWorkdayObjects: boolean, objectAlias: string, completionStageRef?: string | null, fieldIds: { __typename?: 'AtsResultPushFieldIdsGQLModel', score?: string | null, resultUrl?: string | null, completionDate?: string | null, orderStatus?: string | null, integrityRisk?: string | null }, fieldAliases: { __typename?: 'AtsWorkdayFieldAliasesGQLModel', score?: string | null, resultUrl?: string | null, completionDate?: string | null, interviewName?: string | null, evaluatorName?: string | null, recommendedDecision?: string | null, evaluationId?: string | null, orderStatus?: string | null } }>, stageMap: Array<{ __typename?: 'AtsStageMapEntryGQLModel', szStageType: SzMappedStageType, atsStageRef: string, workdayStepIds: Array<string> }>, stageRejectionReasons: Array<{ __typename?: 'AtsStageRejectionReasonsEntryGQLModel', atsStageRef: string, rejectionReasonIds: Array<string>, defaultAutoRejectReasonId?: string | null }> } };

export type SetAtsStageMapMutationVariables = Exact<{
  companyId: Scalars['Int'];
  entries?: InputMaybe<Array<AtsStageMapEntryInput> | AtsStageMapEntryInput>;
}>;


export type SetAtsStageMapMutation = { __typename?: 'Mutation', setAtsStageMap: { __typename?: 'AtsSettingsGQLModel', companyId: number, progressionEnabled: boolean, applicationTrackingEnabled: boolean, interviewEvaluationResultsEnabled: boolean, aiInterviewResultsEnabled: boolean, assessmentResultsEnabled: boolean, aiShortlistResultsEnabled: boolean, allowedRejectionReasonIds?: Array<string> | null, rejectOnBehalfOfUserRemoteId?: string | null, candidatePullMode: AtsCandidatePullMode, stagePushEnabled: boolean, hiringTeamUserProvisioningEnabled: boolean, resultPush: Array<{ __typename?: 'AtsResultPushConfigGQLModel', resultType: AtsResultType, sendAssessmentOrder: boolean, sendResultLink: boolean, sendToAtsFields: boolean, sendToWorkdayObjects: boolean, objectAlias: string, completionStageRef?: string | null, fieldIds: { __typename?: 'AtsResultPushFieldIdsGQLModel', score?: string | null, resultUrl?: string | null, completionDate?: string | null, orderStatus?: string | null, integrityRisk?: string | null }, fieldAliases: { __typename?: 'AtsWorkdayFieldAliasesGQLModel', score?: string | null, resultUrl?: string | null, completionDate?: string | null, interviewName?: string | null, evaluatorName?: string | null, recommendedDecision?: string | null, evaluationId?: string | null, orderStatus?: string | null } }>, stageMap: Array<{ __typename?: 'AtsStageMapEntryGQLModel', szStageType: SzMappedStageType, atsStageRef: string, workdayStepIds: Array<string> }>, stageRejectionReasons: Array<{ __typename?: 'AtsStageRejectionReasonsEntryGQLModel', atsStageRef: string, rejectionReasonIds: Array<string>, defaultAutoRejectReasonId?: string | null }> } };

export type SetAtsCandidatePullModeMutationVariables = Exact<{
  companyId: Scalars['Int'];
  mode: AtsCandidatePullMode;
}>;


export type SetAtsCandidatePullModeMutation = { __typename?: 'Mutation', setAtsCandidatePullMode: { __typename?: 'AtsSettingsGQLModel', companyId: number, progressionEnabled: boolean, applicationTrackingEnabled: boolean, interviewEvaluationResultsEnabled: boolean, aiInterviewResultsEnabled: boolean, assessmentResultsEnabled: boolean, aiShortlistResultsEnabled: boolean, allowedRejectionReasonIds?: Array<string> | null, rejectOnBehalfOfUserRemoteId?: string | null, candidatePullMode: AtsCandidatePullMode, stagePushEnabled: boolean, hiringTeamUserProvisioningEnabled: boolean, resultPush: Array<{ __typename?: 'AtsResultPushConfigGQLModel', resultType: AtsResultType, sendAssessmentOrder: boolean, sendResultLink: boolean, sendToAtsFields: boolean, sendToWorkdayObjects: boolean, objectAlias: string, completionStageRef?: string | null, fieldIds: { __typename?: 'AtsResultPushFieldIdsGQLModel', score?: string | null, resultUrl?: string | null, completionDate?: string | null, orderStatus?: string | null, integrityRisk?: string | null }, fieldAliases: { __typename?: 'AtsWorkdayFieldAliasesGQLModel', score?: string | null, resultUrl?: string | null, completionDate?: string | null, interviewName?: string | null, evaluatorName?: string | null, recommendedDecision?: string | null, evaluationId?: string | null, orderStatus?: string | null } }>, stageMap: Array<{ __typename?: 'AtsStageMapEntryGQLModel', szStageType: SzMappedStageType, atsStageRef: string, workdayStepIds: Array<string> }>, stageRejectionReasons: Array<{ __typename?: 'AtsStageRejectionReasonsEntryGQLModel', atsStageRef: string, rejectionReasonIds: Array<string>, defaultAutoRejectReasonId?: string | null }> } };

export type SetAtsStagePushEnabledMutationVariables = Exact<{
  companyId: Scalars['Int'];
  enabled: Scalars['Boolean'];
}>;


export type SetAtsStagePushEnabledMutation = { __typename?: 'Mutation', setAtsStagePushEnabled: { __typename?: 'AtsSettingsGQLModel', companyId: number, progressionEnabled: boolean, applicationTrackingEnabled: boolean, interviewEvaluationResultsEnabled: boolean, aiInterviewResultsEnabled: boolean, assessmentResultsEnabled: boolean, aiShortlistResultsEnabled: boolean, allowedRejectionReasonIds?: Array<string> | null, rejectOnBehalfOfUserRemoteId?: string | null, candidatePullMode: AtsCandidatePullMode, stagePushEnabled: boolean, hiringTeamUserProvisioningEnabled: boolean, resultPush: Array<{ __typename?: 'AtsResultPushConfigGQLModel', resultType: AtsResultType, sendAssessmentOrder: boolean, sendResultLink: boolean, sendToAtsFields: boolean, sendToWorkdayObjects: boolean, objectAlias: string, completionStageRef?: string | null, fieldIds: { __typename?: 'AtsResultPushFieldIdsGQLModel', score?: string | null, resultUrl?: string | null, completionDate?: string | null, orderStatus?: string | null, integrityRisk?: string | null }, fieldAliases: { __typename?: 'AtsWorkdayFieldAliasesGQLModel', score?: string | null, resultUrl?: string | null, completionDate?: string | null, interviewName?: string | null, evaluatorName?: string | null, recommendedDecision?: string | null, evaluationId?: string | null, orderStatus?: string | null } }>, stageMap: Array<{ __typename?: 'AtsStageMapEntryGQLModel', szStageType: SzMappedStageType, atsStageRef: string, workdayStepIds: Array<string> }>, stageRejectionReasons: Array<{ __typename?: 'AtsStageRejectionReasonsEntryGQLModel', atsStageRef: string, rejectionReasonIds: Array<string>, defaultAutoRejectReasonId?: string | null }> } };

export type SetAtsHiringTeamUserProvisioningEnabledMutationVariables = Exact<{
  companyId: Scalars['Int'];
  enabled: Scalars['Boolean'];
}>;


export type SetAtsHiringTeamUserProvisioningEnabledMutation = { __typename?: 'Mutation', setAtsHiringTeamUserProvisioningEnabled: { __typename?: 'AtsSettingsGQLModel', companyId: number, progressionEnabled: boolean, applicationTrackingEnabled: boolean, interviewEvaluationResultsEnabled: boolean, aiInterviewResultsEnabled: boolean, assessmentResultsEnabled: boolean, aiShortlistResultsEnabled: boolean, allowedRejectionReasonIds?: Array<string> | null, rejectOnBehalfOfUserRemoteId?: string | null, candidatePullMode: AtsCandidatePullMode, stagePushEnabled: boolean, hiringTeamUserProvisioningEnabled: boolean, resultPush: Array<{ __typename?: 'AtsResultPushConfigGQLModel', resultType: AtsResultType, sendAssessmentOrder: boolean, sendResultLink: boolean, sendToAtsFields: boolean, sendToWorkdayObjects: boolean, objectAlias: string, completionStageRef?: string | null, fieldIds: { __typename?: 'AtsResultPushFieldIdsGQLModel', score?: string | null, resultUrl?: string | null, completionDate?: string | null, orderStatus?: string | null, integrityRisk?: string | null }, fieldAliases: { __typename?: 'AtsWorkdayFieldAliasesGQLModel', score?: string | null, resultUrl?: string | null, completionDate?: string | null, interviewName?: string | null, evaluatorName?: string | null, recommendedDecision?: string | null, evaluationId?: string | null, orderStatus?: string | null } }>, stageMap: Array<{ __typename?: 'AtsStageMapEntryGQLModel', szStageType: SzMappedStageType, atsStageRef: string, workdayStepIds: Array<string> }>, stageRejectionReasons: Array<{ __typename?: 'AtsStageRejectionReasonsEntryGQLModel', atsStageRef: string, rejectionReasonIds: Array<string>, defaultAutoRejectReasonId?: string | null }> } };

export type SetAtsRejectOnBehalfOfUserRemoteIdMutationVariables = Exact<{
  companyId: Scalars['Int'];
  userRemoteId?: InputMaybe<Scalars['String']>;
}>;


export type SetAtsRejectOnBehalfOfUserRemoteIdMutation = { __typename?: 'Mutation', setAtsRejectOnBehalfOfUserRemoteId: { __typename?: 'AtsSettingsGQLModel', companyId: number, progressionEnabled: boolean, applicationTrackingEnabled: boolean, interviewEvaluationResultsEnabled: boolean, aiInterviewResultsEnabled: boolean, assessmentResultsEnabled: boolean, aiShortlistResultsEnabled: boolean, allowedRejectionReasonIds?: Array<string> | null, rejectOnBehalfOfUserRemoteId?: string | null, candidatePullMode: AtsCandidatePullMode, stagePushEnabled: boolean, hiringTeamUserProvisioningEnabled: boolean, resultPush: Array<{ __typename?: 'AtsResultPushConfigGQLModel', resultType: AtsResultType, sendAssessmentOrder: boolean, sendResultLink: boolean, sendToAtsFields: boolean, sendToWorkdayObjects: boolean, objectAlias: string, completionStageRef?: string | null, fieldIds: { __typename?: 'AtsResultPushFieldIdsGQLModel', score?: string | null, resultUrl?: string | null, completionDate?: string | null, orderStatus?: string | null, integrityRisk?: string | null }, fieldAliases: { __typename?: 'AtsWorkdayFieldAliasesGQLModel', score?: string | null, resultUrl?: string | null, completionDate?: string | null, interviewName?: string | null, evaluatorName?: string | null, recommendedDecision?: string | null, evaluationId?: string | null, orderStatus?: string | null } }>, stageMap: Array<{ __typename?: 'AtsStageMapEntryGQLModel', szStageType: SzMappedStageType, atsStageRef: string, workdayStepIds: Array<string> }>, stageRejectionReasons: Array<{ __typename?: 'AtsStageRejectionReasonsEntryGQLModel', atsStageRef: string, rejectionReasonIds: Array<string>, defaultAutoRejectReasonId?: string | null }> } };

export type SetAtsStageRejectionReasonsMutationVariables = Exact<{
  companyId: Scalars['Int'];
  entries?: InputMaybe<Array<AtsStageRejectionReasonsEntryInput> | AtsStageRejectionReasonsEntryInput>;
}>;


export type SetAtsStageRejectionReasonsMutation = { __typename?: 'Mutation', setAtsStageRejectionReasons: { __typename?: 'AtsSettingsGQLModel', companyId: number, progressionEnabled: boolean, applicationTrackingEnabled: boolean, interviewEvaluationResultsEnabled: boolean, aiInterviewResultsEnabled: boolean, assessmentResultsEnabled: boolean, aiShortlistResultsEnabled: boolean, allowedRejectionReasonIds?: Array<string> | null, rejectOnBehalfOfUserRemoteId?: string | null, candidatePullMode: AtsCandidatePullMode, stagePushEnabled: boolean, hiringTeamUserProvisioningEnabled: boolean, resultPush: Array<{ __typename?: 'AtsResultPushConfigGQLModel', resultType: AtsResultType, sendAssessmentOrder: boolean, sendResultLink: boolean, sendToAtsFields: boolean, sendToWorkdayObjects: boolean, objectAlias: string, completionStageRef?: string | null, fieldIds: { __typename?: 'AtsResultPushFieldIdsGQLModel', score?: string | null, resultUrl?: string | null, completionDate?: string | null, orderStatus?: string | null, integrityRisk?: string | null }, fieldAliases: { __typename?: 'AtsWorkdayFieldAliasesGQLModel', score?: string | null, resultUrl?: string | null, completionDate?: string | null, interviewName?: string | null, evaluatorName?: string | null, recommendedDecision?: string | null, evaluationId?: string | null, orderStatus?: string | null } }>, stageMap: Array<{ __typename?: 'AtsStageMapEntryGQLModel', szStageType: SzMappedStageType, atsStageRef: string, workdayStepIds: Array<string> }>, stageRejectionReasons: Array<{ __typename?: 'AtsStageRejectionReasonsEntryGQLModel', atsStageRef: string, rejectionReasonIds: Array<string>, defaultAutoRejectReasonId?: string | null }> } };

export type RequestPasswordRecoveryMutationVariables = Exact<{
  email: Scalars['String'];
  clientDomainType: ClientDomainType;
}>;


export type RequestPasswordRecoveryMutation = { __typename?: 'Mutation', requestPasswordRecovery: boolean };

export type ExchangeAuthCodeMutationVariables = Exact<{
  authCode: Scalars['String'];
  clientType: ClientType;
}>;


export type ExchangeAuthCodeMutation = { __typename?: 'Mutation', ExchangeAuthCode: { __typename?: 'AuthenticationResult', accessToken: string, refreshToken: string } };

export type DeauthenticateMutationVariables = Exact<{
  accessToken: Scalars['String'];
}>;


export type DeauthenticateMutation = { __typename?: 'Mutation', deauthenticate: boolean };

export type TraitSoftSkillContextFileUploadMutationVariables = Exact<{
  apply: Scalars['Boolean'];
  file: Scalars['Upload'];
}>;


export type TraitSoftSkillContextFileUploadMutation = { __typename?: 'Mutation', TraitSoftSkillContextFileUpload: { __typename?: 'TraitSoftSkillContextFileUploadModel', apply: boolean, warnings: Array<string>, errorMessage?: string | null, errorMessages?: Array<string> | null, creates?: Array<{ __typename?: 'TraitSoftSkillContextFileUploadLineModel', internalName: string, level: string, negativeSummary: string, positiveSummary: string, softSkillId: string, traitId: string }> | null } };

export type BehaviourFromCsvRowsCreateManyMutationVariables = Exact<{
  dto: Array<BehaviourFromCsvRowsCreateManyArgs> | BehaviourFromCsvRowsCreateManyArgs;
}>;


export type BehaviourFromCsvRowsCreateManyMutation = { __typename?: 'Mutation', BehaviourFromCsvRowsCreateMany: string };

export type ProvisionCoderbyteWorkspaceMutationVariables = Exact<{
  companyId: Scalars['Int'];
}>;


export type ProvisionCoderbyteWorkspaceMutation = { __typename?: 'Mutation', provisionCoderbyteWorkspace: { __typename?: 'CoderbyteWorkspace', id: number, companyId: number, companyName: string, externalId: string, dashboardUrl: string, status: CoderbyteWorkspaceStatus, adminEmail: string, webhookUrl: string, keySetAt?: any | null, adminPasswordSetAt?: any | null, keyVerifiedAt?: any | null, createdAt: any, updatedAt: any } };

export type SetCoderbyteWorkspaceApiKeyMutationVariables = Exact<{
  companyId: Scalars['Int'];
  apiKey: Scalars['String'];
}>;


export type SetCoderbyteWorkspaceApiKeyMutation = { __typename?: 'Mutation', setCoderbyteWorkspaceApiKey: { __typename?: 'CoderbyteWorkspace', id: number, companyId: number, companyName: string, externalId: string, dashboardUrl: string, status: CoderbyteWorkspaceStatus, adminEmail: string, webhookUrl: string, keySetAt?: any | null, adminPasswordSetAt?: any | null, keyVerifiedAt?: any | null, createdAt: any, updatedAt: any } };

export type VerifyCoderbyteWorkspaceApiKeyMutationVariables = Exact<{
  companyId: Scalars['Int'];
}>;


export type VerifyCoderbyteWorkspaceApiKeyMutation = { __typename?: 'Mutation', verifyCoderbyteWorkspaceApiKey: { __typename?: 'CoderbyteWorkspace', id: number, companyId: number, companyName: string, externalId: string, dashboardUrl: string, status: CoderbyteWorkspaceStatus, adminEmail: string, webhookUrl: string, keySetAt?: any | null, adminPasswordSetAt?: any | null, keyVerifiedAt?: any | null, createdAt: any, updatedAt: any } };

export type SetCoderbyteWorkspaceAdminPasswordMutationVariables = Exact<{
  companyId: Scalars['Int'];
  adminPassword: Scalars['String'];
}>;


export type SetCoderbyteWorkspaceAdminPasswordMutation = { __typename?: 'Mutation', setCoderbyteWorkspaceAdminPassword: { __typename?: 'CoderbyteWorkspace', id: number, companyId: number, companyName: string, externalId: string, dashboardUrl: string, status: CoderbyteWorkspaceStatus, adminEmail: string, webhookUrl: string, keySetAt?: any | null, adminPasswordSetAt?: any | null, keyVerifiedAt?: any | null, createdAt: any, updatedAt: any } };

export type UpdateCompanyMutationVariables = Exact<{
  id: Scalars['Int'];
  name: Scalars['String'];
  areCognitiveTestsBlocked?: InputMaybe<Scalars['Boolean']>;
  areRffSoftSkillsDisabled?: InputMaybe<Scalars['Boolean']>;
  isInterviewGuideScoresEnabled?: InputMaybe<Scalars['Boolean']>;
  isLegalAcknowledgementsEnabled?: InputMaybe<Scalars['Boolean']>;
  isSkillsEvaluationScoreEnabled?: InputMaybe<Scalars['Boolean']>;
  isViewGuidanceEnabled?: InputMaybe<Scalars['Boolean']>;
  isAssigneeManagedViaIntegration?: InputMaybe<Scalars['Boolean']>;
  rfuModelType?: InputMaybe<CompanyRfuModelType>;
  reasonableAdjustmentsOption?: InputMaybe<ReasonableAdjustmentsOptionArgs>;
  assessmentExpiryOption?: InputMaybe<AssessmentExpiryOptionArgs>;
  managerReportId?: InputMaybe<Scalars['Int']>;
  candidateReportId?: InputMaybe<Scalars['Int']>;
  hideReports?: InputMaybe<Scalars['Boolean']>;
  atsPullJobsFromDate?: InputMaybe<Scalars['Date']>;
}>;


export type UpdateCompanyMutation = { __typename?: 'Mutation', Company: { __typename?: 'Company', id: number, name: string, logoUrl?: string | null, atsPullJobsFromDate: any, allowedEmailDomains?: Array<string> | null, areCognitiveTestsBlocked: boolean, areRffSoftSkillsDisabled: boolean, isInterviewGuideScoresEnabled: boolean, isLegalAcknowledgementsEnabled: boolean, isSkillsEvaluationScoreEnabled: boolean, isViewGuidanceEnabled: boolean, isAssigneeManagedViaIntegration: boolean, rfuModelType: CompanyRfuModelType, createdAt: string, hideReports: boolean, reasonableAdjustmentsOption: { __typename?: 'ReasonableAdjustmentsOption', kind: ReasonableAdjustmentsOptionKind, value?: string | null }, assessmentExpiryOption?: { __typename?: 'AssessmentExpiryOption', duration: number, unit: AssessmentExpiryOptionUnit } | null, managerReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, candidateReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null } };

export type CompanySignatureCreateOneMutationVariables = Exact<{
  companyId: Scalars['Int'];
  isDefault: Scalars['Boolean'];
  signature: Scalars['String'];
  signatureEmail: Scalars['String'];
}>;


export type CompanySignatureCreateOneMutation = { __typename?: 'Mutation', CompanySignature: { __typename?: 'CompanySignatureModel', id: number, companyId: number, isDefault: boolean, signature: string, signatureEmail: string } };

export type CompanySignatureUpdateOneMutationVariables = Exact<{
  id: Scalars['Int'];
  isDefault?: InputMaybe<Scalars['Boolean']>;
  signature?: InputMaybe<Scalars['String']>;
  signatureEmail?: InputMaybe<Scalars['String']>;
}>;


export type CompanySignatureUpdateOneMutation = { __typename?: 'Mutation', CompanySignature: { __typename?: 'CompanySignatureModel', id: number, companyId: number, isDefault: boolean, signature: string, signatureEmail: string } };

export type CompanySignatureDeleteOneMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CompanySignatureDeleteOneMutation = { __typename?: 'Mutation', CompanySignature: { __typename?: 'DeleteResult', affected?: number | null } };

export type CreateCompanyMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type CreateCompanyMutation = { __typename?: 'Mutation', company: { __typename?: 'Company', id: number, name: string, logoUrl?: string | null, atsPullJobsFromDate: any, allowedEmailDomains?: Array<string> | null, areCognitiveTestsBlocked: boolean, areRffSoftSkillsDisabled: boolean, isInterviewGuideScoresEnabled: boolean, isLegalAcknowledgementsEnabled: boolean, isSkillsEvaluationScoreEnabled: boolean, isViewGuidanceEnabled: boolean, isAssigneeManagedViaIntegration: boolean, rfuModelType: CompanyRfuModelType, createdAt: string, hideReports: boolean, reasonableAdjustmentsOption: { __typename?: 'ReasonableAdjustmentsOption', kind: ReasonableAdjustmentsOptionKind, value?: string | null }, assessmentExpiryOption?: { __typename?: 'AssessmentExpiryOption', duration: number, unit: AssessmentExpiryOptionUnit } | null, managerReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, candidateReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null } };

export type DeleteCompanyMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteCompanyMutation = { __typename?: 'Mutation', deleteCompany: boolean };

export type UploadCompanyLogoMutationVariables = Exact<{
  id: Scalars['Int'];
  file: Scalars['Upload'];
}>;


export type UploadCompanyLogoMutation = { __typename?: 'Mutation', uploadCompanyLogo: string };

export type CompanyAllowedEmailDomainsUpdateMutationVariables = Exact<{
  allowedEmailDomains: Array<Scalars['String']> | Scalars['String'];
  id: Scalars['Int'];
}>;


export type CompanyAllowedEmailDomainsUpdateMutation = { __typename?: 'Mutation', CompanyAllowedEmailDomainsUpdate: Array<string> };

export type CompanyCreateUserMutationVariables = Exact<{
  companyId: Scalars['Float'];
  email: Scalars['String'];
  externalId: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<SupportedLocale>;
  lastName?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<IdentityPermissionRole> | IdentityPermissionRole>;
  sendInvite: Scalars['Boolean'];
}>;


export type CompanyCreateUserMutation = { __typename?: 'Mutation', CompanyCreateUser: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } };

export type CompanyResendInviteMutationVariables = Exact<{
  userId: Scalars['Float'];
  companyId: Scalars['Float'];
}>;


export type CompanyResendInviteMutation = { __typename?: 'Mutation', CompanyResendInvite: boolean };

export type CompanyMaybeUserEmployeeFindManyQueryVariables = Exact<{
  companyId: Scalars['Float'];
}>;


export type CompanyMaybeUserEmployeeFindManyQuery = { __typename?: 'Query', CompanyMaybeUserEmployeeFindMany?: Array<{ __typename?: 'CompanyMaybeUserEmployeeModel', userId?: number | null, employeeId?: string | null, email: string, firstName: string, lastName: string, isUser: boolean, isCompanyEmployee: boolean }> | null };

export type CompanyEmployeeUpdateMutationVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']>;
  customFields?: InputMaybe<UserCompanyInfoCustomFieldsArgs>;
  department?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Date']>;
  firstName?: InputMaybe<Scalars['String']>;
  hrManagerEmployeeId?: InputMaybe<Scalars['String']>;
  id: Scalars['Float'];
  isArchived?: InputMaybe<Scalars['Boolean']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Date']>;
}>;


export type CompanyEmployeeUpdateMutation = { __typename?: 'Mutation', CompanyEmployeeUpdate: { __typename?: 'CompanyEmployeeModel', companyId: number, createdAt: any, customFields?: any | null, deletedAt?: any | null, department?: string | null, email: string, employeeId: string, endDate?: any | null, firstName: string, hrManagerEmployeeId?: string | null, id?: number | null, isArchived?: boolean | null, jobTitle?: string | null, lastName: string, startDate?: any | null, szUserId?: number | null, updatedAt: any } };

export type CompanyEmployeeDeleteOneMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CompanyEmployeeDeleteOneMutation = { __typename?: 'Mutation', CompanyEmployeeDeleteOne: { __typename?: 'DeleteResult', affected?: number | null } };

export type CompanyEmployeeCreateMutationVariables = Exact<{
  companyId: Scalars['Int'];
  customFields?: InputMaybe<UserCompanyInfoCustomFieldsArgs>;
  department?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  employeeId: Scalars['String'];
  endDate?: InputMaybe<Scalars['Date']>;
  firstName: Scalars['String'];
  hrManagerEmployeeId?: InputMaybe<Scalars['String']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  startDate?: InputMaybe<Scalars['Date']>;
}>;


export type CompanyEmployeeCreateMutation = { __typename?: 'Mutation', CompanyEmployeeCreate: { __typename?: 'CompanyEmployeeModel', companyId: number, createdAt: any, customFields?: any | null, deletedAt?: any | null, department?: string | null, email: string, employeeId: string, endDate?: any | null, firstName: string, hrManagerEmployeeId?: string | null, id?: number | null, isArchived?: boolean | null, jobTitle?: string | null, lastName: string, startDate?: any | null, szUserId?: number | null, updatedAt: any } };

export type CompanyRoleUpsertMutationVariables = Exact<{
  companyId: Scalars['Int'];
  roleId: Scalars['Int'];
  twoFactorEnabled: Scalars['Boolean'];
}>;


export type CompanyRoleUpsertMutation = { __typename?: 'Mutation', CompanyRoleUpsert: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } };

export type AdminResultsCsvFileExportMutationVariables = Exact<{
  stageIds: Array<Scalars['Int']> | Scalars['Int'];
  exportLevel?: InputMaybe<AdminResultsExportLevel>;
  scoreType?: InputMaybe<AdminResultsExportScoreType>;
  includeDeiData?: InputMaybe<Scalars['Boolean']>;
  includeFormsData?: InputMaybe<Scalars['Boolean']>;
}>;


export type AdminResultsCsvFileExportMutation = { __typename?: 'Mutation', AdminResultsCsvFileExport: { __typename?: 'FileExportScheduledTask', status: ScheduledTaskStatus, error?: string | null } };

export type InterviewGuideBlueprintQuestionAddSoftSkillMutationVariables = Exact<{
  questionSubId: Scalars['String'];
  softSkillId: Scalars['Int'];
  indicators?: InputMaybe<Array<SoftSkillIndicatorInput> | SoftSkillIndicatorInput>;
}>;


export type InterviewGuideBlueprintQuestionAddSoftSkillMutation = { __typename?: 'Mutation', InterviewGuideBlueprintQuestionAddSoftSkill: { __typename?: 'InterviewGuideBlueprintQuestionModel', id: string, subId: string, softSkillJunctions: Array<{ __typename?: 'InterviewGuideBlueprintQuestionSoftSkill', softSkill: { __typename?: 'BasicBroadSoftSkill', id: number, name: string } | { __typename?: 'BasicFocusedSoftSkill', id: number, name: string } | { __typename?: 'BroadSoftSkill', id: number, name: string } | { __typename?: 'FocusedSoftSkill', id: number, name: string }, indicators: Array<{ __typename: 'SoftSkillIndicatorV1', indicator: string, description: string, reason: string, probe: string, trigger: string } | { __typename: 'SoftSkillIndicatorV2', indicator: string, description: string, reason: string, probe: string, trigger: string, scores: Array<{ __typename?: 'SoftSkillIndicatorV2Score', score: number, label: string, gateway_criteria: Array<string>, differentiation: string }>, negative_evidence: { __typename?: 'SoftSkillIndicatorV2NegativeEvidence', red_flags: Array<{ __typename?: 'SoftSkillIndicatorV2Pattern', pattern: string, example: string }>, score_reducing_patterns: Array<{ __typename?: 'SoftSkillIndicatorV2Pattern', pattern: string, example: string }> } }> }> } };

export type InterviewGuideBlueprintQuestionRemoveSoftSkillMutationVariables = Exact<{
  questionSubId: Scalars['String'];
  softSkillId: Scalars['Int'];
}>;


export type InterviewGuideBlueprintQuestionRemoveSoftSkillMutation = { __typename?: 'Mutation', InterviewGuideBlueprintQuestionRemoveSoftSkill: { __typename?: 'InterviewGuideBlueprintQuestionModel', id: string, subId: string, softSkillJunctions: Array<{ __typename?: 'InterviewGuideBlueprintQuestionSoftSkill', softSkill: { __typename?: 'BasicBroadSoftSkill', id: number, name: string } | { __typename?: 'BasicFocusedSoftSkill', id: number, name: string } | { __typename?: 'BroadSoftSkill', id: number, name: string } | { __typename?: 'FocusedSoftSkill', id: number, name: string }, indicators: Array<{ __typename: 'SoftSkillIndicatorV1', indicator: string, description: string, reason: string, probe: string, trigger: string } | { __typename: 'SoftSkillIndicatorV2', indicator: string, description: string, reason: string, probe: string, trigger: string, scores: Array<{ __typename?: 'SoftSkillIndicatorV2Score', score: number, label: string, gateway_criteria: Array<string>, differentiation: string }>, negative_evidence: { __typename?: 'SoftSkillIndicatorV2NegativeEvidence', red_flags: Array<{ __typename?: 'SoftSkillIndicatorV2Pattern', pattern: string, example: string }>, score_reducing_patterns: Array<{ __typename?: 'SoftSkillIndicatorV2Pattern', pattern: string, example: string }> } }> }> } };

export type InterviewGuideBlueprintQuestionUpdateSoftSkillMutationVariables = Exact<{
  questionSubId: Scalars['String'];
  softSkillId: Scalars['Int'];
  indicators: Array<SoftSkillIndicatorInput> | SoftSkillIndicatorInput;
}>;


export type InterviewGuideBlueprintQuestionUpdateSoftSkillMutation = { __typename?: 'Mutation', InterviewGuideBlueprintQuestionUpdateSoftSkill: { __typename?: 'InterviewGuideBlueprintQuestionModel', id: string, subId: string, softSkillJunctions: Array<{ __typename?: 'InterviewGuideBlueprintQuestionSoftSkill', softSkill: { __typename?: 'BasicBroadSoftSkill', id: number, name: string } | { __typename?: 'BasicFocusedSoftSkill', id: number, name: string } | { __typename?: 'BroadSoftSkill', id: number, name: string } | { __typename?: 'FocusedSoftSkill', id: number, name: string }, indicators: Array<{ __typename: 'SoftSkillIndicatorV1', indicator: string, description: string, reason: string, probe: string, trigger: string } | { __typename: 'SoftSkillIndicatorV2', indicator: string, description: string, reason: string, probe: string, trigger: string, scores: Array<{ __typename?: 'SoftSkillIndicatorV2Score', score: number, label: string, gateway_criteria: Array<string>, differentiation: string }>, negative_evidence: { __typename?: 'SoftSkillIndicatorV2NegativeEvidence', red_flags: Array<{ __typename?: 'SoftSkillIndicatorV2Pattern', pattern: string, example: string }>, score_reducing_patterns: Array<{ __typename?: 'SoftSkillIndicatorV2Pattern', pattern: string, example: string }> } }> }> } };

export type SaveInterviewQuestionContentMutationVariables = Exact<{
  id: Scalars['Int'];
  summary: Scalars['String'];
  feedback: Scalars['String'];
  reasonForQuestion: Scalars['String'];
  mainQuestion: Scalars['String'];
  subQuestions: Array<Scalars['String']> | Scalars['String'];
}>;


export type SaveInterviewQuestionContentMutation = { __typename?: 'Mutation', interviewQuestionContent?: { __typename?: 'InterviewQuestionRoleLevel', id: number, softSkillId: number, traitId: number, classification: ContentClassification, roleLevel: ContentRoleLevel, summary?: string | null, feedback?: string | null, reasonForQuestion?: string | null, mainQuestion?: string | null, subQuestions?: Array<string> | null, softSkill: { __typename?: 'BasicBroadSoftSkill', name: string } | { __typename?: 'BasicFocusedSoftSkill', name: string } | { __typename?: 'BroadSoftSkill', name: string } | { __typename?: 'FocusedSoftSkill', name: string }, trait?: { __typename?: 'Trait', name: string } | null } | null };

export type InterviewQuestionRoleLevelContentUploadMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type InterviewQuestionRoleLevelContentUploadMutation = { __typename?: 'Mutation', InterviewQuestionRoleLevelContentUpload: { __typename?: 'InterviewQuestionRoleLevelContentUploadModel', errorMessages?: Array<string> | null, apply: boolean, errors?: Array<{ __typename?: 'InterviewQuestionRoleLevelContentUploadLineModel', softSkillSlug: string, traitSlug: string, summary: string, roleLevel: ContentRoleLevel, classification: ContentClassification, reasonForQuestion: string, feedback: string, mainQuestion: string, subQuestion1: string, subQuestion2: string, subQuestion3: string }> | null, creates?: Array<{ __typename?: 'InterviewQuestionRoleLevelContentUploadLineModel', softSkillSlug: string, traitSlug: string }> | null } };

export type InterviewStageDeleteMutationVariables = Exact<{
  subId: Scalars['ID'];
}>;


export type InterviewStageDeleteMutation = { __typename?: 'Mutation', InterviewStageDelete: boolean };

export type InterviewStageUpdateMutationVariables = Exact<{
  subId: Scalars['ID'];
  data: InterviewStageUpdateData;
}>;


export type InterviewStageUpdateMutation = { __typename?: 'Mutation', InterviewStageUpdate: { __typename?: 'InterviewStage', subId: string, projectId: number, createdAt: any, duration: number, name: string, focus: InterviewStageFocus, softSkills: Array<{ __typename?: 'BasicBroadSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'BasicFocusedSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'BroadSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'FocusedSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory }>, technicalSkills: Array<{ __typename?: 'TechnicalSkill', id: number, subId: string, name: string }> } };

export type OverwriteInterviewStageSkillsMutationVariables = Exact<{
  id: Scalars['ID'];
  skillsProfileId: Scalars['Int'];
  softSkillIds: Array<Scalars['Int']> | Scalars['Int'];
  technicalSkillIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type OverwriteInterviewStageSkillsMutation = { __typename?: 'Mutation', OverwriteInterviewStageSkills: { __typename?: 'InterviewStage', subId: string, projectId: number, createdAt: any, duration: number, name: string, focus: InterviewStageFocus, softSkills: Array<{ __typename?: 'BasicBroadSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'BasicFocusedSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'BroadSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'FocusedSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory }>, technicalSkills: Array<{ __typename?: 'TechnicalSkill', id: number, subId: string, name: string }> } };

export type ProjectCandidateInviteManyMutationVariables = Exact<{
  projectSubId: Scalars['ID'];
  assessmentStageSubId: Scalars['ID'];
  userDetails: ProjectCandidateUserDetails;
  settings: ProjectCandidateInvitationSettings;
}>;


export type ProjectCandidateInviteManyMutation = { __typename?: 'Mutation', ProjectCandidateInviteMany: Array<{ __typename?: 'ProjectCandidate', subId: string }> };

export type JobRoleCreateOneMutationVariables = Exact<{
  companyId: Scalars['Int'];
  name: Scalars['String'];
  qualifier?: InputMaybe<Scalars['String']>;
  roleLevel: ContentRoleLevel;
  family?: InputMaybe<JobRoleFamily>;
}>;


export type JobRoleCreateOneMutation = { __typename?: 'Mutation', JobRoleCreateOne: { __typename?: 'JobRoleModel', companyId: number, createdAt: any, deletedAt?: any | null, id: number, name: string, qualifier?: string | null, roleLevel: ContentRoleLevel, updatedAt: any, family?: JobRoleFamily | null, skillsProfiles: Array<{ __typename?: 'SuccessProfile', calculationMethod: CalculationMethod, createdAt: any, deletedAt?: any | null, gradingMethod: GradingMethod, id: number, jobRoleId: number, status: SuccessProfileStatus, updatedAt: any, successProfileTechnicalSkills?: Array<{ __typename?: 'SuccessProfileTechnicalSkill', id: number, successProfileId: number, technicalSkillId: number, technicalSkill?: { __typename?: 'TechnicalSkill', id: number, name: string, subId: string } | null }> | null, successProfileSoftSkills?: Array<{ __typename?: 'SuccessProfileSoftSkill', id: number, softSkillId: number, type: SoftSkillType, name: string, weight: number, includeInCalibration: boolean, softSkill: { __typename?: 'BasicBroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BasicFocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, focusedSoftSkills: Array<{ __typename?: 'BasicFocusedSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'FocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, broadSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null }, successProfileSoftSkillTraits: Array<{ __typename?: 'SuccessProfileSoftSkillTrait', id: number, orientation?: number | null, traitId: number, weight: number, name?: string | null }>, successProfileSoftSkillDataSources?: Array<{ __typename?: 'SuccessProfileSoftSkillDataSource', id: number, dataSourceType: DataSourceType, softSkillType: SoftSkillType }> | null }> | null }> } };

export type JobRoleUpdateOneMutationVariables = Exact<{
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  qualifier?: InputMaybe<Scalars['String']>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
  family?: InputMaybe<JobRoleFamily>;
}>;


export type JobRoleUpdateOneMutation = { __typename?: 'Mutation', JobRoleUpdateOne: { __typename?: 'JobRoleModel', companyId: number, createdAt: any, deletedAt?: any | null, id: number, name: string, qualifier?: string | null, roleLevel: ContentRoleLevel, updatedAt: any, family?: JobRoleFamily | null, skillsProfiles: Array<{ __typename?: 'SuccessProfile', calculationMethod: CalculationMethod, createdAt: any, deletedAt?: any | null, gradingMethod: GradingMethod, id: number, jobRoleId: number, status: SuccessProfileStatus, updatedAt: any, successProfileTechnicalSkills?: Array<{ __typename?: 'SuccessProfileTechnicalSkill', id: number, successProfileId: number, technicalSkillId: number, technicalSkill?: { __typename?: 'TechnicalSkill', id: number, name: string, subId: string } | null }> | null, successProfileSoftSkills?: Array<{ __typename?: 'SuccessProfileSoftSkill', id: number, softSkillId: number, type: SoftSkillType, name: string, weight: number, includeInCalibration: boolean, softSkill: { __typename?: 'BasicBroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BasicFocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, focusedSoftSkills: Array<{ __typename?: 'BasicFocusedSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'FocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, broadSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null }, successProfileSoftSkillTraits: Array<{ __typename?: 'SuccessProfileSoftSkillTrait', id: number, orientation?: number | null, traitId: number, weight: number, name?: string | null }>, successProfileSoftSkillDataSources?: Array<{ __typename?: 'SuccessProfileSoftSkillDataSource', id: number, dataSourceType: DataSourceType, softSkillType: SoftSkillType }> | null }> | null }> } };

export type JobRoleDuplicateMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type JobRoleDuplicateMutation = { __typename?: 'Mutation', JobRoleDuplicate: { __typename?: 'JobRoleModel', companyId: number, createdAt: any, deletedAt?: any | null, id: number, name: string, qualifier?: string | null, roleLevel: ContentRoleLevel, updatedAt: any, family?: JobRoleFamily | null, skillsProfiles: Array<{ __typename?: 'SuccessProfile', calculationMethod: CalculationMethod, createdAt: any, deletedAt?: any | null, gradingMethod: GradingMethod, id: number, jobRoleId: number, status: SuccessProfileStatus, updatedAt: any, successProfileTechnicalSkills?: Array<{ __typename?: 'SuccessProfileTechnicalSkill', id: number, successProfileId: number, technicalSkillId: number, technicalSkill?: { __typename?: 'TechnicalSkill', id: number, name: string, subId: string } | null }> | null, successProfileSoftSkills?: Array<{ __typename?: 'SuccessProfileSoftSkill', id: number, softSkillId: number, type: SoftSkillType, name: string, weight: number, includeInCalibration: boolean, softSkill: { __typename?: 'BasicBroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BasicFocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, focusedSoftSkills: Array<{ __typename?: 'BasicFocusedSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'FocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, broadSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null }, successProfileSoftSkillTraits: Array<{ __typename?: 'SuccessProfileSoftSkillTrait', id: number, orientation?: number | null, traitId: number, weight: number, name?: string | null }>, successProfileSoftSkillDataSources?: Array<{ __typename?: 'SuccessProfileSoftSkillDataSource', id: number, dataSourceType: DataSourceType, softSkillType: SoftSkillType }> | null }> | null }> } };

export type KomboSetAssessmentPackagesMutationVariables = Exact<{
  companyId: Scalars['Int'];
}>;


export type KomboSetAssessmentPackagesMutation = { __typename?: 'Mutation', komboSetAssessmentPackages: boolean };

export type ProjectSetCompanySignatureMutationVariables = Exact<{
  companySignatureId?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['Int'];
}>;


export type ProjectSetCompanySignatureMutation = { __typename?: 'Mutation', Project: { __typename?: 'Project', id: number, companySignatureId?: number | null } };

export type EditProjectStateMutationVariables = Exact<{
  id: Scalars['Int'];
  state: Scalars['Boolean'];
}>;


export type EditProjectStateMutation = { __typename?: 'Mutation', project: { __typename?: 'Project', companySignatureId?: number | null, createdAt: string, creatorId?: number | null, publishedAt?: any | null, source: ProjectSource, id: number, isArchived: boolean, isStopped: boolean, locales: Array<SupportedLocale>, primaryLocale: SupportedLocale, moduleType: ProjectModuleType, name: string, requireSheetsExport: boolean, updatedAt: string, version: number, productSolution?: ProductSolution | null, subId: string, indirectInviteSSOEnabled?: boolean | null, isIntegrityMonitoringEnabled: boolean, isAiInterviewScoreHidden: boolean, status: ProjectStatus, projectCandidatesCount: number, company?: { __typename?: 'ProjectCompany', id: number, name: string, logoUrl?: string | null } | null, publishedBy?: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } | null, teamMembers?: Array<{ __typename?: 'ProjectManager', email?: string | null, firstName?: string | null, id: number, lastName?: string | null, userId?: number | null }> | null, assessmentStagesV2: Array<{ __typename?: 'AssessmentStage', id: string, name: string, kind: AssessmentStageKind, startTime?: any | null, endTime?: any | null, cognitiveMode: CognitiveMode, createdAt: any, updatedAt: any, deletedAt?: any | null, assessmentExpiryOption?: { __typename?: 'AssessmentExpiryOption', duration: number, unit: AssessmentExpiryOptionUnit } | null, emailSettings: { __typename?: 'AssessmentStageEmailSettings', emailCandidateReport: boolean, managerReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, candidateReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, projectTeamEmailSettings: { __typename?: 'ProjectTeamEmailSettings', mode: ProjectTeamEmailMode, actorRoles: Array<ActorRole> } }, actions: { __typename?: 'AssessmentStageActions', aiInterview?: { __typename?: 'AiInterviewAssessmentStageAction', id: string, name: string, duration: number, livekitAgentName: LivekitAgentName, isAvatarEnabled: boolean, isTimingAgentEnabled: boolean } | null, dei?: { __typename?: 'DeiStageActionModel', completedCount: number, submittedCount: number, createdAt: any, deletedAt?: any | null, stageId: number, updatedAt: any, fields: { __typename?: 'DeiStageActionFieldsModel', hasAgeRangeField: boolean, hasDisabilityField: boolean, hasEthnicityField: boolean, hasGenderIdentityField: boolean, hasNeurodiversityField: boolean, hasReligiousBeliefsField: boolean, hasSexualOrientationField: boolean, hasDisabilityIdentifyField: boolean, hasNeurodivergenceIdentifyField: boolean, hasFreeSchoolMealsField: boolean } } | null, personalityTest?: { __typename?: 'PersonalityTestAssessmentStageActionNested', id: string, questionsPerTraitCount: number, selectedLocales: Array<SupportedLocale> } | null, cognitiveTests: Array<{ __typename?: 'CognitiveTestAssessmentStageActionNested', id: string, kind: CognitiveKind, sectionCount: number }>, roleSkillSelfAssessments: Array<{ __typename?: 'RssAssessmentModel', id: number, type: RssAssessmentType, stageId: number }>, coderbyte?: { __typename?: 'CoderbyteAssessmentStageActionNested', id: string, name: string, coderbyteTestId: string, details: { __typename?: 'CoderbyteAssessmentStageActionDetails', timeLimitInMinutes?: number | null, isFrozen: boolean, challengeCount?: number | null, multipleChoiceCount?: number | null } } | null, englishProficiency?: { __typename?: 'EnglishProficiencyAssessmentStageActionNested', id: string, requiredCefrLevel: CefrLevel } | null }, availableActions: Array<{ __typename?: 'StageAvailableActionModel', availability: StageActionAvailability, name: string, kind: AssessmentStageActionKind }> }>, interviewStages: Array<{ __typename?: 'InterviewStage', subId: string, projectId: number, createdAt: any, duration: number, name: string, focus: InterviewStageFocus, softSkills: Array<{ __typename?: 'BasicBroadSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'BasicFocusedSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'BroadSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'FocusedSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory }>, technicalSkills: Array<{ __typename?: 'TechnicalSkill', id: number, subId: string, name: string }> }>, creator?: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } | null, updatedBy?: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } | null } };

export type EditProjectArchivingMutationVariables = Exact<{
  id: Scalars['Int'];
  state: Scalars['Boolean'];
}>;


export type EditProjectArchivingMutation = { __typename?: 'Mutation', project: { __typename?: 'Project', companySignatureId?: number | null, createdAt: string, creatorId?: number | null, publishedAt?: any | null, source: ProjectSource, id: number, isArchived: boolean, isStopped: boolean, locales: Array<SupportedLocale>, primaryLocale: SupportedLocale, moduleType: ProjectModuleType, name: string, requireSheetsExport: boolean, updatedAt: string, version: number, productSolution?: ProductSolution | null, subId: string, indirectInviteSSOEnabled?: boolean | null, isIntegrityMonitoringEnabled: boolean, isAiInterviewScoreHidden: boolean, status: ProjectStatus, projectCandidatesCount: number, company?: { __typename?: 'ProjectCompany', id: number, name: string, logoUrl?: string | null } | null, publishedBy?: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } | null, teamMembers?: Array<{ __typename?: 'ProjectManager', email?: string | null, firstName?: string | null, id: number, lastName?: string | null, userId?: number | null }> | null, assessmentStagesV2: Array<{ __typename?: 'AssessmentStage', id: string, name: string, kind: AssessmentStageKind, startTime?: any | null, endTime?: any | null, cognitiveMode: CognitiveMode, createdAt: any, updatedAt: any, deletedAt?: any | null, assessmentExpiryOption?: { __typename?: 'AssessmentExpiryOption', duration: number, unit: AssessmentExpiryOptionUnit } | null, emailSettings: { __typename?: 'AssessmentStageEmailSettings', emailCandidateReport: boolean, managerReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, candidateReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, projectTeamEmailSettings: { __typename?: 'ProjectTeamEmailSettings', mode: ProjectTeamEmailMode, actorRoles: Array<ActorRole> } }, actions: { __typename?: 'AssessmentStageActions', aiInterview?: { __typename?: 'AiInterviewAssessmentStageAction', id: string, name: string, duration: number, livekitAgentName: LivekitAgentName, isAvatarEnabled: boolean, isTimingAgentEnabled: boolean } | null, dei?: { __typename?: 'DeiStageActionModel', completedCount: number, submittedCount: number, createdAt: any, deletedAt?: any | null, stageId: number, updatedAt: any, fields: { __typename?: 'DeiStageActionFieldsModel', hasAgeRangeField: boolean, hasDisabilityField: boolean, hasEthnicityField: boolean, hasGenderIdentityField: boolean, hasNeurodiversityField: boolean, hasReligiousBeliefsField: boolean, hasSexualOrientationField: boolean, hasDisabilityIdentifyField: boolean, hasNeurodivergenceIdentifyField: boolean, hasFreeSchoolMealsField: boolean } } | null, personalityTest?: { __typename?: 'PersonalityTestAssessmentStageActionNested', id: string, questionsPerTraitCount: number, selectedLocales: Array<SupportedLocale> } | null, cognitiveTests: Array<{ __typename?: 'CognitiveTestAssessmentStageActionNested', id: string, kind: CognitiveKind, sectionCount: number }>, roleSkillSelfAssessments: Array<{ __typename?: 'RssAssessmentModel', id: number, type: RssAssessmentType, stageId: number }>, coderbyte?: { __typename?: 'CoderbyteAssessmentStageActionNested', id: string, name: string, coderbyteTestId: string, details: { __typename?: 'CoderbyteAssessmentStageActionDetails', timeLimitInMinutes?: number | null, isFrozen: boolean, challengeCount?: number | null, multipleChoiceCount?: number | null } } | null, englishProficiency?: { __typename?: 'EnglishProficiencyAssessmentStageActionNested', id: string, requiredCefrLevel: CefrLevel } | null }, availableActions: Array<{ __typename?: 'StageAvailableActionModel', availability: StageActionAvailability, name: string, kind: AssessmentStageActionKind }> }>, interviewStages: Array<{ __typename?: 'InterviewStage', subId: string, projectId: number, createdAt: any, duration: number, name: string, focus: InterviewStageFocus, softSkills: Array<{ __typename?: 'BasicBroadSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'BasicFocusedSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'BroadSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'FocusedSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory }>, technicalSkills: Array<{ __typename?: 'TechnicalSkill', id: number, subId: string, name: string }> }>, creator?: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } | null, updatedBy?: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } | null } };

export type CreateProjectMutationVariables = Exact<{
  name: Scalars['String'];
  companyId: Scalars['Float'];
  managers?: InputMaybe<Array<CreateProjectManagerInput> | CreateProjectManagerInput>;
  moduleType?: InputMaybe<ProjectModuleType>;
  requireSheetsExport?: InputMaybe<Scalars['Boolean']>;
  productSolution: ProductSolution;
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', project: { __typename?: 'Project', companySignatureId?: number | null, createdAt: string, creatorId?: number | null, publishedAt?: any | null, source: ProjectSource, id: number, isArchived: boolean, isStopped: boolean, locales: Array<SupportedLocale>, primaryLocale: SupportedLocale, moduleType: ProjectModuleType, name: string, requireSheetsExport: boolean, updatedAt: string, version: number, productSolution?: ProductSolution | null, subId: string, indirectInviteSSOEnabled?: boolean | null, isIntegrityMonitoringEnabled: boolean, isAiInterviewScoreHidden: boolean, status: ProjectStatus, projectCandidatesCount: number, company?: { __typename?: 'ProjectCompany', id: number, name: string, logoUrl?: string | null } | null, publishedBy?: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } | null, teamMembers?: Array<{ __typename?: 'ProjectManager', email?: string | null, firstName?: string | null, id: number, lastName?: string | null, userId?: number | null }> | null, assessmentStagesV2: Array<{ __typename?: 'AssessmentStage', id: string, name: string, kind: AssessmentStageKind, startTime?: any | null, endTime?: any | null, cognitiveMode: CognitiveMode, createdAt: any, updatedAt: any, deletedAt?: any | null, assessmentExpiryOption?: { __typename?: 'AssessmentExpiryOption', duration: number, unit: AssessmentExpiryOptionUnit } | null, emailSettings: { __typename?: 'AssessmentStageEmailSettings', emailCandidateReport: boolean, managerReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, candidateReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, projectTeamEmailSettings: { __typename?: 'ProjectTeamEmailSettings', mode: ProjectTeamEmailMode, actorRoles: Array<ActorRole> } }, actions: { __typename?: 'AssessmentStageActions', aiInterview?: { __typename?: 'AiInterviewAssessmentStageAction', id: string, name: string, duration: number, livekitAgentName: LivekitAgentName, isAvatarEnabled: boolean, isTimingAgentEnabled: boolean } | null, dei?: { __typename?: 'DeiStageActionModel', completedCount: number, submittedCount: number, createdAt: any, deletedAt?: any | null, stageId: number, updatedAt: any, fields: { __typename?: 'DeiStageActionFieldsModel', hasAgeRangeField: boolean, hasDisabilityField: boolean, hasEthnicityField: boolean, hasGenderIdentityField: boolean, hasNeurodiversityField: boolean, hasReligiousBeliefsField: boolean, hasSexualOrientationField: boolean, hasDisabilityIdentifyField: boolean, hasNeurodivergenceIdentifyField: boolean, hasFreeSchoolMealsField: boolean } } | null, personalityTest?: { __typename?: 'PersonalityTestAssessmentStageActionNested', id: string, questionsPerTraitCount: number, selectedLocales: Array<SupportedLocale> } | null, cognitiveTests: Array<{ __typename?: 'CognitiveTestAssessmentStageActionNested', id: string, kind: CognitiveKind, sectionCount: number }>, roleSkillSelfAssessments: Array<{ __typename?: 'RssAssessmentModel', id: number, type: RssAssessmentType, stageId: number }>, coderbyte?: { __typename?: 'CoderbyteAssessmentStageActionNested', id: string, name: string, coderbyteTestId: string, details: { __typename?: 'CoderbyteAssessmentStageActionDetails', timeLimitInMinutes?: number | null, isFrozen: boolean, challengeCount?: number | null, multipleChoiceCount?: number | null } } | null, englishProficiency?: { __typename?: 'EnglishProficiencyAssessmentStageActionNested', id: string, requiredCefrLevel: CefrLevel } | null }, availableActions: Array<{ __typename?: 'StageAvailableActionModel', availability: StageActionAvailability, name: string, kind: AssessmentStageActionKind }> }>, interviewStages: Array<{ __typename?: 'InterviewStage', subId: string, projectId: number, createdAt: any, duration: number, name: string, focus: InterviewStageFocus, softSkills: Array<{ __typename?: 'BasicBroadSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'BasicFocusedSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'BroadSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'FocusedSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory }>, technicalSkills: Array<{ __typename?: 'TechnicalSkill', id: number, subId: string, name: string }> }>, creator?: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } | null, updatedBy?: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } | null } };

export type EditProjectMutationVariables = Exact<{
  id: Scalars['Int'];
  name: Scalars['String'];
  companyId: Scalars['Float'];
  managers?: InputMaybe<Array<CreateProjectManagerInput> | CreateProjectManagerInput>;
  requireSheetsExport?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<SupportedLocale> | SupportedLocale>;
  primaryLocale?: InputMaybe<SupportedLocale>;
  productSolution?: InputMaybe<ProductSolution>;
  isAiInterviewScoreHidden?: InputMaybe<Scalars['Boolean']>;
}>;


export type EditProjectMutation = { __typename?: 'Mutation', project: { __typename?: 'Project', companySignatureId?: number | null, createdAt: string, creatorId?: number | null, publishedAt?: any | null, source: ProjectSource, id: number, isArchived: boolean, isStopped: boolean, locales: Array<SupportedLocale>, primaryLocale: SupportedLocale, moduleType: ProjectModuleType, name: string, requireSheetsExport: boolean, updatedAt: string, version: number, productSolution?: ProductSolution | null, subId: string, indirectInviteSSOEnabled?: boolean | null, isIntegrityMonitoringEnabled: boolean, isAiInterviewScoreHidden: boolean, status: ProjectStatus, projectCandidatesCount: number, company?: { __typename?: 'ProjectCompany', id: number, name: string, logoUrl?: string | null } | null, publishedBy?: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } | null, teamMembers?: Array<{ __typename?: 'ProjectManager', email?: string | null, firstName?: string | null, id: number, lastName?: string | null, userId?: number | null }> | null, assessmentStagesV2: Array<{ __typename?: 'AssessmentStage', id: string, name: string, kind: AssessmentStageKind, startTime?: any | null, endTime?: any | null, cognitiveMode: CognitiveMode, createdAt: any, updatedAt: any, deletedAt?: any | null, assessmentExpiryOption?: { __typename?: 'AssessmentExpiryOption', duration: number, unit: AssessmentExpiryOptionUnit } | null, emailSettings: { __typename?: 'AssessmentStageEmailSettings', emailCandidateReport: boolean, managerReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, candidateReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, projectTeamEmailSettings: { __typename?: 'ProjectTeamEmailSettings', mode: ProjectTeamEmailMode, actorRoles: Array<ActorRole> } }, actions: { __typename?: 'AssessmentStageActions', aiInterview?: { __typename?: 'AiInterviewAssessmentStageAction', id: string, name: string, duration: number, livekitAgentName: LivekitAgentName, isAvatarEnabled: boolean, isTimingAgentEnabled: boolean } | null, dei?: { __typename?: 'DeiStageActionModel', completedCount: number, submittedCount: number, createdAt: any, deletedAt?: any | null, stageId: number, updatedAt: any, fields: { __typename?: 'DeiStageActionFieldsModel', hasAgeRangeField: boolean, hasDisabilityField: boolean, hasEthnicityField: boolean, hasGenderIdentityField: boolean, hasNeurodiversityField: boolean, hasReligiousBeliefsField: boolean, hasSexualOrientationField: boolean, hasDisabilityIdentifyField: boolean, hasNeurodivergenceIdentifyField: boolean, hasFreeSchoolMealsField: boolean } } | null, personalityTest?: { __typename?: 'PersonalityTestAssessmentStageActionNested', id: string, questionsPerTraitCount: number, selectedLocales: Array<SupportedLocale> } | null, cognitiveTests: Array<{ __typename?: 'CognitiveTestAssessmentStageActionNested', id: string, kind: CognitiveKind, sectionCount: number }>, roleSkillSelfAssessments: Array<{ __typename?: 'RssAssessmentModel', id: number, type: RssAssessmentType, stageId: number }>, coderbyte?: { __typename?: 'CoderbyteAssessmentStageActionNested', id: string, name: string, coderbyteTestId: string, details: { __typename?: 'CoderbyteAssessmentStageActionDetails', timeLimitInMinutes?: number | null, isFrozen: boolean, challengeCount?: number | null, multipleChoiceCount?: number | null } } | null, englishProficiency?: { __typename?: 'EnglishProficiencyAssessmentStageActionNested', id: string, requiredCefrLevel: CefrLevel } | null }, availableActions: Array<{ __typename?: 'StageAvailableActionModel', availability: StageActionAvailability, name: string, kind: AssessmentStageActionKind }> }>, interviewStages: Array<{ __typename?: 'InterviewStage', subId: string, projectId: number, createdAt: any, duration: number, name: string, focus: InterviewStageFocus, softSkills: Array<{ __typename?: 'BasicBroadSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'BasicFocusedSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'BroadSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'FocusedSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory }>, technicalSkills: Array<{ __typename?: 'TechnicalSkill', id: number, subId: string, name: string }> }>, creator?: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } | null, updatedBy?: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } | null } };

export type ProjectUpdateStatusMutationVariables = Exact<{
  projectId: Scalars['Int'];
  status: ProjectStatus;
}>;


export type ProjectUpdateStatusMutation = { __typename?: 'Mutation', ProjectUpdateStatus: { __typename?: 'Project', companySignatureId?: number | null, createdAt: string, creatorId?: number | null, publishedAt?: any | null, source: ProjectSource, id: number, isArchived: boolean, isStopped: boolean, locales: Array<SupportedLocale>, primaryLocale: SupportedLocale, moduleType: ProjectModuleType, name: string, requireSheetsExport: boolean, updatedAt: string, version: number, productSolution?: ProductSolution | null, subId: string, indirectInviteSSOEnabled?: boolean | null, isIntegrityMonitoringEnabled: boolean, isAiInterviewScoreHidden: boolean, status: ProjectStatus, projectCandidatesCount: number, company?: { __typename?: 'ProjectCompany', id: number, name: string, logoUrl?: string | null } | null, publishedBy?: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } | null, teamMembers?: Array<{ __typename?: 'ProjectManager', email?: string | null, firstName?: string | null, id: number, lastName?: string | null, userId?: number | null }> | null, assessmentStagesV2: Array<{ __typename?: 'AssessmentStage', id: string, name: string, kind: AssessmentStageKind, startTime?: any | null, endTime?: any | null, cognitiveMode: CognitiveMode, createdAt: any, updatedAt: any, deletedAt?: any | null, assessmentExpiryOption?: { __typename?: 'AssessmentExpiryOption', duration: number, unit: AssessmentExpiryOptionUnit } | null, emailSettings: { __typename?: 'AssessmentStageEmailSettings', emailCandidateReport: boolean, managerReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, candidateReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, projectTeamEmailSettings: { __typename?: 'ProjectTeamEmailSettings', mode: ProjectTeamEmailMode, actorRoles: Array<ActorRole> } }, actions: { __typename?: 'AssessmentStageActions', aiInterview?: { __typename?: 'AiInterviewAssessmentStageAction', id: string, name: string, duration: number, livekitAgentName: LivekitAgentName, isAvatarEnabled: boolean, isTimingAgentEnabled: boolean } | null, dei?: { __typename?: 'DeiStageActionModel', completedCount: number, submittedCount: number, createdAt: any, deletedAt?: any | null, stageId: number, updatedAt: any, fields: { __typename?: 'DeiStageActionFieldsModel', hasAgeRangeField: boolean, hasDisabilityField: boolean, hasEthnicityField: boolean, hasGenderIdentityField: boolean, hasNeurodiversityField: boolean, hasReligiousBeliefsField: boolean, hasSexualOrientationField: boolean, hasDisabilityIdentifyField: boolean, hasNeurodivergenceIdentifyField: boolean, hasFreeSchoolMealsField: boolean } } | null, personalityTest?: { __typename?: 'PersonalityTestAssessmentStageActionNested', id: string, questionsPerTraitCount: number, selectedLocales: Array<SupportedLocale> } | null, cognitiveTests: Array<{ __typename?: 'CognitiveTestAssessmentStageActionNested', id: string, kind: CognitiveKind, sectionCount: number }>, roleSkillSelfAssessments: Array<{ __typename?: 'RssAssessmentModel', id: number, type: RssAssessmentType, stageId: number }>, coderbyte?: { __typename?: 'CoderbyteAssessmentStageActionNested', id: string, name: string, coderbyteTestId: string, details: { __typename?: 'CoderbyteAssessmentStageActionDetails', timeLimitInMinutes?: number | null, isFrozen: boolean, challengeCount?: number | null, multipleChoiceCount?: number | null } } | null, englishProficiency?: { __typename?: 'EnglishProficiencyAssessmentStageActionNested', id: string, requiredCefrLevel: CefrLevel } | null }, availableActions: Array<{ __typename?: 'StageAvailableActionModel', availability: StageActionAvailability, name: string, kind: AssessmentStageActionKind }> }>, interviewStages: Array<{ __typename?: 'InterviewStage', subId: string, projectId: number, createdAt: any, duration: number, name: string, focus: InterviewStageFocus, softSkills: Array<{ __typename?: 'BasicBroadSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'BasicFocusedSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'BroadSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'FocusedSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory }>, technicalSkills: Array<{ __typename?: 'TechnicalSkill', id: number, subId: string, name: string }> }>, creator?: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } | null, updatedBy?: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } | null } };

export type ProjectAddInterviewStageMutationVariables = Exact<{
  subId: Scalars['ID'];
  duration?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  focus: InterviewStageFocus;
}>;


export type ProjectAddInterviewStageMutation = { __typename?: 'Mutation', ProjectAddInterviewStage: { __typename?: 'Project', id: number, interviewStages: Array<{ __typename?: 'InterviewStage', subId: string, projectId: number, createdAt: any, duration: number, name: string, focus: InterviewStageFocus, softSkills: Array<{ __typename?: 'BasicBroadSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'BasicFocusedSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'BroadSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'FocusedSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory }>, technicalSkills: Array<{ __typename?: 'TechnicalSkill', id: number, subId: string, name: string }> }> } };

export type SetProjectCobrandingMutationVariables = Exact<{
  projectId: Scalars['Int'];
  cobrandingEnabled: Scalars['Boolean'];
}>;


export type SetProjectCobrandingMutation = { __typename?: 'Mutation', setProjectCobranding: boolean };

export type ProjectCollaboratorsCreateManyMutationVariables = Exact<{
  collaborators: Array<ProjectCollaboratorCreateOneArgs> | ProjectCollaboratorCreateOneArgs;
}>;


export type ProjectCollaboratorsCreateManyMutation = { __typename?: 'Mutation', collaborators: Array<{ __typename?: 'ProjectCollaboratorRole', id: number, userId?: number | null, groupId?: number | null, actorRole?: ActorRole | null, projectId: number }> };

export type ProjectCollaboratorsUpdateRoleMutationVariables = Exact<{
  actorRole?: InputMaybe<ActorRole>;
  collaboratorId: Scalars['Int'];
}>;


export type ProjectCollaboratorsUpdateRoleMutation = { __typename?: 'Mutation', update: { __typename?: 'ProjectCollaboratorRole', id: number, projectId: number, userId?: number | null, groupId?: number | null, actorRole?: ActorRole | null } };

export type ProjectCollaboratorsDeleteManyMutationVariables = Exact<{
  collaborators: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type ProjectCollaboratorsDeleteManyMutation = { __typename?: 'Mutation', deleted: Array<{ __typename?: 'ProjectCollaboratorDeleteManyResult', status: string, error?: string | null }> };

export type ProjectJobRoleCreateOneMutationVariables = Exact<{
  jobRoleId: Scalars['Int'];
  projectId: Scalars['Int'];
  skillsProfileId: Scalars['Int'];
}>;


export type ProjectJobRoleCreateOneMutation = { __typename?: 'Mutation', ProjectJobRoleCreateOne: { __typename?: 'ProjectJobRoleModel', id: number, createdAt: any, skillsProfileId: number, isLocalizedBenchmarkGroup?: boolean | null, isMainRole: boolean, jobRole: { __typename?: 'JobRoleModel', name: string, id: number, roleLevel: ContentRoleLevel, family?: JobRoleFamily | null, skillsProfiles: Array<{ __typename?: 'SuccessProfile', id: number, successProfileTechnicalSkills?: Array<{ __typename?: 'SuccessProfileTechnicalSkill', id: number, technicalSkill?: { __typename?: 'TechnicalSkill', id: number, name: string, subId: string } | null }> | null, successProfileSoftSkills?: Array<{ __typename?: 'SuccessProfileSoftSkill', id: number, softSkillId: number, name: string, softSkill: { __typename?: 'BasicBroadSoftSkill', subId: string, category: SoftSkillCategory } | { __typename?: 'BasicFocusedSoftSkill', subId: string, category: SoftSkillCategory } | { __typename?: 'BroadSoftSkill', subId: string, category: SoftSkillCategory } | { __typename?: 'FocusedSoftSkill', subId: string, category: SoftSkillCategory } }> | null }> }, project: { __typename?: 'Project', id: number, productSolution?: ProductSolution | null } } };

export type ProjectJobRoleDeleteOneMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ProjectJobRoleDeleteOneMutation = { __typename?: 'Mutation', ProjectJobRoleDeleteOne: { __typename?: 'DeleteResult', affected?: number | null } };

export type ProjectJobRoleSetMainMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ProjectJobRoleSetMainMutation = { __typename?: 'Mutation', ProjectJobRoleSetMain: { __typename?: 'ProjectJobRoleModel', id: number, createdAt: any, skillsProfileId: number, isLocalizedBenchmarkGroup?: boolean | null, isMainRole: boolean, jobRole: { __typename?: 'JobRoleModel', name: string, id: number, roleLevel: ContentRoleLevel, family?: JobRoleFamily | null, skillsProfiles: Array<{ __typename?: 'SuccessProfile', id: number, successProfileTechnicalSkills?: Array<{ __typename?: 'SuccessProfileTechnicalSkill', id: number, technicalSkill?: { __typename?: 'TechnicalSkill', id: number, name: string, subId: string } | null }> | null, successProfileSoftSkills?: Array<{ __typename?: 'SuccessProfileSoftSkill', id: number, softSkillId: number, name: string, softSkill: { __typename?: 'BasicBroadSoftSkill', subId: string, category: SoftSkillCategory } | { __typename?: 'BasicFocusedSoftSkill', subId: string, category: SoftSkillCategory } | { __typename?: 'BroadSoftSkill', subId: string, category: SoftSkillCategory } | { __typename?: 'FocusedSoftSkill', subId: string, category: SoftSkillCategory } }> | null }> }, project: { __typename?: 'Project', id: number, productSolution?: ProductSolution | null } } };

export type ProjectUserUpdateOneMutationVariables = Exact<{
  actorRole: ActorRole;
  projectId: Scalars['Int'];
  userId: Scalars['Int'];
}>;


export type ProjectUserUpdateOneMutation = { __typename?: 'Mutation', ProjectUserUpdateOne: { __typename?: 'ProjectUser', actorRole?: ActorRole | null, user: { __typename?: 'User', id: number }, project: { __typename?: 'Project', id: number } } };

export type ProjectUserDeleteOneMutationVariables = Exact<{
  projectId: Scalars['Float'];
  userId: Scalars['Float'];
}>;


export type ProjectUserDeleteOneMutation = { __typename?: 'Mutation', ProjectUserDeleteOne: { __typename?: 'ProjectUser', actorRole?: ActorRole | null, user: { __typename?: 'User', id: number }, project: { __typename?: 'Project', id: number } } };

export type ReportRenderCreateMutationVariables = Exact<{
  dataSourceId: Scalars['Int'];
  reportId: Scalars['Int'];
  reportRenderType: ReportRenderType;
}>;


export type ReportRenderCreateMutation = { __typename?: 'Mutation', ReportRenderCreate?: { __typename?: 'ReportRender', id: number, subId: string, reportRenderStatus?: ReportRenderStatus | null } | null };

export type ReportAssignmentCreateMutationVariables = Exact<{
  assignedId: Scalars['Int'];
  assignedType: RAssignedType;
  reportId: Scalars['Int'];
}>;


export type ReportAssignmentCreateMutation = { __typename?: 'Mutation', ReportAssignmentCreate?: { __typename?: 'ReportAssignment', assignedId: number, assignedType: RAssignedType, id: number, inheritsSetting?: boolean | null, reportId: number, report: { __typename?: 'Report', id: number, name: string } } | null };

export type ReportAssignmentUpdateMutationVariables = Exact<{
  assignedId: Scalars['Int'];
  assignedType: RAssignedType;
  reportId: Scalars['Int'];
  id: Scalars['Int'];
}>;


export type ReportAssignmentUpdateMutation = { __typename?: 'Mutation', ReportAssignmentUpdate?: { __typename?: 'ReportAssignment', assignedId: number, assignedType: RAssignedType, id: number, inheritsSetting?: boolean | null, reportId: number, report: { __typename?: 'Report', id: number, name: string } } | null };

export type ReportAssignmentDeleteMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ReportAssignmentDeleteMutation = { __typename?: 'Mutation', ReportAssignmentDelete?: { __typename?: 'DeleteResult', affected?: number | null } | null };

export type ReportDeleteMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ReportDeleteMutation = { __typename?: 'Mutation', report?: { __typename?: 'DeleteResult', affected?: number | null } | null };

export type ReportUpdateIsArchivedMutationVariables = Exact<{
  id: Scalars['Int'];
  isArchived: Scalars['Boolean'];
}>;


export type ReportUpdateIsArchivedMutation = { __typename?: 'Mutation', report?: { __typename?: 'Report', id: number, name: string, type: ReportType, subType?: ReportSubType | null, footerType: ReportFooterType, isArchived: boolean, ownerId: number, ownerType: ReportOwnerType, createdAt: any, updatedAt: any, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string } | null, reportConfigs?: Array<{ __typename?: 'ReportConfig', id: number, newPageBefore: boolean, position: number, widgetConfigs?: Array<{ __typename?: 'WidgetConfig', id: number, settings: string, widgetOption?: { __typename?: 'WidgetOption', question?: string | null, fieldType: WidgetOptionFieldType, widgetId: number, id: number, defaultValue?: string | null } | null }> | null, widget: { __typename?: 'Widget', id: number, name?: string | null, isArchived: boolean, updatedAt: any, type: WidgetType } }> | null } | null };

export type ReportUpdateMutationVariables = Exact<{
  id: Scalars['Int'];
  name: Scalars['String'];
  type: ReportType;
  subType?: InputMaybe<ReportSubType>;
  footerType?: InputMaybe<ReportFooterType>;
  reportConfigsToCreate?: InputMaybe<Array<ReportConfigCreateOneBatchedWithReportArgs> | ReportConfigCreateOneBatchedWithReportArgs>;
  reportConfigsToDelete?: InputMaybe<Array<DeleteByIdArgs> | DeleteByIdArgs>;
  reportConfigsToUpdate?: InputMaybe<Array<ReportConfigUpdateOneArgs> | ReportConfigUpdateOneArgs>;
}>;


export type ReportUpdateMutation = { __typename?: 'Mutation', Report?: { __typename?: 'Report', id: number, name: string, type: ReportType, subType?: ReportSubType | null, footerType: ReportFooterType, isArchived: boolean, ownerId: number, ownerType: ReportOwnerType, createdAt: any, updatedAt: any, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string } | null, reportConfigs?: Array<{ __typename?: 'ReportConfig', id: number, newPageBefore: boolean, position: number, widgetConfigs?: Array<{ __typename?: 'WidgetConfig', id: number, settings: string, widgetOption?: { __typename?: 'WidgetOption', question?: string | null, fieldType: WidgetOptionFieldType, widgetId: number, id: number, defaultValue?: string | null } | null }> | null, widget: { __typename?: 'Widget', id: number, name?: string | null, isArchived: boolean, updatedAt: any, type: WidgetType } }> | null } | null };

export type ReportCopyMutationVariables = Exact<{
  name: Scalars['String'];
  type: ReportType;
  subType?: InputMaybe<ReportSubType>;
  footerType?: InputMaybe<ReportFooterType>;
  ownerId: Scalars['Int'];
  ownerType: ReportOwnerType;
  copyReportId: Scalars['Int'];
}>;


export type ReportCopyMutation = { __typename?: 'Mutation', report?: { __typename?: 'Report', id: number, name: string, type: ReportType, subType?: ReportSubType | null, footerType: ReportFooterType, isArchived: boolean, ownerId: number, ownerType: ReportOwnerType, createdAt: any, updatedAt: any, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string } | null, reportConfigs?: Array<{ __typename?: 'ReportConfig', id: number, newPageBefore: boolean, position: number, widgetConfigs?: Array<{ __typename?: 'WidgetConfig', id: number, settings: string, widgetOption?: { __typename?: 'WidgetOption', question?: string | null, fieldType: WidgetOptionFieldType, widgetId: number, id: number, defaultValue?: string | null } | null }> | null, widget: { __typename?: 'Widget', id: number, name?: string | null, isArchived: boolean, updatedAt: any, type: WidgetType } }> | null } | null };

export type ReportCreateMutationVariables = Exact<{
  name: Scalars['String'];
  type: ReportType;
  subType?: InputMaybe<ReportSubType>;
  footerType?: InputMaybe<ReportFooterType>;
  ownerId: Scalars['Int'];
  ownerType: ReportOwnerType;
}>;


export type ReportCreateMutation = { __typename?: 'Mutation', report?: { __typename?: 'Report', id: number, name: string, type: ReportType, subType?: ReportSubType | null, footerType: ReportFooterType, isArchived: boolean, ownerId: number, ownerType: ReportOwnerType, createdAt: any, updatedAt: any, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string } | null, reportConfigs?: Array<{ __typename?: 'ReportConfig', id: number, newPageBefore: boolean, position: number, widgetConfigs?: Array<{ __typename?: 'WidgetConfig', id: number, settings: string, widgetOption?: { __typename?: 'WidgetOption', question?: string | null, fieldType: WidgetOptionFieldType, widgetId: number, id: number, defaultValue?: string | null } | null }> | null, widget: { __typename?: 'Widget', id: number, name?: string | null, isArchived: boolean, updatedAt: any, type: WidgetType } }> | null } | null };

export type StageResultsReportRenderCreateMutationVariables = Exact<{
  dataSourceId: Scalars['Int'];
  reportId: Scalars['Int'];
  reportRenderType: ReportRenderType;
  projectJobRoleId: Scalars['Int'];
}>;


export type StageResultsReportRenderCreateMutation = { __typename?: 'Mutation', StageResultsReportRenderCreate?: { __typename?: 'ReportRender', reportRenderStatus?: ReportRenderStatus | null, statusMessage?: string | null, subId: string, blob?: { __typename?: 'MonolithBlobModel', url: string } | null } | null };

export type RespondantFormDeleteMutationVariables = Exact<{
  id: Scalars['Int'];
  associatedId: Scalars['Int'];
}>;


export type RespondantFormDeleteMutation = { __typename?: 'Mutation', RespondantFormDeleteByRespondantAndAssociatedId?: { __typename?: 'DeleteResult', affected?: number | null } | null };

export type ResultDeleteManyMutationVariables = Exact<{
  doneFor: Scalars['Int'];
  doneBy: Scalars['Int'];
  labels?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type ResultDeleteManyMutation = { __typename?: 'Mutation', ResultDeleteMany: { __typename?: 'DeleteResult', affected?: number | null } };

export type ScheduleRoiCsvFileExportMutationVariables = Exact<{
  projectIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type ScheduleRoiCsvFileExportMutation = { __typename?: 'Mutation', FileExportScheduledTask: { __typename?: 'FileExportScheduledTask', status: ScheduledTaskStatus, error?: string | null, subId: string, blob?: { __typename?: 'MonolithBlobModel', url: string, id: string } | null } };

export type RssAssessmentCandidateReopenAllSubmittedForStageCandidateMutationVariables = Exact<{
  stageCandidateId: Scalars['Int'];
}>;


export type RssAssessmentCandidateReopenAllSubmittedForStageCandidateMutation = { __typename?: 'Mutation', RssAssessmentCandidateReopenAllSubmittedForStageCandidate: Array<{ __typename?: 'RssAssessmentCandidateModel', id: number, status: RssAssessmentCandidateStatus, updatedAt: any, rssAssessment: { __typename?: 'RssAssessmentModel', id: number, type: RssAssessmentType, stageId: number } }> };

export type ScheduledCandidateUsageCsvFileExportMutationVariables = Exact<{
  createdAtFrom?: InputMaybe<Scalars['Date']>;
  createdAtTo?: InputMaybe<Scalars['Date']>;
  companyIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type ScheduledCandidateUsageCsvFileExportMutation = { __typename?: 'Mutation', ScheduledCandidateUsageCsvFileExport: { __typename?: 'FileExportScheduledTask', subId: string, kind: ScheduledTaskKind, status: ScheduledTaskStatus, error?: string | null } };

export type ShortlistStageDeleteMutationVariables = Exact<{
  subId: Scalars['ID'];
}>;


export type ShortlistStageDeleteMutation = { __typename?: 'Mutation', ShortlistStageDelete: boolean };

export type SoftSkillBulkUpdateTraitsMutationVariables = Exact<{
  softSkillTraits: Array<BulkUpdateSoftSkillTraitArgsSingle> | BulkUpdateSoftSkillTraitArgsSingle;
}>;


export type SoftSkillBulkUpdateTraitsMutation = { __typename?: 'Mutation', softSkill?: { __typename?: 'BasicBroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BasicFocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, focusedSoftSkills: Array<{ __typename?: 'BasicFocusedSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'FocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, broadSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | null };

export type SoftSkillCreateMutationVariables = Exact<{
  name: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  category: SoftSkillCategory;
  granularity: SoftSkillGranularity;
  taxonomyVersion: Scalars['Int'];
}>;


export type SoftSkillCreateMutation = { __typename?: 'Mutation', softSkill?: { __typename?: 'BasicBroadSoftSkill', subId: string } | { __typename?: 'BasicFocusedSoftSkill', subId: string } | { __typename?: 'BroadSoftSkill', subId: string } | { __typename?: 'FocusedSoftSkill', subId: string } | null };

export type SoftSkillSoftDeleteMutationVariables = Exact<{
  subId: Scalars['ID'];
}>;


export type SoftSkillSoftDeleteMutation = { __typename?: 'Mutation', softSkill: { __typename?: 'BasicBroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BasicFocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, focusedSoftSkills: Array<{ __typename?: 'BasicFocusedSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'FocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, broadSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } };

export type SoftSkillRestoreMutationVariables = Exact<{
  subId: Scalars['ID'];
}>;


export type SoftSkillRestoreMutation = { __typename?: 'Mutation', softSkill: { __typename?: 'BasicBroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BasicFocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, focusedSoftSkills: Array<{ __typename?: 'BasicFocusedSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'FocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, broadSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } };

export type SoftSkillUpdateMutationVariables = Exact<{
  subId: Scalars['ID'];
  args: SoftSkillUpdateArgs;
}>;


export type SoftSkillUpdateMutation = { __typename?: 'Mutation', softSkill: { __typename?: 'BasicBroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BasicFocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, focusedSoftSkills: Array<{ __typename?: 'BasicFocusedSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'FocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, broadSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } };

export type SaveSoftSkillContentMutationVariables = Exact<{
  id: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  candidateContent?: InputMaybe<Scalars['String']>;
  hiringManagerContent?: InputMaybe<Scalars['String']>;
  internalCandidateContent?: InputMaybe<Scalars['String']>;
}>;


export type SaveSoftSkillContentMutation = { __typename?: 'Mutation', saveSoftSkillContent?: { __typename?: 'SoftSkillRoleLevelContent', id: number, softSkillId?: number | null, grade: Grade, roleLevel: ContentRoleLevel, description?: string | null, candidateContent?: string | null, hiringManagerContent?: string | null, internalCandidateContent?: string | null, softSkill: { __typename?: 'BasicBroadSoftSkill', id: number, name: string } | { __typename?: 'BasicFocusedSoftSkill', id: number, name: string } | { __typename?: 'BroadSoftSkill', id: number, name: string } | { __typename?: 'FocusedSoftSkill', id: number, name: string } } | null };

export type SoftSkillRoleLevelContentUploadMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type SoftSkillRoleLevelContentUploadMutation = { __typename?: 'Mutation', SoftSkillRoleLevelContentUpload: boolean };

export type SoftSkillRoleLevelContentCsvFileExportMutationVariables = Exact<{ [key: string]: never; }>;


export type SoftSkillRoleLevelContentCsvFileExportMutation = { __typename?: 'Mutation', SoftSkillRoleLevelContentCsvFileExport: { __typename?: 'FileExportScheduledTask', subId: string, status: ScheduledTaskStatus, blob?: { __typename?: 'MonolithBlobModel', id: string, url: string } | null } };

export type SetIndirectInviteSsoMutationVariables = Exact<{
  projectId: Scalars['Int'];
  indirectInviteSSO: Scalars['Boolean'];
}>;


export type SetIndirectInviteSsoMutation = { __typename?: 'Mutation', setIndirectInviteSSO: boolean };

export type RemoveOneStageMutationVariables = Exact<{
  stageId: Scalars['Int'];
}>;


export type RemoveOneStageMutation = { __typename?: 'Mutation', RemoveOneStage: { __typename?: 'DeleteResult', affected?: number | null } };

export type CreateStageMutationVariables = Exact<{
  hasCalibration: Scalars['Boolean'];
  endTime?: InputMaybe<Scalars['Date']>;
  name: Scalars['String'];
  projectId: Scalars['Int'];
  startTime?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<StageStatus>;
  cognitiveMode: CognitiveMode;
  emailCandidateReport: Scalars['Boolean'];
  managerReportId?: InputMaybe<Scalars['Int']>;
  candidateReportId?: InputMaybe<Scalars['Int']>;
  projectTeamEmailSettings?: InputMaybe<ProjectTeamEmailSettingsArgs>;
  kind?: InputMaybe<AssessmentStageKind>;
}>;


export type CreateStageMutation = { __typename?: 'Mutation', Stage: { __typename?: 'SmStageModel', id: number, subId: string, name: string, kind: AssessmentStageKind, status: StageStatus, startTime?: any | null, endTime?: any | null, projectId: number, hasCalibration: boolean, createdAt: any, updatedAt: any, deletedAt?: any | null, emailCandidateReport: boolean, cognitiveMode: CognitiveMode, deiStageAction?: { __typename?: 'DeiStageActionModel', completedCount: number, submittedCount: number, createdAt: any, deletedAt?: any | null, stageId: number, updatedAt: any, fields: { __typename?: 'DeiStageActionFieldsModel', hasAgeRangeField: boolean, hasDisabilityField: boolean, hasEthnicityField: boolean, hasGenderIdentityField: boolean, hasNeurodiversityField: boolean, hasReligiousBeliefsField: boolean, hasSexualOrientationField: boolean, hasDisabilityIdentifyField: boolean, hasNeurodivergenceIdentifyField: boolean, hasFreeSchoolMealsField: boolean } } | null, availableActions: Array<{ __typename?: 'StageAvailableActionModel', availability: StageActionAvailability, name: string, kind: AssessmentStageActionKind }>, rssAssessments: Array<{ __typename?: 'RssAssessmentModel', id: number, type: RssAssessmentType, stageId: number }>, assessmentExpiryOption?: { __typename?: 'AssessmentExpiryOption', duration: number, unit: AssessmentExpiryOptionUnit } | null, managerReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, candidateReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, projectTeamEmailSettings: { __typename?: 'ProjectTeamEmailSettings', mode: ProjectTeamEmailMode, actorRoles: Array<ActorRole> } } };

export type StageEditDetailsMutationVariables = Exact<{
  hasCalibration?: InputMaybe<Scalars['Boolean']>;
  endTime?: InputMaybe<Scalars['Date']>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['Date']>;
  assessmentExpiryOption?: InputMaybe<AssessmentExpiryOptionArgs>;
  cognitiveMode?: InputMaybe<CognitiveMode>;
  managerReportId?: InputMaybe<Scalars['Int']>;
  candidateReportId?: InputMaybe<Scalars['Int']>;
  emailCandidateReport?: InputMaybe<Scalars['Boolean']>;
  projectTeamEmailSettings?: InputMaybe<ProjectTeamEmailSettingsArgs>;
}>;


export type StageEditDetailsMutation = { __typename?: 'Mutation', Stage: { __typename?: 'SmStageModel', id: number, subId: string, name: string, kind: AssessmentStageKind, status: StageStatus, startTime?: any | null, endTime?: any | null, projectId: number, hasCalibration: boolean, createdAt: any, updatedAt: any, deletedAt?: any | null, emailCandidateReport: boolean, cognitiveMode: CognitiveMode, deiStageAction?: { __typename?: 'DeiStageActionModel', completedCount: number, submittedCount: number, createdAt: any, deletedAt?: any | null, stageId: number, updatedAt: any, fields: { __typename?: 'DeiStageActionFieldsModel', hasAgeRangeField: boolean, hasDisabilityField: boolean, hasEthnicityField: boolean, hasGenderIdentityField: boolean, hasNeurodiversityField: boolean, hasReligiousBeliefsField: boolean, hasSexualOrientationField: boolean, hasDisabilityIdentifyField: boolean, hasNeurodivergenceIdentifyField: boolean, hasFreeSchoolMealsField: boolean } } | null, availableActions: Array<{ __typename?: 'StageAvailableActionModel', availability: StageActionAvailability, name: string, kind: AssessmentStageActionKind }>, rssAssessments: Array<{ __typename?: 'RssAssessmentModel', id: number, type: RssAssessmentType, stageId: number }>, assessmentExpiryOption?: { __typename?: 'AssessmentExpiryOption', duration: number, unit: AssessmentExpiryOptionUnit } | null, managerReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, candidateReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, projectTeamEmailSettings: { __typename?: 'ProjectTeamEmailSettings', mode: ProjectTeamEmailMode, actorRoles: Array<ActorRole> } } };

export type StageCandidateResetOneMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type StageCandidateResetOneMutation = { __typename?: 'Mutation', Stages: boolean };

export type StageCandidateReprocessOneMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type StageCandidateReprocessOneMutation = { __typename?: 'Mutation', StageCandidateReprocessOne: boolean };

export type StageCandidateDeleteOneMutationVariables = Exact<{
  subId: Scalars['String'];
}>;


export type StageCandidateDeleteOneMutation = { __typename?: 'Mutation', StageCandidateDeleteOne: { __typename?: 'DeleteResult', affected?: number | null } };

export type DeiStageActionUpsertMutationVariables = Exact<{
  stageId: Scalars['Int'];
  fields: DeiStageActionFieldsInput;
}>;


export type DeiStageActionUpsertMutation = { __typename?: 'Mutation', DeiStageActionUpsert: { __typename?: 'DeiStageActionModel', completedCount: number, submittedCount: number, createdAt: any, deletedAt?: any | null, stageId: number, updatedAt: any, fields: { __typename?: 'DeiStageActionFieldsModel', hasAgeRangeField: boolean, hasDisabilityField: boolean, hasEthnicityField: boolean, hasGenderIdentityField: boolean, hasNeurodiversityField: boolean, hasReligiousBeliefsField: boolean, hasSexualOrientationField: boolean, hasDisabilityIdentifyField: boolean, hasNeurodivergenceIdentifyField: boolean, hasFreeSchoolMealsField: boolean } } };

export type DeiStageActionArchiveMutationVariables = Exact<{
  stageId: Scalars['Int'];
}>;


export type DeiStageActionArchiveMutation = { __typename?: 'Mutation', DeiStageActionArchive: { __typename?: 'DeiStageActionModel', completedCount: number, submittedCount: number, createdAt: any, deletedAt?: any | null, stageId: number, updatedAt: any, fields: { __typename?: 'DeiStageActionFieldsModel', hasAgeRangeField: boolean, hasDisabilityField: boolean, hasEthnicityField: boolean, hasGenderIdentityField: boolean, hasNeurodiversityField: boolean, hasReligiousBeliefsField: boolean, hasSexualOrientationField: boolean, hasDisabilityIdentifyField: boolean, hasNeurodivergenceIdentifyField: boolean, hasFreeSchoolMealsField: boolean } } };

export type DeiStageActionUnarchiveMutationVariables = Exact<{
  stageId: Scalars['Int'];
  fields: DeiStageActionFieldsInput;
}>;


export type DeiStageActionUnarchiveMutation = { __typename?: 'Mutation', DeiStageActionUnarchive: { __typename?: 'DeiStageActionModel', completedCount: number, submittedCount: number, createdAt: any, deletedAt?: any | null, stageId: number, updatedAt: any, fields: { __typename?: 'DeiStageActionFieldsModel', hasAgeRangeField: boolean, hasDisabilityField: boolean, hasEthnicityField: boolean, hasGenderIdentityField: boolean, hasNeurodiversityField: boolean, hasReligiousBeliefsField: boolean, hasSexualOrientationField: boolean, hasDisabilityIdentifyField: boolean, hasNeurodivergenceIdentifyField: boolean, hasFreeSchoolMealsField: boolean } } };

export type DeiStageActionCandidateReopenMutationVariables = Exact<{
  stageCandidateId: Scalars['Int'];
}>;


export type DeiStageActionCandidateReopenMutation = { __typename?: 'Mutation', DeiStageActionCandidateReopen: { __typename?: 'DeiStageActionCandidateModel', createdAt: any, status: DeiStageActionCandidateStatus, updatedAt: any, hasActiveConsent: boolean, consentEvents: Array<{ __typename?: 'DeiConsentEventModel', event: DeiConsentEventType, occurredAt: any, actorUserId?: number | null }> } };

export type DeiStageActionCandidateClearAllForCandidateMutationVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type DeiStageActionCandidateClearAllForCandidateMutation = { __typename?: 'Mutation', DeiStageActionCandidateClearAllForCandidate: number };

export type DeiStageActionCandidateRevokeConsentMutationVariables = Exact<{
  stageCandidateId: Scalars['Int'];
}>;


export type DeiStageActionCandidateRevokeConsentMutation = { __typename?: 'Mutation', DeiStageActionCandidateRevokeConsent: { __typename?: 'DeiStageActionCandidateModel', createdAt: any, status: DeiStageActionCandidateStatus, updatedAt: any, hasActiveConsent: boolean, consentEvents: Array<{ __typename?: 'DeiConsentEventModel', event: DeiConsentEventType, occurredAt: any, actorUserId?: number | null }> } };

export type UpdateStageScoringConfigMutationVariables = Exact<{
  stageId: Scalars['Int'];
  components: Array<StageScoringComponentConfigInput> | StageScoringComponentConfigInput;
}>;


export type UpdateStageScoringConfigMutation = { __typename?: 'Mutation', updateStageScoringConfig: { __typename?: 'SmStageModel', id: number, scoringConfig?: { __typename?: 'StageScoringConfig', version: number, components: Array<{ __typename?: 'StageScoringComponentConfig', component: ScoreComponent, kind: ScoreComponentKind, weight: number, threshold?: number | null }> } | null } };

export type UpdateSuccessProfileMutationVariables = Exact<{
  id: Scalars['Int'];
  calculationMethod: CalculationMethod;
  gradingMethod: GradingMethod;
}>;


export type UpdateSuccessProfileMutation = { __typename?: 'Mutation', successProfile: { __typename?: 'SuccessProfile', calculationMethod: CalculationMethod, createdAt: any, deletedAt?: any | null, gradingMethod: GradingMethod, id: number, jobRoleId: number, status: SuccessProfileStatus, updatedAt: any, successProfileTechnicalSkills?: Array<{ __typename?: 'SuccessProfileTechnicalSkill', id: number, successProfileId: number, technicalSkillId: number, technicalSkill?: { __typename?: 'TechnicalSkill', id: number, name: string, subId: string } | null }> | null, successProfileSoftSkills?: Array<{ __typename?: 'SuccessProfileSoftSkill', id: number, softSkillId: number, type: SoftSkillType, name: string, weight: number, includeInCalibration: boolean, softSkill: { __typename?: 'BasicBroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BasicFocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, focusedSoftSkills: Array<{ __typename?: 'BasicFocusedSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'FocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, broadSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null }, successProfileSoftSkillTraits: Array<{ __typename?: 'SuccessProfileSoftSkillTrait', id: number, orientation?: number | null, traitId: number, weight: number, name?: string | null }>, successProfileSoftSkillDataSources?: Array<{ __typename?: 'SuccessProfileSoftSkillDataSource', id: number, dataSourceType: DataSourceType, softSkillType: SoftSkillType }> | null }> | null } };

export type CreateSuccessProfileMutationVariables = Exact<{
  calculationMethod: CalculationMethod;
  gradingMethod: GradingMethod;
  jobRoleId: Scalars['Int'];
}>;


export type CreateSuccessProfileMutation = { __typename?: 'Mutation', successProfile: { __typename?: 'SuccessProfile', calculationMethod: CalculationMethod, createdAt: any, deletedAt?: any | null, gradingMethod: GradingMethod, id: number, jobRoleId: number, status: SuccessProfileStatus, updatedAt: any, successProfileTechnicalSkills?: Array<{ __typename?: 'SuccessProfileTechnicalSkill', id: number, successProfileId: number, technicalSkillId: number, technicalSkill?: { __typename?: 'TechnicalSkill', id: number, name: string, subId: string } | null }> | null, successProfileSoftSkills?: Array<{ __typename?: 'SuccessProfileSoftSkill', id: number, softSkillId: number, type: SoftSkillType, name: string, weight: number, includeInCalibration: boolean, softSkill: { __typename?: 'BasicBroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BasicFocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, focusedSoftSkills: Array<{ __typename?: 'BasicFocusedSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'FocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, broadSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null }, successProfileSoftSkillTraits: Array<{ __typename?: 'SuccessProfileSoftSkillTrait', id: number, orientation?: number | null, traitId: number, weight: number, name?: string | null }>, successProfileSoftSkillDataSources?: Array<{ __typename?: 'SuccessProfileSoftSkillDataSource', id: number, dataSourceType: DataSourceType, softSkillType: SoftSkillType }> | null }> | null } };

export type SuccessProfileSoftSkillsOverwriteMutationVariables = Exact<{
  id: Scalars['Int'];
  softSkills: Array<SuccessProfileSoftSkillCreateOneArgs> | SuccessProfileSoftSkillCreateOneArgs;
}>;


export type SuccessProfileSoftSkillsOverwriteMutation = { __typename?: 'Mutation', SuccessProfileSoftSkillsOverwrite: { __typename?: 'SuccessProfile', id: number, successProfileSoftSkills?: Array<{ __typename?: 'SuccessProfileSoftSkill', id: number, softSkillId: number, weight: number }> | null } };

export type SuccessProfileTechnicalSkillsOverwriteMutationVariables = Exact<{
  id: Scalars['Int'];
  technicalSkills: Array<SuccessProfileTechnicalSkillCreateOneArgs> | SuccessProfileTechnicalSkillCreateOneArgs;
}>;


export type SuccessProfileTechnicalSkillsOverwriteMutation = { __typename?: 'Mutation', SuccessProfileTechnicalSkillsOverwrite: { __typename?: 'SuccessProfile', id: number, successProfileTechnicalSkills?: Array<{ __typename?: 'SuccessProfileTechnicalSkill', id: number, technicalSkillId: number, successProfileId: number }> | null } };

export type TechnicalSkillCreateOneMutationVariables = Exact<{
  name: Scalars['String'];
  iconBlobId?: InputMaybe<Scalars['Int']>;
  skillCategoryId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
}>;


export type TechnicalSkillCreateOneMutation = { __typename?: 'Mutation', TechnicalSkillCreateOne: { __typename?: 'TechnicalSkill', id: number, createdAt: any, updatedAt: any, deletedAt?: any | null, iconBlobId?: number | null, name: string, description?: string | null, skillCategoryId?: number | null, subId: string, skillCategory?: { __typename?: 'SkillCategory', name: string } | null } };

export type TechnicalSkillIconUploadMutationVariables = Exact<{
  id: Scalars['Int'];
  file: Scalars['Upload'];
}>;


export type TechnicalSkillIconUploadMutation = { __typename?: 'Mutation', TechnicalSkillIconUpload: string };

export type TechnicalSkillSoftDeleteMutationVariables = Exact<{
  subId: Scalars['ID'];
}>;


export type TechnicalSkillSoftDeleteMutation = { __typename?: 'Mutation', TechnicalSkillSoftDelete: { __typename?: 'TechnicalSkill', id: number, createdAt: any, updatedAt: any, deletedAt?: any | null, iconBlobId?: number | null, name: string, description?: string | null, skillCategoryId?: number | null, subId: string, skillCategory?: { __typename?: 'SkillCategory', name: string } | null } };

export type TechnicalSkillRestoreMutationVariables = Exact<{
  subId: Scalars['ID'];
}>;


export type TechnicalSkillRestoreMutation = { __typename?: 'Mutation', TechnicalSkillRestore: { __typename?: 'TechnicalSkill', id: number, createdAt: any, updatedAt: any, deletedAt?: any | null, iconBlobId?: number | null, name: string, description?: string | null, skillCategoryId?: number | null, subId: string, skillCategory?: { __typename?: 'SkillCategory', name: string } | null } };

export type TechnicalSkillUpdateMutationVariables = Exact<{
  subId: Scalars['ID'];
  args: TechnicalSkillUpdateArgs;
}>;


export type TechnicalSkillUpdateMutation = { __typename?: 'Mutation', TechnicalSkillUpdate: { __typename?: 'TechnicalSkill', id: number, createdAt: any, updatedAt: any, deletedAt?: any | null, iconBlobId?: number | null, name: string, description?: string | null, skillCategoryId?: number | null, subId: string, skillCategory?: { __typename?: 'SkillCategory', name: string } | null } };

export type ResetCognitiveTestMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ResetCognitiveTestMutation = { __typename?: 'Mutation', resetCognitiveTest: { __typename?: 'CognitiveTestAssessmentStageActionCandidate', id: string, status: CognitiveTestAssessmentStageActionCandidateStatus, assessmentId?: string | null } };

export type ResetPersonalityTestMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ResetPersonalityTestMutation = { __typename?: 'Mutation', resetPersonalityTest: { __typename?: 'PersonalityTestAssessmentStageActionCandidate', id: string, status: PersonalityTestAssessmentStageActionCandidateStatus, assessmentId?: string | null } };

export type UpdateCognitiveTestTimeAllowanceMutationVariables = Exact<{
  id: Scalars['ID'];
  timeModifierPercentage: Scalars['Float'];
}>;


export type UpdateCognitiveTestTimeAllowanceMutation = { __typename?: 'Mutation', updateCognitiveTestTimeAllowance: { __typename?: 'CognitiveTestAssessmentStageActionCandidate', id: string, timeModifierPercentage?: number | null } };

export type ResetCoderbyteAssessmentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ResetCoderbyteAssessmentMutation = { __typename?: 'Mutation', resetCoderbyteAssessment: { __typename?: 'CoderbyteAssessmentStageActionCandidate', id: string, status: CoderbyteAssessmentStageActionCandidateStatus } };

export type ResetEnglishProficiencyAssessmentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ResetEnglishProficiencyAssessmentMutation = { __typename?: 'Mutation', resetEnglishProficiencyAssessment: { __typename?: 'EnglishProficiencyAssessmentStageActionCandidate', id: string, status: EnglishProficiencyAssessmentStageActionCandidateStatus, assessmentId?: string | null } };

export type UpdateCoderbyteAssessmentTimeAllowanceMutationVariables = Exact<{
  id: Scalars['ID'];
  timeModifierPercentage: Scalars['Float'];
}>;


export type UpdateCoderbyteAssessmentTimeAllowanceMutation = { __typename?: 'Mutation', updateCoderbyteAssessmentTimeAllowance: { __typename?: 'CoderbyteAssessmentStageActionCandidate', id: string, timeModifierPercentage: number } };

export type AddPersonalityTestToAssessmentStageMutationVariables = Exact<{
  stageId: Scalars['ID'];
  questionsPerTraitCount?: InputMaybe<Scalars['Int']>;
  selectedLocales?: InputMaybe<Array<SupportedLocale> | SupportedLocale>;
}>;


export type AddPersonalityTestToAssessmentStageMutation = { __typename?: 'Mutation', addPersonalityTestToAssessmentStage: { __typename?: 'PersonalityTestAssessmentStageAction', id: string, questionsPerTraitCount: number, selectedLocales: Array<SupportedLocale> } };

export type AddCognitiveTestToAssessmentStageMutationVariables = Exact<{
  stageId: Scalars['ID'];
  kind: CognitiveKind;
}>;


export type AddCognitiveTestToAssessmentStageMutation = { __typename?: 'Mutation', addCognitiveTestToAssessmentStage: { __typename?: 'CognitiveTestAssessmentStageAction', id: string, kind: CognitiveKind, sectionCount: number } };

export type RemovePersonalityTestFromAssessmentStageMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemovePersonalityTestFromAssessmentStageMutation = { __typename?: 'Mutation', removePersonalityTestFromAssessmentStage: boolean };

export type RemoveCognitiveTestFromAssessmentStageMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveCognitiveTestFromAssessmentStageMutation = { __typename?: 'Mutation', removeCognitiveTestFromAssessmentStage: boolean };

export type UpdatePersonalityTestQuestionsPerTraitCountMutationVariables = Exact<{
  id: Scalars['ID'];
  questionsPerTraitCount: Scalars['Int'];
}>;


export type UpdatePersonalityTestQuestionsPerTraitCountMutation = { __typename?: 'Mutation', updatePersonalityTestQuestionsPerTraitCount: { __typename?: 'PersonalityTestAssessmentStageAction', id: string, questionsPerTraitCount: number } };

export type UpdatePersonalityTestSelectedLocalesMutationVariables = Exact<{
  id: Scalars['ID'];
  selectedLocales: Array<SupportedLocale> | SupportedLocale;
}>;


export type UpdatePersonalityTestSelectedLocalesMutation = { __typename?: 'Mutation', updatePersonalityTestSelectedLocales: { __typename?: 'PersonalityTestAssessmentStageAction', id: string, selectedLocales: Array<SupportedLocale> } };

export type UpdateCognitiveTestSectionCountMutationVariables = Exact<{
  id: Scalars['ID'];
  sectionCount: Scalars['Int'];
}>;


export type UpdateCognitiveTestSectionCountMutation = { __typename?: 'Mutation', updateCognitiveTestSectionCount: { __typename?: 'CognitiveTestAssessmentStageAction', id: string, sectionCount: number } };

export type RefreshCoderbyteAssessmentDetailsMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RefreshCoderbyteAssessmentDetailsMutation = { __typename?: 'Mutation', refreshCoderbyteAssessmentDetails: { __typename?: 'CoderbyteAssessmentStageAction', id: string, details: { __typename?: 'CoderbyteAssessmentStageActionDetails', timeLimitInMinutes?: number | null, isFrozen: boolean, challengeCount?: number | null, multipleChoiceCount?: number | null } } };

export type AddTraitMutationVariables = Exact<{
  name: Scalars['String'];
  description: Scalars['String'];
}>;


export type AddTraitMutation = { __typename?: 'Mutation', Trait?: { __typename?: 'Trait', id: number, subId: string, name: string, description: string, isArchived: boolean, testTypes: Array<{ __typename?: 'TraitTestTypeModel', id: number, testSubType?: TestSubType | null, testType: TestType, traitId: number }> } | null };

export type UpdateTraitMutationVariables = Exact<{
  id: Scalars['Int'];
  name: Scalars['String'];
  description: Scalars['String'];
  isArchived: Scalars['Boolean'];
}>;


export type UpdateTraitMutation = { __typename?: 'Mutation', Trait?: { __typename?: 'Trait', id: number, subId: string, name: string, description: string, isArchived: boolean, testTypes: Array<{ __typename?: 'TraitTestTypeModel', id: number, testSubType?: TestSubType | null, testType: TestType, traitId: number }> } | null };

export type UpdateTraitTestTypesMutationVariables = Exact<{
  dto: Array<TraitTestTypesUpdateOneArgs> | TraitTestTypesUpdateOneArgs;
}>;


export type UpdateTraitTestTypesMutation = { __typename?: 'Mutation', traitTestTypes?: Array<{ __typename?: 'TraitTestTypeModel', id: number, testSubType?: TestSubType | null, testType: TestType, traitId: number }> | null };

export type ArchiveTraitMutationVariables = Exact<{
  id: Scalars['Int'];
  isArchived: Scalars['Boolean'];
}>;


export type ArchiveTraitMutation = { __typename?: 'Mutation', Trait?: { __typename?: 'Trait', id: number, subId: string, name: string, description: string, isArchived: boolean, testTypes: Array<{ __typename?: 'TraitTestTypeModel', id: number, testSubType?: TestSubType | null, testType: TestType, traitId: number }> } | null };

export type DeleteTraitMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteTraitMutation = { __typename?: 'Mutation', affected?: { __typename?: 'DeleteResult', affected?: number | null } | null };

export type SaveTraitContentMutationVariables = Exact<{
  id: Scalars['Int'];
  summary?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  developmentContent?: InputMaybe<Scalars['String']>;
}>;


export type SaveTraitContentMutation = { __typename?: 'Mutation', traitContent?: { __typename?: 'TraitRoleLevelContent', id?: number | null, softSkillId?: number | null, traitId?: number | null, classification: ContentClassification, roleLevel: ContentRoleLevel, summary?: string | null, content?: string | null, developmentContent?: string | null } | null };

export type TraitRoleLevelContentUploadMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type TraitRoleLevelContentUploadMutation = { __typename?: 'Mutation', TraitRoleLevelContentUpload: boolean };

export type UserDeleteMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UserDeleteMutation = { __typename?: 'Mutation', UserDelete: { __typename?: 'DeleteResult', affected?: number | null } };

export type UserDeleteByEmailMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type UserDeleteByEmailMutation = { __typename?: 'Mutation', UserDeleteByEmail: { __typename?: 'DeleteResult', affected?: number | null } };

export type UserCreateMutationVariables = Exact<{
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
}>;


export type UserCreateMutation = { __typename?: 'Mutation', User: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } };

export type UserUpdateMutationVariables = Exact<{
  id: Scalars['Int'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
}>;


export type UserUpdateMutation = { __typename?: 'Mutation', User: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } };

export type UserRoleUpdateMutationVariables = Exact<{
  companyId?: InputMaybe<Scalars['Float']>;
  role?: InputMaybe<IdentityPermissionRole>;
  externalId?: InputMaybe<Scalars['String']>;
  id: Scalars['Float'];
}>;


export type UserRoleUpdateMutation = { __typename?: 'Mutation', UserRole: { __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } } };

export type UserRoleCreateMutationVariables = Exact<{
  userId: Scalars['Float'];
  companyId: Scalars['Float'];
  role: IdentityPermissionRole;
  externalId?: InputMaybe<Scalars['String']>;
}>;


export type UserRoleCreateMutation = { __typename?: 'Mutation', UserRoleCreate?: { __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } } | null };

export type UserRoleDeleteMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UserRoleDeleteMutation = { __typename?: 'Mutation', UserRoleDelete: { __typename?: 'DeleteResult', affected?: number | null } };

export type WidgetOptionUpdateMutationVariables = Exact<{
  name: Scalars['String'];
  question?: InputMaybe<Scalars['String']>;
  defaultValue?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  fieldType: WidgetOptionFieldType;
}>;


export type WidgetOptionUpdateMutation = { __typename?: 'Mutation', WidgetOptions?: { __typename?: 'WidgetOption', id: number, name: string, fieldType: WidgetOptionFieldType, defaultValue?: string | null, question?: string | null, isArchived: boolean, widgetId: number } | null };

export type WidgetUpdateIsArchivedMutationVariables = Exact<{
  id: Scalars['Int'];
  isArchived: Scalars['Boolean'];
}>;


export type WidgetUpdateIsArchivedMutation = { __typename?: 'Mutation', WidgetUpdateIsArchived?: { __typename?: 'Widget', id: number, name?: string | null, type: WidgetType, screenShotBlobId?: number | null, isArchived: boolean, updatedAt: any, screenShotBlob?: { __typename?: 'MonolithBlobModel', id: string, url: string } | null, widgetOptions?: Array<{ __typename?: 'WidgetOption', id: number, question?: string | null, fieldType: WidgetOptionFieldType, defaultValue?: string | null, isArchived: boolean }> | null, reportConfigs?: Array<{ __typename?: 'ReportConfig', id: number, reportId: number, newPageBefore: boolean }> | null } | null };

export type WidgetOptionUpdateIsArchivedMutationVariables = Exact<{
  id: Scalars['Int'];
  isArchived: Scalars['Boolean'];
}>;


export type WidgetOptionUpdateIsArchivedMutation = { __typename?: 'Mutation', WidgetOptionUpdateIsArchived?: { __typename?: 'WidgetOption', id: number, name: string, question?: string | null, isArchived: boolean, fieldType: WidgetOptionFieldType, defaultValue?: string | null } | null };

export type WidgetDeleteMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type WidgetDeleteMutation = { __typename?: 'Mutation', WidgetDelete?: { __typename?: 'DeleteResult', affected?: number | null } | null };

export type WidgetOptionDeleteMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type WidgetOptionDeleteMutation = { __typename?: 'Mutation', WidgetOptionDelete?: { __typename?: 'DeleteResult', affected?: number | null } | null };

export type WidgetCreateMutationVariables = Exact<{
  type: WidgetType;
  name: Scalars['String'];
}>;


export type WidgetCreateMutation = { __typename?: 'Mutation', Widget?: { __typename?: 'Widget', id: number, name?: string | null, type: WidgetType, screenShotBlobId?: number | null, isArchived: boolean, updatedAt: any, screenShotBlob?: { __typename?: 'MonolithBlobModel', id: string, url: string } | null, widgetOptions?: Array<{ __typename?: 'WidgetOption', id: number, question?: string | null, fieldType: WidgetOptionFieldType, defaultValue?: string | null, isArchived: boolean }> | null, reportConfigs?: Array<{ __typename?: 'ReportConfig', id: number, reportId: number, newPageBefore: boolean }> | null } | null };

export type WidgetUploadScreenShotMutationVariables = Exact<{
  id: Scalars['Int'];
  file: Scalars['Upload'];
}>;


export type WidgetUploadScreenShotMutation = { __typename?: 'Mutation', WidgetUploadScreenShot: { __typename?: 'Widget', id: number, name?: string | null, type: WidgetType } };

export type WidgetUpdateMutationVariables = Exact<{
  type?: InputMaybe<WidgetType>;
  name?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
}>;


export type WidgetUpdateMutation = { __typename?: 'Mutation', WidgetUpdate?: { __typename?: 'Widget', id: number, name?: string | null, type: WidgetType } | null };

export type WidgetOptionCreateMutationVariables = Exact<{
  name: Scalars['String'];
  question?: InputMaybe<Scalars['String']>;
  defaultValue?: InputMaybe<Scalars['String']>;
  widgetId: Scalars['Int'];
  fieldType: WidgetOptionFieldType;
}>;


export type WidgetOptionCreateMutation = { __typename?: 'Mutation', WidgetOptions?: { __typename?: 'WidgetOption', id: number, name: string, fieldType: WidgetOptionFieldType, defaultValue?: string | null, question?: string | null, isArchived: boolean, widgetId: number } | null };

export type WidgetOptionUploadCoverPageImageMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type WidgetOptionUploadCoverPageImageMutation = { __typename?: 'Mutation', WidgetOptionUploadCoverPageImage: { __typename?: 'MonolithBlobModel', id: string, url: string } };

export type WidgetOptionUploadBrandedSoftSkillImageMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type WidgetOptionUploadBrandedSoftSkillImageMutation = { __typename?: 'Mutation', WidgetOptionUploadBrandedSoftSkillImage: { __typename?: 'MonolithBlobModel', id: string, url: string } };

export type SkillCategoryFindManyQueryVariables = Exact<{ [key: string]: never; }>;


export type SkillCategoryFindManyQuery = { __typename?: 'Query', SkillCategoryFindMany: Array<{ __typename?: 'SkillCategory', id: number, name: string }> };

export type GetAssessmentStageInviteUrlQueryVariables = Exact<{
  id: Scalars['ID'];
  locale: SupportedLocale;
}>;


export type GetAssessmentStageInviteUrlQuery = { __typename?: 'Query', assessmentStage: { __typename?: 'AssessmentStage', inviteUrl: string } };

export type AtsSettingsFieldsFragment = { __typename?: 'AtsSettingsGQLModel', companyId: number, progressionEnabled: boolean, applicationTrackingEnabled: boolean, interviewEvaluationResultsEnabled: boolean, aiInterviewResultsEnabled: boolean, assessmentResultsEnabled: boolean, aiShortlistResultsEnabled: boolean, allowedRejectionReasonIds?: Array<string> | null, rejectOnBehalfOfUserRemoteId?: string | null, candidatePullMode: AtsCandidatePullMode, stagePushEnabled: boolean, hiringTeamUserProvisioningEnabled: boolean, resultPush: Array<{ __typename?: 'AtsResultPushConfigGQLModel', resultType: AtsResultType, sendAssessmentOrder: boolean, sendResultLink: boolean, sendToAtsFields: boolean, sendToWorkdayObjects: boolean, objectAlias: string, completionStageRef?: string | null, fieldIds: { __typename?: 'AtsResultPushFieldIdsGQLModel', score?: string | null, resultUrl?: string | null, completionDate?: string | null, orderStatus?: string | null, integrityRisk?: string | null }, fieldAliases: { __typename?: 'AtsWorkdayFieldAliasesGQLModel', score?: string | null, resultUrl?: string | null, completionDate?: string | null, interviewName?: string | null, evaluatorName?: string | null, recommendedDecision?: string | null, evaluationId?: string | null, orderStatus?: string | null } }>, stageMap: Array<{ __typename?: 'AtsStageMapEntryGQLModel', szStageType: SzMappedStageType, atsStageRef: string, workdayStepIds: Array<string> }>, stageRejectionReasons: Array<{ __typename?: 'AtsStageRejectionReasonsEntryGQLModel', atsStageRef: string, rejectionReasonIds: Array<string>, defaultAutoRejectReasonId?: string | null }> };

export type AtsSettingsQueryVariables = Exact<{
  companyId: Scalars['Int'];
}>;


export type AtsSettingsQuery = { __typename?: 'Query', atsSettings?: { __typename?: 'AtsSettingsGQLModel', companyId: number, progressionEnabled: boolean, applicationTrackingEnabled: boolean, interviewEvaluationResultsEnabled: boolean, aiInterviewResultsEnabled: boolean, assessmentResultsEnabled: boolean, aiShortlistResultsEnabled: boolean, allowedRejectionReasonIds?: Array<string> | null, rejectOnBehalfOfUserRemoteId?: string | null, candidatePullMode: AtsCandidatePullMode, stagePushEnabled: boolean, hiringTeamUserProvisioningEnabled: boolean, resultPush: Array<{ __typename?: 'AtsResultPushConfigGQLModel', resultType: AtsResultType, sendAssessmentOrder: boolean, sendResultLink: boolean, sendToAtsFields: boolean, sendToWorkdayObjects: boolean, objectAlias: string, completionStageRef?: string | null, fieldIds: { __typename?: 'AtsResultPushFieldIdsGQLModel', score?: string | null, resultUrl?: string | null, completionDate?: string | null, orderStatus?: string | null, integrityRisk?: string | null }, fieldAliases: { __typename?: 'AtsWorkdayFieldAliasesGQLModel', score?: string | null, resultUrl?: string | null, completionDate?: string | null, interviewName?: string | null, evaluatorName?: string | null, recommendedDecision?: string | null, evaluationId?: string | null, orderStatus?: string | null } }>, stageMap: Array<{ __typename?: 'AtsStageMapEntryGQLModel', szStageType: SzMappedStageType, atsStageRef: string, workdayStepIds: Array<string> }>, stageRejectionReasons: Array<{ __typename?: 'AtsStageRejectionReasonsEntryGQLModel', atsStageRef: string, rejectionReasonIds: Array<string>, defaultAutoRejectReasonId?: string | null }> } | null };

export type AtsAllRejectionReasonsQueryVariables = Exact<{
  companyId: Scalars['Int'];
}>;


export type AtsAllRejectionReasonsQuery = { __typename?: 'Query', atsAllRejectionReasons: Array<{ __typename?: 'RejectionReasonGQLModel', id: string, name: string, remoteId: string }> };

export type AtsAllStagesQueryVariables = Exact<{
  companyId: Scalars['Int'];
}>;


export type AtsAllStagesQuery = { __typename?: 'Query', atsAllStages: { __typename?: 'AtsStageCatalogueGQLModel', companyId: number, missingRefCount: number, stages: Array<{ __typename?: 'AtsStageCatalogueEntryGQLModel', atsStageRef: string, name: string }> } };

export type CoderbyteWorkspaceFieldsFragment = { __typename?: 'CoderbyteWorkspace', id: number, companyId: number, companyName: string, externalId: string, dashboardUrl: string, status: CoderbyteWorkspaceStatus, adminEmail: string, webhookUrl: string, keySetAt?: any | null, adminPasswordSetAt?: any | null, keyVerifiedAt?: any | null, createdAt: any, updatedAt: any };

export type CoderbyteWorkspaceUserFieldsFragment = { __typename?: 'CoderbyteWorkspaceUser', id: number, userId: number, firstName?: string | null, lastName?: string | null, userEmail: string, coderbyteEmail: string, status: CoderbyteWorkspaceUserStatus, invitedAt?: any | null, activatedAt?: any | null, lastLoginAt?: any | null };

export type CoderbyteWorkspaceQueryVariables = Exact<{
  companyId: Scalars['Int'];
}>;


export type CoderbyteWorkspaceQuery = { __typename?: 'Query', coderbyteWorkspace?: { __typename?: 'CoderbyteWorkspace', id: number, companyId: number, companyName: string, externalId: string, dashboardUrl: string, status: CoderbyteWorkspaceStatus, adminEmail: string, webhookUrl: string, keySetAt?: any | null, adminPasswordSetAt?: any | null, keyVerifiedAt?: any | null, createdAt: any, updatedAt: any } | null };

export type CoderbyteWorkspacesQueryVariables = Exact<{ [key: string]: never; }>;


export type CoderbyteWorkspacesQuery = { __typename?: 'Query', coderbyteWorkspaces: Array<{ __typename?: 'CoderbyteWorkspace', id: number, companyId: number, companyName: string, externalId: string, dashboardUrl: string, status: CoderbyteWorkspaceStatus, adminEmail: string, webhookUrl: string, keySetAt?: any | null, adminPasswordSetAt?: any | null, keyVerifiedAt?: any | null, createdAt: any, updatedAt: any }> };

export type CoderbyteWorkspaceWithUsersQueryVariables = Exact<{
  companyId: Scalars['Int'];
}>;


export type CoderbyteWorkspaceWithUsersQuery = { __typename?: 'Query', coderbyteWorkspace?: { __typename?: 'CoderbyteWorkspace', id: number, companyId: number, companyName: string, externalId: string, dashboardUrl: string, status: CoderbyteWorkspaceStatus, adminEmail: string, webhookUrl: string, keySetAt?: any | null, adminPasswordSetAt?: any | null, keyVerifiedAt?: any | null, createdAt: any, updatedAt: any, users: Array<{ __typename?: 'CoderbyteWorkspaceUser', id: number, userId: number, firstName?: string | null, lastName?: string | null, userEmail: string, coderbyteEmail: string, status: CoderbyteWorkspaceUserStatus, invitedAt?: any | null, activatedAt?: any | null, lastLoginAt?: any | null }> } | null };

export type CoderbyteWorkspaceAdminPasswordQueryVariables = Exact<{
  companyId: Scalars['Int'];
}>;


export type CoderbyteWorkspaceAdminPasswordQuery = { __typename?: 'Query', coderbyteWorkspaceAdminPassword?: string | null };

export type CoderbyteWorkspaceApiKeyQueryVariables = Exact<{
  companyId: Scalars['Int'];
}>;


export type CoderbyteWorkspaceApiKeyQuery = { __typename?: 'Query', coderbyteWorkspaceApiKey?: string | null };

export type CompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type CompaniesQuery = { __typename?: 'Query', Companies?: Array<{ __typename?: 'Company', id: number, name: string, logoUrl?: string | null, atsPullJobsFromDate: any, allowedEmailDomains?: Array<string> | null, areCognitiveTestsBlocked: boolean, areRffSoftSkillsDisabled: boolean, isInterviewGuideScoresEnabled: boolean, isLegalAcknowledgementsEnabled: boolean, isSkillsEvaluationScoreEnabled: boolean, isViewGuidanceEnabled: boolean, isAssigneeManagedViaIntegration: boolean, rfuModelType: CompanyRfuModelType, createdAt: string, hideReports: boolean, reasonableAdjustmentsOption: { __typename?: 'ReasonableAdjustmentsOption', kind: ReasonableAdjustmentsOptionKind, value?: string | null }, assessmentExpiryOption?: { __typename?: 'AssessmentExpiryOption', duration: number, unit: AssessmentExpiryOptionUnit } | null, managerReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, candidateReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null }> | null };

export type CompanyQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CompanyQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: number, name: string, logoUrl?: string | null, atsPullJobsFromDate: any, allowedEmailDomains?: Array<string> | null, areCognitiveTestsBlocked: boolean, areRffSoftSkillsDisabled: boolean, isInterviewGuideScoresEnabled: boolean, isLegalAcknowledgementsEnabled: boolean, isSkillsEvaluationScoreEnabled: boolean, isViewGuidanceEnabled: boolean, isAssigneeManagedViaIntegration: boolean, rfuModelType: CompanyRfuModelType, createdAt: string, hideReports: boolean, reasonableAdjustmentsOption: { __typename?: 'ReasonableAdjustmentsOption', kind: ReasonableAdjustmentsOptionKind, value?: string | null }, assessmentExpiryOption?: { __typename?: 'AssessmentExpiryOption', duration: number, unit: AssessmentExpiryOptionUnit } | null, managerReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, candidateReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null } | null };

export type CompanySignatureFindManyQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']>;
}>;


export type CompanySignatureFindManyQuery = { __typename?: 'Query', CompanySignature?: Array<{ __typename?: 'CompanySignatureModel', id: number, companyId: number, isDefault: boolean, signature: string, signatureEmail: string }> | null };

export type CompanyFindManyByIdsQueryVariables = Exact<{
  ids: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type CompanyFindManyByIdsQuery = { __typename?: 'Query', CompanyFindManyByIds?: Array<{ __typename?: 'Company', id: number, name: string, logoUrl?: string | null, atsPullJobsFromDate: any, allowedEmailDomains?: Array<string> | null, areCognitiveTestsBlocked: boolean, areRffSoftSkillsDisabled: boolean, isInterviewGuideScoresEnabled: boolean, isLegalAcknowledgementsEnabled: boolean, isSkillsEvaluationScoreEnabled: boolean, isViewGuidanceEnabled: boolean, isAssigneeManagedViaIntegration: boolean, rfuModelType: CompanyRfuModelType, createdAt: string, hideReports: boolean, reasonableAdjustmentsOption: { __typename?: 'ReasonableAdjustmentsOption', kind: ReasonableAdjustmentsOptionKind, value?: string | null }, assessmentExpiryOption?: { __typename?: 'AssessmentExpiryOption', duration: number, unit: AssessmentExpiryOptionUnit } | null, managerReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, candidateReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null }> | null };

export type GetCompanyIdQueryVariables = Exact<{
  projectId: Scalars['Float'];
}>;


export type GetCompanyIdQuery = { __typename?: 'Query', getCompanyId: { __typename?: 'ProjectCompanyId', companyId: number } };

export type CompaniesPaginatedQueryVariables = Exact<{
  pagination?: InputMaybe<OffsetBasedPaginationArgs>;
  filters?: InputMaybe<CompaniesPaginatedFilters>;
  includeCompanyIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type CompaniesPaginatedQuery = { __typename?: 'Query', CompaniesPaginated: { __typename?: 'CompaniesPaginatedGQLModel', data?: Array<{ __typename?: 'Company', id: number, name: string, logoUrl?: string | null, atsPullJobsFromDate: any, allowedEmailDomains?: Array<string> | null, areCognitiveTestsBlocked: boolean, areRffSoftSkillsDisabled: boolean, isInterviewGuideScoresEnabled: boolean, isLegalAcknowledgementsEnabled: boolean, isSkillsEvaluationScoreEnabled: boolean, isViewGuidanceEnabled: boolean, isAssigneeManagedViaIntegration: boolean, rfuModelType: CompanyRfuModelType, createdAt: string, hideReports: boolean, reasonableAdjustmentsOption: { __typename?: 'ReasonableAdjustmentsOption', kind: ReasonableAdjustmentsOptionKind, value?: string | null }, assessmentExpiryOption?: { __typename?: 'AssessmentExpiryOption', duration: number, unit: AssessmentExpiryOptionUnit } | null, managerReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, candidateReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null }> | null, pageInfo?: { __typename?: 'Pageinfo', skip?: number | null, take?: number | null, itemsOnPage: number, itemsTotal: number, pageTotal: number, currentPage: number } | null } };

export type CompanyFindUsersQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CompanyFindUsersQuery = { __typename?: 'Query', companyUsers: Array<{ __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } | null> };

export type CompanyFindUsersPaginatedQueryVariables = Exact<{
  id: Scalars['Int'];
  skip: Scalars['Int'];
  take: Scalars['Int'];
}>;


export type CompanyFindUsersPaginatedQuery = { __typename?: 'Query', companyUsers: { __typename?: 'UserModelPaginated', data?: Array<{ __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> }> | null, pageInfo?: { __typename?: 'Pageinfo', skip?: number | null, take?: number | null, itemsOnPage: number, itemsTotal: number, pageTotal: number, currentPage: number } | null } };

export type CompanyGetDefaultReportsQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyGetDefaultReportsQuery = { __typename?: 'Query', CompanyGetDefaultReports: { __typename?: 'CompanyDefaultReports', managerReport: { __typename?: 'Report', id: number, name: string, type: ReportType }, candidateReport: { __typename?: 'Report', id: number, name: string, type: ReportType } } };

export type CompanyRolesQueryVariables = Exact<{
  companyId: Scalars['Int'];
}>;


export type CompanyRolesQuery = { __typename?: 'Query', CompanyRoles: Array<{ __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null }> };

export type CompanySettingChangesQueryVariables = Exact<{
  companyId: Scalars['Int'];
  pagination: OffsetBasedPaginationArgs;
  source?: InputMaybe<CompanySettingChangeSource>;
  settingSearch?: InputMaybe<Scalars['String']>;
  settingKeys?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  order: CompanySettingChangeOrderArgs;
}>;


export type CompanySettingChangesQuery = { __typename?: 'Query', companySettingChanges: { __typename?: 'PaginatedCompanySettingChangesModel', data?: Array<{ __typename?: 'CompanySettingChangeModel', id: number, changedById?: number | null, changedByDisplay?: string | null, source: CompanySettingChangeSource, setting: string, oldValue?: string | null, newValue?: string | null, mutationName: string, occurredAt: any }> | null, pageInfo?: { __typename?: 'Pageinfo', skip?: number | null, take?: number | null, itemsOnPage: number, itemsTotal: number, pageTotal: number, currentPage: number } | null } };

export type CompanyUsersFindManyPaginatedQueryVariables = Exact<{
  args: CompanyUsersArgs;
  order?: InputMaybe<CompanyUsersOrderOptions>;
  paginate?: InputMaybe<OffsetBasedPaginationArgs>;
}>;


export type CompanyUsersFindManyPaginatedQuery = { __typename?: 'Query', companyUsers: { __typename?: 'CompanyUserModelPaginated', data?: Array<{ __typename?: 'CompanyUser', group?: { __typename?: 'UserGroupModel', id: number, subId: string, companyId: number, name: string, description?: string | null, membersCount?: number | null, membersPreview?: Array<{ __typename?: 'UserGroupMemberPreview', id: number, firstName?: string | null, lastName?: string | null, email: string }> | null } | null, user?: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null } | null, inProjectTeam?: { __typename?: 'AssignmentStatus', asGroupMember?: boolean | null, asIndividual?: boolean | null } | null, inStageCandidate?: { __typename?: 'AssignmentStatus', asGroupMember?: boolean | null, asIndividual?: boolean | null } | null, inUserGroup?: { __typename?: 'AssignmentStatus', asGroupMember?: boolean | null, asIndividual?: boolean | null } | null }> | null, pageInfo?: { __typename?: 'Pageinfo', skip?: number | null, take?: number | null, itemsOnPage: number, itemsTotal: number, pageTotal: number, currentPage: number } | null } };

export type CompanyFindManyUsersWithRolesQueryVariables = Exact<{
  take: Scalars['Int'];
  skip: Scalars['Int'];
  userRoles: Array<IdentityPermissionRole> | IdentityPermissionRole;
  companyIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type CompanyFindManyUsersWithRolesQuery = { __typename?: 'Query', CompanyFindManyUsersWithRoles: { __typename?: 'CompanyUserInfoPaginated', total: number, companyUserInfo: Array<{ __typename?: 'CompanyUserInfo', company: { __typename?: 'Company', id: number, name: string }, companyUserAcrossAllRoles: { __typename?: 'CompanyUsersCount', companyId: number, totalUsers: number, totalUsersWithPassword: number }, companyUserAcrossEachRole: Array<{ __typename?: 'CompanyUsersWithRolesCount', companyId: number, totalUsersWithPassword: number, totalUsers: number, roleName: IdentityPermissionRole }> }> } };

export type TraitSoftSkillContextCsvGenerateAndUploadQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type TraitSoftSkillContextCsvGenerateAndUploadQuery = { __typename?: 'Query', TraitSoftSkillContextCsvGenerateAndUpload?: { __typename?: 'MonolithBlobModel', id: string, key: string, acl: Acl, extension: string, bucket: string, publishedName: string, url: string, contentType?: string | null, contentEncoding?: string | null, ownerService: string, createdAt: any, updatedAt: any, deletedAt?: any | null } | null };

export type GetFormReportCsvQueryVariables = Exact<{
  formManagerType: FormManagerType;
  formType: FormType;
  formOwnerId: Scalars['Int'];
  associatedId: Scalars['Int'];
}>;


export type GetFormReportCsvQuery = { __typename?: 'Query', getFormReportCSV?: string | null };

export type FormManagerTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type FormManagerTypesQuery = { __typename?: 'Query', FormReportFindFormManagerTypes?: { __typename?: 'FormReportIndividualQueries', formManagerTypes?: Array<FormManagerType> | null } | null };

export type FormTypesQueryVariables = Exact<{
  formManagerType: FormManagerType;
}>;


export type FormTypesQuery = { __typename?: 'Query', FormReportFindFormTypes?: { __typename?: 'FormReportIndividualQueries', formTypes?: Array<FormType> | null } | null };

export type FormOwnersQueryVariables = Exact<{
  formManagerType: FormManagerType;
  formType: FormType;
}>;


export type FormOwnersQuery = { __typename?: 'Query', FormReportFindFormOwners?: Array<{ __typename?: 'FormReportFormOwners', id?: number | null, name?: string | null }> | null };

export type FormAssociatesQueryVariables = Exact<{
  formManagerType: FormManagerType;
  formType: FormType;
  formOwnerId: Scalars['Int'];
}>;


export type FormAssociatesQuery = { __typename?: 'Query', FormReportFindAssociatedIds?: { __typename?: 'FormReportIndividualQueries', associatedIds?: Array<number> | null } | null };

export type InterviewGuideBlueprintQueryVariables = Exact<{
  subId: Scalars['ID'];
}>;


export type InterviewGuideBlueprintQuery = { __typename?: 'Query', InterviewGuideBlueprint: { __typename?: 'InterviewGuideBlueprintModel', id: string, subId: string, status: InterviewGuideBlueprintStatus, version: number, generationStatus: InterviewGuideBlueprintGenerationStatus, questions: Array<{ __typename?: 'InterviewGuideBlueprintQuestionModel', id: string, subId: string, type: InterviewGuideBlueprintQuestionType, position: number, content?: string | null, extraContent?: string | null, duration: number, isPlaceholder: boolean, isMandatory: boolean, isEditable: boolean, isEdited: boolean, softSkillJunctions: Array<{ __typename?: 'InterviewGuideBlueprintQuestionSoftSkill', softSkill: { __typename?: 'BasicBroadSoftSkill', id: number, name: string } | { __typename?: 'BasicFocusedSoftSkill', id: number, name: string } | { __typename?: 'BroadSoftSkill', id: number, name: string } | { __typename?: 'FocusedSoftSkill', id: number, name: string }, indicators: Array<{ __typename: 'SoftSkillIndicatorV1', indicator: string, description: string, reason: string, probe: string, trigger: string } | { __typename: 'SoftSkillIndicatorV2', indicator: string, description: string, reason: string, probe: string, trigger: string, scores: Array<{ __typename?: 'SoftSkillIndicatorV2Score', score: number, label: string, gateway_criteria: Array<string>, differentiation: string }>, negative_evidence: { __typename?: 'SoftSkillIndicatorV2NegativeEvidence', red_flags: Array<{ __typename?: 'SoftSkillIndicatorV2Pattern', pattern: string, example: string }>, score_reducing_patterns: Array<{ __typename?: 'SoftSkillIndicatorV2Pattern', pattern: string, example: string }> } }> }> }> } };

export type InterviewQuestionRoleLevelContentFindManyAndCountQueryVariables = Exact<{
  softSkillIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  traitIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  roleLevels?: InputMaybe<Array<ContentRoleLevel> | ContentRoleLevel>;
  classifications?: InputMaybe<Array<ContentClassification> | ContentClassification>;
  take: Scalars['Int'];
  page: Scalars['Int'];
  order?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type InterviewQuestionRoleLevelContentFindManyAndCountQuery = { __typename?: 'Query', interviewQuestionContent: { __typename?: 'InterviewQuestionRoleLevelPaginatedModel', count?: number | null, interviewQuestionContent?: Array<{ __typename?: 'InterviewQuestionRoleLevel', id: number, softSkillId: number, traitId: number, classification: ContentClassification, roleLevel: ContentRoleLevel, summary?: string | null, feedback?: string | null, reasonForQuestion?: string | null, mainQuestion?: string | null, subQuestions?: Array<string> | null, softSkill: { __typename?: 'BasicBroadSoftSkill', name: string } | { __typename?: 'BasicFocusedSoftSkill', name: string } | { __typename?: 'BroadSoftSkill', name: string } | { __typename?: 'FocusedSoftSkill', name: string }, trait?: { __typename?: 'Trait', name: string } | null }> | null } };

export type JobRoleFindOneQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type JobRoleFindOneQuery = { __typename?: 'Query', JobRoleFindOne?: { __typename?: 'JobRoleModel', companyId: number, createdAt: any, deletedAt?: any | null, id: number, name: string, qualifier?: string | null, roleLevel: ContentRoleLevel, updatedAt: any, family?: JobRoleFamily | null, skillsProfiles: Array<{ __typename?: 'SuccessProfile', calculationMethod: CalculationMethod, createdAt: any, deletedAt?: any | null, gradingMethod: GradingMethod, id: number, jobRoleId: number, status: SuccessProfileStatus, updatedAt: any, successProfileTechnicalSkills?: Array<{ __typename?: 'SuccessProfileTechnicalSkill', id: number, successProfileId: number, technicalSkillId: number, technicalSkill?: { __typename?: 'TechnicalSkill', id: number, name: string, subId: string } | null }> | null, successProfileSoftSkills?: Array<{ __typename?: 'SuccessProfileSoftSkill', id: number, softSkillId: number, type: SoftSkillType, name: string, weight: number, includeInCalibration: boolean, softSkill: { __typename?: 'BasicBroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BasicFocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, focusedSoftSkills: Array<{ __typename?: 'BasicFocusedSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'FocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, broadSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null }, successProfileSoftSkillTraits: Array<{ __typename?: 'SuccessProfileSoftSkillTrait', id: number, orientation?: number | null, traitId: number, weight: number, name?: string | null }>, successProfileSoftSkillDataSources?: Array<{ __typename?: 'SuccessProfileSoftSkillDataSource', id: number, dataSourceType: DataSourceType, softSkillType: SoftSkillType }> | null }> | null }> } | null };

export type JobRoleFindManyQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
}>;


export type JobRoleFindManyQuery = { __typename?: 'Query', JobRoleFindMany: Array<{ __typename?: 'JobRoleModel', companyId: number, createdAt: any, deletedAt?: any | null, id: number, name: string, qualifier?: string | null, roleLevel: ContentRoleLevel, updatedAt: any, skillsProfiles: Array<{ __typename?: 'SuccessProfile', id: number, createdAt: any }> }> };

export type JobRoleFindManyPaginatedQueryVariables = Exact<{
  pagination: OffsetBasedPaginationArgs;
  order?: InputMaybe<JobRoleFindManyPaginatedOrderArgs>;
  filters?: InputMaybe<JobRoleFindManyPaginatedFiltersArgs>;
}>;


export type JobRoleFindManyPaginatedQuery = { __typename?: 'Query', JobRoleFindManyPaginated: { __typename?: 'JobRolePaginated', data: Array<{ __typename?: 'JobRolePaginatedData', id: number, subId: string, createdAt: any, updatedAt: any, name: string, qualifier?: string | null, roleLevel: ContentRoleLevel, family?: JobRoleFamily | null, projectsCount: number, source: JobRoleSource, company: { __typename?: 'Company', id: number, name: string }, skillsProfiles: Array<{ __typename?: 'SuccessProfile', calculationMethod: CalculationMethod, createdAt: any, deletedAt?: any | null, gradingMethod: GradingMethod, id: number, jobRoleId: number, status: SuccessProfileStatus, updatedAt: any, successProfileSoftSkills?: Array<{ __typename?: 'SuccessProfileSoftSkill', id: number, softSkillId: number, name: string, softSkill: { __typename?: 'BasicBroadSoftSkill', subId: string, category: SoftSkillCategory } | { __typename?: 'BasicFocusedSoftSkill', subId: string, category: SoftSkillCategory } | { __typename?: 'BroadSoftSkill', subId: string, category: SoftSkillCategory } | { __typename?: 'FocusedSoftSkill', subId: string, category: SoftSkillCategory } }> | null }> }>, page: { __typename?: 'Pageinfo', skip?: number | null, take?: number | null, itemsOnPage: number, itemsTotal: number, pageTotal: number, currentPage: number } } };

export type KomboIntegrationFindOneQueryVariables = Exact<{
  companyId: Scalars['Int'];
}>;


export type KomboIntegrationFindOneQuery = { __typename?: 'Query', komboIntegrationsFindOne?: { __typename?: 'KomboIntegrationModel', id: string, tool: string, enabled: boolean, assessmentIntegrationId?: string | null } | null };

export type KomboIntegrationListFieldsFragment = { __typename?: 'KomboIntegrationModel', id: string, companyId: number, tool: string, enabled: boolean, atsIntegrationId?: string | null, assessmentIntegrationId?: string | null, latestSyncRun?: { __typename?: 'KomboSyncRunModel', id: string, status: KomboSyncRunStatus, completedAt?: any | null } | null };

export type KomboIntegrationsListQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
}>;


export type KomboIntegrationsListQuery = { __typename?: 'Query', komboIntegrationsFindManyPaginated: { __typename?: 'KomboIntegrationPaginated', data?: Array<{ __typename?: 'KomboIntegrationModel', id: string, companyId: number, tool: string, enabled: boolean, atsIntegrationId?: string | null, assessmentIntegrationId?: string | null, latestSyncRun?: { __typename?: 'KomboSyncRunModel', id: string, status: KomboSyncRunStatus, completedAt?: any | null } | null }> | null, pageInfo?: { __typename?: 'Pageinfo', itemsTotal: number } | null } };

export type ProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectsQuery = { __typename?: 'Query', projects: Array<{ __typename?: 'Project', companySignatureId?: number | null, createdAt: string, creatorId?: number | null, publishedAt?: any | null, source: ProjectSource, id: number, isArchived: boolean, isStopped: boolean, locales: Array<SupportedLocale>, primaryLocale: SupportedLocale, moduleType: ProjectModuleType, name: string, requireSheetsExport: boolean, updatedAt: string, version: number, productSolution?: ProductSolution | null, subId: string, indirectInviteSSOEnabled?: boolean | null, isIntegrityMonitoringEnabled: boolean, isAiInterviewScoreHidden: boolean, status: ProjectStatus, projectCandidatesCount: number, company?: { __typename?: 'ProjectCompany', id: number, name: string, logoUrl?: string | null } | null, publishedBy?: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } | null, teamMembers?: Array<{ __typename?: 'ProjectManager', email?: string | null, firstName?: string | null, id: number, lastName?: string | null, userId?: number | null }> | null, assessmentStagesV2: Array<{ __typename?: 'AssessmentStage', id: string, name: string, kind: AssessmentStageKind, startTime?: any | null, endTime?: any | null, cognitiveMode: CognitiveMode, createdAt: any, updatedAt: any, deletedAt?: any | null, assessmentExpiryOption?: { __typename?: 'AssessmentExpiryOption', duration: number, unit: AssessmentExpiryOptionUnit } | null, emailSettings: { __typename?: 'AssessmentStageEmailSettings', emailCandidateReport: boolean, managerReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, candidateReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, projectTeamEmailSettings: { __typename?: 'ProjectTeamEmailSettings', mode: ProjectTeamEmailMode, actorRoles: Array<ActorRole> } }, actions: { __typename?: 'AssessmentStageActions', aiInterview?: { __typename?: 'AiInterviewAssessmentStageAction', id: string, name: string, duration: number, livekitAgentName: LivekitAgentName, isAvatarEnabled: boolean, isTimingAgentEnabled: boolean } | null, dei?: { __typename?: 'DeiStageActionModel', completedCount: number, submittedCount: number, createdAt: any, deletedAt?: any | null, stageId: number, updatedAt: any, fields: { __typename?: 'DeiStageActionFieldsModel', hasAgeRangeField: boolean, hasDisabilityField: boolean, hasEthnicityField: boolean, hasGenderIdentityField: boolean, hasNeurodiversityField: boolean, hasReligiousBeliefsField: boolean, hasSexualOrientationField: boolean, hasDisabilityIdentifyField: boolean, hasNeurodivergenceIdentifyField: boolean, hasFreeSchoolMealsField: boolean } } | null, personalityTest?: { __typename?: 'PersonalityTestAssessmentStageActionNested', id: string, questionsPerTraitCount: number, selectedLocales: Array<SupportedLocale> } | null, cognitiveTests: Array<{ __typename?: 'CognitiveTestAssessmentStageActionNested', id: string, kind: CognitiveKind, sectionCount: number }>, roleSkillSelfAssessments: Array<{ __typename?: 'RssAssessmentModel', id: number, type: RssAssessmentType, stageId: number }>, coderbyte?: { __typename?: 'CoderbyteAssessmentStageActionNested', id: string, name: string, coderbyteTestId: string, details: { __typename?: 'CoderbyteAssessmentStageActionDetails', timeLimitInMinutes?: number | null, isFrozen: boolean, challengeCount?: number | null, multipleChoiceCount?: number | null } } | null, englishProficiency?: { __typename?: 'EnglishProficiencyAssessmentStageActionNested', id: string, requiredCefrLevel: CefrLevel } | null }, availableActions: Array<{ __typename?: 'StageAvailableActionModel', availability: StageActionAvailability, name: string, kind: AssessmentStageActionKind }> }>, interviewStages: Array<{ __typename?: 'InterviewStage', subId: string, projectId: number, createdAt: any, duration: number, name: string, focus: InterviewStageFocus, softSkills: Array<{ __typename?: 'BasicBroadSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'BasicFocusedSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'BroadSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'FocusedSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory }>, technicalSkills: Array<{ __typename?: 'TechnicalSkill', id: number, subId: string, name: string }> }>, creator?: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } | null, updatedBy?: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } | null }> };

export type GetProjectByIdQueryVariables = Exact<{
  id: Scalars['Float'];
}>;


export type GetProjectByIdQuery = { __typename?: 'Query', project?: { __typename?: 'Project', companySignatureId?: number | null, createdAt: string, creatorId?: number | null, publishedAt?: any | null, source: ProjectSource, id: number, isArchived: boolean, isStopped: boolean, locales: Array<SupportedLocale>, primaryLocale: SupportedLocale, moduleType: ProjectModuleType, name: string, requireSheetsExport: boolean, updatedAt: string, version: number, productSolution?: ProductSolution | null, subId: string, indirectInviteSSOEnabled?: boolean | null, isIntegrityMonitoringEnabled: boolean, isAiInterviewScoreHidden: boolean, status: ProjectStatus, projectCandidatesCount: number, company?: { __typename?: 'ProjectCompany', id: number, name: string, logoUrl?: string | null } | null, publishedBy?: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } | null, teamMembers?: Array<{ __typename?: 'ProjectManager', email?: string | null, firstName?: string | null, id: number, lastName?: string | null, userId?: number | null }> | null, assessmentStagesV2: Array<{ __typename?: 'AssessmentStage', id: string, name: string, kind: AssessmentStageKind, startTime?: any | null, endTime?: any | null, cognitiveMode: CognitiveMode, createdAt: any, updatedAt: any, deletedAt?: any | null, assessmentExpiryOption?: { __typename?: 'AssessmentExpiryOption', duration: number, unit: AssessmentExpiryOptionUnit } | null, emailSettings: { __typename?: 'AssessmentStageEmailSettings', emailCandidateReport: boolean, managerReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, candidateReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, projectTeamEmailSettings: { __typename?: 'ProjectTeamEmailSettings', mode: ProjectTeamEmailMode, actorRoles: Array<ActorRole> } }, actions: { __typename?: 'AssessmentStageActions', aiInterview?: { __typename?: 'AiInterviewAssessmentStageAction', id: string, name: string, duration: number, livekitAgentName: LivekitAgentName, isAvatarEnabled: boolean, isTimingAgentEnabled: boolean } | null, dei?: { __typename?: 'DeiStageActionModel', completedCount: number, submittedCount: number, createdAt: any, deletedAt?: any | null, stageId: number, updatedAt: any, fields: { __typename?: 'DeiStageActionFieldsModel', hasAgeRangeField: boolean, hasDisabilityField: boolean, hasEthnicityField: boolean, hasGenderIdentityField: boolean, hasNeurodiversityField: boolean, hasReligiousBeliefsField: boolean, hasSexualOrientationField: boolean, hasDisabilityIdentifyField: boolean, hasNeurodivergenceIdentifyField: boolean, hasFreeSchoolMealsField: boolean } } | null, personalityTest?: { __typename?: 'PersonalityTestAssessmentStageActionNested', id: string, questionsPerTraitCount: number, selectedLocales: Array<SupportedLocale> } | null, cognitiveTests: Array<{ __typename?: 'CognitiveTestAssessmentStageActionNested', id: string, kind: CognitiveKind, sectionCount: number }>, roleSkillSelfAssessments: Array<{ __typename?: 'RssAssessmentModel', id: number, type: RssAssessmentType, stageId: number }>, coderbyte?: { __typename?: 'CoderbyteAssessmentStageActionNested', id: string, name: string, coderbyteTestId: string, details: { __typename?: 'CoderbyteAssessmentStageActionDetails', timeLimitInMinutes?: number | null, isFrozen: boolean, challengeCount?: number | null, multipleChoiceCount?: number | null } } | null, englishProficiency?: { __typename?: 'EnglishProficiencyAssessmentStageActionNested', id: string, requiredCefrLevel: CefrLevel } | null }, availableActions: Array<{ __typename?: 'StageAvailableActionModel', availability: StageActionAvailability, name: string, kind: AssessmentStageActionKind }> }>, interviewStages: Array<{ __typename?: 'InterviewStage', subId: string, projectId: number, createdAt: any, duration: number, name: string, focus: InterviewStageFocus, softSkills: Array<{ __typename?: 'BasicBroadSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'BasicFocusedSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'BroadSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'FocusedSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory }>, technicalSkills: Array<{ __typename?: 'TechnicalSkill', id: number, subId: string, name: string }> }>, creator?: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } | null, updatedBy?: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } | null } | null };

export type ProjectBaseGetProjectByIdQueryVariables = Exact<{
  id: Scalars['Float'];
}>;


export type ProjectBaseGetProjectByIdQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: number, status: ProjectStatus, subId: string, description?: string | null, name: string, version: number, creatorId?: number | null, isArchived: boolean, isStopped: boolean, renderCandidateReport: boolean, companyId?: number | null, companySignatureId?: number | null, moduleType: ProjectModuleType, productSolution?: ProductSolution | null, createdAt: string, updatedAt: string, deletedAt?: string | null, locales: Array<SupportedLocale>, primaryLocale: SupportedLocale, indirectInviteSSOEnabled?: boolean | null, publishedAt?: any | null, lastCandidateActivity?: any | null, source: ProjectSource } | null };

export type ProjectFindManyByCompanyQueryVariables = Exact<{
  companyId: Scalars['Int'];
}>;


export type ProjectFindManyByCompanyQuery = { __typename?: 'Query', projects: Array<{ __typename?: 'Project', companySignatureId?: number | null, createdAt: string, creatorId?: number | null, publishedAt?: any | null, source: ProjectSource, id: number, isArchived: boolean, isStopped: boolean, locales: Array<SupportedLocale>, primaryLocale: SupportedLocale, moduleType: ProjectModuleType, name: string, requireSheetsExport: boolean, updatedAt: string, version: number, productSolution?: ProductSolution | null, subId: string, indirectInviteSSOEnabled?: boolean | null, isIntegrityMonitoringEnabled: boolean, isAiInterviewScoreHidden: boolean, status: ProjectStatus, projectCandidatesCount: number, company?: { __typename?: 'ProjectCompany', id: number, name: string, logoUrl?: string | null } | null, publishedBy?: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } | null, teamMembers?: Array<{ __typename?: 'ProjectManager', email?: string | null, firstName?: string | null, id: number, lastName?: string | null, userId?: number | null }> | null, assessmentStagesV2: Array<{ __typename?: 'AssessmentStage', id: string, name: string, kind: AssessmentStageKind, startTime?: any | null, endTime?: any | null, cognitiveMode: CognitiveMode, createdAt: any, updatedAt: any, deletedAt?: any | null, assessmentExpiryOption?: { __typename?: 'AssessmentExpiryOption', duration: number, unit: AssessmentExpiryOptionUnit } | null, emailSettings: { __typename?: 'AssessmentStageEmailSettings', emailCandidateReport: boolean, managerReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, candidateReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, projectTeamEmailSettings: { __typename?: 'ProjectTeamEmailSettings', mode: ProjectTeamEmailMode, actorRoles: Array<ActorRole> } }, actions: { __typename?: 'AssessmentStageActions', aiInterview?: { __typename?: 'AiInterviewAssessmentStageAction', id: string, name: string, duration: number, livekitAgentName: LivekitAgentName, isAvatarEnabled: boolean, isTimingAgentEnabled: boolean } | null, dei?: { __typename?: 'DeiStageActionModel', completedCount: number, submittedCount: number, createdAt: any, deletedAt?: any | null, stageId: number, updatedAt: any, fields: { __typename?: 'DeiStageActionFieldsModel', hasAgeRangeField: boolean, hasDisabilityField: boolean, hasEthnicityField: boolean, hasGenderIdentityField: boolean, hasNeurodiversityField: boolean, hasReligiousBeliefsField: boolean, hasSexualOrientationField: boolean, hasDisabilityIdentifyField: boolean, hasNeurodivergenceIdentifyField: boolean, hasFreeSchoolMealsField: boolean } } | null, personalityTest?: { __typename?: 'PersonalityTestAssessmentStageActionNested', id: string, questionsPerTraitCount: number, selectedLocales: Array<SupportedLocale> } | null, cognitiveTests: Array<{ __typename?: 'CognitiveTestAssessmentStageActionNested', id: string, kind: CognitiveKind, sectionCount: number }>, roleSkillSelfAssessments: Array<{ __typename?: 'RssAssessmentModel', id: number, type: RssAssessmentType, stageId: number }>, coderbyte?: { __typename?: 'CoderbyteAssessmentStageActionNested', id: string, name: string, coderbyteTestId: string, details: { __typename?: 'CoderbyteAssessmentStageActionDetails', timeLimitInMinutes?: number | null, isFrozen: boolean, challengeCount?: number | null, multipleChoiceCount?: number | null } } | null, englishProficiency?: { __typename?: 'EnglishProficiencyAssessmentStageActionNested', id: string, requiredCefrLevel: CefrLevel } | null }, availableActions: Array<{ __typename?: 'StageAvailableActionModel', availability: StageActionAvailability, name: string, kind: AssessmentStageActionKind }> }>, interviewStages: Array<{ __typename?: 'InterviewStage', subId: string, projectId: number, createdAt: any, duration: number, name: string, focus: InterviewStageFocus, softSkills: Array<{ __typename?: 'BasicBroadSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'BasicFocusedSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'BroadSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'FocusedSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory }>, technicalSkills: Array<{ __typename?: 'TechnicalSkill', id: number, subId: string, name: string }> }>, creator?: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } | null, updatedBy?: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } | null }> };

export type ResultsPageProjectFindManyByCompanyQueryVariables = Exact<{
  companyId: Scalars['Int'];
}>;


export type ResultsPageProjectFindManyByCompanyQuery = { __typename?: 'Query', projects: Array<{ __typename?: 'Project', id: number, name: string, isArchived: boolean, status: ProjectStatus }> };

export type ProjectsFindManyPaginatedQueryVariables = Exact<{
  filters?: InputMaybe<ProjectFilterArgs>;
  order?: InputMaybe<ProjectOrderArgs>;
  pagination?: InputMaybe<OffsetBasedPaginationArgs>;
}>;


export type ProjectsFindManyPaginatedQuery = { __typename?: 'Query', Projects: { __typename?: 'PaginatedProjectsModel', data?: Array<{ __typename?: 'Project', id: number, subId: string, name: string, createdAt: string, updatedAt: string, isStopped: boolean, isArchived: boolean, deletedAt?: string | null, projectCandidatesCount: number, publishedAt?: any | null, status: ProjectStatus, company?: { __typename?: 'ProjectCompany', id: number, name: string, logoUrl?: string | null } | null, assessmentStagesV2: Array<{ __typename?: 'AssessmentStage', id: string, name: string, kind: AssessmentStageKind, deletedAt?: any | null }>, interviewStages: Array<{ __typename?: 'InterviewStage', subId: string, name: string, createdAt: any }>, shortlistStages: Array<{ __typename?: 'ShortlistStage', subId: string }>, contentStages: Array<{ __typename?: 'ContentStageModel', subId: string }> }> | null, pageInfo?: { __typename?: 'Pageinfo', skip?: number | null, take?: number | null, itemsOnPage: number, itemsTotal: number, pageTotal: number, currentPage: number } | null } };

export type ProjectGetInterviewLinkCountQueryVariables = Exact<{
  projectId: Scalars['Int'];
}>;


export type ProjectGetInterviewLinkCountQuery = { __typename?: 'Query', ProjectGetInterviewLinkCount: number };

export type ProjectGetCandidateStageBreakdownQueryVariables = Exact<{
  projectId: Scalars['Int'];
}>;


export type ProjectGetCandidateStageBreakdownQuery = { __typename?: 'Query', ProjectGetCandidateStageBreakdown: Array<{ __typename?: 'ProjectCandidateStageBreakdown', category: ProjectCandidateStageCategory, candidatesCount: number, completedCount?: number | null }> };

export type ProjectGetAllowedTransitionsQueryVariables = Exact<{
  projectId: Scalars['Int'];
  app: SzApp;
}>;


export type ProjectGetAllowedTransitionsQuery = { __typename?: 'Query', ProjectGetAllowedTransitions: Array<ProjectStatus> };

export type ProjectValidatePolicyActionsQueryVariables = Exact<{
  projectId: Scalars['Int'];
  actions: Array<ProjectAction> | ProjectAction;
  app: SzApp;
}>;


export type ProjectValidatePolicyActionsQuery = { __typename?: 'Query', ProjectValidatePolicyActions: Array<boolean> };

export type HiringTeamUsersFindManyQueryVariables = Exact<{
  companyIds: Array<Scalars['Int']> | Scalars['Int'];
  search?: InputMaybe<Scalars['String']>;
}>;


export type HiringTeamUsersFindManyQuery = { __typename?: 'Query', HiringTeamUsersFindMany: Array<{ __typename?: 'HiringTeamUser', id: number, firstName: string, lastName: string, email?: string | null, companyId: number, companyName: string }> };

export type GetProjectCobrandingQueryVariables = Exact<{
  subId: Scalars['String'];
}>;


export type GetProjectCobrandingQuery = { __typename?: 'Query', getProjectCobranding: { __typename?: 'ProjectCobrandingModel', companyLogoUrl?: string | null, companyName: string, name: string, accentColor1?: string | null } };

export type ProjectCollaboratorsFindManyPaginatedQueryVariables = Exact<{
  args: ProjectCollaboratorArgs;
  order?: InputMaybe<ProjectCollaboratorOrderOptions>;
  paginate?: InputMaybe<OffsetBasedPaginationArgs>;
}>;


export type ProjectCollaboratorsFindManyPaginatedQuery = { __typename?: 'Query', collaborators?: { __typename?: 'ProjectCollaboratorPaginated', data?: Array<{ __typename?: 'ProjectCollaborator', id: number, actorRole?: ActorRole | null, userId?: number | null, groupId?: number | null, user?: { __typename?: 'ProjectCollaboratorUser', id: number, uuid: string, email: string, firstName?: string | null, lastName?: string | null, companyRoles?: Array<IdentityPermissionRole | null> | null, avatarUrl?: string | null } | null, group?: { __typename?: 'ProjectCollaboratorGroup', id: number, subId: string, name: string, description?: string | null, companyId: number, membersCount: number, membersPreview: Array<{ __typename?: 'ProjectCollaboratorGroupMembersPreview', id: number, uuid: string, firstName?: string | null, lastName?: string | null, email: string }> } | null }> | null, pageInfo?: { __typename?: 'Pageinfo', currentPage: number, itemsOnPage: number, itemsTotal: number, pageTotal: number, skip?: number | null, take?: number | null } | null } | null };

export type ProjectJobRoleFindManyQueryVariables = Exact<{
  id: Scalars['Int'];
  isMainRole?: InputMaybe<Scalars['Boolean']>;
}>;


export type ProjectJobRoleFindManyQuery = { __typename?: 'Query', ProjectJobRoleFindMany: Array<{ __typename?: 'ProjectJobRoleModel', id: number, createdAt: any, skillsProfileId: number, isLocalizedBenchmarkGroup?: boolean | null, isMainRole: boolean, jobRole: { __typename?: 'JobRoleModel', name: string, id: number, roleLevel: ContentRoleLevel, family?: JobRoleFamily | null, skillsProfiles: Array<{ __typename?: 'SuccessProfile', id: number, successProfileTechnicalSkills?: Array<{ __typename?: 'SuccessProfileTechnicalSkill', id: number, technicalSkill?: { __typename?: 'TechnicalSkill', id: number, name: string, subId: string } | null }> | null, successProfileSoftSkills?: Array<{ __typename?: 'SuccessProfileSoftSkill', id: number, softSkillId: number, name: string, softSkill: { __typename?: 'BasicBroadSoftSkill', subId: string, category: SoftSkillCategory } | { __typename?: 'BasicFocusedSoftSkill', subId: string, category: SoftSkillCategory } | { __typename?: 'BroadSoftSkill', subId: string, category: SoftSkillCategory } | { __typename?: 'FocusedSoftSkill', subId: string, category: SoftSkillCategory } }> | null }> }, project: { __typename?: 'Project', id: number, productSolution?: ProductSolution | null } }> };

export type ProjectsByJobRoleFindManyQueryVariables = Exact<{
  jobRoleId: Scalars['Int'];
}>;


export type ProjectsByJobRoleFindManyQuery = { __typename?: 'Query', ProjectJobRoleFindMany: Array<{ __typename?: 'ProjectJobRoleModel', project: { __typename?: 'Project', companySignatureId?: number | null, createdAt: string, creatorId?: number | null, publishedAt?: any | null, source: ProjectSource, id: number, isArchived: boolean, isStopped: boolean, locales: Array<SupportedLocale>, primaryLocale: SupportedLocale, moduleType: ProjectModuleType, name: string, requireSheetsExport: boolean, updatedAt: string, version: number, productSolution?: ProductSolution | null, subId: string, indirectInviteSSOEnabled?: boolean | null, isIntegrityMonitoringEnabled: boolean, isAiInterviewScoreHidden: boolean, status: ProjectStatus, projectCandidatesCount: number, company?: { __typename?: 'ProjectCompany', id: number, name: string, logoUrl?: string | null } | null, publishedBy?: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } | null, teamMembers?: Array<{ __typename?: 'ProjectManager', email?: string | null, firstName?: string | null, id: number, lastName?: string | null, userId?: number | null }> | null, assessmentStagesV2: Array<{ __typename?: 'AssessmentStage', id: string, name: string, kind: AssessmentStageKind, startTime?: any | null, endTime?: any | null, cognitiveMode: CognitiveMode, createdAt: any, updatedAt: any, deletedAt?: any | null, assessmentExpiryOption?: { __typename?: 'AssessmentExpiryOption', duration: number, unit: AssessmentExpiryOptionUnit } | null, emailSettings: { __typename?: 'AssessmentStageEmailSettings', emailCandidateReport: boolean, managerReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, candidateReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, projectTeamEmailSettings: { __typename?: 'ProjectTeamEmailSettings', mode: ProjectTeamEmailMode, actorRoles: Array<ActorRole> } }, actions: { __typename?: 'AssessmentStageActions', aiInterview?: { __typename?: 'AiInterviewAssessmentStageAction', id: string, name: string, duration: number, livekitAgentName: LivekitAgentName, isAvatarEnabled: boolean, isTimingAgentEnabled: boolean } | null, dei?: { __typename?: 'DeiStageActionModel', completedCount: number, submittedCount: number, createdAt: any, deletedAt?: any | null, stageId: number, updatedAt: any, fields: { __typename?: 'DeiStageActionFieldsModel', hasAgeRangeField: boolean, hasDisabilityField: boolean, hasEthnicityField: boolean, hasGenderIdentityField: boolean, hasNeurodiversityField: boolean, hasReligiousBeliefsField: boolean, hasSexualOrientationField: boolean, hasDisabilityIdentifyField: boolean, hasNeurodivergenceIdentifyField: boolean, hasFreeSchoolMealsField: boolean } } | null, personalityTest?: { __typename?: 'PersonalityTestAssessmentStageActionNested', id: string, questionsPerTraitCount: number, selectedLocales: Array<SupportedLocale> } | null, cognitiveTests: Array<{ __typename?: 'CognitiveTestAssessmentStageActionNested', id: string, kind: CognitiveKind, sectionCount: number }>, roleSkillSelfAssessments: Array<{ __typename?: 'RssAssessmentModel', id: number, type: RssAssessmentType, stageId: number }>, coderbyte?: { __typename?: 'CoderbyteAssessmentStageActionNested', id: string, name: string, coderbyteTestId: string, details: { __typename?: 'CoderbyteAssessmentStageActionDetails', timeLimitInMinutes?: number | null, isFrozen: boolean, challengeCount?: number | null, multipleChoiceCount?: number | null } } | null, englishProficiency?: { __typename?: 'EnglishProficiencyAssessmentStageActionNested', id: string, requiredCefrLevel: CefrLevel } | null }, availableActions: Array<{ __typename?: 'StageAvailableActionModel', availability: StageActionAvailability, name: string, kind: AssessmentStageActionKind }> }>, interviewStages: Array<{ __typename?: 'InterviewStage', subId: string, projectId: number, createdAt: any, duration: number, name: string, focus: InterviewStageFocus, softSkills: Array<{ __typename?: 'BasicBroadSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'BasicFocusedSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'BroadSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'FocusedSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory }>, technicalSkills: Array<{ __typename?: 'TechnicalSkill', id: number, subId: string, name: string }> }>, creator?: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } | null, updatedBy?: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } | null } }> };

export type ProjectUserFindManyQueryVariables = Exact<{
  userIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type ProjectUserFindManyQuery = { __typename?: 'Query', ProjectUserFindMany: Array<{ __typename?: 'ProjectUser', actorRole?: ActorRole | null, project: { __typename?: 'Project', id: number, name: string, createdAt: string, isArchived: boolean, isStopped: boolean, moduleType: ProjectModuleType, requireSheetsExport: boolean, updatedAt: string, version: number, productSolution?: ProductSolution | null, subId: string, company?: { __typename?: 'ProjectCompany', id: number, name: string } | null, managers?: Array<{ __typename?: 'ProjectManager', email?: string | null, firstName?: string | null, id: number, lastName?: string | null, userId?: number | null }> | null }, user: { __typename?: 'User', id: number, email: string } }> };

export type ReportsQueryVariables = Exact<{ [key: string]: never; }>;


export type ReportsQuery = { __typename?: 'Query', Reports?: Array<{ __typename?: 'Report', id: number, name: string, type: ReportType, subType?: ReportSubType | null, footerType: ReportFooterType, isArchived: boolean, ownerId: number, ownerType: ReportOwnerType, createdAt: any, updatedAt: any, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string } | null, reportConfigs?: Array<{ __typename?: 'ReportConfig', id: number, newPageBefore: boolean, position: number, widgetConfigs?: Array<{ __typename?: 'WidgetConfig', id: number, settings: string, widgetOption?: { __typename?: 'WidgetOption', question?: string | null, fieldType: WidgetOptionFieldType, widgetId: number, id: number, defaultValue?: string | null } | null }> | null, widget: { __typename?: 'Widget', id: number, name?: string | null, isArchived: boolean, updatedAt: any, type: WidgetType } }> | null }> | null };

export type ReportQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ReportQuery = { __typename?: 'Query', report?: { __typename?: 'Report', id: number, name: string, type: ReportType, subType?: ReportSubType | null, footerType: ReportFooterType, isArchived: boolean, ownerId: number, ownerType: ReportOwnerType, createdAt: any, updatedAt: any, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string } | null, reportConfigs?: Array<{ __typename?: 'ReportConfig', id: number, newPageBefore: boolean, position: number, widgetConfigs?: Array<{ __typename?: 'WidgetConfig', id: number, settings: string, widgetOption?: { __typename?: 'WidgetOption', question?: string | null, fieldType: WidgetOptionFieldType, widgetId: number, id: number, defaultValue?: string | null } | null }> | null, widget: { __typename?: 'Widget', id: number, name?: string | null, isArchived: boolean, updatedAt: any, type: WidgetType } }> | null } | null };

export type ReportRenderFindManyQueryVariables = Exact<{
  dataSourceId?: InputMaybe<Scalars['Int']>;
  subType?: InputMaybe<ReportSubType>;
  reportRenderType?: InputMaybe<ReportRenderType>;
  projectJobRoleId?: InputMaybe<Scalars['Int']>;
}>;


export type ReportRenderFindManyQuery = { __typename?: 'Query', report?: Array<{ __typename?: 'ReportRender', id: number, subId: string, reportRenderStatus?: ReportRenderStatus | null }> | null };

export type ReportAssignmentFindStageReportQueryVariables = Exact<{
  type: ReportType;
  subType: ReportSubType;
  stageId?: InputMaybe<Scalars['Int']>;
  projectId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
}>;


export type ReportAssignmentFindStageReportQuery = { __typename?: 'Query', reports?: { __typename?: 'ReportAssignment', assignedId: number, assignedType: RAssignedType, id: number, inheritsSetting?: boolean | null, reportId: number, report: { __typename?: 'Report', id: number, name: string } } | null };

export type ReportFindManyQueryVariables = Exact<{
  type?: InputMaybe<ReportType>;
}>;


export type ReportFindManyQuery = { __typename?: 'Query', report?: Array<{ __typename?: 'Report', id: number, name: string, subType?: ReportSubType | null, type: ReportType }> | null };

export type ReportsFindByCompanyQueryVariables = Exact<{
  type?: InputMaybe<ReportType>;
  subType?: InputMaybe<ReportSubType>;
  ownerId?: InputMaybe<Scalars['Int']>;
  includeSharedReports: Scalars['Boolean'];
}>;


export type ReportsFindByCompanyQuery = { __typename?: 'Query', ReportsFindByCompany?: Array<{ __typename?: 'Report', id: number, name: string, ownerId: number }> | null };

export type ReportRenderQueryVariables = Exact<{
  subId: Scalars['String'];
}>;


export type ReportRenderQuery = { __typename?: 'Query', ReportRender?: { __typename?: 'ReportRender', id: number, subId: string, reportRenderStatus?: ReportRenderStatus | null, statusMessage?: string | null, blob?: { __typename?: 'MonolithBlobModel', url: string } | null } | null };

export type FindOneRoiCsvFileExportScheduledTaskQueryVariables = Exact<{
  subId?: InputMaybe<Scalars['String']>;
}>;


export type FindOneRoiCsvFileExportScheduledTaskQuery = { __typename?: 'Query', FindOneROICsvFileExportScheduledTask: { __typename?: 'FileExportScheduledTask', error?: string | null, status: ScheduledTaskStatus, subId: string, blob?: { __typename?: 'MonolithBlobModel', id: string, url: string } | null } };

export type RolesQueryVariables = Exact<{ [key: string]: never; }>;


export type RolesQuery = { __typename?: 'Query', Roles: Array<{ __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }> };

export type RoleFindManyQueryVariables = Exact<{
  filterForIdentity?: InputMaybe<Scalars['Boolean']>;
}>;


export type RoleFindManyQuery = { __typename?: 'Query', RoleFindMany: Array<{ __typename?: 'Role', id: number, description?: string | null, name: string, type: RoleType }> };

export type FindScheduledTaskQueryVariables = Exact<{
  subId?: InputMaybe<Scalars['String']>;
}>;


export type FindScheduledTaskQuery = { __typename?: 'Query', FindScheduledTask: { __typename?: 'FileExportScheduledTask', error?: string | null, status: ScheduledTaskStatus, subId: string, blob?: { __typename?: 'MonolithBlobModel', id: string, url: string, expiryDate?: any | null } | null } };

export type SkillsProfileSourceByJobRoleIdQueryVariables = Exact<{
  jobRoleId: Scalars['Int'];
}>;


export type SkillsProfileSourceByJobRoleIdQuery = { __typename?: 'Query', SkillsProfileSourceByJobRoleId?: { __typename?: 'SkillsProfileSource', subId: string } | null };

export type ResultValidatedSkillsQueryVariables = Exact<{
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  companyIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  take: Scalars['Int'];
  skip: Scalars['Int'];
}>;


export type ResultValidatedSkillsQuery = { __typename?: 'Query', ResultValidatedSkills: { __typename?: 'ResultValidatedSkillsPaginatedModel', total: number, resultValidatedSkills: Array<{ __typename?: 'ResultValidatedSkillsModel', totalValidateSkills: number, company: { __typename?: 'Company', id: number, name: string, logoUrl?: string | null, atsPullJobsFromDate: any, allowedEmailDomains?: Array<string> | null, areCognitiveTestsBlocked: boolean, areRffSoftSkillsDisabled: boolean, isInterviewGuideScoresEnabled: boolean, isLegalAcknowledgementsEnabled: boolean, isSkillsEvaluationScoreEnabled: boolean, isViewGuidanceEnabled: boolean, isAssigneeManagedViaIntegration: boolean, rfuModelType: CompanyRfuModelType, createdAt: string, hideReports: boolean, reasonableAdjustmentsOption: { __typename?: 'ReasonableAdjustmentsOption', kind: ReasonableAdjustmentsOptionKind, value?: string | null }, assessmentExpiryOption?: { __typename?: 'AssessmentExpiryOption', duration: number, unit: AssessmentExpiryOptionUnit } | null, managerReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, candidateReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null } }> } };

export type SoftSkillGetAllValidForProjectQueryVariables = Exact<{
  projectId: Scalars['Int'];
}>;


export type SoftSkillGetAllValidForProjectQuery = { __typename?: 'Query', softSkills: Array<{ __typename?: 'BasicBroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BasicFocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, focusedSoftSkills: Array<{ __typename?: 'BasicFocusedSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'FocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, broadSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null }> };

export type SoftSkillsQueryVariables = Exact<{ [key: string]: never; }>;


export type SoftSkillsQuery = { __typename?: 'Query', SoftSkills?: Array<{ __typename?: 'BasicBroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BasicFocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, focusedSoftSkills: Array<{ __typename?: 'BasicFocusedSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'FocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, broadSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null }> | null };

export type SoftSkillFindManyQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
}>;


export type SoftSkillFindManyQuery = { __typename?: 'Query', SoftSkillFindMany?: Array<{ __typename?: 'BasicBroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BasicFocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, focusedSoftSkills: Array<{ __typename?: 'BasicFocusedSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'FocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, broadSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null }> | null };

export type GetSzAndProvidedCompanySoftSkillsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']>;
}>;


export type GetSzAndProvidedCompanySoftSkillsQuery = { __typename?: 'Query', SZSoftSkills?: Array<{ __typename?: 'BasicBroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BasicFocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, focusedSoftSkills: Array<{ __typename?: 'BasicFocusedSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'FocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, broadSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null }> | null, CompanySoftSkills?: Array<{ __typename?: 'BasicBroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BasicFocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, focusedSoftSkills: Array<{ __typename?: 'BasicFocusedSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'FocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, broadSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null }> | null };

export type SoftSkillQueryVariables = Exact<{
  subId: Scalars['ID'];
}>;


export type SoftSkillQuery = { __typename?: 'Query', SoftSkill?: { __typename?: 'BasicBroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BasicFocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, focusedSoftSkills: Array<{ __typename?: 'BasicFocusedSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'FocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, broadSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | null };

export type SoftSkillFindManyPaginatedQueryVariables = Exact<{
  filters?: InputMaybe<SoftSkillFindManyPaginatedFilters>;
  pagination?: InputMaybe<OffsetBasedPaginationArgs>;
  order?: InputMaybe<SoftSkillFindManyPaginatedOrder>;
}>;


export type SoftSkillFindManyPaginatedQuery = { __typename?: 'Query', SoftSkillFindManyPaginated: { __typename?: 'PaginatedSoftSkillGQLModel', data?: Array<{ __typename?: 'BasicBroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BasicFocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, focusedSoftSkills: Array<{ __typename?: 'BasicFocusedSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'FocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, broadSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null }> | null, pageInfo?: { __typename?: 'Pageinfo', skip?: number | null, take?: number | null, itemsOnPage: number, itemsTotal: number, pageTotal: number, currentPage: number } | null } };

export type SoftSkillRoleLevelContentFindManyAndCountQueryVariables = Exact<{
  softSkillIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  roleLevels?: InputMaybe<Array<ContentRoleLevel> | ContentRoleLevel>;
  grades?: InputMaybe<Array<Grade> | Grade>;
  take: Scalars['Int'];
  page: Scalars['Int'];
  order?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type SoftSkillRoleLevelContentFindManyAndCountQuery = { __typename?: 'Query', softSkillContent: { __typename?: 'SoftSkillRoleLevelContentPaginated', count?: number | null, softSkillContent?: Array<{ __typename?: 'SoftSkillRoleLevelContent', id: number, softSkillId?: number | null, grade: Grade, roleLevel: ContentRoleLevel, description?: string | null, candidateContent?: string | null, hiringManagerContent?: string | null, internalCandidateContent?: string | null, softSkill: { __typename?: 'BasicBroadSoftSkill', id: number, name: string } | { __typename?: 'BasicFocusedSoftSkill', id: number, name: string } | { __typename?: 'BroadSoftSkill', id: number, name: string } | { __typename?: 'FocusedSoftSkill', id: number, name: string } }> | null } };

export type SoftSkillTraitsQueryVariables = Exact<{ [key: string]: never; }>;


export type SoftSkillTraitsQuery = { __typename?: 'Query', softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null };

export type FindSoftSkillTraitsBySsIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type FindSoftSkillTraitsBySsIdQuery = { __typename?: 'Query', softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null };

export type FindManySoftSkillTraitsBySsIdQueryVariables = Exact<{
  ids: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type FindManySoftSkillTraitsBySsIdQuery = { __typename?: 'Query', softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null };

export type GetProjectSamlAuthInfoQueryVariables = Exact<{
  projectId: Scalars['Float'];
}>;


export type GetProjectSamlAuthInfoQuery = { __typename?: 'Query', getProjectSamlAuthInfo: string };

export type StageFindManyQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars['Int']>;
  projectIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type StageFindManyQuery = { __typename?: 'Query', Stages?: Array<{ __typename?: 'SmStageModel', id: number, subId: string, name: string, kind: AssessmentStageKind, status: StageStatus, startTime?: any | null, endTime?: any | null, projectId: number, hasCalibration: boolean, createdAt: any, updatedAt: any, deletedAt?: any | null, emailCandidateReport: boolean, cognitiveMode: CognitiveMode, deiStageAction?: { __typename?: 'DeiStageActionModel', completedCount: number, submittedCount: number, createdAt: any, deletedAt?: any | null, stageId: number, updatedAt: any, fields: { __typename?: 'DeiStageActionFieldsModel', hasAgeRangeField: boolean, hasDisabilityField: boolean, hasEthnicityField: boolean, hasGenderIdentityField: boolean, hasNeurodiversityField: boolean, hasReligiousBeliefsField: boolean, hasSexualOrientationField: boolean, hasDisabilityIdentifyField: boolean, hasNeurodivergenceIdentifyField: boolean, hasFreeSchoolMealsField: boolean } } | null, availableActions: Array<{ __typename?: 'StageAvailableActionModel', availability: StageActionAvailability, name: string, kind: AssessmentStageActionKind }>, rssAssessments: Array<{ __typename?: 'RssAssessmentModel', id: number, type: RssAssessmentType, stageId: number }>, assessmentExpiryOption?: { __typename?: 'AssessmentExpiryOption', duration: number, unit: AssessmentExpiryOptionUnit } | null, managerReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, candidateReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, projectTeamEmailSettings: { __typename?: 'ProjectTeamEmailSettings', mode: ProjectTeamEmailMode, actorRoles: Array<ActorRole> } }> | null };

export type ResultsPageStageFindManyQueryVariables = Exact<{
  projectIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type ResultsPageStageFindManyQuery = { __typename?: 'Query', Stages?: Array<{ __typename?: 'SmStageModel', projectId: number, name: string, id: number }> | null };

export type StageQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type StageQuery = { __typename?: 'Query', Stage?: { __typename?: 'SmStageModel', id: number, subId: string, name: string, kind: AssessmentStageKind, status: StageStatus, startTime?: any | null, endTime?: any | null, projectId: number, hasCalibration: boolean, createdAt: any, updatedAt: any, deletedAt?: any | null, emailCandidateReport: boolean, cognitiveMode: CognitiveMode, deiStageAction?: { __typename?: 'DeiStageActionModel', completedCount: number, submittedCount: number, createdAt: any, deletedAt?: any | null, stageId: number, updatedAt: any, fields: { __typename?: 'DeiStageActionFieldsModel', hasAgeRangeField: boolean, hasDisabilityField: boolean, hasEthnicityField: boolean, hasGenderIdentityField: boolean, hasNeurodiversityField: boolean, hasReligiousBeliefsField: boolean, hasSexualOrientationField: boolean, hasDisabilityIdentifyField: boolean, hasNeurodivergenceIdentifyField: boolean, hasFreeSchoolMealsField: boolean } } | null, availableActions: Array<{ __typename?: 'StageAvailableActionModel', availability: StageActionAvailability, name: string, kind: AssessmentStageActionKind }>, rssAssessments: Array<{ __typename?: 'RssAssessmentModel', id: number, type: RssAssessmentType, stageId: number }>, assessmentExpiryOption?: { __typename?: 'AssessmentExpiryOption', duration: number, unit: AssessmentExpiryOptionUnit } | null, managerReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, candidateReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, projectTeamEmailSettings: { __typename?: 'ProjectTeamEmailSettings', mode: ProjectTeamEmailMode, actorRoles: Array<ActorRole> } } | null };

export type DeiStageActionQueryVariables = Exact<{
  stageId: Scalars['Int'];
}>;


export type DeiStageActionQuery = { __typename?: 'Query', DeiStageAction?: { __typename?: 'DeiStageActionModel', completedCount: number, submittedCount: number, createdAt: any, deletedAt?: any | null, stageId: number, updatedAt: any, fields: { __typename?: 'DeiStageActionFieldsModel', hasAgeRangeField: boolean, hasDisabilityField: boolean, hasEthnicityField: boolean, hasGenderIdentityField: boolean, hasNeurodiversityField: boolean, hasReligiousBeliefsField: boolean, hasSexualOrientationField: boolean, hasDisabilityIdentifyField: boolean, hasNeurodivergenceIdentifyField: boolean, hasFreeSchoolMealsField: boolean } } | null };

export type StageCandidateFindManyQueryVariables = Exact<{
  candidateId?: InputMaybe<Scalars['Int']>;
  relationDepth?: InputMaybe<RelationDepth>;
}>;


export type StageCandidateFindManyQuery = { __typename?: 'Query', StageCandidates?: Array<{ __typename?: 'SmStageCandidateModel', id: number, subId: string, companyId?: number | null, doneFor: number, doneBy: number, lastDateOfCandidateAction?: any | null, status: StageCandidateStatus, deiStageActionCandidate?: { __typename?: 'DeiStageActionCandidateModel', createdAt: any, status: DeiStageActionCandidateStatus, updatedAt: any, hasActiveConsent: boolean, consentEvents: Array<{ __typename?: 'DeiConsentEventModel', event: DeiConsentEventType, occurredAt: any, actorUserId?: number | null }> } | null, stage: { __typename?: 'SmStageModel', id: number, name: string, projectId: number, cognitiveMode: CognitiveMode }, rssAssessmentCandidates?: Array<{ __typename?: 'RssAssessmentCandidateModel', id: number, status: RssAssessmentCandidateStatus, updatedAt: any, rssAssessment: { __typename?: 'RssAssessmentModel', id: number, type: RssAssessmentType, stageId: number } }> | null, formCandidates?: Array<{ __typename?: 'FormCandidateModel', createdAt: any, deletedAt?: any | null, formId: number, id: number, stageCandidateId: number, status: FormCandidateStatus, subId: string, updatedAt: any, form: { __typename?: 'Form', formManagerType: FormManagerType, formOwnerName: string, formType: FormType, id: number, name: string } } | null> | null, projectCandidate: { __typename?: 'BasicProjectCandidate', subId: string, isExpired: boolean, expiresAt?: any | null }, personalityTestActionCandidate?: { __typename?: 'PersonalityTestAssessmentStageActionCandidate', id: string, status: PersonalityTestAssessmentStageActionCandidateStatus, assessmentId?: string | null } | null, cognitiveTestActionCandidates: Array<{ __typename?: 'CognitiveTestAssessmentStageActionCandidate', id: string, status: CognitiveTestAssessmentStageActionCandidateStatus, assessmentId?: string | null, timeModifierPercentage?: number | null, action: { __typename?: 'CognitiveTestAssessmentStageActionNested', id: string, kind: CognitiveKind } }>, actionCandidates: { __typename?: 'StageCandidateActionCandidates', coderbyte?: { __typename?: 'CoderbyteAssessmentStageActionCandidate', id: string, status: CoderbyteAssessmentStageActionCandidateStatus, timeModifierPercentage: number, action?: { __typename?: 'CoderbyteAssessmentStageActionNested', id: string, name: string, coderbyteTestId: string, details: { __typename?: 'CoderbyteAssessmentStageActionDetails', timeLimitInMinutes?: number | null } } | null } | null, englishProficiency?: { __typename?: 'EnglishProficiencyAssessmentStageActionCandidate', id: string, status: EnglishProficiencyAssessmentStageActionCandidateStatus, assessmentId?: string | null } | null } }> | null };

export type SuccessProfileQueryVariables = Exact<{
  projectId: Scalars['Int'];
}>;


export type SuccessProfileQuery = { __typename?: 'Query', SuccessProfile?: { __typename?: 'SuccessProfile', calculationMethod: CalculationMethod, createdAt: any, deletedAt?: any | null, gradingMethod: GradingMethod, id: number, jobRoleId: number, status: SuccessProfileStatus, updatedAt: any, successProfileTechnicalSkills?: Array<{ __typename?: 'SuccessProfileTechnicalSkill', id: number, successProfileId: number, technicalSkillId: number, technicalSkill?: { __typename?: 'TechnicalSkill', id: number, name: string, subId: string } | null }> | null, successProfileSoftSkills?: Array<{ __typename?: 'SuccessProfileSoftSkill', id: number, softSkillId: number, type: SoftSkillType, name: string, weight: number, includeInCalibration: boolean, softSkill: { __typename?: 'BasicBroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BasicFocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'BroadSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, focusedSoftSkills: Array<{ __typename?: 'BasicFocusedSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null } | { __typename?: 'FocusedSoftSkill', id: number, subId: string, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, taxonomyVersion: number, examples: Array<string>, deletedAt?: any | null, broadSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, similarSoftSkills: Array<{ __typename?: 'BasicBroadSoftSkill', subId: string, name: string }>, company?: { __typename?: 'Company', id: number, name: string, rfuModelType: CompanyRfuModelType } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null }> | null }, successProfileSoftSkillTraits: Array<{ __typename?: 'SuccessProfileSoftSkillTrait', id: number, orientation?: number | null, traitId: number, weight: number, name?: string | null }>, successProfileSoftSkillDataSources?: Array<{ __typename?: 'SuccessProfileSoftSkillDataSource', id: number, dataSourceType: DataSourceType, softSkillType: SoftSkillType }> | null }> | null } | null };

export type TechnicalSkillSearchQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
  skip: Scalars['Int'];
  take: Scalars['Int'];
  skillCategoryNames?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sortOrder?: InputMaybe<SortOption>;
  sortField?: InputMaybe<TechnicalSkillSortField>;
}>;


export type TechnicalSkillSearchQuery = { __typename?: 'Query', TechnicalSkillFreeTextSearchPaginated: { __typename?: 'PaginatedTechnicalSkill', total: number, technicalSkills: Array<{ __typename?: 'TechnicalSkill', id: number, createdAt: any, updatedAt: any, deletedAt?: any | null, iconBlobId?: number | null, name: string, description?: string | null, skillCategoryId?: number | null, subId: string, skillCategory?: { __typename?: 'SkillCategory', name: string } | null }> } };

export type TechnicalSkillFindManyQueryVariables = Exact<{ [key: string]: never; }>;


export type TechnicalSkillFindManyQuery = { __typename?: 'Query', TechnicalSkillFindMany: Array<{ __typename?: 'TechnicalSkill', id: number, createdAt: any, updatedAt: any, deletedAt?: any | null, iconBlobId?: number | null, name: string, description?: string | null, skillCategoryId?: number | null, subId: string, skillCategory?: { __typename?: 'SkillCategory', name: string } | null }> };

export type TechnicalSkillFindManyPaginatedQueryVariables = Exact<{
  semanticSearch?: InputMaybe<TechnicalSkillSemanticSearchArgs>;
  filters?: InputMaybe<TechnicalSkillFindManyPaginatedFilters>;
  order?: InputMaybe<TechnicalSkillFindManyPaginatedOrder>;
  pagination?: InputMaybe<OffsetBasedPaginationArgs>;
}>;


export type TechnicalSkillFindManyPaginatedQuery = { __typename?: 'Query', TechnicalSkillFindManyPaginated: { __typename?: 'PaginatedTechnicalSkillModel', data?: Array<{ __typename?: 'TechnicalSkill', id: number, createdAt: any, updatedAt: any, deletedAt?: any | null, iconBlobId?: number | null, name: string, description?: string | null, skillCategoryId?: number | null, subId: string, skillCategory?: { __typename?: 'SkillCategory', name: string } | null, company?: { __typename?: 'Company', id: number, name: string, logoUrl?: string | null, atsPullJobsFromDate: any, allowedEmailDomains?: Array<string> | null, areCognitiveTestsBlocked: boolean, areRffSoftSkillsDisabled: boolean, isInterviewGuideScoresEnabled: boolean, isLegalAcknowledgementsEnabled: boolean, isSkillsEvaluationScoreEnabled: boolean, isViewGuidanceEnabled: boolean, isAssigneeManagedViaIntegration: boolean, rfuModelType: CompanyRfuModelType, createdAt: string, hideReports: boolean, reasonableAdjustmentsOption: { __typename?: 'ReasonableAdjustmentsOption', kind: ReasonableAdjustmentsOptionKind, value?: string | null }, assessmentExpiryOption?: { __typename?: 'AssessmentExpiryOption', duration: number, unit: AssessmentExpiryOptionUnit } | null, managerReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, candidateReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null } | null }> | null, pageInfo?: { __typename?: 'Pageinfo', skip?: number | null, take?: number | null, itemsOnPage: number, itemsTotal: number, pageTotal: number, currentPage: number } | null } };

export type TechnicalSkillQueryVariables = Exact<{
  subId: Scalars['ID'];
}>;


export type TechnicalSkillQuery = { __typename?: 'Query', TechnicalSkill: { __typename?: 'TechnicalSkill', id: number, createdAt: any, updatedAt: any, deletedAt?: any | null, iconBlobId?: number | null, name: string, description?: string | null, skillCategoryId?: number | null, subId: string, skillCategory?: { __typename?: 'SkillCategory', name: string } | null, company?: { __typename?: 'Company', id: number, name: string, logoUrl?: string | null, atsPullJobsFromDate: any, allowedEmailDomains?: Array<string> | null, areCognitiveTestsBlocked: boolean, areRffSoftSkillsDisabled: boolean, isInterviewGuideScoresEnabled: boolean, isLegalAcknowledgementsEnabled: boolean, isSkillsEvaluationScoreEnabled: boolean, isViewGuidanceEnabled: boolean, isAssigneeManagedViaIntegration: boolean, rfuModelType: CompanyRfuModelType, createdAt: string, hideReports: boolean, reasonableAdjustmentsOption: { __typename?: 'ReasonableAdjustmentsOption', kind: ReasonableAdjustmentsOptionKind, value?: string | null }, assessmentExpiryOption?: { __typename?: 'AssessmentExpiryOption', duration: number, unit: AssessmentExpiryOptionUnit } | null, managerReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, candidateReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null } | null } };

export type TraitsQueryVariables = Exact<{
  isArchived?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type TraitsQuery = { __typename?: 'Query', Traits?: Array<{ __typename?: 'Trait', id: number, subId: string, name: string, description: string, isArchived: boolean, testTypes: Array<{ __typename?: 'TraitTestTypeModel', id: number, testSubType?: TestSubType | null, testType: TestType, traitId: number }> }> | null };

export type TraitRoleLevelContentFindManyAndCountQueryVariables = Exact<{
  softSkillIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  traitIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  roleLevels?: InputMaybe<Array<ContentRoleLevel> | ContentRoleLevel>;
  classifications?: InputMaybe<Array<ContentClassification> | ContentClassification>;
  take: Scalars['Int'];
  page: Scalars['Int'];
  order?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type TraitRoleLevelContentFindManyAndCountQuery = { __typename?: 'Query', traitContent: { __typename?: 'TraitRoleLevelContentPaginatedModel', count?: number | null, traitContent?: Array<{ __typename?: 'TraitRoleLevelContent', id?: number | null, softSkillId?: number | null, traitId?: number | null, classification: ContentClassification, roleLevel: ContentRoleLevel, summary?: string | null, content?: string | null, developmentContent?: string | null, softSkill: { __typename?: 'BasicBroadSoftSkill', name: string } | { __typename?: 'BasicFocusedSoftSkill', name: string } | { __typename?: 'BroadSoftSkill', name: string } | { __typename?: 'FocusedSoftSkill', name: string }, trait?: { __typename?: 'Trait', name: string } | null }> | null } };

export type UserQueryVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  subId?: InputMaybe<Scalars['String']>;
}>;


export type UserQuery = { __typename?: 'Query', User?: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } | null };

export type UsersQueryVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  subIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type UsersQuery = { __typename?: 'Query', Users?: Array<{ __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> }> | null };

export type UserFreeTextSearchPaginateQueryVariables = Exact<{
  freetext: Scalars['String'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type UserFreeTextSearchPaginateQuery = { __typename?: 'Query', Users?: { __typename?: 'UserModelPaginated', data?: Array<{ __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string }> | null, pageInfo?: { __typename?: 'Pageinfo', currentPage: number, itemsOnPage: number, itemsTotal: number, pageTotal: number, skip?: number | null, take?: number | null } | null } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } };

export type WidgetsQueryVariables = Exact<{ [key: string]: never; }>;


export type WidgetsQuery = { __typename?: 'Query', Widgets?: Array<{ __typename?: 'Widget', id: number, name?: string | null, type: WidgetType, screenShotBlobId?: number | null, isArchived: boolean, updatedAt: any, screenShotBlob?: { __typename?: 'MonolithBlobModel', id: string, url: string } | null, widgetOptions?: Array<{ __typename?: 'WidgetOption', id: number, question?: string | null, fieldType: WidgetOptionFieldType, defaultValue?: string | null, isArchived: boolean }> | null, reportConfigs?: Array<{ __typename?: 'ReportConfig', id: number, reportId: number, newPageBefore: boolean }> | null }> | null };

export type WidgetQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type WidgetQuery = { __typename?: 'Query', Widget?: { __typename?: 'Widget', id: number, name?: string | null, type: WidgetType, screenShotBlobId?: number | null, isArchived: boolean, screenShotBlob?: { __typename?: 'MonolithBlobModel', url: string, id: string } | null, widgetOptions?: Array<{ __typename?: 'WidgetOption', id: number, name: string, fieldType: WidgetOptionFieldType, question?: string | null, defaultValue?: string | null, isArchived: boolean }> | null, reportConfigs?: Array<{ __typename?: 'ReportConfig', id: number, reportId: number, newPageBefore: boolean, report: { __typename?: 'Report', id: number, name: string } }> | null } | null };

export type GetWidgetTypeEnumQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWidgetTypeEnumQuery = { __typename?: 'Query', __type?: { __typename?: '__Type', enumValues?: Array<{ __typename?: '__EnumValue', name: string, description?: string | null }> | null } | null };

export type UseGetProjectFromLocationHookProjectFragment = { __typename?: 'Project', id: number, name: string, company?: { __typename?: 'ProjectCompany', id: number, name: string } | null };

export type UseGetProjectFromLocationHookGetProjectByIdQueryVariables = Exact<{
  id: Scalars['Float'];
}>;


export type UseGetProjectFromLocationHookGetProjectByIdQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: number, name: string, company?: { __typename?: 'ProjectCompany', id: number, name: string } | null } | null };

export type UseProjectPolicyActionsHookProjectFragment = { __typename?: 'Project', id: number, name: string, status: ProjectStatus, source: ProjectSource, interviewStages: Array<{ __typename?: 'InterviewStage', subId: string }>, shortlistStages: Array<{ __typename?: 'ShortlistStage', subId: string }>, assessmentStagesV2: Array<{ __typename?: 'AssessmentStage', id: string }> };

export type UseProjectPolicyActionsHookGetProjectByIdQueryVariables = Exact<{
  id: Scalars['Float'];
}>;


export type UseProjectPolicyActionsHookGetProjectByIdQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: number, name: string, status: ProjectStatus, source: ProjectSource, interviewStages: Array<{ __typename?: 'InterviewStage', subId: string }>, shortlistStages: Array<{ __typename?: 'ShortlistStage', subId: string }>, assessmentStagesV2: Array<{ __typename?: 'AssessmentStage', id: string }> } | null };

export type CompaniesPageCompanyFragment = { __typename?: 'Company', id: number, name: string, logoUrl?: string | null };

export type CompaniesPageCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type CompaniesPageCompaniesQuery = { __typename?: 'Query', Companies?: Array<{ __typename?: 'Company', id: number, name: string, logoUrl?: string | null }> | null };

export type CompanyPageCompanyFragment = { __typename?: 'Company', id: number, name: string, logoUrl?: string | null, atsIdentifier?: string | null, atsPullJobsFromDate: any, allowedEmailDomains?: Array<string> | null, areCognitiveTestsBlocked: boolean, areRffSoftSkillsDisabled: boolean, isInterviewGuideScoresEnabled: boolean, isLegalAcknowledgementsEnabled: boolean, isLiveChatEnabled: boolean, isSkillsEvaluationScoreEnabled: boolean, isViewGuidanceEnabled: boolean, isAssigneeManagedViaIntegration: boolean, rfuModelType: CompanyRfuModelType, companyLifecycle: CompanyLifecycle, createdAt: string, hideReports: boolean, generateManagerReport: boolean, generateCandidateReport: boolean, emailCandidateReport: boolean, enableCompanyCodingAssessments: boolean, areMultiAssessmentStagesEnabled: boolean, isPersonalityTestMandatory: boolean, isAtsRoleCreationWithRequisitionEnabled: boolean, isAtsRoleCreationWithoutRequisitionEnabled: boolean, isRoleLiveEmailEnabled: boolean, isHiringTeamMemberAddedEmailEnabled: boolean, isIntegrityMonitoringAvailable: boolean, isIntegrityMonitoringAssessmentDefaultEnabled: boolean, isIntegrityMonitoringAiInterviewDefaultEnabled: boolean, isAiInterviewScoreHidingAvailable: boolean, isAiInterviewEnabled: boolean, isShortlistingEnabled: boolean, isAiShortlistNationalityScrutinyEnabled: boolean, isApplicationAnswerEvidenceEnabled: boolean, isAlternativeSupportEmailEnabled: boolean, alternativeSupportEmail?: string | null, explicitConsentEmail?: string | null, isWhitelabelingEnabled: boolean, isSpottedZebraScoreEnabled: boolean, reasonableAdjustmentsOption: { __typename?: 'ReasonableAdjustmentsOption', kind: ReasonableAdjustmentsOptionKind, value?: string | null }, assessmentExpiryOption?: { __typename?: 'AssessmentExpiryOption', duration: number, unit: AssessmentExpiryOptionUnit } | null, managerReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, candidateReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, csmUser?: { __typename?: 'User', id: number, firstName: string, lastName: string, email: string } | null, projectTeamEmailSettings: { __typename?: 'ProjectTeamEmailSettings', mode: ProjectTeamEmailMode, actorRoles: Array<ActorRole> } };

export type CompanyPageCompanyQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CompanyPageCompanyQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: number, name: string, logoUrl?: string | null, atsIdentifier?: string | null, atsPullJobsFromDate: any, allowedEmailDomains?: Array<string> | null, areCognitiveTestsBlocked: boolean, areRffSoftSkillsDisabled: boolean, isInterviewGuideScoresEnabled: boolean, isLegalAcknowledgementsEnabled: boolean, isLiveChatEnabled: boolean, isSkillsEvaluationScoreEnabled: boolean, isViewGuidanceEnabled: boolean, isAssigneeManagedViaIntegration: boolean, rfuModelType: CompanyRfuModelType, companyLifecycle: CompanyLifecycle, createdAt: string, hideReports: boolean, generateManagerReport: boolean, generateCandidateReport: boolean, emailCandidateReport: boolean, enableCompanyCodingAssessments: boolean, areMultiAssessmentStagesEnabled: boolean, isPersonalityTestMandatory: boolean, isAtsRoleCreationWithRequisitionEnabled: boolean, isAtsRoleCreationWithoutRequisitionEnabled: boolean, isRoleLiveEmailEnabled: boolean, isHiringTeamMemberAddedEmailEnabled: boolean, isIntegrityMonitoringAvailable: boolean, isIntegrityMonitoringAssessmentDefaultEnabled: boolean, isIntegrityMonitoringAiInterviewDefaultEnabled: boolean, isAiInterviewScoreHidingAvailable: boolean, isAiInterviewEnabled: boolean, isShortlistingEnabled: boolean, isAiShortlistNationalityScrutinyEnabled: boolean, isApplicationAnswerEvidenceEnabled: boolean, isAlternativeSupportEmailEnabled: boolean, alternativeSupportEmail?: string | null, explicitConsentEmail?: string | null, isWhitelabelingEnabled: boolean, isSpottedZebraScoreEnabled: boolean, reasonableAdjustmentsOption: { __typename?: 'ReasonableAdjustmentsOption', kind: ReasonableAdjustmentsOptionKind, value?: string | null }, assessmentExpiryOption?: { __typename?: 'AssessmentExpiryOption', duration: number, unit: AssessmentExpiryOptionUnit } | null, managerReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, candidateReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, csmUser?: { __typename?: 'User', id: number, firstName: string, lastName: string, email: string } | null, projectTeamEmailSettings: { __typename?: 'ProjectTeamEmailSettings', mode: ProjectTeamEmailMode, actorRoles: Array<ActorRole> } } | null };

export type CompanyPageUpdateCompanyMutationVariables = Exact<{
  id: Scalars['Int'];
  name: Scalars['String'];
  areCognitiveTestsBlocked?: InputMaybe<Scalars['Boolean']>;
  areRffSoftSkillsDisabled?: InputMaybe<Scalars['Boolean']>;
  isInterviewGuideScoresEnabled?: InputMaybe<Scalars['Boolean']>;
  isLegalAcknowledgementsEnabled?: InputMaybe<Scalars['Boolean']>;
  isLiveChatEnabled?: InputMaybe<Scalars['Boolean']>;
  isSkillsEvaluationScoreEnabled?: InputMaybe<Scalars['Boolean']>;
  isViewGuidanceEnabled?: InputMaybe<Scalars['Boolean']>;
  isAssigneeManagedViaIntegration?: InputMaybe<Scalars['Boolean']>;
  isRoleRequirementsEnabled?: InputMaybe<Scalars['Boolean']>;
  rfuModelType?: InputMaybe<CompanyRfuModelType>;
  companyLifecycle?: InputMaybe<CompanyLifecycle>;
  reasonableAdjustmentsOption?: InputMaybe<ReasonableAdjustmentsOptionArgs>;
  assessmentExpiryOption?: InputMaybe<AssessmentExpiryOptionArgs>;
  managerReportId?: InputMaybe<Scalars['Int']>;
  candidateReportId?: InputMaybe<Scalars['Int']>;
  csmUserId?: InputMaybe<Scalars['Int']>;
  hideReports?: InputMaybe<Scalars['Boolean']>;
  atsPullJobsFromDate?: InputMaybe<Scalars['Date']>;
  generateManagerReport?: InputMaybe<Scalars['Boolean']>;
  generateCandidateReport?: InputMaybe<Scalars['Boolean']>;
  emailCandidateReport?: InputMaybe<Scalars['Boolean']>;
  projectTeamEmailSettings?: InputMaybe<ProjectTeamEmailSettingsArgs>;
  enableCompanyCodingAssessments?: InputMaybe<Scalars['Boolean']>;
  areMultiAssessmentStagesEnabled?: InputMaybe<Scalars['Boolean']>;
  isPersonalityTestMandatory?: InputMaybe<Scalars['Boolean']>;
  isAtsRoleCreationWithRequisitionEnabled?: InputMaybe<Scalars['Boolean']>;
  isAtsRoleCreationWithoutRequisitionEnabled?: InputMaybe<Scalars['Boolean']>;
  isRoleLiveEmailEnabled?: InputMaybe<Scalars['Boolean']>;
  isHiringTeamMemberAddedEmailEnabled?: InputMaybe<Scalars['Boolean']>;
  isIntegrityMonitoringAvailable?: InputMaybe<Scalars['Boolean']>;
  isIntegrityMonitoringAssessmentDefaultEnabled?: InputMaybe<Scalars['Boolean']>;
  isIntegrityMonitoringAiInterviewDefaultEnabled?: InputMaybe<Scalars['Boolean']>;
  isAiInterviewScoreHidingAvailable?: InputMaybe<Scalars['Boolean']>;
  isAiInterviewEnabled?: InputMaybe<Scalars['Boolean']>;
  isShortlistingEnabled?: InputMaybe<Scalars['Boolean']>;
  isAiShortlistNationalityScrutinyEnabled?: InputMaybe<Scalars['Boolean']>;
  isApplicationAnswerEvidenceEnabled?: InputMaybe<Scalars['Boolean']>;
  isAlternativeSupportEmailEnabled?: InputMaybe<Scalars['Boolean']>;
  alternativeSupportEmail?: InputMaybe<Scalars['String']>;
  explicitConsentEmail?: InputMaybe<Scalars['String']>;
  isWhitelabelingEnabled?: InputMaybe<Scalars['Boolean']>;
  isSpottedZebraScoreEnabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type CompanyPageUpdateCompanyMutation = { __typename?: 'Mutation', Company: { __typename?: 'Company', id: number, name: string, logoUrl?: string | null, atsIdentifier?: string | null, atsPullJobsFromDate: any, allowedEmailDomains?: Array<string> | null, areCognitiveTestsBlocked: boolean, areRffSoftSkillsDisabled: boolean, isInterviewGuideScoresEnabled: boolean, isLegalAcknowledgementsEnabled: boolean, isLiveChatEnabled: boolean, isSkillsEvaluationScoreEnabled: boolean, isViewGuidanceEnabled: boolean, isAssigneeManagedViaIntegration: boolean, rfuModelType: CompanyRfuModelType, companyLifecycle: CompanyLifecycle, createdAt: string, hideReports: boolean, generateManagerReport: boolean, generateCandidateReport: boolean, emailCandidateReport: boolean, enableCompanyCodingAssessments: boolean, areMultiAssessmentStagesEnabled: boolean, isPersonalityTestMandatory: boolean, isAtsRoleCreationWithRequisitionEnabled: boolean, isAtsRoleCreationWithoutRequisitionEnabled: boolean, isRoleLiveEmailEnabled: boolean, isHiringTeamMemberAddedEmailEnabled: boolean, isIntegrityMonitoringAvailable: boolean, isIntegrityMonitoringAssessmentDefaultEnabled: boolean, isIntegrityMonitoringAiInterviewDefaultEnabled: boolean, isAiInterviewScoreHidingAvailable: boolean, isAiInterviewEnabled: boolean, isShortlistingEnabled: boolean, isAiShortlistNationalityScrutinyEnabled: boolean, isApplicationAnswerEvidenceEnabled: boolean, isAlternativeSupportEmailEnabled: boolean, alternativeSupportEmail?: string | null, explicitConsentEmail?: string | null, isWhitelabelingEnabled: boolean, isSpottedZebraScoreEnabled: boolean, reasonableAdjustmentsOption: { __typename?: 'ReasonableAdjustmentsOption', kind: ReasonableAdjustmentsOptionKind, value?: string | null }, assessmentExpiryOption?: { __typename?: 'AssessmentExpiryOption', duration: number, unit: AssessmentExpiryOptionUnit } | null, managerReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, candidateReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, csmUser?: { __typename?: 'User', id: number, firstName: string, lastName: string, email: string } | null, projectTeamEmailSettings: { __typename?: 'ProjectTeamEmailSettings', mode: ProjectTeamEmailMode, actorRoles: Array<ActorRole> } } };

export type ProjectPageCompanyFragment = { __typename?: 'Company', id: number, name: string, logoUrl?: string | null, atsPullJobsFromDate: any, allowedEmailDomains?: Array<string> | null, areCognitiveTestsBlocked: boolean, areRffSoftSkillsDisabled: boolean, areMultiAssessmentStagesEnabled: boolean, isInterviewGuideScoresEnabled: boolean, isLegalAcknowledgementsEnabled: boolean, isSkillsEvaluationScoreEnabled: boolean, isViewGuidanceEnabled: boolean, isAssigneeManagedViaIntegration: boolean, rfuModelType: CompanyRfuModelType, createdAt: string, hideReports: boolean, generateManagerReport: boolean, generateCandidateReport: boolean, emailCandidateReport: boolean, isIntegrityMonitoringAvailable: boolean, isAiInterviewScoreHidingAvailable: boolean, isShortlistingEnabled: boolean, isSpottedZebraScoreEnabled: boolean, reasonableAdjustmentsOption: { __typename?: 'ReasonableAdjustmentsOption', kind: ReasonableAdjustmentsOptionKind, value?: string | null }, assessmentExpiryOption?: { __typename?: 'AssessmentExpiryOption', duration: number, unit: AssessmentExpiryOptionUnit } | null, managerReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, candidateReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, projectTeamEmailSettings: { __typename?: 'ProjectTeamEmailSettings', mode: ProjectTeamEmailMode, actorRoles: Array<ActorRole> } };

export type ProjectPageCompanyQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ProjectPageCompanyQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: number, name: string, logoUrl?: string | null, atsPullJobsFromDate: any, allowedEmailDomains?: Array<string> | null, areCognitiveTestsBlocked: boolean, areRffSoftSkillsDisabled: boolean, areMultiAssessmentStagesEnabled: boolean, isInterviewGuideScoresEnabled: boolean, isLegalAcknowledgementsEnabled: boolean, isSkillsEvaluationScoreEnabled: boolean, isViewGuidanceEnabled: boolean, isAssigneeManagedViaIntegration: boolean, rfuModelType: CompanyRfuModelType, createdAt: string, hideReports: boolean, generateManagerReport: boolean, generateCandidateReport: boolean, emailCandidateReport: boolean, isIntegrityMonitoringAvailable: boolean, isAiInterviewScoreHidingAvailable: boolean, isShortlistingEnabled: boolean, isSpottedZebraScoreEnabled: boolean, reasonableAdjustmentsOption: { __typename?: 'ReasonableAdjustmentsOption', kind: ReasonableAdjustmentsOptionKind, value?: string | null }, assessmentExpiryOption?: { __typename?: 'AssessmentExpiryOption', duration: number, unit: AssessmentExpiryOptionUnit } | null, managerReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, candidateReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, projectTeamEmailSettings: { __typename?: 'ProjectTeamEmailSettings', mode: ProjectTeamEmailMode, actorRoles: Array<ActorRole> } } | null };

export type ProjectPageProjectFragment = { __typename?: 'Project', companySignatureId?: number | null, createdAt: string, creatorId?: number | null, publishedAt?: any | null, source: ProjectSource, id: number, isArchived: boolean, deletedAt?: string | null, isStopped: boolean, locales: Array<SupportedLocale>, primaryLocale: SupportedLocale, moduleType: ProjectModuleType, name: string, requireSheetsExport: boolean, updatedAt: string, version: number, productSolution?: ProductSolution | null, subId: string, indirectInviteSSOEnabled?: boolean | null, isIntegrityMonitoringEnabled: boolean, isAiInterviewScoreHidden: boolean, status: ProjectStatus, projectCandidatesCount: number, company?: { __typename?: 'ProjectCompany', id: number, name: string, logoUrl?: string | null } | null, publishedBy?: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } | null, teamMembers?: Array<{ __typename?: 'ProjectManager', email?: string | null, firstName?: string | null, id: number, lastName?: string | null, userId?: number | null }> | null, assessmentStages: Array<{ __typename?: 'SmStageModel', id: number, subId: string, scoringConfig?: { __typename?: 'StageScoringConfig', version: number, components: Array<{ __typename?: 'StageScoringComponentConfig', component: ScoreComponent, kind: ScoreComponentKind, weight: number, threshold?: number | null }> } | null }>, assessmentStagesV2: Array<{ __typename?: 'AssessmentStage', id: string, name: string, kind: AssessmentStageKind, startTime?: any | null, endTime?: any | null, cognitiveMode: CognitiveMode, createdAt: any, updatedAt: any, deletedAt?: any | null, assessmentExpiryOption?: { __typename?: 'AssessmentExpiryOption', duration: number, unit: AssessmentExpiryOptionUnit } | null, emailSettings: { __typename?: 'AssessmentStageEmailSettings', emailCandidateReport: boolean, managerReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, candidateReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, projectTeamEmailSettings: { __typename?: 'ProjectTeamEmailSettings', mode: ProjectTeamEmailMode, actorRoles: Array<ActorRole> } }, actions: { __typename?: 'AssessmentStageActions', aiInterview?: { __typename?: 'AiInterviewAssessmentStageAction', id: string, name: string, duration: number, livekitAgentName: LivekitAgentName, isAvatarEnabled: boolean, isTimingAgentEnabled: boolean } | null, dei?: { __typename?: 'DeiStageActionModel', completedCount: number, submittedCount: number, createdAt: any, deletedAt?: any | null, stageId: number, updatedAt: any, fields: { __typename?: 'DeiStageActionFieldsModel', hasAgeRangeField: boolean, hasDisabilityField: boolean, hasEthnicityField: boolean, hasGenderIdentityField: boolean, hasNeurodiversityField: boolean, hasReligiousBeliefsField: boolean, hasSexualOrientationField: boolean, hasDisabilityIdentifyField: boolean, hasNeurodivergenceIdentifyField: boolean, hasFreeSchoolMealsField: boolean } } | null, personalityTest?: { __typename?: 'PersonalityTestAssessmentStageActionNested', id: string, questionsPerTraitCount: number, selectedLocales: Array<SupportedLocale> } | null, cognitiveTests: Array<{ __typename?: 'CognitiveTestAssessmentStageActionNested', id: string, kind: CognitiveKind, sectionCount: number }>, roleSkillSelfAssessments: Array<{ __typename?: 'RssAssessmentModel', id: number, type: RssAssessmentType, stageId: number }>, coderbyte?: { __typename?: 'CoderbyteAssessmentStageActionNested', id: string, name: string, coderbyteTestId: string, details: { __typename?: 'CoderbyteAssessmentStageActionDetails', timeLimitInMinutes?: number | null, isFrozen: boolean, challengeCount?: number | null, multipleChoiceCount?: number | null } } | null, englishProficiency?: { __typename?: 'EnglishProficiencyAssessmentStageActionNested', id: string, requiredCefrLevel: CefrLevel } | null }, availableActions: Array<{ __typename?: 'StageAvailableActionModel', availability: StageActionAvailability, name: string, kind: AssessmentStageActionKind }> }>, interviewStages: Array<{ __typename?: 'InterviewStage', subId: string, projectId: number, createdAt: any, duration: number, name: string, focus: InterviewStageFocus, softSkills: Array<{ __typename?: 'BasicBroadSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'BasicFocusedSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'BroadSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'FocusedSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory }>, technicalSkills: Array<{ __typename?: 'TechnicalSkill', id: number, subId: string, name: string }> }>, creator?: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } | null, updatedBy?: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } | null, shortlistStages: Array<{ __typename?: 'ShortlistStage', subId: string, projectId: number, name: string, createdAt: any, updatedAt: any }> };

export type ProjectPageGetProjectByIdQueryVariables = Exact<{
  id: Scalars['Float'];
}>;


export type ProjectPageGetProjectByIdQuery = { __typename?: 'Query', project?: { __typename?: 'Project', companySignatureId?: number | null, createdAt: string, creatorId?: number | null, publishedAt?: any | null, source: ProjectSource, id: number, isArchived: boolean, deletedAt?: string | null, isStopped: boolean, locales: Array<SupportedLocale>, primaryLocale: SupportedLocale, moduleType: ProjectModuleType, name: string, requireSheetsExport: boolean, updatedAt: string, version: number, productSolution?: ProductSolution | null, subId: string, indirectInviteSSOEnabled?: boolean | null, isIntegrityMonitoringEnabled: boolean, isAiInterviewScoreHidden: boolean, status: ProjectStatus, projectCandidatesCount: number, company?: { __typename?: 'ProjectCompany', id: number, name: string, logoUrl?: string | null } | null, publishedBy?: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } | null, teamMembers?: Array<{ __typename?: 'ProjectManager', email?: string | null, firstName?: string | null, id: number, lastName?: string | null, userId?: number | null }> | null, assessmentStages: Array<{ __typename?: 'SmStageModel', id: number, subId: string, scoringConfig?: { __typename?: 'StageScoringConfig', version: number, components: Array<{ __typename?: 'StageScoringComponentConfig', component: ScoreComponent, kind: ScoreComponentKind, weight: number, threshold?: number | null }> } | null }>, assessmentStagesV2: Array<{ __typename?: 'AssessmentStage', id: string, name: string, kind: AssessmentStageKind, startTime?: any | null, endTime?: any | null, cognitiveMode: CognitiveMode, createdAt: any, updatedAt: any, deletedAt?: any | null, assessmentExpiryOption?: { __typename?: 'AssessmentExpiryOption', duration: number, unit: AssessmentExpiryOptionUnit } | null, emailSettings: { __typename?: 'AssessmentStageEmailSettings', emailCandidateReport: boolean, managerReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, candidateReport?: { __typename?: 'Report', id: number, name: string, type: ReportType } | null, projectTeamEmailSettings: { __typename?: 'ProjectTeamEmailSettings', mode: ProjectTeamEmailMode, actorRoles: Array<ActorRole> } }, actions: { __typename?: 'AssessmentStageActions', aiInterview?: { __typename?: 'AiInterviewAssessmentStageAction', id: string, name: string, duration: number, livekitAgentName: LivekitAgentName, isAvatarEnabled: boolean, isTimingAgentEnabled: boolean } | null, dei?: { __typename?: 'DeiStageActionModel', completedCount: number, submittedCount: number, createdAt: any, deletedAt?: any | null, stageId: number, updatedAt: any, fields: { __typename?: 'DeiStageActionFieldsModel', hasAgeRangeField: boolean, hasDisabilityField: boolean, hasEthnicityField: boolean, hasGenderIdentityField: boolean, hasNeurodiversityField: boolean, hasReligiousBeliefsField: boolean, hasSexualOrientationField: boolean, hasDisabilityIdentifyField: boolean, hasNeurodivergenceIdentifyField: boolean, hasFreeSchoolMealsField: boolean } } | null, personalityTest?: { __typename?: 'PersonalityTestAssessmentStageActionNested', id: string, questionsPerTraitCount: number, selectedLocales: Array<SupportedLocale> } | null, cognitiveTests: Array<{ __typename?: 'CognitiveTestAssessmentStageActionNested', id: string, kind: CognitiveKind, sectionCount: number }>, roleSkillSelfAssessments: Array<{ __typename?: 'RssAssessmentModel', id: number, type: RssAssessmentType, stageId: number }>, coderbyte?: { __typename?: 'CoderbyteAssessmentStageActionNested', id: string, name: string, coderbyteTestId: string, details: { __typename?: 'CoderbyteAssessmentStageActionDetails', timeLimitInMinutes?: number | null, isFrozen: boolean, challengeCount?: number | null, multipleChoiceCount?: number | null } } | null, englishProficiency?: { __typename?: 'EnglishProficiencyAssessmentStageActionNested', id: string, requiredCefrLevel: CefrLevel } | null }, availableActions: Array<{ __typename?: 'StageAvailableActionModel', availability: StageActionAvailability, name: string, kind: AssessmentStageActionKind }> }>, interviewStages: Array<{ __typename?: 'InterviewStage', subId: string, projectId: number, createdAt: any, duration: number, name: string, focus: InterviewStageFocus, softSkills: Array<{ __typename?: 'BasicBroadSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'BasicFocusedSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'BroadSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory } | { __typename?: 'FocusedSoftSkill', id: number, subId: string, name: string, category: SoftSkillCategory }>, technicalSkills: Array<{ __typename?: 'TechnicalSkill', id: number, subId: string, name: string }> }>, creator?: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } | null, updatedBy?: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, twoFactorEnabled: boolean, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null, type: RoleType }, samlAuthInfos?: Array<{ __typename?: 'SamlAuthInfoModel', subId: string }> | null } }> } | null, shortlistStages: Array<{ __typename?: 'ShortlistStage', subId: string, projectId: number, name: string, createdAt: any, updatedAt: any }> } | null };

export type ProjectAddShortlistStageMutationVariables = Exact<{
  subId: Scalars['ID'];
  name: Scalars['String'];
}>;


export type ProjectAddShortlistStageMutation = { __typename?: 'Mutation', ProjectAddShortlistStage: { __typename?: 'ProjectAddShortlistStage', project: { __typename?: 'Project', id: number, shortlistStages: Array<{ __typename?: 'ShortlistStage', subId: string, projectId: number, name: string, createdAt: any, updatedAt: any }> } } };

export type RoleArtefactsRoleFindOneQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RoleArtefactsRoleFindOneQuery = { __typename?: 'Query', RoleWizardRoleFindOne?: { __typename?: 'RoleModel', jobDescriptionFileName?: string | null, jobDescriptionProcessingStatus?: ProjectJobDescriptionProcessingStatus | null, meetingId?: string | null } | null };

export type RoleArtefactsMeetingFindOneQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type RoleArtefactsMeetingFindOneQuery = { __typename?: 'Query', MeetingFindOne?: { __typename?: 'MeetingModel', id: string, name: string } | null };

export type RoleArtefactsGetJobDescriptionUrlQueryVariables = Exact<{
  roleId: Scalars['Int'];
}>;


export type RoleArtefactsGetJobDescriptionUrlQuery = { __typename?: 'Query', RoleWizardGetJobDescriptionUrl?: string | null };

export type DuplicateModalJobRoleFragment = { __typename?: 'JobRoleModel', id: number, skillsProfiles: Array<{ __typename?: 'SuccessProfile', id: number, successProfileSoftSkills?: Array<{ __typename?: 'SuccessProfileSoftSkill', id: number, name: string, weight: number, softSkill: { __typename?: 'BasicBroadSoftSkill', category: SoftSkillCategory } | { __typename?: 'BasicFocusedSoftSkill', category: SoftSkillCategory } | { __typename?: 'BroadSoftSkill', category: SoftSkillCategory } | { __typename?: 'FocusedSoftSkill', category: SoftSkillCategory } }> | null, successProfileTechnicalSkills?: Array<{ __typename?: 'SuccessProfileTechnicalSkill', id: number, technicalSkill?: { __typename?: 'TechnicalSkill', name: string } | null }> | null }> };

export type ShallowJobRolePaginatedDataFragment = { __typename?: 'JobRolePaginatedData', id: number, subId: string, createdAt: any, name: string, qualifier?: string | null, roleLevel: ContentRoleLevel, family?: JobRoleFamily | null, source: JobRoleSource, skillsProfiles: Array<{ __typename?: 'SuccessProfile', id: number, successProfileSoftSkills?: Array<{ __typename?: 'SuccessProfileSoftSkill', id: number }> | null, successProfileTechnicalSkills?: Array<{ __typename?: 'SuccessProfileTechnicalSkill', id: number }> | null }> };

export type DuplicateJobRoleModalFindOneQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type DuplicateJobRoleModalFindOneQuery = { __typename?: 'Query', JobRoleFindOne?: { __typename?: 'JobRoleModel', id: number, skillsProfiles: Array<{ __typename?: 'SuccessProfile', id: number, successProfileSoftSkills?: Array<{ __typename?: 'SuccessProfileSoftSkill', id: number, name: string, weight: number, softSkill: { __typename?: 'BasicBroadSoftSkill', category: SoftSkillCategory } | { __typename?: 'BasicFocusedSoftSkill', category: SoftSkillCategory } | { __typename?: 'BroadSoftSkill', category: SoftSkillCategory } | { __typename?: 'FocusedSoftSkill', category: SoftSkillCategory } }> | null, successProfileTechnicalSkills?: Array<{ __typename?: 'SuccessProfileTechnicalSkill', id: number, technicalSkill?: { __typename?: 'TechnicalSkill', name: string } | null }> | null }> } | null };

export type DuplicateJobRoleModalPaginatedFragment = { __typename?: 'JobRolePaginated', data: Array<{ __typename?: 'JobRolePaginatedData', id: number, subId: string, createdAt: any, name: string, qualifier?: string | null, roleLevel: ContentRoleLevel, family?: JobRoleFamily | null, source: JobRoleSource, skillsProfiles: Array<{ __typename?: 'SuccessProfile', id: number, successProfileSoftSkills?: Array<{ __typename?: 'SuccessProfileSoftSkill', id: number }> | null, successProfileTechnicalSkills?: Array<{ __typename?: 'SuccessProfileTechnicalSkill', id: number }> | null }> }>, page: { __typename?: 'Pageinfo', skip?: number | null, take?: number | null, itemsOnPage: number, itemsTotal: number, pageTotal: number, currentPage: number } };

export type DuplicateJobRoleModalFindManyPaginatedQueryVariables = Exact<{
  pagination: OffsetBasedPaginationArgs;
  order?: InputMaybe<JobRoleFindManyPaginatedOrderArgs>;
  filters?: InputMaybe<JobRoleFindManyPaginatedFiltersArgs>;
}>;


export type DuplicateJobRoleModalFindManyPaginatedQuery = { __typename?: 'Query', JobRoleFindManyPaginated: { __typename?: 'JobRolePaginated', data: Array<{ __typename?: 'JobRolePaginatedData', id: number, subId: string, createdAt: any, name: string, qualifier?: string | null, roleLevel: ContentRoleLevel, family?: JobRoleFamily | null, source: JobRoleSource, skillsProfiles: Array<{ __typename?: 'SuccessProfile', id: number, successProfileSoftSkills?: Array<{ __typename?: 'SuccessProfileSoftSkill', id: number }> | null, successProfileTechnicalSkills?: Array<{ __typename?: 'SuccessProfileTechnicalSkill', id: number }> | null }> }>, page: { __typename?: 'Pageinfo', skip?: number | null, take?: number | null, itemsOnPage: number, itemsTotal: number, pageTotal: number, currentPage: number } } };

export type ExportsProjectsFindManyByCompanyQueryVariables = Exact<{
  companyId: Scalars['Int'];
}>;


export type ExportsProjectsFindManyByCompanyQuery = { __typename?: 'Query', projects: Array<{ __typename: 'Project', id: number, name: string, isArchived: boolean }> };

export type ExportsCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type ExportsCompaniesQuery = { __typename?: 'Query', Companies?: Array<{ __typename: 'Company', id: number, name: string }> | null };

export type ExportsProjectFindManysByCompanyWithStageCandidateRangeQueryVariables = Exact<{
  companyIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  createdAtFrom?: InputMaybe<Scalars['Date']>;
  createdAtTo?: InputMaybe<Scalars['Date']>;
}>;


export type ExportsProjectFindManysByCompanyWithStageCandidateRangeQuery = { __typename?: 'Query', projects: Array<{ __typename?: 'CompanyProjects', id: number, numberOfStageCandidates: number, percentageOfCompletedStageCandidates: number, numberOfCompletedInTimeFrameStageCandidates: number, company: { __typename?: 'Company', id: number, name: string }, projects: Array<{ __typename?: 'ProjectWithStageCandidates', id: number, name: string, numberOfStageCandidates: number, percentageOfCompletedStageCandidates: number, numberOfCompletedInTimeFrameStageCandidates: number }> }> };

export type UserPageProjectFragment = { __typename?: 'Project', id: number, status: ProjectStatus, subId: string, description?: string | null, name: string, version: number, creatorId?: number | null, isArchived: boolean, isStopped: boolean, renderCandidateReport: boolean, companyId?: number | null, companySignatureId?: number | null, moduleType: ProjectModuleType, productSolution?: ProductSolution | null, createdAt: string, updatedAt: string, deletedAt?: string | null, locales: Array<SupportedLocale>, primaryLocale: SupportedLocale, indirectInviteSSOEnabled?: boolean | null, publishedAt?: any | null, lastCandidateActivity?: any | null, source: ProjectSource, company?: { __typename?: 'ProjectCompany', id: number, name: string } | null };

export type UserPageGetProjectByIdQueryVariables = Exact<{
  id: Scalars['Float'];
}>;


export type UserPageGetProjectByIdQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: number, status: ProjectStatus, subId: string, description?: string | null, name: string, version: number, creatorId?: number | null, isArchived: boolean, isStopped: boolean, renderCandidateReport: boolean, companyId?: number | null, companySignatureId?: number | null, moduleType: ProjectModuleType, productSolution?: ProductSolution | null, createdAt: string, updatedAt: string, deletedAt?: string | null, locales: Array<SupportedLocale>, primaryLocale: SupportedLocale, indirectInviteSSOEnabled?: boolean | null, publishedAt?: any | null, lastCandidateActivity?: any | null, source: ProjectSource, company?: { __typename?: 'ProjectCompany', id: number, name: string } | null } | null };

export const TechnicalSkillFragmentDoc = gql`
    fragment TechnicalSkill on TechnicalSkill {
  id
  createdAt
  updatedAt
  deletedAt
  iconBlobId
  name
  description
  skillCategoryId
  skillCategory {
    name
  }
  subId
}
    `;
export const ShallowReportFragmentDoc = gql`
    fragment ShallowReport on Report {
  id
  name
  type
}
    `;
export const CompanyFragmentDoc = gql`
    fragment Company on Company {
  id
  name
  logoUrl
  atsPullJobsFromDate
  allowedEmailDomains
  areCognitiveTestsBlocked
  areRffSoftSkillsDisabled
  isInterviewGuideScoresEnabled
  isLegalAcknowledgementsEnabled
  isSkillsEvaluationScoreEnabled
  isViewGuidanceEnabled
  isAssigneeManagedViaIntegration
  rfuModelType
  createdAt
  reasonableAdjustmentsOption {
    kind
    value
  }
  assessmentExpiryOption {
    duration
    unit
  }
  managerReport {
    ...ShallowReport
  }
  candidateReport {
    ...ShallowReport
  }
  hideReports
}
    ${ShallowReportFragmentDoc}`;
export const TechnicalSkillWithCompanyFragmentDoc = gql`
    fragment TechnicalSkillWithCompany on TechnicalSkill {
  id
  createdAt
  updatedAt
  deletedAt
  iconBlobId
  name
  description
  skillCategoryId
  skillCategory {
    name
  }
  subId
  company {
    ...Company
  }
}
    ${CompanyFragmentDoc}`;
export const BlobFragmentDoc = gql`
    fragment Blob on MonolithBlobModel {
  id
  key
  acl
  extension
  bucket
  publishedName
  url
  contentType
  contentEncoding
  ownerService
  createdAt
  updatedAt
  deletedAt
}
    `;
export const BlobUrlFragmentDoc = gql`
    fragment BlobUrl on MonolithBlobModel {
  id
  url
}
    `;
export const ScheduledTaskBlobFragmentDoc = gql`
    fragment ScheduledTaskBlob on MonolithBlobModel {
  id
  url
  expiryDate
}
    `;
export const CompanySignatureModelFragmentDoc = gql`
    fragment CompanySignatureModel on CompanySignatureModel {
  id
  companyId
  isDefault
  signature
  signatureEmail
}
    `;
export const CompanyEmployeeFragmentDoc = gql`
    fragment CompanyEmployee on CompanyEmployeeModel {
  companyId
  createdAt
  customFields
  deletedAt
  department
  email
  employeeId
  endDate
  firstName
  hrManagerEmployeeId
  id
  isArchived
  jobTitle
  lastName
  startDate
  szUserId
  updatedAt
}
    `;
export const CompanyUsersCountFragmentDoc = gql`
    fragment CompanyUsersCount on CompanyUsersCount {
  companyId
  totalUsers
  totalUsersWithPassword
}
    `;
export const CompanyUsersWithRolesCountFragmentDoc = gql`
    fragment CompanyUsersWithRolesCount on CompanyUsersWithRolesCount {
  companyId
  totalUsersWithPassword
  totalUsers
  roleName
}
    `;
export const CompanyUserInfoFragmentDoc = gql`
    fragment CompanyUserInfo on CompanyUserInfo {
  company {
    ...Company
  }
  companyUserAcrossAllRoles {
    ...CompanyUsersCount
  }
  companyUserAcrossEachRole {
    ...CompanyUsersWithRolesCount
  }
}
    ${CompanyFragmentDoc}
${CompanyUsersCountFragmentDoc}
${CompanyUsersWithRolesCountFragmentDoc}`;
export const CompanyUserInfoPaginatedFragmentDoc = gql`
    fragment CompanyUserInfoPaginated on CompanyUserInfoPaginated {
  companyUserInfo {
    ...CompanyUserInfo
  }
  total
}
    ${CompanyUserInfoFragmentDoc}`;
export const ShallowCompanyUserInfoFragmentDoc = gql`
    fragment ShallowCompanyUserInfo on CompanyUserInfo {
  company {
    id
    name
  }
  companyUserAcrossAllRoles {
    ...CompanyUsersCount
  }
  companyUserAcrossEachRole {
    ...CompanyUsersWithRolesCount
  }
}
    ${CompanyUsersCountFragmentDoc}
${CompanyUsersWithRolesCountFragmentDoc}`;
export const ShallowCompanyUserInfoPaginatedFragmentDoc = gql`
    fragment ShallowCompanyUserInfoPaginated on CompanyUserInfoPaginated {
  companyUserInfo {
    ...ShallowCompanyUserInfo
  }
  total
}
    ${ShallowCompanyUserInfoFragmentDoc}`;
export const TechnicalSkillNameFragmentDoc = gql`
    fragment TechnicalSkillName on TechnicalSkill {
  id
  name
  subId
}
    `;
export const SuccessProfileTechnicalSkillFragmentDoc = gql`
    fragment SuccessProfileTechnicalSkill on SuccessProfileTechnicalSkill {
  id
  successProfileId
  technicalSkill {
    ...TechnicalSkillName
  }
  technicalSkillId
}
    ${TechnicalSkillNameFragmentDoc}`;
export const SoftSkillTraitFragmentDoc = gql`
    fragment SoftSkillTrait on SoftSkillTrait {
  id
  orientation
  weight
  traitId
  traitName
  trait {
    id
    name
  }
}
    `;
export const BasicFocusedSoftSkillFragmentDoc = gql`
    fragment BasicFocusedSoftSkill on SoftSkill {
  subId
  name
}
    `;
export const BasicBroadSoftSkillFragmentDoc = gql`
    fragment BasicBroadSoftSkill on SoftSkill {
  subId
  name
}
    `;
export const SoftSkillFragmentDoc = gql`
    fragment SoftSkill on SoftSkill {
  id
  subId
  name
  companyId
  category
  measurementConstructType
  description
  taxonomyVersion
  company {
    id
    name
    rfuModelType
  }
  softSkillTraits {
    ...SoftSkillTrait
  }
  examples
  deletedAt
  ... on BroadSoftSkill {
    focusedSoftSkills {
      ...BasicFocusedSoftSkill
    }
    similarSoftSkills {
      ...BasicBroadSoftSkill
    }
  }
  ... on FocusedSoftSkill {
    broadSoftSkills {
      ...BasicBroadSoftSkill
    }
    similarSoftSkills {
      ...BasicFocusedSoftSkill
    }
  }
}
    ${SoftSkillTraitFragmentDoc}
${BasicFocusedSoftSkillFragmentDoc}
${BasicBroadSoftSkillFragmentDoc}`;
export const SuccessProfileSoftSkillTraitFragmentDoc = gql`
    fragment SuccessProfileSoftSkillTrait on SuccessProfileSoftSkillTrait {
  id
  orientation
  traitId
  weight
  name
}
    `;
export const SuccessProfileSoftSkillFragmentDoc = gql`
    fragment SuccessProfileSoftSkill on SuccessProfileSoftSkill {
  id
  softSkillId
  type
  name
  weight
  includeInCalibration
  softSkill {
    ...SoftSkill
  }
  successProfileSoftSkillTraits {
    ...SuccessProfileSoftSkillTrait
  }
  successProfileSoftSkillDataSources {
    id
    dataSourceType
    softSkillType
  }
}
    ${SoftSkillFragmentDoc}
${SuccessProfileSoftSkillTraitFragmentDoc}`;
export const SuccessProfileFragmentDoc = gql`
    fragment SuccessProfile on SuccessProfile {
  calculationMethod
  createdAt
  deletedAt
  gradingMethod
  id
  jobRoleId
  status
  successProfileTechnicalSkills {
    ...SuccessProfileTechnicalSkill
  }
  successProfileSoftSkills {
    ...SuccessProfileSoftSkill
  }
  updatedAt
}
    ${SuccessProfileTechnicalSkillFragmentDoc}
${SuccessProfileSoftSkillFragmentDoc}`;
export const JobRoleFragmentDoc = gql`
    fragment JobRole on JobRoleModel {
  companyId
  createdAt
  deletedAt
  id
  name
  qualifier
  roleLevel
  skillsProfiles {
    ...SuccessProfile
  }
  updatedAt
  family
}
    ${SuccessProfileFragmentDoc}`;
export const JobRoleOverviewFragmentDoc = gql`
    fragment JobRoleOverview on JobRoleModel {
  companyId
  createdAt
  deletedAt
  id
  name
  qualifier
  roleLevel
  updatedAt
  skillsProfiles {
    id
    createdAt
  }
}
    `;
export const SuccessProfileShallowFragmentDoc = gql`
    fragment SuccessProfileShallow on SuccessProfile {
  calculationMethod
  createdAt
  deletedAt
  gradingMethod
  id
  jobRoleId
  status
  updatedAt
}
    `;
export const SuccessProfileSoftSkillNameAndCategoryFragmentDoc = gql`
    fragment SuccessProfileSoftSkillNameAndCategory on SuccessProfileSoftSkill {
  id
  softSkillId
  name
  softSkill {
    subId
    category
  }
}
    `;
export const SuccessProfileSkillWithOnlySoftSkillsFragmentDoc = gql`
    fragment SuccessProfileSkillWithOnlySoftSkills on SuccessProfile {
  ...SuccessProfileShallow
  successProfileSoftSkills {
    ...SuccessProfileSoftSkillNameAndCategory
  }
}
    ${SuccessProfileShallowFragmentDoc}
${SuccessProfileSoftSkillNameAndCategoryFragmentDoc}`;
export const JobRolePaginatedDataFragmentDoc = gql`
    fragment JobRolePaginatedData on JobRolePaginatedData {
  id
  subId
  createdAt
  updatedAt
  name
  qualifier
  roleLevel
  family
  company {
    id
    name
  }
  projectsCount
  source
  skillsProfiles {
    ...SuccessProfileSkillWithOnlySoftSkills
  }
}
    ${SuccessProfileSkillWithOnlySoftSkillsFragmentDoc}`;
export const PageInfoFragmentDoc = gql`
    fragment PageInfo on Pageinfo {
  skip
  take
  itemsOnPage
  itemsTotal
  pageTotal
  currentPage
}
    `;
export const JobRolePaginatedFragmentDoc = gql`
    fragment JobRolePaginated on JobRolePaginated {
  data {
    ...JobRolePaginatedData
  }
  page {
    ...PageInfo
  }
}
    ${JobRolePaginatedDataFragmentDoc}
${PageInfoFragmentDoc}`;
export const ProjectCompanyFragmentDoc = gql`
    fragment ProjectCompany on ProjectCompany {
  id
  name
  logoUrl
}
    `;
export const RoleFragmentDoc = gql`
    fragment Role on Role {
  id
  name
  description
  type
}
    `;
export const CompanyRoleFragmentDoc = gql`
    fragment CompanyRole on CompanyRole {
  companyId
  twoFactorEnabled
  role {
    ...Role
  }
  id
  samlAuthInfos {
    subId
  }
}
    ${RoleFragmentDoc}`;
export const UserRoleFragmentDoc = gql`
    fragment UserRole on UserRole {
  id
  userId
  companyRole {
    ...CompanyRole
  }
  externalId
}
    ${CompanyRoleFragmentDoc}`;
export const UserFragmentDoc = gql`
    fragment User on User {
  id
  subId
  firstName
  lastName
  email
  avatarUrl
  externalId
  twoFactorEnabled
  preferredLocale {
    source
    locale
  }
  roles {
    ...UserRole
  }
}
    ${UserRoleFragmentDoc}`;
export const ProjectManagerFragmentDoc = gql`
    fragment ProjectManager on ProjectManager {
  email
  firstName
  id
  lastName
  userId
}
    `;
export const DeiFieldsFragmentDoc = gql`
    fragment DeiFields on DeiStageActionFieldsModel {
  hasAgeRangeField
  hasDisabilityField
  hasEthnicityField
  hasGenderIdentityField
  hasNeurodiversityField
  hasReligiousBeliefsField
  hasSexualOrientationField
  hasDisabilityIdentifyField
  hasNeurodivergenceIdentifyField
  hasFreeSchoolMealsField
}
    `;
export const DeiStageActionFragmentDoc = gql`
    fragment DeiStageAction on DeiStageActionModel {
  completedCount
  submittedCount
  createdAt
  deletedAt
  fields {
    ...DeiFields
  }
  stageId
  updatedAt
}
    ${DeiFieldsFragmentDoc}`;
export const PersonalityTestActionFragmentDoc = gql`
    fragment PersonalityTestAction on PersonalityTestAssessmentStageActionNested {
  id
  questionsPerTraitCount
  selectedLocales
}
    `;
export const CognitiveTestActionFragmentDoc = gql`
    fragment CognitiveTestAction on CognitiveTestAssessmentStageActionNested {
  id
  kind
  sectionCount
}
    `;
export const RssAssessmentFragmentDoc = gql`
    fragment RssAssessment on RssAssessmentModel {
  id
  type
  stageId
}
    `;
export const CoderbyteStageActionFragmentDoc = gql`
    fragment CoderbyteStageAction on CoderbyteAssessmentStageActionNested {
  id
  name
  coderbyteTestId
  details {
    timeLimitInMinutes
    isFrozen
    challengeCount
    multipleChoiceCount
  }
}
    `;
export const EnglishProficiencyStageActionFragmentDoc = gql`
    fragment EnglishProficiencyStageAction on EnglishProficiencyAssessmentStageActionNested {
  id
  requiredCefrLevel
}
    `;
export const StageAvailableActionFragmentDoc = gql`
    fragment StageAvailableAction on StageAvailableActionModel {
  availability
  name
  kind
}
    `;
export const AssessmentStageFragmentFragmentDoc = gql`
    fragment AssessmentStageFragment on AssessmentStage {
  id
  name
  kind
  startTime
  endTime
  cognitiveMode
  createdAt
  updatedAt
  deletedAt
  assessmentExpiryOption {
    duration
    unit
  }
  emailSettings {
    emailCandidateReport
    managerReport {
      ...ShallowReport
    }
    candidateReport {
      ...ShallowReport
    }
    projectTeamEmailSettings {
      mode
      actorRoles
    }
  }
  actions {
    aiInterview {
      id
      name
      duration
      livekitAgentName
      isAvatarEnabled
      isTimingAgentEnabled
    }
    dei {
      ...DeiStageAction
    }
    personalityTest {
      ...PersonalityTestAction
    }
    cognitiveTests {
      ...CognitiveTestAction
    }
    roleSkillSelfAssessments {
      ...RssAssessment
    }
    coderbyte {
      ...CoderbyteStageAction
    }
    englishProficiency {
      ...EnglishProficiencyStageAction
    }
  }
  availableActions {
    ...StageAvailableAction
  }
}
    ${ShallowReportFragmentDoc}
${DeiStageActionFragmentDoc}
${PersonalityTestActionFragmentDoc}
${CognitiveTestActionFragmentDoc}
${RssAssessmentFragmentDoc}
${CoderbyteStageActionFragmentDoc}
${EnglishProficiencyStageActionFragmentDoc}
${StageAvailableActionFragmentDoc}`;
export const InterviewStageFragmentDoc = gql`
    fragment InterviewStage on InterviewStage {
  subId
  projectId
  createdAt
  duration
  name
  focus
  softSkills {
    id
    subId
    name
    category
  }
  technicalSkills {
    id
    subId
    name
  }
}
    `;
export const ProjectFragmentDoc = gql`
    fragment Project on Project {
  company {
    ...ProjectCompany
  }
  companySignatureId
  createdAt
  creatorId
  publishedAt
  publishedBy {
    ...User
  }
  source
  id
  isArchived
  isStopped
  locales
  primaryLocale
  teamMembers {
    ...ProjectManager
  }
  moduleType
  name
  requireSheetsExport
  updatedAt
  version
  productSolution
  subId
  indirectInviteSSOEnabled
  isIntegrityMonitoringEnabled
  isAiInterviewScoreHidden
  assessmentStagesV2 {
    ...AssessmentStageFragment
  }
  interviewStages {
    ...InterviewStage
  }
  status
  creator {
    ...User
  }
  updatedBy {
    ...User
  }
  projectCandidatesCount
}
    ${ProjectCompanyFragmentDoc}
${UserFragmentDoc}
${ProjectManagerFragmentDoc}
${AssessmentStageFragmentFragmentDoc}
${InterviewStageFragmentDoc}`;
export const ShallowAssessmentStageFragmentDoc = gql`
    fragment ShallowAssessmentStage on AssessmentStage {
  id
  name
  kind
  deletedAt
}
    `;
export const ShallowInterviewStageFragmentDoc = gql`
    fragment ShallowInterviewStage on InterviewStage {
  subId
  name
  createdAt
}
    `;
export const ProjectTableItemFragmentDoc = gql`
    fragment ProjectTableItem on Project {
  id
  subId
  name
  company {
    ...ProjectCompany
  }
  createdAt
  updatedAt
  isStopped
  isArchived
  deletedAt
  projectCandidatesCount
  assessmentStagesV2 {
    ...ShallowAssessmentStage
  }
  interviewStages {
    ...ShallowInterviewStage
  }
  shortlistStages {
    subId
  }
  contentStages {
    subId
  }
  publishedAt
  status
}
    ${ProjectCompanyFragmentDoc}
${ShallowAssessmentStageFragmentDoc}
${ShallowInterviewStageFragmentDoc}`;
export const SuccessProfileTechnicalSkillNameFragmentDoc = gql`
    fragment SuccessProfileTechnicalSkillName on SuccessProfileTechnicalSkill {
  id
  technicalSkill {
    ...TechnicalSkillName
  }
}
    ${TechnicalSkillNameFragmentDoc}`;
export const SuccessProfileSkillNamesFragmentDoc = gql`
    fragment SuccessProfileSkillNames on SuccessProfile {
  id
  successProfileTechnicalSkills {
    ...SuccessProfileTechnicalSkillName
  }
  successProfileSoftSkills {
    ...SuccessProfileSoftSkillNameAndCategory
  }
}
    ${SuccessProfileTechnicalSkillNameFragmentDoc}
${SuccessProfileSoftSkillNameAndCategoryFragmentDoc}`;
export const JobRoleNameFragmentDoc = gql`
    fragment JobRoleName on JobRoleModel {
  name
  id
  skillsProfiles {
    ...SuccessProfileSkillNames
  }
  roleLevel
  family
}
    ${SuccessProfileSkillNamesFragmentDoc}`;
export const ProjectJobRoleFragmentDoc = gql`
    fragment ProjectJobRole on ProjectJobRoleModel {
  id
  createdAt
  jobRole {
    ...JobRoleName
  }
  project {
    id
    productSolution
  }
  skillsProfileId
  isLocalizedBenchmarkGroup
  isMainRole
}
    ${JobRoleNameFragmentDoc}`;
export const ProjectWithStageCandidatesFragmentDoc = gql`
    fragment ProjectWithStageCandidates on ProjectWithStageCandidates {
  id
  name
  numberOfStageCandidates
  percentageOfCompletedStageCandidates
  numberOfCompletedInTimeFrameStageCandidates
}
    `;
export const ReportAssignmentFragmentDoc = gql`
    fragment ReportAssignment on ReportAssignment {
  assignedId
  assignedType
  id
  inheritsSetting
  reportId
  report {
    id
    name
  }
}
    `;
export const ReportFragmentDoc = gql`
    fragment Report on Report {
  id
  name
  type
  subType
  footerType
  isArchived
  ownerId
  ownerType
  createdAt
  updatedAt
  deletedAt
  company {
    id
    name
  }
  reportConfigs {
    id
    newPageBefore
    position
    widgetConfigs {
      id
      settings
      widgetOption {
        question
        fieldType
        widgetId
        id
        defaultValue
      }
    }
    widget {
      id
      name
      isArchived
      updatedAt
      type
    }
  }
}
    `;
export const ReportListItemFragmentDoc = gql`
    fragment ReportListItem on Report {
  id
  name
  type
  subType
  isArchived
  ownerId
  company {
    id
    name
  }
  ownerType
  createdAt
  updatedAt
  deletedAt
}
    `;
export const ResultValidatedSkillsModelFragmentDoc = gql`
    fragment ResultValidatedSkillsModel on ResultValidatedSkillsModel {
  company {
    ...Company
  }
  totalValidateSkills
}
    ${CompanyFragmentDoc}`;
export const ResultValidatedSkillsPaginatedModelFragmentDoc = gql`
    fragment ResultValidatedSkillsPaginatedModel on ResultValidatedSkillsPaginatedModel {
  resultValidatedSkills {
    ...ResultValidatedSkillsModel
  }
  total
}
    ${ResultValidatedSkillsModelFragmentDoc}`;
export const SmStageModelFragmentDoc = gql`
    fragment SmStageModel on SmStageModel {
  id
  subId
  name
  kind
  status
  startTime
  endTime
  projectId
  hasCalibration
  createdAt
  updatedAt
  deletedAt
  emailCandidateReport
  deiStageAction {
    ...DeiStageAction
  }
  availableActions {
    ...StageAvailableAction
  }
  rssAssessments {
    ...RssAssessment
  }
  assessmentExpiryOption {
    duration
    unit
  }
  cognitiveMode
  managerReport {
    ...ShallowReport
  }
  candidateReport {
    ...ShallowReport
  }
  projectTeamEmailSettings {
    mode
    actorRoles
  }
}
    ${DeiStageActionFragmentDoc}
${StageAvailableActionFragmentDoc}
${RssAssessmentFragmentDoc}
${ShallowReportFragmentDoc}`;
export const ShallowSmStageModelFragmentDoc = gql`
    fragment ShallowSmStageModel on SmStageModel {
  id
  name
}
    `;
export const DeiStageActionCandidateFragmentDoc = gql`
    fragment DeiStageActionCandidate on DeiStageActionCandidateModel {
  createdAt
  status
  updatedAt
  hasActiveConsent
  consentEvents {
    event
    occurredAt
    actorUserId
  }
}
    `;
export const RssAssessmentCandidateFragmentDoc = gql`
    fragment RssAssessmentCandidate on RssAssessmentCandidateModel {
  id
  status
  updatedAt
  rssAssessment {
    ...RssAssessment
  }
}
    ${RssAssessmentFragmentDoc}`;
export const FormFragmentDoc = gql`
    fragment Form on Form {
  formManagerType
  formOwnerName
  formType
  id
  name
}
    `;
export const FormCandidateModelFragmentDoc = gql`
    fragment FormCandidateModel on FormCandidateModel {
  createdAt
  deletedAt
  formId
  id
  stageCandidateId
  status
  subId
  updatedAt
  form {
    ...Form
  }
}
    ${FormFragmentDoc}`;
export const PersonalityTestActionCandidateFragmentDoc = gql`
    fragment PersonalityTestActionCandidate on PersonalityTestAssessmentStageActionCandidate {
  id
  status
  assessmentId
}
    `;
export const CognitiveTestActionCandidateFragmentDoc = gql`
    fragment CognitiveTestActionCandidate on CognitiveTestAssessmentStageActionCandidate {
  id
  status
  assessmentId
  timeModifierPercentage
  action {
    id
    kind
  }
}
    `;
export const CoderbyteActionCandidateFragmentDoc = gql`
    fragment CoderbyteActionCandidate on CoderbyteAssessmentStageActionCandidate {
  id
  status
  timeModifierPercentage
  action {
    id
    name
    coderbyteTestId
    details {
      timeLimitInMinutes
    }
  }
}
    `;
export const EnglishProficiencyActionCandidateFragmentDoc = gql`
    fragment EnglishProficiencyActionCandidate on EnglishProficiencyAssessmentStageActionCandidate {
  id
  status
  assessmentId
}
    `;
export const StageCandidateModelFragmentDoc = gql`
    fragment StageCandidateModel on SmStageCandidateModel {
  id
  subId
  companyId
  doneFor
  doneBy
  lastDateOfCandidateAction
  deiStageActionCandidate {
    ...DeiStageActionCandidate
  }
  stage {
    id
    name
    projectId
    cognitiveMode
  }
  status
  rssAssessmentCandidates {
    ...RssAssessmentCandidate
  }
  formCandidates {
    ...FormCandidateModel
  }
  projectCandidate {
    subId
    isExpired
    expiresAt
  }
  personalityTestActionCandidate {
    ...PersonalityTestActionCandidate
  }
  cognitiveTestActionCandidates {
    ...CognitiveTestActionCandidate
  }
  actionCandidates {
    coderbyte {
      ...CoderbyteActionCandidate
    }
    englishProficiency {
      ...EnglishProficiencyActionCandidate
    }
  }
}
    ${DeiStageActionCandidateFragmentDoc}
${RssAssessmentCandidateFragmentDoc}
${FormCandidateModelFragmentDoc}
${PersonalityTestActionCandidateFragmentDoc}
${CognitiveTestActionCandidateFragmentDoc}
${CoderbyteActionCandidateFragmentDoc}
${EnglishProficiencyActionCandidateFragmentDoc}`;
export const TraitTestTypeFragmentDoc = gql`
    fragment TraitTestType on TraitTestTypeModel {
  id
  testSubType
  testType
  traitId
}
    `;
export const TraitFragmentDoc = gql`
    fragment Trait on Trait {
  id
  subId
  name
  description
  isArchived
  testTypes {
    ...TraitTestType
  }
  subId
}
    ${TraitTestTypeFragmentDoc}`;
export const TraitSoftSkillContextFileUploadRowFragmentDoc = gql`
    fragment TraitSoftSkillContextFileUploadRow on TraitSoftSkillContextFileUploadLineModel {
  internalName
  level
  negativeSummary
  positiveSummary
  softSkillId
  traitId
}
    `;
export const ContentValidatiorPieceModelFragmentDoc = gql`
    fragment ContentValidatiorPieceModel on ContentValidatiorPieceModel {
  softSkillId
  softSkillName
  traitId
  traitName
  numOfSsContent
  numOfSsSpContent
  numOfTraitContent
  numOfIqContent
}
    `;
export const WidgetFragmentDoc = gql`
    fragment Widget on Widget {
  id
  name
  type
  screenShotBlob {
    id
    url
  }
  screenShotBlobId
  isArchived
  widgetOptions {
    id
    question
    fieldType
    defaultValue
    isArchived
  }
  reportConfigs {
    id
    reportId
    newPageBefore
  }
  updatedAt
}
    `;
export const AtsSettingsFieldsFragmentDoc = gql`
    fragment AtsSettingsFields on AtsSettingsGQLModel {
  companyId
  progressionEnabled
  applicationTrackingEnabled
  interviewEvaluationResultsEnabled
  aiInterviewResultsEnabled
  assessmentResultsEnabled
  aiShortlistResultsEnabled
  allowedRejectionReasonIds
  rejectOnBehalfOfUserRemoteId
  resultPush {
    resultType
    sendAssessmentOrder
    sendResultLink
    sendToAtsFields
    fieldIds {
      score
      resultUrl
      completionDate
      orderStatus
      integrityRisk
    }
    sendToWorkdayObjects
    objectAlias
    fieldAliases {
      score
      resultUrl
      completionDate
      interviewName
      evaluatorName
      recommendedDecision
      evaluationId
      orderStatus
    }
    completionStageRef
  }
  stageMap {
    szStageType
    atsStageRef
    workdayStepIds
  }
  candidatePullMode
  stagePushEnabled
  hiringTeamUserProvisioningEnabled
  stageRejectionReasons {
    atsStageRef
    rejectionReasonIds
    defaultAutoRejectReasonId
  }
}
    `;
export const CoderbyteWorkspaceFieldsFragmentDoc = gql`
    fragment CoderbyteWorkspaceFields on CoderbyteWorkspace {
  id
  companyId
  companyName
  externalId
  dashboardUrl
  status
  adminEmail
  webhookUrl
  keySetAt
  adminPasswordSetAt
  keyVerifiedAt
  createdAt
  updatedAt
}
    `;
export const CoderbyteWorkspaceUserFieldsFragmentDoc = gql`
    fragment CoderbyteWorkspaceUserFields on CoderbyteWorkspaceUser {
  id
  userId
  firstName
  lastName
  userEmail
  coderbyteEmail
  status
  invitedAt
  activatedAt
  lastLoginAt
}
    `;
export const KomboIntegrationListFieldsFragmentDoc = gql`
    fragment KomboIntegrationListFields on KomboIntegrationModel {
  id
  companyId
  tool
  enabled
  atsIntegrationId
  assessmentIntegrationId
  latestSyncRun {
    id
    status
    completedAt
  }
}
    `;
export const UseGetProjectFromLocationHookProjectFragmentDoc = gql`
    fragment UseGetProjectFromLocationHookProject on Project {
  id
  name
  company {
    id
    name
  }
}
    `;
export const UseProjectPolicyActionsHookProjectFragmentDoc = gql`
    fragment UseProjectPolicyActionsHookProject on Project {
  id
  name
  status
  source
  interviewStages {
    subId
  }
  shortlistStages {
    subId
  }
  assessmentStagesV2 {
    id
  }
}
    `;
export const CompaniesPageCompanyFragmentDoc = gql`
    fragment CompaniesPageCompany on Company {
  id
  name
  logoUrl
}
    `;
export const ProjectTeamEmailSettingsBaseFragmentDoc = gql`
    fragment ProjectTeamEmailSettingsBase on ProjectTeamEmailSettings {
  mode
  actorRoles
}
    `;
export const CompanyPageCompanyFragmentDoc = gql`
    fragment CompanyPageCompany on Company {
  id
  name
  logoUrl
  atsIdentifier
  atsPullJobsFromDate
  allowedEmailDomains
  areCognitiveTestsBlocked
  areRffSoftSkillsDisabled
  isInterviewGuideScoresEnabled
  isLegalAcknowledgementsEnabled
  isLiveChatEnabled
  isSkillsEvaluationScoreEnabled
  isViewGuidanceEnabled
  isAssigneeManagedViaIntegration
  rfuModelType
  companyLifecycle
  createdAt
  reasonableAdjustmentsOption {
    kind
    value
  }
  assessmentExpiryOption {
    duration
    unit
  }
  managerReport {
    ...ShallowReport
  }
  candidateReport {
    ...ShallowReport
  }
  csmUser {
    id
    firstName
    lastName
    email
  }
  hideReports
  generateManagerReport
  generateCandidateReport
  emailCandidateReport
  projectTeamEmailSettings {
    ...ProjectTeamEmailSettingsBase
  }
  enableCompanyCodingAssessments
  areMultiAssessmentStagesEnabled
  isPersonalityTestMandatory
  isAtsRoleCreationWithRequisitionEnabled
  isAtsRoleCreationWithoutRequisitionEnabled
  isRoleLiveEmailEnabled
  isHiringTeamMemberAddedEmailEnabled
  isIntegrityMonitoringAvailable
  isIntegrityMonitoringAssessmentDefaultEnabled
  isIntegrityMonitoringAiInterviewDefaultEnabled
  isAiInterviewScoreHidingAvailable
  isAiInterviewEnabled
  isShortlistingEnabled
  isAiShortlistNationalityScrutinyEnabled
  isApplicationAnswerEvidenceEnabled
  isAlternativeSupportEmailEnabled
  alternativeSupportEmail
  explicitConsentEmail
  isWhitelabelingEnabled
  isSpottedZebraScoreEnabled
}
    ${ShallowReportFragmentDoc}
${ProjectTeamEmailSettingsBaseFragmentDoc}`;
export const ProjectPageCompanyFragmentDoc = gql`
    fragment ProjectPageCompany on Company {
  id
  name
  logoUrl
  atsPullJobsFromDate
  allowedEmailDomains
  areCognitiveTestsBlocked
  areRffSoftSkillsDisabled
  areMultiAssessmentStagesEnabled
  isInterviewGuideScoresEnabled
  isLegalAcknowledgementsEnabled
  isSkillsEvaluationScoreEnabled
  isViewGuidanceEnabled
  isAssigneeManagedViaIntegration
  rfuModelType
  createdAt
  reasonableAdjustmentsOption {
    kind
    value
  }
  assessmentExpiryOption {
    duration
    unit
  }
  managerReport {
    ...ShallowReport
  }
  candidateReport {
    ...ShallowReport
  }
  hideReports
  generateManagerReport
  generateCandidateReport
  emailCandidateReport
  projectTeamEmailSettings {
    ...ProjectTeamEmailSettingsBase
  }
  isIntegrityMonitoringAvailable
  isAiInterviewScoreHidingAvailable
  isShortlistingEnabled
  isSpottedZebraScoreEnabled
}
    ${ShallowReportFragmentDoc}
${ProjectTeamEmailSettingsBaseFragmentDoc}`;
export const ShortlistStageBaseFragmentDoc = gql`
    fragment ShortlistStageBase on ShortlistStage {
  subId
  projectId
  name
  createdAt
  updatedAt
}
    `;
export const ProjectPageProjectFragmentDoc = gql`
    fragment ProjectPageProject on Project {
  company {
    ...ProjectCompany
  }
  companySignatureId
  createdAt
  creatorId
  publishedAt
  publishedBy {
    ...User
  }
  source
  id
  isArchived
  deletedAt
  isStopped
  locales
  primaryLocale
  teamMembers {
    ...ProjectManager
  }
  moduleType
  name
  requireSheetsExport
  updatedAt
  version
  productSolution
  subId
  indirectInviteSSOEnabled
  isIntegrityMonitoringEnabled
  assessmentStages {
    id
    subId
    scoringConfig {
      version
      components {
        component
        kind
        weight
        threshold
      }
    }
  }
  isAiInterviewScoreHidden
  assessmentStagesV2 {
    ...AssessmentStageFragment
  }
  interviewStages {
    ...InterviewStage
  }
  status
  creator {
    ...User
  }
  updatedBy {
    ...User
  }
  projectCandidatesCount
  shortlistStages {
    ...ShortlistStageBase
  }
}
    ${ProjectCompanyFragmentDoc}
${UserFragmentDoc}
${ProjectManagerFragmentDoc}
${AssessmentStageFragmentFragmentDoc}
${InterviewStageFragmentDoc}
${ShortlistStageBaseFragmentDoc}`;
export const DuplicateModalJobRoleFragmentDoc = gql`
    fragment DuplicateModalJobRole on JobRoleModel {
  id
  skillsProfiles {
    id
    successProfileSoftSkills {
      id
      name
      weight
      softSkill {
        category
      }
    }
    successProfileTechnicalSkills {
      id
      technicalSkill {
        name
      }
    }
  }
}
    `;
export const ShallowJobRolePaginatedDataFragmentDoc = gql`
    fragment ShallowJobRolePaginatedData on JobRolePaginatedData {
  id
  subId
  createdAt
  name
  qualifier
  roleLevel
  family
  source
  skillsProfiles {
    id
    successProfileSoftSkills {
      id
    }
    successProfileTechnicalSkills {
      id
    }
  }
}
    `;
export const DuplicateJobRoleModalPaginatedFragmentDoc = gql`
    fragment DuplicateJobRoleModalPaginated on JobRolePaginated {
  data {
    ...ShallowJobRolePaginatedData
  }
  page {
    ...PageInfo
  }
}
    ${ShallowJobRolePaginatedDataFragmentDoc}
${PageInfoFragmentDoc}`;
export const ProjectBaseFragmentDoc = gql`
    fragment ProjectBase on Project {
  id
  status
  subId
  description
  name
  version
  creatorId
  isArchived
  isStopped
  renderCandidateReport
  companyId
  companySignatureId
  moduleType
  productSolution
  createdAt
  updatedAt
  deletedAt
  locales
  primaryLocale
  indirectInviteSSOEnabled
  publishedAt
  lastCandidateActivity
  source
}
    `;
export const UserPageProjectFragmentDoc = gql`
    fragment UserPageProject on Project {
  ...ProjectBase
  company {
    id
    name
  }
}
    ${ProjectBaseFragmentDoc}`;
export const DeleteAssessmentStageDocument = gql`
    mutation DeleteAssessmentStage($id: ID!) {
  deleteAssessmentStage(id: $id)
}
    `;
export type DeleteAssessmentStageMutationFn = Apollo.MutationFunction<DeleteAssessmentStageMutation, DeleteAssessmentStageMutationVariables>;

/**
 * __useDeleteAssessmentStageMutation__
 *
 * To run a mutation, you first call `useDeleteAssessmentStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssessmentStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssessmentStageMutation, { data, loading, error }] = useDeleteAssessmentStageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAssessmentStageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAssessmentStageMutation, DeleteAssessmentStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAssessmentStageMutation, DeleteAssessmentStageMutationVariables>(DeleteAssessmentStageDocument, options);
      }
export type DeleteAssessmentStageMutationHookResult = ReturnType<typeof useDeleteAssessmentStageMutation>;
export type DeleteAssessmentStageMutationResult = Apollo.MutationResult<DeleteAssessmentStageMutation>;
export type DeleteAssessmentStageMutationOptions = Apollo.BaseMutationOptions<DeleteAssessmentStageMutation, DeleteAssessmentStageMutationVariables>;
export const UpdateAssessmentStageDocument = gql`
    mutation UpdateAssessmentStage($id: ID!, $input: UpdateAssessmentStageInput!) {
  updateAssessmentStage(id: $id, input: $input) {
    ...AssessmentStageFragment
  }
}
    ${AssessmentStageFragmentFragmentDoc}`;
export type UpdateAssessmentStageMutationFn = Apollo.MutationFunction<UpdateAssessmentStageMutation, UpdateAssessmentStageMutationVariables>;

/**
 * __useUpdateAssessmentStageMutation__
 *
 * To run a mutation, you first call `useUpdateAssessmentStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssessmentStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssessmentStageMutation, { data, loading, error }] = useUpdateAssessmentStageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAssessmentStageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssessmentStageMutation, UpdateAssessmentStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssessmentStageMutation, UpdateAssessmentStageMutationVariables>(UpdateAssessmentStageDocument, options);
      }
export type UpdateAssessmentStageMutationHookResult = ReturnType<typeof useUpdateAssessmentStageMutation>;
export type UpdateAssessmentStageMutationResult = Apollo.MutationResult<UpdateAssessmentStageMutation>;
export type UpdateAssessmentStageMutationOptions = Apollo.BaseMutationOptions<UpdateAssessmentStageMutation, UpdateAssessmentStageMutationVariables>;
export const UpsertAssessmentStageDeiActionDocument = gql`
    mutation UpsertAssessmentStageDeiAction($stageId: ID!, $fields: DeiStageActionFieldsInput!) {
  upsertAssessmentStageDeiAction(stageId: $stageId, fields: $fields) {
    ...DeiStageAction
  }
}
    ${DeiStageActionFragmentDoc}`;
export type UpsertAssessmentStageDeiActionMutationFn = Apollo.MutationFunction<UpsertAssessmentStageDeiActionMutation, UpsertAssessmentStageDeiActionMutationVariables>;

/**
 * __useUpsertAssessmentStageDeiActionMutation__
 *
 * To run a mutation, you first call `useUpsertAssessmentStageDeiActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAssessmentStageDeiActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertAssessmentStageDeiActionMutation, { data, loading, error }] = useUpsertAssessmentStageDeiActionMutation({
 *   variables: {
 *      stageId: // value for 'stageId'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useUpsertAssessmentStageDeiActionMutation(baseOptions?: Apollo.MutationHookOptions<UpsertAssessmentStageDeiActionMutation, UpsertAssessmentStageDeiActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertAssessmentStageDeiActionMutation, UpsertAssessmentStageDeiActionMutationVariables>(UpsertAssessmentStageDeiActionDocument, options);
      }
export type UpsertAssessmentStageDeiActionMutationHookResult = ReturnType<typeof useUpsertAssessmentStageDeiActionMutation>;
export type UpsertAssessmentStageDeiActionMutationResult = Apollo.MutationResult<UpsertAssessmentStageDeiActionMutation>;
export type UpsertAssessmentStageDeiActionMutationOptions = Apollo.BaseMutationOptions<UpsertAssessmentStageDeiActionMutation, UpsertAssessmentStageDeiActionMutationVariables>;
export const ArchiveAssessmentStageDeiActionDocument = gql`
    mutation ArchiveAssessmentStageDeiAction($stageId: ID!) {
  archiveAssessmentStageDeiAction(stageId: $stageId) {
    ...DeiStageAction
  }
}
    ${DeiStageActionFragmentDoc}`;
export type ArchiveAssessmentStageDeiActionMutationFn = Apollo.MutationFunction<ArchiveAssessmentStageDeiActionMutation, ArchiveAssessmentStageDeiActionMutationVariables>;

/**
 * __useArchiveAssessmentStageDeiActionMutation__
 *
 * To run a mutation, you first call `useArchiveAssessmentStageDeiActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveAssessmentStageDeiActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveAssessmentStageDeiActionMutation, { data, loading, error }] = useArchiveAssessmentStageDeiActionMutation({
 *   variables: {
 *      stageId: // value for 'stageId'
 *   },
 * });
 */
export function useArchiveAssessmentStageDeiActionMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveAssessmentStageDeiActionMutation, ArchiveAssessmentStageDeiActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveAssessmentStageDeiActionMutation, ArchiveAssessmentStageDeiActionMutationVariables>(ArchiveAssessmentStageDeiActionDocument, options);
      }
export type ArchiveAssessmentStageDeiActionMutationHookResult = ReturnType<typeof useArchiveAssessmentStageDeiActionMutation>;
export type ArchiveAssessmentStageDeiActionMutationResult = Apollo.MutationResult<ArchiveAssessmentStageDeiActionMutation>;
export type ArchiveAssessmentStageDeiActionMutationOptions = Apollo.BaseMutationOptions<ArchiveAssessmentStageDeiActionMutation, ArchiveAssessmentStageDeiActionMutationVariables>;
export const UnarchiveAssessmentStageDeiActionDocument = gql`
    mutation UnarchiveAssessmentStageDeiAction($stageId: ID!, $fields: DeiStageActionFieldsInput) {
  unarchiveAssessmentStageDeiAction(stageId: $stageId, fields: $fields) {
    ...DeiStageAction
  }
}
    ${DeiStageActionFragmentDoc}`;
export type UnarchiveAssessmentStageDeiActionMutationFn = Apollo.MutationFunction<UnarchiveAssessmentStageDeiActionMutation, UnarchiveAssessmentStageDeiActionMutationVariables>;

/**
 * __useUnarchiveAssessmentStageDeiActionMutation__
 *
 * To run a mutation, you first call `useUnarchiveAssessmentStageDeiActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveAssessmentStageDeiActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveAssessmentStageDeiActionMutation, { data, loading, error }] = useUnarchiveAssessmentStageDeiActionMutation({
 *   variables: {
 *      stageId: // value for 'stageId'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useUnarchiveAssessmentStageDeiActionMutation(baseOptions?: Apollo.MutationHookOptions<UnarchiveAssessmentStageDeiActionMutation, UnarchiveAssessmentStageDeiActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnarchiveAssessmentStageDeiActionMutation, UnarchiveAssessmentStageDeiActionMutationVariables>(UnarchiveAssessmentStageDeiActionDocument, options);
      }
export type UnarchiveAssessmentStageDeiActionMutationHookResult = ReturnType<typeof useUnarchiveAssessmentStageDeiActionMutation>;
export type UnarchiveAssessmentStageDeiActionMutationResult = Apollo.MutationResult<UnarchiveAssessmentStageDeiActionMutation>;
export type UnarchiveAssessmentStageDeiActionMutationOptions = Apollo.BaseMutationOptions<UnarchiveAssessmentStageDeiActionMutation, UnarchiveAssessmentStageDeiActionMutationVariables>;
export const UpdateAiInterviewAssessmentStageActionLivekitAgentNameDocument = gql`
    mutation UpdateAiInterviewAssessmentStageActionLivekitAgentName($id: ID!, $livekitAgentName: LivekitAgentName!) {
  updateAiInterviewAssessmentStageActionLivekitAgentName(
    id: $id
    livekitAgentName: $livekitAgentName
  ) {
    id
    livekitAgentName
  }
}
    `;
export type UpdateAiInterviewAssessmentStageActionLivekitAgentNameMutationFn = Apollo.MutationFunction<UpdateAiInterviewAssessmentStageActionLivekitAgentNameMutation, UpdateAiInterviewAssessmentStageActionLivekitAgentNameMutationVariables>;

/**
 * __useUpdateAiInterviewAssessmentStageActionLivekitAgentNameMutation__
 *
 * To run a mutation, you first call `useUpdateAiInterviewAssessmentStageActionLivekitAgentNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAiInterviewAssessmentStageActionLivekitAgentNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAiInterviewAssessmentStageActionLivekitAgentNameMutation, { data, loading, error }] = useUpdateAiInterviewAssessmentStageActionLivekitAgentNameMutation({
 *   variables: {
 *      id: // value for 'id'
 *      livekitAgentName: // value for 'livekitAgentName'
 *   },
 * });
 */
export function useUpdateAiInterviewAssessmentStageActionLivekitAgentNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAiInterviewAssessmentStageActionLivekitAgentNameMutation, UpdateAiInterviewAssessmentStageActionLivekitAgentNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAiInterviewAssessmentStageActionLivekitAgentNameMutation, UpdateAiInterviewAssessmentStageActionLivekitAgentNameMutationVariables>(UpdateAiInterviewAssessmentStageActionLivekitAgentNameDocument, options);
      }
export type UpdateAiInterviewAssessmentStageActionLivekitAgentNameMutationHookResult = ReturnType<typeof useUpdateAiInterviewAssessmentStageActionLivekitAgentNameMutation>;
export type UpdateAiInterviewAssessmentStageActionLivekitAgentNameMutationResult = Apollo.MutationResult<UpdateAiInterviewAssessmentStageActionLivekitAgentNameMutation>;
export type UpdateAiInterviewAssessmentStageActionLivekitAgentNameMutationOptions = Apollo.BaseMutationOptions<UpdateAiInterviewAssessmentStageActionLivekitAgentNameMutation, UpdateAiInterviewAssessmentStageActionLivekitAgentNameMutationVariables>;
export const UpdateAiInterviewAssessmentStageActionIsAvatarEnabledDocument = gql`
    mutation UpdateAiInterviewAssessmentStageActionIsAvatarEnabled($id: ID!, $isAvatarEnabled: Boolean!) {
  updateAiInterviewAssessmentStageActionIsAvatarEnabled(
    id: $id
    isAvatarEnabled: $isAvatarEnabled
  ) {
    id
    isAvatarEnabled
  }
}
    `;
export type UpdateAiInterviewAssessmentStageActionIsAvatarEnabledMutationFn = Apollo.MutationFunction<UpdateAiInterviewAssessmentStageActionIsAvatarEnabledMutation, UpdateAiInterviewAssessmentStageActionIsAvatarEnabledMutationVariables>;

/**
 * __useUpdateAiInterviewAssessmentStageActionIsAvatarEnabledMutation__
 *
 * To run a mutation, you first call `useUpdateAiInterviewAssessmentStageActionIsAvatarEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAiInterviewAssessmentStageActionIsAvatarEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAiInterviewAssessmentStageActionIsAvatarEnabledMutation, { data, loading, error }] = useUpdateAiInterviewAssessmentStageActionIsAvatarEnabledMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isAvatarEnabled: // value for 'isAvatarEnabled'
 *   },
 * });
 */
export function useUpdateAiInterviewAssessmentStageActionIsAvatarEnabledMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAiInterviewAssessmentStageActionIsAvatarEnabledMutation, UpdateAiInterviewAssessmentStageActionIsAvatarEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAiInterviewAssessmentStageActionIsAvatarEnabledMutation, UpdateAiInterviewAssessmentStageActionIsAvatarEnabledMutationVariables>(UpdateAiInterviewAssessmentStageActionIsAvatarEnabledDocument, options);
      }
export type UpdateAiInterviewAssessmentStageActionIsAvatarEnabledMutationHookResult = ReturnType<typeof useUpdateAiInterviewAssessmentStageActionIsAvatarEnabledMutation>;
export type UpdateAiInterviewAssessmentStageActionIsAvatarEnabledMutationResult = Apollo.MutationResult<UpdateAiInterviewAssessmentStageActionIsAvatarEnabledMutation>;
export type UpdateAiInterviewAssessmentStageActionIsAvatarEnabledMutationOptions = Apollo.BaseMutationOptions<UpdateAiInterviewAssessmentStageActionIsAvatarEnabledMutation, UpdateAiInterviewAssessmentStageActionIsAvatarEnabledMutationVariables>;
export const UpdateAiInterviewAssessmentStageActionIsTimingAgentEnabledDocument = gql`
    mutation UpdateAiInterviewAssessmentStageActionIsTimingAgentEnabled($id: ID!, $isTimingAgentEnabled: Boolean!) {
  updateAiInterviewAssessmentStageActionIsTimingAgentEnabled(
    id: $id
    isTimingAgentEnabled: $isTimingAgentEnabled
  ) {
    id
    isTimingAgentEnabled
  }
}
    `;
export type UpdateAiInterviewAssessmentStageActionIsTimingAgentEnabledMutationFn = Apollo.MutationFunction<UpdateAiInterviewAssessmentStageActionIsTimingAgentEnabledMutation, UpdateAiInterviewAssessmentStageActionIsTimingAgentEnabledMutationVariables>;

/**
 * __useUpdateAiInterviewAssessmentStageActionIsTimingAgentEnabledMutation__
 *
 * To run a mutation, you first call `useUpdateAiInterviewAssessmentStageActionIsTimingAgentEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAiInterviewAssessmentStageActionIsTimingAgentEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAiInterviewAssessmentStageActionIsTimingAgentEnabledMutation, { data, loading, error }] = useUpdateAiInterviewAssessmentStageActionIsTimingAgentEnabledMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isTimingAgentEnabled: // value for 'isTimingAgentEnabled'
 *   },
 * });
 */
export function useUpdateAiInterviewAssessmentStageActionIsTimingAgentEnabledMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAiInterviewAssessmentStageActionIsTimingAgentEnabledMutation, UpdateAiInterviewAssessmentStageActionIsTimingAgentEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAiInterviewAssessmentStageActionIsTimingAgentEnabledMutation, UpdateAiInterviewAssessmentStageActionIsTimingAgentEnabledMutationVariables>(UpdateAiInterviewAssessmentStageActionIsTimingAgentEnabledDocument, options);
      }
export type UpdateAiInterviewAssessmentStageActionIsTimingAgentEnabledMutationHookResult = ReturnType<typeof useUpdateAiInterviewAssessmentStageActionIsTimingAgentEnabledMutation>;
export type UpdateAiInterviewAssessmentStageActionIsTimingAgentEnabledMutationResult = Apollo.MutationResult<UpdateAiInterviewAssessmentStageActionIsTimingAgentEnabledMutation>;
export type UpdateAiInterviewAssessmentStageActionIsTimingAgentEnabledMutationOptions = Apollo.BaseMutationOptions<UpdateAiInterviewAssessmentStageActionIsTimingAgentEnabledMutation, UpdateAiInterviewAssessmentStageActionIsTimingAgentEnabledMutationVariables>;
export const CreateAssessmentStageRssActionDocument = gql`
    mutation CreateAssessmentStageRssAction($stageId: ID!, $type: RssAssessmentType!) {
  createAssessmentStageRssAction(stageId: $stageId, type: $type) {
    ...RssAssessment
  }
}
    ${RssAssessmentFragmentDoc}`;
export type CreateAssessmentStageRssActionMutationFn = Apollo.MutationFunction<CreateAssessmentStageRssActionMutation, CreateAssessmentStageRssActionMutationVariables>;

/**
 * __useCreateAssessmentStageRssActionMutation__
 *
 * To run a mutation, you first call `useCreateAssessmentStageRssActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssessmentStageRssActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssessmentStageRssActionMutation, { data, loading, error }] = useCreateAssessmentStageRssActionMutation({
 *   variables: {
 *      stageId: // value for 'stageId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateAssessmentStageRssActionMutation(baseOptions?: Apollo.MutationHookOptions<CreateAssessmentStageRssActionMutation, CreateAssessmentStageRssActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAssessmentStageRssActionMutation, CreateAssessmentStageRssActionMutationVariables>(CreateAssessmentStageRssActionDocument, options);
      }
export type CreateAssessmentStageRssActionMutationHookResult = ReturnType<typeof useCreateAssessmentStageRssActionMutation>;
export type CreateAssessmentStageRssActionMutationResult = Apollo.MutationResult<CreateAssessmentStageRssActionMutation>;
export type CreateAssessmentStageRssActionMutationOptions = Apollo.BaseMutationOptions<CreateAssessmentStageRssActionMutation, CreateAssessmentStageRssActionMutationVariables>;
export const DeleteAssessmentStageRssActionDocument = gql`
    mutation DeleteAssessmentStageRssAction($stageId: ID!, $type: RssAssessmentType!) {
  deleteAssessmentStageRssAction(stageId: $stageId, type: $type)
}
    `;
export type DeleteAssessmentStageRssActionMutationFn = Apollo.MutationFunction<DeleteAssessmentStageRssActionMutation, DeleteAssessmentStageRssActionMutationVariables>;

/**
 * __useDeleteAssessmentStageRssActionMutation__
 *
 * To run a mutation, you first call `useDeleteAssessmentStageRssActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssessmentStageRssActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssessmentStageRssActionMutation, { data, loading, error }] = useDeleteAssessmentStageRssActionMutation({
 *   variables: {
 *      stageId: // value for 'stageId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useDeleteAssessmentStageRssActionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAssessmentStageRssActionMutation, DeleteAssessmentStageRssActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAssessmentStageRssActionMutation, DeleteAssessmentStageRssActionMutationVariables>(DeleteAssessmentStageRssActionDocument, options);
      }
export type DeleteAssessmentStageRssActionMutationHookResult = ReturnType<typeof useDeleteAssessmentStageRssActionMutation>;
export type DeleteAssessmentStageRssActionMutationResult = Apollo.MutationResult<DeleteAssessmentStageRssActionMutation>;
export type DeleteAssessmentStageRssActionMutationOptions = Apollo.BaseMutationOptions<DeleteAssessmentStageRssActionMutation, DeleteAssessmentStageRssActionMutationVariables>;
export const SetAtsProgressionEnabledDocument = gql`
    mutation SetAtsProgressionEnabled($companyId: Int!, $enabled: Boolean!) {
  setAtsProgressionEnabled(companyId: $companyId, enabled: $enabled) {
    companyId
    progressionEnabled
    applicationTrackingEnabled
    interviewEvaluationResultsEnabled
    aiInterviewResultsEnabled
    assessmentResultsEnabled
  }
}
    `;
export type SetAtsProgressionEnabledMutationFn = Apollo.MutationFunction<SetAtsProgressionEnabledMutation, SetAtsProgressionEnabledMutationVariables>;

/**
 * __useSetAtsProgressionEnabledMutation__
 *
 * To run a mutation, you first call `useSetAtsProgressionEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAtsProgressionEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAtsProgressionEnabledMutation, { data, loading, error }] = useSetAtsProgressionEnabledMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useSetAtsProgressionEnabledMutation(baseOptions?: Apollo.MutationHookOptions<SetAtsProgressionEnabledMutation, SetAtsProgressionEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAtsProgressionEnabledMutation, SetAtsProgressionEnabledMutationVariables>(SetAtsProgressionEnabledDocument, options);
      }
export type SetAtsProgressionEnabledMutationHookResult = ReturnType<typeof useSetAtsProgressionEnabledMutation>;
export type SetAtsProgressionEnabledMutationResult = Apollo.MutationResult<SetAtsProgressionEnabledMutation>;
export type SetAtsProgressionEnabledMutationOptions = Apollo.BaseMutationOptions<SetAtsProgressionEnabledMutation, SetAtsProgressionEnabledMutationVariables>;
export const SetAtsInterviewEvaluationResultsEnabledDocument = gql`
    mutation SetAtsInterviewEvaluationResultsEnabled($companyId: Int!, $enabled: Boolean!) {
  setAtsInterviewEvaluationResultsEnabled(
    companyId: $companyId
    enabled: $enabled
  ) {
    companyId
    progressionEnabled
    applicationTrackingEnabled
    interviewEvaluationResultsEnabled
    aiInterviewResultsEnabled
    assessmentResultsEnabled
  }
}
    `;
export type SetAtsInterviewEvaluationResultsEnabledMutationFn = Apollo.MutationFunction<SetAtsInterviewEvaluationResultsEnabledMutation, SetAtsInterviewEvaluationResultsEnabledMutationVariables>;

/**
 * __useSetAtsInterviewEvaluationResultsEnabledMutation__
 *
 * To run a mutation, you first call `useSetAtsInterviewEvaluationResultsEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAtsInterviewEvaluationResultsEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAtsInterviewEvaluationResultsEnabledMutation, { data, loading, error }] = useSetAtsInterviewEvaluationResultsEnabledMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useSetAtsInterviewEvaluationResultsEnabledMutation(baseOptions?: Apollo.MutationHookOptions<SetAtsInterviewEvaluationResultsEnabledMutation, SetAtsInterviewEvaluationResultsEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAtsInterviewEvaluationResultsEnabledMutation, SetAtsInterviewEvaluationResultsEnabledMutationVariables>(SetAtsInterviewEvaluationResultsEnabledDocument, options);
      }
export type SetAtsInterviewEvaluationResultsEnabledMutationHookResult = ReturnType<typeof useSetAtsInterviewEvaluationResultsEnabledMutation>;
export type SetAtsInterviewEvaluationResultsEnabledMutationResult = Apollo.MutationResult<SetAtsInterviewEvaluationResultsEnabledMutation>;
export type SetAtsInterviewEvaluationResultsEnabledMutationOptions = Apollo.BaseMutationOptions<SetAtsInterviewEvaluationResultsEnabledMutation, SetAtsInterviewEvaluationResultsEnabledMutationVariables>;
export const SetAtsAiInterviewResultsEnabledDocument = gql`
    mutation SetAtsAiInterviewResultsEnabled($companyId: Int!, $enabled: Boolean!) {
  setAtsAiInterviewResultsEnabled(companyId: $companyId, enabled: $enabled) {
    companyId
    progressionEnabled
    applicationTrackingEnabled
    interviewEvaluationResultsEnabled
    aiInterviewResultsEnabled
    assessmentResultsEnabled
  }
}
    `;
export type SetAtsAiInterviewResultsEnabledMutationFn = Apollo.MutationFunction<SetAtsAiInterviewResultsEnabledMutation, SetAtsAiInterviewResultsEnabledMutationVariables>;

/**
 * __useSetAtsAiInterviewResultsEnabledMutation__
 *
 * To run a mutation, you first call `useSetAtsAiInterviewResultsEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAtsAiInterviewResultsEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAtsAiInterviewResultsEnabledMutation, { data, loading, error }] = useSetAtsAiInterviewResultsEnabledMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useSetAtsAiInterviewResultsEnabledMutation(baseOptions?: Apollo.MutationHookOptions<SetAtsAiInterviewResultsEnabledMutation, SetAtsAiInterviewResultsEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAtsAiInterviewResultsEnabledMutation, SetAtsAiInterviewResultsEnabledMutationVariables>(SetAtsAiInterviewResultsEnabledDocument, options);
      }
export type SetAtsAiInterviewResultsEnabledMutationHookResult = ReturnType<typeof useSetAtsAiInterviewResultsEnabledMutation>;
export type SetAtsAiInterviewResultsEnabledMutationResult = Apollo.MutationResult<SetAtsAiInterviewResultsEnabledMutation>;
export type SetAtsAiInterviewResultsEnabledMutationOptions = Apollo.BaseMutationOptions<SetAtsAiInterviewResultsEnabledMutation, SetAtsAiInterviewResultsEnabledMutationVariables>;
export const SetAtsAssessmentResultsEnabledDocument = gql`
    mutation SetAtsAssessmentResultsEnabled($companyId: Int!, $enabled: Boolean!) {
  setAtsAssessmentResultsEnabled(companyId: $companyId, enabled: $enabled) {
    companyId
    progressionEnabled
    applicationTrackingEnabled
    interviewEvaluationResultsEnabled
    aiInterviewResultsEnabled
    assessmentResultsEnabled
  }
}
    `;
export type SetAtsAssessmentResultsEnabledMutationFn = Apollo.MutationFunction<SetAtsAssessmentResultsEnabledMutation, SetAtsAssessmentResultsEnabledMutationVariables>;

/**
 * __useSetAtsAssessmentResultsEnabledMutation__
 *
 * To run a mutation, you first call `useSetAtsAssessmentResultsEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAtsAssessmentResultsEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAtsAssessmentResultsEnabledMutation, { data, loading, error }] = useSetAtsAssessmentResultsEnabledMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useSetAtsAssessmentResultsEnabledMutation(baseOptions?: Apollo.MutationHookOptions<SetAtsAssessmentResultsEnabledMutation, SetAtsAssessmentResultsEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAtsAssessmentResultsEnabledMutation, SetAtsAssessmentResultsEnabledMutationVariables>(SetAtsAssessmentResultsEnabledDocument, options);
      }
export type SetAtsAssessmentResultsEnabledMutationHookResult = ReturnType<typeof useSetAtsAssessmentResultsEnabledMutation>;
export type SetAtsAssessmentResultsEnabledMutationResult = Apollo.MutationResult<SetAtsAssessmentResultsEnabledMutation>;
export type SetAtsAssessmentResultsEnabledMutationOptions = Apollo.BaseMutationOptions<SetAtsAssessmentResultsEnabledMutation, SetAtsAssessmentResultsEnabledMutationVariables>;
export const SetAtsResultPushConfigDocument = gql`
    mutation SetAtsResultPushConfig($companyId: Int!, $configs: [AtsResultPushConfigInput!]!) {
  setAtsResultPushConfig(companyId: $companyId, configs: $configs) {
    ...AtsSettingsFields
  }
}
    ${AtsSettingsFieldsFragmentDoc}`;
export type SetAtsResultPushConfigMutationFn = Apollo.MutationFunction<SetAtsResultPushConfigMutation, SetAtsResultPushConfigMutationVariables>;

/**
 * __useSetAtsResultPushConfigMutation__
 *
 * To run a mutation, you first call `useSetAtsResultPushConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAtsResultPushConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAtsResultPushConfigMutation, { data, loading, error }] = useSetAtsResultPushConfigMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      configs: // value for 'configs'
 *   },
 * });
 */
export function useSetAtsResultPushConfigMutation(baseOptions?: Apollo.MutationHookOptions<SetAtsResultPushConfigMutation, SetAtsResultPushConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAtsResultPushConfigMutation, SetAtsResultPushConfigMutationVariables>(SetAtsResultPushConfigDocument, options);
      }
export type SetAtsResultPushConfigMutationHookResult = ReturnType<typeof useSetAtsResultPushConfigMutation>;
export type SetAtsResultPushConfigMutationResult = Apollo.MutationResult<SetAtsResultPushConfigMutation>;
export type SetAtsResultPushConfigMutationOptions = Apollo.BaseMutationOptions<SetAtsResultPushConfigMutation, SetAtsResultPushConfigMutationVariables>;
export const SetAtsAllowedRejectionReasonIdsDocument = gql`
    mutation SetAtsAllowedRejectionReasonIds($companyId: Int!, $ids: [String!]) {
  setAtsAllowedRejectionReasonIds(companyId: $companyId, ids: $ids) {
    ...AtsSettingsFields
  }
}
    ${AtsSettingsFieldsFragmentDoc}`;
export type SetAtsAllowedRejectionReasonIdsMutationFn = Apollo.MutationFunction<SetAtsAllowedRejectionReasonIdsMutation, SetAtsAllowedRejectionReasonIdsMutationVariables>;

/**
 * __useSetAtsAllowedRejectionReasonIdsMutation__
 *
 * To run a mutation, you first call `useSetAtsAllowedRejectionReasonIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAtsAllowedRejectionReasonIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAtsAllowedRejectionReasonIdsMutation, { data, loading, error }] = useSetAtsAllowedRejectionReasonIdsMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSetAtsAllowedRejectionReasonIdsMutation(baseOptions?: Apollo.MutationHookOptions<SetAtsAllowedRejectionReasonIdsMutation, SetAtsAllowedRejectionReasonIdsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAtsAllowedRejectionReasonIdsMutation, SetAtsAllowedRejectionReasonIdsMutationVariables>(SetAtsAllowedRejectionReasonIdsDocument, options);
      }
export type SetAtsAllowedRejectionReasonIdsMutationHookResult = ReturnType<typeof useSetAtsAllowedRejectionReasonIdsMutation>;
export type SetAtsAllowedRejectionReasonIdsMutationResult = Apollo.MutationResult<SetAtsAllowedRejectionReasonIdsMutation>;
export type SetAtsAllowedRejectionReasonIdsMutationOptions = Apollo.BaseMutationOptions<SetAtsAllowedRejectionReasonIdsMutation, SetAtsAllowedRejectionReasonIdsMutationVariables>;
export const SetAtsStageMapDocument = gql`
    mutation SetAtsStageMap($companyId: Int!, $entries: [AtsStageMapEntryInput!]) {
  setAtsStageMap(companyId: $companyId, entries: $entries) {
    ...AtsSettingsFields
  }
}
    ${AtsSettingsFieldsFragmentDoc}`;
export type SetAtsStageMapMutationFn = Apollo.MutationFunction<SetAtsStageMapMutation, SetAtsStageMapMutationVariables>;

/**
 * __useSetAtsStageMapMutation__
 *
 * To run a mutation, you first call `useSetAtsStageMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAtsStageMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAtsStageMapMutation, { data, loading, error }] = useSetAtsStageMapMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      entries: // value for 'entries'
 *   },
 * });
 */
export function useSetAtsStageMapMutation(baseOptions?: Apollo.MutationHookOptions<SetAtsStageMapMutation, SetAtsStageMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAtsStageMapMutation, SetAtsStageMapMutationVariables>(SetAtsStageMapDocument, options);
      }
export type SetAtsStageMapMutationHookResult = ReturnType<typeof useSetAtsStageMapMutation>;
export type SetAtsStageMapMutationResult = Apollo.MutationResult<SetAtsStageMapMutation>;
export type SetAtsStageMapMutationOptions = Apollo.BaseMutationOptions<SetAtsStageMapMutation, SetAtsStageMapMutationVariables>;
export const SetAtsCandidatePullModeDocument = gql`
    mutation SetAtsCandidatePullMode($companyId: Int!, $mode: AtsCandidatePullMode!) {
  setAtsCandidatePullMode(companyId: $companyId, mode: $mode) {
    ...AtsSettingsFields
  }
}
    ${AtsSettingsFieldsFragmentDoc}`;
export type SetAtsCandidatePullModeMutationFn = Apollo.MutationFunction<SetAtsCandidatePullModeMutation, SetAtsCandidatePullModeMutationVariables>;

/**
 * __useSetAtsCandidatePullModeMutation__
 *
 * To run a mutation, you first call `useSetAtsCandidatePullModeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAtsCandidatePullModeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAtsCandidatePullModeMutation, { data, loading, error }] = useSetAtsCandidatePullModeMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      mode: // value for 'mode'
 *   },
 * });
 */
export function useSetAtsCandidatePullModeMutation(baseOptions?: Apollo.MutationHookOptions<SetAtsCandidatePullModeMutation, SetAtsCandidatePullModeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAtsCandidatePullModeMutation, SetAtsCandidatePullModeMutationVariables>(SetAtsCandidatePullModeDocument, options);
      }
export type SetAtsCandidatePullModeMutationHookResult = ReturnType<typeof useSetAtsCandidatePullModeMutation>;
export type SetAtsCandidatePullModeMutationResult = Apollo.MutationResult<SetAtsCandidatePullModeMutation>;
export type SetAtsCandidatePullModeMutationOptions = Apollo.BaseMutationOptions<SetAtsCandidatePullModeMutation, SetAtsCandidatePullModeMutationVariables>;
export const SetAtsStagePushEnabledDocument = gql`
    mutation SetAtsStagePushEnabled($companyId: Int!, $enabled: Boolean!) {
  setAtsStagePushEnabled(companyId: $companyId, enabled: $enabled) {
    ...AtsSettingsFields
  }
}
    ${AtsSettingsFieldsFragmentDoc}`;
export type SetAtsStagePushEnabledMutationFn = Apollo.MutationFunction<SetAtsStagePushEnabledMutation, SetAtsStagePushEnabledMutationVariables>;

/**
 * __useSetAtsStagePushEnabledMutation__
 *
 * To run a mutation, you first call `useSetAtsStagePushEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAtsStagePushEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAtsStagePushEnabledMutation, { data, loading, error }] = useSetAtsStagePushEnabledMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useSetAtsStagePushEnabledMutation(baseOptions?: Apollo.MutationHookOptions<SetAtsStagePushEnabledMutation, SetAtsStagePushEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAtsStagePushEnabledMutation, SetAtsStagePushEnabledMutationVariables>(SetAtsStagePushEnabledDocument, options);
      }
export type SetAtsStagePushEnabledMutationHookResult = ReturnType<typeof useSetAtsStagePushEnabledMutation>;
export type SetAtsStagePushEnabledMutationResult = Apollo.MutationResult<SetAtsStagePushEnabledMutation>;
export type SetAtsStagePushEnabledMutationOptions = Apollo.BaseMutationOptions<SetAtsStagePushEnabledMutation, SetAtsStagePushEnabledMutationVariables>;
export const SetAtsHiringTeamUserProvisioningEnabledDocument = gql`
    mutation SetAtsHiringTeamUserProvisioningEnabled($companyId: Int!, $enabled: Boolean!) {
  setAtsHiringTeamUserProvisioningEnabled(
    companyId: $companyId
    enabled: $enabled
  ) {
    ...AtsSettingsFields
  }
}
    ${AtsSettingsFieldsFragmentDoc}`;
export type SetAtsHiringTeamUserProvisioningEnabledMutationFn = Apollo.MutationFunction<SetAtsHiringTeamUserProvisioningEnabledMutation, SetAtsHiringTeamUserProvisioningEnabledMutationVariables>;

/**
 * __useSetAtsHiringTeamUserProvisioningEnabledMutation__
 *
 * To run a mutation, you first call `useSetAtsHiringTeamUserProvisioningEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAtsHiringTeamUserProvisioningEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAtsHiringTeamUserProvisioningEnabledMutation, { data, loading, error }] = useSetAtsHiringTeamUserProvisioningEnabledMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useSetAtsHiringTeamUserProvisioningEnabledMutation(baseOptions?: Apollo.MutationHookOptions<SetAtsHiringTeamUserProvisioningEnabledMutation, SetAtsHiringTeamUserProvisioningEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAtsHiringTeamUserProvisioningEnabledMutation, SetAtsHiringTeamUserProvisioningEnabledMutationVariables>(SetAtsHiringTeamUserProvisioningEnabledDocument, options);
      }
export type SetAtsHiringTeamUserProvisioningEnabledMutationHookResult = ReturnType<typeof useSetAtsHiringTeamUserProvisioningEnabledMutation>;
export type SetAtsHiringTeamUserProvisioningEnabledMutationResult = Apollo.MutationResult<SetAtsHiringTeamUserProvisioningEnabledMutation>;
export type SetAtsHiringTeamUserProvisioningEnabledMutationOptions = Apollo.BaseMutationOptions<SetAtsHiringTeamUserProvisioningEnabledMutation, SetAtsHiringTeamUserProvisioningEnabledMutationVariables>;
export const SetAtsRejectOnBehalfOfUserRemoteIdDocument = gql`
    mutation SetAtsRejectOnBehalfOfUserRemoteId($companyId: Int!, $userRemoteId: String) {
  setAtsRejectOnBehalfOfUserRemoteId(
    companyId: $companyId
    userRemoteId: $userRemoteId
  ) {
    ...AtsSettingsFields
  }
}
    ${AtsSettingsFieldsFragmentDoc}`;
export type SetAtsRejectOnBehalfOfUserRemoteIdMutationFn = Apollo.MutationFunction<SetAtsRejectOnBehalfOfUserRemoteIdMutation, SetAtsRejectOnBehalfOfUserRemoteIdMutationVariables>;

/**
 * __useSetAtsRejectOnBehalfOfUserRemoteIdMutation__
 *
 * To run a mutation, you first call `useSetAtsRejectOnBehalfOfUserRemoteIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAtsRejectOnBehalfOfUserRemoteIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAtsRejectOnBehalfOfUserRemoteIdMutation, { data, loading, error }] = useSetAtsRejectOnBehalfOfUserRemoteIdMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      userRemoteId: // value for 'userRemoteId'
 *   },
 * });
 */
export function useSetAtsRejectOnBehalfOfUserRemoteIdMutation(baseOptions?: Apollo.MutationHookOptions<SetAtsRejectOnBehalfOfUserRemoteIdMutation, SetAtsRejectOnBehalfOfUserRemoteIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAtsRejectOnBehalfOfUserRemoteIdMutation, SetAtsRejectOnBehalfOfUserRemoteIdMutationVariables>(SetAtsRejectOnBehalfOfUserRemoteIdDocument, options);
      }
export type SetAtsRejectOnBehalfOfUserRemoteIdMutationHookResult = ReturnType<typeof useSetAtsRejectOnBehalfOfUserRemoteIdMutation>;
export type SetAtsRejectOnBehalfOfUserRemoteIdMutationResult = Apollo.MutationResult<SetAtsRejectOnBehalfOfUserRemoteIdMutation>;
export type SetAtsRejectOnBehalfOfUserRemoteIdMutationOptions = Apollo.BaseMutationOptions<SetAtsRejectOnBehalfOfUserRemoteIdMutation, SetAtsRejectOnBehalfOfUserRemoteIdMutationVariables>;
export const SetAtsStageRejectionReasonsDocument = gql`
    mutation SetAtsStageRejectionReasons($companyId: Int!, $entries: [AtsStageRejectionReasonsEntryInput!]) {
  setAtsStageRejectionReasons(companyId: $companyId, entries: $entries) {
    ...AtsSettingsFields
  }
}
    ${AtsSettingsFieldsFragmentDoc}`;
export type SetAtsStageRejectionReasonsMutationFn = Apollo.MutationFunction<SetAtsStageRejectionReasonsMutation, SetAtsStageRejectionReasonsMutationVariables>;

/**
 * __useSetAtsStageRejectionReasonsMutation__
 *
 * To run a mutation, you first call `useSetAtsStageRejectionReasonsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAtsStageRejectionReasonsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAtsStageRejectionReasonsMutation, { data, loading, error }] = useSetAtsStageRejectionReasonsMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      entries: // value for 'entries'
 *   },
 * });
 */
export function useSetAtsStageRejectionReasonsMutation(baseOptions?: Apollo.MutationHookOptions<SetAtsStageRejectionReasonsMutation, SetAtsStageRejectionReasonsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAtsStageRejectionReasonsMutation, SetAtsStageRejectionReasonsMutationVariables>(SetAtsStageRejectionReasonsDocument, options);
      }
export type SetAtsStageRejectionReasonsMutationHookResult = ReturnType<typeof useSetAtsStageRejectionReasonsMutation>;
export type SetAtsStageRejectionReasonsMutationResult = Apollo.MutationResult<SetAtsStageRejectionReasonsMutation>;
export type SetAtsStageRejectionReasonsMutationOptions = Apollo.BaseMutationOptions<SetAtsStageRejectionReasonsMutation, SetAtsStageRejectionReasonsMutationVariables>;
export const RequestPasswordRecoveryDocument = gql`
    mutation RequestPasswordRecovery($email: String!, $clientDomainType: ClientDomainType!) {
  requestPasswordRecovery(email: $email, clientDomainType: $clientDomainType)
}
    `;
export type RequestPasswordRecoveryMutationFn = Apollo.MutationFunction<RequestPasswordRecoveryMutation, RequestPasswordRecoveryMutationVariables>;

/**
 * __useRequestPasswordRecoveryMutation__
 *
 * To run a mutation, you first call `useRequestPasswordRecoveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordRecoveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPasswordRecoveryMutation, { data, loading, error }] = useRequestPasswordRecoveryMutation({
 *   variables: {
 *      email: // value for 'email'
 *      clientDomainType: // value for 'clientDomainType'
 *   },
 * });
 */
export function useRequestPasswordRecoveryMutation(baseOptions?: Apollo.MutationHookOptions<RequestPasswordRecoveryMutation, RequestPasswordRecoveryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestPasswordRecoveryMutation, RequestPasswordRecoveryMutationVariables>(RequestPasswordRecoveryDocument, options);
      }
export type RequestPasswordRecoveryMutationHookResult = ReturnType<typeof useRequestPasswordRecoveryMutation>;
export type RequestPasswordRecoveryMutationResult = Apollo.MutationResult<RequestPasswordRecoveryMutation>;
export type RequestPasswordRecoveryMutationOptions = Apollo.BaseMutationOptions<RequestPasswordRecoveryMutation, RequestPasswordRecoveryMutationVariables>;
export const ExchangeAuthCodeDocument = gql`
    mutation ExchangeAuthCode($authCode: String!, $clientType: ClientType!) {
  ExchangeAuthCode(authCode: $authCode, clientType: $clientType) {
    accessToken
    refreshToken
  }
}
    `;
export type ExchangeAuthCodeMutationFn = Apollo.MutationFunction<ExchangeAuthCodeMutation, ExchangeAuthCodeMutationVariables>;

/**
 * __useExchangeAuthCodeMutation__
 *
 * To run a mutation, you first call `useExchangeAuthCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExchangeAuthCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exchangeAuthCodeMutation, { data, loading, error }] = useExchangeAuthCodeMutation({
 *   variables: {
 *      authCode: // value for 'authCode'
 *      clientType: // value for 'clientType'
 *   },
 * });
 */
export function useExchangeAuthCodeMutation(baseOptions?: Apollo.MutationHookOptions<ExchangeAuthCodeMutation, ExchangeAuthCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExchangeAuthCodeMutation, ExchangeAuthCodeMutationVariables>(ExchangeAuthCodeDocument, options);
      }
export type ExchangeAuthCodeMutationHookResult = ReturnType<typeof useExchangeAuthCodeMutation>;
export type ExchangeAuthCodeMutationResult = Apollo.MutationResult<ExchangeAuthCodeMutation>;
export type ExchangeAuthCodeMutationOptions = Apollo.BaseMutationOptions<ExchangeAuthCodeMutation, ExchangeAuthCodeMutationVariables>;
export const DeauthenticateDocument = gql`
    mutation Deauthenticate($accessToken: String!) {
  deauthenticate(accessToken: $accessToken)
}
    `;
export type DeauthenticateMutationFn = Apollo.MutationFunction<DeauthenticateMutation, DeauthenticateMutationVariables>;

/**
 * __useDeauthenticateMutation__
 *
 * To run a mutation, you first call `useDeauthenticateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeauthenticateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deauthenticateMutation, { data, loading, error }] = useDeauthenticateMutation({
 *   variables: {
 *      accessToken: // value for 'accessToken'
 *   },
 * });
 */
export function useDeauthenticateMutation(baseOptions?: Apollo.MutationHookOptions<DeauthenticateMutation, DeauthenticateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeauthenticateMutation, DeauthenticateMutationVariables>(DeauthenticateDocument, options);
      }
export type DeauthenticateMutationHookResult = ReturnType<typeof useDeauthenticateMutation>;
export type DeauthenticateMutationResult = Apollo.MutationResult<DeauthenticateMutation>;
export type DeauthenticateMutationOptions = Apollo.BaseMutationOptions<DeauthenticateMutation, DeauthenticateMutationVariables>;
export const TraitSoftSkillContextFileUploadDocument = gql`
    mutation TraitSoftSkillContextFileUpload($apply: Boolean!, $file: Upload!) {
  TraitSoftSkillContextFileUpload(apply: $apply, file: $file) {
    apply
    creates {
      ...TraitSoftSkillContextFileUploadRow
    }
    warnings
    errorMessage
    errorMessages
  }
}
    ${TraitSoftSkillContextFileUploadRowFragmentDoc}`;
export type TraitSoftSkillContextFileUploadMutationFn = Apollo.MutationFunction<TraitSoftSkillContextFileUploadMutation, TraitSoftSkillContextFileUploadMutationVariables>;

/**
 * __useTraitSoftSkillContextFileUploadMutation__
 *
 * To run a mutation, you first call `useTraitSoftSkillContextFileUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTraitSoftSkillContextFileUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [traitSoftSkillContextFileUploadMutation, { data, loading, error }] = useTraitSoftSkillContextFileUploadMutation({
 *   variables: {
 *      apply: // value for 'apply'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useTraitSoftSkillContextFileUploadMutation(baseOptions?: Apollo.MutationHookOptions<TraitSoftSkillContextFileUploadMutation, TraitSoftSkillContextFileUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TraitSoftSkillContextFileUploadMutation, TraitSoftSkillContextFileUploadMutationVariables>(TraitSoftSkillContextFileUploadDocument, options);
      }
export type TraitSoftSkillContextFileUploadMutationHookResult = ReturnType<typeof useTraitSoftSkillContextFileUploadMutation>;
export type TraitSoftSkillContextFileUploadMutationResult = Apollo.MutationResult<TraitSoftSkillContextFileUploadMutation>;
export type TraitSoftSkillContextFileUploadMutationOptions = Apollo.BaseMutationOptions<TraitSoftSkillContextFileUploadMutation, TraitSoftSkillContextFileUploadMutationVariables>;
export const BehaviourFromCsvRowsCreateManyDocument = gql`
    mutation BehaviourFromCsvRowsCreateMany($dto: [BehaviourFromCsvRowsCreateManyArgs!]!) {
  BehaviourFromCsvRowsCreateMany(dto: $dto)
}
    `;
export type BehaviourFromCsvRowsCreateManyMutationFn = Apollo.MutationFunction<BehaviourFromCsvRowsCreateManyMutation, BehaviourFromCsvRowsCreateManyMutationVariables>;

/**
 * __useBehaviourFromCsvRowsCreateManyMutation__
 *
 * To run a mutation, you first call `useBehaviourFromCsvRowsCreateManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBehaviourFromCsvRowsCreateManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [behaviourFromCsvRowsCreateManyMutation, { data, loading, error }] = useBehaviourFromCsvRowsCreateManyMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useBehaviourFromCsvRowsCreateManyMutation(baseOptions?: Apollo.MutationHookOptions<BehaviourFromCsvRowsCreateManyMutation, BehaviourFromCsvRowsCreateManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BehaviourFromCsvRowsCreateManyMutation, BehaviourFromCsvRowsCreateManyMutationVariables>(BehaviourFromCsvRowsCreateManyDocument, options);
      }
export type BehaviourFromCsvRowsCreateManyMutationHookResult = ReturnType<typeof useBehaviourFromCsvRowsCreateManyMutation>;
export type BehaviourFromCsvRowsCreateManyMutationResult = Apollo.MutationResult<BehaviourFromCsvRowsCreateManyMutation>;
export type BehaviourFromCsvRowsCreateManyMutationOptions = Apollo.BaseMutationOptions<BehaviourFromCsvRowsCreateManyMutation, BehaviourFromCsvRowsCreateManyMutationVariables>;
export const ProvisionCoderbyteWorkspaceDocument = gql`
    mutation ProvisionCoderbyteWorkspace($companyId: Int!) {
  provisionCoderbyteWorkspace(companyId: $companyId) {
    ...CoderbyteWorkspaceFields
  }
}
    ${CoderbyteWorkspaceFieldsFragmentDoc}`;
export type ProvisionCoderbyteWorkspaceMutationFn = Apollo.MutationFunction<ProvisionCoderbyteWorkspaceMutation, ProvisionCoderbyteWorkspaceMutationVariables>;

/**
 * __useProvisionCoderbyteWorkspaceMutation__
 *
 * To run a mutation, you first call `useProvisionCoderbyteWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProvisionCoderbyteWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [provisionCoderbyteWorkspaceMutation, { data, loading, error }] = useProvisionCoderbyteWorkspaceMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useProvisionCoderbyteWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<ProvisionCoderbyteWorkspaceMutation, ProvisionCoderbyteWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProvisionCoderbyteWorkspaceMutation, ProvisionCoderbyteWorkspaceMutationVariables>(ProvisionCoderbyteWorkspaceDocument, options);
      }
export type ProvisionCoderbyteWorkspaceMutationHookResult = ReturnType<typeof useProvisionCoderbyteWorkspaceMutation>;
export type ProvisionCoderbyteWorkspaceMutationResult = Apollo.MutationResult<ProvisionCoderbyteWorkspaceMutation>;
export type ProvisionCoderbyteWorkspaceMutationOptions = Apollo.BaseMutationOptions<ProvisionCoderbyteWorkspaceMutation, ProvisionCoderbyteWorkspaceMutationVariables>;
export const SetCoderbyteWorkspaceApiKeyDocument = gql`
    mutation SetCoderbyteWorkspaceApiKey($companyId: Int!, $apiKey: String!) {
  setCoderbyteWorkspaceApiKey(companyId: $companyId, apiKey: $apiKey) {
    ...CoderbyteWorkspaceFields
  }
}
    ${CoderbyteWorkspaceFieldsFragmentDoc}`;
export type SetCoderbyteWorkspaceApiKeyMutationFn = Apollo.MutationFunction<SetCoderbyteWorkspaceApiKeyMutation, SetCoderbyteWorkspaceApiKeyMutationVariables>;

/**
 * __useSetCoderbyteWorkspaceApiKeyMutation__
 *
 * To run a mutation, you first call `useSetCoderbyteWorkspaceApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCoderbyteWorkspaceApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCoderbyteWorkspaceApiKeyMutation, { data, loading, error }] = useSetCoderbyteWorkspaceApiKeyMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      apiKey: // value for 'apiKey'
 *   },
 * });
 */
export function useSetCoderbyteWorkspaceApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<SetCoderbyteWorkspaceApiKeyMutation, SetCoderbyteWorkspaceApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCoderbyteWorkspaceApiKeyMutation, SetCoderbyteWorkspaceApiKeyMutationVariables>(SetCoderbyteWorkspaceApiKeyDocument, options);
      }
export type SetCoderbyteWorkspaceApiKeyMutationHookResult = ReturnType<typeof useSetCoderbyteWorkspaceApiKeyMutation>;
export type SetCoderbyteWorkspaceApiKeyMutationResult = Apollo.MutationResult<SetCoderbyteWorkspaceApiKeyMutation>;
export type SetCoderbyteWorkspaceApiKeyMutationOptions = Apollo.BaseMutationOptions<SetCoderbyteWorkspaceApiKeyMutation, SetCoderbyteWorkspaceApiKeyMutationVariables>;
export const VerifyCoderbyteWorkspaceApiKeyDocument = gql`
    mutation VerifyCoderbyteWorkspaceApiKey($companyId: Int!) {
  verifyCoderbyteWorkspaceApiKey(companyId: $companyId) {
    ...CoderbyteWorkspaceFields
  }
}
    ${CoderbyteWorkspaceFieldsFragmentDoc}`;
export type VerifyCoderbyteWorkspaceApiKeyMutationFn = Apollo.MutationFunction<VerifyCoderbyteWorkspaceApiKeyMutation, VerifyCoderbyteWorkspaceApiKeyMutationVariables>;

/**
 * __useVerifyCoderbyteWorkspaceApiKeyMutation__
 *
 * To run a mutation, you first call `useVerifyCoderbyteWorkspaceApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyCoderbyteWorkspaceApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyCoderbyteWorkspaceApiKeyMutation, { data, loading, error }] = useVerifyCoderbyteWorkspaceApiKeyMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useVerifyCoderbyteWorkspaceApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<VerifyCoderbyteWorkspaceApiKeyMutation, VerifyCoderbyteWorkspaceApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyCoderbyteWorkspaceApiKeyMutation, VerifyCoderbyteWorkspaceApiKeyMutationVariables>(VerifyCoderbyteWorkspaceApiKeyDocument, options);
      }
export type VerifyCoderbyteWorkspaceApiKeyMutationHookResult = ReturnType<typeof useVerifyCoderbyteWorkspaceApiKeyMutation>;
export type VerifyCoderbyteWorkspaceApiKeyMutationResult = Apollo.MutationResult<VerifyCoderbyteWorkspaceApiKeyMutation>;
export type VerifyCoderbyteWorkspaceApiKeyMutationOptions = Apollo.BaseMutationOptions<VerifyCoderbyteWorkspaceApiKeyMutation, VerifyCoderbyteWorkspaceApiKeyMutationVariables>;
export const SetCoderbyteWorkspaceAdminPasswordDocument = gql`
    mutation SetCoderbyteWorkspaceAdminPassword($companyId: Int!, $adminPassword: String!) {
  setCoderbyteWorkspaceAdminPassword(
    companyId: $companyId
    adminPassword: $adminPassword
  ) {
    ...CoderbyteWorkspaceFields
  }
}
    ${CoderbyteWorkspaceFieldsFragmentDoc}`;
export type SetCoderbyteWorkspaceAdminPasswordMutationFn = Apollo.MutationFunction<SetCoderbyteWorkspaceAdminPasswordMutation, SetCoderbyteWorkspaceAdminPasswordMutationVariables>;

/**
 * __useSetCoderbyteWorkspaceAdminPasswordMutation__
 *
 * To run a mutation, you first call `useSetCoderbyteWorkspaceAdminPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCoderbyteWorkspaceAdminPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCoderbyteWorkspaceAdminPasswordMutation, { data, loading, error }] = useSetCoderbyteWorkspaceAdminPasswordMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      adminPassword: // value for 'adminPassword'
 *   },
 * });
 */
export function useSetCoderbyteWorkspaceAdminPasswordMutation(baseOptions?: Apollo.MutationHookOptions<SetCoderbyteWorkspaceAdminPasswordMutation, SetCoderbyteWorkspaceAdminPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCoderbyteWorkspaceAdminPasswordMutation, SetCoderbyteWorkspaceAdminPasswordMutationVariables>(SetCoderbyteWorkspaceAdminPasswordDocument, options);
      }
export type SetCoderbyteWorkspaceAdminPasswordMutationHookResult = ReturnType<typeof useSetCoderbyteWorkspaceAdminPasswordMutation>;
export type SetCoderbyteWorkspaceAdminPasswordMutationResult = Apollo.MutationResult<SetCoderbyteWorkspaceAdminPasswordMutation>;
export type SetCoderbyteWorkspaceAdminPasswordMutationOptions = Apollo.BaseMutationOptions<SetCoderbyteWorkspaceAdminPasswordMutation, SetCoderbyteWorkspaceAdminPasswordMutationVariables>;
export const UpdateCompanyDocument = gql`
    mutation UpdateCompany($id: Int!, $name: String!, $areCognitiveTestsBlocked: Boolean, $areRffSoftSkillsDisabled: Boolean, $isInterviewGuideScoresEnabled: Boolean, $isLegalAcknowledgementsEnabled: Boolean, $isSkillsEvaluationScoreEnabled: Boolean, $isViewGuidanceEnabled: Boolean, $isAssigneeManagedViaIntegration: Boolean, $rfuModelType: CompanyRFUModelType, $reasonableAdjustmentsOption: ReasonableAdjustmentsOptionArgs, $assessmentExpiryOption: AssessmentExpiryOptionArgs, $managerReportId: Int, $candidateReportId: Int, $hideReports: Boolean, $atsPullJobsFromDate: Date) {
  Company: updateCompany(
    id: $id
    name: $name
    areCognitiveTestsBlocked: $areCognitiveTestsBlocked
    areRffSoftSkillsDisabled: $areRffSoftSkillsDisabled
    isInterviewGuideScoresEnabled: $isInterviewGuideScoresEnabled
    isLegalAcknowledgementsEnabled: $isLegalAcknowledgementsEnabled
    isSkillsEvaluationScoreEnabled: $isSkillsEvaluationScoreEnabled
    isViewGuidanceEnabled: $isViewGuidanceEnabled
    isAssigneeManagedViaIntegration: $isAssigneeManagedViaIntegration
    rfuModelType: $rfuModelType
    reasonableAdjustmentsOption: $reasonableAdjustmentsOption
    assessmentExpiryOption: $assessmentExpiryOption
    managerReportId: $managerReportId
    candidateReportId: $candidateReportId
    hideReports: $hideReports
    atsPullJobsFromDate: $atsPullJobsFromDate
  ) {
    ...Company
  }
}
    ${CompanyFragmentDoc}`;
export type UpdateCompanyMutationFn = Apollo.MutationFunction<UpdateCompanyMutation, UpdateCompanyMutationVariables>;

/**
 * __useUpdateCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMutation, { data, loading, error }] = useUpdateCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      areCognitiveTestsBlocked: // value for 'areCognitiveTestsBlocked'
 *      areRffSoftSkillsDisabled: // value for 'areRffSoftSkillsDisabled'
 *      isInterviewGuideScoresEnabled: // value for 'isInterviewGuideScoresEnabled'
 *      isLegalAcknowledgementsEnabled: // value for 'isLegalAcknowledgementsEnabled'
 *      isSkillsEvaluationScoreEnabled: // value for 'isSkillsEvaluationScoreEnabled'
 *      isViewGuidanceEnabled: // value for 'isViewGuidanceEnabled'
 *      isAssigneeManagedViaIntegration: // value for 'isAssigneeManagedViaIntegration'
 *      rfuModelType: // value for 'rfuModelType'
 *      reasonableAdjustmentsOption: // value for 'reasonableAdjustmentsOption'
 *      assessmentExpiryOption: // value for 'assessmentExpiryOption'
 *      managerReportId: // value for 'managerReportId'
 *      candidateReportId: // value for 'candidateReportId'
 *      hideReports: // value for 'hideReports'
 *      atsPullJobsFromDate: // value for 'atsPullJobsFromDate'
 *   },
 * });
 */
export function useUpdateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyMutation, UpdateCompanyMutationVariables>(UpdateCompanyDocument, options);
      }
export type UpdateCompanyMutationHookResult = ReturnType<typeof useUpdateCompanyMutation>;
export type UpdateCompanyMutationResult = Apollo.MutationResult<UpdateCompanyMutation>;
export type UpdateCompanyMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>;
export const CompanySignatureCreateOneDocument = gql`
    mutation CompanySignatureCreateOne($companyId: Int!, $isDefault: Boolean!, $signature: String!, $signatureEmail: String!) {
  CompanySignature: CompanySignatureCreateOne(
    companyId: $companyId
    isDefault: $isDefault
    signature: $signature
    signatureEmail: $signatureEmail
  ) {
    ...CompanySignatureModel
  }
}
    ${CompanySignatureModelFragmentDoc}`;
export type CompanySignatureCreateOneMutationFn = Apollo.MutationFunction<CompanySignatureCreateOneMutation, CompanySignatureCreateOneMutationVariables>;

/**
 * __useCompanySignatureCreateOneMutation__
 *
 * To run a mutation, you first call `useCompanySignatureCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanySignatureCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companySignatureCreateOneMutation, { data, loading, error }] = useCompanySignatureCreateOneMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      isDefault: // value for 'isDefault'
 *      signature: // value for 'signature'
 *      signatureEmail: // value for 'signatureEmail'
 *   },
 * });
 */
export function useCompanySignatureCreateOneMutation(baseOptions?: Apollo.MutationHookOptions<CompanySignatureCreateOneMutation, CompanySignatureCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanySignatureCreateOneMutation, CompanySignatureCreateOneMutationVariables>(CompanySignatureCreateOneDocument, options);
      }
export type CompanySignatureCreateOneMutationHookResult = ReturnType<typeof useCompanySignatureCreateOneMutation>;
export type CompanySignatureCreateOneMutationResult = Apollo.MutationResult<CompanySignatureCreateOneMutation>;
export type CompanySignatureCreateOneMutationOptions = Apollo.BaseMutationOptions<CompanySignatureCreateOneMutation, CompanySignatureCreateOneMutationVariables>;
export const CompanySignatureUpdateOneDocument = gql`
    mutation CompanySignatureUpdateOne($id: Int!, $isDefault: Boolean, $signature: String, $signatureEmail: String) {
  CompanySignature: CompanySignatureUpdateOne(
    id: $id
    isDefault: $isDefault
    signature: $signature
    signatureEmail: $signatureEmail
  ) {
    ...CompanySignatureModel
  }
}
    ${CompanySignatureModelFragmentDoc}`;
export type CompanySignatureUpdateOneMutationFn = Apollo.MutationFunction<CompanySignatureUpdateOneMutation, CompanySignatureUpdateOneMutationVariables>;

/**
 * __useCompanySignatureUpdateOneMutation__
 *
 * To run a mutation, you first call `useCompanySignatureUpdateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanySignatureUpdateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companySignatureUpdateOneMutation, { data, loading, error }] = useCompanySignatureUpdateOneMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isDefault: // value for 'isDefault'
 *      signature: // value for 'signature'
 *      signatureEmail: // value for 'signatureEmail'
 *   },
 * });
 */
export function useCompanySignatureUpdateOneMutation(baseOptions?: Apollo.MutationHookOptions<CompanySignatureUpdateOneMutation, CompanySignatureUpdateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanySignatureUpdateOneMutation, CompanySignatureUpdateOneMutationVariables>(CompanySignatureUpdateOneDocument, options);
      }
export type CompanySignatureUpdateOneMutationHookResult = ReturnType<typeof useCompanySignatureUpdateOneMutation>;
export type CompanySignatureUpdateOneMutationResult = Apollo.MutationResult<CompanySignatureUpdateOneMutation>;
export type CompanySignatureUpdateOneMutationOptions = Apollo.BaseMutationOptions<CompanySignatureUpdateOneMutation, CompanySignatureUpdateOneMutationVariables>;
export const CompanySignatureDeleteOneDocument = gql`
    mutation CompanySignatureDeleteOne($id: Int!) {
  CompanySignature: CompanySignatureDeleteOne(id: $id) {
    affected
  }
}
    `;
export type CompanySignatureDeleteOneMutationFn = Apollo.MutationFunction<CompanySignatureDeleteOneMutation, CompanySignatureDeleteOneMutationVariables>;

/**
 * __useCompanySignatureDeleteOneMutation__
 *
 * To run a mutation, you first call `useCompanySignatureDeleteOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanySignatureDeleteOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companySignatureDeleteOneMutation, { data, loading, error }] = useCompanySignatureDeleteOneMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompanySignatureDeleteOneMutation(baseOptions?: Apollo.MutationHookOptions<CompanySignatureDeleteOneMutation, CompanySignatureDeleteOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanySignatureDeleteOneMutation, CompanySignatureDeleteOneMutationVariables>(CompanySignatureDeleteOneDocument, options);
      }
export type CompanySignatureDeleteOneMutationHookResult = ReturnType<typeof useCompanySignatureDeleteOneMutation>;
export type CompanySignatureDeleteOneMutationResult = Apollo.MutationResult<CompanySignatureDeleteOneMutation>;
export type CompanySignatureDeleteOneMutationOptions = Apollo.BaseMutationOptions<CompanySignatureDeleteOneMutation, CompanySignatureDeleteOneMutationVariables>;
export const CreateCompanyDocument = gql`
    mutation CreateCompany($name: String!) {
  company: createCompany(name: $name) {
    ...Company
  }
}
    ${CompanyFragmentDoc}`;
export type CreateCompanyMutationFn = Apollo.MutationFunction<CreateCompanyMutation, CreateCompanyMutationVariables>;

/**
 * __useCreateCompanyMutation__
 *
 * To run a mutation, you first call `useCreateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyMutation, { data, loading, error }] = useCreateCompanyMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyMutation, CreateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyMutation, CreateCompanyMutationVariables>(CreateCompanyDocument, options);
      }
export type CreateCompanyMutationHookResult = ReturnType<typeof useCreateCompanyMutation>;
export type CreateCompanyMutationResult = Apollo.MutationResult<CreateCompanyMutation>;
export type CreateCompanyMutationOptions = Apollo.BaseMutationOptions<CreateCompanyMutation, CreateCompanyMutationVariables>;
export const DeleteCompanyDocument = gql`
    mutation DeleteCompany($id: Int!) {
  deleteCompany(id: $id)
}
    `;
export type DeleteCompanyMutationFn = Apollo.MutationFunction<DeleteCompanyMutation, DeleteCompanyMutationVariables>;

/**
 * __useDeleteCompanyMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyMutation, { data, loading, error }] = useDeleteCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCompanyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCompanyMutation, DeleteCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCompanyMutation, DeleteCompanyMutationVariables>(DeleteCompanyDocument, options);
      }
export type DeleteCompanyMutationHookResult = ReturnType<typeof useDeleteCompanyMutation>;
export type DeleteCompanyMutationResult = Apollo.MutationResult<DeleteCompanyMutation>;
export type DeleteCompanyMutationOptions = Apollo.BaseMutationOptions<DeleteCompanyMutation, DeleteCompanyMutationVariables>;
export const UploadCompanyLogoDocument = gql`
    mutation UploadCompanyLogo($id: Int!, $file: Upload!) {
  uploadCompanyLogo(id: $id, file: $file)
}
    `;
export type UploadCompanyLogoMutationFn = Apollo.MutationFunction<UploadCompanyLogoMutation, UploadCompanyLogoMutationVariables>;

/**
 * __useUploadCompanyLogoMutation__
 *
 * To run a mutation, you first call `useUploadCompanyLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadCompanyLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadCompanyLogoMutation, { data, loading, error }] = useUploadCompanyLogoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadCompanyLogoMutation(baseOptions?: Apollo.MutationHookOptions<UploadCompanyLogoMutation, UploadCompanyLogoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadCompanyLogoMutation, UploadCompanyLogoMutationVariables>(UploadCompanyLogoDocument, options);
      }
export type UploadCompanyLogoMutationHookResult = ReturnType<typeof useUploadCompanyLogoMutation>;
export type UploadCompanyLogoMutationResult = Apollo.MutationResult<UploadCompanyLogoMutation>;
export type UploadCompanyLogoMutationOptions = Apollo.BaseMutationOptions<UploadCompanyLogoMutation, UploadCompanyLogoMutationVariables>;
export const CompanyAllowedEmailDomainsUpdateDocument = gql`
    mutation CompanyAllowedEmailDomainsUpdate($allowedEmailDomains: [String!]!, $id: Int!) {
  CompanyAllowedEmailDomainsUpdate(
    allowedEmailDomains: $allowedEmailDomains
    id: $id
  )
}
    `;
export type CompanyAllowedEmailDomainsUpdateMutationFn = Apollo.MutationFunction<CompanyAllowedEmailDomainsUpdateMutation, CompanyAllowedEmailDomainsUpdateMutationVariables>;

/**
 * __useCompanyAllowedEmailDomainsUpdateMutation__
 *
 * To run a mutation, you first call `useCompanyAllowedEmailDomainsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyAllowedEmailDomainsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyAllowedEmailDomainsUpdateMutation, { data, loading, error }] = useCompanyAllowedEmailDomainsUpdateMutation({
 *   variables: {
 *      allowedEmailDomains: // value for 'allowedEmailDomains'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompanyAllowedEmailDomainsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CompanyAllowedEmailDomainsUpdateMutation, CompanyAllowedEmailDomainsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanyAllowedEmailDomainsUpdateMutation, CompanyAllowedEmailDomainsUpdateMutationVariables>(CompanyAllowedEmailDomainsUpdateDocument, options);
      }
export type CompanyAllowedEmailDomainsUpdateMutationHookResult = ReturnType<typeof useCompanyAllowedEmailDomainsUpdateMutation>;
export type CompanyAllowedEmailDomainsUpdateMutationResult = Apollo.MutationResult<CompanyAllowedEmailDomainsUpdateMutation>;
export type CompanyAllowedEmailDomainsUpdateMutationOptions = Apollo.BaseMutationOptions<CompanyAllowedEmailDomainsUpdateMutation, CompanyAllowedEmailDomainsUpdateMutationVariables>;
export const CompanyCreateUserDocument = gql`
    mutation CompanyCreateUser($companyId: Float!, $email: String!, $externalId: String!, $firstName: String, $locale: SupportedLocale, $lastName: String, $roles: [IdentityPermissionRole!], $sendInvite: Boolean!) {
  CompanyCreateUser(
    companyId: $companyId
    email: $email
    externalId: $externalId
    firstName: $firstName
    lastName: $lastName
    locale: $locale
    roles: $roles
    sendInvite: $sendInvite
  ) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type CompanyCreateUserMutationFn = Apollo.MutationFunction<CompanyCreateUserMutation, CompanyCreateUserMutationVariables>;

/**
 * __useCompanyCreateUserMutation__
 *
 * To run a mutation, you first call `useCompanyCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyCreateUserMutation, { data, loading, error }] = useCompanyCreateUserMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      email: // value for 'email'
 *      externalId: // value for 'externalId'
 *      firstName: // value for 'firstName'
 *      locale: // value for 'locale'
 *      lastName: // value for 'lastName'
 *      roles: // value for 'roles'
 *      sendInvite: // value for 'sendInvite'
 *   },
 * });
 */
export function useCompanyCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CompanyCreateUserMutation, CompanyCreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanyCreateUserMutation, CompanyCreateUserMutationVariables>(CompanyCreateUserDocument, options);
      }
export type CompanyCreateUserMutationHookResult = ReturnType<typeof useCompanyCreateUserMutation>;
export type CompanyCreateUserMutationResult = Apollo.MutationResult<CompanyCreateUserMutation>;
export type CompanyCreateUserMutationOptions = Apollo.BaseMutationOptions<CompanyCreateUserMutation, CompanyCreateUserMutationVariables>;
export const CompanyResendInviteDocument = gql`
    mutation CompanyResendInvite($userId: Float!, $companyId: Float!) {
  CompanyResendInvite(userId: $userId, companyId: $companyId)
}
    `;
export type CompanyResendInviteMutationFn = Apollo.MutationFunction<CompanyResendInviteMutation, CompanyResendInviteMutationVariables>;

/**
 * __useCompanyResendInviteMutation__
 *
 * To run a mutation, you first call `useCompanyResendInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyResendInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyResendInviteMutation, { data, loading, error }] = useCompanyResendInviteMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCompanyResendInviteMutation(baseOptions?: Apollo.MutationHookOptions<CompanyResendInviteMutation, CompanyResendInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanyResendInviteMutation, CompanyResendInviteMutationVariables>(CompanyResendInviteDocument, options);
      }
export type CompanyResendInviteMutationHookResult = ReturnType<typeof useCompanyResendInviteMutation>;
export type CompanyResendInviteMutationResult = Apollo.MutationResult<CompanyResendInviteMutation>;
export type CompanyResendInviteMutationOptions = Apollo.BaseMutationOptions<CompanyResendInviteMutation, CompanyResendInviteMutationVariables>;
export const CompanyMaybeUserEmployeeFindManyDocument = gql`
    query CompanyMaybeUserEmployeeFindMany($companyId: Float!) {
  CompanyMaybeUserEmployeeFindMany(companyId: $companyId) {
    userId
    employeeId
    email
    firstName
    lastName
    isUser
    isCompanyEmployee
  }
}
    `;

/**
 * __useCompanyMaybeUserEmployeeFindManyQuery__
 *
 * To run a query within a React component, call `useCompanyMaybeUserEmployeeFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyMaybeUserEmployeeFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyMaybeUserEmployeeFindManyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCompanyMaybeUserEmployeeFindManyQuery(baseOptions: Apollo.QueryHookOptions<CompanyMaybeUserEmployeeFindManyQuery, CompanyMaybeUserEmployeeFindManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyMaybeUserEmployeeFindManyQuery, CompanyMaybeUserEmployeeFindManyQueryVariables>(CompanyMaybeUserEmployeeFindManyDocument, options);
      }
export function useCompanyMaybeUserEmployeeFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyMaybeUserEmployeeFindManyQuery, CompanyMaybeUserEmployeeFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyMaybeUserEmployeeFindManyQuery, CompanyMaybeUserEmployeeFindManyQueryVariables>(CompanyMaybeUserEmployeeFindManyDocument, options);
        }
export type CompanyMaybeUserEmployeeFindManyQueryHookResult = ReturnType<typeof useCompanyMaybeUserEmployeeFindManyQuery>;
export type CompanyMaybeUserEmployeeFindManyLazyQueryHookResult = ReturnType<typeof useCompanyMaybeUserEmployeeFindManyLazyQuery>;
export type CompanyMaybeUserEmployeeFindManyQueryResult = Apollo.QueryResult<CompanyMaybeUserEmployeeFindManyQuery, CompanyMaybeUserEmployeeFindManyQueryVariables>;
export const CompanyEmployeeUpdateDocument = gql`
    mutation companyEmployeeUpdate($companyId: Int, $customFields: UserCompanyInfoCustomFieldsArgs, $department: String, $email: String, $employeeId: String, $endDate: Date, $firstName: String, $hrManagerEmployeeId: String, $id: Float!, $isArchived: Boolean, $jobTitle: String, $lastName: String, $startDate: Date) {
  CompanyEmployeeUpdate(
    companyId: $companyId
    customFields: $customFields
    department: $department
    email: $email
    employeeId: $employeeId
    endDate: $endDate
    firstName: $firstName
    hrManagerEmployeeId: $hrManagerEmployeeId
    id: $id
    isArchived: $isArchived
    jobTitle: $jobTitle
    lastName: $lastName
    startDate: $startDate
  ) {
    ...CompanyEmployee
  }
}
    ${CompanyEmployeeFragmentDoc}`;
export type CompanyEmployeeUpdateMutationFn = Apollo.MutationFunction<CompanyEmployeeUpdateMutation, CompanyEmployeeUpdateMutationVariables>;

/**
 * __useCompanyEmployeeUpdateMutation__
 *
 * To run a mutation, you first call `useCompanyEmployeeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyEmployeeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyEmployeeUpdateMutation, { data, loading, error }] = useCompanyEmployeeUpdateMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      customFields: // value for 'customFields'
 *      department: // value for 'department'
 *      email: // value for 'email'
 *      employeeId: // value for 'employeeId'
 *      endDate: // value for 'endDate'
 *      firstName: // value for 'firstName'
 *      hrManagerEmployeeId: // value for 'hrManagerEmployeeId'
 *      id: // value for 'id'
 *      isArchived: // value for 'isArchived'
 *      jobTitle: // value for 'jobTitle'
 *      lastName: // value for 'lastName'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useCompanyEmployeeUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CompanyEmployeeUpdateMutation, CompanyEmployeeUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanyEmployeeUpdateMutation, CompanyEmployeeUpdateMutationVariables>(CompanyEmployeeUpdateDocument, options);
      }
export type CompanyEmployeeUpdateMutationHookResult = ReturnType<typeof useCompanyEmployeeUpdateMutation>;
export type CompanyEmployeeUpdateMutationResult = Apollo.MutationResult<CompanyEmployeeUpdateMutation>;
export type CompanyEmployeeUpdateMutationOptions = Apollo.BaseMutationOptions<CompanyEmployeeUpdateMutation, CompanyEmployeeUpdateMutationVariables>;
export const CompanyEmployeeDeleteOneDocument = gql`
    mutation companyEmployeeDeleteOne($id: Int!) {
  CompanyEmployeeDeleteOne(id: $id) {
    affected
  }
}
    `;
export type CompanyEmployeeDeleteOneMutationFn = Apollo.MutationFunction<CompanyEmployeeDeleteOneMutation, CompanyEmployeeDeleteOneMutationVariables>;

/**
 * __useCompanyEmployeeDeleteOneMutation__
 *
 * To run a mutation, you first call `useCompanyEmployeeDeleteOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyEmployeeDeleteOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyEmployeeDeleteOneMutation, { data, loading, error }] = useCompanyEmployeeDeleteOneMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompanyEmployeeDeleteOneMutation(baseOptions?: Apollo.MutationHookOptions<CompanyEmployeeDeleteOneMutation, CompanyEmployeeDeleteOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanyEmployeeDeleteOneMutation, CompanyEmployeeDeleteOneMutationVariables>(CompanyEmployeeDeleteOneDocument, options);
      }
export type CompanyEmployeeDeleteOneMutationHookResult = ReturnType<typeof useCompanyEmployeeDeleteOneMutation>;
export type CompanyEmployeeDeleteOneMutationResult = Apollo.MutationResult<CompanyEmployeeDeleteOneMutation>;
export type CompanyEmployeeDeleteOneMutationOptions = Apollo.BaseMutationOptions<CompanyEmployeeDeleteOneMutation, CompanyEmployeeDeleteOneMutationVariables>;
export const CompanyEmployeeCreateDocument = gql`
    mutation companyEmployeeCreate($companyId: Int!, $customFields: UserCompanyInfoCustomFieldsArgs, $department: String, $email: String!, $employeeId: String!, $endDate: Date, $firstName: String!, $hrManagerEmployeeId: String, $isArchived: Boolean, $jobTitle: String, $lastName: String!, $startDate: Date) {
  CompanyEmployeeCreate(
    companyId: $companyId
    customFields: $customFields
    department: $department
    email: $email
    employeeId: $employeeId
    endDate: $endDate
    firstName: $firstName
    hrManagerEmployeeId: $hrManagerEmployeeId
    isArchived: $isArchived
    jobTitle: $jobTitle
    lastName: $lastName
    startDate: $startDate
  ) {
    ...CompanyEmployee
  }
}
    ${CompanyEmployeeFragmentDoc}`;
export type CompanyEmployeeCreateMutationFn = Apollo.MutationFunction<CompanyEmployeeCreateMutation, CompanyEmployeeCreateMutationVariables>;

/**
 * __useCompanyEmployeeCreateMutation__
 *
 * To run a mutation, you first call `useCompanyEmployeeCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyEmployeeCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyEmployeeCreateMutation, { data, loading, error }] = useCompanyEmployeeCreateMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      customFields: // value for 'customFields'
 *      department: // value for 'department'
 *      email: // value for 'email'
 *      employeeId: // value for 'employeeId'
 *      endDate: // value for 'endDate'
 *      firstName: // value for 'firstName'
 *      hrManagerEmployeeId: // value for 'hrManagerEmployeeId'
 *      isArchived: // value for 'isArchived'
 *      jobTitle: // value for 'jobTitle'
 *      lastName: // value for 'lastName'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useCompanyEmployeeCreateMutation(baseOptions?: Apollo.MutationHookOptions<CompanyEmployeeCreateMutation, CompanyEmployeeCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanyEmployeeCreateMutation, CompanyEmployeeCreateMutationVariables>(CompanyEmployeeCreateDocument, options);
      }
export type CompanyEmployeeCreateMutationHookResult = ReturnType<typeof useCompanyEmployeeCreateMutation>;
export type CompanyEmployeeCreateMutationResult = Apollo.MutationResult<CompanyEmployeeCreateMutation>;
export type CompanyEmployeeCreateMutationOptions = Apollo.BaseMutationOptions<CompanyEmployeeCreateMutation, CompanyEmployeeCreateMutationVariables>;
export const CompanyRoleUpsertDocument = gql`
    mutation CompanyRoleUpsert($companyId: Int!, $roleId: Int!, $twoFactorEnabled: Boolean!) {
  CompanyRoleUpsert(
    companyId: $companyId
    roleId: $roleId
    twoFactorEnabled: $twoFactorEnabled
  ) {
    ...CompanyRole
  }
}
    ${CompanyRoleFragmentDoc}`;
export type CompanyRoleUpsertMutationFn = Apollo.MutationFunction<CompanyRoleUpsertMutation, CompanyRoleUpsertMutationVariables>;

/**
 * __useCompanyRoleUpsertMutation__
 *
 * To run a mutation, you first call `useCompanyRoleUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyRoleUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyRoleUpsertMutation, { data, loading, error }] = useCompanyRoleUpsertMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      roleId: // value for 'roleId'
 *      twoFactorEnabled: // value for 'twoFactorEnabled'
 *   },
 * });
 */
export function useCompanyRoleUpsertMutation(baseOptions?: Apollo.MutationHookOptions<CompanyRoleUpsertMutation, CompanyRoleUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanyRoleUpsertMutation, CompanyRoleUpsertMutationVariables>(CompanyRoleUpsertDocument, options);
      }
export type CompanyRoleUpsertMutationHookResult = ReturnType<typeof useCompanyRoleUpsertMutation>;
export type CompanyRoleUpsertMutationResult = Apollo.MutationResult<CompanyRoleUpsertMutation>;
export type CompanyRoleUpsertMutationOptions = Apollo.BaseMutationOptions<CompanyRoleUpsertMutation, CompanyRoleUpsertMutationVariables>;
export const AdminResultsCsvFileExportDocument = gql`
    mutation AdminResultsCsvFileExport($stageIds: [Int!]!, $exportLevel: AdminResultsExportLevel, $scoreType: AdminResultsExportScoreType, $includeDeiData: Boolean, $includeFormsData: Boolean) {
  AdminResultsCsvFileExport(
    stageIds: $stageIds
    exportLevel: $exportLevel
    scoreType: $scoreType
    includeDeiData: $includeDeiData
    includeFormsData: $includeFormsData
  ) {
    status
    error
  }
}
    `;
export type AdminResultsCsvFileExportMutationFn = Apollo.MutationFunction<AdminResultsCsvFileExportMutation, AdminResultsCsvFileExportMutationVariables>;

/**
 * __useAdminResultsCsvFileExportMutation__
 *
 * To run a mutation, you first call `useAdminResultsCsvFileExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminResultsCsvFileExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminResultsCsvFileExportMutation, { data, loading, error }] = useAdminResultsCsvFileExportMutation({
 *   variables: {
 *      stageIds: // value for 'stageIds'
 *      exportLevel: // value for 'exportLevel'
 *      scoreType: // value for 'scoreType'
 *      includeDeiData: // value for 'includeDeiData'
 *      includeFormsData: // value for 'includeFormsData'
 *   },
 * });
 */
export function useAdminResultsCsvFileExportMutation(baseOptions?: Apollo.MutationHookOptions<AdminResultsCsvFileExportMutation, AdminResultsCsvFileExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminResultsCsvFileExportMutation, AdminResultsCsvFileExportMutationVariables>(AdminResultsCsvFileExportDocument, options);
      }
export type AdminResultsCsvFileExportMutationHookResult = ReturnType<typeof useAdminResultsCsvFileExportMutation>;
export type AdminResultsCsvFileExportMutationResult = Apollo.MutationResult<AdminResultsCsvFileExportMutation>;
export type AdminResultsCsvFileExportMutationOptions = Apollo.BaseMutationOptions<AdminResultsCsvFileExportMutation, AdminResultsCsvFileExportMutationVariables>;
export const InterviewGuideBlueprintQuestionAddSoftSkillDocument = gql`
    mutation InterviewGuideBlueprintQuestionAddSoftSkill($questionSubId: String!, $softSkillId: Int!, $indicators: [SoftSkillIndicatorInput!]) {
  InterviewGuideBlueprintQuestionAddSoftSkill(
    questionSubId: $questionSubId
    softSkillId: $softSkillId
    indicators: $indicators
  ) {
    id
    subId
    softSkillJunctions {
      softSkill {
        id
        name
      }
      indicators {
        __typename
        indicator
        description
        reason
        probe
        trigger
        ... on SoftSkillIndicatorV2 {
          scores {
            score
            label
            gateway_criteria
            differentiation
          }
          negative_evidence {
            red_flags {
              pattern
              example
            }
            score_reducing_patterns {
              pattern
              example
            }
          }
        }
      }
    }
  }
}
    `;
export type InterviewGuideBlueprintQuestionAddSoftSkillMutationFn = Apollo.MutationFunction<InterviewGuideBlueprintQuestionAddSoftSkillMutation, InterviewGuideBlueprintQuestionAddSoftSkillMutationVariables>;

/**
 * __useInterviewGuideBlueprintQuestionAddSoftSkillMutation__
 *
 * To run a mutation, you first call `useInterviewGuideBlueprintQuestionAddSoftSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterviewGuideBlueprintQuestionAddSoftSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interviewGuideBlueprintQuestionAddSoftSkillMutation, { data, loading, error }] = useInterviewGuideBlueprintQuestionAddSoftSkillMutation({
 *   variables: {
 *      questionSubId: // value for 'questionSubId'
 *      softSkillId: // value for 'softSkillId'
 *      indicators: // value for 'indicators'
 *   },
 * });
 */
export function useInterviewGuideBlueprintQuestionAddSoftSkillMutation(baseOptions?: Apollo.MutationHookOptions<InterviewGuideBlueprintQuestionAddSoftSkillMutation, InterviewGuideBlueprintQuestionAddSoftSkillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InterviewGuideBlueprintQuestionAddSoftSkillMutation, InterviewGuideBlueprintQuestionAddSoftSkillMutationVariables>(InterviewGuideBlueprintQuestionAddSoftSkillDocument, options);
      }
export type InterviewGuideBlueprintQuestionAddSoftSkillMutationHookResult = ReturnType<typeof useInterviewGuideBlueprintQuestionAddSoftSkillMutation>;
export type InterviewGuideBlueprintQuestionAddSoftSkillMutationResult = Apollo.MutationResult<InterviewGuideBlueprintQuestionAddSoftSkillMutation>;
export type InterviewGuideBlueprintQuestionAddSoftSkillMutationOptions = Apollo.BaseMutationOptions<InterviewGuideBlueprintQuestionAddSoftSkillMutation, InterviewGuideBlueprintQuestionAddSoftSkillMutationVariables>;
export const InterviewGuideBlueprintQuestionRemoveSoftSkillDocument = gql`
    mutation InterviewGuideBlueprintQuestionRemoveSoftSkill($questionSubId: String!, $softSkillId: Int!) {
  InterviewGuideBlueprintQuestionRemoveSoftSkill(
    questionSubId: $questionSubId
    softSkillId: $softSkillId
  ) {
    id
    subId
    softSkillJunctions {
      softSkill {
        id
        name
      }
      indicators {
        __typename
        indicator
        description
        reason
        probe
        trigger
        ... on SoftSkillIndicatorV2 {
          scores {
            score
            label
            gateway_criteria
            differentiation
          }
          negative_evidence {
            red_flags {
              pattern
              example
            }
            score_reducing_patterns {
              pattern
              example
            }
          }
        }
      }
    }
  }
}
    `;
export type InterviewGuideBlueprintQuestionRemoveSoftSkillMutationFn = Apollo.MutationFunction<InterviewGuideBlueprintQuestionRemoveSoftSkillMutation, InterviewGuideBlueprintQuestionRemoveSoftSkillMutationVariables>;

/**
 * __useInterviewGuideBlueprintQuestionRemoveSoftSkillMutation__
 *
 * To run a mutation, you first call `useInterviewGuideBlueprintQuestionRemoveSoftSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterviewGuideBlueprintQuestionRemoveSoftSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interviewGuideBlueprintQuestionRemoveSoftSkillMutation, { data, loading, error }] = useInterviewGuideBlueprintQuestionRemoveSoftSkillMutation({
 *   variables: {
 *      questionSubId: // value for 'questionSubId'
 *      softSkillId: // value for 'softSkillId'
 *   },
 * });
 */
export function useInterviewGuideBlueprintQuestionRemoveSoftSkillMutation(baseOptions?: Apollo.MutationHookOptions<InterviewGuideBlueprintQuestionRemoveSoftSkillMutation, InterviewGuideBlueprintQuestionRemoveSoftSkillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InterviewGuideBlueprintQuestionRemoveSoftSkillMutation, InterviewGuideBlueprintQuestionRemoveSoftSkillMutationVariables>(InterviewGuideBlueprintQuestionRemoveSoftSkillDocument, options);
      }
export type InterviewGuideBlueprintQuestionRemoveSoftSkillMutationHookResult = ReturnType<typeof useInterviewGuideBlueprintQuestionRemoveSoftSkillMutation>;
export type InterviewGuideBlueprintQuestionRemoveSoftSkillMutationResult = Apollo.MutationResult<InterviewGuideBlueprintQuestionRemoveSoftSkillMutation>;
export type InterviewGuideBlueprintQuestionRemoveSoftSkillMutationOptions = Apollo.BaseMutationOptions<InterviewGuideBlueprintQuestionRemoveSoftSkillMutation, InterviewGuideBlueprintQuestionRemoveSoftSkillMutationVariables>;
export const InterviewGuideBlueprintQuestionUpdateSoftSkillDocument = gql`
    mutation InterviewGuideBlueprintQuestionUpdateSoftSkill($questionSubId: String!, $softSkillId: Int!, $indicators: [SoftSkillIndicatorInput!]!) {
  InterviewGuideBlueprintQuestionUpdateSoftSkill(
    questionSubId: $questionSubId
    softSkillId: $softSkillId
    indicators: $indicators
  ) {
    id
    subId
    softSkillJunctions {
      softSkill {
        id
        name
      }
      indicators {
        __typename
        indicator
        description
        reason
        probe
        trigger
        ... on SoftSkillIndicatorV2 {
          scores {
            score
            label
            gateway_criteria
            differentiation
          }
          negative_evidence {
            red_flags {
              pattern
              example
            }
            score_reducing_patterns {
              pattern
              example
            }
          }
        }
      }
    }
  }
}
    `;
export type InterviewGuideBlueprintQuestionUpdateSoftSkillMutationFn = Apollo.MutationFunction<InterviewGuideBlueprintQuestionUpdateSoftSkillMutation, InterviewGuideBlueprintQuestionUpdateSoftSkillMutationVariables>;

/**
 * __useInterviewGuideBlueprintQuestionUpdateSoftSkillMutation__
 *
 * To run a mutation, you first call `useInterviewGuideBlueprintQuestionUpdateSoftSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterviewGuideBlueprintQuestionUpdateSoftSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interviewGuideBlueprintQuestionUpdateSoftSkillMutation, { data, loading, error }] = useInterviewGuideBlueprintQuestionUpdateSoftSkillMutation({
 *   variables: {
 *      questionSubId: // value for 'questionSubId'
 *      softSkillId: // value for 'softSkillId'
 *      indicators: // value for 'indicators'
 *   },
 * });
 */
export function useInterviewGuideBlueprintQuestionUpdateSoftSkillMutation(baseOptions?: Apollo.MutationHookOptions<InterviewGuideBlueprintQuestionUpdateSoftSkillMutation, InterviewGuideBlueprintQuestionUpdateSoftSkillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InterviewGuideBlueprintQuestionUpdateSoftSkillMutation, InterviewGuideBlueprintQuestionUpdateSoftSkillMutationVariables>(InterviewGuideBlueprintQuestionUpdateSoftSkillDocument, options);
      }
export type InterviewGuideBlueprintQuestionUpdateSoftSkillMutationHookResult = ReturnType<typeof useInterviewGuideBlueprintQuestionUpdateSoftSkillMutation>;
export type InterviewGuideBlueprintQuestionUpdateSoftSkillMutationResult = Apollo.MutationResult<InterviewGuideBlueprintQuestionUpdateSoftSkillMutation>;
export type InterviewGuideBlueprintQuestionUpdateSoftSkillMutationOptions = Apollo.BaseMutationOptions<InterviewGuideBlueprintQuestionUpdateSoftSkillMutation, InterviewGuideBlueprintQuestionUpdateSoftSkillMutationVariables>;
export const SaveInterviewQuestionContentDocument = gql`
    mutation SaveInterviewQuestionContent($id: Int!, $summary: String!, $feedback: String!, $reasonForQuestion: String!, $mainQuestion: String!, $subQuestions: [String!]!) {
  interviewQuestionContent: InterviewQuestionRoleLevelContentUpdate(
    id: $id
    summary: $summary
    feedback: $feedback
    reasonForQuestion: $reasonForQuestion
    mainQuestion: $mainQuestion
    subQuestions: $subQuestions
  ) {
    id
    softSkill {
      name
    }
    trait {
      name
    }
    softSkillId
    traitId
    classification
    roleLevel
    summary
    feedback
    reasonForQuestion
    mainQuestion
    subQuestions
  }
}
    `;
export type SaveInterviewQuestionContentMutationFn = Apollo.MutationFunction<SaveInterviewQuestionContentMutation, SaveInterviewQuestionContentMutationVariables>;

/**
 * __useSaveInterviewQuestionContentMutation__
 *
 * To run a mutation, you first call `useSaveInterviewQuestionContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveInterviewQuestionContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveInterviewQuestionContentMutation, { data, loading, error }] = useSaveInterviewQuestionContentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      summary: // value for 'summary'
 *      feedback: // value for 'feedback'
 *      reasonForQuestion: // value for 'reasonForQuestion'
 *      mainQuestion: // value for 'mainQuestion'
 *      subQuestions: // value for 'subQuestions'
 *   },
 * });
 */
export function useSaveInterviewQuestionContentMutation(baseOptions?: Apollo.MutationHookOptions<SaveInterviewQuestionContentMutation, SaveInterviewQuestionContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveInterviewQuestionContentMutation, SaveInterviewQuestionContentMutationVariables>(SaveInterviewQuestionContentDocument, options);
      }
export type SaveInterviewQuestionContentMutationHookResult = ReturnType<typeof useSaveInterviewQuestionContentMutation>;
export type SaveInterviewQuestionContentMutationResult = Apollo.MutationResult<SaveInterviewQuestionContentMutation>;
export type SaveInterviewQuestionContentMutationOptions = Apollo.BaseMutationOptions<SaveInterviewQuestionContentMutation, SaveInterviewQuestionContentMutationVariables>;
export const InterviewQuestionRoleLevelContentUploadDocument = gql`
    mutation InterviewQuestionRoleLevelContentUpload($file: Upload!) {
  InterviewQuestionRoleLevelContentUpload(file: $file) {
    errorMessages
    errors {
      softSkillSlug
      traitSlug
      summary
      roleLevel
      classification
      reasonForQuestion
      feedback
      mainQuestion
      subQuestion1
      subQuestion2
      subQuestion3
    }
    apply
    creates {
      softSkillSlug
      traitSlug
    }
  }
}
    `;
export type InterviewQuestionRoleLevelContentUploadMutationFn = Apollo.MutationFunction<InterviewQuestionRoleLevelContentUploadMutation, InterviewQuestionRoleLevelContentUploadMutationVariables>;

/**
 * __useInterviewQuestionRoleLevelContentUploadMutation__
 *
 * To run a mutation, you first call `useInterviewQuestionRoleLevelContentUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterviewQuestionRoleLevelContentUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interviewQuestionRoleLevelContentUploadMutation, { data, loading, error }] = useInterviewQuestionRoleLevelContentUploadMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useInterviewQuestionRoleLevelContentUploadMutation(baseOptions?: Apollo.MutationHookOptions<InterviewQuestionRoleLevelContentUploadMutation, InterviewQuestionRoleLevelContentUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InterviewQuestionRoleLevelContentUploadMutation, InterviewQuestionRoleLevelContentUploadMutationVariables>(InterviewQuestionRoleLevelContentUploadDocument, options);
      }
export type InterviewQuestionRoleLevelContentUploadMutationHookResult = ReturnType<typeof useInterviewQuestionRoleLevelContentUploadMutation>;
export type InterviewQuestionRoleLevelContentUploadMutationResult = Apollo.MutationResult<InterviewQuestionRoleLevelContentUploadMutation>;
export type InterviewQuestionRoleLevelContentUploadMutationOptions = Apollo.BaseMutationOptions<InterviewQuestionRoleLevelContentUploadMutation, InterviewQuestionRoleLevelContentUploadMutationVariables>;
export const InterviewStageDeleteDocument = gql`
    mutation InterviewStageDelete($subId: ID!) {
  InterviewStageDelete(subId: $subId)
}
    `;
export type InterviewStageDeleteMutationFn = Apollo.MutationFunction<InterviewStageDeleteMutation, InterviewStageDeleteMutationVariables>;

/**
 * __useInterviewStageDeleteMutation__
 *
 * To run a mutation, you first call `useInterviewStageDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterviewStageDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interviewStageDeleteMutation, { data, loading, error }] = useInterviewStageDeleteMutation({
 *   variables: {
 *      subId: // value for 'subId'
 *   },
 * });
 */
export function useInterviewStageDeleteMutation(baseOptions?: Apollo.MutationHookOptions<InterviewStageDeleteMutation, InterviewStageDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InterviewStageDeleteMutation, InterviewStageDeleteMutationVariables>(InterviewStageDeleteDocument, options);
      }
export type InterviewStageDeleteMutationHookResult = ReturnType<typeof useInterviewStageDeleteMutation>;
export type InterviewStageDeleteMutationResult = Apollo.MutationResult<InterviewStageDeleteMutation>;
export type InterviewStageDeleteMutationOptions = Apollo.BaseMutationOptions<InterviewStageDeleteMutation, InterviewStageDeleteMutationVariables>;
export const InterviewStageUpdateDocument = gql`
    mutation InterviewStageUpdate($subId: ID!, $data: InterviewStageUpdateData!) {
  InterviewStageUpdate(subId: $subId, data: $data) {
    ...InterviewStage
  }
}
    ${InterviewStageFragmentDoc}`;
export type InterviewStageUpdateMutationFn = Apollo.MutationFunction<InterviewStageUpdateMutation, InterviewStageUpdateMutationVariables>;

/**
 * __useInterviewStageUpdateMutation__
 *
 * To run a mutation, you first call `useInterviewStageUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterviewStageUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interviewStageUpdateMutation, { data, loading, error }] = useInterviewStageUpdateMutation({
 *   variables: {
 *      subId: // value for 'subId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useInterviewStageUpdateMutation(baseOptions?: Apollo.MutationHookOptions<InterviewStageUpdateMutation, InterviewStageUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InterviewStageUpdateMutation, InterviewStageUpdateMutationVariables>(InterviewStageUpdateDocument, options);
      }
export type InterviewStageUpdateMutationHookResult = ReturnType<typeof useInterviewStageUpdateMutation>;
export type InterviewStageUpdateMutationResult = Apollo.MutationResult<InterviewStageUpdateMutation>;
export type InterviewStageUpdateMutationOptions = Apollo.BaseMutationOptions<InterviewStageUpdateMutation, InterviewStageUpdateMutationVariables>;
export const OverwriteInterviewStageSkillsDocument = gql`
    mutation OverwriteInterviewStageSkills($id: ID!, $skillsProfileId: Int!, $softSkillIds: [Int!]!, $technicalSkillIds: [Int!]!) {
  OverwriteInterviewStageSkills(
    id: $id
    skillsProfileId: $skillsProfileId
    softSkillIds: $softSkillIds
    technicalSkillIds: $technicalSkillIds
  ) {
    ...InterviewStage
  }
}
    ${InterviewStageFragmentDoc}`;
export type OverwriteInterviewStageSkillsMutationFn = Apollo.MutationFunction<OverwriteInterviewStageSkillsMutation, OverwriteInterviewStageSkillsMutationVariables>;

/**
 * __useOverwriteInterviewStageSkillsMutation__
 *
 * To run a mutation, you first call `useOverwriteInterviewStageSkillsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOverwriteInterviewStageSkillsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [overwriteInterviewStageSkillsMutation, { data, loading, error }] = useOverwriteInterviewStageSkillsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      skillsProfileId: // value for 'skillsProfileId'
 *      softSkillIds: // value for 'softSkillIds'
 *      technicalSkillIds: // value for 'technicalSkillIds'
 *   },
 * });
 */
export function useOverwriteInterviewStageSkillsMutation(baseOptions?: Apollo.MutationHookOptions<OverwriteInterviewStageSkillsMutation, OverwriteInterviewStageSkillsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OverwriteInterviewStageSkillsMutation, OverwriteInterviewStageSkillsMutationVariables>(OverwriteInterviewStageSkillsDocument, options);
      }
export type OverwriteInterviewStageSkillsMutationHookResult = ReturnType<typeof useOverwriteInterviewStageSkillsMutation>;
export type OverwriteInterviewStageSkillsMutationResult = Apollo.MutationResult<OverwriteInterviewStageSkillsMutation>;
export type OverwriteInterviewStageSkillsMutationOptions = Apollo.BaseMutationOptions<OverwriteInterviewStageSkillsMutation, OverwriteInterviewStageSkillsMutationVariables>;
export const ProjectCandidateInviteManyDocument = gql`
    mutation ProjectCandidateInviteMany($projectSubId: ID!, $assessmentStageSubId: ID!, $userDetails: ProjectCandidateUserDetails!, $settings: ProjectCandidateInvitationSettings!) {
  ProjectCandidateInviteMany(
    projectSubId: $projectSubId
    userDetails: [$userDetails]
    settings: $settings
    assessmentInviteSettings: {assessmentStageSubId: $assessmentStageSubId}
  ) {
    subId
  }
}
    `;
export type ProjectCandidateInviteManyMutationFn = Apollo.MutationFunction<ProjectCandidateInviteManyMutation, ProjectCandidateInviteManyMutationVariables>;

/**
 * __useProjectCandidateInviteManyMutation__
 *
 * To run a mutation, you first call `useProjectCandidateInviteManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectCandidateInviteManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectCandidateInviteManyMutation, { data, loading, error }] = useProjectCandidateInviteManyMutation({
 *   variables: {
 *      projectSubId: // value for 'projectSubId'
 *      assessmentStageSubId: // value for 'assessmentStageSubId'
 *      userDetails: // value for 'userDetails'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useProjectCandidateInviteManyMutation(baseOptions?: Apollo.MutationHookOptions<ProjectCandidateInviteManyMutation, ProjectCandidateInviteManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectCandidateInviteManyMutation, ProjectCandidateInviteManyMutationVariables>(ProjectCandidateInviteManyDocument, options);
      }
export type ProjectCandidateInviteManyMutationHookResult = ReturnType<typeof useProjectCandidateInviteManyMutation>;
export type ProjectCandidateInviteManyMutationResult = Apollo.MutationResult<ProjectCandidateInviteManyMutation>;
export type ProjectCandidateInviteManyMutationOptions = Apollo.BaseMutationOptions<ProjectCandidateInviteManyMutation, ProjectCandidateInviteManyMutationVariables>;
export const JobRoleCreateOneDocument = gql`
    mutation JobRoleCreateOne($companyId: Int!, $name: String!, $qualifier: String, $roleLevel: ContentRoleLevel!, $family: JobRoleFamily) {
  JobRoleCreateOne(
    companyId: $companyId
    name: $name
    qualifier: $qualifier
    roleLevel: $roleLevel
    family: $family
  ) {
    ...JobRole
  }
}
    ${JobRoleFragmentDoc}`;
export type JobRoleCreateOneMutationFn = Apollo.MutationFunction<JobRoleCreateOneMutation, JobRoleCreateOneMutationVariables>;

/**
 * __useJobRoleCreateOneMutation__
 *
 * To run a mutation, you first call `useJobRoleCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobRoleCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobRoleCreateOneMutation, { data, loading, error }] = useJobRoleCreateOneMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      name: // value for 'name'
 *      qualifier: // value for 'qualifier'
 *      roleLevel: // value for 'roleLevel'
 *      family: // value for 'family'
 *   },
 * });
 */
export function useJobRoleCreateOneMutation(baseOptions?: Apollo.MutationHookOptions<JobRoleCreateOneMutation, JobRoleCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JobRoleCreateOneMutation, JobRoleCreateOneMutationVariables>(JobRoleCreateOneDocument, options);
      }
export type JobRoleCreateOneMutationHookResult = ReturnType<typeof useJobRoleCreateOneMutation>;
export type JobRoleCreateOneMutationResult = Apollo.MutationResult<JobRoleCreateOneMutation>;
export type JobRoleCreateOneMutationOptions = Apollo.BaseMutationOptions<JobRoleCreateOneMutation, JobRoleCreateOneMutationVariables>;
export const JobRoleUpdateOneDocument = gql`
    mutation JobRoleUpdateOne($id: Int!, $name: String, $qualifier: String, $roleLevel: ContentRoleLevel, $family: JobRoleFamily) {
  JobRoleUpdateOne(
    id: $id
    name: $name
    qualifier: $qualifier
    roleLevel: $roleLevel
    family: $family
  ) {
    ...JobRole
  }
}
    ${JobRoleFragmentDoc}`;
export type JobRoleUpdateOneMutationFn = Apollo.MutationFunction<JobRoleUpdateOneMutation, JobRoleUpdateOneMutationVariables>;

/**
 * __useJobRoleUpdateOneMutation__
 *
 * To run a mutation, you first call `useJobRoleUpdateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobRoleUpdateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobRoleUpdateOneMutation, { data, loading, error }] = useJobRoleUpdateOneMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      qualifier: // value for 'qualifier'
 *      roleLevel: // value for 'roleLevel'
 *      family: // value for 'family'
 *   },
 * });
 */
export function useJobRoleUpdateOneMutation(baseOptions?: Apollo.MutationHookOptions<JobRoleUpdateOneMutation, JobRoleUpdateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JobRoleUpdateOneMutation, JobRoleUpdateOneMutationVariables>(JobRoleUpdateOneDocument, options);
      }
export type JobRoleUpdateOneMutationHookResult = ReturnType<typeof useJobRoleUpdateOneMutation>;
export type JobRoleUpdateOneMutationResult = Apollo.MutationResult<JobRoleUpdateOneMutation>;
export type JobRoleUpdateOneMutationOptions = Apollo.BaseMutationOptions<JobRoleUpdateOneMutation, JobRoleUpdateOneMutationVariables>;
export const JobRoleDuplicateDocument = gql`
    mutation JobRoleDuplicate($id: Int) {
  JobRoleDuplicate(id: $id) {
    ...JobRole
  }
}
    ${JobRoleFragmentDoc}`;
export type JobRoleDuplicateMutationFn = Apollo.MutationFunction<JobRoleDuplicateMutation, JobRoleDuplicateMutationVariables>;

/**
 * __useJobRoleDuplicateMutation__
 *
 * To run a mutation, you first call `useJobRoleDuplicateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobRoleDuplicateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobRoleDuplicateMutation, { data, loading, error }] = useJobRoleDuplicateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJobRoleDuplicateMutation(baseOptions?: Apollo.MutationHookOptions<JobRoleDuplicateMutation, JobRoleDuplicateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JobRoleDuplicateMutation, JobRoleDuplicateMutationVariables>(JobRoleDuplicateDocument, options);
      }
export type JobRoleDuplicateMutationHookResult = ReturnType<typeof useJobRoleDuplicateMutation>;
export type JobRoleDuplicateMutationResult = Apollo.MutationResult<JobRoleDuplicateMutation>;
export type JobRoleDuplicateMutationOptions = Apollo.BaseMutationOptions<JobRoleDuplicateMutation, JobRoleDuplicateMutationVariables>;
export const KomboSetAssessmentPackagesDocument = gql`
    mutation KomboSetAssessmentPackages($companyId: Int!) {
  komboSetAssessmentPackages(companyId: $companyId)
}
    `;
export type KomboSetAssessmentPackagesMutationFn = Apollo.MutationFunction<KomboSetAssessmentPackagesMutation, KomboSetAssessmentPackagesMutationVariables>;

/**
 * __useKomboSetAssessmentPackagesMutation__
 *
 * To run a mutation, you first call `useKomboSetAssessmentPackagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKomboSetAssessmentPackagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [komboSetAssessmentPackagesMutation, { data, loading, error }] = useKomboSetAssessmentPackagesMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useKomboSetAssessmentPackagesMutation(baseOptions?: Apollo.MutationHookOptions<KomboSetAssessmentPackagesMutation, KomboSetAssessmentPackagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<KomboSetAssessmentPackagesMutation, KomboSetAssessmentPackagesMutationVariables>(KomboSetAssessmentPackagesDocument, options);
      }
export type KomboSetAssessmentPackagesMutationHookResult = ReturnType<typeof useKomboSetAssessmentPackagesMutation>;
export type KomboSetAssessmentPackagesMutationResult = Apollo.MutationResult<KomboSetAssessmentPackagesMutation>;
export type KomboSetAssessmentPackagesMutationOptions = Apollo.BaseMutationOptions<KomboSetAssessmentPackagesMutation, KomboSetAssessmentPackagesMutationVariables>;
export const ProjectSetCompanySignatureDocument = gql`
    mutation ProjectSetCompanySignature($companySignatureId: Int, $projectId: Int!) {
  Project: ProjectSetCompanySignature(
    companySignatureId: $companySignatureId
    projectId: $projectId
  ) {
    id
    companySignatureId
  }
}
    `;
export type ProjectSetCompanySignatureMutationFn = Apollo.MutationFunction<ProjectSetCompanySignatureMutation, ProjectSetCompanySignatureMutationVariables>;

/**
 * __useProjectSetCompanySignatureMutation__
 *
 * To run a mutation, you first call `useProjectSetCompanySignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectSetCompanySignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectSetCompanySignatureMutation, { data, loading, error }] = useProjectSetCompanySignatureMutation({
 *   variables: {
 *      companySignatureId: // value for 'companySignatureId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectSetCompanySignatureMutation(baseOptions?: Apollo.MutationHookOptions<ProjectSetCompanySignatureMutation, ProjectSetCompanySignatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectSetCompanySignatureMutation, ProjectSetCompanySignatureMutationVariables>(ProjectSetCompanySignatureDocument, options);
      }
export type ProjectSetCompanySignatureMutationHookResult = ReturnType<typeof useProjectSetCompanySignatureMutation>;
export type ProjectSetCompanySignatureMutationResult = Apollo.MutationResult<ProjectSetCompanySignatureMutation>;
export type ProjectSetCompanySignatureMutationOptions = Apollo.BaseMutationOptions<ProjectSetCompanySignatureMutation, ProjectSetCompanySignatureMutationVariables>;
export const EditProjectStateDocument = gql`
    mutation EditProjectState($id: Int!, $state: Boolean!) {
  project: editProjectState(id: $id, state: $state) {
    ...Project
  }
}
    ${ProjectFragmentDoc}`;
export type EditProjectStateMutationFn = Apollo.MutationFunction<EditProjectStateMutation, EditProjectStateMutationVariables>;

/**
 * __useEditProjectStateMutation__
 *
 * To run a mutation, you first call `useEditProjectStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProjectStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProjectStateMutation, { data, loading, error }] = useEditProjectStateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useEditProjectStateMutation(baseOptions?: Apollo.MutationHookOptions<EditProjectStateMutation, EditProjectStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditProjectStateMutation, EditProjectStateMutationVariables>(EditProjectStateDocument, options);
      }
export type EditProjectStateMutationHookResult = ReturnType<typeof useEditProjectStateMutation>;
export type EditProjectStateMutationResult = Apollo.MutationResult<EditProjectStateMutation>;
export type EditProjectStateMutationOptions = Apollo.BaseMutationOptions<EditProjectStateMutation, EditProjectStateMutationVariables>;
export const EditProjectArchivingDocument = gql`
    mutation EditProjectArchiving($id: Int!, $state: Boolean!) {
  project: editProjectArchiving(id: $id, state: $state) {
    ...Project
  }
}
    ${ProjectFragmentDoc}`;
export type EditProjectArchivingMutationFn = Apollo.MutationFunction<EditProjectArchivingMutation, EditProjectArchivingMutationVariables>;

/**
 * __useEditProjectArchivingMutation__
 *
 * To run a mutation, you first call `useEditProjectArchivingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProjectArchivingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProjectArchivingMutation, { data, loading, error }] = useEditProjectArchivingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useEditProjectArchivingMutation(baseOptions?: Apollo.MutationHookOptions<EditProjectArchivingMutation, EditProjectArchivingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditProjectArchivingMutation, EditProjectArchivingMutationVariables>(EditProjectArchivingDocument, options);
      }
export type EditProjectArchivingMutationHookResult = ReturnType<typeof useEditProjectArchivingMutation>;
export type EditProjectArchivingMutationResult = Apollo.MutationResult<EditProjectArchivingMutation>;
export type EditProjectArchivingMutationOptions = Apollo.BaseMutationOptions<EditProjectArchivingMutation, EditProjectArchivingMutationVariables>;
export const CreateProjectDocument = gql`
    mutation CreateProject($name: String!, $companyId: Float!, $managers: [CreateProjectManagerInput!], $moduleType: ProjectModuleType, $requireSheetsExport: Boolean, $productSolution: ProductSolution!) {
  project: createProject(
    name: $name
    companyId: $companyId
    managers: $managers
    moduleType: $moduleType
    requireSheetsExport: $requireSheetsExport
    productSolution: $productSolution
  ) {
    ...Project
  }
}
    ${ProjectFragmentDoc}`;
export type CreateProjectMutationFn = Apollo.MutationFunction<CreateProjectMutation, CreateProjectMutationVariables>;

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      name: // value for 'name'
 *      companyId: // value for 'companyId'
 *      managers: // value for 'managers'
 *      moduleType: // value for 'moduleType'
 *      requireSheetsExport: // value for 'requireSheetsExport'
 *      productSolution: // value for 'productSolution'
 *   },
 * });
 */
export function useCreateProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectMutation, CreateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectMutation, CreateProjectMutationVariables>(CreateProjectDocument, options);
      }
export type CreateProjectMutationHookResult = ReturnType<typeof useCreateProjectMutation>;
export type CreateProjectMutationResult = Apollo.MutationResult<CreateProjectMutation>;
export type CreateProjectMutationOptions = Apollo.BaseMutationOptions<CreateProjectMutation, CreateProjectMutationVariables>;
export const EditProjectDocument = gql`
    mutation EditProject($id: Int!, $name: String!, $companyId: Float!, $managers: [CreateProjectManagerInput!], $requireSheetsExport: Boolean, $locales: [SupportedLocale!], $primaryLocale: SupportedLocale, $productSolution: ProductSolution, $isAiInterviewScoreHidden: Boolean) {
  project: editProject(
    id: $id
    name: $name
    companyId: $companyId
    managers: $managers
    requireSheetsExport: $requireSheetsExport
    locales: $locales
    primaryLocale: $primaryLocale
    productSolution: $productSolution
    isAiInterviewScoreHidden: $isAiInterviewScoreHidden
  ) {
    ...Project
  }
}
    ${ProjectFragmentDoc}`;
export type EditProjectMutationFn = Apollo.MutationFunction<EditProjectMutation, EditProjectMutationVariables>;

/**
 * __useEditProjectMutation__
 *
 * To run a mutation, you first call `useEditProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProjectMutation, { data, loading, error }] = useEditProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      companyId: // value for 'companyId'
 *      managers: // value for 'managers'
 *      requireSheetsExport: // value for 'requireSheetsExport'
 *      locales: // value for 'locales'
 *      primaryLocale: // value for 'primaryLocale'
 *      productSolution: // value for 'productSolution'
 *      isAiInterviewScoreHidden: // value for 'isAiInterviewScoreHidden'
 *   },
 * });
 */
export function useEditProjectMutation(baseOptions?: Apollo.MutationHookOptions<EditProjectMutation, EditProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditProjectMutation, EditProjectMutationVariables>(EditProjectDocument, options);
      }
export type EditProjectMutationHookResult = ReturnType<typeof useEditProjectMutation>;
export type EditProjectMutationResult = Apollo.MutationResult<EditProjectMutation>;
export type EditProjectMutationOptions = Apollo.BaseMutationOptions<EditProjectMutation, EditProjectMutationVariables>;
export const ProjectUpdateStatusDocument = gql`
    mutation ProjectUpdateStatus($projectId: Int!, $status: ProjectStatus!) {
  ProjectUpdateStatus(projectId: $projectId, status: $status) {
    ...Project
  }
}
    ${ProjectFragmentDoc}`;
export type ProjectUpdateStatusMutationFn = Apollo.MutationFunction<ProjectUpdateStatusMutation, ProjectUpdateStatusMutationVariables>;

/**
 * __useProjectUpdateStatusMutation__
 *
 * To run a mutation, you first call `useProjectUpdateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectUpdateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectUpdateStatusMutation, { data, loading, error }] = useProjectUpdateStatusMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useProjectUpdateStatusMutation(baseOptions?: Apollo.MutationHookOptions<ProjectUpdateStatusMutation, ProjectUpdateStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectUpdateStatusMutation, ProjectUpdateStatusMutationVariables>(ProjectUpdateStatusDocument, options);
      }
export type ProjectUpdateStatusMutationHookResult = ReturnType<typeof useProjectUpdateStatusMutation>;
export type ProjectUpdateStatusMutationResult = Apollo.MutationResult<ProjectUpdateStatusMutation>;
export type ProjectUpdateStatusMutationOptions = Apollo.BaseMutationOptions<ProjectUpdateStatusMutation, ProjectUpdateStatusMutationVariables>;
export const ProjectAddInterviewStageDocument = gql`
    mutation ProjectAddInterviewStage($subId: ID!, $duration: Int, $name: String!, $focus: InterviewStageFocus!) {
  ProjectAddInterviewStage(
    subId: $subId
    duration: $duration
    name: $name
    focus: $focus
  ) {
    id
    interviewStages {
      ...InterviewStage
    }
  }
}
    ${InterviewStageFragmentDoc}`;
export type ProjectAddInterviewStageMutationFn = Apollo.MutationFunction<ProjectAddInterviewStageMutation, ProjectAddInterviewStageMutationVariables>;

/**
 * __useProjectAddInterviewStageMutation__
 *
 * To run a mutation, you first call `useProjectAddInterviewStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectAddInterviewStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectAddInterviewStageMutation, { data, loading, error }] = useProjectAddInterviewStageMutation({
 *   variables: {
 *      subId: // value for 'subId'
 *      duration: // value for 'duration'
 *      name: // value for 'name'
 *      focus: // value for 'focus'
 *   },
 * });
 */
export function useProjectAddInterviewStageMutation(baseOptions?: Apollo.MutationHookOptions<ProjectAddInterviewStageMutation, ProjectAddInterviewStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectAddInterviewStageMutation, ProjectAddInterviewStageMutationVariables>(ProjectAddInterviewStageDocument, options);
      }
export type ProjectAddInterviewStageMutationHookResult = ReturnType<typeof useProjectAddInterviewStageMutation>;
export type ProjectAddInterviewStageMutationResult = Apollo.MutationResult<ProjectAddInterviewStageMutation>;
export type ProjectAddInterviewStageMutationOptions = Apollo.BaseMutationOptions<ProjectAddInterviewStageMutation, ProjectAddInterviewStageMutationVariables>;
export const SetProjectCobrandingDocument = gql`
    mutation SetProjectCobranding($projectId: Int!, $cobrandingEnabled: Boolean!) {
  setProjectCobranding(id: $projectId, cobrandingEnabled: $cobrandingEnabled)
}
    `;
export type SetProjectCobrandingMutationFn = Apollo.MutationFunction<SetProjectCobrandingMutation, SetProjectCobrandingMutationVariables>;

/**
 * __useSetProjectCobrandingMutation__
 *
 * To run a mutation, you first call `useSetProjectCobrandingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProjectCobrandingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProjectCobrandingMutation, { data, loading, error }] = useSetProjectCobrandingMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      cobrandingEnabled: // value for 'cobrandingEnabled'
 *   },
 * });
 */
export function useSetProjectCobrandingMutation(baseOptions?: Apollo.MutationHookOptions<SetProjectCobrandingMutation, SetProjectCobrandingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetProjectCobrandingMutation, SetProjectCobrandingMutationVariables>(SetProjectCobrandingDocument, options);
      }
export type SetProjectCobrandingMutationHookResult = ReturnType<typeof useSetProjectCobrandingMutation>;
export type SetProjectCobrandingMutationResult = Apollo.MutationResult<SetProjectCobrandingMutation>;
export type SetProjectCobrandingMutationOptions = Apollo.BaseMutationOptions<SetProjectCobrandingMutation, SetProjectCobrandingMutationVariables>;
export const ProjectCollaboratorsCreateManyDocument = gql`
    mutation ProjectCollaboratorsCreateMany($collaborators: [ProjectCollaboratorCreateOneArgs!]!) {
  collaborators: ProjectCollaboratorsCreateMany(collaborators: $collaborators) {
    id
    userId
    groupId
    actorRole
    projectId
  }
}
    `;
export type ProjectCollaboratorsCreateManyMutationFn = Apollo.MutationFunction<ProjectCollaboratorsCreateManyMutation, ProjectCollaboratorsCreateManyMutationVariables>;

/**
 * __useProjectCollaboratorsCreateManyMutation__
 *
 * To run a mutation, you first call `useProjectCollaboratorsCreateManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectCollaboratorsCreateManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectCollaboratorsCreateManyMutation, { data, loading, error }] = useProjectCollaboratorsCreateManyMutation({
 *   variables: {
 *      collaborators: // value for 'collaborators'
 *   },
 * });
 */
export function useProjectCollaboratorsCreateManyMutation(baseOptions?: Apollo.MutationHookOptions<ProjectCollaboratorsCreateManyMutation, ProjectCollaboratorsCreateManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectCollaboratorsCreateManyMutation, ProjectCollaboratorsCreateManyMutationVariables>(ProjectCollaboratorsCreateManyDocument, options);
      }
export type ProjectCollaboratorsCreateManyMutationHookResult = ReturnType<typeof useProjectCollaboratorsCreateManyMutation>;
export type ProjectCollaboratorsCreateManyMutationResult = Apollo.MutationResult<ProjectCollaboratorsCreateManyMutation>;
export type ProjectCollaboratorsCreateManyMutationOptions = Apollo.BaseMutationOptions<ProjectCollaboratorsCreateManyMutation, ProjectCollaboratorsCreateManyMutationVariables>;
export const ProjectCollaboratorsUpdateRoleDocument = gql`
    mutation ProjectCollaboratorsUpdateRole($actorRole: ActorRole, $collaboratorId: Int!) {
  update: ProjectCollaboratorsUpdateRole(
    newActorRole: $actorRole
    projectTeamMemberId: $collaboratorId
  ) {
    id
    projectId
    userId
    groupId
    actorRole
  }
}
    `;
export type ProjectCollaboratorsUpdateRoleMutationFn = Apollo.MutationFunction<ProjectCollaboratorsUpdateRoleMutation, ProjectCollaboratorsUpdateRoleMutationVariables>;

/**
 * __useProjectCollaboratorsUpdateRoleMutation__
 *
 * To run a mutation, you first call `useProjectCollaboratorsUpdateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectCollaboratorsUpdateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectCollaboratorsUpdateRoleMutation, { data, loading, error }] = useProjectCollaboratorsUpdateRoleMutation({
 *   variables: {
 *      actorRole: // value for 'actorRole'
 *      collaboratorId: // value for 'collaboratorId'
 *   },
 * });
 */
export function useProjectCollaboratorsUpdateRoleMutation(baseOptions?: Apollo.MutationHookOptions<ProjectCollaboratorsUpdateRoleMutation, ProjectCollaboratorsUpdateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectCollaboratorsUpdateRoleMutation, ProjectCollaboratorsUpdateRoleMutationVariables>(ProjectCollaboratorsUpdateRoleDocument, options);
      }
export type ProjectCollaboratorsUpdateRoleMutationHookResult = ReturnType<typeof useProjectCollaboratorsUpdateRoleMutation>;
export type ProjectCollaboratorsUpdateRoleMutationResult = Apollo.MutationResult<ProjectCollaboratorsUpdateRoleMutation>;
export type ProjectCollaboratorsUpdateRoleMutationOptions = Apollo.BaseMutationOptions<ProjectCollaboratorsUpdateRoleMutation, ProjectCollaboratorsUpdateRoleMutationVariables>;
export const ProjectCollaboratorsDeleteManyDocument = gql`
    mutation ProjectCollaboratorsDeleteMany($collaborators: [Int!]!) {
  deleted: ProjectCollaboratorsDeleteMany(collaborators: $collaborators) {
    status
    error
  }
}
    `;
export type ProjectCollaboratorsDeleteManyMutationFn = Apollo.MutationFunction<ProjectCollaboratorsDeleteManyMutation, ProjectCollaboratorsDeleteManyMutationVariables>;

/**
 * __useProjectCollaboratorsDeleteManyMutation__
 *
 * To run a mutation, you first call `useProjectCollaboratorsDeleteManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectCollaboratorsDeleteManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectCollaboratorsDeleteManyMutation, { data, loading, error }] = useProjectCollaboratorsDeleteManyMutation({
 *   variables: {
 *      collaborators: // value for 'collaborators'
 *   },
 * });
 */
export function useProjectCollaboratorsDeleteManyMutation(baseOptions?: Apollo.MutationHookOptions<ProjectCollaboratorsDeleteManyMutation, ProjectCollaboratorsDeleteManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectCollaboratorsDeleteManyMutation, ProjectCollaboratorsDeleteManyMutationVariables>(ProjectCollaboratorsDeleteManyDocument, options);
      }
export type ProjectCollaboratorsDeleteManyMutationHookResult = ReturnType<typeof useProjectCollaboratorsDeleteManyMutation>;
export type ProjectCollaboratorsDeleteManyMutationResult = Apollo.MutationResult<ProjectCollaboratorsDeleteManyMutation>;
export type ProjectCollaboratorsDeleteManyMutationOptions = Apollo.BaseMutationOptions<ProjectCollaboratorsDeleteManyMutation, ProjectCollaboratorsDeleteManyMutationVariables>;
export const ProjectJobRoleCreateOneDocument = gql`
    mutation ProjectJobRoleCreateOne($jobRoleId: Int!, $projectId: Int!, $skillsProfileId: Int!) {
  ProjectJobRoleCreateOne(
    jobRoleId: $jobRoleId
    projectId: $projectId
    skillsProfileId: $skillsProfileId
  ) {
    ...ProjectJobRole
  }
}
    ${ProjectJobRoleFragmentDoc}`;
export type ProjectJobRoleCreateOneMutationFn = Apollo.MutationFunction<ProjectJobRoleCreateOneMutation, ProjectJobRoleCreateOneMutationVariables>;

/**
 * __useProjectJobRoleCreateOneMutation__
 *
 * To run a mutation, you first call `useProjectJobRoleCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectJobRoleCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectJobRoleCreateOneMutation, { data, loading, error }] = useProjectJobRoleCreateOneMutation({
 *   variables: {
 *      jobRoleId: // value for 'jobRoleId'
 *      projectId: // value for 'projectId'
 *      skillsProfileId: // value for 'skillsProfileId'
 *   },
 * });
 */
export function useProjectJobRoleCreateOneMutation(baseOptions?: Apollo.MutationHookOptions<ProjectJobRoleCreateOneMutation, ProjectJobRoleCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectJobRoleCreateOneMutation, ProjectJobRoleCreateOneMutationVariables>(ProjectJobRoleCreateOneDocument, options);
      }
export type ProjectJobRoleCreateOneMutationHookResult = ReturnType<typeof useProjectJobRoleCreateOneMutation>;
export type ProjectJobRoleCreateOneMutationResult = Apollo.MutationResult<ProjectJobRoleCreateOneMutation>;
export type ProjectJobRoleCreateOneMutationOptions = Apollo.BaseMutationOptions<ProjectJobRoleCreateOneMutation, ProjectJobRoleCreateOneMutationVariables>;
export const ProjectJobRoleDeleteOneDocument = gql`
    mutation ProjectJobRoleDeleteOne($id: Int!) {
  ProjectJobRoleDeleteOne(id: $id) {
    affected
  }
}
    `;
export type ProjectJobRoleDeleteOneMutationFn = Apollo.MutationFunction<ProjectJobRoleDeleteOneMutation, ProjectJobRoleDeleteOneMutationVariables>;

/**
 * __useProjectJobRoleDeleteOneMutation__
 *
 * To run a mutation, you first call `useProjectJobRoleDeleteOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectJobRoleDeleteOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectJobRoleDeleteOneMutation, { data, loading, error }] = useProjectJobRoleDeleteOneMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectJobRoleDeleteOneMutation(baseOptions?: Apollo.MutationHookOptions<ProjectJobRoleDeleteOneMutation, ProjectJobRoleDeleteOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectJobRoleDeleteOneMutation, ProjectJobRoleDeleteOneMutationVariables>(ProjectJobRoleDeleteOneDocument, options);
      }
export type ProjectJobRoleDeleteOneMutationHookResult = ReturnType<typeof useProjectJobRoleDeleteOneMutation>;
export type ProjectJobRoleDeleteOneMutationResult = Apollo.MutationResult<ProjectJobRoleDeleteOneMutation>;
export type ProjectJobRoleDeleteOneMutationOptions = Apollo.BaseMutationOptions<ProjectJobRoleDeleteOneMutation, ProjectJobRoleDeleteOneMutationVariables>;
export const ProjectJobRoleSetMainDocument = gql`
    mutation ProjectJobRoleSetMain($id: Int!) {
  ProjectJobRoleSetMain(id: $id) {
    ...ProjectJobRole
  }
}
    ${ProjectJobRoleFragmentDoc}`;
export type ProjectJobRoleSetMainMutationFn = Apollo.MutationFunction<ProjectJobRoleSetMainMutation, ProjectJobRoleSetMainMutationVariables>;

/**
 * __useProjectJobRoleSetMainMutation__
 *
 * To run a mutation, you first call `useProjectJobRoleSetMainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectJobRoleSetMainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectJobRoleSetMainMutation, { data, loading, error }] = useProjectJobRoleSetMainMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectJobRoleSetMainMutation(baseOptions?: Apollo.MutationHookOptions<ProjectJobRoleSetMainMutation, ProjectJobRoleSetMainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectJobRoleSetMainMutation, ProjectJobRoleSetMainMutationVariables>(ProjectJobRoleSetMainDocument, options);
      }
export type ProjectJobRoleSetMainMutationHookResult = ReturnType<typeof useProjectJobRoleSetMainMutation>;
export type ProjectJobRoleSetMainMutationResult = Apollo.MutationResult<ProjectJobRoleSetMainMutation>;
export type ProjectJobRoleSetMainMutationOptions = Apollo.BaseMutationOptions<ProjectJobRoleSetMainMutation, ProjectJobRoleSetMainMutationVariables>;
export const ProjectUserUpdateOneDocument = gql`
    mutation ProjectUserUpdateOne($actorRole: ActorRole!, $projectId: Int!, $userId: Int!) {
  ProjectUserUpdateOne(
    actorRole: $actorRole
    projectId: $projectId
    userId: $userId
  ) {
    user {
      id
    }
    project {
      id
    }
    actorRole
  }
}
    `;
export type ProjectUserUpdateOneMutationFn = Apollo.MutationFunction<ProjectUserUpdateOneMutation, ProjectUserUpdateOneMutationVariables>;

/**
 * __useProjectUserUpdateOneMutation__
 *
 * To run a mutation, you first call `useProjectUserUpdateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectUserUpdateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectUserUpdateOneMutation, { data, loading, error }] = useProjectUserUpdateOneMutation({
 *   variables: {
 *      actorRole: // value for 'actorRole'
 *      projectId: // value for 'projectId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useProjectUserUpdateOneMutation(baseOptions?: Apollo.MutationHookOptions<ProjectUserUpdateOneMutation, ProjectUserUpdateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectUserUpdateOneMutation, ProjectUserUpdateOneMutationVariables>(ProjectUserUpdateOneDocument, options);
      }
export type ProjectUserUpdateOneMutationHookResult = ReturnType<typeof useProjectUserUpdateOneMutation>;
export type ProjectUserUpdateOneMutationResult = Apollo.MutationResult<ProjectUserUpdateOneMutation>;
export type ProjectUserUpdateOneMutationOptions = Apollo.BaseMutationOptions<ProjectUserUpdateOneMutation, ProjectUserUpdateOneMutationVariables>;
export const ProjectUserDeleteOneDocument = gql`
    mutation ProjectUserDeleteOne($projectId: Float!, $userId: Float!) {
  ProjectUserDeleteOne(projectId: $projectId, userId: $userId) {
    user {
      id
    }
    project {
      id
    }
    actorRole
  }
}
    `;
export type ProjectUserDeleteOneMutationFn = Apollo.MutationFunction<ProjectUserDeleteOneMutation, ProjectUserDeleteOneMutationVariables>;

/**
 * __useProjectUserDeleteOneMutation__
 *
 * To run a mutation, you first call `useProjectUserDeleteOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectUserDeleteOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectUserDeleteOneMutation, { data, loading, error }] = useProjectUserDeleteOneMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useProjectUserDeleteOneMutation(baseOptions?: Apollo.MutationHookOptions<ProjectUserDeleteOneMutation, ProjectUserDeleteOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectUserDeleteOneMutation, ProjectUserDeleteOneMutationVariables>(ProjectUserDeleteOneDocument, options);
      }
export type ProjectUserDeleteOneMutationHookResult = ReturnType<typeof useProjectUserDeleteOneMutation>;
export type ProjectUserDeleteOneMutationResult = Apollo.MutationResult<ProjectUserDeleteOneMutation>;
export type ProjectUserDeleteOneMutationOptions = Apollo.BaseMutationOptions<ProjectUserDeleteOneMutation, ProjectUserDeleteOneMutationVariables>;
export const ReportRenderCreateDocument = gql`
    mutation ReportRenderCreate($dataSourceId: Int!, $reportId: Int!, $reportRenderType: ReportRenderType!) {
  ReportRenderCreate(
    dataSourceId: $dataSourceId
    reportId: $reportId
    reportRenderType: $reportRenderType
  ) {
    id
    subId
    reportRenderStatus
  }
}
    `;
export type ReportRenderCreateMutationFn = Apollo.MutationFunction<ReportRenderCreateMutation, ReportRenderCreateMutationVariables>;

/**
 * __useReportRenderCreateMutation__
 *
 * To run a mutation, you first call `useReportRenderCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportRenderCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportRenderCreateMutation, { data, loading, error }] = useReportRenderCreateMutation({
 *   variables: {
 *      dataSourceId: // value for 'dataSourceId'
 *      reportId: // value for 'reportId'
 *      reportRenderType: // value for 'reportRenderType'
 *   },
 * });
 */
export function useReportRenderCreateMutation(baseOptions?: Apollo.MutationHookOptions<ReportRenderCreateMutation, ReportRenderCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportRenderCreateMutation, ReportRenderCreateMutationVariables>(ReportRenderCreateDocument, options);
      }
export type ReportRenderCreateMutationHookResult = ReturnType<typeof useReportRenderCreateMutation>;
export type ReportRenderCreateMutationResult = Apollo.MutationResult<ReportRenderCreateMutation>;
export type ReportRenderCreateMutationOptions = Apollo.BaseMutationOptions<ReportRenderCreateMutation, ReportRenderCreateMutationVariables>;
export const ReportAssignmentCreateDocument = gql`
    mutation ReportAssignmentCreate($assignedId: Int!, $assignedType: RAssignedType!, $reportId: Int!) {
  ReportAssignmentCreate(
    assignedId: $assignedId
    assignedType: $assignedType
    reportId: $reportId
  ) {
    ...ReportAssignment
  }
}
    ${ReportAssignmentFragmentDoc}`;
export type ReportAssignmentCreateMutationFn = Apollo.MutationFunction<ReportAssignmentCreateMutation, ReportAssignmentCreateMutationVariables>;

/**
 * __useReportAssignmentCreateMutation__
 *
 * To run a mutation, you first call `useReportAssignmentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportAssignmentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportAssignmentCreateMutation, { data, loading, error }] = useReportAssignmentCreateMutation({
 *   variables: {
 *      assignedId: // value for 'assignedId'
 *      assignedType: // value for 'assignedType'
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useReportAssignmentCreateMutation(baseOptions?: Apollo.MutationHookOptions<ReportAssignmentCreateMutation, ReportAssignmentCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportAssignmentCreateMutation, ReportAssignmentCreateMutationVariables>(ReportAssignmentCreateDocument, options);
      }
export type ReportAssignmentCreateMutationHookResult = ReturnType<typeof useReportAssignmentCreateMutation>;
export type ReportAssignmentCreateMutationResult = Apollo.MutationResult<ReportAssignmentCreateMutation>;
export type ReportAssignmentCreateMutationOptions = Apollo.BaseMutationOptions<ReportAssignmentCreateMutation, ReportAssignmentCreateMutationVariables>;
export const ReportAssignmentUpdateDocument = gql`
    mutation ReportAssignmentUpdate($assignedId: Int!, $assignedType: RAssignedType!, $reportId: Int!, $id: Int!) {
  ReportAssignmentUpdate(
    id: $id
    assignedId: $assignedId
    assignedType: $assignedType
    reportId: $reportId
  ) {
    ...ReportAssignment
  }
}
    ${ReportAssignmentFragmentDoc}`;
export type ReportAssignmentUpdateMutationFn = Apollo.MutationFunction<ReportAssignmentUpdateMutation, ReportAssignmentUpdateMutationVariables>;

/**
 * __useReportAssignmentUpdateMutation__
 *
 * To run a mutation, you first call `useReportAssignmentUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportAssignmentUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportAssignmentUpdateMutation, { data, loading, error }] = useReportAssignmentUpdateMutation({
 *   variables: {
 *      assignedId: // value for 'assignedId'
 *      assignedType: // value for 'assignedType'
 *      reportId: // value for 'reportId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportAssignmentUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ReportAssignmentUpdateMutation, ReportAssignmentUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportAssignmentUpdateMutation, ReportAssignmentUpdateMutationVariables>(ReportAssignmentUpdateDocument, options);
      }
export type ReportAssignmentUpdateMutationHookResult = ReturnType<typeof useReportAssignmentUpdateMutation>;
export type ReportAssignmentUpdateMutationResult = Apollo.MutationResult<ReportAssignmentUpdateMutation>;
export type ReportAssignmentUpdateMutationOptions = Apollo.BaseMutationOptions<ReportAssignmentUpdateMutation, ReportAssignmentUpdateMutationVariables>;
export const ReportAssignmentDeleteDocument = gql`
    mutation ReportAssignmentDelete($id: Int!) {
  ReportAssignmentDelete(id: $id) {
    affected
  }
}
    `;
export type ReportAssignmentDeleteMutationFn = Apollo.MutationFunction<ReportAssignmentDeleteMutation, ReportAssignmentDeleteMutationVariables>;

/**
 * __useReportAssignmentDeleteMutation__
 *
 * To run a mutation, you first call `useReportAssignmentDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportAssignmentDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportAssignmentDeleteMutation, { data, loading, error }] = useReportAssignmentDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportAssignmentDeleteMutation(baseOptions?: Apollo.MutationHookOptions<ReportAssignmentDeleteMutation, ReportAssignmentDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportAssignmentDeleteMutation, ReportAssignmentDeleteMutationVariables>(ReportAssignmentDeleteDocument, options);
      }
export type ReportAssignmentDeleteMutationHookResult = ReturnType<typeof useReportAssignmentDeleteMutation>;
export type ReportAssignmentDeleteMutationResult = Apollo.MutationResult<ReportAssignmentDeleteMutation>;
export type ReportAssignmentDeleteMutationOptions = Apollo.BaseMutationOptions<ReportAssignmentDeleteMutation, ReportAssignmentDeleteMutationVariables>;
export const ReportDeleteDocument = gql`
    mutation ReportDelete($id: Int!) {
  report: ReportDelete(id: $id) {
    affected
  }
}
    `;
export type ReportDeleteMutationFn = Apollo.MutationFunction<ReportDeleteMutation, ReportDeleteMutationVariables>;

/**
 * __useReportDeleteMutation__
 *
 * To run a mutation, you first call `useReportDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportDeleteMutation, { data, loading, error }] = useReportDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportDeleteMutation(baseOptions?: Apollo.MutationHookOptions<ReportDeleteMutation, ReportDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportDeleteMutation, ReportDeleteMutationVariables>(ReportDeleteDocument, options);
      }
export type ReportDeleteMutationHookResult = ReturnType<typeof useReportDeleteMutation>;
export type ReportDeleteMutationResult = Apollo.MutationResult<ReportDeleteMutation>;
export type ReportDeleteMutationOptions = Apollo.BaseMutationOptions<ReportDeleteMutation, ReportDeleteMutationVariables>;
export const ReportUpdateIsArchivedDocument = gql`
    mutation ReportUpdateIsArchived($id: Int!, $isArchived: Boolean!) {
  report: ReportUpdateIsArchived(id: $id, isArchived: $isArchived) {
    ...Report
  }
}
    ${ReportFragmentDoc}`;
export type ReportUpdateIsArchivedMutationFn = Apollo.MutationFunction<ReportUpdateIsArchivedMutation, ReportUpdateIsArchivedMutationVariables>;

/**
 * __useReportUpdateIsArchivedMutation__
 *
 * To run a mutation, you first call `useReportUpdateIsArchivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportUpdateIsArchivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportUpdateIsArchivedMutation, { data, loading, error }] = useReportUpdateIsArchivedMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isArchived: // value for 'isArchived'
 *   },
 * });
 */
export function useReportUpdateIsArchivedMutation(baseOptions?: Apollo.MutationHookOptions<ReportUpdateIsArchivedMutation, ReportUpdateIsArchivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportUpdateIsArchivedMutation, ReportUpdateIsArchivedMutationVariables>(ReportUpdateIsArchivedDocument, options);
      }
export type ReportUpdateIsArchivedMutationHookResult = ReturnType<typeof useReportUpdateIsArchivedMutation>;
export type ReportUpdateIsArchivedMutationResult = Apollo.MutationResult<ReportUpdateIsArchivedMutation>;
export type ReportUpdateIsArchivedMutationOptions = Apollo.BaseMutationOptions<ReportUpdateIsArchivedMutation, ReportUpdateIsArchivedMutationVariables>;
export const ReportUpdateDocument = gql`
    mutation ReportUpdate($id: Int!, $name: String!, $type: ReportType!, $subType: ReportSubType, $footerType: ReportFooterType, $reportConfigsToCreate: [ReportConfigCreateOneBatchedWithReportArgs!], $reportConfigsToDelete: [DeleteByIdArgs!], $reportConfigsToUpdate: [ReportConfigUpdateOneArgs!]) {
  Report: ReportUpdate(
    id: $id
    name: $name
    type: $type
    subType: $subType
    footerType: $footerType
    reportConfigsToCreate: $reportConfigsToCreate
    reportConfigsToUpdate: $reportConfigsToUpdate
    reportConfigsToDelete: $reportConfigsToDelete
  ) {
    ...Report
  }
}
    ${ReportFragmentDoc}`;
export type ReportUpdateMutationFn = Apollo.MutationFunction<ReportUpdateMutation, ReportUpdateMutationVariables>;

/**
 * __useReportUpdateMutation__
 *
 * To run a mutation, you first call `useReportUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportUpdateMutation, { data, loading, error }] = useReportUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      type: // value for 'type'
 *      subType: // value for 'subType'
 *      footerType: // value for 'footerType'
 *      reportConfigsToCreate: // value for 'reportConfigsToCreate'
 *      reportConfigsToDelete: // value for 'reportConfigsToDelete'
 *      reportConfigsToUpdate: // value for 'reportConfigsToUpdate'
 *   },
 * });
 */
export function useReportUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ReportUpdateMutation, ReportUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportUpdateMutation, ReportUpdateMutationVariables>(ReportUpdateDocument, options);
      }
export type ReportUpdateMutationHookResult = ReturnType<typeof useReportUpdateMutation>;
export type ReportUpdateMutationResult = Apollo.MutationResult<ReportUpdateMutation>;
export type ReportUpdateMutationOptions = Apollo.BaseMutationOptions<ReportUpdateMutation, ReportUpdateMutationVariables>;
export const ReportCopyDocument = gql`
    mutation ReportCopy($name: String!, $type: ReportType!, $subType: ReportSubType, $footerType: ReportFooterType, $ownerId: Int!, $ownerType: ReportOwnerType!, $copyReportId: Int!) {
  report: ReportCopy(
    name: $name
    type: $type
    subType: $subType
    footerType: $footerType
    ownerId: $ownerId
    ownerType: $ownerType
    copyReportId: $copyReportId
  ) {
    ...Report
  }
}
    ${ReportFragmentDoc}`;
export type ReportCopyMutationFn = Apollo.MutationFunction<ReportCopyMutation, ReportCopyMutationVariables>;

/**
 * __useReportCopyMutation__
 *
 * To run a mutation, you first call `useReportCopyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportCopyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportCopyMutation, { data, loading, error }] = useReportCopyMutation({
 *   variables: {
 *      name: // value for 'name'
 *      type: // value for 'type'
 *      subType: // value for 'subType'
 *      footerType: // value for 'footerType'
 *      ownerId: // value for 'ownerId'
 *      ownerType: // value for 'ownerType'
 *      copyReportId: // value for 'copyReportId'
 *   },
 * });
 */
export function useReportCopyMutation(baseOptions?: Apollo.MutationHookOptions<ReportCopyMutation, ReportCopyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportCopyMutation, ReportCopyMutationVariables>(ReportCopyDocument, options);
      }
export type ReportCopyMutationHookResult = ReturnType<typeof useReportCopyMutation>;
export type ReportCopyMutationResult = Apollo.MutationResult<ReportCopyMutation>;
export type ReportCopyMutationOptions = Apollo.BaseMutationOptions<ReportCopyMutation, ReportCopyMutationVariables>;
export const ReportCreateDocument = gql`
    mutation ReportCreate($name: String!, $type: ReportType!, $subType: ReportSubType, $footerType: ReportFooterType, $ownerId: Int!, $ownerType: ReportOwnerType!) {
  report: ReportCreate(
    name: $name
    type: $type
    subType: $subType
    footerType: $footerType
    ownerId: $ownerId
    ownerType: $ownerType
  ) {
    ...Report
  }
}
    ${ReportFragmentDoc}`;
export type ReportCreateMutationFn = Apollo.MutationFunction<ReportCreateMutation, ReportCreateMutationVariables>;

/**
 * __useReportCreateMutation__
 *
 * To run a mutation, you first call `useReportCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportCreateMutation, { data, loading, error }] = useReportCreateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      type: // value for 'type'
 *      subType: // value for 'subType'
 *      footerType: // value for 'footerType'
 *      ownerId: // value for 'ownerId'
 *      ownerType: // value for 'ownerType'
 *   },
 * });
 */
export function useReportCreateMutation(baseOptions?: Apollo.MutationHookOptions<ReportCreateMutation, ReportCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportCreateMutation, ReportCreateMutationVariables>(ReportCreateDocument, options);
      }
export type ReportCreateMutationHookResult = ReturnType<typeof useReportCreateMutation>;
export type ReportCreateMutationResult = Apollo.MutationResult<ReportCreateMutation>;
export type ReportCreateMutationOptions = Apollo.BaseMutationOptions<ReportCreateMutation, ReportCreateMutationVariables>;
export const StageResultsReportRenderCreateDocument = gql`
    mutation StageResultsReportRenderCreate($dataSourceId: Int!, $reportId: Int!, $reportRenderType: ReportRenderType!, $projectJobRoleId: Int!) {
  StageResultsReportRenderCreate(
    dataSourceId: $dataSourceId
    reportId: $reportId
    reportRenderType: $reportRenderType
    projectJobRoleId: $projectJobRoleId
  ) {
    reportRenderStatus
    statusMessage
    subId
    blob {
      url
    }
  }
}
    `;
export type StageResultsReportRenderCreateMutationFn = Apollo.MutationFunction<StageResultsReportRenderCreateMutation, StageResultsReportRenderCreateMutationVariables>;

/**
 * __useStageResultsReportRenderCreateMutation__
 *
 * To run a mutation, you first call `useStageResultsReportRenderCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStageResultsReportRenderCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stageResultsReportRenderCreateMutation, { data, loading, error }] = useStageResultsReportRenderCreateMutation({
 *   variables: {
 *      dataSourceId: // value for 'dataSourceId'
 *      reportId: // value for 'reportId'
 *      reportRenderType: // value for 'reportRenderType'
 *      projectJobRoleId: // value for 'projectJobRoleId'
 *   },
 * });
 */
export function useStageResultsReportRenderCreateMutation(baseOptions?: Apollo.MutationHookOptions<StageResultsReportRenderCreateMutation, StageResultsReportRenderCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StageResultsReportRenderCreateMutation, StageResultsReportRenderCreateMutationVariables>(StageResultsReportRenderCreateDocument, options);
      }
export type StageResultsReportRenderCreateMutationHookResult = ReturnType<typeof useStageResultsReportRenderCreateMutation>;
export type StageResultsReportRenderCreateMutationResult = Apollo.MutationResult<StageResultsReportRenderCreateMutation>;
export type StageResultsReportRenderCreateMutationOptions = Apollo.BaseMutationOptions<StageResultsReportRenderCreateMutation, StageResultsReportRenderCreateMutationVariables>;
export const RespondantFormDeleteDocument = gql`
    mutation RespondantFormDelete($id: Int!, $associatedId: Int!) {
  RespondantFormDeleteByRespondantAndAssociatedId(
    id: $id
    associatedId: $associatedId
  ) {
    affected
  }
}
    `;
export type RespondantFormDeleteMutationFn = Apollo.MutationFunction<RespondantFormDeleteMutation, RespondantFormDeleteMutationVariables>;

/**
 * __useRespondantFormDeleteMutation__
 *
 * To run a mutation, you first call `useRespondantFormDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRespondantFormDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [respondantFormDeleteMutation, { data, loading, error }] = useRespondantFormDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      associatedId: // value for 'associatedId'
 *   },
 * });
 */
export function useRespondantFormDeleteMutation(baseOptions?: Apollo.MutationHookOptions<RespondantFormDeleteMutation, RespondantFormDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RespondantFormDeleteMutation, RespondantFormDeleteMutationVariables>(RespondantFormDeleteDocument, options);
      }
export type RespondantFormDeleteMutationHookResult = ReturnType<typeof useRespondantFormDeleteMutation>;
export type RespondantFormDeleteMutationResult = Apollo.MutationResult<RespondantFormDeleteMutation>;
export type RespondantFormDeleteMutationOptions = Apollo.BaseMutationOptions<RespondantFormDeleteMutation, RespondantFormDeleteMutationVariables>;
export const ResultDeleteManyDocument = gql`
    mutation ResultDeleteMany($doneFor: Int!, $doneBy: Int!, $labels: [String!]) {
  ResultDeleteMany(doneFor: $doneFor, doneBy: $doneBy, labels: $labels) {
    affected
  }
}
    `;
export type ResultDeleteManyMutationFn = Apollo.MutationFunction<ResultDeleteManyMutation, ResultDeleteManyMutationVariables>;

/**
 * __useResultDeleteManyMutation__
 *
 * To run a mutation, you first call `useResultDeleteManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResultDeleteManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resultDeleteManyMutation, { data, loading, error }] = useResultDeleteManyMutation({
 *   variables: {
 *      doneFor: // value for 'doneFor'
 *      doneBy: // value for 'doneBy'
 *      labels: // value for 'labels'
 *   },
 * });
 */
export function useResultDeleteManyMutation(baseOptions?: Apollo.MutationHookOptions<ResultDeleteManyMutation, ResultDeleteManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResultDeleteManyMutation, ResultDeleteManyMutationVariables>(ResultDeleteManyDocument, options);
      }
export type ResultDeleteManyMutationHookResult = ReturnType<typeof useResultDeleteManyMutation>;
export type ResultDeleteManyMutationResult = Apollo.MutationResult<ResultDeleteManyMutation>;
export type ResultDeleteManyMutationOptions = Apollo.BaseMutationOptions<ResultDeleteManyMutation, ResultDeleteManyMutationVariables>;
export const ScheduleRoiCsvFileExportDocument = gql`
    mutation ScheduleROICsvFileExport($projectIds: [Int!]!) {
  FileExportScheduledTask: ScheduleROICsvFileExport(projectIds: $projectIds) {
    status
    error
    subId
    blob {
      url
      id
    }
  }
}
    `;
export type ScheduleRoiCsvFileExportMutationFn = Apollo.MutationFunction<ScheduleRoiCsvFileExportMutation, ScheduleRoiCsvFileExportMutationVariables>;

/**
 * __useScheduleRoiCsvFileExportMutation__
 *
 * To run a mutation, you first call `useScheduleRoiCsvFileExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleRoiCsvFileExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleRoiCsvFileExportMutation, { data, loading, error }] = useScheduleRoiCsvFileExportMutation({
 *   variables: {
 *      projectIds: // value for 'projectIds'
 *   },
 * });
 */
export function useScheduleRoiCsvFileExportMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleRoiCsvFileExportMutation, ScheduleRoiCsvFileExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleRoiCsvFileExportMutation, ScheduleRoiCsvFileExportMutationVariables>(ScheduleRoiCsvFileExportDocument, options);
      }
export type ScheduleRoiCsvFileExportMutationHookResult = ReturnType<typeof useScheduleRoiCsvFileExportMutation>;
export type ScheduleRoiCsvFileExportMutationResult = Apollo.MutationResult<ScheduleRoiCsvFileExportMutation>;
export type ScheduleRoiCsvFileExportMutationOptions = Apollo.BaseMutationOptions<ScheduleRoiCsvFileExportMutation, ScheduleRoiCsvFileExportMutationVariables>;
export const RssAssessmentCandidateReopenAllSubmittedForStageCandidateDocument = gql`
    mutation RssAssessmentCandidateReopenAllSubmittedForStageCandidate($stageCandidateId: Int!) {
  RssAssessmentCandidateReopenAllSubmittedForStageCandidate(
    stageCandidateId: $stageCandidateId
  ) {
    ...RssAssessmentCandidate
  }
}
    ${RssAssessmentCandidateFragmentDoc}`;
export type RssAssessmentCandidateReopenAllSubmittedForStageCandidateMutationFn = Apollo.MutationFunction<RssAssessmentCandidateReopenAllSubmittedForStageCandidateMutation, RssAssessmentCandidateReopenAllSubmittedForStageCandidateMutationVariables>;

/**
 * __useRssAssessmentCandidateReopenAllSubmittedForStageCandidateMutation__
 *
 * To run a mutation, you first call `useRssAssessmentCandidateReopenAllSubmittedForStageCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRssAssessmentCandidateReopenAllSubmittedForStageCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rssAssessmentCandidateReopenAllSubmittedForStageCandidateMutation, { data, loading, error }] = useRssAssessmentCandidateReopenAllSubmittedForStageCandidateMutation({
 *   variables: {
 *      stageCandidateId: // value for 'stageCandidateId'
 *   },
 * });
 */
export function useRssAssessmentCandidateReopenAllSubmittedForStageCandidateMutation(baseOptions?: Apollo.MutationHookOptions<RssAssessmentCandidateReopenAllSubmittedForStageCandidateMutation, RssAssessmentCandidateReopenAllSubmittedForStageCandidateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RssAssessmentCandidateReopenAllSubmittedForStageCandidateMutation, RssAssessmentCandidateReopenAllSubmittedForStageCandidateMutationVariables>(RssAssessmentCandidateReopenAllSubmittedForStageCandidateDocument, options);
      }
export type RssAssessmentCandidateReopenAllSubmittedForStageCandidateMutationHookResult = ReturnType<typeof useRssAssessmentCandidateReopenAllSubmittedForStageCandidateMutation>;
export type RssAssessmentCandidateReopenAllSubmittedForStageCandidateMutationResult = Apollo.MutationResult<RssAssessmentCandidateReopenAllSubmittedForStageCandidateMutation>;
export type RssAssessmentCandidateReopenAllSubmittedForStageCandidateMutationOptions = Apollo.BaseMutationOptions<RssAssessmentCandidateReopenAllSubmittedForStageCandidateMutation, RssAssessmentCandidateReopenAllSubmittedForStageCandidateMutationVariables>;
export const ScheduledCandidateUsageCsvFileExportDocument = gql`
    mutation ScheduledCandidateUsageCsvFileExport($createdAtFrom: Date, $createdAtTo: Date, $companyIds: [Int!]) {
  ScheduledCandidateUsageCsvFileExport(
    companyIds: $companyIds
    stageCandidateCreatedAtFrom: $createdAtFrom
    stageCandidateCreatedAtTo: $createdAtTo
  ) {
    subId
    kind
    status
    error
  }
}
    `;
export type ScheduledCandidateUsageCsvFileExportMutationFn = Apollo.MutationFunction<ScheduledCandidateUsageCsvFileExportMutation, ScheduledCandidateUsageCsvFileExportMutationVariables>;

/**
 * __useScheduledCandidateUsageCsvFileExportMutation__
 *
 * To run a mutation, you first call `useScheduledCandidateUsageCsvFileExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduledCandidateUsageCsvFileExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduledCandidateUsageCsvFileExportMutation, { data, loading, error }] = useScheduledCandidateUsageCsvFileExportMutation({
 *   variables: {
 *      createdAtFrom: // value for 'createdAtFrom'
 *      createdAtTo: // value for 'createdAtTo'
 *      companyIds: // value for 'companyIds'
 *   },
 * });
 */
export function useScheduledCandidateUsageCsvFileExportMutation(baseOptions?: Apollo.MutationHookOptions<ScheduledCandidateUsageCsvFileExportMutation, ScheduledCandidateUsageCsvFileExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduledCandidateUsageCsvFileExportMutation, ScheduledCandidateUsageCsvFileExportMutationVariables>(ScheduledCandidateUsageCsvFileExportDocument, options);
      }
export type ScheduledCandidateUsageCsvFileExportMutationHookResult = ReturnType<typeof useScheduledCandidateUsageCsvFileExportMutation>;
export type ScheduledCandidateUsageCsvFileExportMutationResult = Apollo.MutationResult<ScheduledCandidateUsageCsvFileExportMutation>;
export type ScheduledCandidateUsageCsvFileExportMutationOptions = Apollo.BaseMutationOptions<ScheduledCandidateUsageCsvFileExportMutation, ScheduledCandidateUsageCsvFileExportMutationVariables>;
export const ShortlistStageDeleteDocument = gql`
    mutation ShortlistStageDelete($subId: ID!) {
  ShortlistStageDelete(subId: $subId)
}
    `;
export type ShortlistStageDeleteMutationFn = Apollo.MutationFunction<ShortlistStageDeleteMutation, ShortlistStageDeleteMutationVariables>;

/**
 * __useShortlistStageDeleteMutation__
 *
 * To run a mutation, you first call `useShortlistStageDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShortlistStageDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shortlistStageDeleteMutation, { data, loading, error }] = useShortlistStageDeleteMutation({
 *   variables: {
 *      subId: // value for 'subId'
 *   },
 * });
 */
export function useShortlistStageDeleteMutation(baseOptions?: Apollo.MutationHookOptions<ShortlistStageDeleteMutation, ShortlistStageDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShortlistStageDeleteMutation, ShortlistStageDeleteMutationVariables>(ShortlistStageDeleteDocument, options);
      }
export type ShortlistStageDeleteMutationHookResult = ReturnType<typeof useShortlistStageDeleteMutation>;
export type ShortlistStageDeleteMutationResult = Apollo.MutationResult<ShortlistStageDeleteMutation>;
export type ShortlistStageDeleteMutationOptions = Apollo.BaseMutationOptions<ShortlistStageDeleteMutation, ShortlistStageDeleteMutationVariables>;
export const SoftSkillBulkUpdateTraitsDocument = gql`
    mutation SoftSkillBulkUpdateTraits($softSkillTraits: [BulkUpdateSoftSkillTraitArgsSingle!]!) {
  softSkill: SoftSkillBulkUpdateTraits(softSkillTraits: $softSkillTraits) {
    ...SoftSkill
  }
}
    ${SoftSkillFragmentDoc}`;
export type SoftSkillBulkUpdateTraitsMutationFn = Apollo.MutationFunction<SoftSkillBulkUpdateTraitsMutation, SoftSkillBulkUpdateTraitsMutationVariables>;

/**
 * __useSoftSkillBulkUpdateTraitsMutation__
 *
 * To run a mutation, you first call `useSoftSkillBulkUpdateTraitsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftSkillBulkUpdateTraitsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softSkillBulkUpdateTraitsMutation, { data, loading, error }] = useSoftSkillBulkUpdateTraitsMutation({
 *   variables: {
 *      softSkillTraits: // value for 'softSkillTraits'
 *   },
 * });
 */
export function useSoftSkillBulkUpdateTraitsMutation(baseOptions?: Apollo.MutationHookOptions<SoftSkillBulkUpdateTraitsMutation, SoftSkillBulkUpdateTraitsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftSkillBulkUpdateTraitsMutation, SoftSkillBulkUpdateTraitsMutationVariables>(SoftSkillBulkUpdateTraitsDocument, options);
      }
export type SoftSkillBulkUpdateTraitsMutationHookResult = ReturnType<typeof useSoftSkillBulkUpdateTraitsMutation>;
export type SoftSkillBulkUpdateTraitsMutationResult = Apollo.MutationResult<SoftSkillBulkUpdateTraitsMutation>;
export type SoftSkillBulkUpdateTraitsMutationOptions = Apollo.BaseMutationOptions<SoftSkillBulkUpdateTraitsMutation, SoftSkillBulkUpdateTraitsMutationVariables>;
export const SoftSkillCreateDocument = gql`
    mutation SoftSkillCreate($name: String!, $description: String, $companyId: Int, $category: SoftSkillCategory!, $granularity: SoftSkillGranularity!, $taxonomyVersion: Int!) {
  softSkill: SoftSkillCreate(
    name: $name
    description: $description
    companyId: $companyId
    category: $category
    granularity: $granularity
    taxonomyVersion: $taxonomyVersion
    measurementConstructType: BEHAVIOR
  ) {
    subId
  }
}
    `;
export type SoftSkillCreateMutationFn = Apollo.MutationFunction<SoftSkillCreateMutation, SoftSkillCreateMutationVariables>;

/**
 * __useSoftSkillCreateMutation__
 *
 * To run a mutation, you first call `useSoftSkillCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftSkillCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softSkillCreateMutation, { data, loading, error }] = useSoftSkillCreateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      companyId: // value for 'companyId'
 *      category: // value for 'category'
 *      granularity: // value for 'granularity'
 *      taxonomyVersion: // value for 'taxonomyVersion'
 *   },
 * });
 */
export function useSoftSkillCreateMutation(baseOptions?: Apollo.MutationHookOptions<SoftSkillCreateMutation, SoftSkillCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftSkillCreateMutation, SoftSkillCreateMutationVariables>(SoftSkillCreateDocument, options);
      }
export type SoftSkillCreateMutationHookResult = ReturnType<typeof useSoftSkillCreateMutation>;
export type SoftSkillCreateMutationResult = Apollo.MutationResult<SoftSkillCreateMutation>;
export type SoftSkillCreateMutationOptions = Apollo.BaseMutationOptions<SoftSkillCreateMutation, SoftSkillCreateMutationVariables>;
export const SoftSkillSoftDeleteDocument = gql`
    mutation SoftSkillSoftDelete($subId: ID!) {
  softSkill: SoftSkillSoftDelete(subId: $subId) {
    ...SoftSkill
  }
}
    ${SoftSkillFragmentDoc}`;
export type SoftSkillSoftDeleteMutationFn = Apollo.MutationFunction<SoftSkillSoftDeleteMutation, SoftSkillSoftDeleteMutationVariables>;

/**
 * __useSoftSkillSoftDeleteMutation__
 *
 * To run a mutation, you first call `useSoftSkillSoftDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftSkillSoftDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softSkillSoftDeleteMutation, { data, loading, error }] = useSoftSkillSoftDeleteMutation({
 *   variables: {
 *      subId: // value for 'subId'
 *   },
 * });
 */
export function useSoftSkillSoftDeleteMutation(baseOptions?: Apollo.MutationHookOptions<SoftSkillSoftDeleteMutation, SoftSkillSoftDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftSkillSoftDeleteMutation, SoftSkillSoftDeleteMutationVariables>(SoftSkillSoftDeleteDocument, options);
      }
export type SoftSkillSoftDeleteMutationHookResult = ReturnType<typeof useSoftSkillSoftDeleteMutation>;
export type SoftSkillSoftDeleteMutationResult = Apollo.MutationResult<SoftSkillSoftDeleteMutation>;
export type SoftSkillSoftDeleteMutationOptions = Apollo.BaseMutationOptions<SoftSkillSoftDeleteMutation, SoftSkillSoftDeleteMutationVariables>;
export const SoftSkillRestoreDocument = gql`
    mutation SoftSkillRestore($subId: ID!) {
  softSkill: SoftSkillRestore(subId: $subId) {
    ...SoftSkill
  }
}
    ${SoftSkillFragmentDoc}`;
export type SoftSkillRestoreMutationFn = Apollo.MutationFunction<SoftSkillRestoreMutation, SoftSkillRestoreMutationVariables>;

/**
 * __useSoftSkillRestoreMutation__
 *
 * To run a mutation, you first call `useSoftSkillRestoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftSkillRestoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softSkillRestoreMutation, { data, loading, error }] = useSoftSkillRestoreMutation({
 *   variables: {
 *      subId: // value for 'subId'
 *   },
 * });
 */
export function useSoftSkillRestoreMutation(baseOptions?: Apollo.MutationHookOptions<SoftSkillRestoreMutation, SoftSkillRestoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftSkillRestoreMutation, SoftSkillRestoreMutationVariables>(SoftSkillRestoreDocument, options);
      }
export type SoftSkillRestoreMutationHookResult = ReturnType<typeof useSoftSkillRestoreMutation>;
export type SoftSkillRestoreMutationResult = Apollo.MutationResult<SoftSkillRestoreMutation>;
export type SoftSkillRestoreMutationOptions = Apollo.BaseMutationOptions<SoftSkillRestoreMutation, SoftSkillRestoreMutationVariables>;
export const SoftSkillUpdateDocument = gql`
    mutation SoftSkillUpdate($subId: ID!, $args: SoftSkillUpdateArgs!) {
  softSkill: SoftSkillUpdate(subId: $subId, args: $args) {
    ...SoftSkill
  }
}
    ${SoftSkillFragmentDoc}`;
export type SoftSkillUpdateMutationFn = Apollo.MutationFunction<SoftSkillUpdateMutation, SoftSkillUpdateMutationVariables>;

/**
 * __useSoftSkillUpdateMutation__
 *
 * To run a mutation, you first call `useSoftSkillUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftSkillUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softSkillUpdateMutation, { data, loading, error }] = useSoftSkillUpdateMutation({
 *   variables: {
 *      subId: // value for 'subId'
 *      args: // value for 'args'
 *   },
 * });
 */
export function useSoftSkillUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SoftSkillUpdateMutation, SoftSkillUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftSkillUpdateMutation, SoftSkillUpdateMutationVariables>(SoftSkillUpdateDocument, options);
      }
export type SoftSkillUpdateMutationHookResult = ReturnType<typeof useSoftSkillUpdateMutation>;
export type SoftSkillUpdateMutationResult = Apollo.MutationResult<SoftSkillUpdateMutation>;
export type SoftSkillUpdateMutationOptions = Apollo.BaseMutationOptions<SoftSkillUpdateMutation, SoftSkillUpdateMutationVariables>;
export const SaveSoftSkillContentDocument = gql`
    mutation SaveSoftSkillContent($id: Int!, $description: String, $candidateContent: String, $hiringManagerContent: String, $internalCandidateContent: String) {
  saveSoftSkillContent: SoftSkillRoleLevelContentUpdate(
    id: $id
    description: $description
    candidateContent: $candidateContent
    hiringManagerContent: $hiringManagerContent
    internalCandidateContent: $internalCandidateContent
  ) {
    id
    softSkillId
    softSkill {
      id
      name
    }
    grade
    roleLevel
    description
    candidateContent
    hiringManagerContent
    internalCandidateContent
  }
}
    `;
export type SaveSoftSkillContentMutationFn = Apollo.MutationFunction<SaveSoftSkillContentMutation, SaveSoftSkillContentMutationVariables>;

/**
 * __useSaveSoftSkillContentMutation__
 *
 * To run a mutation, you first call `useSaveSoftSkillContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSoftSkillContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSoftSkillContentMutation, { data, loading, error }] = useSaveSoftSkillContentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      description: // value for 'description'
 *      candidateContent: // value for 'candidateContent'
 *      hiringManagerContent: // value for 'hiringManagerContent'
 *      internalCandidateContent: // value for 'internalCandidateContent'
 *   },
 * });
 */
export function useSaveSoftSkillContentMutation(baseOptions?: Apollo.MutationHookOptions<SaveSoftSkillContentMutation, SaveSoftSkillContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveSoftSkillContentMutation, SaveSoftSkillContentMutationVariables>(SaveSoftSkillContentDocument, options);
      }
export type SaveSoftSkillContentMutationHookResult = ReturnType<typeof useSaveSoftSkillContentMutation>;
export type SaveSoftSkillContentMutationResult = Apollo.MutationResult<SaveSoftSkillContentMutation>;
export type SaveSoftSkillContentMutationOptions = Apollo.BaseMutationOptions<SaveSoftSkillContentMutation, SaveSoftSkillContentMutationVariables>;
export const SoftSkillRoleLevelContentUploadDocument = gql`
    mutation SoftSkillRoleLevelContentUpload($file: Upload!) {
  SoftSkillRoleLevelContentUpload(file: $file)
}
    `;
export type SoftSkillRoleLevelContentUploadMutationFn = Apollo.MutationFunction<SoftSkillRoleLevelContentUploadMutation, SoftSkillRoleLevelContentUploadMutationVariables>;

/**
 * __useSoftSkillRoleLevelContentUploadMutation__
 *
 * To run a mutation, you first call `useSoftSkillRoleLevelContentUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftSkillRoleLevelContentUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softSkillRoleLevelContentUploadMutation, { data, loading, error }] = useSoftSkillRoleLevelContentUploadMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useSoftSkillRoleLevelContentUploadMutation(baseOptions?: Apollo.MutationHookOptions<SoftSkillRoleLevelContentUploadMutation, SoftSkillRoleLevelContentUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftSkillRoleLevelContentUploadMutation, SoftSkillRoleLevelContentUploadMutationVariables>(SoftSkillRoleLevelContentUploadDocument, options);
      }
export type SoftSkillRoleLevelContentUploadMutationHookResult = ReturnType<typeof useSoftSkillRoleLevelContentUploadMutation>;
export type SoftSkillRoleLevelContentUploadMutationResult = Apollo.MutationResult<SoftSkillRoleLevelContentUploadMutation>;
export type SoftSkillRoleLevelContentUploadMutationOptions = Apollo.BaseMutationOptions<SoftSkillRoleLevelContentUploadMutation, SoftSkillRoleLevelContentUploadMutationVariables>;
export const SoftSkillRoleLevelContentCsvFileExportDocument = gql`
    mutation SoftSkillRoleLevelContentCsvFileExport {
  SoftSkillRoleLevelContentCsvFileExport {
    subId
    status
    blob {
      ...BlobUrl
    }
  }
}
    ${BlobUrlFragmentDoc}`;
export type SoftSkillRoleLevelContentCsvFileExportMutationFn = Apollo.MutationFunction<SoftSkillRoleLevelContentCsvFileExportMutation, SoftSkillRoleLevelContentCsvFileExportMutationVariables>;

/**
 * __useSoftSkillRoleLevelContentCsvFileExportMutation__
 *
 * To run a mutation, you first call `useSoftSkillRoleLevelContentCsvFileExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftSkillRoleLevelContentCsvFileExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softSkillRoleLevelContentCsvFileExportMutation, { data, loading, error }] = useSoftSkillRoleLevelContentCsvFileExportMutation({
 *   variables: {
 *   },
 * });
 */
export function useSoftSkillRoleLevelContentCsvFileExportMutation(baseOptions?: Apollo.MutationHookOptions<SoftSkillRoleLevelContentCsvFileExportMutation, SoftSkillRoleLevelContentCsvFileExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftSkillRoleLevelContentCsvFileExportMutation, SoftSkillRoleLevelContentCsvFileExportMutationVariables>(SoftSkillRoleLevelContentCsvFileExportDocument, options);
      }
export type SoftSkillRoleLevelContentCsvFileExportMutationHookResult = ReturnType<typeof useSoftSkillRoleLevelContentCsvFileExportMutation>;
export type SoftSkillRoleLevelContentCsvFileExportMutationResult = Apollo.MutationResult<SoftSkillRoleLevelContentCsvFileExportMutation>;
export type SoftSkillRoleLevelContentCsvFileExportMutationOptions = Apollo.BaseMutationOptions<SoftSkillRoleLevelContentCsvFileExportMutation, SoftSkillRoleLevelContentCsvFileExportMutationVariables>;
export const SetIndirectInviteSsoDocument = gql`
    mutation SetIndirectInviteSSO($projectId: Int!, $indirectInviteSSO: Boolean!) {
  setIndirectInviteSSO(id: $projectId, indirectInviteSSO: $indirectInviteSSO)
}
    `;
export type SetIndirectInviteSsoMutationFn = Apollo.MutationFunction<SetIndirectInviteSsoMutation, SetIndirectInviteSsoMutationVariables>;

/**
 * __useSetIndirectInviteSsoMutation__
 *
 * To run a mutation, you first call `useSetIndirectInviteSsoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetIndirectInviteSsoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setIndirectInviteSsoMutation, { data, loading, error }] = useSetIndirectInviteSsoMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      indirectInviteSSO: // value for 'indirectInviteSSO'
 *   },
 * });
 */
export function useSetIndirectInviteSsoMutation(baseOptions?: Apollo.MutationHookOptions<SetIndirectInviteSsoMutation, SetIndirectInviteSsoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetIndirectInviteSsoMutation, SetIndirectInviteSsoMutationVariables>(SetIndirectInviteSsoDocument, options);
      }
export type SetIndirectInviteSsoMutationHookResult = ReturnType<typeof useSetIndirectInviteSsoMutation>;
export type SetIndirectInviteSsoMutationResult = Apollo.MutationResult<SetIndirectInviteSsoMutation>;
export type SetIndirectInviteSsoMutationOptions = Apollo.BaseMutationOptions<SetIndirectInviteSsoMutation, SetIndirectInviteSsoMutationVariables>;
export const RemoveOneStageDocument = gql`
    mutation RemoveOneStage($stageId: Int!) {
  RemoveOneStage: StageDeleteOne(id: $stageId) {
    affected
  }
}
    `;
export type RemoveOneStageMutationFn = Apollo.MutationFunction<RemoveOneStageMutation, RemoveOneStageMutationVariables>;

/**
 * __useRemoveOneStageMutation__
 *
 * To run a mutation, you first call `useRemoveOneStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveOneStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeOneStageMutation, { data, loading, error }] = useRemoveOneStageMutation({
 *   variables: {
 *      stageId: // value for 'stageId'
 *   },
 * });
 */
export function useRemoveOneStageMutation(baseOptions?: Apollo.MutationHookOptions<RemoveOneStageMutation, RemoveOneStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveOneStageMutation, RemoveOneStageMutationVariables>(RemoveOneStageDocument, options);
      }
export type RemoveOneStageMutationHookResult = ReturnType<typeof useRemoveOneStageMutation>;
export type RemoveOneStageMutationResult = Apollo.MutationResult<RemoveOneStageMutation>;
export type RemoveOneStageMutationOptions = Apollo.BaseMutationOptions<RemoveOneStageMutation, RemoveOneStageMutationVariables>;
export const CreateStageDocument = gql`
    mutation CreateStage($hasCalibration: Boolean!, $endTime: Date, $name: String!, $projectId: Int!, $startTime: Date, $status: StageStatus, $cognitiveMode: CognitiveMode!, $emailCandidateReport: Boolean!, $managerReportId: Int, $candidateReportId: Int, $projectTeamEmailSettings: ProjectTeamEmailSettingsArgs, $kind: AssessmentStageKind) {
  Stage: StageCreate(
    hasCalibration: $hasCalibration
    endTime: $endTime
    name: $name
    projectId: $projectId
    startTime: $startTime
    status: $status
    cognitiveMode: $cognitiveMode
    emailCandidateReport: $emailCandidateReport
    managerReportId: $managerReportId
    candidateReportId: $candidateReportId
    projectTeamEmailSettings: $projectTeamEmailSettings
    kind: $kind
  ) {
    ...SmStageModel
  }
}
    ${SmStageModelFragmentDoc}`;
export type CreateStageMutationFn = Apollo.MutationFunction<CreateStageMutation, CreateStageMutationVariables>;

/**
 * __useCreateStageMutation__
 *
 * To run a mutation, you first call `useCreateStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStageMutation, { data, loading, error }] = useCreateStageMutation({
 *   variables: {
 *      hasCalibration: // value for 'hasCalibration'
 *      endTime: // value for 'endTime'
 *      name: // value for 'name'
 *      projectId: // value for 'projectId'
 *      startTime: // value for 'startTime'
 *      status: // value for 'status'
 *      cognitiveMode: // value for 'cognitiveMode'
 *      emailCandidateReport: // value for 'emailCandidateReport'
 *      managerReportId: // value for 'managerReportId'
 *      candidateReportId: // value for 'candidateReportId'
 *      projectTeamEmailSettings: // value for 'projectTeamEmailSettings'
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useCreateStageMutation(baseOptions?: Apollo.MutationHookOptions<CreateStageMutation, CreateStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStageMutation, CreateStageMutationVariables>(CreateStageDocument, options);
      }
export type CreateStageMutationHookResult = ReturnType<typeof useCreateStageMutation>;
export type CreateStageMutationResult = Apollo.MutationResult<CreateStageMutation>;
export type CreateStageMutationOptions = Apollo.BaseMutationOptions<CreateStageMutation, CreateStageMutationVariables>;
export const StageEditDetailsDocument = gql`
    mutation StageEditDetails($hasCalibration: Boolean, $endTime: Date, $id: Int!, $name: String, $startTime: Date, $assessmentExpiryOption: AssessmentExpiryOptionArgs, $cognitiveMode: CognitiveMode, $managerReportId: Int, $candidateReportId: Int, $emailCandidateReport: Boolean, $projectTeamEmailSettings: ProjectTeamEmailSettingsArgs) {
  Stage: StageUpdate(
    hasCalibration: $hasCalibration
    endTime: $endTime
    id: $id
    name: $name
    startTime: $startTime
    assessmentExpiryOption: $assessmentExpiryOption
    cognitiveMode: $cognitiveMode
    managerReportId: $managerReportId
    candidateReportId: $candidateReportId
    emailCandidateReport: $emailCandidateReport
    projectTeamEmailSettings: $projectTeamEmailSettings
  ) {
    ...SmStageModel
  }
}
    ${SmStageModelFragmentDoc}`;
export type StageEditDetailsMutationFn = Apollo.MutationFunction<StageEditDetailsMutation, StageEditDetailsMutationVariables>;

/**
 * __useStageEditDetailsMutation__
 *
 * To run a mutation, you first call `useStageEditDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStageEditDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stageEditDetailsMutation, { data, loading, error }] = useStageEditDetailsMutation({
 *   variables: {
 *      hasCalibration: // value for 'hasCalibration'
 *      endTime: // value for 'endTime'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      startTime: // value for 'startTime'
 *      assessmentExpiryOption: // value for 'assessmentExpiryOption'
 *      cognitiveMode: // value for 'cognitiveMode'
 *      managerReportId: // value for 'managerReportId'
 *      candidateReportId: // value for 'candidateReportId'
 *      emailCandidateReport: // value for 'emailCandidateReport'
 *      projectTeamEmailSettings: // value for 'projectTeamEmailSettings'
 *   },
 * });
 */
export function useStageEditDetailsMutation(baseOptions?: Apollo.MutationHookOptions<StageEditDetailsMutation, StageEditDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StageEditDetailsMutation, StageEditDetailsMutationVariables>(StageEditDetailsDocument, options);
      }
export type StageEditDetailsMutationHookResult = ReturnType<typeof useStageEditDetailsMutation>;
export type StageEditDetailsMutationResult = Apollo.MutationResult<StageEditDetailsMutation>;
export type StageEditDetailsMutationOptions = Apollo.BaseMutationOptions<StageEditDetailsMutation, StageEditDetailsMutationVariables>;
export const StageCandidateResetOneDocument = gql`
    mutation StageCandidateResetOne($id: Int) {
  Stages: StageCandidateResetOne(id: $id)
}
    `;
export type StageCandidateResetOneMutationFn = Apollo.MutationFunction<StageCandidateResetOneMutation, StageCandidateResetOneMutationVariables>;

/**
 * __useStageCandidateResetOneMutation__
 *
 * To run a mutation, you first call `useStageCandidateResetOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStageCandidateResetOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stageCandidateResetOneMutation, { data, loading, error }] = useStageCandidateResetOneMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStageCandidateResetOneMutation(baseOptions?: Apollo.MutationHookOptions<StageCandidateResetOneMutation, StageCandidateResetOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StageCandidateResetOneMutation, StageCandidateResetOneMutationVariables>(StageCandidateResetOneDocument, options);
      }
export type StageCandidateResetOneMutationHookResult = ReturnType<typeof useStageCandidateResetOneMutation>;
export type StageCandidateResetOneMutationResult = Apollo.MutationResult<StageCandidateResetOneMutation>;
export type StageCandidateResetOneMutationOptions = Apollo.BaseMutationOptions<StageCandidateResetOneMutation, StageCandidateResetOneMutationVariables>;
export const StageCandidateReprocessOneDocument = gql`
    mutation StageCandidateReprocessOne($id: Int) {
  StageCandidateReprocessOne(id: $id)
}
    `;
export type StageCandidateReprocessOneMutationFn = Apollo.MutationFunction<StageCandidateReprocessOneMutation, StageCandidateReprocessOneMutationVariables>;

/**
 * __useStageCandidateReprocessOneMutation__
 *
 * To run a mutation, you first call `useStageCandidateReprocessOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStageCandidateReprocessOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stageCandidateReprocessOneMutation, { data, loading, error }] = useStageCandidateReprocessOneMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStageCandidateReprocessOneMutation(baseOptions?: Apollo.MutationHookOptions<StageCandidateReprocessOneMutation, StageCandidateReprocessOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StageCandidateReprocessOneMutation, StageCandidateReprocessOneMutationVariables>(StageCandidateReprocessOneDocument, options);
      }
export type StageCandidateReprocessOneMutationHookResult = ReturnType<typeof useStageCandidateReprocessOneMutation>;
export type StageCandidateReprocessOneMutationResult = Apollo.MutationResult<StageCandidateReprocessOneMutation>;
export type StageCandidateReprocessOneMutationOptions = Apollo.BaseMutationOptions<StageCandidateReprocessOneMutation, StageCandidateReprocessOneMutationVariables>;
export const StageCandidateDeleteOneDocument = gql`
    mutation StageCandidateDeleteOne($subId: String!) {
  StageCandidateDeleteOne(subId: $subId) {
    affected
  }
}
    `;
export type StageCandidateDeleteOneMutationFn = Apollo.MutationFunction<StageCandidateDeleteOneMutation, StageCandidateDeleteOneMutationVariables>;

/**
 * __useStageCandidateDeleteOneMutation__
 *
 * To run a mutation, you first call `useStageCandidateDeleteOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStageCandidateDeleteOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stageCandidateDeleteOneMutation, { data, loading, error }] = useStageCandidateDeleteOneMutation({
 *   variables: {
 *      subId: // value for 'subId'
 *   },
 * });
 */
export function useStageCandidateDeleteOneMutation(baseOptions?: Apollo.MutationHookOptions<StageCandidateDeleteOneMutation, StageCandidateDeleteOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StageCandidateDeleteOneMutation, StageCandidateDeleteOneMutationVariables>(StageCandidateDeleteOneDocument, options);
      }
export type StageCandidateDeleteOneMutationHookResult = ReturnType<typeof useStageCandidateDeleteOneMutation>;
export type StageCandidateDeleteOneMutationResult = Apollo.MutationResult<StageCandidateDeleteOneMutation>;
export type StageCandidateDeleteOneMutationOptions = Apollo.BaseMutationOptions<StageCandidateDeleteOneMutation, StageCandidateDeleteOneMutationVariables>;
export const DeiStageActionUpsertDocument = gql`
    mutation DeiStageActionUpsert($stageId: Int!, $fields: DeiStageActionFieldsInput!) {
  DeiStageActionUpsert(stageId: $stageId, fields: $fields) {
    ...DeiStageAction
  }
}
    ${DeiStageActionFragmentDoc}`;
export type DeiStageActionUpsertMutationFn = Apollo.MutationFunction<DeiStageActionUpsertMutation, DeiStageActionUpsertMutationVariables>;

/**
 * __useDeiStageActionUpsertMutation__
 *
 * To run a mutation, you first call `useDeiStageActionUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeiStageActionUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deiStageActionUpsertMutation, { data, loading, error }] = useDeiStageActionUpsertMutation({
 *   variables: {
 *      stageId: // value for 'stageId'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useDeiStageActionUpsertMutation(baseOptions?: Apollo.MutationHookOptions<DeiStageActionUpsertMutation, DeiStageActionUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeiStageActionUpsertMutation, DeiStageActionUpsertMutationVariables>(DeiStageActionUpsertDocument, options);
      }
export type DeiStageActionUpsertMutationHookResult = ReturnType<typeof useDeiStageActionUpsertMutation>;
export type DeiStageActionUpsertMutationResult = Apollo.MutationResult<DeiStageActionUpsertMutation>;
export type DeiStageActionUpsertMutationOptions = Apollo.BaseMutationOptions<DeiStageActionUpsertMutation, DeiStageActionUpsertMutationVariables>;
export const DeiStageActionArchiveDocument = gql`
    mutation DeiStageActionArchive($stageId: Int!) {
  DeiStageActionArchive(stageId: $stageId) {
    ...DeiStageAction
  }
}
    ${DeiStageActionFragmentDoc}`;
export type DeiStageActionArchiveMutationFn = Apollo.MutationFunction<DeiStageActionArchiveMutation, DeiStageActionArchiveMutationVariables>;

/**
 * __useDeiStageActionArchiveMutation__
 *
 * To run a mutation, you first call `useDeiStageActionArchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeiStageActionArchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deiStageActionArchiveMutation, { data, loading, error }] = useDeiStageActionArchiveMutation({
 *   variables: {
 *      stageId: // value for 'stageId'
 *   },
 * });
 */
export function useDeiStageActionArchiveMutation(baseOptions?: Apollo.MutationHookOptions<DeiStageActionArchiveMutation, DeiStageActionArchiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeiStageActionArchiveMutation, DeiStageActionArchiveMutationVariables>(DeiStageActionArchiveDocument, options);
      }
export type DeiStageActionArchiveMutationHookResult = ReturnType<typeof useDeiStageActionArchiveMutation>;
export type DeiStageActionArchiveMutationResult = Apollo.MutationResult<DeiStageActionArchiveMutation>;
export type DeiStageActionArchiveMutationOptions = Apollo.BaseMutationOptions<DeiStageActionArchiveMutation, DeiStageActionArchiveMutationVariables>;
export const DeiStageActionUnarchiveDocument = gql`
    mutation DeiStageActionUnarchive($stageId: Int!, $fields: DeiStageActionFieldsInput!) {
  DeiStageActionUnarchive(stageId: $stageId, fields: $fields) {
    ...DeiStageAction
  }
}
    ${DeiStageActionFragmentDoc}`;
export type DeiStageActionUnarchiveMutationFn = Apollo.MutationFunction<DeiStageActionUnarchiveMutation, DeiStageActionUnarchiveMutationVariables>;

/**
 * __useDeiStageActionUnarchiveMutation__
 *
 * To run a mutation, you first call `useDeiStageActionUnarchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeiStageActionUnarchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deiStageActionUnarchiveMutation, { data, loading, error }] = useDeiStageActionUnarchiveMutation({
 *   variables: {
 *      stageId: // value for 'stageId'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useDeiStageActionUnarchiveMutation(baseOptions?: Apollo.MutationHookOptions<DeiStageActionUnarchiveMutation, DeiStageActionUnarchiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeiStageActionUnarchiveMutation, DeiStageActionUnarchiveMutationVariables>(DeiStageActionUnarchiveDocument, options);
      }
export type DeiStageActionUnarchiveMutationHookResult = ReturnType<typeof useDeiStageActionUnarchiveMutation>;
export type DeiStageActionUnarchiveMutationResult = Apollo.MutationResult<DeiStageActionUnarchiveMutation>;
export type DeiStageActionUnarchiveMutationOptions = Apollo.BaseMutationOptions<DeiStageActionUnarchiveMutation, DeiStageActionUnarchiveMutationVariables>;
export const DeiStageActionCandidateReopenDocument = gql`
    mutation DeiStageActionCandidateReopen($stageCandidateId: Int!) {
  DeiStageActionCandidateReopen(stageCandidateId: $stageCandidateId) {
    ...DeiStageActionCandidate
  }
}
    ${DeiStageActionCandidateFragmentDoc}`;
export type DeiStageActionCandidateReopenMutationFn = Apollo.MutationFunction<DeiStageActionCandidateReopenMutation, DeiStageActionCandidateReopenMutationVariables>;

/**
 * __useDeiStageActionCandidateReopenMutation__
 *
 * To run a mutation, you first call `useDeiStageActionCandidateReopenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeiStageActionCandidateReopenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deiStageActionCandidateReopenMutation, { data, loading, error }] = useDeiStageActionCandidateReopenMutation({
 *   variables: {
 *      stageCandidateId: // value for 'stageCandidateId'
 *   },
 * });
 */
export function useDeiStageActionCandidateReopenMutation(baseOptions?: Apollo.MutationHookOptions<DeiStageActionCandidateReopenMutation, DeiStageActionCandidateReopenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeiStageActionCandidateReopenMutation, DeiStageActionCandidateReopenMutationVariables>(DeiStageActionCandidateReopenDocument, options);
      }
export type DeiStageActionCandidateReopenMutationHookResult = ReturnType<typeof useDeiStageActionCandidateReopenMutation>;
export type DeiStageActionCandidateReopenMutationResult = Apollo.MutationResult<DeiStageActionCandidateReopenMutation>;
export type DeiStageActionCandidateReopenMutationOptions = Apollo.BaseMutationOptions<DeiStageActionCandidateReopenMutation, DeiStageActionCandidateReopenMutationVariables>;
export const DeiStageActionCandidateClearAllForCandidateDocument = gql`
    mutation DeiStageActionCandidateClearAllForCandidate($userId: Int!) {
  DeiStageActionCandidateClearAllForCandidate(userId: $userId)
}
    `;
export type DeiStageActionCandidateClearAllForCandidateMutationFn = Apollo.MutationFunction<DeiStageActionCandidateClearAllForCandidateMutation, DeiStageActionCandidateClearAllForCandidateMutationVariables>;

/**
 * __useDeiStageActionCandidateClearAllForCandidateMutation__
 *
 * To run a mutation, you first call `useDeiStageActionCandidateClearAllForCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeiStageActionCandidateClearAllForCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deiStageActionCandidateClearAllForCandidateMutation, { data, loading, error }] = useDeiStageActionCandidateClearAllForCandidateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeiStageActionCandidateClearAllForCandidateMutation(baseOptions?: Apollo.MutationHookOptions<DeiStageActionCandidateClearAllForCandidateMutation, DeiStageActionCandidateClearAllForCandidateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeiStageActionCandidateClearAllForCandidateMutation, DeiStageActionCandidateClearAllForCandidateMutationVariables>(DeiStageActionCandidateClearAllForCandidateDocument, options);
      }
export type DeiStageActionCandidateClearAllForCandidateMutationHookResult = ReturnType<typeof useDeiStageActionCandidateClearAllForCandidateMutation>;
export type DeiStageActionCandidateClearAllForCandidateMutationResult = Apollo.MutationResult<DeiStageActionCandidateClearAllForCandidateMutation>;
export type DeiStageActionCandidateClearAllForCandidateMutationOptions = Apollo.BaseMutationOptions<DeiStageActionCandidateClearAllForCandidateMutation, DeiStageActionCandidateClearAllForCandidateMutationVariables>;
export const DeiStageActionCandidateRevokeConsentDocument = gql`
    mutation DeiStageActionCandidateRevokeConsent($stageCandidateId: Int!) {
  DeiStageActionCandidateRevokeConsent(stageCandidateId: $stageCandidateId) {
    ...DeiStageActionCandidate
  }
}
    ${DeiStageActionCandidateFragmentDoc}`;
export type DeiStageActionCandidateRevokeConsentMutationFn = Apollo.MutationFunction<DeiStageActionCandidateRevokeConsentMutation, DeiStageActionCandidateRevokeConsentMutationVariables>;

/**
 * __useDeiStageActionCandidateRevokeConsentMutation__
 *
 * To run a mutation, you first call `useDeiStageActionCandidateRevokeConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeiStageActionCandidateRevokeConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deiStageActionCandidateRevokeConsentMutation, { data, loading, error }] = useDeiStageActionCandidateRevokeConsentMutation({
 *   variables: {
 *      stageCandidateId: // value for 'stageCandidateId'
 *   },
 * });
 */
export function useDeiStageActionCandidateRevokeConsentMutation(baseOptions?: Apollo.MutationHookOptions<DeiStageActionCandidateRevokeConsentMutation, DeiStageActionCandidateRevokeConsentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeiStageActionCandidateRevokeConsentMutation, DeiStageActionCandidateRevokeConsentMutationVariables>(DeiStageActionCandidateRevokeConsentDocument, options);
      }
export type DeiStageActionCandidateRevokeConsentMutationHookResult = ReturnType<typeof useDeiStageActionCandidateRevokeConsentMutation>;
export type DeiStageActionCandidateRevokeConsentMutationResult = Apollo.MutationResult<DeiStageActionCandidateRevokeConsentMutation>;
export type DeiStageActionCandidateRevokeConsentMutationOptions = Apollo.BaseMutationOptions<DeiStageActionCandidateRevokeConsentMutation, DeiStageActionCandidateRevokeConsentMutationVariables>;
export const UpdateStageScoringConfigDocument = gql`
    mutation UpdateStageScoringConfig($stageId: Int!, $components: [StageScoringComponentConfigInput!]!) {
  updateStageScoringConfig(stageId: $stageId, components: $components) {
    id
    scoringConfig {
      version
      components {
        component
        kind
        weight
        threshold
      }
    }
  }
}
    `;
export type UpdateStageScoringConfigMutationFn = Apollo.MutationFunction<UpdateStageScoringConfigMutation, UpdateStageScoringConfigMutationVariables>;

/**
 * __useUpdateStageScoringConfigMutation__
 *
 * To run a mutation, you first call `useUpdateStageScoringConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStageScoringConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStageScoringConfigMutation, { data, loading, error }] = useUpdateStageScoringConfigMutation({
 *   variables: {
 *      stageId: // value for 'stageId'
 *      components: // value for 'components'
 *   },
 * });
 */
export function useUpdateStageScoringConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStageScoringConfigMutation, UpdateStageScoringConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStageScoringConfigMutation, UpdateStageScoringConfigMutationVariables>(UpdateStageScoringConfigDocument, options);
      }
export type UpdateStageScoringConfigMutationHookResult = ReturnType<typeof useUpdateStageScoringConfigMutation>;
export type UpdateStageScoringConfigMutationResult = Apollo.MutationResult<UpdateStageScoringConfigMutation>;
export type UpdateStageScoringConfigMutationOptions = Apollo.BaseMutationOptions<UpdateStageScoringConfigMutation, UpdateStageScoringConfigMutationVariables>;
export const UpdateSuccessProfileDocument = gql`
    mutation UpdateSuccessProfile($id: Int!, $calculationMethod: CalculationMethod!, $gradingMethod: GradingMethod!) {
  successProfile: SuccessProfileUpdateOne(
    id: $id
    calculationMethod: $calculationMethod
    gradingMethod: $gradingMethod
  ) {
    ...SuccessProfile
  }
}
    ${SuccessProfileFragmentDoc}`;
export type UpdateSuccessProfileMutationFn = Apollo.MutationFunction<UpdateSuccessProfileMutation, UpdateSuccessProfileMutationVariables>;

/**
 * __useUpdateSuccessProfileMutation__
 *
 * To run a mutation, you first call `useUpdateSuccessProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSuccessProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSuccessProfileMutation, { data, loading, error }] = useUpdateSuccessProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *      calculationMethod: // value for 'calculationMethod'
 *      gradingMethod: // value for 'gradingMethod'
 *   },
 * });
 */
export function useUpdateSuccessProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSuccessProfileMutation, UpdateSuccessProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSuccessProfileMutation, UpdateSuccessProfileMutationVariables>(UpdateSuccessProfileDocument, options);
      }
export type UpdateSuccessProfileMutationHookResult = ReturnType<typeof useUpdateSuccessProfileMutation>;
export type UpdateSuccessProfileMutationResult = Apollo.MutationResult<UpdateSuccessProfileMutation>;
export type UpdateSuccessProfileMutationOptions = Apollo.BaseMutationOptions<UpdateSuccessProfileMutation, UpdateSuccessProfileMutationVariables>;
export const CreateSuccessProfileDocument = gql`
    mutation CreateSuccessProfile($calculationMethod: CalculationMethod!, $gradingMethod: GradingMethod!, $jobRoleId: Int!) {
  successProfile: SuccessProfileCreateOne(
    calculationMethod: $calculationMethod
    gradingMethod: $gradingMethod
    jobRoleId: $jobRoleId
  ) {
    ...SuccessProfile
  }
}
    ${SuccessProfileFragmentDoc}`;
export type CreateSuccessProfileMutationFn = Apollo.MutationFunction<CreateSuccessProfileMutation, CreateSuccessProfileMutationVariables>;

/**
 * __useCreateSuccessProfileMutation__
 *
 * To run a mutation, you first call `useCreateSuccessProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSuccessProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSuccessProfileMutation, { data, loading, error }] = useCreateSuccessProfileMutation({
 *   variables: {
 *      calculationMethod: // value for 'calculationMethod'
 *      gradingMethod: // value for 'gradingMethod'
 *      jobRoleId: // value for 'jobRoleId'
 *   },
 * });
 */
export function useCreateSuccessProfileMutation(baseOptions?: Apollo.MutationHookOptions<CreateSuccessProfileMutation, CreateSuccessProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSuccessProfileMutation, CreateSuccessProfileMutationVariables>(CreateSuccessProfileDocument, options);
      }
export type CreateSuccessProfileMutationHookResult = ReturnType<typeof useCreateSuccessProfileMutation>;
export type CreateSuccessProfileMutationResult = Apollo.MutationResult<CreateSuccessProfileMutation>;
export type CreateSuccessProfileMutationOptions = Apollo.BaseMutationOptions<CreateSuccessProfileMutation, CreateSuccessProfileMutationVariables>;
export const SuccessProfileSoftSkillsOverwriteDocument = gql`
    mutation SuccessProfileSoftSkillsOverwrite($id: Int!, $softSkills: [SuccessProfileSoftSkillCreateOneArgs!]!) {
  SuccessProfileSoftSkillsOverwrite(id: $id, softSkills: $softSkills) {
    id
    successProfileSoftSkills {
      id
      softSkillId
      weight
    }
  }
}
    `;
export type SuccessProfileSoftSkillsOverwriteMutationFn = Apollo.MutationFunction<SuccessProfileSoftSkillsOverwriteMutation, SuccessProfileSoftSkillsOverwriteMutationVariables>;

/**
 * __useSuccessProfileSoftSkillsOverwriteMutation__
 *
 * To run a mutation, you first call `useSuccessProfileSoftSkillsOverwriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuccessProfileSoftSkillsOverwriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [successProfileSoftSkillsOverwriteMutation, { data, loading, error }] = useSuccessProfileSoftSkillsOverwriteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      softSkills: // value for 'softSkills'
 *   },
 * });
 */
export function useSuccessProfileSoftSkillsOverwriteMutation(baseOptions?: Apollo.MutationHookOptions<SuccessProfileSoftSkillsOverwriteMutation, SuccessProfileSoftSkillsOverwriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuccessProfileSoftSkillsOverwriteMutation, SuccessProfileSoftSkillsOverwriteMutationVariables>(SuccessProfileSoftSkillsOverwriteDocument, options);
      }
export type SuccessProfileSoftSkillsOverwriteMutationHookResult = ReturnType<typeof useSuccessProfileSoftSkillsOverwriteMutation>;
export type SuccessProfileSoftSkillsOverwriteMutationResult = Apollo.MutationResult<SuccessProfileSoftSkillsOverwriteMutation>;
export type SuccessProfileSoftSkillsOverwriteMutationOptions = Apollo.BaseMutationOptions<SuccessProfileSoftSkillsOverwriteMutation, SuccessProfileSoftSkillsOverwriteMutationVariables>;
export const SuccessProfileTechnicalSkillsOverwriteDocument = gql`
    mutation SuccessProfileTechnicalSkillsOverwrite($id: Int!, $technicalSkills: [SuccessProfileTechnicalSkillCreateOneArgs!]!) {
  SuccessProfileTechnicalSkillsOverwrite(
    id: $id
    technicalSkills: $technicalSkills
  ) {
    id
    successProfileTechnicalSkills {
      id
      technicalSkillId
      successProfileId
    }
  }
}
    `;
export type SuccessProfileTechnicalSkillsOverwriteMutationFn = Apollo.MutationFunction<SuccessProfileTechnicalSkillsOverwriteMutation, SuccessProfileTechnicalSkillsOverwriteMutationVariables>;

/**
 * __useSuccessProfileTechnicalSkillsOverwriteMutation__
 *
 * To run a mutation, you first call `useSuccessProfileTechnicalSkillsOverwriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuccessProfileTechnicalSkillsOverwriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [successProfileTechnicalSkillsOverwriteMutation, { data, loading, error }] = useSuccessProfileTechnicalSkillsOverwriteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      technicalSkills: // value for 'technicalSkills'
 *   },
 * });
 */
export function useSuccessProfileTechnicalSkillsOverwriteMutation(baseOptions?: Apollo.MutationHookOptions<SuccessProfileTechnicalSkillsOverwriteMutation, SuccessProfileTechnicalSkillsOverwriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuccessProfileTechnicalSkillsOverwriteMutation, SuccessProfileTechnicalSkillsOverwriteMutationVariables>(SuccessProfileTechnicalSkillsOverwriteDocument, options);
      }
export type SuccessProfileTechnicalSkillsOverwriteMutationHookResult = ReturnType<typeof useSuccessProfileTechnicalSkillsOverwriteMutation>;
export type SuccessProfileTechnicalSkillsOverwriteMutationResult = Apollo.MutationResult<SuccessProfileTechnicalSkillsOverwriteMutation>;
export type SuccessProfileTechnicalSkillsOverwriteMutationOptions = Apollo.BaseMutationOptions<SuccessProfileTechnicalSkillsOverwriteMutation, SuccessProfileTechnicalSkillsOverwriteMutationVariables>;
export const TechnicalSkillCreateOneDocument = gql`
    mutation TechnicalSkillCreateOne($name: String!, $iconBlobId: Int, $skillCategoryId: Int, $companyId: Int, $description: String) {
  TechnicalSkillCreateOne(
    name: $name
    iconBlobId: $iconBlobId
    skillCategoryId: $skillCategoryId
    companyId: $companyId
    description: $description
  ) {
    ...TechnicalSkill
  }
}
    ${TechnicalSkillFragmentDoc}`;
export type TechnicalSkillCreateOneMutationFn = Apollo.MutationFunction<TechnicalSkillCreateOneMutation, TechnicalSkillCreateOneMutationVariables>;

/**
 * __useTechnicalSkillCreateOneMutation__
 *
 * To run a mutation, you first call `useTechnicalSkillCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTechnicalSkillCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [technicalSkillCreateOneMutation, { data, loading, error }] = useTechnicalSkillCreateOneMutation({
 *   variables: {
 *      name: // value for 'name'
 *      iconBlobId: // value for 'iconBlobId'
 *      skillCategoryId: // value for 'skillCategoryId'
 *      companyId: // value for 'companyId'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useTechnicalSkillCreateOneMutation(baseOptions?: Apollo.MutationHookOptions<TechnicalSkillCreateOneMutation, TechnicalSkillCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TechnicalSkillCreateOneMutation, TechnicalSkillCreateOneMutationVariables>(TechnicalSkillCreateOneDocument, options);
      }
export type TechnicalSkillCreateOneMutationHookResult = ReturnType<typeof useTechnicalSkillCreateOneMutation>;
export type TechnicalSkillCreateOneMutationResult = Apollo.MutationResult<TechnicalSkillCreateOneMutation>;
export type TechnicalSkillCreateOneMutationOptions = Apollo.BaseMutationOptions<TechnicalSkillCreateOneMutation, TechnicalSkillCreateOneMutationVariables>;
export const TechnicalSkillIconUploadDocument = gql`
    mutation TechnicalSkillIconUpload($id: Int!, $file: Upload!) {
  TechnicalSkillIconUpload(id: $id, file: $file)
}
    `;
export type TechnicalSkillIconUploadMutationFn = Apollo.MutationFunction<TechnicalSkillIconUploadMutation, TechnicalSkillIconUploadMutationVariables>;

/**
 * __useTechnicalSkillIconUploadMutation__
 *
 * To run a mutation, you first call `useTechnicalSkillIconUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTechnicalSkillIconUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [technicalSkillIconUploadMutation, { data, loading, error }] = useTechnicalSkillIconUploadMutation({
 *   variables: {
 *      id: // value for 'id'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useTechnicalSkillIconUploadMutation(baseOptions?: Apollo.MutationHookOptions<TechnicalSkillIconUploadMutation, TechnicalSkillIconUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TechnicalSkillIconUploadMutation, TechnicalSkillIconUploadMutationVariables>(TechnicalSkillIconUploadDocument, options);
      }
export type TechnicalSkillIconUploadMutationHookResult = ReturnType<typeof useTechnicalSkillIconUploadMutation>;
export type TechnicalSkillIconUploadMutationResult = Apollo.MutationResult<TechnicalSkillIconUploadMutation>;
export type TechnicalSkillIconUploadMutationOptions = Apollo.BaseMutationOptions<TechnicalSkillIconUploadMutation, TechnicalSkillIconUploadMutationVariables>;
export const TechnicalSkillSoftDeleteDocument = gql`
    mutation TechnicalSkillSoftDelete($subId: ID!) {
  TechnicalSkillSoftDelete(subId: $subId) {
    ...TechnicalSkill
  }
}
    ${TechnicalSkillFragmentDoc}`;
export type TechnicalSkillSoftDeleteMutationFn = Apollo.MutationFunction<TechnicalSkillSoftDeleteMutation, TechnicalSkillSoftDeleteMutationVariables>;

/**
 * __useTechnicalSkillSoftDeleteMutation__
 *
 * To run a mutation, you first call `useTechnicalSkillSoftDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTechnicalSkillSoftDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [technicalSkillSoftDeleteMutation, { data, loading, error }] = useTechnicalSkillSoftDeleteMutation({
 *   variables: {
 *      subId: // value for 'subId'
 *   },
 * });
 */
export function useTechnicalSkillSoftDeleteMutation(baseOptions?: Apollo.MutationHookOptions<TechnicalSkillSoftDeleteMutation, TechnicalSkillSoftDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TechnicalSkillSoftDeleteMutation, TechnicalSkillSoftDeleteMutationVariables>(TechnicalSkillSoftDeleteDocument, options);
      }
export type TechnicalSkillSoftDeleteMutationHookResult = ReturnType<typeof useTechnicalSkillSoftDeleteMutation>;
export type TechnicalSkillSoftDeleteMutationResult = Apollo.MutationResult<TechnicalSkillSoftDeleteMutation>;
export type TechnicalSkillSoftDeleteMutationOptions = Apollo.BaseMutationOptions<TechnicalSkillSoftDeleteMutation, TechnicalSkillSoftDeleteMutationVariables>;
export const TechnicalSkillRestoreDocument = gql`
    mutation TechnicalSkillRestore($subId: ID!) {
  TechnicalSkillRestore(subId: $subId) {
    ...TechnicalSkill
  }
}
    ${TechnicalSkillFragmentDoc}`;
export type TechnicalSkillRestoreMutationFn = Apollo.MutationFunction<TechnicalSkillRestoreMutation, TechnicalSkillRestoreMutationVariables>;

/**
 * __useTechnicalSkillRestoreMutation__
 *
 * To run a mutation, you first call `useTechnicalSkillRestoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTechnicalSkillRestoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [technicalSkillRestoreMutation, { data, loading, error }] = useTechnicalSkillRestoreMutation({
 *   variables: {
 *      subId: // value for 'subId'
 *   },
 * });
 */
export function useTechnicalSkillRestoreMutation(baseOptions?: Apollo.MutationHookOptions<TechnicalSkillRestoreMutation, TechnicalSkillRestoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TechnicalSkillRestoreMutation, TechnicalSkillRestoreMutationVariables>(TechnicalSkillRestoreDocument, options);
      }
export type TechnicalSkillRestoreMutationHookResult = ReturnType<typeof useTechnicalSkillRestoreMutation>;
export type TechnicalSkillRestoreMutationResult = Apollo.MutationResult<TechnicalSkillRestoreMutation>;
export type TechnicalSkillRestoreMutationOptions = Apollo.BaseMutationOptions<TechnicalSkillRestoreMutation, TechnicalSkillRestoreMutationVariables>;
export const TechnicalSkillUpdateDocument = gql`
    mutation TechnicalSkillUpdate($subId: ID!, $args: TechnicalSkillUpdateArgs!) {
  TechnicalSkillUpdate(subId: $subId, args: $args) {
    ...TechnicalSkill
  }
}
    ${TechnicalSkillFragmentDoc}`;
export type TechnicalSkillUpdateMutationFn = Apollo.MutationFunction<TechnicalSkillUpdateMutation, TechnicalSkillUpdateMutationVariables>;

/**
 * __useTechnicalSkillUpdateMutation__
 *
 * To run a mutation, you first call `useTechnicalSkillUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTechnicalSkillUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [technicalSkillUpdateMutation, { data, loading, error }] = useTechnicalSkillUpdateMutation({
 *   variables: {
 *      subId: // value for 'subId'
 *      args: // value for 'args'
 *   },
 * });
 */
export function useTechnicalSkillUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TechnicalSkillUpdateMutation, TechnicalSkillUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TechnicalSkillUpdateMutation, TechnicalSkillUpdateMutationVariables>(TechnicalSkillUpdateDocument, options);
      }
export type TechnicalSkillUpdateMutationHookResult = ReturnType<typeof useTechnicalSkillUpdateMutation>;
export type TechnicalSkillUpdateMutationResult = Apollo.MutationResult<TechnicalSkillUpdateMutation>;
export type TechnicalSkillUpdateMutationOptions = Apollo.BaseMutationOptions<TechnicalSkillUpdateMutation, TechnicalSkillUpdateMutationVariables>;
export const ResetCognitiveTestDocument = gql`
    mutation ResetCognitiveTest($id: ID!) {
  resetCognitiveTest(id: $id) {
    id
    status
    assessmentId
  }
}
    `;
export type ResetCognitiveTestMutationFn = Apollo.MutationFunction<ResetCognitiveTestMutation, ResetCognitiveTestMutationVariables>;

/**
 * __useResetCognitiveTestMutation__
 *
 * To run a mutation, you first call `useResetCognitiveTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetCognitiveTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetCognitiveTestMutation, { data, loading, error }] = useResetCognitiveTestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResetCognitiveTestMutation(baseOptions?: Apollo.MutationHookOptions<ResetCognitiveTestMutation, ResetCognitiveTestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetCognitiveTestMutation, ResetCognitiveTestMutationVariables>(ResetCognitiveTestDocument, options);
      }
export type ResetCognitiveTestMutationHookResult = ReturnType<typeof useResetCognitiveTestMutation>;
export type ResetCognitiveTestMutationResult = Apollo.MutationResult<ResetCognitiveTestMutation>;
export type ResetCognitiveTestMutationOptions = Apollo.BaseMutationOptions<ResetCognitiveTestMutation, ResetCognitiveTestMutationVariables>;
export const ResetPersonalityTestDocument = gql`
    mutation ResetPersonalityTest($id: ID!) {
  resetPersonalityTest(id: $id) {
    id
    status
    assessmentId
  }
}
    `;
export type ResetPersonalityTestMutationFn = Apollo.MutationFunction<ResetPersonalityTestMutation, ResetPersonalityTestMutationVariables>;

/**
 * __useResetPersonalityTestMutation__
 *
 * To run a mutation, you first call `useResetPersonalityTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPersonalityTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPersonalityTestMutation, { data, loading, error }] = useResetPersonalityTestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResetPersonalityTestMutation(baseOptions?: Apollo.MutationHookOptions<ResetPersonalityTestMutation, ResetPersonalityTestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPersonalityTestMutation, ResetPersonalityTestMutationVariables>(ResetPersonalityTestDocument, options);
      }
export type ResetPersonalityTestMutationHookResult = ReturnType<typeof useResetPersonalityTestMutation>;
export type ResetPersonalityTestMutationResult = Apollo.MutationResult<ResetPersonalityTestMutation>;
export type ResetPersonalityTestMutationOptions = Apollo.BaseMutationOptions<ResetPersonalityTestMutation, ResetPersonalityTestMutationVariables>;
export const UpdateCognitiveTestTimeAllowanceDocument = gql`
    mutation UpdateCognitiveTestTimeAllowance($id: ID!, $timeModifierPercentage: Float!) {
  updateCognitiveTestTimeAllowance(
    id: $id
    timeModifierPercentage: $timeModifierPercentage
  ) {
    id
    timeModifierPercentage
  }
}
    `;
export type UpdateCognitiveTestTimeAllowanceMutationFn = Apollo.MutationFunction<UpdateCognitiveTestTimeAllowanceMutation, UpdateCognitiveTestTimeAllowanceMutationVariables>;

/**
 * __useUpdateCognitiveTestTimeAllowanceMutation__
 *
 * To run a mutation, you first call `useUpdateCognitiveTestTimeAllowanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCognitiveTestTimeAllowanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCognitiveTestTimeAllowanceMutation, { data, loading, error }] = useUpdateCognitiveTestTimeAllowanceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      timeModifierPercentage: // value for 'timeModifierPercentage'
 *   },
 * });
 */
export function useUpdateCognitiveTestTimeAllowanceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCognitiveTestTimeAllowanceMutation, UpdateCognitiveTestTimeAllowanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCognitiveTestTimeAllowanceMutation, UpdateCognitiveTestTimeAllowanceMutationVariables>(UpdateCognitiveTestTimeAllowanceDocument, options);
      }
export type UpdateCognitiveTestTimeAllowanceMutationHookResult = ReturnType<typeof useUpdateCognitiveTestTimeAllowanceMutation>;
export type UpdateCognitiveTestTimeAllowanceMutationResult = Apollo.MutationResult<UpdateCognitiveTestTimeAllowanceMutation>;
export type UpdateCognitiveTestTimeAllowanceMutationOptions = Apollo.BaseMutationOptions<UpdateCognitiveTestTimeAllowanceMutation, UpdateCognitiveTestTimeAllowanceMutationVariables>;
export const ResetCoderbyteAssessmentDocument = gql`
    mutation ResetCoderbyteAssessment($id: ID!) {
  resetCoderbyteAssessment(id: $id) {
    id
    status
  }
}
    `;
export type ResetCoderbyteAssessmentMutationFn = Apollo.MutationFunction<ResetCoderbyteAssessmentMutation, ResetCoderbyteAssessmentMutationVariables>;

/**
 * __useResetCoderbyteAssessmentMutation__
 *
 * To run a mutation, you first call `useResetCoderbyteAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetCoderbyteAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetCoderbyteAssessmentMutation, { data, loading, error }] = useResetCoderbyteAssessmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResetCoderbyteAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<ResetCoderbyteAssessmentMutation, ResetCoderbyteAssessmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetCoderbyteAssessmentMutation, ResetCoderbyteAssessmentMutationVariables>(ResetCoderbyteAssessmentDocument, options);
      }
export type ResetCoderbyteAssessmentMutationHookResult = ReturnType<typeof useResetCoderbyteAssessmentMutation>;
export type ResetCoderbyteAssessmentMutationResult = Apollo.MutationResult<ResetCoderbyteAssessmentMutation>;
export type ResetCoderbyteAssessmentMutationOptions = Apollo.BaseMutationOptions<ResetCoderbyteAssessmentMutation, ResetCoderbyteAssessmentMutationVariables>;
export const ResetEnglishProficiencyAssessmentDocument = gql`
    mutation ResetEnglishProficiencyAssessment($id: ID!) {
  resetEnglishProficiencyAssessment(id: $id) {
    id
    status
    assessmentId
  }
}
    `;
export type ResetEnglishProficiencyAssessmentMutationFn = Apollo.MutationFunction<ResetEnglishProficiencyAssessmentMutation, ResetEnglishProficiencyAssessmentMutationVariables>;

/**
 * __useResetEnglishProficiencyAssessmentMutation__
 *
 * To run a mutation, you first call `useResetEnglishProficiencyAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetEnglishProficiencyAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetEnglishProficiencyAssessmentMutation, { data, loading, error }] = useResetEnglishProficiencyAssessmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResetEnglishProficiencyAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<ResetEnglishProficiencyAssessmentMutation, ResetEnglishProficiencyAssessmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetEnglishProficiencyAssessmentMutation, ResetEnglishProficiencyAssessmentMutationVariables>(ResetEnglishProficiencyAssessmentDocument, options);
      }
export type ResetEnglishProficiencyAssessmentMutationHookResult = ReturnType<typeof useResetEnglishProficiencyAssessmentMutation>;
export type ResetEnglishProficiencyAssessmentMutationResult = Apollo.MutationResult<ResetEnglishProficiencyAssessmentMutation>;
export type ResetEnglishProficiencyAssessmentMutationOptions = Apollo.BaseMutationOptions<ResetEnglishProficiencyAssessmentMutation, ResetEnglishProficiencyAssessmentMutationVariables>;
export const UpdateCoderbyteAssessmentTimeAllowanceDocument = gql`
    mutation UpdateCoderbyteAssessmentTimeAllowance($id: ID!, $timeModifierPercentage: Float!) {
  updateCoderbyteAssessmentTimeAllowance(
    id: $id
    timeModifierPercentage: $timeModifierPercentage
  ) {
    id
    timeModifierPercentage
  }
}
    `;
export type UpdateCoderbyteAssessmentTimeAllowanceMutationFn = Apollo.MutationFunction<UpdateCoderbyteAssessmentTimeAllowanceMutation, UpdateCoderbyteAssessmentTimeAllowanceMutationVariables>;

/**
 * __useUpdateCoderbyteAssessmentTimeAllowanceMutation__
 *
 * To run a mutation, you first call `useUpdateCoderbyteAssessmentTimeAllowanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoderbyteAssessmentTimeAllowanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoderbyteAssessmentTimeAllowanceMutation, { data, loading, error }] = useUpdateCoderbyteAssessmentTimeAllowanceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      timeModifierPercentage: // value for 'timeModifierPercentage'
 *   },
 * });
 */
export function useUpdateCoderbyteAssessmentTimeAllowanceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCoderbyteAssessmentTimeAllowanceMutation, UpdateCoderbyteAssessmentTimeAllowanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCoderbyteAssessmentTimeAllowanceMutation, UpdateCoderbyteAssessmentTimeAllowanceMutationVariables>(UpdateCoderbyteAssessmentTimeAllowanceDocument, options);
      }
export type UpdateCoderbyteAssessmentTimeAllowanceMutationHookResult = ReturnType<typeof useUpdateCoderbyteAssessmentTimeAllowanceMutation>;
export type UpdateCoderbyteAssessmentTimeAllowanceMutationResult = Apollo.MutationResult<UpdateCoderbyteAssessmentTimeAllowanceMutation>;
export type UpdateCoderbyteAssessmentTimeAllowanceMutationOptions = Apollo.BaseMutationOptions<UpdateCoderbyteAssessmentTimeAllowanceMutation, UpdateCoderbyteAssessmentTimeAllowanceMutationVariables>;
export const AddPersonalityTestToAssessmentStageDocument = gql`
    mutation AddPersonalityTestToAssessmentStage($stageId: ID!, $questionsPerTraitCount: Int, $selectedLocales: [SupportedLocale!]) {
  addPersonalityTestToAssessmentStage(
    stageId: $stageId
    questionsPerTraitCount: $questionsPerTraitCount
    selectedLocales: $selectedLocales
  ) {
    id
    questionsPerTraitCount
    selectedLocales
  }
}
    `;
export type AddPersonalityTestToAssessmentStageMutationFn = Apollo.MutationFunction<AddPersonalityTestToAssessmentStageMutation, AddPersonalityTestToAssessmentStageMutationVariables>;

/**
 * __useAddPersonalityTestToAssessmentStageMutation__
 *
 * To run a mutation, you first call `useAddPersonalityTestToAssessmentStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPersonalityTestToAssessmentStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPersonalityTestToAssessmentStageMutation, { data, loading, error }] = useAddPersonalityTestToAssessmentStageMutation({
 *   variables: {
 *      stageId: // value for 'stageId'
 *      questionsPerTraitCount: // value for 'questionsPerTraitCount'
 *      selectedLocales: // value for 'selectedLocales'
 *   },
 * });
 */
export function useAddPersonalityTestToAssessmentStageMutation(baseOptions?: Apollo.MutationHookOptions<AddPersonalityTestToAssessmentStageMutation, AddPersonalityTestToAssessmentStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPersonalityTestToAssessmentStageMutation, AddPersonalityTestToAssessmentStageMutationVariables>(AddPersonalityTestToAssessmentStageDocument, options);
      }
export type AddPersonalityTestToAssessmentStageMutationHookResult = ReturnType<typeof useAddPersonalityTestToAssessmentStageMutation>;
export type AddPersonalityTestToAssessmentStageMutationResult = Apollo.MutationResult<AddPersonalityTestToAssessmentStageMutation>;
export type AddPersonalityTestToAssessmentStageMutationOptions = Apollo.BaseMutationOptions<AddPersonalityTestToAssessmentStageMutation, AddPersonalityTestToAssessmentStageMutationVariables>;
export const AddCognitiveTestToAssessmentStageDocument = gql`
    mutation AddCognitiveTestToAssessmentStage($stageId: ID!, $kind: CognitiveKind!) {
  addCognitiveTestToAssessmentStage(stageId: $stageId, kind: $kind) {
    id
    kind
    sectionCount
  }
}
    `;
export type AddCognitiveTestToAssessmentStageMutationFn = Apollo.MutationFunction<AddCognitiveTestToAssessmentStageMutation, AddCognitiveTestToAssessmentStageMutationVariables>;

/**
 * __useAddCognitiveTestToAssessmentStageMutation__
 *
 * To run a mutation, you first call `useAddCognitiveTestToAssessmentStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCognitiveTestToAssessmentStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCognitiveTestToAssessmentStageMutation, { data, loading, error }] = useAddCognitiveTestToAssessmentStageMutation({
 *   variables: {
 *      stageId: // value for 'stageId'
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useAddCognitiveTestToAssessmentStageMutation(baseOptions?: Apollo.MutationHookOptions<AddCognitiveTestToAssessmentStageMutation, AddCognitiveTestToAssessmentStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCognitiveTestToAssessmentStageMutation, AddCognitiveTestToAssessmentStageMutationVariables>(AddCognitiveTestToAssessmentStageDocument, options);
      }
export type AddCognitiveTestToAssessmentStageMutationHookResult = ReturnType<typeof useAddCognitiveTestToAssessmentStageMutation>;
export type AddCognitiveTestToAssessmentStageMutationResult = Apollo.MutationResult<AddCognitiveTestToAssessmentStageMutation>;
export type AddCognitiveTestToAssessmentStageMutationOptions = Apollo.BaseMutationOptions<AddCognitiveTestToAssessmentStageMutation, AddCognitiveTestToAssessmentStageMutationVariables>;
export const RemovePersonalityTestFromAssessmentStageDocument = gql`
    mutation RemovePersonalityTestFromAssessmentStage($id: ID!) {
  removePersonalityTestFromAssessmentStage(id: $id)
}
    `;
export type RemovePersonalityTestFromAssessmentStageMutationFn = Apollo.MutationFunction<RemovePersonalityTestFromAssessmentStageMutation, RemovePersonalityTestFromAssessmentStageMutationVariables>;

/**
 * __useRemovePersonalityTestFromAssessmentStageMutation__
 *
 * To run a mutation, you first call `useRemovePersonalityTestFromAssessmentStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePersonalityTestFromAssessmentStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePersonalityTestFromAssessmentStageMutation, { data, loading, error }] = useRemovePersonalityTestFromAssessmentStageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemovePersonalityTestFromAssessmentStageMutation(baseOptions?: Apollo.MutationHookOptions<RemovePersonalityTestFromAssessmentStageMutation, RemovePersonalityTestFromAssessmentStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePersonalityTestFromAssessmentStageMutation, RemovePersonalityTestFromAssessmentStageMutationVariables>(RemovePersonalityTestFromAssessmentStageDocument, options);
      }
export type RemovePersonalityTestFromAssessmentStageMutationHookResult = ReturnType<typeof useRemovePersonalityTestFromAssessmentStageMutation>;
export type RemovePersonalityTestFromAssessmentStageMutationResult = Apollo.MutationResult<RemovePersonalityTestFromAssessmentStageMutation>;
export type RemovePersonalityTestFromAssessmentStageMutationOptions = Apollo.BaseMutationOptions<RemovePersonalityTestFromAssessmentStageMutation, RemovePersonalityTestFromAssessmentStageMutationVariables>;
export const RemoveCognitiveTestFromAssessmentStageDocument = gql`
    mutation RemoveCognitiveTestFromAssessmentStage($id: ID!) {
  removeCognitiveTestFromAssessmentStage(id: $id)
}
    `;
export type RemoveCognitiveTestFromAssessmentStageMutationFn = Apollo.MutationFunction<RemoveCognitiveTestFromAssessmentStageMutation, RemoveCognitiveTestFromAssessmentStageMutationVariables>;

/**
 * __useRemoveCognitiveTestFromAssessmentStageMutation__
 *
 * To run a mutation, you first call `useRemoveCognitiveTestFromAssessmentStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCognitiveTestFromAssessmentStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCognitiveTestFromAssessmentStageMutation, { data, loading, error }] = useRemoveCognitiveTestFromAssessmentStageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveCognitiveTestFromAssessmentStageMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCognitiveTestFromAssessmentStageMutation, RemoveCognitiveTestFromAssessmentStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCognitiveTestFromAssessmentStageMutation, RemoveCognitiveTestFromAssessmentStageMutationVariables>(RemoveCognitiveTestFromAssessmentStageDocument, options);
      }
export type RemoveCognitiveTestFromAssessmentStageMutationHookResult = ReturnType<typeof useRemoveCognitiveTestFromAssessmentStageMutation>;
export type RemoveCognitiveTestFromAssessmentStageMutationResult = Apollo.MutationResult<RemoveCognitiveTestFromAssessmentStageMutation>;
export type RemoveCognitiveTestFromAssessmentStageMutationOptions = Apollo.BaseMutationOptions<RemoveCognitiveTestFromAssessmentStageMutation, RemoveCognitiveTestFromAssessmentStageMutationVariables>;
export const UpdatePersonalityTestQuestionsPerTraitCountDocument = gql`
    mutation UpdatePersonalityTestQuestionsPerTraitCount($id: ID!, $questionsPerTraitCount: Int!) {
  updatePersonalityTestQuestionsPerTraitCount(
    id: $id
    questionsPerTraitCount: $questionsPerTraitCount
  ) {
    id
    questionsPerTraitCount
  }
}
    `;
export type UpdatePersonalityTestQuestionsPerTraitCountMutationFn = Apollo.MutationFunction<UpdatePersonalityTestQuestionsPerTraitCountMutation, UpdatePersonalityTestQuestionsPerTraitCountMutationVariables>;

/**
 * __useUpdatePersonalityTestQuestionsPerTraitCountMutation__
 *
 * To run a mutation, you first call `useUpdatePersonalityTestQuestionsPerTraitCountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonalityTestQuestionsPerTraitCountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonalityTestQuestionsPerTraitCountMutation, { data, loading, error }] = useUpdatePersonalityTestQuestionsPerTraitCountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      questionsPerTraitCount: // value for 'questionsPerTraitCount'
 *   },
 * });
 */
export function useUpdatePersonalityTestQuestionsPerTraitCountMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonalityTestQuestionsPerTraitCountMutation, UpdatePersonalityTestQuestionsPerTraitCountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonalityTestQuestionsPerTraitCountMutation, UpdatePersonalityTestQuestionsPerTraitCountMutationVariables>(UpdatePersonalityTestQuestionsPerTraitCountDocument, options);
      }
export type UpdatePersonalityTestQuestionsPerTraitCountMutationHookResult = ReturnType<typeof useUpdatePersonalityTestQuestionsPerTraitCountMutation>;
export type UpdatePersonalityTestQuestionsPerTraitCountMutationResult = Apollo.MutationResult<UpdatePersonalityTestQuestionsPerTraitCountMutation>;
export type UpdatePersonalityTestQuestionsPerTraitCountMutationOptions = Apollo.BaseMutationOptions<UpdatePersonalityTestQuestionsPerTraitCountMutation, UpdatePersonalityTestQuestionsPerTraitCountMutationVariables>;
export const UpdatePersonalityTestSelectedLocalesDocument = gql`
    mutation UpdatePersonalityTestSelectedLocales($id: ID!, $selectedLocales: [SupportedLocale!]!) {
  updatePersonalityTestSelectedLocales(id: $id, selectedLocales: $selectedLocales) {
    id
    selectedLocales
  }
}
    `;
export type UpdatePersonalityTestSelectedLocalesMutationFn = Apollo.MutationFunction<UpdatePersonalityTestSelectedLocalesMutation, UpdatePersonalityTestSelectedLocalesMutationVariables>;

/**
 * __useUpdatePersonalityTestSelectedLocalesMutation__
 *
 * To run a mutation, you first call `useUpdatePersonalityTestSelectedLocalesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonalityTestSelectedLocalesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonalityTestSelectedLocalesMutation, { data, loading, error }] = useUpdatePersonalityTestSelectedLocalesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      selectedLocales: // value for 'selectedLocales'
 *   },
 * });
 */
export function useUpdatePersonalityTestSelectedLocalesMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonalityTestSelectedLocalesMutation, UpdatePersonalityTestSelectedLocalesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonalityTestSelectedLocalesMutation, UpdatePersonalityTestSelectedLocalesMutationVariables>(UpdatePersonalityTestSelectedLocalesDocument, options);
      }
export type UpdatePersonalityTestSelectedLocalesMutationHookResult = ReturnType<typeof useUpdatePersonalityTestSelectedLocalesMutation>;
export type UpdatePersonalityTestSelectedLocalesMutationResult = Apollo.MutationResult<UpdatePersonalityTestSelectedLocalesMutation>;
export type UpdatePersonalityTestSelectedLocalesMutationOptions = Apollo.BaseMutationOptions<UpdatePersonalityTestSelectedLocalesMutation, UpdatePersonalityTestSelectedLocalesMutationVariables>;
export const UpdateCognitiveTestSectionCountDocument = gql`
    mutation UpdateCognitiveTestSectionCount($id: ID!, $sectionCount: Int!) {
  updateCognitiveTestSectionCount(id: $id, sectionCount: $sectionCount) {
    id
    sectionCount
  }
}
    `;
export type UpdateCognitiveTestSectionCountMutationFn = Apollo.MutationFunction<UpdateCognitiveTestSectionCountMutation, UpdateCognitiveTestSectionCountMutationVariables>;

/**
 * __useUpdateCognitiveTestSectionCountMutation__
 *
 * To run a mutation, you first call `useUpdateCognitiveTestSectionCountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCognitiveTestSectionCountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCognitiveTestSectionCountMutation, { data, loading, error }] = useUpdateCognitiveTestSectionCountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sectionCount: // value for 'sectionCount'
 *   },
 * });
 */
export function useUpdateCognitiveTestSectionCountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCognitiveTestSectionCountMutation, UpdateCognitiveTestSectionCountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCognitiveTestSectionCountMutation, UpdateCognitiveTestSectionCountMutationVariables>(UpdateCognitiveTestSectionCountDocument, options);
      }
export type UpdateCognitiveTestSectionCountMutationHookResult = ReturnType<typeof useUpdateCognitiveTestSectionCountMutation>;
export type UpdateCognitiveTestSectionCountMutationResult = Apollo.MutationResult<UpdateCognitiveTestSectionCountMutation>;
export type UpdateCognitiveTestSectionCountMutationOptions = Apollo.BaseMutationOptions<UpdateCognitiveTestSectionCountMutation, UpdateCognitiveTestSectionCountMutationVariables>;
export const RefreshCoderbyteAssessmentDetailsDocument = gql`
    mutation RefreshCoderbyteAssessmentDetails($id: ID!) {
  refreshCoderbyteAssessmentDetails(id: $id) {
    id
    details {
      timeLimitInMinutes
      isFrozen
      challengeCount
      multipleChoiceCount
    }
  }
}
    `;
export type RefreshCoderbyteAssessmentDetailsMutationFn = Apollo.MutationFunction<RefreshCoderbyteAssessmentDetailsMutation, RefreshCoderbyteAssessmentDetailsMutationVariables>;

/**
 * __useRefreshCoderbyteAssessmentDetailsMutation__
 *
 * To run a mutation, you first call `useRefreshCoderbyteAssessmentDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshCoderbyteAssessmentDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshCoderbyteAssessmentDetailsMutation, { data, loading, error }] = useRefreshCoderbyteAssessmentDetailsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRefreshCoderbyteAssessmentDetailsMutation(baseOptions?: Apollo.MutationHookOptions<RefreshCoderbyteAssessmentDetailsMutation, RefreshCoderbyteAssessmentDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshCoderbyteAssessmentDetailsMutation, RefreshCoderbyteAssessmentDetailsMutationVariables>(RefreshCoderbyteAssessmentDetailsDocument, options);
      }
export type RefreshCoderbyteAssessmentDetailsMutationHookResult = ReturnType<typeof useRefreshCoderbyteAssessmentDetailsMutation>;
export type RefreshCoderbyteAssessmentDetailsMutationResult = Apollo.MutationResult<RefreshCoderbyteAssessmentDetailsMutation>;
export type RefreshCoderbyteAssessmentDetailsMutationOptions = Apollo.BaseMutationOptions<RefreshCoderbyteAssessmentDetailsMutation, RefreshCoderbyteAssessmentDetailsMutationVariables>;
export const AddTraitDocument = gql`
    mutation AddTrait($name: String!, $description: String!) {
  Trait: TraitCreate(name: $name, description: $description) {
    ...Trait
  }
}
    ${TraitFragmentDoc}`;
export type AddTraitMutationFn = Apollo.MutationFunction<AddTraitMutation, AddTraitMutationVariables>;

/**
 * __useAddTraitMutation__
 *
 * To run a mutation, you first call `useAddTraitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTraitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTraitMutation, { data, loading, error }] = useAddTraitMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useAddTraitMutation(baseOptions?: Apollo.MutationHookOptions<AddTraitMutation, AddTraitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTraitMutation, AddTraitMutationVariables>(AddTraitDocument, options);
      }
export type AddTraitMutationHookResult = ReturnType<typeof useAddTraitMutation>;
export type AddTraitMutationResult = Apollo.MutationResult<AddTraitMutation>;
export type AddTraitMutationOptions = Apollo.BaseMutationOptions<AddTraitMutation, AddTraitMutationVariables>;
export const UpdateTraitDocument = gql`
    mutation UpdateTrait($id: Int!, $name: String!, $description: String!, $isArchived: Boolean!) {
  Trait: TraitUpdate(
    id: $id
    name: $name
    description: $description
    isArchived: $isArchived
  ) {
    ...Trait
  }
}
    ${TraitFragmentDoc}`;
export type UpdateTraitMutationFn = Apollo.MutationFunction<UpdateTraitMutation, UpdateTraitMutationVariables>;

/**
 * __useUpdateTraitMutation__
 *
 * To run a mutation, you first call `useUpdateTraitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTraitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTraitMutation, { data, loading, error }] = useUpdateTraitMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      isArchived: // value for 'isArchived'
 *   },
 * });
 */
export function useUpdateTraitMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTraitMutation, UpdateTraitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTraitMutation, UpdateTraitMutationVariables>(UpdateTraitDocument, options);
      }
export type UpdateTraitMutationHookResult = ReturnType<typeof useUpdateTraitMutation>;
export type UpdateTraitMutationResult = Apollo.MutationResult<UpdateTraitMutation>;
export type UpdateTraitMutationOptions = Apollo.BaseMutationOptions<UpdateTraitMutation, UpdateTraitMutationVariables>;
export const UpdateTraitTestTypesDocument = gql`
    mutation UpdateTraitTestTypes($dto: [TraitTestTypesUpdateOneArgs!]!) {
  traitTestTypes: TraitTestTypeReplaceMany(dto: $dto) {
    ...TraitTestType
  }
}
    ${TraitTestTypeFragmentDoc}`;
export type UpdateTraitTestTypesMutationFn = Apollo.MutationFunction<UpdateTraitTestTypesMutation, UpdateTraitTestTypesMutationVariables>;

/**
 * __useUpdateTraitTestTypesMutation__
 *
 * To run a mutation, you first call `useUpdateTraitTestTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTraitTestTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTraitTestTypesMutation, { data, loading, error }] = useUpdateTraitTestTypesMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useUpdateTraitTestTypesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTraitTestTypesMutation, UpdateTraitTestTypesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTraitTestTypesMutation, UpdateTraitTestTypesMutationVariables>(UpdateTraitTestTypesDocument, options);
      }
export type UpdateTraitTestTypesMutationHookResult = ReturnType<typeof useUpdateTraitTestTypesMutation>;
export type UpdateTraitTestTypesMutationResult = Apollo.MutationResult<UpdateTraitTestTypesMutation>;
export type UpdateTraitTestTypesMutationOptions = Apollo.BaseMutationOptions<UpdateTraitTestTypesMutation, UpdateTraitTestTypesMutationVariables>;
export const ArchiveTraitDocument = gql`
    mutation ArchiveTrait($id: Int!, $isArchived: Boolean!) {
  Trait: TraitUpdateIsArchived(id: $id, isArchived: $isArchived) {
    ...Trait
  }
}
    ${TraitFragmentDoc}`;
export type ArchiveTraitMutationFn = Apollo.MutationFunction<ArchiveTraitMutation, ArchiveTraitMutationVariables>;

/**
 * __useArchiveTraitMutation__
 *
 * To run a mutation, you first call `useArchiveTraitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveTraitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveTraitMutation, { data, loading, error }] = useArchiveTraitMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isArchived: // value for 'isArchived'
 *   },
 * });
 */
export function useArchiveTraitMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveTraitMutation, ArchiveTraitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveTraitMutation, ArchiveTraitMutationVariables>(ArchiveTraitDocument, options);
      }
export type ArchiveTraitMutationHookResult = ReturnType<typeof useArchiveTraitMutation>;
export type ArchiveTraitMutationResult = Apollo.MutationResult<ArchiveTraitMutation>;
export type ArchiveTraitMutationOptions = Apollo.BaseMutationOptions<ArchiveTraitMutation, ArchiveTraitMutationVariables>;
export const DeleteTraitDocument = gql`
    mutation DeleteTrait($id: Int!) {
  affected: TraitDelete(id: $id) {
    affected
  }
}
    `;
export type DeleteTraitMutationFn = Apollo.MutationFunction<DeleteTraitMutation, DeleteTraitMutationVariables>;

/**
 * __useDeleteTraitMutation__
 *
 * To run a mutation, you first call `useDeleteTraitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTraitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTraitMutation, { data, loading, error }] = useDeleteTraitMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTraitMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTraitMutation, DeleteTraitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTraitMutation, DeleteTraitMutationVariables>(DeleteTraitDocument, options);
      }
export type DeleteTraitMutationHookResult = ReturnType<typeof useDeleteTraitMutation>;
export type DeleteTraitMutationResult = Apollo.MutationResult<DeleteTraitMutation>;
export type DeleteTraitMutationOptions = Apollo.BaseMutationOptions<DeleteTraitMutation, DeleteTraitMutationVariables>;
export const SaveTraitContentDocument = gql`
    mutation SaveTraitContent($id: Int!, $summary: String, $content: String, $developmentContent: String) {
  traitContent: TraitRoleLevelContentUpdate(
    id: $id
    summary: $summary
    content: $content
    developmentContent: $developmentContent
  ) {
    id
    softSkillId
    traitId
    classification
    roleLevel
    summary
    content
    developmentContent
  }
}
    `;
export type SaveTraitContentMutationFn = Apollo.MutationFunction<SaveTraitContentMutation, SaveTraitContentMutationVariables>;

/**
 * __useSaveTraitContentMutation__
 *
 * To run a mutation, you first call `useSaveTraitContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTraitContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTraitContentMutation, { data, loading, error }] = useSaveTraitContentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      summary: // value for 'summary'
 *      content: // value for 'content'
 *      developmentContent: // value for 'developmentContent'
 *   },
 * });
 */
export function useSaveTraitContentMutation(baseOptions?: Apollo.MutationHookOptions<SaveTraitContentMutation, SaveTraitContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveTraitContentMutation, SaveTraitContentMutationVariables>(SaveTraitContentDocument, options);
      }
export type SaveTraitContentMutationHookResult = ReturnType<typeof useSaveTraitContentMutation>;
export type SaveTraitContentMutationResult = Apollo.MutationResult<SaveTraitContentMutation>;
export type SaveTraitContentMutationOptions = Apollo.BaseMutationOptions<SaveTraitContentMutation, SaveTraitContentMutationVariables>;
export const TraitRoleLevelContentUploadDocument = gql`
    mutation TraitRoleLevelContentUpload($file: Upload!) {
  TraitRoleLevelContentUpload(file: $file)
}
    `;
export type TraitRoleLevelContentUploadMutationFn = Apollo.MutationFunction<TraitRoleLevelContentUploadMutation, TraitRoleLevelContentUploadMutationVariables>;

/**
 * __useTraitRoleLevelContentUploadMutation__
 *
 * To run a mutation, you first call `useTraitRoleLevelContentUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTraitRoleLevelContentUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [traitRoleLevelContentUploadMutation, { data, loading, error }] = useTraitRoleLevelContentUploadMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useTraitRoleLevelContentUploadMutation(baseOptions?: Apollo.MutationHookOptions<TraitRoleLevelContentUploadMutation, TraitRoleLevelContentUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TraitRoleLevelContentUploadMutation, TraitRoleLevelContentUploadMutationVariables>(TraitRoleLevelContentUploadDocument, options);
      }
export type TraitRoleLevelContentUploadMutationHookResult = ReturnType<typeof useTraitRoleLevelContentUploadMutation>;
export type TraitRoleLevelContentUploadMutationResult = Apollo.MutationResult<TraitRoleLevelContentUploadMutation>;
export type TraitRoleLevelContentUploadMutationOptions = Apollo.BaseMutationOptions<TraitRoleLevelContentUploadMutation, TraitRoleLevelContentUploadMutationVariables>;
export const UserDeleteDocument = gql`
    mutation UserDelete($id: Int!) {
  UserDelete(id: $id) {
    affected
  }
}
    `;
export type UserDeleteMutationFn = Apollo.MutationFunction<UserDeleteMutation, UserDeleteMutationVariables>;

/**
 * __useUserDeleteMutation__
 *
 * To run a mutation, you first call `useUserDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userDeleteMutation, { data, loading, error }] = useUserDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserDeleteMutation(baseOptions?: Apollo.MutationHookOptions<UserDeleteMutation, UserDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserDeleteMutation, UserDeleteMutationVariables>(UserDeleteDocument, options);
      }
export type UserDeleteMutationHookResult = ReturnType<typeof useUserDeleteMutation>;
export type UserDeleteMutationResult = Apollo.MutationResult<UserDeleteMutation>;
export type UserDeleteMutationOptions = Apollo.BaseMutationOptions<UserDeleteMutation, UserDeleteMutationVariables>;
export const UserDeleteByEmailDocument = gql`
    mutation UserDeleteByEmail($email: String!) {
  UserDeleteByEmail(email: $email) {
    affected
  }
}
    `;
export type UserDeleteByEmailMutationFn = Apollo.MutationFunction<UserDeleteByEmailMutation, UserDeleteByEmailMutationVariables>;

/**
 * __useUserDeleteByEmailMutation__
 *
 * To run a mutation, you first call `useUserDeleteByEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserDeleteByEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userDeleteByEmailMutation, { data, loading, error }] = useUserDeleteByEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUserDeleteByEmailMutation(baseOptions?: Apollo.MutationHookOptions<UserDeleteByEmailMutation, UserDeleteByEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserDeleteByEmailMutation, UserDeleteByEmailMutationVariables>(UserDeleteByEmailDocument, options);
      }
export type UserDeleteByEmailMutationHookResult = ReturnType<typeof useUserDeleteByEmailMutation>;
export type UserDeleteByEmailMutationResult = Apollo.MutationResult<UserDeleteByEmailMutation>;
export type UserDeleteByEmailMutationOptions = Apollo.BaseMutationOptions<UserDeleteByEmailMutation, UserDeleteByEmailMutationVariables>;
export const UserCreateDocument = gql`
    mutation UserCreate($firstName: String!, $lastName: String!, $email: String!) {
  User: UserCreate(firstName: $firstName, lastName: $lastName, email: $email) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type UserCreateMutationFn = Apollo.MutationFunction<UserCreateMutation, UserCreateMutationVariables>;

/**
 * __useUserCreateMutation__
 *
 * To run a mutation, you first call `useUserCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userCreateMutation, { data, loading, error }] = useUserCreateMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUserCreateMutation(baseOptions?: Apollo.MutationHookOptions<UserCreateMutation, UserCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserCreateMutation, UserCreateMutationVariables>(UserCreateDocument, options);
      }
export type UserCreateMutationHookResult = ReturnType<typeof useUserCreateMutation>;
export type UserCreateMutationResult = Apollo.MutationResult<UserCreateMutation>;
export type UserCreateMutationOptions = Apollo.BaseMutationOptions<UserCreateMutation, UserCreateMutationVariables>;
export const UserUpdateDocument = gql`
    mutation UserUpdate($id: Int!, $firstName: String!, $lastName: String!, $email: String!) {
  User: UserUpdate(
    id: $id
    firstName: $firstName
    lastName: $lastName
    email: $email
  ) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type UserUpdateMutationFn = Apollo.MutationFunction<UserUpdateMutation, UserUpdateMutationVariables>;

/**
 * __useUserUpdateMutation__
 *
 * To run a mutation, you first call `useUserUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdateMutation, { data, loading, error }] = useUserUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUserUpdateMutation(baseOptions?: Apollo.MutationHookOptions<UserUpdateMutation, UserUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserUpdateMutation, UserUpdateMutationVariables>(UserUpdateDocument, options);
      }
export type UserUpdateMutationHookResult = ReturnType<typeof useUserUpdateMutation>;
export type UserUpdateMutationResult = Apollo.MutationResult<UserUpdateMutation>;
export type UserUpdateMutationOptions = Apollo.BaseMutationOptions<UserUpdateMutation, UserUpdateMutationVariables>;
export const UserRoleUpdateDocument = gql`
    mutation UserRoleUpdate($companyId: Float, $role: IdentityPermissionRole, $externalId: String, $id: Float!) {
  UserRole: UserRoleUpdate(
    companyId: $companyId
    role: $role
    externalId: $externalId
    id: $id
  ) {
    ...UserRole
  }
}
    ${UserRoleFragmentDoc}`;
export type UserRoleUpdateMutationFn = Apollo.MutationFunction<UserRoleUpdateMutation, UserRoleUpdateMutationVariables>;

/**
 * __useUserRoleUpdateMutation__
 *
 * To run a mutation, you first call `useUserRoleUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserRoleUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userRoleUpdateMutation, { data, loading, error }] = useUserRoleUpdateMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      role: // value for 'role'
 *      externalId: // value for 'externalId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserRoleUpdateMutation(baseOptions?: Apollo.MutationHookOptions<UserRoleUpdateMutation, UserRoleUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserRoleUpdateMutation, UserRoleUpdateMutationVariables>(UserRoleUpdateDocument, options);
      }
export type UserRoleUpdateMutationHookResult = ReturnType<typeof useUserRoleUpdateMutation>;
export type UserRoleUpdateMutationResult = Apollo.MutationResult<UserRoleUpdateMutation>;
export type UserRoleUpdateMutationOptions = Apollo.BaseMutationOptions<UserRoleUpdateMutation, UserRoleUpdateMutationVariables>;
export const UserRoleCreateDocument = gql`
    mutation UserRoleCreate($userId: Float!, $companyId: Float!, $role: IdentityPermissionRole!, $externalId: String) {
  UserRoleCreate(
    userId: $userId
    companyId: $companyId
    role: $role
    externalId: $externalId
  ) {
    ...UserRole
  }
}
    ${UserRoleFragmentDoc}`;
export type UserRoleCreateMutationFn = Apollo.MutationFunction<UserRoleCreateMutation, UserRoleCreateMutationVariables>;

/**
 * __useUserRoleCreateMutation__
 *
 * To run a mutation, you first call `useUserRoleCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserRoleCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userRoleCreateMutation, { data, loading, error }] = useUserRoleCreateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      companyId: // value for 'companyId'
 *      role: // value for 'role'
 *      externalId: // value for 'externalId'
 *   },
 * });
 */
export function useUserRoleCreateMutation(baseOptions?: Apollo.MutationHookOptions<UserRoleCreateMutation, UserRoleCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserRoleCreateMutation, UserRoleCreateMutationVariables>(UserRoleCreateDocument, options);
      }
export type UserRoleCreateMutationHookResult = ReturnType<typeof useUserRoleCreateMutation>;
export type UserRoleCreateMutationResult = Apollo.MutationResult<UserRoleCreateMutation>;
export type UserRoleCreateMutationOptions = Apollo.BaseMutationOptions<UserRoleCreateMutation, UserRoleCreateMutationVariables>;
export const UserRoleDeleteDocument = gql`
    mutation UserRoleDelete($id: Int!) {
  UserRoleDelete(id: $id) {
    affected
  }
}
    `;
export type UserRoleDeleteMutationFn = Apollo.MutationFunction<UserRoleDeleteMutation, UserRoleDeleteMutationVariables>;

/**
 * __useUserRoleDeleteMutation__
 *
 * To run a mutation, you first call `useUserRoleDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserRoleDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userRoleDeleteMutation, { data, loading, error }] = useUserRoleDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserRoleDeleteMutation(baseOptions?: Apollo.MutationHookOptions<UserRoleDeleteMutation, UserRoleDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserRoleDeleteMutation, UserRoleDeleteMutationVariables>(UserRoleDeleteDocument, options);
      }
export type UserRoleDeleteMutationHookResult = ReturnType<typeof useUserRoleDeleteMutation>;
export type UserRoleDeleteMutationResult = Apollo.MutationResult<UserRoleDeleteMutation>;
export type UserRoleDeleteMutationOptions = Apollo.BaseMutationOptions<UserRoleDeleteMutation, UserRoleDeleteMutationVariables>;
export const WidgetOptionUpdateDocument = gql`
    mutation WidgetOptionUpdate($name: String!, $question: String, $defaultValue: String, $id: Int!, $fieldType: WidgetOptionFieldType!) {
  WidgetOptions: WidgetOptionUpdate(
    name: $name
    question: $question
    defaultValue: $defaultValue
    id: $id
    fieldType: $fieldType
  ) {
    id
    name
    fieldType
    defaultValue
    question
    isArchived
    widgetId
  }
}
    `;
export type WidgetOptionUpdateMutationFn = Apollo.MutationFunction<WidgetOptionUpdateMutation, WidgetOptionUpdateMutationVariables>;

/**
 * __useWidgetOptionUpdateMutation__
 *
 * To run a mutation, you first call `useWidgetOptionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWidgetOptionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [widgetOptionUpdateMutation, { data, loading, error }] = useWidgetOptionUpdateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      question: // value for 'question'
 *      defaultValue: // value for 'defaultValue'
 *      id: // value for 'id'
 *      fieldType: // value for 'fieldType'
 *   },
 * });
 */
export function useWidgetOptionUpdateMutation(baseOptions?: Apollo.MutationHookOptions<WidgetOptionUpdateMutation, WidgetOptionUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WidgetOptionUpdateMutation, WidgetOptionUpdateMutationVariables>(WidgetOptionUpdateDocument, options);
      }
export type WidgetOptionUpdateMutationHookResult = ReturnType<typeof useWidgetOptionUpdateMutation>;
export type WidgetOptionUpdateMutationResult = Apollo.MutationResult<WidgetOptionUpdateMutation>;
export type WidgetOptionUpdateMutationOptions = Apollo.BaseMutationOptions<WidgetOptionUpdateMutation, WidgetOptionUpdateMutationVariables>;
export const WidgetUpdateIsArchivedDocument = gql`
    mutation WidgetUpdateIsArchived($id: Int!, $isArchived: Boolean!) {
  WidgetUpdateIsArchived(id: $id, isArchived: $isArchived) {
    ...Widget
  }
}
    ${WidgetFragmentDoc}`;
export type WidgetUpdateIsArchivedMutationFn = Apollo.MutationFunction<WidgetUpdateIsArchivedMutation, WidgetUpdateIsArchivedMutationVariables>;

/**
 * __useWidgetUpdateIsArchivedMutation__
 *
 * To run a mutation, you first call `useWidgetUpdateIsArchivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWidgetUpdateIsArchivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [widgetUpdateIsArchivedMutation, { data, loading, error }] = useWidgetUpdateIsArchivedMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isArchived: // value for 'isArchived'
 *   },
 * });
 */
export function useWidgetUpdateIsArchivedMutation(baseOptions?: Apollo.MutationHookOptions<WidgetUpdateIsArchivedMutation, WidgetUpdateIsArchivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WidgetUpdateIsArchivedMutation, WidgetUpdateIsArchivedMutationVariables>(WidgetUpdateIsArchivedDocument, options);
      }
export type WidgetUpdateIsArchivedMutationHookResult = ReturnType<typeof useWidgetUpdateIsArchivedMutation>;
export type WidgetUpdateIsArchivedMutationResult = Apollo.MutationResult<WidgetUpdateIsArchivedMutation>;
export type WidgetUpdateIsArchivedMutationOptions = Apollo.BaseMutationOptions<WidgetUpdateIsArchivedMutation, WidgetUpdateIsArchivedMutationVariables>;
export const WidgetOptionUpdateIsArchivedDocument = gql`
    mutation WidgetOptionUpdateIsArchived($id: Int!, $isArchived: Boolean!) {
  WidgetOptionUpdateIsArchived(id: $id, isArchived: $isArchived) {
    id
    name
    question
    isArchived
    fieldType
    defaultValue
  }
}
    `;
export type WidgetOptionUpdateIsArchivedMutationFn = Apollo.MutationFunction<WidgetOptionUpdateIsArchivedMutation, WidgetOptionUpdateIsArchivedMutationVariables>;

/**
 * __useWidgetOptionUpdateIsArchivedMutation__
 *
 * To run a mutation, you first call `useWidgetOptionUpdateIsArchivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWidgetOptionUpdateIsArchivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [widgetOptionUpdateIsArchivedMutation, { data, loading, error }] = useWidgetOptionUpdateIsArchivedMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isArchived: // value for 'isArchived'
 *   },
 * });
 */
export function useWidgetOptionUpdateIsArchivedMutation(baseOptions?: Apollo.MutationHookOptions<WidgetOptionUpdateIsArchivedMutation, WidgetOptionUpdateIsArchivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WidgetOptionUpdateIsArchivedMutation, WidgetOptionUpdateIsArchivedMutationVariables>(WidgetOptionUpdateIsArchivedDocument, options);
      }
export type WidgetOptionUpdateIsArchivedMutationHookResult = ReturnType<typeof useWidgetOptionUpdateIsArchivedMutation>;
export type WidgetOptionUpdateIsArchivedMutationResult = Apollo.MutationResult<WidgetOptionUpdateIsArchivedMutation>;
export type WidgetOptionUpdateIsArchivedMutationOptions = Apollo.BaseMutationOptions<WidgetOptionUpdateIsArchivedMutation, WidgetOptionUpdateIsArchivedMutationVariables>;
export const WidgetDeleteDocument = gql`
    mutation WidgetDelete($id: Int!) {
  WidgetDelete(id: $id) {
    affected
  }
}
    `;
export type WidgetDeleteMutationFn = Apollo.MutationFunction<WidgetDeleteMutation, WidgetDeleteMutationVariables>;

/**
 * __useWidgetDeleteMutation__
 *
 * To run a mutation, you first call `useWidgetDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWidgetDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [widgetDeleteMutation, { data, loading, error }] = useWidgetDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWidgetDeleteMutation(baseOptions?: Apollo.MutationHookOptions<WidgetDeleteMutation, WidgetDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WidgetDeleteMutation, WidgetDeleteMutationVariables>(WidgetDeleteDocument, options);
      }
export type WidgetDeleteMutationHookResult = ReturnType<typeof useWidgetDeleteMutation>;
export type WidgetDeleteMutationResult = Apollo.MutationResult<WidgetDeleteMutation>;
export type WidgetDeleteMutationOptions = Apollo.BaseMutationOptions<WidgetDeleteMutation, WidgetDeleteMutationVariables>;
export const WidgetOptionDeleteDocument = gql`
    mutation WidgetOptionDelete($id: Int!) {
  WidgetOptionDelete(id: $id) {
    affected
  }
}
    `;
export type WidgetOptionDeleteMutationFn = Apollo.MutationFunction<WidgetOptionDeleteMutation, WidgetOptionDeleteMutationVariables>;

/**
 * __useWidgetOptionDeleteMutation__
 *
 * To run a mutation, you first call `useWidgetOptionDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWidgetOptionDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [widgetOptionDeleteMutation, { data, loading, error }] = useWidgetOptionDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWidgetOptionDeleteMutation(baseOptions?: Apollo.MutationHookOptions<WidgetOptionDeleteMutation, WidgetOptionDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WidgetOptionDeleteMutation, WidgetOptionDeleteMutationVariables>(WidgetOptionDeleteDocument, options);
      }
export type WidgetOptionDeleteMutationHookResult = ReturnType<typeof useWidgetOptionDeleteMutation>;
export type WidgetOptionDeleteMutationResult = Apollo.MutationResult<WidgetOptionDeleteMutation>;
export type WidgetOptionDeleteMutationOptions = Apollo.BaseMutationOptions<WidgetOptionDeleteMutation, WidgetOptionDeleteMutationVariables>;
export const WidgetCreateDocument = gql`
    mutation WidgetCreate($type: WidgetType!, $name: String!) {
  Widget: WidgetCreate(name: $name, type: $type) {
    ...Widget
  }
}
    ${WidgetFragmentDoc}`;
export type WidgetCreateMutationFn = Apollo.MutationFunction<WidgetCreateMutation, WidgetCreateMutationVariables>;

/**
 * __useWidgetCreateMutation__
 *
 * To run a mutation, you first call `useWidgetCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWidgetCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [widgetCreateMutation, { data, loading, error }] = useWidgetCreateMutation({
 *   variables: {
 *      type: // value for 'type'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useWidgetCreateMutation(baseOptions?: Apollo.MutationHookOptions<WidgetCreateMutation, WidgetCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WidgetCreateMutation, WidgetCreateMutationVariables>(WidgetCreateDocument, options);
      }
export type WidgetCreateMutationHookResult = ReturnType<typeof useWidgetCreateMutation>;
export type WidgetCreateMutationResult = Apollo.MutationResult<WidgetCreateMutation>;
export type WidgetCreateMutationOptions = Apollo.BaseMutationOptions<WidgetCreateMutation, WidgetCreateMutationVariables>;
export const WidgetUploadScreenShotDocument = gql`
    mutation WidgetUploadScreenShot($id: Int!, $file: Upload!) {
  WidgetUploadScreenShot(id: $id, file: $file) {
    id
    name
    type
  }
}
    `;
export type WidgetUploadScreenShotMutationFn = Apollo.MutationFunction<WidgetUploadScreenShotMutation, WidgetUploadScreenShotMutationVariables>;

/**
 * __useWidgetUploadScreenShotMutation__
 *
 * To run a mutation, you first call `useWidgetUploadScreenShotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWidgetUploadScreenShotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [widgetUploadScreenShotMutation, { data, loading, error }] = useWidgetUploadScreenShotMutation({
 *   variables: {
 *      id: // value for 'id'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useWidgetUploadScreenShotMutation(baseOptions?: Apollo.MutationHookOptions<WidgetUploadScreenShotMutation, WidgetUploadScreenShotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WidgetUploadScreenShotMutation, WidgetUploadScreenShotMutationVariables>(WidgetUploadScreenShotDocument, options);
      }
export type WidgetUploadScreenShotMutationHookResult = ReturnType<typeof useWidgetUploadScreenShotMutation>;
export type WidgetUploadScreenShotMutationResult = Apollo.MutationResult<WidgetUploadScreenShotMutation>;
export type WidgetUploadScreenShotMutationOptions = Apollo.BaseMutationOptions<WidgetUploadScreenShotMutation, WidgetUploadScreenShotMutationVariables>;
export const WidgetUpdateDocument = gql`
    mutation WidgetUpdate($type: WidgetType, $name: String, $id: Int!) {
  WidgetUpdate(id: $id, name: $name, type: $type) {
    id
    name
    type
  }
}
    `;
export type WidgetUpdateMutationFn = Apollo.MutationFunction<WidgetUpdateMutation, WidgetUpdateMutationVariables>;

/**
 * __useWidgetUpdateMutation__
 *
 * To run a mutation, you first call `useWidgetUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWidgetUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [widgetUpdateMutation, { data, loading, error }] = useWidgetUpdateMutation({
 *   variables: {
 *      type: // value for 'type'
 *      name: // value for 'name'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWidgetUpdateMutation(baseOptions?: Apollo.MutationHookOptions<WidgetUpdateMutation, WidgetUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WidgetUpdateMutation, WidgetUpdateMutationVariables>(WidgetUpdateDocument, options);
      }
export type WidgetUpdateMutationHookResult = ReturnType<typeof useWidgetUpdateMutation>;
export type WidgetUpdateMutationResult = Apollo.MutationResult<WidgetUpdateMutation>;
export type WidgetUpdateMutationOptions = Apollo.BaseMutationOptions<WidgetUpdateMutation, WidgetUpdateMutationVariables>;
export const WidgetOptionCreateDocument = gql`
    mutation WidgetOptionCreate($name: String!, $question: String, $defaultValue: String, $widgetId: Int!, $fieldType: WidgetOptionFieldType!) {
  WidgetOptions: WidgetOptionCreate(
    name: $name
    question: $question
    defaultValue: $defaultValue
    widgetId: $widgetId
    fieldType: $fieldType
  ) {
    id
    name
    fieldType
    defaultValue
    question
    isArchived
    widgetId
  }
}
    `;
export type WidgetOptionCreateMutationFn = Apollo.MutationFunction<WidgetOptionCreateMutation, WidgetOptionCreateMutationVariables>;

/**
 * __useWidgetOptionCreateMutation__
 *
 * To run a mutation, you first call `useWidgetOptionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWidgetOptionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [widgetOptionCreateMutation, { data, loading, error }] = useWidgetOptionCreateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      question: // value for 'question'
 *      defaultValue: // value for 'defaultValue'
 *      widgetId: // value for 'widgetId'
 *      fieldType: // value for 'fieldType'
 *   },
 * });
 */
export function useWidgetOptionCreateMutation(baseOptions?: Apollo.MutationHookOptions<WidgetOptionCreateMutation, WidgetOptionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WidgetOptionCreateMutation, WidgetOptionCreateMutationVariables>(WidgetOptionCreateDocument, options);
      }
export type WidgetOptionCreateMutationHookResult = ReturnType<typeof useWidgetOptionCreateMutation>;
export type WidgetOptionCreateMutationResult = Apollo.MutationResult<WidgetOptionCreateMutation>;
export type WidgetOptionCreateMutationOptions = Apollo.BaseMutationOptions<WidgetOptionCreateMutation, WidgetOptionCreateMutationVariables>;
export const WidgetOptionUploadCoverPageImageDocument = gql`
    mutation WidgetOptionUploadCoverPageImage($file: Upload!) {
  WidgetOptionUploadCoverPageImage(file: $file) {
    id
    url
  }
}
    `;
export type WidgetOptionUploadCoverPageImageMutationFn = Apollo.MutationFunction<WidgetOptionUploadCoverPageImageMutation, WidgetOptionUploadCoverPageImageMutationVariables>;

/**
 * __useWidgetOptionUploadCoverPageImageMutation__
 *
 * To run a mutation, you first call `useWidgetOptionUploadCoverPageImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWidgetOptionUploadCoverPageImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [widgetOptionUploadCoverPageImageMutation, { data, loading, error }] = useWidgetOptionUploadCoverPageImageMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useWidgetOptionUploadCoverPageImageMutation(baseOptions?: Apollo.MutationHookOptions<WidgetOptionUploadCoverPageImageMutation, WidgetOptionUploadCoverPageImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WidgetOptionUploadCoverPageImageMutation, WidgetOptionUploadCoverPageImageMutationVariables>(WidgetOptionUploadCoverPageImageDocument, options);
      }
export type WidgetOptionUploadCoverPageImageMutationHookResult = ReturnType<typeof useWidgetOptionUploadCoverPageImageMutation>;
export type WidgetOptionUploadCoverPageImageMutationResult = Apollo.MutationResult<WidgetOptionUploadCoverPageImageMutation>;
export type WidgetOptionUploadCoverPageImageMutationOptions = Apollo.BaseMutationOptions<WidgetOptionUploadCoverPageImageMutation, WidgetOptionUploadCoverPageImageMutationVariables>;
export const WidgetOptionUploadBrandedSoftSkillImageDocument = gql`
    mutation WidgetOptionUploadBrandedSoftSkillImage($file: Upload!) {
  WidgetOptionUploadBrandedSoftSkillImage(file: $file) {
    id
    url
  }
}
    `;
export type WidgetOptionUploadBrandedSoftSkillImageMutationFn = Apollo.MutationFunction<WidgetOptionUploadBrandedSoftSkillImageMutation, WidgetOptionUploadBrandedSoftSkillImageMutationVariables>;

/**
 * __useWidgetOptionUploadBrandedSoftSkillImageMutation__
 *
 * To run a mutation, you first call `useWidgetOptionUploadBrandedSoftSkillImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWidgetOptionUploadBrandedSoftSkillImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [widgetOptionUploadBrandedSoftSkillImageMutation, { data, loading, error }] = useWidgetOptionUploadBrandedSoftSkillImageMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useWidgetOptionUploadBrandedSoftSkillImageMutation(baseOptions?: Apollo.MutationHookOptions<WidgetOptionUploadBrandedSoftSkillImageMutation, WidgetOptionUploadBrandedSoftSkillImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WidgetOptionUploadBrandedSoftSkillImageMutation, WidgetOptionUploadBrandedSoftSkillImageMutationVariables>(WidgetOptionUploadBrandedSoftSkillImageDocument, options);
      }
export type WidgetOptionUploadBrandedSoftSkillImageMutationHookResult = ReturnType<typeof useWidgetOptionUploadBrandedSoftSkillImageMutation>;
export type WidgetOptionUploadBrandedSoftSkillImageMutationResult = Apollo.MutationResult<WidgetOptionUploadBrandedSoftSkillImageMutation>;
export type WidgetOptionUploadBrandedSoftSkillImageMutationOptions = Apollo.BaseMutationOptions<WidgetOptionUploadBrandedSoftSkillImageMutation, WidgetOptionUploadBrandedSoftSkillImageMutationVariables>;
export const SkillCategoryFindManyDocument = gql`
    query SkillCategoryFindMany {
  SkillCategoryFindMany {
    id
    name
  }
}
    `;

/**
 * __useSkillCategoryFindManyQuery__
 *
 * To run a query within a React component, call `useSkillCategoryFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkillCategoryFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkillCategoryFindManyQuery({
 *   variables: {
 *   },
 * });
 */
export function useSkillCategoryFindManyQuery(baseOptions?: Apollo.QueryHookOptions<SkillCategoryFindManyQuery, SkillCategoryFindManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SkillCategoryFindManyQuery, SkillCategoryFindManyQueryVariables>(SkillCategoryFindManyDocument, options);
      }
export function useSkillCategoryFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SkillCategoryFindManyQuery, SkillCategoryFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SkillCategoryFindManyQuery, SkillCategoryFindManyQueryVariables>(SkillCategoryFindManyDocument, options);
        }
export type SkillCategoryFindManyQueryHookResult = ReturnType<typeof useSkillCategoryFindManyQuery>;
export type SkillCategoryFindManyLazyQueryHookResult = ReturnType<typeof useSkillCategoryFindManyLazyQuery>;
export type SkillCategoryFindManyQueryResult = Apollo.QueryResult<SkillCategoryFindManyQuery, SkillCategoryFindManyQueryVariables>;
export const GetAssessmentStageInviteUrlDocument = gql`
    query GetAssessmentStageInviteUrl($id: ID!, $locale: SupportedLocale!) {
  assessmentStage(id: $id) {
    inviteUrl(locale: $locale)
  }
}
    `;

/**
 * __useGetAssessmentStageInviteUrlQuery__
 *
 * To run a query within a React component, call `useGetAssessmentStageInviteUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssessmentStageInviteUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssessmentStageInviteUrlQuery({
 *   variables: {
 *      id: // value for 'id'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetAssessmentStageInviteUrlQuery(baseOptions: Apollo.QueryHookOptions<GetAssessmentStageInviteUrlQuery, GetAssessmentStageInviteUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssessmentStageInviteUrlQuery, GetAssessmentStageInviteUrlQueryVariables>(GetAssessmentStageInviteUrlDocument, options);
      }
export function useGetAssessmentStageInviteUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssessmentStageInviteUrlQuery, GetAssessmentStageInviteUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssessmentStageInviteUrlQuery, GetAssessmentStageInviteUrlQueryVariables>(GetAssessmentStageInviteUrlDocument, options);
        }
export type GetAssessmentStageInviteUrlQueryHookResult = ReturnType<typeof useGetAssessmentStageInviteUrlQuery>;
export type GetAssessmentStageInviteUrlLazyQueryHookResult = ReturnType<typeof useGetAssessmentStageInviteUrlLazyQuery>;
export type GetAssessmentStageInviteUrlQueryResult = Apollo.QueryResult<GetAssessmentStageInviteUrlQuery, GetAssessmentStageInviteUrlQueryVariables>;
export const AtsSettingsDocument = gql`
    query AtsSettings($companyId: Int!) {
  atsSettings(companyId: $companyId) {
    ...AtsSettingsFields
  }
}
    ${AtsSettingsFieldsFragmentDoc}`;

/**
 * __useAtsSettingsQuery__
 *
 * To run a query within a React component, call `useAtsSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtsSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtsSettingsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useAtsSettingsQuery(baseOptions: Apollo.QueryHookOptions<AtsSettingsQuery, AtsSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AtsSettingsQuery, AtsSettingsQueryVariables>(AtsSettingsDocument, options);
      }
export function useAtsSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AtsSettingsQuery, AtsSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AtsSettingsQuery, AtsSettingsQueryVariables>(AtsSettingsDocument, options);
        }
export type AtsSettingsQueryHookResult = ReturnType<typeof useAtsSettingsQuery>;
export type AtsSettingsLazyQueryHookResult = ReturnType<typeof useAtsSettingsLazyQuery>;
export type AtsSettingsQueryResult = Apollo.QueryResult<AtsSettingsQuery, AtsSettingsQueryVariables>;
export const AtsAllRejectionReasonsDocument = gql`
    query AtsAllRejectionReasons($companyId: Int!) {
  atsAllRejectionReasons(companyId: $companyId) {
    id
    name
    remoteId
  }
}
    `;

/**
 * __useAtsAllRejectionReasonsQuery__
 *
 * To run a query within a React component, call `useAtsAllRejectionReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtsAllRejectionReasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtsAllRejectionReasonsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useAtsAllRejectionReasonsQuery(baseOptions: Apollo.QueryHookOptions<AtsAllRejectionReasonsQuery, AtsAllRejectionReasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AtsAllRejectionReasonsQuery, AtsAllRejectionReasonsQueryVariables>(AtsAllRejectionReasonsDocument, options);
      }
export function useAtsAllRejectionReasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AtsAllRejectionReasonsQuery, AtsAllRejectionReasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AtsAllRejectionReasonsQuery, AtsAllRejectionReasonsQueryVariables>(AtsAllRejectionReasonsDocument, options);
        }
export type AtsAllRejectionReasonsQueryHookResult = ReturnType<typeof useAtsAllRejectionReasonsQuery>;
export type AtsAllRejectionReasonsLazyQueryHookResult = ReturnType<typeof useAtsAllRejectionReasonsLazyQuery>;
export type AtsAllRejectionReasonsQueryResult = Apollo.QueryResult<AtsAllRejectionReasonsQuery, AtsAllRejectionReasonsQueryVariables>;
export const AtsAllStagesDocument = gql`
    query AtsAllStages($companyId: Int!) {
  atsAllStages(companyId: $companyId) {
    companyId
    missingRefCount
    stages {
      atsStageRef
      name
    }
  }
}
    `;

/**
 * __useAtsAllStagesQuery__
 *
 * To run a query within a React component, call `useAtsAllStagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtsAllStagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtsAllStagesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useAtsAllStagesQuery(baseOptions: Apollo.QueryHookOptions<AtsAllStagesQuery, AtsAllStagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AtsAllStagesQuery, AtsAllStagesQueryVariables>(AtsAllStagesDocument, options);
      }
export function useAtsAllStagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AtsAllStagesQuery, AtsAllStagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AtsAllStagesQuery, AtsAllStagesQueryVariables>(AtsAllStagesDocument, options);
        }
export type AtsAllStagesQueryHookResult = ReturnType<typeof useAtsAllStagesQuery>;
export type AtsAllStagesLazyQueryHookResult = ReturnType<typeof useAtsAllStagesLazyQuery>;
export type AtsAllStagesQueryResult = Apollo.QueryResult<AtsAllStagesQuery, AtsAllStagesQueryVariables>;
export const CoderbyteWorkspaceDocument = gql`
    query CoderbyteWorkspace($companyId: Int!) {
  coderbyteWorkspace(companyId: $companyId) {
    ...CoderbyteWorkspaceFields
  }
}
    ${CoderbyteWorkspaceFieldsFragmentDoc}`;

/**
 * __useCoderbyteWorkspaceQuery__
 *
 * To run a query within a React component, call `useCoderbyteWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoderbyteWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoderbyteWorkspaceQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCoderbyteWorkspaceQuery(baseOptions: Apollo.QueryHookOptions<CoderbyteWorkspaceQuery, CoderbyteWorkspaceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoderbyteWorkspaceQuery, CoderbyteWorkspaceQueryVariables>(CoderbyteWorkspaceDocument, options);
      }
export function useCoderbyteWorkspaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoderbyteWorkspaceQuery, CoderbyteWorkspaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoderbyteWorkspaceQuery, CoderbyteWorkspaceQueryVariables>(CoderbyteWorkspaceDocument, options);
        }
export type CoderbyteWorkspaceQueryHookResult = ReturnType<typeof useCoderbyteWorkspaceQuery>;
export type CoderbyteWorkspaceLazyQueryHookResult = ReturnType<typeof useCoderbyteWorkspaceLazyQuery>;
export type CoderbyteWorkspaceQueryResult = Apollo.QueryResult<CoderbyteWorkspaceQuery, CoderbyteWorkspaceQueryVariables>;
export const CoderbyteWorkspacesDocument = gql`
    query CoderbyteWorkspaces {
  coderbyteWorkspaces {
    ...CoderbyteWorkspaceFields
  }
}
    ${CoderbyteWorkspaceFieldsFragmentDoc}`;

/**
 * __useCoderbyteWorkspacesQuery__
 *
 * To run a query within a React component, call `useCoderbyteWorkspacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoderbyteWorkspacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoderbyteWorkspacesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCoderbyteWorkspacesQuery(baseOptions?: Apollo.QueryHookOptions<CoderbyteWorkspacesQuery, CoderbyteWorkspacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoderbyteWorkspacesQuery, CoderbyteWorkspacesQueryVariables>(CoderbyteWorkspacesDocument, options);
      }
export function useCoderbyteWorkspacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoderbyteWorkspacesQuery, CoderbyteWorkspacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoderbyteWorkspacesQuery, CoderbyteWorkspacesQueryVariables>(CoderbyteWorkspacesDocument, options);
        }
export type CoderbyteWorkspacesQueryHookResult = ReturnType<typeof useCoderbyteWorkspacesQuery>;
export type CoderbyteWorkspacesLazyQueryHookResult = ReturnType<typeof useCoderbyteWorkspacesLazyQuery>;
export type CoderbyteWorkspacesQueryResult = Apollo.QueryResult<CoderbyteWorkspacesQuery, CoderbyteWorkspacesQueryVariables>;
export const CoderbyteWorkspaceWithUsersDocument = gql`
    query CoderbyteWorkspaceWithUsers($companyId: Int!) {
  coderbyteWorkspace(companyId: $companyId) {
    ...CoderbyteWorkspaceFields
    users {
      ...CoderbyteWorkspaceUserFields
    }
  }
}
    ${CoderbyteWorkspaceFieldsFragmentDoc}
${CoderbyteWorkspaceUserFieldsFragmentDoc}`;

/**
 * __useCoderbyteWorkspaceWithUsersQuery__
 *
 * To run a query within a React component, call `useCoderbyteWorkspaceWithUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoderbyteWorkspaceWithUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoderbyteWorkspaceWithUsersQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCoderbyteWorkspaceWithUsersQuery(baseOptions: Apollo.QueryHookOptions<CoderbyteWorkspaceWithUsersQuery, CoderbyteWorkspaceWithUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoderbyteWorkspaceWithUsersQuery, CoderbyteWorkspaceWithUsersQueryVariables>(CoderbyteWorkspaceWithUsersDocument, options);
      }
export function useCoderbyteWorkspaceWithUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoderbyteWorkspaceWithUsersQuery, CoderbyteWorkspaceWithUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoderbyteWorkspaceWithUsersQuery, CoderbyteWorkspaceWithUsersQueryVariables>(CoderbyteWorkspaceWithUsersDocument, options);
        }
export type CoderbyteWorkspaceWithUsersQueryHookResult = ReturnType<typeof useCoderbyteWorkspaceWithUsersQuery>;
export type CoderbyteWorkspaceWithUsersLazyQueryHookResult = ReturnType<typeof useCoderbyteWorkspaceWithUsersLazyQuery>;
export type CoderbyteWorkspaceWithUsersQueryResult = Apollo.QueryResult<CoderbyteWorkspaceWithUsersQuery, CoderbyteWorkspaceWithUsersQueryVariables>;
export const CoderbyteWorkspaceAdminPasswordDocument = gql`
    query CoderbyteWorkspaceAdminPassword($companyId: Int!) {
  coderbyteWorkspaceAdminPassword(companyId: $companyId)
}
    `;

/**
 * __useCoderbyteWorkspaceAdminPasswordQuery__
 *
 * To run a query within a React component, call `useCoderbyteWorkspaceAdminPasswordQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoderbyteWorkspaceAdminPasswordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoderbyteWorkspaceAdminPasswordQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCoderbyteWorkspaceAdminPasswordQuery(baseOptions: Apollo.QueryHookOptions<CoderbyteWorkspaceAdminPasswordQuery, CoderbyteWorkspaceAdminPasswordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoderbyteWorkspaceAdminPasswordQuery, CoderbyteWorkspaceAdminPasswordQueryVariables>(CoderbyteWorkspaceAdminPasswordDocument, options);
      }
export function useCoderbyteWorkspaceAdminPasswordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoderbyteWorkspaceAdminPasswordQuery, CoderbyteWorkspaceAdminPasswordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoderbyteWorkspaceAdminPasswordQuery, CoderbyteWorkspaceAdminPasswordQueryVariables>(CoderbyteWorkspaceAdminPasswordDocument, options);
        }
export type CoderbyteWorkspaceAdminPasswordQueryHookResult = ReturnType<typeof useCoderbyteWorkspaceAdminPasswordQuery>;
export type CoderbyteWorkspaceAdminPasswordLazyQueryHookResult = ReturnType<typeof useCoderbyteWorkspaceAdminPasswordLazyQuery>;
export type CoderbyteWorkspaceAdminPasswordQueryResult = Apollo.QueryResult<CoderbyteWorkspaceAdminPasswordQuery, CoderbyteWorkspaceAdminPasswordQueryVariables>;
export const CoderbyteWorkspaceApiKeyDocument = gql`
    query CoderbyteWorkspaceApiKey($companyId: Int!) {
  coderbyteWorkspaceApiKey(companyId: $companyId)
}
    `;

/**
 * __useCoderbyteWorkspaceApiKeyQuery__
 *
 * To run a query within a React component, call `useCoderbyteWorkspaceApiKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoderbyteWorkspaceApiKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoderbyteWorkspaceApiKeyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCoderbyteWorkspaceApiKeyQuery(baseOptions: Apollo.QueryHookOptions<CoderbyteWorkspaceApiKeyQuery, CoderbyteWorkspaceApiKeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoderbyteWorkspaceApiKeyQuery, CoderbyteWorkspaceApiKeyQueryVariables>(CoderbyteWorkspaceApiKeyDocument, options);
      }
export function useCoderbyteWorkspaceApiKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoderbyteWorkspaceApiKeyQuery, CoderbyteWorkspaceApiKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoderbyteWorkspaceApiKeyQuery, CoderbyteWorkspaceApiKeyQueryVariables>(CoderbyteWorkspaceApiKeyDocument, options);
        }
export type CoderbyteWorkspaceApiKeyQueryHookResult = ReturnType<typeof useCoderbyteWorkspaceApiKeyQuery>;
export type CoderbyteWorkspaceApiKeyLazyQueryHookResult = ReturnType<typeof useCoderbyteWorkspaceApiKeyLazyQuery>;
export type CoderbyteWorkspaceApiKeyQueryResult = Apollo.QueryResult<CoderbyteWorkspaceApiKeyQuery, CoderbyteWorkspaceApiKeyQueryVariables>;
export const CompaniesDocument = gql`
    query Companies {
  Companies: companies {
    ...Company
  }
}
    ${CompanyFragmentDoc}`;

/**
 * __useCompaniesQuery__
 *
 * To run a query within a React component, call `useCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<CompaniesQuery, CompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompaniesQuery, CompaniesQueryVariables>(CompaniesDocument, options);
      }
export function useCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompaniesQuery, CompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompaniesQuery, CompaniesQueryVariables>(CompaniesDocument, options);
        }
export type CompaniesQueryHookResult = ReturnType<typeof useCompaniesQuery>;
export type CompaniesLazyQueryHookResult = ReturnType<typeof useCompaniesLazyQuery>;
export type CompaniesQueryResult = Apollo.QueryResult<CompaniesQuery, CompaniesQueryVariables>;
export const CompanyDocument = gql`
    query Company($id: Int!) {
  company(id: $id) {
    ...Company
  }
}
    ${CompanyFragmentDoc}`;

/**
 * __useCompanyQuery__
 *
 * To run a query within a React component, call `useCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompanyQuery(baseOptions: Apollo.QueryHookOptions<CompanyQuery, CompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options);
      }
export function useCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyQuery, CompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options);
        }
export type CompanyQueryHookResult = ReturnType<typeof useCompanyQuery>;
export type CompanyLazyQueryHookResult = ReturnType<typeof useCompanyLazyQuery>;
export type CompanyQueryResult = Apollo.QueryResult<CompanyQuery, CompanyQueryVariables>;
export const CompanySignatureFindManyDocument = gql`
    query CompanySignatureFindMany($companyId: Int) {
  CompanySignature: CompanySignatureFindMany(companyId: $companyId) {
    ...CompanySignatureModel
  }
}
    ${CompanySignatureModelFragmentDoc}`;

/**
 * __useCompanySignatureFindManyQuery__
 *
 * To run a query within a React component, call `useCompanySignatureFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanySignatureFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanySignatureFindManyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCompanySignatureFindManyQuery(baseOptions?: Apollo.QueryHookOptions<CompanySignatureFindManyQuery, CompanySignatureFindManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanySignatureFindManyQuery, CompanySignatureFindManyQueryVariables>(CompanySignatureFindManyDocument, options);
      }
export function useCompanySignatureFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanySignatureFindManyQuery, CompanySignatureFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanySignatureFindManyQuery, CompanySignatureFindManyQueryVariables>(CompanySignatureFindManyDocument, options);
        }
export type CompanySignatureFindManyQueryHookResult = ReturnType<typeof useCompanySignatureFindManyQuery>;
export type CompanySignatureFindManyLazyQueryHookResult = ReturnType<typeof useCompanySignatureFindManyLazyQuery>;
export type CompanySignatureFindManyQueryResult = Apollo.QueryResult<CompanySignatureFindManyQuery, CompanySignatureFindManyQueryVariables>;
export const CompanyFindManyByIdsDocument = gql`
    query CompanyFindManyByIds($ids: [Int!]!) {
  CompanyFindManyByIds: companyFindManyByIds(ids: $ids) {
    ...Company
  }
}
    ${CompanyFragmentDoc}`;

/**
 * __useCompanyFindManyByIdsQuery__
 *
 * To run a query within a React component, call `useCompanyFindManyByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyFindManyByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyFindManyByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useCompanyFindManyByIdsQuery(baseOptions: Apollo.QueryHookOptions<CompanyFindManyByIdsQuery, CompanyFindManyByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyFindManyByIdsQuery, CompanyFindManyByIdsQueryVariables>(CompanyFindManyByIdsDocument, options);
      }
export function useCompanyFindManyByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyFindManyByIdsQuery, CompanyFindManyByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyFindManyByIdsQuery, CompanyFindManyByIdsQueryVariables>(CompanyFindManyByIdsDocument, options);
        }
export type CompanyFindManyByIdsQueryHookResult = ReturnType<typeof useCompanyFindManyByIdsQuery>;
export type CompanyFindManyByIdsLazyQueryHookResult = ReturnType<typeof useCompanyFindManyByIdsLazyQuery>;
export type CompanyFindManyByIdsQueryResult = Apollo.QueryResult<CompanyFindManyByIdsQuery, CompanyFindManyByIdsQueryVariables>;
export const GetCompanyIdDocument = gql`
    query GetCompanyId($projectId: Float!) {
  getCompanyId(id: $projectId) {
    companyId
  }
}
    `;

/**
 * __useGetCompanyIdQuery__
 *
 * To run a query within a React component, call `useGetCompanyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetCompanyIdQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyIdQuery, GetCompanyIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyIdQuery, GetCompanyIdQueryVariables>(GetCompanyIdDocument, options);
      }
export function useGetCompanyIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyIdQuery, GetCompanyIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyIdQuery, GetCompanyIdQueryVariables>(GetCompanyIdDocument, options);
        }
export type GetCompanyIdQueryHookResult = ReturnType<typeof useGetCompanyIdQuery>;
export type GetCompanyIdLazyQueryHookResult = ReturnType<typeof useGetCompanyIdLazyQuery>;
export type GetCompanyIdQueryResult = Apollo.QueryResult<GetCompanyIdQuery, GetCompanyIdQueryVariables>;
export const CompaniesPaginatedDocument = gql`
    query CompaniesPaginated($pagination: OffsetBasedPaginationArgs, $filters: CompaniesPaginatedFilters, $includeCompanyIds: [Int!]) {
  CompaniesPaginated(
    pagination: $pagination
    filters: $filters
    includeCompanyIds: $includeCompanyIds
  ) {
    data {
      ...Company
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${CompanyFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useCompaniesPaginatedQuery__
 *
 * To run a query within a React component, call `useCompaniesPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompaniesPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompaniesPaginatedQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filters: // value for 'filters'
 *      includeCompanyIds: // value for 'includeCompanyIds'
 *   },
 * });
 */
export function useCompaniesPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<CompaniesPaginatedQuery, CompaniesPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompaniesPaginatedQuery, CompaniesPaginatedQueryVariables>(CompaniesPaginatedDocument, options);
      }
export function useCompaniesPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompaniesPaginatedQuery, CompaniesPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompaniesPaginatedQuery, CompaniesPaginatedQueryVariables>(CompaniesPaginatedDocument, options);
        }
export type CompaniesPaginatedQueryHookResult = ReturnType<typeof useCompaniesPaginatedQuery>;
export type CompaniesPaginatedLazyQueryHookResult = ReturnType<typeof useCompaniesPaginatedLazyQuery>;
export type CompaniesPaginatedQueryResult = Apollo.QueryResult<CompaniesPaginatedQuery, CompaniesPaginatedQueryVariables>;
export const CompanyFindUsersDocument = gql`
    query CompanyFindUsers($id: Int!) {
  companyUsers: CompanyFindUsers(id: $id) {
    ...User
  }
}
    ${UserFragmentDoc}`;

/**
 * __useCompanyFindUsersQuery__
 *
 * To run a query within a React component, call `useCompanyFindUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyFindUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyFindUsersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompanyFindUsersQuery(baseOptions: Apollo.QueryHookOptions<CompanyFindUsersQuery, CompanyFindUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyFindUsersQuery, CompanyFindUsersQueryVariables>(CompanyFindUsersDocument, options);
      }
export function useCompanyFindUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyFindUsersQuery, CompanyFindUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyFindUsersQuery, CompanyFindUsersQueryVariables>(CompanyFindUsersDocument, options);
        }
export type CompanyFindUsersQueryHookResult = ReturnType<typeof useCompanyFindUsersQuery>;
export type CompanyFindUsersLazyQueryHookResult = ReturnType<typeof useCompanyFindUsersLazyQuery>;
export type CompanyFindUsersQueryResult = Apollo.QueryResult<CompanyFindUsersQuery, CompanyFindUsersQueryVariables>;
export const CompanyFindUsersPaginatedDocument = gql`
    query CompanyFindUsersPaginated($id: Int!, $skip: Int!, $take: Int!) {
  companyUsers: CompanyFindUsersPaginated(id: $id, skip: $skip, take: $take) {
    data {
      ...User
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${UserFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useCompanyFindUsersPaginatedQuery__
 *
 * To run a query within a React component, call `useCompanyFindUsersPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyFindUsersPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyFindUsersPaginatedQuery({
 *   variables: {
 *      id: // value for 'id'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useCompanyFindUsersPaginatedQuery(baseOptions: Apollo.QueryHookOptions<CompanyFindUsersPaginatedQuery, CompanyFindUsersPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyFindUsersPaginatedQuery, CompanyFindUsersPaginatedQueryVariables>(CompanyFindUsersPaginatedDocument, options);
      }
export function useCompanyFindUsersPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyFindUsersPaginatedQuery, CompanyFindUsersPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyFindUsersPaginatedQuery, CompanyFindUsersPaginatedQueryVariables>(CompanyFindUsersPaginatedDocument, options);
        }
export type CompanyFindUsersPaginatedQueryHookResult = ReturnType<typeof useCompanyFindUsersPaginatedQuery>;
export type CompanyFindUsersPaginatedLazyQueryHookResult = ReturnType<typeof useCompanyFindUsersPaginatedLazyQuery>;
export type CompanyFindUsersPaginatedQueryResult = Apollo.QueryResult<CompanyFindUsersPaginatedQuery, CompanyFindUsersPaginatedQueryVariables>;
export const CompanyGetDefaultReportsDocument = gql`
    query CompanyGetDefaultReports {
  CompanyGetDefaultReports {
    managerReport {
      ...ShallowReport
    }
    candidateReport {
      ...ShallowReport
    }
  }
}
    ${ShallowReportFragmentDoc}`;

/**
 * __useCompanyGetDefaultReportsQuery__
 *
 * To run a query within a React component, call `useCompanyGetDefaultReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyGetDefaultReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyGetDefaultReportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompanyGetDefaultReportsQuery(baseOptions?: Apollo.QueryHookOptions<CompanyGetDefaultReportsQuery, CompanyGetDefaultReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyGetDefaultReportsQuery, CompanyGetDefaultReportsQueryVariables>(CompanyGetDefaultReportsDocument, options);
      }
export function useCompanyGetDefaultReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyGetDefaultReportsQuery, CompanyGetDefaultReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyGetDefaultReportsQuery, CompanyGetDefaultReportsQueryVariables>(CompanyGetDefaultReportsDocument, options);
        }
export type CompanyGetDefaultReportsQueryHookResult = ReturnType<typeof useCompanyGetDefaultReportsQuery>;
export type CompanyGetDefaultReportsLazyQueryHookResult = ReturnType<typeof useCompanyGetDefaultReportsLazyQuery>;
export type CompanyGetDefaultReportsQueryResult = Apollo.QueryResult<CompanyGetDefaultReportsQuery, CompanyGetDefaultReportsQueryVariables>;
export const CompanyRolesDocument = gql`
    query CompanyRoles($companyId: Int!) {
  CompanyRoles(companyId: $companyId) {
    ...CompanyRole
  }
}
    ${CompanyRoleFragmentDoc}`;

/**
 * __useCompanyRolesQuery__
 *
 * To run a query within a React component, call `useCompanyRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyRolesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCompanyRolesQuery(baseOptions: Apollo.QueryHookOptions<CompanyRolesQuery, CompanyRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyRolesQuery, CompanyRolesQueryVariables>(CompanyRolesDocument, options);
      }
export function useCompanyRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyRolesQuery, CompanyRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyRolesQuery, CompanyRolesQueryVariables>(CompanyRolesDocument, options);
        }
export type CompanyRolesQueryHookResult = ReturnType<typeof useCompanyRolesQuery>;
export type CompanyRolesLazyQueryHookResult = ReturnType<typeof useCompanyRolesLazyQuery>;
export type CompanyRolesQueryResult = Apollo.QueryResult<CompanyRolesQuery, CompanyRolesQueryVariables>;
export const CompanySettingChangesDocument = gql`
    query CompanySettingChanges($companyId: Int!, $pagination: OffsetBasedPaginationArgs!, $source: CompanySettingChangeSource, $settingSearch: String, $settingKeys: [String!], $order: CompanySettingChangeOrderArgs!) {
  companySettingChanges(
    companyId: $companyId
    pagination: $pagination
    source: $source
    settingSearch: $settingSearch
    settingKeys: $settingKeys
    order: $order
  ) {
    data {
      id
      changedById
      changedByDisplay
      source
      setting
      oldValue
      newValue
      mutationName
      occurredAt
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useCompanySettingChangesQuery__
 *
 * To run a query within a React component, call `useCompanySettingChangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanySettingChangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanySettingChangesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      pagination: // value for 'pagination'
 *      source: // value for 'source'
 *      settingSearch: // value for 'settingSearch'
 *      settingKeys: // value for 'settingKeys'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCompanySettingChangesQuery(baseOptions: Apollo.QueryHookOptions<CompanySettingChangesQuery, CompanySettingChangesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanySettingChangesQuery, CompanySettingChangesQueryVariables>(CompanySettingChangesDocument, options);
      }
export function useCompanySettingChangesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanySettingChangesQuery, CompanySettingChangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanySettingChangesQuery, CompanySettingChangesQueryVariables>(CompanySettingChangesDocument, options);
        }
export type CompanySettingChangesQueryHookResult = ReturnType<typeof useCompanySettingChangesQuery>;
export type CompanySettingChangesLazyQueryHookResult = ReturnType<typeof useCompanySettingChangesLazyQuery>;
export type CompanySettingChangesQueryResult = Apollo.QueryResult<CompanySettingChangesQuery, CompanySettingChangesQueryVariables>;
export const CompanyUsersFindManyPaginatedDocument = gql`
    query CompanyUsersFindManyPaginated($args: CompanyUsersArgs!, $order: CompanyUsersOrderOptions, $paginate: OffsetBasedPaginationArgs) {
  companyUsers: CompanyUsersFindManyPaginated(
    args: $args
    order: $order
    paginate: $paginate
  ) {
    data {
      group {
        id
        subId
        companyId
        name
        description
        membersCount
        membersPreview {
          id
          firstName
          lastName
          email
        }
      }
      user {
        id
        subId
        firstName
        lastName
        email
        avatarUrl
      }
      inProjectTeam {
        asGroupMember
        asIndividual
      }
      inStageCandidate {
        asGroupMember
        asIndividual
      }
      inUserGroup {
        asGroupMember
        asIndividual
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useCompanyUsersFindManyPaginatedQuery__
 *
 * To run a query within a React component, call `useCompanyUsersFindManyPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyUsersFindManyPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyUsersFindManyPaginatedQuery({
 *   variables: {
 *      args: // value for 'args'
 *      order: // value for 'order'
 *      paginate: // value for 'paginate'
 *   },
 * });
 */
export function useCompanyUsersFindManyPaginatedQuery(baseOptions: Apollo.QueryHookOptions<CompanyUsersFindManyPaginatedQuery, CompanyUsersFindManyPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyUsersFindManyPaginatedQuery, CompanyUsersFindManyPaginatedQueryVariables>(CompanyUsersFindManyPaginatedDocument, options);
      }
export function useCompanyUsersFindManyPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyUsersFindManyPaginatedQuery, CompanyUsersFindManyPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyUsersFindManyPaginatedQuery, CompanyUsersFindManyPaginatedQueryVariables>(CompanyUsersFindManyPaginatedDocument, options);
        }
export type CompanyUsersFindManyPaginatedQueryHookResult = ReturnType<typeof useCompanyUsersFindManyPaginatedQuery>;
export type CompanyUsersFindManyPaginatedLazyQueryHookResult = ReturnType<typeof useCompanyUsersFindManyPaginatedLazyQuery>;
export type CompanyUsersFindManyPaginatedQueryResult = Apollo.QueryResult<CompanyUsersFindManyPaginatedQuery, CompanyUsersFindManyPaginatedQueryVariables>;
export const CompanyFindManyUsersWithRolesDocument = gql`
    query CompanyFindManyUsersWithRoles($take: Int!, $skip: Int!, $userRoles: [IdentityPermissionRole!]!, $companyIds: [Int!]) {
  CompanyFindManyUsersWithRoles(
    take: $take
    skip: $skip
    userRoles: $userRoles
    companyIds: $companyIds
  ) {
    ...ShallowCompanyUserInfoPaginated
  }
}
    ${ShallowCompanyUserInfoPaginatedFragmentDoc}`;

/**
 * __useCompanyFindManyUsersWithRolesQuery__
 *
 * To run a query within a React component, call `useCompanyFindManyUsersWithRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyFindManyUsersWithRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyFindManyUsersWithRolesQuery({
 *   variables: {
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      userRoles: // value for 'userRoles'
 *      companyIds: // value for 'companyIds'
 *   },
 * });
 */
export function useCompanyFindManyUsersWithRolesQuery(baseOptions: Apollo.QueryHookOptions<CompanyFindManyUsersWithRolesQuery, CompanyFindManyUsersWithRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyFindManyUsersWithRolesQuery, CompanyFindManyUsersWithRolesQueryVariables>(CompanyFindManyUsersWithRolesDocument, options);
      }
export function useCompanyFindManyUsersWithRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyFindManyUsersWithRolesQuery, CompanyFindManyUsersWithRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyFindManyUsersWithRolesQuery, CompanyFindManyUsersWithRolesQueryVariables>(CompanyFindManyUsersWithRolesDocument, options);
        }
export type CompanyFindManyUsersWithRolesQueryHookResult = ReturnType<typeof useCompanyFindManyUsersWithRolesQuery>;
export type CompanyFindManyUsersWithRolesLazyQueryHookResult = ReturnType<typeof useCompanyFindManyUsersWithRolesLazyQuery>;
export type CompanyFindManyUsersWithRolesQueryResult = Apollo.QueryResult<CompanyFindManyUsersWithRolesQuery, CompanyFindManyUsersWithRolesQueryVariables>;
export const TraitSoftSkillContextCsvGenerateAndUploadDocument = gql`
    query TraitSoftSkillContextCsvGenerateAndUpload($ids: [Int!]) {
  TraitSoftSkillContextCsvGenerateAndUpload(ids: $ids) {
    ...Blob
  }
}
    ${BlobFragmentDoc}`;

/**
 * __useTraitSoftSkillContextCsvGenerateAndUploadQuery__
 *
 * To run a query within a React component, call `useTraitSoftSkillContextCsvGenerateAndUploadQuery` and pass it any options that fit your needs.
 * When your component renders, `useTraitSoftSkillContextCsvGenerateAndUploadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTraitSoftSkillContextCsvGenerateAndUploadQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useTraitSoftSkillContextCsvGenerateAndUploadQuery(baseOptions?: Apollo.QueryHookOptions<TraitSoftSkillContextCsvGenerateAndUploadQuery, TraitSoftSkillContextCsvGenerateAndUploadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TraitSoftSkillContextCsvGenerateAndUploadQuery, TraitSoftSkillContextCsvGenerateAndUploadQueryVariables>(TraitSoftSkillContextCsvGenerateAndUploadDocument, options);
      }
export function useTraitSoftSkillContextCsvGenerateAndUploadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TraitSoftSkillContextCsvGenerateAndUploadQuery, TraitSoftSkillContextCsvGenerateAndUploadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TraitSoftSkillContextCsvGenerateAndUploadQuery, TraitSoftSkillContextCsvGenerateAndUploadQueryVariables>(TraitSoftSkillContextCsvGenerateAndUploadDocument, options);
        }
export type TraitSoftSkillContextCsvGenerateAndUploadQueryHookResult = ReturnType<typeof useTraitSoftSkillContextCsvGenerateAndUploadQuery>;
export type TraitSoftSkillContextCsvGenerateAndUploadLazyQueryHookResult = ReturnType<typeof useTraitSoftSkillContextCsvGenerateAndUploadLazyQuery>;
export type TraitSoftSkillContextCsvGenerateAndUploadQueryResult = Apollo.QueryResult<TraitSoftSkillContextCsvGenerateAndUploadQuery, TraitSoftSkillContextCsvGenerateAndUploadQueryVariables>;
export const GetFormReportCsvDocument = gql`
    query getFormReportCSV($formManagerType: FormManagerType!, $formType: FormType!, $formOwnerId: Int!, $associatedId: Int!) {
  getFormReportCSV(
    formManagerType: $formManagerType
    formType: $formType
    formOwnerId: $formOwnerId
    associatedId: $associatedId
  )
}
    `;

/**
 * __useGetFormReportCsvQuery__
 *
 * To run a query within a React component, call `useGetFormReportCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormReportCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormReportCsvQuery({
 *   variables: {
 *      formManagerType: // value for 'formManagerType'
 *      formType: // value for 'formType'
 *      formOwnerId: // value for 'formOwnerId'
 *      associatedId: // value for 'associatedId'
 *   },
 * });
 */
export function useGetFormReportCsvQuery(baseOptions: Apollo.QueryHookOptions<GetFormReportCsvQuery, GetFormReportCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormReportCsvQuery, GetFormReportCsvQueryVariables>(GetFormReportCsvDocument, options);
      }
export function useGetFormReportCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormReportCsvQuery, GetFormReportCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormReportCsvQuery, GetFormReportCsvQueryVariables>(GetFormReportCsvDocument, options);
        }
export type GetFormReportCsvQueryHookResult = ReturnType<typeof useGetFormReportCsvQuery>;
export type GetFormReportCsvLazyQueryHookResult = ReturnType<typeof useGetFormReportCsvLazyQuery>;
export type GetFormReportCsvQueryResult = Apollo.QueryResult<GetFormReportCsvQuery, GetFormReportCsvQueryVariables>;
export const FormManagerTypesDocument = gql`
    query FormManagerTypes {
  FormReportFindFormManagerTypes {
    formManagerTypes
  }
}
    `;

/**
 * __useFormManagerTypesQuery__
 *
 * To run a query within a React component, call `useFormManagerTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormManagerTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormManagerTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFormManagerTypesQuery(baseOptions?: Apollo.QueryHookOptions<FormManagerTypesQuery, FormManagerTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormManagerTypesQuery, FormManagerTypesQueryVariables>(FormManagerTypesDocument, options);
      }
export function useFormManagerTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormManagerTypesQuery, FormManagerTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormManagerTypesQuery, FormManagerTypesQueryVariables>(FormManagerTypesDocument, options);
        }
export type FormManagerTypesQueryHookResult = ReturnType<typeof useFormManagerTypesQuery>;
export type FormManagerTypesLazyQueryHookResult = ReturnType<typeof useFormManagerTypesLazyQuery>;
export type FormManagerTypesQueryResult = Apollo.QueryResult<FormManagerTypesQuery, FormManagerTypesQueryVariables>;
export const FormTypesDocument = gql`
    query FormTypes($formManagerType: FormManagerType!) {
  FormReportFindFormTypes(formManagerType: $formManagerType) {
    formTypes
  }
}
    `;

/**
 * __useFormTypesQuery__
 *
 * To run a query within a React component, call `useFormTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormTypesQuery({
 *   variables: {
 *      formManagerType: // value for 'formManagerType'
 *   },
 * });
 */
export function useFormTypesQuery(baseOptions: Apollo.QueryHookOptions<FormTypesQuery, FormTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormTypesQuery, FormTypesQueryVariables>(FormTypesDocument, options);
      }
export function useFormTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormTypesQuery, FormTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormTypesQuery, FormTypesQueryVariables>(FormTypesDocument, options);
        }
export type FormTypesQueryHookResult = ReturnType<typeof useFormTypesQuery>;
export type FormTypesLazyQueryHookResult = ReturnType<typeof useFormTypesLazyQuery>;
export type FormTypesQueryResult = Apollo.QueryResult<FormTypesQuery, FormTypesQueryVariables>;
export const FormOwnersDocument = gql`
    query FormOwners($formManagerType: FormManagerType!, $formType: FormType!) {
  FormReportFindFormOwners(formManagerType: $formManagerType, formType: $formType) {
    id
    name
  }
}
    `;

/**
 * __useFormOwnersQuery__
 *
 * To run a query within a React component, call `useFormOwnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormOwnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormOwnersQuery({
 *   variables: {
 *      formManagerType: // value for 'formManagerType'
 *      formType: // value for 'formType'
 *   },
 * });
 */
export function useFormOwnersQuery(baseOptions: Apollo.QueryHookOptions<FormOwnersQuery, FormOwnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormOwnersQuery, FormOwnersQueryVariables>(FormOwnersDocument, options);
      }
export function useFormOwnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormOwnersQuery, FormOwnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormOwnersQuery, FormOwnersQueryVariables>(FormOwnersDocument, options);
        }
export type FormOwnersQueryHookResult = ReturnType<typeof useFormOwnersQuery>;
export type FormOwnersLazyQueryHookResult = ReturnType<typeof useFormOwnersLazyQuery>;
export type FormOwnersQueryResult = Apollo.QueryResult<FormOwnersQuery, FormOwnersQueryVariables>;
export const FormAssociatesDocument = gql`
    query FormAssociates($formManagerType: FormManagerType!, $formType: FormType!, $formOwnerId: Int!) {
  FormReportFindAssociatedIds(
    formManagerType: $formManagerType
    formType: $formType
    formOwnerId: $formOwnerId
  ) {
    associatedIds
  }
}
    `;

/**
 * __useFormAssociatesQuery__
 *
 * To run a query within a React component, call `useFormAssociatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormAssociatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormAssociatesQuery({
 *   variables: {
 *      formManagerType: // value for 'formManagerType'
 *      formType: // value for 'formType'
 *      formOwnerId: // value for 'formOwnerId'
 *   },
 * });
 */
export function useFormAssociatesQuery(baseOptions: Apollo.QueryHookOptions<FormAssociatesQuery, FormAssociatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormAssociatesQuery, FormAssociatesQueryVariables>(FormAssociatesDocument, options);
      }
export function useFormAssociatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormAssociatesQuery, FormAssociatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormAssociatesQuery, FormAssociatesQueryVariables>(FormAssociatesDocument, options);
        }
export type FormAssociatesQueryHookResult = ReturnType<typeof useFormAssociatesQuery>;
export type FormAssociatesLazyQueryHookResult = ReturnType<typeof useFormAssociatesLazyQuery>;
export type FormAssociatesQueryResult = Apollo.QueryResult<FormAssociatesQuery, FormAssociatesQueryVariables>;
export const InterviewGuideBlueprintDocument = gql`
    query InterviewGuideBlueprint($subId: ID!) {
  InterviewGuideBlueprint(subId: $subId) {
    id
    subId
    status
    version
    generationStatus
    questions {
      id
      subId
      type
      position
      content
      extraContent
      duration
      isPlaceholder
      isMandatory
      isEditable
      isEdited
      softSkillJunctions {
        softSkill {
          id
          name
        }
        indicators {
          __typename
          indicator
          description
          reason
          probe
          trigger
          ... on SoftSkillIndicatorV2 {
            scores {
              score
              label
              gateway_criteria
              differentiation
            }
            negative_evidence {
              red_flags {
                pattern
                example
              }
              score_reducing_patterns {
                pattern
                example
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useInterviewGuideBlueprintQuery__
 *
 * To run a query within a React component, call `useInterviewGuideBlueprintQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterviewGuideBlueprintQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewGuideBlueprintQuery({
 *   variables: {
 *      subId: // value for 'subId'
 *   },
 * });
 */
export function useInterviewGuideBlueprintQuery(baseOptions: Apollo.QueryHookOptions<InterviewGuideBlueprintQuery, InterviewGuideBlueprintQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterviewGuideBlueprintQuery, InterviewGuideBlueprintQueryVariables>(InterviewGuideBlueprintDocument, options);
      }
export function useInterviewGuideBlueprintLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterviewGuideBlueprintQuery, InterviewGuideBlueprintQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterviewGuideBlueprintQuery, InterviewGuideBlueprintQueryVariables>(InterviewGuideBlueprintDocument, options);
        }
export type InterviewGuideBlueprintQueryHookResult = ReturnType<typeof useInterviewGuideBlueprintQuery>;
export type InterviewGuideBlueprintLazyQueryHookResult = ReturnType<typeof useInterviewGuideBlueprintLazyQuery>;
export type InterviewGuideBlueprintQueryResult = Apollo.QueryResult<InterviewGuideBlueprintQuery, InterviewGuideBlueprintQueryVariables>;
export const InterviewQuestionRoleLevelContentFindManyAndCountDocument = gql`
    query InterviewQuestionRoleLevelContentFindManyAndCount($softSkillIds: [Int!], $traitIds: [Int!], $roleLevels: [ContentRoleLevel!], $classifications: [ContentClassification!], $take: Int!, $page: Int!, $order: [String!]) {
  interviewQuestionContent: InterviewQuestionRoleLevelContentFindManyAndCount(
    softSkillIds: $softSkillIds
    traitIds: $traitIds
    roleLevels: $roleLevels
    classifications: $classifications
    take: $take
    page: $page
    order: $order
  ) {
    interviewQuestionContent {
      id
      softSkill {
        name
      }
      trait {
        name
      }
      softSkillId
      traitId
      classification
      roleLevel
      summary
      feedback
      reasonForQuestion
      mainQuestion
      subQuestions
    }
    count
  }
}
    `;

/**
 * __useInterviewQuestionRoleLevelContentFindManyAndCountQuery__
 *
 * To run a query within a React component, call `useInterviewQuestionRoleLevelContentFindManyAndCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterviewQuestionRoleLevelContentFindManyAndCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewQuestionRoleLevelContentFindManyAndCountQuery({
 *   variables: {
 *      softSkillIds: // value for 'softSkillIds'
 *      traitIds: // value for 'traitIds'
 *      roleLevels: // value for 'roleLevels'
 *      classifications: // value for 'classifications'
 *      take: // value for 'take'
 *      page: // value for 'page'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useInterviewQuestionRoleLevelContentFindManyAndCountQuery(baseOptions: Apollo.QueryHookOptions<InterviewQuestionRoleLevelContentFindManyAndCountQuery, InterviewQuestionRoleLevelContentFindManyAndCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterviewQuestionRoleLevelContentFindManyAndCountQuery, InterviewQuestionRoleLevelContentFindManyAndCountQueryVariables>(InterviewQuestionRoleLevelContentFindManyAndCountDocument, options);
      }
export function useInterviewQuestionRoleLevelContentFindManyAndCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterviewQuestionRoleLevelContentFindManyAndCountQuery, InterviewQuestionRoleLevelContentFindManyAndCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterviewQuestionRoleLevelContentFindManyAndCountQuery, InterviewQuestionRoleLevelContentFindManyAndCountQueryVariables>(InterviewQuestionRoleLevelContentFindManyAndCountDocument, options);
        }
export type InterviewQuestionRoleLevelContentFindManyAndCountQueryHookResult = ReturnType<typeof useInterviewQuestionRoleLevelContentFindManyAndCountQuery>;
export type InterviewQuestionRoleLevelContentFindManyAndCountLazyQueryHookResult = ReturnType<typeof useInterviewQuestionRoleLevelContentFindManyAndCountLazyQuery>;
export type InterviewQuestionRoleLevelContentFindManyAndCountQueryResult = Apollo.QueryResult<InterviewQuestionRoleLevelContentFindManyAndCountQuery, InterviewQuestionRoleLevelContentFindManyAndCountQueryVariables>;
export const JobRoleFindOneDocument = gql`
    query JobRoleFindOne($id: Int) {
  JobRoleFindOne(id: $id) {
    ...JobRole
  }
}
    ${JobRoleFragmentDoc}`;

/**
 * __useJobRoleFindOneQuery__
 *
 * To run a query within a React component, call `useJobRoleFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobRoleFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobRoleFindOneQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJobRoleFindOneQuery(baseOptions?: Apollo.QueryHookOptions<JobRoleFindOneQuery, JobRoleFindOneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobRoleFindOneQuery, JobRoleFindOneQueryVariables>(JobRoleFindOneDocument, options);
      }
export function useJobRoleFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobRoleFindOneQuery, JobRoleFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobRoleFindOneQuery, JobRoleFindOneQueryVariables>(JobRoleFindOneDocument, options);
        }
export type JobRoleFindOneQueryHookResult = ReturnType<typeof useJobRoleFindOneQuery>;
export type JobRoleFindOneLazyQueryHookResult = ReturnType<typeof useJobRoleFindOneLazyQuery>;
export type JobRoleFindOneQueryResult = Apollo.QueryResult<JobRoleFindOneQuery, JobRoleFindOneQueryVariables>;
export const JobRoleFindManyDocument = gql`
    query JobRoleFindMany($companyId: Int, $roleLevel: ContentRoleLevel) {
  JobRoleFindMany(companyId: $companyId, roleLevel: $roleLevel) {
    ...JobRoleOverview
  }
}
    ${JobRoleOverviewFragmentDoc}`;

/**
 * __useJobRoleFindManyQuery__
 *
 * To run a query within a React component, call `useJobRoleFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobRoleFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobRoleFindManyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      roleLevel: // value for 'roleLevel'
 *   },
 * });
 */
export function useJobRoleFindManyQuery(baseOptions?: Apollo.QueryHookOptions<JobRoleFindManyQuery, JobRoleFindManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobRoleFindManyQuery, JobRoleFindManyQueryVariables>(JobRoleFindManyDocument, options);
      }
export function useJobRoleFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobRoleFindManyQuery, JobRoleFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobRoleFindManyQuery, JobRoleFindManyQueryVariables>(JobRoleFindManyDocument, options);
        }
export type JobRoleFindManyQueryHookResult = ReturnType<typeof useJobRoleFindManyQuery>;
export type JobRoleFindManyLazyQueryHookResult = ReturnType<typeof useJobRoleFindManyLazyQuery>;
export type JobRoleFindManyQueryResult = Apollo.QueryResult<JobRoleFindManyQuery, JobRoleFindManyQueryVariables>;
export const JobRoleFindManyPaginatedDocument = gql`
    query JobRoleFindManyPaginated($pagination: OffsetBasedPaginationArgs!, $order: JobRoleFindManyPaginatedOrderArgs, $filters: JobRoleFindManyPaginatedFiltersArgs) {
  JobRoleFindManyPaginated(
    pagination: $pagination
    order: $order
    filters: $filters
  ) {
    ...JobRolePaginated
  }
}
    ${JobRolePaginatedFragmentDoc}`;

/**
 * __useJobRoleFindManyPaginatedQuery__
 *
 * To run a query within a React component, call `useJobRoleFindManyPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobRoleFindManyPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobRoleFindManyPaginatedQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useJobRoleFindManyPaginatedQuery(baseOptions: Apollo.QueryHookOptions<JobRoleFindManyPaginatedQuery, JobRoleFindManyPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobRoleFindManyPaginatedQuery, JobRoleFindManyPaginatedQueryVariables>(JobRoleFindManyPaginatedDocument, options);
      }
export function useJobRoleFindManyPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobRoleFindManyPaginatedQuery, JobRoleFindManyPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobRoleFindManyPaginatedQuery, JobRoleFindManyPaginatedQueryVariables>(JobRoleFindManyPaginatedDocument, options);
        }
export type JobRoleFindManyPaginatedQueryHookResult = ReturnType<typeof useJobRoleFindManyPaginatedQuery>;
export type JobRoleFindManyPaginatedLazyQueryHookResult = ReturnType<typeof useJobRoleFindManyPaginatedLazyQuery>;
export type JobRoleFindManyPaginatedQueryResult = Apollo.QueryResult<JobRoleFindManyPaginatedQuery, JobRoleFindManyPaginatedQueryVariables>;
export const KomboIntegrationFindOneDocument = gql`
    query KomboIntegrationFindOne($companyId: Int!) {
  komboIntegrationsFindOne(companyId: $companyId) {
    id
    tool
    enabled
    assessmentIntegrationId
  }
}
    `;

/**
 * __useKomboIntegrationFindOneQuery__
 *
 * To run a query within a React component, call `useKomboIntegrationFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useKomboIntegrationFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKomboIntegrationFindOneQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useKomboIntegrationFindOneQuery(baseOptions: Apollo.QueryHookOptions<KomboIntegrationFindOneQuery, KomboIntegrationFindOneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KomboIntegrationFindOneQuery, KomboIntegrationFindOneQueryVariables>(KomboIntegrationFindOneDocument, options);
      }
export function useKomboIntegrationFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KomboIntegrationFindOneQuery, KomboIntegrationFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KomboIntegrationFindOneQuery, KomboIntegrationFindOneQueryVariables>(KomboIntegrationFindOneDocument, options);
        }
export type KomboIntegrationFindOneQueryHookResult = ReturnType<typeof useKomboIntegrationFindOneQuery>;
export type KomboIntegrationFindOneLazyQueryHookResult = ReturnType<typeof useKomboIntegrationFindOneLazyQuery>;
export type KomboIntegrationFindOneQueryResult = Apollo.QueryResult<KomboIntegrationFindOneQuery, KomboIntegrationFindOneQueryVariables>;
export const KomboIntegrationsListDocument = gql`
    query KomboIntegrationsList($skip: Int!, $take: Int!) {
  komboIntegrationsFindManyPaginated(skip: $skip, take: $take) {
    data {
      ...KomboIntegrationListFields
    }
    pageInfo {
      itemsTotal
    }
  }
}
    ${KomboIntegrationListFieldsFragmentDoc}`;

/**
 * __useKomboIntegrationsListQuery__
 *
 * To run a query within a React component, call `useKomboIntegrationsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useKomboIntegrationsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKomboIntegrationsListQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useKomboIntegrationsListQuery(baseOptions: Apollo.QueryHookOptions<KomboIntegrationsListQuery, KomboIntegrationsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KomboIntegrationsListQuery, KomboIntegrationsListQueryVariables>(KomboIntegrationsListDocument, options);
      }
export function useKomboIntegrationsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KomboIntegrationsListQuery, KomboIntegrationsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KomboIntegrationsListQuery, KomboIntegrationsListQueryVariables>(KomboIntegrationsListDocument, options);
        }
export type KomboIntegrationsListQueryHookResult = ReturnType<typeof useKomboIntegrationsListQuery>;
export type KomboIntegrationsListLazyQueryHookResult = ReturnType<typeof useKomboIntegrationsListLazyQuery>;
export type KomboIntegrationsListQueryResult = Apollo.QueryResult<KomboIntegrationsListQuery, KomboIntegrationsListQueryVariables>;
export const ProjectsDocument = gql`
    query Projects {
  projects: getAllProjects {
    ...Project
  }
}
    ${ProjectFragmentDoc}`;

/**
 * __useProjectsQuery__
 *
 * To run a query within a React component, call `useProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProjectsQuery(baseOptions?: Apollo.QueryHookOptions<ProjectsQuery, ProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, options);
      }
export function useProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectsQuery, ProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, options);
        }
export type ProjectsQueryHookResult = ReturnType<typeof useProjectsQuery>;
export type ProjectsLazyQueryHookResult = ReturnType<typeof useProjectsLazyQuery>;
export type ProjectsQueryResult = Apollo.QueryResult<ProjectsQuery, ProjectsQueryVariables>;
export const GetProjectByIdDocument = gql`
    query getProjectById($id: Float!) {
  project: getProjectById(id: $id) {
    ...Project
  }
}
    ${ProjectFragmentDoc}`;

/**
 * __useGetProjectByIdQuery__
 *
 * To run a query within a React component, call `useGetProjectByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectByIdQuery(baseOptions: Apollo.QueryHookOptions<GetProjectByIdQuery, GetProjectByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectByIdQuery, GetProjectByIdQueryVariables>(GetProjectByIdDocument, options);
      }
export function useGetProjectByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectByIdQuery, GetProjectByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectByIdQuery, GetProjectByIdQueryVariables>(GetProjectByIdDocument, options);
        }
export type GetProjectByIdQueryHookResult = ReturnType<typeof useGetProjectByIdQuery>;
export type GetProjectByIdLazyQueryHookResult = ReturnType<typeof useGetProjectByIdLazyQuery>;
export type GetProjectByIdQueryResult = Apollo.QueryResult<GetProjectByIdQuery, GetProjectByIdQueryVariables>;
export const ProjectBaseGetProjectByIdDocument = gql`
    query ProjectBaseGetProjectById($id: Float!) {
  project: getProjectById(id: $id) {
    ...ProjectBase
  }
}
    ${ProjectBaseFragmentDoc}`;

/**
 * __useProjectBaseGetProjectByIdQuery__
 *
 * To run a query within a React component, call `useProjectBaseGetProjectByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectBaseGetProjectByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectBaseGetProjectByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectBaseGetProjectByIdQuery(baseOptions: Apollo.QueryHookOptions<ProjectBaseGetProjectByIdQuery, ProjectBaseGetProjectByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectBaseGetProjectByIdQuery, ProjectBaseGetProjectByIdQueryVariables>(ProjectBaseGetProjectByIdDocument, options);
      }
export function useProjectBaseGetProjectByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectBaseGetProjectByIdQuery, ProjectBaseGetProjectByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectBaseGetProjectByIdQuery, ProjectBaseGetProjectByIdQueryVariables>(ProjectBaseGetProjectByIdDocument, options);
        }
export type ProjectBaseGetProjectByIdQueryHookResult = ReturnType<typeof useProjectBaseGetProjectByIdQuery>;
export type ProjectBaseGetProjectByIdLazyQueryHookResult = ReturnType<typeof useProjectBaseGetProjectByIdLazyQuery>;
export type ProjectBaseGetProjectByIdQueryResult = Apollo.QueryResult<ProjectBaseGetProjectByIdQuery, ProjectBaseGetProjectByIdQueryVariables>;
export const ProjectFindManyByCompanyDocument = gql`
    query ProjectFindManyByCompany($companyId: Int!) {
  projects: ProjectFindManyByCompany(companyId: $companyId) {
    ...Project
  }
}
    ${ProjectFragmentDoc}`;

/**
 * __useProjectFindManyByCompanyQuery__
 *
 * To run a query within a React component, call `useProjectFindManyByCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectFindManyByCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectFindManyByCompanyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useProjectFindManyByCompanyQuery(baseOptions: Apollo.QueryHookOptions<ProjectFindManyByCompanyQuery, ProjectFindManyByCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectFindManyByCompanyQuery, ProjectFindManyByCompanyQueryVariables>(ProjectFindManyByCompanyDocument, options);
      }
export function useProjectFindManyByCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectFindManyByCompanyQuery, ProjectFindManyByCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectFindManyByCompanyQuery, ProjectFindManyByCompanyQueryVariables>(ProjectFindManyByCompanyDocument, options);
        }
export type ProjectFindManyByCompanyQueryHookResult = ReturnType<typeof useProjectFindManyByCompanyQuery>;
export type ProjectFindManyByCompanyLazyQueryHookResult = ReturnType<typeof useProjectFindManyByCompanyLazyQuery>;
export type ProjectFindManyByCompanyQueryResult = Apollo.QueryResult<ProjectFindManyByCompanyQuery, ProjectFindManyByCompanyQueryVariables>;
export const ResultsPageProjectFindManyByCompanyDocument = gql`
    query ResultsPageProjectFindManyByCompany($companyId: Int!) {
  projects: ProjectFindManyByCompany(companyId: $companyId) {
    id
    name
    isArchived
    status
  }
}
    `;

/**
 * __useResultsPageProjectFindManyByCompanyQuery__
 *
 * To run a query within a React component, call `useResultsPageProjectFindManyByCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useResultsPageProjectFindManyByCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResultsPageProjectFindManyByCompanyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useResultsPageProjectFindManyByCompanyQuery(baseOptions: Apollo.QueryHookOptions<ResultsPageProjectFindManyByCompanyQuery, ResultsPageProjectFindManyByCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResultsPageProjectFindManyByCompanyQuery, ResultsPageProjectFindManyByCompanyQueryVariables>(ResultsPageProjectFindManyByCompanyDocument, options);
      }
export function useResultsPageProjectFindManyByCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResultsPageProjectFindManyByCompanyQuery, ResultsPageProjectFindManyByCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResultsPageProjectFindManyByCompanyQuery, ResultsPageProjectFindManyByCompanyQueryVariables>(ResultsPageProjectFindManyByCompanyDocument, options);
        }
export type ResultsPageProjectFindManyByCompanyQueryHookResult = ReturnType<typeof useResultsPageProjectFindManyByCompanyQuery>;
export type ResultsPageProjectFindManyByCompanyLazyQueryHookResult = ReturnType<typeof useResultsPageProjectFindManyByCompanyLazyQuery>;
export type ResultsPageProjectFindManyByCompanyQueryResult = Apollo.QueryResult<ResultsPageProjectFindManyByCompanyQuery, ResultsPageProjectFindManyByCompanyQueryVariables>;
export const ProjectsFindManyPaginatedDocument = gql`
    query ProjectsFindManyPaginated($filters: ProjectFilterArgs, $order: ProjectOrderArgs, $pagination: OffsetBasedPaginationArgs) {
  Projects(filters: $filters, order: $order, pagination: $pagination) {
    data {
      ...ProjectTableItem
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${ProjectTableItemFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useProjectsFindManyPaginatedQuery__
 *
 * To run a query within a React component, call `useProjectsFindManyPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsFindManyPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsFindManyPaginatedQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useProjectsFindManyPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<ProjectsFindManyPaginatedQuery, ProjectsFindManyPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectsFindManyPaginatedQuery, ProjectsFindManyPaginatedQueryVariables>(ProjectsFindManyPaginatedDocument, options);
      }
export function useProjectsFindManyPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectsFindManyPaginatedQuery, ProjectsFindManyPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectsFindManyPaginatedQuery, ProjectsFindManyPaginatedQueryVariables>(ProjectsFindManyPaginatedDocument, options);
        }
export type ProjectsFindManyPaginatedQueryHookResult = ReturnType<typeof useProjectsFindManyPaginatedQuery>;
export type ProjectsFindManyPaginatedLazyQueryHookResult = ReturnType<typeof useProjectsFindManyPaginatedLazyQuery>;
export type ProjectsFindManyPaginatedQueryResult = Apollo.QueryResult<ProjectsFindManyPaginatedQuery, ProjectsFindManyPaginatedQueryVariables>;
export const ProjectGetInterviewLinkCountDocument = gql`
    query ProjectGetInterviewLinkCount($projectId: Int!) {
  ProjectGetInterviewLinkCount(projectId: $projectId)
}
    `;

/**
 * __useProjectGetInterviewLinkCountQuery__
 *
 * To run a query within a React component, call `useProjectGetInterviewLinkCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectGetInterviewLinkCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectGetInterviewLinkCountQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectGetInterviewLinkCountQuery(baseOptions: Apollo.QueryHookOptions<ProjectGetInterviewLinkCountQuery, ProjectGetInterviewLinkCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectGetInterviewLinkCountQuery, ProjectGetInterviewLinkCountQueryVariables>(ProjectGetInterviewLinkCountDocument, options);
      }
export function useProjectGetInterviewLinkCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectGetInterviewLinkCountQuery, ProjectGetInterviewLinkCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectGetInterviewLinkCountQuery, ProjectGetInterviewLinkCountQueryVariables>(ProjectGetInterviewLinkCountDocument, options);
        }
export type ProjectGetInterviewLinkCountQueryHookResult = ReturnType<typeof useProjectGetInterviewLinkCountQuery>;
export type ProjectGetInterviewLinkCountLazyQueryHookResult = ReturnType<typeof useProjectGetInterviewLinkCountLazyQuery>;
export type ProjectGetInterviewLinkCountQueryResult = Apollo.QueryResult<ProjectGetInterviewLinkCountQuery, ProjectGetInterviewLinkCountQueryVariables>;
export const ProjectGetCandidateStageBreakdownDocument = gql`
    query ProjectGetCandidateStageBreakdown($projectId: Int!) {
  ProjectGetCandidateStageBreakdown(projectId: $projectId) {
    category
    candidatesCount
    completedCount
  }
}
    `;

/**
 * __useProjectGetCandidateStageBreakdownQuery__
 *
 * To run a query within a React component, call `useProjectGetCandidateStageBreakdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectGetCandidateStageBreakdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectGetCandidateStageBreakdownQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectGetCandidateStageBreakdownQuery(baseOptions: Apollo.QueryHookOptions<ProjectGetCandidateStageBreakdownQuery, ProjectGetCandidateStageBreakdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectGetCandidateStageBreakdownQuery, ProjectGetCandidateStageBreakdownQueryVariables>(ProjectGetCandidateStageBreakdownDocument, options);
      }
export function useProjectGetCandidateStageBreakdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectGetCandidateStageBreakdownQuery, ProjectGetCandidateStageBreakdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectGetCandidateStageBreakdownQuery, ProjectGetCandidateStageBreakdownQueryVariables>(ProjectGetCandidateStageBreakdownDocument, options);
        }
export type ProjectGetCandidateStageBreakdownQueryHookResult = ReturnType<typeof useProjectGetCandidateStageBreakdownQuery>;
export type ProjectGetCandidateStageBreakdownLazyQueryHookResult = ReturnType<typeof useProjectGetCandidateStageBreakdownLazyQuery>;
export type ProjectGetCandidateStageBreakdownQueryResult = Apollo.QueryResult<ProjectGetCandidateStageBreakdownQuery, ProjectGetCandidateStageBreakdownQueryVariables>;
export const ProjectGetAllowedTransitionsDocument = gql`
    query ProjectGetAllowedTransitions($projectId: Int!, $app: SzApp!) {
  ProjectGetAllowedTransitions(projectId: $projectId, app: $app)
}
    `;

/**
 * __useProjectGetAllowedTransitionsQuery__
 *
 * To run a query within a React component, call `useProjectGetAllowedTransitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectGetAllowedTransitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectGetAllowedTransitionsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      app: // value for 'app'
 *   },
 * });
 */
export function useProjectGetAllowedTransitionsQuery(baseOptions: Apollo.QueryHookOptions<ProjectGetAllowedTransitionsQuery, ProjectGetAllowedTransitionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectGetAllowedTransitionsQuery, ProjectGetAllowedTransitionsQueryVariables>(ProjectGetAllowedTransitionsDocument, options);
      }
export function useProjectGetAllowedTransitionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectGetAllowedTransitionsQuery, ProjectGetAllowedTransitionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectGetAllowedTransitionsQuery, ProjectGetAllowedTransitionsQueryVariables>(ProjectGetAllowedTransitionsDocument, options);
        }
export type ProjectGetAllowedTransitionsQueryHookResult = ReturnType<typeof useProjectGetAllowedTransitionsQuery>;
export type ProjectGetAllowedTransitionsLazyQueryHookResult = ReturnType<typeof useProjectGetAllowedTransitionsLazyQuery>;
export type ProjectGetAllowedTransitionsQueryResult = Apollo.QueryResult<ProjectGetAllowedTransitionsQuery, ProjectGetAllowedTransitionsQueryVariables>;
export const ProjectValidatePolicyActionsDocument = gql`
    query ProjectValidatePolicyActions($projectId: Int!, $actions: [ProjectAction!]!, $app: SzApp!) {
  ProjectValidatePolicyActions(
    projectId: $projectId
    actions: $actions
    app: $app
  )
}
    `;

/**
 * __useProjectValidatePolicyActionsQuery__
 *
 * To run a query within a React component, call `useProjectValidatePolicyActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectValidatePolicyActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectValidatePolicyActionsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      actions: // value for 'actions'
 *      app: // value for 'app'
 *   },
 * });
 */
export function useProjectValidatePolicyActionsQuery(baseOptions: Apollo.QueryHookOptions<ProjectValidatePolicyActionsQuery, ProjectValidatePolicyActionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectValidatePolicyActionsQuery, ProjectValidatePolicyActionsQueryVariables>(ProjectValidatePolicyActionsDocument, options);
      }
export function useProjectValidatePolicyActionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectValidatePolicyActionsQuery, ProjectValidatePolicyActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectValidatePolicyActionsQuery, ProjectValidatePolicyActionsQueryVariables>(ProjectValidatePolicyActionsDocument, options);
        }
export type ProjectValidatePolicyActionsQueryHookResult = ReturnType<typeof useProjectValidatePolicyActionsQuery>;
export type ProjectValidatePolicyActionsLazyQueryHookResult = ReturnType<typeof useProjectValidatePolicyActionsLazyQuery>;
export type ProjectValidatePolicyActionsQueryResult = Apollo.QueryResult<ProjectValidatePolicyActionsQuery, ProjectValidatePolicyActionsQueryVariables>;
export const HiringTeamUsersFindManyDocument = gql`
    query HiringTeamUsersFindMany($companyIds: [Int!]!, $search: String) {
  HiringTeamUsersFindMany(companyIds: $companyIds, search: $search) {
    id
    firstName
    lastName
    email
    companyId
    companyName
  }
}
    `;

/**
 * __useHiringTeamUsersFindManyQuery__
 *
 * To run a query within a React component, call `useHiringTeamUsersFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useHiringTeamUsersFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHiringTeamUsersFindManyQuery({
 *   variables: {
 *      companyIds: // value for 'companyIds'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useHiringTeamUsersFindManyQuery(baseOptions: Apollo.QueryHookOptions<HiringTeamUsersFindManyQuery, HiringTeamUsersFindManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HiringTeamUsersFindManyQuery, HiringTeamUsersFindManyQueryVariables>(HiringTeamUsersFindManyDocument, options);
      }
export function useHiringTeamUsersFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HiringTeamUsersFindManyQuery, HiringTeamUsersFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HiringTeamUsersFindManyQuery, HiringTeamUsersFindManyQueryVariables>(HiringTeamUsersFindManyDocument, options);
        }
export type HiringTeamUsersFindManyQueryHookResult = ReturnType<typeof useHiringTeamUsersFindManyQuery>;
export type HiringTeamUsersFindManyLazyQueryHookResult = ReturnType<typeof useHiringTeamUsersFindManyLazyQuery>;
export type HiringTeamUsersFindManyQueryResult = Apollo.QueryResult<HiringTeamUsersFindManyQuery, HiringTeamUsersFindManyQueryVariables>;
export const GetProjectCobrandingDocument = gql`
    query getProjectCobranding($subId: String!) {
  getProjectCobranding(subId: $subId) {
    companyLogoUrl
    companyName
    name
    accentColor1
  }
}
    `;

/**
 * __useGetProjectCobrandingQuery__
 *
 * To run a query within a React component, call `useGetProjectCobrandingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectCobrandingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectCobrandingQuery({
 *   variables: {
 *      subId: // value for 'subId'
 *   },
 * });
 */
export function useGetProjectCobrandingQuery(baseOptions: Apollo.QueryHookOptions<GetProjectCobrandingQuery, GetProjectCobrandingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectCobrandingQuery, GetProjectCobrandingQueryVariables>(GetProjectCobrandingDocument, options);
      }
export function useGetProjectCobrandingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectCobrandingQuery, GetProjectCobrandingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectCobrandingQuery, GetProjectCobrandingQueryVariables>(GetProjectCobrandingDocument, options);
        }
export type GetProjectCobrandingQueryHookResult = ReturnType<typeof useGetProjectCobrandingQuery>;
export type GetProjectCobrandingLazyQueryHookResult = ReturnType<typeof useGetProjectCobrandingLazyQuery>;
export type GetProjectCobrandingQueryResult = Apollo.QueryResult<GetProjectCobrandingQuery, GetProjectCobrandingQueryVariables>;
export const ProjectCollaboratorsFindManyPaginatedDocument = gql`
    query ProjectCollaboratorsFindManyPaginated($args: ProjectCollaboratorArgs!, $order: ProjectCollaboratorOrderOptions, $paginate: OffsetBasedPaginationArgs) {
  collaborators: ProjectCollaboratorsFindManyPaginated(
    args: $args
    order: $order
    paginate: $paginate
  ) {
    data {
      id
      actorRole
      userId
      user {
        id
        uuid
        email
        firstName
        lastName
        companyRoles
        avatarUrl
      }
      groupId
      group {
        id
        subId
        name
        description
        companyId
        membersCount
        membersPreview {
          id
          uuid
          firstName
          lastName
          email
        }
      }
    }
    pageInfo {
      currentPage
      itemsOnPage
      itemsTotal
      pageTotal
      skip
      take
    }
  }
}
    `;

/**
 * __useProjectCollaboratorsFindManyPaginatedQuery__
 *
 * To run a query within a React component, call `useProjectCollaboratorsFindManyPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectCollaboratorsFindManyPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectCollaboratorsFindManyPaginatedQuery({
 *   variables: {
 *      args: // value for 'args'
 *      order: // value for 'order'
 *      paginate: // value for 'paginate'
 *   },
 * });
 */
export function useProjectCollaboratorsFindManyPaginatedQuery(baseOptions: Apollo.QueryHookOptions<ProjectCollaboratorsFindManyPaginatedQuery, ProjectCollaboratorsFindManyPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectCollaboratorsFindManyPaginatedQuery, ProjectCollaboratorsFindManyPaginatedQueryVariables>(ProjectCollaboratorsFindManyPaginatedDocument, options);
      }
export function useProjectCollaboratorsFindManyPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectCollaboratorsFindManyPaginatedQuery, ProjectCollaboratorsFindManyPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectCollaboratorsFindManyPaginatedQuery, ProjectCollaboratorsFindManyPaginatedQueryVariables>(ProjectCollaboratorsFindManyPaginatedDocument, options);
        }
export type ProjectCollaboratorsFindManyPaginatedQueryHookResult = ReturnType<typeof useProjectCollaboratorsFindManyPaginatedQuery>;
export type ProjectCollaboratorsFindManyPaginatedLazyQueryHookResult = ReturnType<typeof useProjectCollaboratorsFindManyPaginatedLazyQuery>;
export type ProjectCollaboratorsFindManyPaginatedQueryResult = Apollo.QueryResult<ProjectCollaboratorsFindManyPaginatedQuery, ProjectCollaboratorsFindManyPaginatedQueryVariables>;
export const ProjectJobRoleFindManyDocument = gql`
    query ProjectJobRoleFindMany($id: Int!, $isMainRole: Boolean) {
  ProjectJobRoleFindMany(projectId: $id, isMainRole: $isMainRole) {
    ...ProjectJobRole
  }
}
    ${ProjectJobRoleFragmentDoc}`;

/**
 * __useProjectJobRoleFindManyQuery__
 *
 * To run a query within a React component, call `useProjectJobRoleFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectJobRoleFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectJobRoleFindManyQuery({
 *   variables: {
 *      id: // value for 'id'
 *      isMainRole: // value for 'isMainRole'
 *   },
 * });
 */
export function useProjectJobRoleFindManyQuery(baseOptions: Apollo.QueryHookOptions<ProjectJobRoleFindManyQuery, ProjectJobRoleFindManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectJobRoleFindManyQuery, ProjectJobRoleFindManyQueryVariables>(ProjectJobRoleFindManyDocument, options);
      }
export function useProjectJobRoleFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectJobRoleFindManyQuery, ProjectJobRoleFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectJobRoleFindManyQuery, ProjectJobRoleFindManyQueryVariables>(ProjectJobRoleFindManyDocument, options);
        }
export type ProjectJobRoleFindManyQueryHookResult = ReturnType<typeof useProjectJobRoleFindManyQuery>;
export type ProjectJobRoleFindManyLazyQueryHookResult = ReturnType<typeof useProjectJobRoleFindManyLazyQuery>;
export type ProjectJobRoleFindManyQueryResult = Apollo.QueryResult<ProjectJobRoleFindManyQuery, ProjectJobRoleFindManyQueryVariables>;
export const ProjectsByJobRoleFindManyDocument = gql`
    query ProjectsByJobRoleFindMany($jobRoleId: Int!) {
  ProjectJobRoleFindMany(jobRoleId: $jobRoleId) {
    project {
      ...Project
    }
  }
}
    ${ProjectFragmentDoc}`;

/**
 * __useProjectsByJobRoleFindManyQuery__
 *
 * To run a query within a React component, call `useProjectsByJobRoleFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsByJobRoleFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsByJobRoleFindManyQuery({
 *   variables: {
 *      jobRoleId: // value for 'jobRoleId'
 *   },
 * });
 */
export function useProjectsByJobRoleFindManyQuery(baseOptions: Apollo.QueryHookOptions<ProjectsByJobRoleFindManyQuery, ProjectsByJobRoleFindManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectsByJobRoleFindManyQuery, ProjectsByJobRoleFindManyQueryVariables>(ProjectsByJobRoleFindManyDocument, options);
      }
export function useProjectsByJobRoleFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectsByJobRoleFindManyQuery, ProjectsByJobRoleFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectsByJobRoleFindManyQuery, ProjectsByJobRoleFindManyQueryVariables>(ProjectsByJobRoleFindManyDocument, options);
        }
export type ProjectsByJobRoleFindManyQueryHookResult = ReturnType<typeof useProjectsByJobRoleFindManyQuery>;
export type ProjectsByJobRoleFindManyLazyQueryHookResult = ReturnType<typeof useProjectsByJobRoleFindManyLazyQuery>;
export type ProjectsByJobRoleFindManyQueryResult = Apollo.QueryResult<ProjectsByJobRoleFindManyQuery, ProjectsByJobRoleFindManyQueryVariables>;
export const ProjectUserFindManyDocument = gql`
    query ProjectUserFindMany($userIds: [Int!]!) {
  ProjectUserFindMany(userIds: $userIds) {
    project {
      id
      name
      createdAt
      isArchived
      isStopped
      moduleType
      requireSheetsExport
      updatedAt
      version
      productSolution
      subId
      company {
        id
        name
      }
      managers {
        ...ProjectManager
      }
    }
    actorRole
    user {
      id
      email
    }
  }
}
    ${ProjectManagerFragmentDoc}`;

/**
 * __useProjectUserFindManyQuery__
 *
 * To run a query within a React component, call `useProjectUserFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectUserFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectUserFindManyQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useProjectUserFindManyQuery(baseOptions: Apollo.QueryHookOptions<ProjectUserFindManyQuery, ProjectUserFindManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectUserFindManyQuery, ProjectUserFindManyQueryVariables>(ProjectUserFindManyDocument, options);
      }
export function useProjectUserFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectUserFindManyQuery, ProjectUserFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectUserFindManyQuery, ProjectUserFindManyQueryVariables>(ProjectUserFindManyDocument, options);
        }
export type ProjectUserFindManyQueryHookResult = ReturnType<typeof useProjectUserFindManyQuery>;
export type ProjectUserFindManyLazyQueryHookResult = ReturnType<typeof useProjectUserFindManyLazyQuery>;
export type ProjectUserFindManyQueryResult = Apollo.QueryResult<ProjectUserFindManyQuery, ProjectUserFindManyQueryVariables>;
export const ReportsDocument = gql`
    query Reports {
  Reports {
    ...Report
  }
}
    ${ReportFragmentDoc}`;

/**
 * __useReportsQuery__
 *
 * To run a query within a React component, call `useReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useReportsQuery(baseOptions?: Apollo.QueryHookOptions<ReportsQuery, ReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportsQuery, ReportsQueryVariables>(ReportsDocument, options);
      }
export function useReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportsQuery, ReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportsQuery, ReportsQueryVariables>(ReportsDocument, options);
        }
export type ReportsQueryHookResult = ReturnType<typeof useReportsQuery>;
export type ReportsLazyQueryHookResult = ReturnType<typeof useReportsLazyQuery>;
export type ReportsQueryResult = Apollo.QueryResult<ReportsQuery, ReportsQueryVariables>;
export const ReportDocument = gql`
    query Report($id: Int!) {
  report: Report(id: $id) {
    ...Report
  }
}
    ${ReportFragmentDoc}`;

/**
 * __useReportQuery__
 *
 * To run a query within a React component, call `useReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportQuery(baseOptions: Apollo.QueryHookOptions<ReportQuery, ReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportQuery, ReportQueryVariables>(ReportDocument, options);
      }
export function useReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportQuery, ReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportQuery, ReportQueryVariables>(ReportDocument, options);
        }
export type ReportQueryHookResult = ReturnType<typeof useReportQuery>;
export type ReportLazyQueryHookResult = ReturnType<typeof useReportLazyQuery>;
export type ReportQueryResult = Apollo.QueryResult<ReportQuery, ReportQueryVariables>;
export const ReportRenderFindManyDocument = gql`
    query ReportRenderFindMany($dataSourceId: Int, $subType: ReportSubType, $reportRenderType: ReportRenderType, $projectJobRoleId: Int) {
  report: ReportRenderFindMany(
    dataSourceId: $dataSourceId
    subType: $subType
    reportRenderType: $reportRenderType
    projectJobRoleId: $projectJobRoleId
  ) {
    id
    subId
    reportRenderStatus
  }
}
    `;

/**
 * __useReportRenderFindManyQuery__
 *
 * To run a query within a React component, call `useReportRenderFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportRenderFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportRenderFindManyQuery({
 *   variables: {
 *      dataSourceId: // value for 'dataSourceId'
 *      subType: // value for 'subType'
 *      reportRenderType: // value for 'reportRenderType'
 *      projectJobRoleId: // value for 'projectJobRoleId'
 *   },
 * });
 */
export function useReportRenderFindManyQuery(baseOptions?: Apollo.QueryHookOptions<ReportRenderFindManyQuery, ReportRenderFindManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportRenderFindManyQuery, ReportRenderFindManyQueryVariables>(ReportRenderFindManyDocument, options);
      }
export function useReportRenderFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportRenderFindManyQuery, ReportRenderFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportRenderFindManyQuery, ReportRenderFindManyQueryVariables>(ReportRenderFindManyDocument, options);
        }
export type ReportRenderFindManyQueryHookResult = ReturnType<typeof useReportRenderFindManyQuery>;
export type ReportRenderFindManyLazyQueryHookResult = ReturnType<typeof useReportRenderFindManyLazyQuery>;
export type ReportRenderFindManyQueryResult = Apollo.QueryResult<ReportRenderFindManyQuery, ReportRenderFindManyQueryVariables>;
export const ReportAssignmentFindStageReportDocument = gql`
    query ReportAssignmentFindStageReport($type: ReportType!, $subType: ReportSubType!, $stageId: Int, $projectId: Int, $companyId: Int) {
  reports: ReportAssignmentFindStageReport(
    type: $type
    subType: $subType
    stageId: $stageId
    projectId: $projectId
    companyId: $companyId
  ) {
    ...ReportAssignment
  }
}
    ${ReportAssignmentFragmentDoc}`;

/**
 * __useReportAssignmentFindStageReportQuery__
 *
 * To run a query within a React component, call `useReportAssignmentFindStageReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportAssignmentFindStageReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportAssignmentFindStageReportQuery({
 *   variables: {
 *      type: // value for 'type'
 *      subType: // value for 'subType'
 *      stageId: // value for 'stageId'
 *      projectId: // value for 'projectId'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useReportAssignmentFindStageReportQuery(baseOptions: Apollo.QueryHookOptions<ReportAssignmentFindStageReportQuery, ReportAssignmentFindStageReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportAssignmentFindStageReportQuery, ReportAssignmentFindStageReportQueryVariables>(ReportAssignmentFindStageReportDocument, options);
      }
export function useReportAssignmentFindStageReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportAssignmentFindStageReportQuery, ReportAssignmentFindStageReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportAssignmentFindStageReportQuery, ReportAssignmentFindStageReportQueryVariables>(ReportAssignmentFindStageReportDocument, options);
        }
export type ReportAssignmentFindStageReportQueryHookResult = ReturnType<typeof useReportAssignmentFindStageReportQuery>;
export type ReportAssignmentFindStageReportLazyQueryHookResult = ReturnType<typeof useReportAssignmentFindStageReportLazyQuery>;
export type ReportAssignmentFindStageReportQueryResult = Apollo.QueryResult<ReportAssignmentFindStageReportQuery, ReportAssignmentFindStageReportQueryVariables>;
export const ReportFindManyDocument = gql`
    query ReportFindMany($type: ReportType) {
  report: ReportFindMany(type: $type) {
    id
    name
    subType
    type
  }
}
    `;

/**
 * __useReportFindManyQuery__
 *
 * To run a query within a React component, call `useReportFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportFindManyQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useReportFindManyQuery(baseOptions?: Apollo.QueryHookOptions<ReportFindManyQuery, ReportFindManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportFindManyQuery, ReportFindManyQueryVariables>(ReportFindManyDocument, options);
      }
export function useReportFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportFindManyQuery, ReportFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportFindManyQuery, ReportFindManyQueryVariables>(ReportFindManyDocument, options);
        }
export type ReportFindManyQueryHookResult = ReturnType<typeof useReportFindManyQuery>;
export type ReportFindManyLazyQueryHookResult = ReturnType<typeof useReportFindManyLazyQuery>;
export type ReportFindManyQueryResult = Apollo.QueryResult<ReportFindManyQuery, ReportFindManyQueryVariables>;
export const ReportsFindByCompanyDocument = gql`
    query ReportsFindByCompany($type: ReportType, $subType: ReportSubType, $ownerId: Int, $includeSharedReports: Boolean!) {
  ReportsFindByCompany(
    type: $type
    subType: $subType
    ownerId: $ownerId
    includeSharedReports: $includeSharedReports
  ) {
    id
    name
    ownerId
  }
}
    `;

/**
 * __useReportsFindByCompanyQuery__
 *
 * To run a query within a React component, call `useReportsFindByCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportsFindByCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportsFindByCompanyQuery({
 *   variables: {
 *      type: // value for 'type'
 *      subType: // value for 'subType'
 *      ownerId: // value for 'ownerId'
 *      includeSharedReports: // value for 'includeSharedReports'
 *   },
 * });
 */
export function useReportsFindByCompanyQuery(baseOptions: Apollo.QueryHookOptions<ReportsFindByCompanyQuery, ReportsFindByCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportsFindByCompanyQuery, ReportsFindByCompanyQueryVariables>(ReportsFindByCompanyDocument, options);
      }
export function useReportsFindByCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportsFindByCompanyQuery, ReportsFindByCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportsFindByCompanyQuery, ReportsFindByCompanyQueryVariables>(ReportsFindByCompanyDocument, options);
        }
export type ReportsFindByCompanyQueryHookResult = ReturnType<typeof useReportsFindByCompanyQuery>;
export type ReportsFindByCompanyLazyQueryHookResult = ReturnType<typeof useReportsFindByCompanyLazyQuery>;
export type ReportsFindByCompanyQueryResult = Apollo.QueryResult<ReportsFindByCompanyQuery, ReportsFindByCompanyQueryVariables>;
export const ReportRenderDocument = gql`
    query ReportRender($subId: String!) {
  ReportRender(subId: $subId) {
    id
    subId
    blob {
      url
    }
    reportRenderStatus
    statusMessage
  }
}
    `;

/**
 * __useReportRenderQuery__
 *
 * To run a query within a React component, call `useReportRenderQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportRenderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportRenderQuery({
 *   variables: {
 *      subId: // value for 'subId'
 *   },
 * });
 */
export function useReportRenderQuery(baseOptions: Apollo.QueryHookOptions<ReportRenderQuery, ReportRenderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportRenderQuery, ReportRenderQueryVariables>(ReportRenderDocument, options);
      }
export function useReportRenderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportRenderQuery, ReportRenderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportRenderQuery, ReportRenderQueryVariables>(ReportRenderDocument, options);
        }
export type ReportRenderQueryHookResult = ReturnType<typeof useReportRenderQuery>;
export type ReportRenderLazyQueryHookResult = ReturnType<typeof useReportRenderLazyQuery>;
export type ReportRenderQueryResult = Apollo.QueryResult<ReportRenderQuery, ReportRenderQueryVariables>;
export const FindOneRoiCsvFileExportScheduledTaskDocument = gql`
    query FindOneROICsvFileExportScheduledTask($subId: String) {
  FindOneROICsvFileExportScheduledTask(subId: $subId) {
    blob {
      id
      url
    }
    error
    status
    subId
  }
}
    `;

/**
 * __useFindOneRoiCsvFileExportScheduledTaskQuery__
 *
 * To run a query within a React component, call `useFindOneRoiCsvFileExportScheduledTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOneRoiCsvFileExportScheduledTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOneRoiCsvFileExportScheduledTaskQuery({
 *   variables: {
 *      subId: // value for 'subId'
 *   },
 * });
 */
export function useFindOneRoiCsvFileExportScheduledTaskQuery(baseOptions?: Apollo.QueryHookOptions<FindOneRoiCsvFileExportScheduledTaskQuery, FindOneRoiCsvFileExportScheduledTaskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindOneRoiCsvFileExportScheduledTaskQuery, FindOneRoiCsvFileExportScheduledTaskQueryVariables>(FindOneRoiCsvFileExportScheduledTaskDocument, options);
      }
export function useFindOneRoiCsvFileExportScheduledTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindOneRoiCsvFileExportScheduledTaskQuery, FindOneRoiCsvFileExportScheduledTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindOneRoiCsvFileExportScheduledTaskQuery, FindOneRoiCsvFileExportScheduledTaskQueryVariables>(FindOneRoiCsvFileExportScheduledTaskDocument, options);
        }
export type FindOneRoiCsvFileExportScheduledTaskQueryHookResult = ReturnType<typeof useFindOneRoiCsvFileExportScheduledTaskQuery>;
export type FindOneRoiCsvFileExportScheduledTaskLazyQueryHookResult = ReturnType<typeof useFindOneRoiCsvFileExportScheduledTaskLazyQuery>;
export type FindOneRoiCsvFileExportScheduledTaskQueryResult = Apollo.QueryResult<FindOneRoiCsvFileExportScheduledTaskQuery, FindOneRoiCsvFileExportScheduledTaskQueryVariables>;
export const RolesDocument = gql`
    query Roles {
  Roles {
    ...Role
  }
}
    ${RoleFragmentDoc}`;

/**
 * __useRolesQuery__
 *
 * To run a query within a React component, call `useRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRolesQuery(baseOptions?: Apollo.QueryHookOptions<RolesQuery, RolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RolesQuery, RolesQueryVariables>(RolesDocument, options);
      }
export function useRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RolesQuery, RolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RolesQuery, RolesQueryVariables>(RolesDocument, options);
        }
export type RolesQueryHookResult = ReturnType<typeof useRolesQuery>;
export type RolesLazyQueryHookResult = ReturnType<typeof useRolesLazyQuery>;
export type RolesQueryResult = Apollo.QueryResult<RolesQuery, RolesQueryVariables>;
export const RoleFindManyDocument = gql`
    query RoleFindMany($filterForIdentity: Boolean) {
  RoleFindMany(filterForIdentity: $filterForIdentity) {
    id
    description
    name
    type
  }
}
    `;

/**
 * __useRoleFindManyQuery__
 *
 * To run a query within a React component, call `useRoleFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoleFindManyQuery({
 *   variables: {
 *      filterForIdentity: // value for 'filterForIdentity'
 *   },
 * });
 */
export function useRoleFindManyQuery(baseOptions?: Apollo.QueryHookOptions<RoleFindManyQuery, RoleFindManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoleFindManyQuery, RoleFindManyQueryVariables>(RoleFindManyDocument, options);
      }
export function useRoleFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoleFindManyQuery, RoleFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoleFindManyQuery, RoleFindManyQueryVariables>(RoleFindManyDocument, options);
        }
export type RoleFindManyQueryHookResult = ReturnType<typeof useRoleFindManyQuery>;
export type RoleFindManyLazyQueryHookResult = ReturnType<typeof useRoleFindManyLazyQuery>;
export type RoleFindManyQueryResult = Apollo.QueryResult<RoleFindManyQuery, RoleFindManyQueryVariables>;
export const FindScheduledTaskDocument = gql`
    query FindScheduledTask($subId: String) {
  FindScheduledTask(subId: $subId) {
    error
    status
    subId
    blob {
      ...ScheduledTaskBlob
    }
  }
}
    ${ScheduledTaskBlobFragmentDoc}`;

/**
 * __useFindScheduledTaskQuery__
 *
 * To run a query within a React component, call `useFindScheduledTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindScheduledTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindScheduledTaskQuery({
 *   variables: {
 *      subId: // value for 'subId'
 *   },
 * });
 */
export function useFindScheduledTaskQuery(baseOptions?: Apollo.QueryHookOptions<FindScheduledTaskQuery, FindScheduledTaskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindScheduledTaskQuery, FindScheduledTaskQueryVariables>(FindScheduledTaskDocument, options);
      }
export function useFindScheduledTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindScheduledTaskQuery, FindScheduledTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindScheduledTaskQuery, FindScheduledTaskQueryVariables>(FindScheduledTaskDocument, options);
        }
export type FindScheduledTaskQueryHookResult = ReturnType<typeof useFindScheduledTaskQuery>;
export type FindScheduledTaskLazyQueryHookResult = ReturnType<typeof useFindScheduledTaskLazyQuery>;
export type FindScheduledTaskQueryResult = Apollo.QueryResult<FindScheduledTaskQuery, FindScheduledTaskQueryVariables>;
export const SkillsProfileSourceByJobRoleIdDocument = gql`
    query SkillsProfileSourceByJobRoleId($jobRoleId: Int!) {
  SkillsProfileSourceByJobRoleId(jobRoleId: $jobRoleId) {
    subId
  }
}
    `;

/**
 * __useSkillsProfileSourceByJobRoleIdQuery__
 *
 * To run a query within a React component, call `useSkillsProfileSourceByJobRoleIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkillsProfileSourceByJobRoleIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkillsProfileSourceByJobRoleIdQuery({
 *   variables: {
 *      jobRoleId: // value for 'jobRoleId'
 *   },
 * });
 */
export function useSkillsProfileSourceByJobRoleIdQuery(baseOptions: Apollo.QueryHookOptions<SkillsProfileSourceByJobRoleIdQuery, SkillsProfileSourceByJobRoleIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SkillsProfileSourceByJobRoleIdQuery, SkillsProfileSourceByJobRoleIdQueryVariables>(SkillsProfileSourceByJobRoleIdDocument, options);
      }
export function useSkillsProfileSourceByJobRoleIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SkillsProfileSourceByJobRoleIdQuery, SkillsProfileSourceByJobRoleIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SkillsProfileSourceByJobRoleIdQuery, SkillsProfileSourceByJobRoleIdQueryVariables>(SkillsProfileSourceByJobRoleIdDocument, options);
        }
export type SkillsProfileSourceByJobRoleIdQueryHookResult = ReturnType<typeof useSkillsProfileSourceByJobRoleIdQuery>;
export type SkillsProfileSourceByJobRoleIdLazyQueryHookResult = ReturnType<typeof useSkillsProfileSourceByJobRoleIdLazyQuery>;
export type SkillsProfileSourceByJobRoleIdQueryResult = Apollo.QueryResult<SkillsProfileSourceByJobRoleIdQuery, SkillsProfileSourceByJobRoleIdQueryVariables>;
export const ResultValidatedSkillsDocument = gql`
    query ResultValidatedSkills($dateFrom: Date, $dateTo: Date, $companyIds: [Int!], $take: Int!, $skip: Int!) {
  ResultValidatedSkills(
    dateFrom: $dateFrom
    dateTo: $dateTo
    companyIds: $companyIds
    take: $take
    skip: $skip
  ) {
    ...ResultValidatedSkillsPaginatedModel
  }
}
    ${ResultValidatedSkillsPaginatedModelFragmentDoc}`;

/**
 * __useResultValidatedSkillsQuery__
 *
 * To run a query within a React component, call `useResultValidatedSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResultValidatedSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResultValidatedSkillsQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      companyIds: // value for 'companyIds'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useResultValidatedSkillsQuery(baseOptions: Apollo.QueryHookOptions<ResultValidatedSkillsQuery, ResultValidatedSkillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResultValidatedSkillsQuery, ResultValidatedSkillsQueryVariables>(ResultValidatedSkillsDocument, options);
      }
export function useResultValidatedSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResultValidatedSkillsQuery, ResultValidatedSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResultValidatedSkillsQuery, ResultValidatedSkillsQueryVariables>(ResultValidatedSkillsDocument, options);
        }
export type ResultValidatedSkillsQueryHookResult = ReturnType<typeof useResultValidatedSkillsQuery>;
export type ResultValidatedSkillsLazyQueryHookResult = ReturnType<typeof useResultValidatedSkillsLazyQuery>;
export type ResultValidatedSkillsQueryResult = Apollo.QueryResult<ResultValidatedSkillsQuery, ResultValidatedSkillsQueryVariables>;
export const SoftSkillGetAllValidForProjectDocument = gql`
    query SoftSkillGetAllValidForProject($projectId: Int!) {
  softSkills: SoftSkillGetAllValidForProject(projectId: $projectId) {
    ...SoftSkill
  }
}
    ${SoftSkillFragmentDoc}`;

/**
 * __useSoftSkillGetAllValidForProjectQuery__
 *
 * To run a query within a React component, call `useSoftSkillGetAllValidForProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoftSkillGetAllValidForProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoftSkillGetAllValidForProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useSoftSkillGetAllValidForProjectQuery(baseOptions: Apollo.QueryHookOptions<SoftSkillGetAllValidForProjectQuery, SoftSkillGetAllValidForProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SoftSkillGetAllValidForProjectQuery, SoftSkillGetAllValidForProjectQueryVariables>(SoftSkillGetAllValidForProjectDocument, options);
      }
export function useSoftSkillGetAllValidForProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SoftSkillGetAllValidForProjectQuery, SoftSkillGetAllValidForProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SoftSkillGetAllValidForProjectQuery, SoftSkillGetAllValidForProjectQueryVariables>(SoftSkillGetAllValidForProjectDocument, options);
        }
export type SoftSkillGetAllValidForProjectQueryHookResult = ReturnType<typeof useSoftSkillGetAllValidForProjectQuery>;
export type SoftSkillGetAllValidForProjectLazyQueryHookResult = ReturnType<typeof useSoftSkillGetAllValidForProjectLazyQuery>;
export type SoftSkillGetAllValidForProjectQueryResult = Apollo.QueryResult<SoftSkillGetAllValidForProjectQuery, SoftSkillGetAllValidForProjectQueryVariables>;
export const SoftSkillsDocument = gql`
    query SoftSkills {
  SoftSkills {
    ...SoftSkill
  }
}
    ${SoftSkillFragmentDoc}`;

/**
 * __useSoftSkillsQuery__
 *
 * To run a query within a React component, call `useSoftSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoftSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoftSkillsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSoftSkillsQuery(baseOptions?: Apollo.QueryHookOptions<SoftSkillsQuery, SoftSkillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SoftSkillsQuery, SoftSkillsQueryVariables>(SoftSkillsDocument, options);
      }
export function useSoftSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SoftSkillsQuery, SoftSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SoftSkillsQuery, SoftSkillsQueryVariables>(SoftSkillsDocument, options);
        }
export type SoftSkillsQueryHookResult = ReturnType<typeof useSoftSkillsQuery>;
export type SoftSkillsLazyQueryHookResult = ReturnType<typeof useSoftSkillsLazyQuery>;
export type SoftSkillsQueryResult = Apollo.QueryResult<SoftSkillsQuery, SoftSkillsQueryVariables>;
export const SoftSkillFindManyDocument = gql`
    query SoftSkillFindMany($ids: [Int!], $companyId: Int) {
  SoftSkillFindMany(ids: $ids, companyId: $companyId) {
    ...SoftSkill
  }
}
    ${SoftSkillFragmentDoc}`;

/**
 * __useSoftSkillFindManyQuery__
 *
 * To run a query within a React component, call `useSoftSkillFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoftSkillFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoftSkillFindManyQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useSoftSkillFindManyQuery(baseOptions?: Apollo.QueryHookOptions<SoftSkillFindManyQuery, SoftSkillFindManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SoftSkillFindManyQuery, SoftSkillFindManyQueryVariables>(SoftSkillFindManyDocument, options);
      }
export function useSoftSkillFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SoftSkillFindManyQuery, SoftSkillFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SoftSkillFindManyQuery, SoftSkillFindManyQueryVariables>(SoftSkillFindManyDocument, options);
        }
export type SoftSkillFindManyQueryHookResult = ReturnType<typeof useSoftSkillFindManyQuery>;
export type SoftSkillFindManyLazyQueryHookResult = ReturnType<typeof useSoftSkillFindManyLazyQuery>;
export type SoftSkillFindManyQueryResult = Apollo.QueryResult<SoftSkillFindManyQuery, SoftSkillFindManyQueryVariables>;
export const GetSzAndProvidedCompanySoftSkillsDocument = gql`
    query getSZAndProvidedCompanySoftSkills($companyId: Int) {
  SZSoftSkills: SoftSkillFindMany(companyId: null) {
    ...SoftSkill
  }
  CompanySoftSkills: SoftSkillFindMany(companyId: $companyId) {
    ...SoftSkill
  }
}
    ${SoftSkillFragmentDoc}`;

/**
 * __useGetSzAndProvidedCompanySoftSkillsQuery__
 *
 * To run a query within a React component, call `useGetSzAndProvidedCompanySoftSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSzAndProvidedCompanySoftSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSzAndProvidedCompanySoftSkillsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetSzAndProvidedCompanySoftSkillsQuery(baseOptions?: Apollo.QueryHookOptions<GetSzAndProvidedCompanySoftSkillsQuery, GetSzAndProvidedCompanySoftSkillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSzAndProvidedCompanySoftSkillsQuery, GetSzAndProvidedCompanySoftSkillsQueryVariables>(GetSzAndProvidedCompanySoftSkillsDocument, options);
      }
export function useGetSzAndProvidedCompanySoftSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSzAndProvidedCompanySoftSkillsQuery, GetSzAndProvidedCompanySoftSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSzAndProvidedCompanySoftSkillsQuery, GetSzAndProvidedCompanySoftSkillsQueryVariables>(GetSzAndProvidedCompanySoftSkillsDocument, options);
        }
export type GetSzAndProvidedCompanySoftSkillsQueryHookResult = ReturnType<typeof useGetSzAndProvidedCompanySoftSkillsQuery>;
export type GetSzAndProvidedCompanySoftSkillsLazyQueryHookResult = ReturnType<typeof useGetSzAndProvidedCompanySoftSkillsLazyQuery>;
export type GetSzAndProvidedCompanySoftSkillsQueryResult = Apollo.QueryResult<GetSzAndProvidedCompanySoftSkillsQuery, GetSzAndProvidedCompanySoftSkillsQueryVariables>;
export const SoftSkillDocument = gql`
    query SoftSkill($subId: ID!) {
  SoftSkill(subId: $subId) {
    ...SoftSkill
  }
}
    ${SoftSkillFragmentDoc}`;

/**
 * __useSoftSkillQuery__
 *
 * To run a query within a React component, call `useSoftSkillQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoftSkillQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoftSkillQuery({
 *   variables: {
 *      subId: // value for 'subId'
 *   },
 * });
 */
export function useSoftSkillQuery(baseOptions: Apollo.QueryHookOptions<SoftSkillQuery, SoftSkillQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SoftSkillQuery, SoftSkillQueryVariables>(SoftSkillDocument, options);
      }
export function useSoftSkillLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SoftSkillQuery, SoftSkillQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SoftSkillQuery, SoftSkillQueryVariables>(SoftSkillDocument, options);
        }
export type SoftSkillQueryHookResult = ReturnType<typeof useSoftSkillQuery>;
export type SoftSkillLazyQueryHookResult = ReturnType<typeof useSoftSkillLazyQuery>;
export type SoftSkillQueryResult = Apollo.QueryResult<SoftSkillQuery, SoftSkillQueryVariables>;
export const SoftSkillFindManyPaginatedDocument = gql`
    query SoftSkillFindManyPaginated($filters: SoftSkillFindManyPaginatedFilters, $pagination: OffsetBasedPaginationArgs, $order: SoftSkillFindManyPaginatedOrder) {
  SoftSkillFindManyPaginated(
    filters: $filters
    pagination: $pagination
    order: $order
  ) {
    data {
      ...SoftSkill
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${SoftSkillFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useSoftSkillFindManyPaginatedQuery__
 *
 * To run a query within a React component, call `useSoftSkillFindManyPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoftSkillFindManyPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoftSkillFindManyPaginatedQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSoftSkillFindManyPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<SoftSkillFindManyPaginatedQuery, SoftSkillFindManyPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SoftSkillFindManyPaginatedQuery, SoftSkillFindManyPaginatedQueryVariables>(SoftSkillFindManyPaginatedDocument, options);
      }
export function useSoftSkillFindManyPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SoftSkillFindManyPaginatedQuery, SoftSkillFindManyPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SoftSkillFindManyPaginatedQuery, SoftSkillFindManyPaginatedQueryVariables>(SoftSkillFindManyPaginatedDocument, options);
        }
export type SoftSkillFindManyPaginatedQueryHookResult = ReturnType<typeof useSoftSkillFindManyPaginatedQuery>;
export type SoftSkillFindManyPaginatedLazyQueryHookResult = ReturnType<typeof useSoftSkillFindManyPaginatedLazyQuery>;
export type SoftSkillFindManyPaginatedQueryResult = Apollo.QueryResult<SoftSkillFindManyPaginatedQuery, SoftSkillFindManyPaginatedQueryVariables>;
export const SoftSkillRoleLevelContentFindManyAndCountDocument = gql`
    query SoftSkillRoleLevelContentFindManyAndCount($softSkillIds: [Int!], $roleLevels: [ContentRoleLevel!], $grades: [Grade!], $take: Int!, $page: Int!, $order: [String!]) {
  softSkillContent: SoftSkillRoleLevelContentFindManyAndCount(
    softSkillIds: $softSkillIds
    roleLevels: $roleLevels
    grades: $grades
    take: $take
    page: $page
    order: $order
  ) {
    softSkillContent {
      id
      softSkillId
      softSkill {
        id
        name
      }
      grade
      roleLevel
      description
      candidateContent
      hiringManagerContent
      internalCandidateContent
    }
    count
  }
}
    `;

/**
 * __useSoftSkillRoleLevelContentFindManyAndCountQuery__
 *
 * To run a query within a React component, call `useSoftSkillRoleLevelContentFindManyAndCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoftSkillRoleLevelContentFindManyAndCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoftSkillRoleLevelContentFindManyAndCountQuery({
 *   variables: {
 *      softSkillIds: // value for 'softSkillIds'
 *      roleLevels: // value for 'roleLevels'
 *      grades: // value for 'grades'
 *      take: // value for 'take'
 *      page: // value for 'page'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSoftSkillRoleLevelContentFindManyAndCountQuery(baseOptions: Apollo.QueryHookOptions<SoftSkillRoleLevelContentFindManyAndCountQuery, SoftSkillRoleLevelContentFindManyAndCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SoftSkillRoleLevelContentFindManyAndCountQuery, SoftSkillRoleLevelContentFindManyAndCountQueryVariables>(SoftSkillRoleLevelContentFindManyAndCountDocument, options);
      }
export function useSoftSkillRoleLevelContentFindManyAndCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SoftSkillRoleLevelContentFindManyAndCountQuery, SoftSkillRoleLevelContentFindManyAndCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SoftSkillRoleLevelContentFindManyAndCountQuery, SoftSkillRoleLevelContentFindManyAndCountQueryVariables>(SoftSkillRoleLevelContentFindManyAndCountDocument, options);
        }
export type SoftSkillRoleLevelContentFindManyAndCountQueryHookResult = ReturnType<typeof useSoftSkillRoleLevelContentFindManyAndCountQuery>;
export type SoftSkillRoleLevelContentFindManyAndCountLazyQueryHookResult = ReturnType<typeof useSoftSkillRoleLevelContentFindManyAndCountLazyQuery>;
export type SoftSkillRoleLevelContentFindManyAndCountQueryResult = Apollo.QueryResult<SoftSkillRoleLevelContentFindManyAndCountQuery, SoftSkillRoleLevelContentFindManyAndCountQueryVariables>;
export const SoftSkillTraitsDocument = gql`
    query SoftSkillTraits {
  softSkillTraits: SoftSkillTraits {
    ...SoftSkillTrait
  }
}
    ${SoftSkillTraitFragmentDoc}`;

/**
 * __useSoftSkillTraitsQuery__
 *
 * To run a query within a React component, call `useSoftSkillTraitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoftSkillTraitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoftSkillTraitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSoftSkillTraitsQuery(baseOptions?: Apollo.QueryHookOptions<SoftSkillTraitsQuery, SoftSkillTraitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SoftSkillTraitsQuery, SoftSkillTraitsQueryVariables>(SoftSkillTraitsDocument, options);
      }
export function useSoftSkillTraitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SoftSkillTraitsQuery, SoftSkillTraitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SoftSkillTraitsQuery, SoftSkillTraitsQueryVariables>(SoftSkillTraitsDocument, options);
        }
export type SoftSkillTraitsQueryHookResult = ReturnType<typeof useSoftSkillTraitsQuery>;
export type SoftSkillTraitsLazyQueryHookResult = ReturnType<typeof useSoftSkillTraitsLazyQuery>;
export type SoftSkillTraitsQueryResult = Apollo.QueryResult<SoftSkillTraitsQuery, SoftSkillTraitsQueryVariables>;
export const FindSoftSkillTraitsBySsIdDocument = gql`
    query FindSoftSkillTraitsBySSId($id: Int!) {
  softSkillTraits: SoftSkillTraitFindManyBySoftSkill(id: $id) {
    ...SoftSkillTrait
  }
}
    ${SoftSkillTraitFragmentDoc}`;

/**
 * __useFindSoftSkillTraitsBySsIdQuery__
 *
 * To run a query within a React component, call `useFindSoftSkillTraitsBySsIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindSoftSkillTraitsBySsIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindSoftSkillTraitsBySsIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindSoftSkillTraitsBySsIdQuery(baseOptions: Apollo.QueryHookOptions<FindSoftSkillTraitsBySsIdQuery, FindSoftSkillTraitsBySsIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindSoftSkillTraitsBySsIdQuery, FindSoftSkillTraitsBySsIdQueryVariables>(FindSoftSkillTraitsBySsIdDocument, options);
      }
export function useFindSoftSkillTraitsBySsIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindSoftSkillTraitsBySsIdQuery, FindSoftSkillTraitsBySsIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindSoftSkillTraitsBySsIdQuery, FindSoftSkillTraitsBySsIdQueryVariables>(FindSoftSkillTraitsBySsIdDocument, options);
        }
export type FindSoftSkillTraitsBySsIdQueryHookResult = ReturnType<typeof useFindSoftSkillTraitsBySsIdQuery>;
export type FindSoftSkillTraitsBySsIdLazyQueryHookResult = ReturnType<typeof useFindSoftSkillTraitsBySsIdLazyQuery>;
export type FindSoftSkillTraitsBySsIdQueryResult = Apollo.QueryResult<FindSoftSkillTraitsBySsIdQuery, FindSoftSkillTraitsBySsIdQueryVariables>;
export const FindManySoftSkillTraitsBySsIdDocument = gql`
    query FindManySoftSkillTraitsBySSId($ids: [Int!]!) {
  softSkillTraits: SoftSkillTraitFindManyBySoftSkills(ids: $ids) {
    ...SoftSkillTrait
  }
}
    ${SoftSkillTraitFragmentDoc}`;

/**
 * __useFindManySoftSkillTraitsBySsIdQuery__
 *
 * To run a query within a React component, call `useFindManySoftSkillTraitsBySsIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManySoftSkillTraitsBySsIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManySoftSkillTraitsBySsIdQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useFindManySoftSkillTraitsBySsIdQuery(baseOptions: Apollo.QueryHookOptions<FindManySoftSkillTraitsBySsIdQuery, FindManySoftSkillTraitsBySsIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManySoftSkillTraitsBySsIdQuery, FindManySoftSkillTraitsBySsIdQueryVariables>(FindManySoftSkillTraitsBySsIdDocument, options);
      }
export function useFindManySoftSkillTraitsBySsIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManySoftSkillTraitsBySsIdQuery, FindManySoftSkillTraitsBySsIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManySoftSkillTraitsBySsIdQuery, FindManySoftSkillTraitsBySsIdQueryVariables>(FindManySoftSkillTraitsBySsIdDocument, options);
        }
export type FindManySoftSkillTraitsBySsIdQueryHookResult = ReturnType<typeof useFindManySoftSkillTraitsBySsIdQuery>;
export type FindManySoftSkillTraitsBySsIdLazyQueryHookResult = ReturnType<typeof useFindManySoftSkillTraitsBySsIdLazyQuery>;
export type FindManySoftSkillTraitsBySsIdQueryResult = Apollo.QueryResult<FindManySoftSkillTraitsBySsIdQuery, FindManySoftSkillTraitsBySsIdQueryVariables>;
export const GetProjectSamlAuthInfoDocument = gql`
    query GetProjectSamlAuthInfo($projectId: Float!) {
  getProjectSamlAuthInfo(id: $projectId)
}
    `;

/**
 * __useGetProjectSamlAuthInfoQuery__
 *
 * To run a query within a React component, call `useGetProjectSamlAuthInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectSamlAuthInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectSamlAuthInfoQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectSamlAuthInfoQuery(baseOptions: Apollo.QueryHookOptions<GetProjectSamlAuthInfoQuery, GetProjectSamlAuthInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectSamlAuthInfoQuery, GetProjectSamlAuthInfoQueryVariables>(GetProjectSamlAuthInfoDocument, options);
      }
export function useGetProjectSamlAuthInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectSamlAuthInfoQuery, GetProjectSamlAuthInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectSamlAuthInfoQuery, GetProjectSamlAuthInfoQueryVariables>(GetProjectSamlAuthInfoDocument, options);
        }
export type GetProjectSamlAuthInfoQueryHookResult = ReturnType<typeof useGetProjectSamlAuthInfoQuery>;
export type GetProjectSamlAuthInfoLazyQueryHookResult = ReturnType<typeof useGetProjectSamlAuthInfoLazyQuery>;
export type GetProjectSamlAuthInfoQueryResult = Apollo.QueryResult<GetProjectSamlAuthInfoQuery, GetProjectSamlAuthInfoQueryVariables>;
export const StageFindManyDocument = gql`
    query StageFindMany($projectId: Int, $projectIds: [Int!]) {
  Stages: StageFindMany(projectId: $projectId, projectIds: $projectIds) {
    ...SmStageModel
  }
}
    ${SmStageModelFragmentDoc}`;

/**
 * __useStageFindManyQuery__
 *
 * To run a query within a React component, call `useStageFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useStageFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStageFindManyQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      projectIds: // value for 'projectIds'
 *   },
 * });
 */
export function useStageFindManyQuery(baseOptions?: Apollo.QueryHookOptions<StageFindManyQuery, StageFindManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StageFindManyQuery, StageFindManyQueryVariables>(StageFindManyDocument, options);
      }
export function useStageFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StageFindManyQuery, StageFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StageFindManyQuery, StageFindManyQueryVariables>(StageFindManyDocument, options);
        }
export type StageFindManyQueryHookResult = ReturnType<typeof useStageFindManyQuery>;
export type StageFindManyLazyQueryHookResult = ReturnType<typeof useStageFindManyLazyQuery>;
export type StageFindManyQueryResult = Apollo.QueryResult<StageFindManyQuery, StageFindManyQueryVariables>;
export const ResultsPageStageFindManyDocument = gql`
    query ResultsPageStageFindMany($projectIds: [Int!]) {
  Stages: StageFindMany(projectIds: $projectIds) {
    projectId
    name
    id
  }
}
    `;

/**
 * __useResultsPageStageFindManyQuery__
 *
 * To run a query within a React component, call `useResultsPageStageFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useResultsPageStageFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResultsPageStageFindManyQuery({
 *   variables: {
 *      projectIds: // value for 'projectIds'
 *   },
 * });
 */
export function useResultsPageStageFindManyQuery(baseOptions?: Apollo.QueryHookOptions<ResultsPageStageFindManyQuery, ResultsPageStageFindManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResultsPageStageFindManyQuery, ResultsPageStageFindManyQueryVariables>(ResultsPageStageFindManyDocument, options);
      }
export function useResultsPageStageFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResultsPageStageFindManyQuery, ResultsPageStageFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResultsPageStageFindManyQuery, ResultsPageStageFindManyQueryVariables>(ResultsPageStageFindManyDocument, options);
        }
export type ResultsPageStageFindManyQueryHookResult = ReturnType<typeof useResultsPageStageFindManyQuery>;
export type ResultsPageStageFindManyLazyQueryHookResult = ReturnType<typeof useResultsPageStageFindManyLazyQuery>;
export type ResultsPageStageFindManyQueryResult = Apollo.QueryResult<ResultsPageStageFindManyQuery, ResultsPageStageFindManyQueryVariables>;
export const StageDocument = gql`
    query Stage($id: Int!) {
  Stage(id: $id) {
    ...SmStageModel
  }
}
    ${SmStageModelFragmentDoc}`;

/**
 * __useStageQuery__
 *
 * To run a query within a React component, call `useStageQuery` and pass it any options that fit your needs.
 * When your component renders, `useStageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStageQuery(baseOptions: Apollo.QueryHookOptions<StageQuery, StageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StageQuery, StageQueryVariables>(StageDocument, options);
      }
export function useStageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StageQuery, StageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StageQuery, StageQueryVariables>(StageDocument, options);
        }
export type StageQueryHookResult = ReturnType<typeof useStageQuery>;
export type StageLazyQueryHookResult = ReturnType<typeof useStageLazyQuery>;
export type StageQueryResult = Apollo.QueryResult<StageQuery, StageQueryVariables>;
export const DeiStageActionDocument = gql`
    query DeiStageAction($stageId: Int!) {
  DeiStageAction(stageId: $stageId) {
    ...DeiStageAction
  }
}
    ${DeiStageActionFragmentDoc}`;

/**
 * __useDeiStageActionQuery__
 *
 * To run a query within a React component, call `useDeiStageActionQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeiStageActionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeiStageActionQuery({
 *   variables: {
 *      stageId: // value for 'stageId'
 *   },
 * });
 */
export function useDeiStageActionQuery(baseOptions: Apollo.QueryHookOptions<DeiStageActionQuery, DeiStageActionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeiStageActionQuery, DeiStageActionQueryVariables>(DeiStageActionDocument, options);
      }
export function useDeiStageActionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeiStageActionQuery, DeiStageActionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeiStageActionQuery, DeiStageActionQueryVariables>(DeiStageActionDocument, options);
        }
export type DeiStageActionQueryHookResult = ReturnType<typeof useDeiStageActionQuery>;
export type DeiStageActionLazyQueryHookResult = ReturnType<typeof useDeiStageActionLazyQuery>;
export type DeiStageActionQueryResult = Apollo.QueryResult<DeiStageActionQuery, DeiStageActionQueryVariables>;
export const StageCandidateFindManyDocument = gql`
    query StageCandidateFindMany($candidateId: Int, $relationDepth: RelationDepth) {
  StageCandidates: StageCandidateFindMany(
    candidateId: $candidateId
    relationDepth: $relationDepth
  ) {
    ...StageCandidateModel
  }
}
    ${StageCandidateModelFragmentDoc}`;

/**
 * __useStageCandidateFindManyQuery__
 *
 * To run a query within a React component, call `useStageCandidateFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useStageCandidateFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStageCandidateFindManyQuery({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *      relationDepth: // value for 'relationDepth'
 *   },
 * });
 */
export function useStageCandidateFindManyQuery(baseOptions?: Apollo.QueryHookOptions<StageCandidateFindManyQuery, StageCandidateFindManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StageCandidateFindManyQuery, StageCandidateFindManyQueryVariables>(StageCandidateFindManyDocument, options);
      }
export function useStageCandidateFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StageCandidateFindManyQuery, StageCandidateFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StageCandidateFindManyQuery, StageCandidateFindManyQueryVariables>(StageCandidateFindManyDocument, options);
        }
export type StageCandidateFindManyQueryHookResult = ReturnType<typeof useStageCandidateFindManyQuery>;
export type StageCandidateFindManyLazyQueryHookResult = ReturnType<typeof useStageCandidateFindManyLazyQuery>;
export type StageCandidateFindManyQueryResult = Apollo.QueryResult<StageCandidateFindManyQuery, StageCandidateFindManyQueryVariables>;
export const SuccessProfileDocument = gql`
    query SuccessProfile($projectId: Int!) {
  SuccessProfile(projectId: $projectId) {
    ...SuccessProfile
  }
}
    ${SuccessProfileFragmentDoc}`;

/**
 * __useSuccessProfileQuery__
 *
 * To run a query within a React component, call `useSuccessProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuccessProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuccessProfileQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useSuccessProfileQuery(baseOptions: Apollo.QueryHookOptions<SuccessProfileQuery, SuccessProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuccessProfileQuery, SuccessProfileQueryVariables>(SuccessProfileDocument, options);
      }
export function useSuccessProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuccessProfileQuery, SuccessProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuccessProfileQuery, SuccessProfileQueryVariables>(SuccessProfileDocument, options);
        }
export type SuccessProfileQueryHookResult = ReturnType<typeof useSuccessProfileQuery>;
export type SuccessProfileLazyQueryHookResult = ReturnType<typeof useSuccessProfileLazyQuery>;
export type SuccessProfileQueryResult = Apollo.QueryResult<SuccessProfileQuery, SuccessProfileQueryVariables>;
export const TechnicalSkillSearchDocument = gql`
    query TechnicalSkillSearch($searchText: String, $skip: Int!, $take: Int!, $skillCategoryNames: [String!], $sortOrder: SortOption, $sortField: TechnicalSkillSortField) {
  TechnicalSkillFreeTextSearchPaginated(
    freetext: $searchText
    skip: $skip
    take: $take
    sortField: $sortField
    sortOrder: $sortOrder
    withDeleted: ALL
    skillCategoryNames: $skillCategoryNames
  ) {
    total
    technicalSkills {
      ...TechnicalSkill
    }
  }
}
    ${TechnicalSkillFragmentDoc}`;

/**
 * __useTechnicalSkillSearchQuery__
 *
 * To run a query within a React component, call `useTechnicalSkillSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useTechnicalSkillSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTechnicalSkillSearchQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      skillCategoryNames: // value for 'skillCategoryNames'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *   },
 * });
 */
export function useTechnicalSkillSearchQuery(baseOptions: Apollo.QueryHookOptions<TechnicalSkillSearchQuery, TechnicalSkillSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TechnicalSkillSearchQuery, TechnicalSkillSearchQueryVariables>(TechnicalSkillSearchDocument, options);
      }
export function useTechnicalSkillSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TechnicalSkillSearchQuery, TechnicalSkillSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TechnicalSkillSearchQuery, TechnicalSkillSearchQueryVariables>(TechnicalSkillSearchDocument, options);
        }
export type TechnicalSkillSearchQueryHookResult = ReturnType<typeof useTechnicalSkillSearchQuery>;
export type TechnicalSkillSearchLazyQueryHookResult = ReturnType<typeof useTechnicalSkillSearchLazyQuery>;
export type TechnicalSkillSearchQueryResult = Apollo.QueryResult<TechnicalSkillSearchQuery, TechnicalSkillSearchQueryVariables>;
export const TechnicalSkillFindManyDocument = gql`
    query TechnicalSkillFindMany {
  TechnicalSkillFindMany {
    ...TechnicalSkill
  }
}
    ${TechnicalSkillFragmentDoc}`;

/**
 * __useTechnicalSkillFindManyQuery__
 *
 * To run a query within a React component, call `useTechnicalSkillFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useTechnicalSkillFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTechnicalSkillFindManyQuery({
 *   variables: {
 *   },
 * });
 */
export function useTechnicalSkillFindManyQuery(baseOptions?: Apollo.QueryHookOptions<TechnicalSkillFindManyQuery, TechnicalSkillFindManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TechnicalSkillFindManyQuery, TechnicalSkillFindManyQueryVariables>(TechnicalSkillFindManyDocument, options);
      }
export function useTechnicalSkillFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TechnicalSkillFindManyQuery, TechnicalSkillFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TechnicalSkillFindManyQuery, TechnicalSkillFindManyQueryVariables>(TechnicalSkillFindManyDocument, options);
        }
export type TechnicalSkillFindManyQueryHookResult = ReturnType<typeof useTechnicalSkillFindManyQuery>;
export type TechnicalSkillFindManyLazyQueryHookResult = ReturnType<typeof useTechnicalSkillFindManyLazyQuery>;
export type TechnicalSkillFindManyQueryResult = Apollo.QueryResult<TechnicalSkillFindManyQuery, TechnicalSkillFindManyQueryVariables>;
export const TechnicalSkillFindManyPaginatedDocument = gql`
    query TechnicalSkillFindManyPaginated($semanticSearch: TechnicalSkillSemanticSearchArgs, $filters: TechnicalSkillFindManyPaginatedFilters, $order: TechnicalSkillFindManyPaginatedOrder, $pagination: OffsetBasedPaginationArgs) {
  TechnicalSkillFindManyPaginated(
    semanticSearch: $semanticSearch
    filters: $filters
    order: $order
    pagination: $pagination
  ) {
    data {
      ...TechnicalSkillWithCompany
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${TechnicalSkillWithCompanyFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useTechnicalSkillFindManyPaginatedQuery__
 *
 * To run a query within a React component, call `useTechnicalSkillFindManyPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useTechnicalSkillFindManyPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTechnicalSkillFindManyPaginatedQuery({
 *   variables: {
 *      semanticSearch: // value for 'semanticSearch'
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useTechnicalSkillFindManyPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<TechnicalSkillFindManyPaginatedQuery, TechnicalSkillFindManyPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TechnicalSkillFindManyPaginatedQuery, TechnicalSkillFindManyPaginatedQueryVariables>(TechnicalSkillFindManyPaginatedDocument, options);
      }
export function useTechnicalSkillFindManyPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TechnicalSkillFindManyPaginatedQuery, TechnicalSkillFindManyPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TechnicalSkillFindManyPaginatedQuery, TechnicalSkillFindManyPaginatedQueryVariables>(TechnicalSkillFindManyPaginatedDocument, options);
        }
export type TechnicalSkillFindManyPaginatedQueryHookResult = ReturnType<typeof useTechnicalSkillFindManyPaginatedQuery>;
export type TechnicalSkillFindManyPaginatedLazyQueryHookResult = ReturnType<typeof useTechnicalSkillFindManyPaginatedLazyQuery>;
export type TechnicalSkillFindManyPaginatedQueryResult = Apollo.QueryResult<TechnicalSkillFindManyPaginatedQuery, TechnicalSkillFindManyPaginatedQueryVariables>;
export const TechnicalSkillDocument = gql`
    query TechnicalSkill($subId: ID!) {
  TechnicalSkill(subId: $subId) {
    ...TechnicalSkillWithCompany
  }
}
    ${TechnicalSkillWithCompanyFragmentDoc}`;

/**
 * __useTechnicalSkillQuery__
 *
 * To run a query within a React component, call `useTechnicalSkillQuery` and pass it any options that fit your needs.
 * When your component renders, `useTechnicalSkillQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTechnicalSkillQuery({
 *   variables: {
 *      subId: // value for 'subId'
 *   },
 * });
 */
export function useTechnicalSkillQuery(baseOptions: Apollo.QueryHookOptions<TechnicalSkillQuery, TechnicalSkillQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TechnicalSkillQuery, TechnicalSkillQueryVariables>(TechnicalSkillDocument, options);
      }
export function useTechnicalSkillLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TechnicalSkillQuery, TechnicalSkillQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TechnicalSkillQuery, TechnicalSkillQueryVariables>(TechnicalSkillDocument, options);
        }
export type TechnicalSkillQueryHookResult = ReturnType<typeof useTechnicalSkillQuery>;
export type TechnicalSkillLazyQueryHookResult = ReturnType<typeof useTechnicalSkillLazyQuery>;
export type TechnicalSkillQueryResult = Apollo.QueryResult<TechnicalSkillQuery, TechnicalSkillQueryVariables>;
export const TraitsDocument = gql`
    query Traits($isArchived: Boolean, $ids: [Int!]) {
  Traits(isArchived: $isArchived, ids: $ids) {
    ...Trait
  }
}
    ${TraitFragmentDoc}`;

/**
 * __useTraitsQuery__
 *
 * To run a query within a React component, call `useTraitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTraitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTraitsQuery({
 *   variables: {
 *      isArchived: // value for 'isArchived'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useTraitsQuery(baseOptions?: Apollo.QueryHookOptions<TraitsQuery, TraitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TraitsQuery, TraitsQueryVariables>(TraitsDocument, options);
      }
export function useTraitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TraitsQuery, TraitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TraitsQuery, TraitsQueryVariables>(TraitsDocument, options);
        }
export type TraitsQueryHookResult = ReturnType<typeof useTraitsQuery>;
export type TraitsLazyQueryHookResult = ReturnType<typeof useTraitsLazyQuery>;
export type TraitsQueryResult = Apollo.QueryResult<TraitsQuery, TraitsQueryVariables>;
export const TraitRoleLevelContentFindManyAndCountDocument = gql`
    query TraitRoleLevelContentFindManyAndCount($softSkillIds: [Int!], $traitIds: [Int!], $roleLevels: [ContentRoleLevel!], $classifications: [ContentClassification!], $take: Int!, $page: Int!, $order: [String!]) {
  traitContent: TraitRoleLevelContentFindManyAndCount(
    softSkillIds: $softSkillIds
    traitIds: $traitIds
    roleLevels: $roleLevels
    classifications: $classifications
    take: $take
    page: $page
    order: $order
  ) {
    traitContent {
      id
      softSkillId
      traitId
      softSkill {
        name
      }
      trait {
        name
      }
      classification
      roleLevel
      summary
      content
      developmentContent
    }
    count
  }
}
    `;

/**
 * __useTraitRoleLevelContentFindManyAndCountQuery__
 *
 * To run a query within a React component, call `useTraitRoleLevelContentFindManyAndCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useTraitRoleLevelContentFindManyAndCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTraitRoleLevelContentFindManyAndCountQuery({
 *   variables: {
 *      softSkillIds: // value for 'softSkillIds'
 *      traitIds: // value for 'traitIds'
 *      roleLevels: // value for 'roleLevels'
 *      classifications: // value for 'classifications'
 *      take: // value for 'take'
 *      page: // value for 'page'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useTraitRoleLevelContentFindManyAndCountQuery(baseOptions: Apollo.QueryHookOptions<TraitRoleLevelContentFindManyAndCountQuery, TraitRoleLevelContentFindManyAndCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TraitRoleLevelContentFindManyAndCountQuery, TraitRoleLevelContentFindManyAndCountQueryVariables>(TraitRoleLevelContentFindManyAndCountDocument, options);
      }
export function useTraitRoleLevelContentFindManyAndCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TraitRoleLevelContentFindManyAndCountQuery, TraitRoleLevelContentFindManyAndCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TraitRoleLevelContentFindManyAndCountQuery, TraitRoleLevelContentFindManyAndCountQueryVariables>(TraitRoleLevelContentFindManyAndCountDocument, options);
        }
export type TraitRoleLevelContentFindManyAndCountQueryHookResult = ReturnType<typeof useTraitRoleLevelContentFindManyAndCountQuery>;
export type TraitRoleLevelContentFindManyAndCountLazyQueryHookResult = ReturnType<typeof useTraitRoleLevelContentFindManyAndCountLazyQuery>;
export type TraitRoleLevelContentFindManyAndCountQueryResult = Apollo.QueryResult<TraitRoleLevelContentFindManyAndCountQuery, TraitRoleLevelContentFindManyAndCountQueryVariables>;
export const UserDocument = gql`
    query User($firstName: String, $lastName: String, $email: String, $id: Int, $subId: String) {
  User(
    firstName: $firstName
    lastName: $lastName
    email: $email
    id: $id
    subId: $subId
  ) {
    ...User
  }
}
    ${UserFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      id: // value for 'id'
 *      subId: // value for 'subId'
 *   },
 * });
 */
export function useUserQuery(baseOptions?: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const UsersDocument = gql`
    query Users($firstName: String, $lastName: String, $email: String, $subIds: [String!], $ids: [Int!]) {
  Users(
    firstName: $firstName
    lastName: $lastName
    email: $email
    subIds: $subIds
    ids: $ids
  ) {
    ...User
  }
}
    ${UserFragmentDoc}`;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      subIds: // value for 'subIds'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export const UserFreeTextSearchPaginateDocument = gql`
    query UserFreeTextSearchPaginate($freetext: String!, $take: Int, $skip: Int) {
  Users: UserFreeTextSearchPaginate(freetext: $freetext, skip: $skip, take: $take) {
    data {
      id
      subId
      firstName
      lastName
      email
    }
    pageInfo {
      currentPage
      itemsOnPage
      itemsTotal
      pageTotal
      skip
      take
    }
  }
}
    `;

/**
 * __useUserFreeTextSearchPaginateQuery__
 *
 * To run a query within a React component, call `useUserFreeTextSearchPaginateQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserFreeTextSearchPaginateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserFreeTextSearchPaginateQuery({
 *   variables: {
 *      freetext: // value for 'freetext'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useUserFreeTextSearchPaginateQuery(baseOptions: Apollo.QueryHookOptions<UserFreeTextSearchPaginateQuery, UserFreeTextSearchPaginateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserFreeTextSearchPaginateQuery, UserFreeTextSearchPaginateQueryVariables>(UserFreeTextSearchPaginateDocument, options);
      }
export function useUserFreeTextSearchPaginateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserFreeTextSearchPaginateQuery, UserFreeTextSearchPaginateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserFreeTextSearchPaginateQuery, UserFreeTextSearchPaginateQueryVariables>(UserFreeTextSearchPaginateDocument, options);
        }
export type UserFreeTextSearchPaginateQueryHookResult = ReturnType<typeof useUserFreeTextSearchPaginateQuery>;
export type UserFreeTextSearchPaginateLazyQueryHookResult = ReturnType<typeof useUserFreeTextSearchPaginateLazyQuery>;
export type UserFreeTextSearchPaginateQueryResult = Apollo.QueryResult<UserFreeTextSearchPaginateQuery, UserFreeTextSearchPaginateQueryVariables>;
export const MeDocument = gql`
    query me {
  me {
    ...User
  }
}
    ${UserFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const WidgetsDocument = gql`
    query Widgets {
  Widgets {
    ...Widget
  }
}
    ${WidgetFragmentDoc}`;

/**
 * __useWidgetsQuery__
 *
 * To run a query within a React component, call `useWidgetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWidgetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWidgetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useWidgetsQuery(baseOptions?: Apollo.QueryHookOptions<WidgetsQuery, WidgetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WidgetsQuery, WidgetsQueryVariables>(WidgetsDocument, options);
      }
export function useWidgetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WidgetsQuery, WidgetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WidgetsQuery, WidgetsQueryVariables>(WidgetsDocument, options);
        }
export type WidgetsQueryHookResult = ReturnType<typeof useWidgetsQuery>;
export type WidgetsLazyQueryHookResult = ReturnType<typeof useWidgetsLazyQuery>;
export type WidgetsQueryResult = Apollo.QueryResult<WidgetsQuery, WidgetsQueryVariables>;
export const WidgetDocument = gql`
    query Widget($id: Int!) {
  Widget: Widget(id: $id) {
    id
    name
    type
    screenShotBlobId
    screenShotBlob {
      url
      id
    }
    isArchived
    widgetOptions {
      id
      name
      fieldType
      question
      defaultValue
      isArchived
    }
    reportConfigs {
      id
      reportId
      newPageBefore
      report {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useWidgetQuery__
 *
 * To run a query within a React component, call `useWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWidgetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWidgetQuery(baseOptions: Apollo.QueryHookOptions<WidgetQuery, WidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WidgetQuery, WidgetQueryVariables>(WidgetDocument, options);
      }
export function useWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WidgetQuery, WidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WidgetQuery, WidgetQueryVariables>(WidgetDocument, options);
        }
export type WidgetQueryHookResult = ReturnType<typeof useWidgetQuery>;
export type WidgetLazyQueryHookResult = ReturnType<typeof useWidgetLazyQuery>;
export type WidgetQueryResult = Apollo.QueryResult<WidgetQuery, WidgetQueryVariables>;
export const GetWidgetTypeEnumDocument = gql`
    query GetWidgetTypeEnum {
  __type(name: "WidgetType") {
    enumValues {
      name
      description
    }
  }
}
    `;

/**
 * __useGetWidgetTypeEnumQuery__
 *
 * To run a query within a React component, call `useGetWidgetTypeEnumQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWidgetTypeEnumQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWidgetTypeEnumQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWidgetTypeEnumQuery(baseOptions?: Apollo.QueryHookOptions<GetWidgetTypeEnumQuery, GetWidgetTypeEnumQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWidgetTypeEnumQuery, GetWidgetTypeEnumQueryVariables>(GetWidgetTypeEnumDocument, options);
      }
export function useGetWidgetTypeEnumLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWidgetTypeEnumQuery, GetWidgetTypeEnumQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWidgetTypeEnumQuery, GetWidgetTypeEnumQueryVariables>(GetWidgetTypeEnumDocument, options);
        }
export type GetWidgetTypeEnumQueryHookResult = ReturnType<typeof useGetWidgetTypeEnumQuery>;
export type GetWidgetTypeEnumLazyQueryHookResult = ReturnType<typeof useGetWidgetTypeEnumLazyQuery>;
export type GetWidgetTypeEnumQueryResult = Apollo.QueryResult<GetWidgetTypeEnumQuery, GetWidgetTypeEnumQueryVariables>;
export const UseGetProjectFromLocationHookGetProjectByIdDocument = gql`
    query UseGetProjectFromLocationHookGetProjectById($id: Float!) {
  project: getProjectById(id: $id) {
    ...UseGetProjectFromLocationHookProject
  }
}
    ${UseGetProjectFromLocationHookProjectFragmentDoc}`;

/**
 * __useUseGetProjectFromLocationHookGetProjectByIdQuery__
 *
 * To run a query within a React component, call `useUseGetProjectFromLocationHookGetProjectByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseGetProjectFromLocationHookGetProjectByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseGetProjectFromLocationHookGetProjectByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUseGetProjectFromLocationHookGetProjectByIdQuery(baseOptions: Apollo.QueryHookOptions<UseGetProjectFromLocationHookGetProjectByIdQuery, UseGetProjectFromLocationHookGetProjectByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseGetProjectFromLocationHookGetProjectByIdQuery, UseGetProjectFromLocationHookGetProjectByIdQueryVariables>(UseGetProjectFromLocationHookGetProjectByIdDocument, options);
      }
export function useUseGetProjectFromLocationHookGetProjectByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseGetProjectFromLocationHookGetProjectByIdQuery, UseGetProjectFromLocationHookGetProjectByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseGetProjectFromLocationHookGetProjectByIdQuery, UseGetProjectFromLocationHookGetProjectByIdQueryVariables>(UseGetProjectFromLocationHookGetProjectByIdDocument, options);
        }
export type UseGetProjectFromLocationHookGetProjectByIdQueryHookResult = ReturnType<typeof useUseGetProjectFromLocationHookGetProjectByIdQuery>;
export type UseGetProjectFromLocationHookGetProjectByIdLazyQueryHookResult = ReturnType<typeof useUseGetProjectFromLocationHookGetProjectByIdLazyQuery>;
export type UseGetProjectFromLocationHookGetProjectByIdQueryResult = Apollo.QueryResult<UseGetProjectFromLocationHookGetProjectByIdQuery, UseGetProjectFromLocationHookGetProjectByIdQueryVariables>;
export const UseProjectPolicyActionsHookGetProjectByIdDocument = gql`
    query UseProjectPolicyActionsHookGetProjectById($id: Float!) {
  project: getProjectById(id: $id) {
    ...UseProjectPolicyActionsHookProject
  }
}
    ${UseProjectPolicyActionsHookProjectFragmentDoc}`;

/**
 * __useUseProjectPolicyActionsHookGetProjectByIdQuery__
 *
 * To run a query within a React component, call `useUseProjectPolicyActionsHookGetProjectByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseProjectPolicyActionsHookGetProjectByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseProjectPolicyActionsHookGetProjectByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUseProjectPolicyActionsHookGetProjectByIdQuery(baseOptions: Apollo.QueryHookOptions<UseProjectPolicyActionsHookGetProjectByIdQuery, UseProjectPolicyActionsHookGetProjectByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseProjectPolicyActionsHookGetProjectByIdQuery, UseProjectPolicyActionsHookGetProjectByIdQueryVariables>(UseProjectPolicyActionsHookGetProjectByIdDocument, options);
      }
export function useUseProjectPolicyActionsHookGetProjectByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseProjectPolicyActionsHookGetProjectByIdQuery, UseProjectPolicyActionsHookGetProjectByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseProjectPolicyActionsHookGetProjectByIdQuery, UseProjectPolicyActionsHookGetProjectByIdQueryVariables>(UseProjectPolicyActionsHookGetProjectByIdDocument, options);
        }
export type UseProjectPolicyActionsHookGetProjectByIdQueryHookResult = ReturnType<typeof useUseProjectPolicyActionsHookGetProjectByIdQuery>;
export type UseProjectPolicyActionsHookGetProjectByIdLazyQueryHookResult = ReturnType<typeof useUseProjectPolicyActionsHookGetProjectByIdLazyQuery>;
export type UseProjectPolicyActionsHookGetProjectByIdQueryResult = Apollo.QueryResult<UseProjectPolicyActionsHookGetProjectByIdQuery, UseProjectPolicyActionsHookGetProjectByIdQueryVariables>;
export const CompaniesPageCompaniesDocument = gql`
    query CompaniesPageCompanies {
  Companies: companies {
    ...CompaniesPageCompany
  }
}
    ${CompaniesPageCompanyFragmentDoc}`;

/**
 * __useCompaniesPageCompaniesQuery__
 *
 * To run a query within a React component, call `useCompaniesPageCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompaniesPageCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompaniesPageCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompaniesPageCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<CompaniesPageCompaniesQuery, CompaniesPageCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompaniesPageCompaniesQuery, CompaniesPageCompaniesQueryVariables>(CompaniesPageCompaniesDocument, options);
      }
export function useCompaniesPageCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompaniesPageCompaniesQuery, CompaniesPageCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompaniesPageCompaniesQuery, CompaniesPageCompaniesQueryVariables>(CompaniesPageCompaniesDocument, options);
        }
export type CompaniesPageCompaniesQueryHookResult = ReturnType<typeof useCompaniesPageCompaniesQuery>;
export type CompaniesPageCompaniesLazyQueryHookResult = ReturnType<typeof useCompaniesPageCompaniesLazyQuery>;
export type CompaniesPageCompaniesQueryResult = Apollo.QueryResult<CompaniesPageCompaniesQuery, CompaniesPageCompaniesQueryVariables>;
export const CompanyPageCompanyDocument = gql`
    query CompanyPageCompany($id: Int!) {
  company(id: $id) {
    ...CompanyPageCompany
  }
}
    ${CompanyPageCompanyFragmentDoc}`;

/**
 * __useCompanyPageCompanyQuery__
 *
 * To run a query within a React component, call `useCompanyPageCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyPageCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyPageCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompanyPageCompanyQuery(baseOptions: Apollo.QueryHookOptions<CompanyPageCompanyQuery, CompanyPageCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyPageCompanyQuery, CompanyPageCompanyQueryVariables>(CompanyPageCompanyDocument, options);
      }
export function useCompanyPageCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyPageCompanyQuery, CompanyPageCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyPageCompanyQuery, CompanyPageCompanyQueryVariables>(CompanyPageCompanyDocument, options);
        }
export type CompanyPageCompanyQueryHookResult = ReturnType<typeof useCompanyPageCompanyQuery>;
export type CompanyPageCompanyLazyQueryHookResult = ReturnType<typeof useCompanyPageCompanyLazyQuery>;
export type CompanyPageCompanyQueryResult = Apollo.QueryResult<CompanyPageCompanyQuery, CompanyPageCompanyQueryVariables>;
export const CompanyPageUpdateCompanyDocument = gql`
    mutation CompanyPageUpdateCompany($id: Int!, $name: String!, $areCognitiveTestsBlocked: Boolean, $areRffSoftSkillsDisabled: Boolean, $isInterviewGuideScoresEnabled: Boolean, $isLegalAcknowledgementsEnabled: Boolean, $isLiveChatEnabled: Boolean, $isSkillsEvaluationScoreEnabled: Boolean, $isViewGuidanceEnabled: Boolean, $isAssigneeManagedViaIntegration: Boolean, $isRoleRequirementsEnabled: Boolean, $rfuModelType: CompanyRFUModelType, $companyLifecycle: CompanyLifecycle, $reasonableAdjustmentsOption: ReasonableAdjustmentsOptionArgs, $assessmentExpiryOption: AssessmentExpiryOptionArgs, $managerReportId: Int, $candidateReportId: Int, $csmUserId: Int, $hideReports: Boolean, $atsPullJobsFromDate: Date, $generateManagerReport: Boolean, $generateCandidateReport: Boolean, $emailCandidateReport: Boolean, $projectTeamEmailSettings: ProjectTeamEmailSettingsArgs, $enableCompanyCodingAssessments: Boolean, $areMultiAssessmentStagesEnabled: Boolean, $isPersonalityTestMandatory: Boolean, $isAtsRoleCreationWithRequisitionEnabled: Boolean, $isAtsRoleCreationWithoutRequisitionEnabled: Boolean, $isRoleLiveEmailEnabled: Boolean, $isHiringTeamMemberAddedEmailEnabled: Boolean, $isIntegrityMonitoringAvailable: Boolean, $isIntegrityMonitoringAssessmentDefaultEnabled: Boolean, $isIntegrityMonitoringAiInterviewDefaultEnabled: Boolean, $isAiInterviewScoreHidingAvailable: Boolean, $isAiInterviewEnabled: Boolean, $isShortlistingEnabled: Boolean, $isAiShortlistNationalityScrutinyEnabled: Boolean, $isApplicationAnswerEvidenceEnabled: Boolean, $isAlternativeSupportEmailEnabled: Boolean, $alternativeSupportEmail: String, $explicitConsentEmail: String, $isWhitelabelingEnabled: Boolean, $isSpottedZebraScoreEnabled: Boolean) {
  Company: updateCompany(
    id: $id
    name: $name
    areCognitiveTestsBlocked: $areCognitiveTestsBlocked
    areRffSoftSkillsDisabled: $areRffSoftSkillsDisabled
    isInterviewGuideScoresEnabled: $isInterviewGuideScoresEnabled
    isLegalAcknowledgementsEnabled: $isLegalAcknowledgementsEnabled
    isLiveChatEnabled: $isLiveChatEnabled
    isSkillsEvaluationScoreEnabled: $isSkillsEvaluationScoreEnabled
    isViewGuidanceEnabled: $isViewGuidanceEnabled
    isAssigneeManagedViaIntegration: $isAssigneeManagedViaIntegration
    isRoleRequirementsEnabled: $isRoleRequirementsEnabled
    rfuModelType: $rfuModelType
    companyLifecycle: $companyLifecycle
    reasonableAdjustmentsOption: $reasonableAdjustmentsOption
    assessmentExpiryOption: $assessmentExpiryOption
    managerReportId: $managerReportId
    candidateReportId: $candidateReportId
    csmUserId: $csmUserId
    hideReports: $hideReports
    atsPullJobsFromDate: $atsPullJobsFromDate
    generateManagerReport: $generateManagerReport
    generateCandidateReport: $generateCandidateReport
    emailCandidateReport: $emailCandidateReport
    projectTeamEmailSettings: $projectTeamEmailSettings
    enableCompanyCodingAssessments: $enableCompanyCodingAssessments
    areMultiAssessmentStagesEnabled: $areMultiAssessmentStagesEnabled
    isPersonalityTestMandatory: $isPersonalityTestMandatory
    isAtsRoleCreationWithRequisitionEnabled: $isAtsRoleCreationWithRequisitionEnabled
    isAtsRoleCreationWithoutRequisitionEnabled: $isAtsRoleCreationWithoutRequisitionEnabled
    isRoleLiveEmailEnabled: $isRoleLiveEmailEnabled
    isHiringTeamMemberAddedEmailEnabled: $isHiringTeamMemberAddedEmailEnabled
    isIntegrityMonitoringAvailable: $isIntegrityMonitoringAvailable
    isIntegrityMonitoringAssessmentDefaultEnabled: $isIntegrityMonitoringAssessmentDefaultEnabled
    isIntegrityMonitoringAiInterviewDefaultEnabled: $isIntegrityMonitoringAiInterviewDefaultEnabled
    isAiInterviewScoreHidingAvailable: $isAiInterviewScoreHidingAvailable
    isAiInterviewEnabled: $isAiInterviewEnabled
    isShortlistingEnabled: $isShortlistingEnabled
    isAiShortlistNationalityScrutinyEnabled: $isAiShortlistNationalityScrutinyEnabled
    isApplicationAnswerEvidenceEnabled: $isApplicationAnswerEvidenceEnabled
    isAlternativeSupportEmailEnabled: $isAlternativeSupportEmailEnabled
    alternativeSupportEmail: $alternativeSupportEmail
    explicitConsentEmail: $explicitConsentEmail
    isWhitelabelingEnabled: $isWhitelabelingEnabled
    isSpottedZebraScoreEnabled: $isSpottedZebraScoreEnabled
  ) {
    ...CompanyPageCompany
  }
}
    ${CompanyPageCompanyFragmentDoc}`;
export type CompanyPageUpdateCompanyMutationFn = Apollo.MutationFunction<CompanyPageUpdateCompanyMutation, CompanyPageUpdateCompanyMutationVariables>;

/**
 * __useCompanyPageUpdateCompanyMutation__
 *
 * To run a mutation, you first call `useCompanyPageUpdateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyPageUpdateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyPageUpdateCompanyMutation, { data, loading, error }] = useCompanyPageUpdateCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      areCognitiveTestsBlocked: // value for 'areCognitiveTestsBlocked'
 *      areRffSoftSkillsDisabled: // value for 'areRffSoftSkillsDisabled'
 *      isInterviewGuideScoresEnabled: // value for 'isInterviewGuideScoresEnabled'
 *      isLegalAcknowledgementsEnabled: // value for 'isLegalAcknowledgementsEnabled'
 *      isLiveChatEnabled: // value for 'isLiveChatEnabled'
 *      isSkillsEvaluationScoreEnabled: // value for 'isSkillsEvaluationScoreEnabled'
 *      isViewGuidanceEnabled: // value for 'isViewGuidanceEnabled'
 *      isAssigneeManagedViaIntegration: // value for 'isAssigneeManagedViaIntegration'
 *      isRoleRequirementsEnabled: // value for 'isRoleRequirementsEnabled'
 *      rfuModelType: // value for 'rfuModelType'
 *      companyLifecycle: // value for 'companyLifecycle'
 *      reasonableAdjustmentsOption: // value for 'reasonableAdjustmentsOption'
 *      assessmentExpiryOption: // value for 'assessmentExpiryOption'
 *      managerReportId: // value for 'managerReportId'
 *      candidateReportId: // value for 'candidateReportId'
 *      csmUserId: // value for 'csmUserId'
 *      hideReports: // value for 'hideReports'
 *      atsPullJobsFromDate: // value for 'atsPullJobsFromDate'
 *      generateManagerReport: // value for 'generateManagerReport'
 *      generateCandidateReport: // value for 'generateCandidateReport'
 *      emailCandidateReport: // value for 'emailCandidateReport'
 *      projectTeamEmailSettings: // value for 'projectTeamEmailSettings'
 *      enableCompanyCodingAssessments: // value for 'enableCompanyCodingAssessments'
 *      areMultiAssessmentStagesEnabled: // value for 'areMultiAssessmentStagesEnabled'
 *      isPersonalityTestMandatory: // value for 'isPersonalityTestMandatory'
 *      isAtsRoleCreationWithRequisitionEnabled: // value for 'isAtsRoleCreationWithRequisitionEnabled'
 *      isAtsRoleCreationWithoutRequisitionEnabled: // value for 'isAtsRoleCreationWithoutRequisitionEnabled'
 *      isRoleLiveEmailEnabled: // value for 'isRoleLiveEmailEnabled'
 *      isHiringTeamMemberAddedEmailEnabled: // value for 'isHiringTeamMemberAddedEmailEnabled'
 *      isIntegrityMonitoringAvailable: // value for 'isIntegrityMonitoringAvailable'
 *      isIntegrityMonitoringAssessmentDefaultEnabled: // value for 'isIntegrityMonitoringAssessmentDefaultEnabled'
 *      isIntegrityMonitoringAiInterviewDefaultEnabled: // value for 'isIntegrityMonitoringAiInterviewDefaultEnabled'
 *      isAiInterviewScoreHidingAvailable: // value for 'isAiInterviewScoreHidingAvailable'
 *      isAiInterviewEnabled: // value for 'isAiInterviewEnabled'
 *      isShortlistingEnabled: // value for 'isShortlistingEnabled'
 *      isAiShortlistNationalityScrutinyEnabled: // value for 'isAiShortlistNationalityScrutinyEnabled'
 *      isApplicationAnswerEvidenceEnabled: // value for 'isApplicationAnswerEvidenceEnabled'
 *      isAlternativeSupportEmailEnabled: // value for 'isAlternativeSupportEmailEnabled'
 *      alternativeSupportEmail: // value for 'alternativeSupportEmail'
 *      explicitConsentEmail: // value for 'explicitConsentEmail'
 *      isWhitelabelingEnabled: // value for 'isWhitelabelingEnabled'
 *      isSpottedZebraScoreEnabled: // value for 'isSpottedZebraScoreEnabled'
 *   },
 * });
 */
export function useCompanyPageUpdateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<CompanyPageUpdateCompanyMutation, CompanyPageUpdateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanyPageUpdateCompanyMutation, CompanyPageUpdateCompanyMutationVariables>(CompanyPageUpdateCompanyDocument, options);
      }
export type CompanyPageUpdateCompanyMutationHookResult = ReturnType<typeof useCompanyPageUpdateCompanyMutation>;
export type CompanyPageUpdateCompanyMutationResult = Apollo.MutationResult<CompanyPageUpdateCompanyMutation>;
export type CompanyPageUpdateCompanyMutationOptions = Apollo.BaseMutationOptions<CompanyPageUpdateCompanyMutation, CompanyPageUpdateCompanyMutationVariables>;
export const ProjectPageCompanyDocument = gql`
    query ProjectPageCompany($id: Int!) {
  company(id: $id) {
    ...ProjectPageCompany
  }
}
    ${ProjectPageCompanyFragmentDoc}`;

/**
 * __useProjectPageCompanyQuery__
 *
 * To run a query within a React component, call `useProjectPageCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectPageCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectPageCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectPageCompanyQuery(baseOptions: Apollo.QueryHookOptions<ProjectPageCompanyQuery, ProjectPageCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectPageCompanyQuery, ProjectPageCompanyQueryVariables>(ProjectPageCompanyDocument, options);
      }
export function useProjectPageCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectPageCompanyQuery, ProjectPageCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectPageCompanyQuery, ProjectPageCompanyQueryVariables>(ProjectPageCompanyDocument, options);
        }
export type ProjectPageCompanyQueryHookResult = ReturnType<typeof useProjectPageCompanyQuery>;
export type ProjectPageCompanyLazyQueryHookResult = ReturnType<typeof useProjectPageCompanyLazyQuery>;
export type ProjectPageCompanyQueryResult = Apollo.QueryResult<ProjectPageCompanyQuery, ProjectPageCompanyQueryVariables>;
export const ProjectPageGetProjectByIdDocument = gql`
    query ProjectPageGetProjectById($id: Float!) {
  project: getProjectById(id: $id) {
    ...ProjectPageProject
  }
}
    ${ProjectPageProjectFragmentDoc}`;

/**
 * __useProjectPageGetProjectByIdQuery__
 *
 * To run a query within a React component, call `useProjectPageGetProjectByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectPageGetProjectByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectPageGetProjectByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectPageGetProjectByIdQuery(baseOptions: Apollo.QueryHookOptions<ProjectPageGetProjectByIdQuery, ProjectPageGetProjectByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectPageGetProjectByIdQuery, ProjectPageGetProjectByIdQueryVariables>(ProjectPageGetProjectByIdDocument, options);
      }
export function useProjectPageGetProjectByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectPageGetProjectByIdQuery, ProjectPageGetProjectByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectPageGetProjectByIdQuery, ProjectPageGetProjectByIdQueryVariables>(ProjectPageGetProjectByIdDocument, options);
        }
export type ProjectPageGetProjectByIdQueryHookResult = ReturnType<typeof useProjectPageGetProjectByIdQuery>;
export type ProjectPageGetProjectByIdLazyQueryHookResult = ReturnType<typeof useProjectPageGetProjectByIdLazyQuery>;
export type ProjectPageGetProjectByIdQueryResult = Apollo.QueryResult<ProjectPageGetProjectByIdQuery, ProjectPageGetProjectByIdQueryVariables>;
export const ProjectAddShortlistStageDocument = gql`
    mutation ProjectAddShortlistStage($subId: ID!, $name: String!) {
  ProjectAddShortlistStage(subId: $subId, name: $name) {
    project {
      id
      shortlistStages {
        ...ShortlistStageBase
      }
    }
  }
}
    ${ShortlistStageBaseFragmentDoc}`;
export type ProjectAddShortlistStageMutationFn = Apollo.MutationFunction<ProjectAddShortlistStageMutation, ProjectAddShortlistStageMutationVariables>;

/**
 * __useProjectAddShortlistStageMutation__
 *
 * To run a mutation, you first call `useProjectAddShortlistStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectAddShortlistStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectAddShortlistStageMutation, { data, loading, error }] = useProjectAddShortlistStageMutation({
 *   variables: {
 *      subId: // value for 'subId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useProjectAddShortlistStageMutation(baseOptions?: Apollo.MutationHookOptions<ProjectAddShortlistStageMutation, ProjectAddShortlistStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectAddShortlistStageMutation, ProjectAddShortlistStageMutationVariables>(ProjectAddShortlistStageDocument, options);
      }
export type ProjectAddShortlistStageMutationHookResult = ReturnType<typeof useProjectAddShortlistStageMutation>;
export type ProjectAddShortlistStageMutationResult = Apollo.MutationResult<ProjectAddShortlistStageMutation>;
export type ProjectAddShortlistStageMutationOptions = Apollo.BaseMutationOptions<ProjectAddShortlistStageMutation, ProjectAddShortlistStageMutationVariables>;
export const RoleArtefactsRoleFindOneDocument = gql`
    query RoleArtefactsRoleFindOne($id: Int!) {
  RoleWizardRoleFindOne(id: $id) {
    jobDescriptionFileName
    jobDescriptionProcessingStatus
    meetingId
  }
}
    `;

/**
 * __useRoleArtefactsRoleFindOneQuery__
 *
 * To run a query within a React component, call `useRoleArtefactsRoleFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleArtefactsRoleFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoleArtefactsRoleFindOneQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRoleArtefactsRoleFindOneQuery(baseOptions: Apollo.QueryHookOptions<RoleArtefactsRoleFindOneQuery, RoleArtefactsRoleFindOneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoleArtefactsRoleFindOneQuery, RoleArtefactsRoleFindOneQueryVariables>(RoleArtefactsRoleFindOneDocument, options);
      }
export function useRoleArtefactsRoleFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoleArtefactsRoleFindOneQuery, RoleArtefactsRoleFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoleArtefactsRoleFindOneQuery, RoleArtefactsRoleFindOneQueryVariables>(RoleArtefactsRoleFindOneDocument, options);
        }
export type RoleArtefactsRoleFindOneQueryHookResult = ReturnType<typeof useRoleArtefactsRoleFindOneQuery>;
export type RoleArtefactsRoleFindOneLazyQueryHookResult = ReturnType<typeof useRoleArtefactsRoleFindOneLazyQuery>;
export type RoleArtefactsRoleFindOneQueryResult = Apollo.QueryResult<RoleArtefactsRoleFindOneQuery, RoleArtefactsRoleFindOneQueryVariables>;
export const RoleArtefactsMeetingFindOneDocument = gql`
    query RoleArtefactsMeetingFindOne($id: String!) {
  MeetingFindOne(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useRoleArtefactsMeetingFindOneQuery__
 *
 * To run a query within a React component, call `useRoleArtefactsMeetingFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleArtefactsMeetingFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoleArtefactsMeetingFindOneQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRoleArtefactsMeetingFindOneQuery(baseOptions: Apollo.QueryHookOptions<RoleArtefactsMeetingFindOneQuery, RoleArtefactsMeetingFindOneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoleArtefactsMeetingFindOneQuery, RoleArtefactsMeetingFindOneQueryVariables>(RoleArtefactsMeetingFindOneDocument, options);
      }
export function useRoleArtefactsMeetingFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoleArtefactsMeetingFindOneQuery, RoleArtefactsMeetingFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoleArtefactsMeetingFindOneQuery, RoleArtefactsMeetingFindOneQueryVariables>(RoleArtefactsMeetingFindOneDocument, options);
        }
export type RoleArtefactsMeetingFindOneQueryHookResult = ReturnType<typeof useRoleArtefactsMeetingFindOneQuery>;
export type RoleArtefactsMeetingFindOneLazyQueryHookResult = ReturnType<typeof useRoleArtefactsMeetingFindOneLazyQuery>;
export type RoleArtefactsMeetingFindOneQueryResult = Apollo.QueryResult<RoleArtefactsMeetingFindOneQuery, RoleArtefactsMeetingFindOneQueryVariables>;
export const RoleArtefactsGetJobDescriptionUrlDocument = gql`
    query RoleArtefactsGetJobDescriptionUrl($roleId: Int!) {
  RoleWizardGetJobDescriptionUrl(roleId: $roleId)
}
    `;

/**
 * __useRoleArtefactsGetJobDescriptionUrlQuery__
 *
 * To run a query within a React component, call `useRoleArtefactsGetJobDescriptionUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleArtefactsGetJobDescriptionUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoleArtefactsGetJobDescriptionUrlQuery({
 *   variables: {
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useRoleArtefactsGetJobDescriptionUrlQuery(baseOptions: Apollo.QueryHookOptions<RoleArtefactsGetJobDescriptionUrlQuery, RoleArtefactsGetJobDescriptionUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoleArtefactsGetJobDescriptionUrlQuery, RoleArtefactsGetJobDescriptionUrlQueryVariables>(RoleArtefactsGetJobDescriptionUrlDocument, options);
      }
export function useRoleArtefactsGetJobDescriptionUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoleArtefactsGetJobDescriptionUrlQuery, RoleArtefactsGetJobDescriptionUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoleArtefactsGetJobDescriptionUrlQuery, RoleArtefactsGetJobDescriptionUrlQueryVariables>(RoleArtefactsGetJobDescriptionUrlDocument, options);
        }
export type RoleArtefactsGetJobDescriptionUrlQueryHookResult = ReturnType<typeof useRoleArtefactsGetJobDescriptionUrlQuery>;
export type RoleArtefactsGetJobDescriptionUrlLazyQueryHookResult = ReturnType<typeof useRoleArtefactsGetJobDescriptionUrlLazyQuery>;
export type RoleArtefactsGetJobDescriptionUrlQueryResult = Apollo.QueryResult<RoleArtefactsGetJobDescriptionUrlQuery, RoleArtefactsGetJobDescriptionUrlQueryVariables>;
export const DuplicateJobRoleModalFindOneDocument = gql`
    query DuplicateJobRoleModalFindOne($id: Int) {
  JobRoleFindOne(id: $id) {
    ...DuplicateModalJobRole
  }
}
    ${DuplicateModalJobRoleFragmentDoc}`;

/**
 * __useDuplicateJobRoleModalFindOneQuery__
 *
 * To run a query within a React component, call `useDuplicateJobRoleModalFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useDuplicateJobRoleModalFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDuplicateJobRoleModalFindOneQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDuplicateJobRoleModalFindOneQuery(baseOptions?: Apollo.QueryHookOptions<DuplicateJobRoleModalFindOneQuery, DuplicateJobRoleModalFindOneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DuplicateJobRoleModalFindOneQuery, DuplicateJobRoleModalFindOneQueryVariables>(DuplicateJobRoleModalFindOneDocument, options);
      }
export function useDuplicateJobRoleModalFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DuplicateJobRoleModalFindOneQuery, DuplicateJobRoleModalFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DuplicateJobRoleModalFindOneQuery, DuplicateJobRoleModalFindOneQueryVariables>(DuplicateJobRoleModalFindOneDocument, options);
        }
export type DuplicateJobRoleModalFindOneQueryHookResult = ReturnType<typeof useDuplicateJobRoleModalFindOneQuery>;
export type DuplicateJobRoleModalFindOneLazyQueryHookResult = ReturnType<typeof useDuplicateJobRoleModalFindOneLazyQuery>;
export type DuplicateJobRoleModalFindOneQueryResult = Apollo.QueryResult<DuplicateJobRoleModalFindOneQuery, DuplicateJobRoleModalFindOneQueryVariables>;
export const DuplicateJobRoleModalFindManyPaginatedDocument = gql`
    query DuplicateJobRoleModalFindManyPaginated($pagination: OffsetBasedPaginationArgs!, $order: JobRoleFindManyPaginatedOrderArgs, $filters: JobRoleFindManyPaginatedFiltersArgs) {
  JobRoleFindManyPaginated(
    pagination: $pagination
    order: $order
    filters: $filters
  ) {
    ...DuplicateJobRoleModalPaginated
  }
}
    ${DuplicateJobRoleModalPaginatedFragmentDoc}`;

/**
 * __useDuplicateJobRoleModalFindManyPaginatedQuery__
 *
 * To run a query within a React component, call `useDuplicateJobRoleModalFindManyPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useDuplicateJobRoleModalFindManyPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDuplicateJobRoleModalFindManyPaginatedQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useDuplicateJobRoleModalFindManyPaginatedQuery(baseOptions: Apollo.QueryHookOptions<DuplicateJobRoleModalFindManyPaginatedQuery, DuplicateJobRoleModalFindManyPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DuplicateJobRoleModalFindManyPaginatedQuery, DuplicateJobRoleModalFindManyPaginatedQueryVariables>(DuplicateJobRoleModalFindManyPaginatedDocument, options);
      }
export function useDuplicateJobRoleModalFindManyPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DuplicateJobRoleModalFindManyPaginatedQuery, DuplicateJobRoleModalFindManyPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DuplicateJobRoleModalFindManyPaginatedQuery, DuplicateJobRoleModalFindManyPaginatedQueryVariables>(DuplicateJobRoleModalFindManyPaginatedDocument, options);
        }
export type DuplicateJobRoleModalFindManyPaginatedQueryHookResult = ReturnType<typeof useDuplicateJobRoleModalFindManyPaginatedQuery>;
export type DuplicateJobRoleModalFindManyPaginatedLazyQueryHookResult = ReturnType<typeof useDuplicateJobRoleModalFindManyPaginatedLazyQuery>;
export type DuplicateJobRoleModalFindManyPaginatedQueryResult = Apollo.QueryResult<DuplicateJobRoleModalFindManyPaginatedQuery, DuplicateJobRoleModalFindManyPaginatedQueryVariables>;
export const ExportsProjectsFindManyByCompanyDocument = gql`
    query ExportsProjectsFindManyByCompany($companyId: Int!) {
  projects: ProjectFindManyByCompany(companyId: $companyId) {
    id
    name
    isArchived
    __typename
  }
}
    `;

/**
 * __useExportsProjectsFindManyByCompanyQuery__
 *
 * To run a query within a React component, call `useExportsProjectsFindManyByCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportsProjectsFindManyByCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportsProjectsFindManyByCompanyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useExportsProjectsFindManyByCompanyQuery(baseOptions: Apollo.QueryHookOptions<ExportsProjectsFindManyByCompanyQuery, ExportsProjectsFindManyByCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportsProjectsFindManyByCompanyQuery, ExportsProjectsFindManyByCompanyQueryVariables>(ExportsProjectsFindManyByCompanyDocument, options);
      }
export function useExportsProjectsFindManyByCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportsProjectsFindManyByCompanyQuery, ExportsProjectsFindManyByCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportsProjectsFindManyByCompanyQuery, ExportsProjectsFindManyByCompanyQueryVariables>(ExportsProjectsFindManyByCompanyDocument, options);
        }
export type ExportsProjectsFindManyByCompanyQueryHookResult = ReturnType<typeof useExportsProjectsFindManyByCompanyQuery>;
export type ExportsProjectsFindManyByCompanyLazyQueryHookResult = ReturnType<typeof useExportsProjectsFindManyByCompanyLazyQuery>;
export type ExportsProjectsFindManyByCompanyQueryResult = Apollo.QueryResult<ExportsProjectsFindManyByCompanyQuery, ExportsProjectsFindManyByCompanyQueryVariables>;
export const ExportsCompaniesDocument = gql`
    query ExportsCompanies {
  Companies: companies {
    id
    name
    __typename
  }
}
    `;

/**
 * __useExportsCompaniesQuery__
 *
 * To run a query within a React component, call `useExportsCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportsCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportsCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useExportsCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<ExportsCompaniesQuery, ExportsCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportsCompaniesQuery, ExportsCompaniesQueryVariables>(ExportsCompaniesDocument, options);
      }
export function useExportsCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportsCompaniesQuery, ExportsCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportsCompaniesQuery, ExportsCompaniesQueryVariables>(ExportsCompaniesDocument, options);
        }
export type ExportsCompaniesQueryHookResult = ReturnType<typeof useExportsCompaniesQuery>;
export type ExportsCompaniesLazyQueryHookResult = ReturnType<typeof useExportsCompaniesLazyQuery>;
export type ExportsCompaniesQueryResult = Apollo.QueryResult<ExportsCompaniesQuery, ExportsCompaniesQueryVariables>;
export const ExportsProjectFindManysByCompanyWithStageCandidateRangeDocument = gql`
    query ExportsProjectFindManysByCompanyWithStageCandidateRange($companyIds: [Int!], $createdAtFrom: Date, $createdAtTo: Date) {
  projects: ProjectFindManysByCompanyWithStageCandidateRange(
    companyIds: $companyIds
    stageCandidateCreatedAtFrom: $createdAtFrom
    stageCandidateCreatedAtTo: $createdAtTo
  ) {
    id
    company {
      id
      name
    }
    numberOfStageCandidates
    percentageOfCompletedStageCandidates
    numberOfCompletedInTimeFrameStageCandidates
    projects {
      ...ProjectWithStageCandidates
    }
  }
}
    ${ProjectWithStageCandidatesFragmentDoc}`;

/**
 * __useExportsProjectFindManysByCompanyWithStageCandidateRangeQuery__
 *
 * To run a query within a React component, call `useExportsProjectFindManysByCompanyWithStageCandidateRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportsProjectFindManysByCompanyWithStageCandidateRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportsProjectFindManysByCompanyWithStageCandidateRangeQuery({
 *   variables: {
 *      companyIds: // value for 'companyIds'
 *      createdAtFrom: // value for 'createdAtFrom'
 *      createdAtTo: // value for 'createdAtTo'
 *   },
 * });
 */
export function useExportsProjectFindManysByCompanyWithStageCandidateRangeQuery(baseOptions?: Apollo.QueryHookOptions<ExportsProjectFindManysByCompanyWithStageCandidateRangeQuery, ExportsProjectFindManysByCompanyWithStageCandidateRangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportsProjectFindManysByCompanyWithStageCandidateRangeQuery, ExportsProjectFindManysByCompanyWithStageCandidateRangeQueryVariables>(ExportsProjectFindManysByCompanyWithStageCandidateRangeDocument, options);
      }
export function useExportsProjectFindManysByCompanyWithStageCandidateRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportsProjectFindManysByCompanyWithStageCandidateRangeQuery, ExportsProjectFindManysByCompanyWithStageCandidateRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportsProjectFindManysByCompanyWithStageCandidateRangeQuery, ExportsProjectFindManysByCompanyWithStageCandidateRangeQueryVariables>(ExportsProjectFindManysByCompanyWithStageCandidateRangeDocument, options);
        }
export type ExportsProjectFindManysByCompanyWithStageCandidateRangeQueryHookResult = ReturnType<typeof useExportsProjectFindManysByCompanyWithStageCandidateRangeQuery>;
export type ExportsProjectFindManysByCompanyWithStageCandidateRangeLazyQueryHookResult = ReturnType<typeof useExportsProjectFindManysByCompanyWithStageCandidateRangeLazyQuery>;
export type ExportsProjectFindManysByCompanyWithStageCandidateRangeQueryResult = Apollo.QueryResult<ExportsProjectFindManysByCompanyWithStageCandidateRangeQuery, ExportsProjectFindManysByCompanyWithStageCandidateRangeQueryVariables>;
export const UserPageGetProjectByIdDocument = gql`
    query UserPageGetProjectById($id: Float!) {
  project: getProjectById(id: $id) {
    ...UserPageProject
  }
}
    ${UserPageProjectFragmentDoc}`;

/**
 * __useUserPageGetProjectByIdQuery__
 *
 * To run a query within a React component, call `useUserPageGetProjectByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPageGetProjectByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPageGetProjectByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserPageGetProjectByIdQuery(baseOptions: Apollo.QueryHookOptions<UserPageGetProjectByIdQuery, UserPageGetProjectByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserPageGetProjectByIdQuery, UserPageGetProjectByIdQueryVariables>(UserPageGetProjectByIdDocument, options);
      }
export function useUserPageGetProjectByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserPageGetProjectByIdQuery, UserPageGetProjectByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserPageGetProjectByIdQuery, UserPageGetProjectByIdQueryVariables>(UserPageGetProjectByIdDocument, options);
        }
export type UserPageGetProjectByIdQueryHookResult = ReturnType<typeof useUserPageGetProjectByIdQuery>;
export type UserPageGetProjectByIdLazyQueryHookResult = ReturnType<typeof useUserPageGetProjectByIdLazyQuery>;
export type UserPageGetProjectByIdQueryResult = Apollo.QueryResult<UserPageGetProjectByIdQuery, UserPageGetProjectByIdQueryVariables>;